/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		2:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + "bd6a11629af9dfae08bd" + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74);
	__webpack_require__(10);
	__webpack_require__(1178);
	module.exports = __webpack_require__(86);


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.9/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest
	* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.9',
	  major: 1,
	  minor: 6,
	  dot: 9,
	  codeName: 'fiery-basilisk'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.9' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	
	  // CTM HACK to allow webpack build by Rob: exposed $injector endpoint to load modules dynamically. Keep it when upgrading AngularJS
	  instanceInjector.loadModule = function(moduleName) {
	    forEach(loadModules([moduleName]), function(fn) { instanceInjector.invoke(fn || noop); });
	  }
	  // END CTM HACK
	
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  // CTM HACK REMOVE THESE LINES
	  // instanceInjector.loadNewModules = function(mods) {
	  //   forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  // };
	  // END CTM HACK
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` (*DEPRECATED*)
	 *
	 * `replace` will be removed in next major release - i.e. v2.0).
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
	   * current strictComponentBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
	   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
	   * on the component's HTML tag.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestAborted;
	      xhr.ontimeout = requestTimeout;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        markQExceptionHandled(intervals[promise.$$intervalId].promise);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (parsedExpression.oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      return unwatch;
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      if (fn.inputs) {
	        fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // potentially non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  markQStateExceptionHandled(q.$$state);
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * `$watchGroup` is more performant than watching each expression individually, and should be
	       * used when the listener does not need to know which expression has changed.
	       * If the listener needs to know which expression has changed,
	       * {@link ng.$rootScope.Scope#$watch $watch()} or
	       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`.
	       *
	       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
	       *    expression, and not the difference of the values between each call of the listener.
	       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
	       *    which expression has changed / remained stable:
	       *
	       *    ```js
	       *
	       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
	       *      console.log(newValues, oldValues);
	       *    });
	       *
	       *    // newValues, oldValues initially
	       *    // [undefined, undefined], [undefined, undefined]
	       *
	       *    $scope.v1 = 'a';
	       *    $scope.v2 = 'a';
	       *
	       *    // ['a', 'a'], [undefined, undefined]
	       *
	       *    $scope.v2 = 'b'
	       *
	       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
	       *    // ['a', 'b'], [undefined, 'a']
	       *
	       *    ```
	       *
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes AngularJS accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var expression = attr[name].trim();
	        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');
	
	        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
	        var watchExpression = $parse(expression, watchInterceptor);
	        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;
	
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch(watchExpression, watchAction, isOneTime);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClass[OneTime]WatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassOneTimeWatchAction(newClassValue) {
	          var newClassString = toClassString(newClassValue);
	
	          if (newClassString !== oldClassString) {
	            ngClassWatchAction(newClassString);
	          }
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	
	  function toFlatValue(classValue) {
	    var flatValue = classValue;
	
	    if (isArray(classValue)) {
	      flatValue = classValue.map(toFlatValue);
	    } else if (isObject(classValue)) {
	      var hasUndefined = false;
	
	      flatValue = Object.keys(classValue).filter(function(key) {
	        var value = classValue[key];
	
	        if (!hasUndefined && isUndefined(value)) {
	          hasUndefined = true;
	        }
	
	        return value;
	      });
	
	      if (hasUndefined) {
	        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
	        // the watcher, by including at least one `undefined` value.
	        flatValue.push(undefined);
	      }
	    }
	
	    return flatValue;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 *
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur click',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *
	 *     "default" also applies to all events that are listed in `updateOn` but are not
	 *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
	 *
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @knownIssue
	 *
	 * In Firefox, the select model is only updated when the select element is blurred. For example,
	 * when switching between options with the keyboard, the select model is only set to the
	 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
	 * outside the select.
	 *
	 * This is due to an ambiguity in the select element specification. See the
	 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
	 * for more information, and this
	 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.angular;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var currentUserService = function currentUserService() {
	  var service = {};
	  var namespace = 'CURRENT_USER';
	
	  service.store = store;
	  service.get = get;
	  service.clear = clear;
	  service.isConsultant = isConsultant;
	
	  function store(key, value) {
	    if (key === 'debtor') {
	      window.svelteStore.userDebtor.set(value);
	      localStorage.setItem('activeDebtor', value.Name);
	    } else {
	      sessionStorage.setItem(namespace + '_' + key, JSON.stringify(value));
	      if (value && value.IsFromAuth0) {
	        sessionStorage.setItem('IsFromAuth0', value.IsFromAuth0);
	      }
	    }
	
	    return get(key);
	  }
	
	  function get(key) {
	    var storedItem = sessionStorage.getItem(namespace + '_' + key);
	    return storedItem ? JSON.parse(storedItem) : null;
	  }
	
	  function clear(key) {
	    if (key) {
	      sessionStorage.removeItem(namespace + '_' + key);
	    } else {
	      Object.keys(sessionStorage).forEach(function (key) {
	        if (key.startsWith(namespace)) {
	          sessionStorage.removeItem(key);
	        }
	      });
	    }
	  }
	
	  function isConsultant() {
	    var userInfo = get('userInfo');
	    var _isConsultant = userInfo && userInfo.Role === 'Consultant';
	    if (_isConsultant) localStorage.setItem('isConsultant', true);
	    return _isConsultant;
	  }
	
	  return service;
	};
	
	currentUserService.$inject = $inject;
	
	exports['default'] = currentUserService;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbLocationSelect = angular.module('app.lbLocationSelect', []);
	
	lbLocationSelect.controller('lbLocationSelectCtrl', __webpack_require__(327));
	lbLocationSelect.component('lbLocationSelect', __webpack_require__(326));
	
	exports['default'] = lbLocationSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var cssClassNameFilter = function cssClassNameFilter() {
	  return function (str) {
	    if (!str) return '';
	
	    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
	    }).replace(/\s+/g, '');
	  };
	};
	
	cssClassNameFilter.$inject = $inject;
	
	exports['default'] = cssClassNameFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'moment', 'APP_CONFIG', 'locationService', 'ENUMS'];
	
	var itinerariesService = function itinerariesService($q, $http, moment, APP_CONFIG, locationService, ENUMS) {
	  var service = {
	    itinerary: undefined,
	    get: getItinerary,
	    set: set,
	    save: save,
	    post: post,
	    find: find,
	    reset: reset,
	    getCurrentSearch: getCurrentSearch,
	    getStayLength: getStayLength,
	    searchItineraries: searchItineraries,
	    locationSearch: locationSearch,
	    addItems: addItems,
	    updateSearch: updateSearch,
	    postSearch: postSearch,
	    getPolicyOptions: getPolicyOptions,
	    deleteSector: deleteSector,
	    groupPost: groupPost,
	    nextStage: nextStage,
	    totalPaxInCurrentSearch: totalPaxInCurrentSearch,
	    invalidSeatsForSector: invalidSeatsForSector,
	    isUsingRailCard: isUsingRailCard,
	    getLoyaltyPrograms: getLoyaltyPrograms,
	    getCarSupplierLocations: getCarSupplierLocations,
	    getFareRules: getFareRules,
	    postMembership: postMembership,
	    deleteMembership: deleteMembership,
	    getApprovers: getApprovers,
	    getPassengerApprovers: getPassengerApprovers,
	    getCompanyReferences: getCompanyReferences,
	    getDepartments: getDepartments,
	    getCostCentres: getCostCentres,
	    putFlight: putFlight,
	    putRail: putRail,
	    computePaxFlightTotalAmount: computePaxFlightTotalAmount,
	    computePaxSectors: computePaxSectors,
	    deletePax: deletePax,
	    computeItinerary: computeItinerary,
	    requiresApproval: requiresApproval,
	    isChanging: isChanging
	  };
	
	  function isChanging() {
	    return service.itinerary.ChangeStatus === 'Changing';
	  }
	
	  function getCurrentSearch(searchIdentifier) {
	    var currentSearchType = locationService.currentSearchType;
	
	    if (searchIdentifier) {
	      return service.itinerary.Search[currentSearchType + 's'].find(function (searchItem) {
	        return searchItem.Identifier === searchIdentifier;
	      });
	    } else {
	      var currentSearchIndex = locationService.searchIndex[currentSearchType];
	      return service.itinerary.Search[currentSearchType + 's'][currentSearchIndex];
	    }
	  }
	
	  function getStayLength(hotelSearch) {
	    var checkinMoment = moment(hotelSearch.DateFrom);
	    var checkoutMoment = moment(hotelSearch.DateTo);
	
	    return checkoutMoment.diff(checkinMoment, 'days');
	  }
	
	  function getPolicyOptions(searchIdentifier) {
	    return getCurrentSearch(searchIdentifier).Policy;
	  }
	
	  function totalPaxInCurrentSearch() {
	    return getCurrentSearch().Passengers.length;
	  }
	
	  function updateSearch(searchType, searchIndex, search) {
	    if (Number.isInteger(searchIndex)) {
	      if (searchType === 'Cars') {
	        service.itinerary.Search[searchType][searchIndex] = search;
	      } else {
	        _.merge(service.itinerary.Search[searchType][searchIndex], search);
	      }
	    } else if (_.isArray(search)) {
	      _.forEach(search, function (newSearch, searchIndex) {
	        _.merge(service.itinerary.Search[searchType][searchIndex], newSearch);
	      });
	    }
	
	    set(service.itinerary);
	
	    return service.itinerary.Search;
	  }
	
	  function postSearch(updatedSearch) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itinerarySearch', service.itinerary.Identifier);
	
	    $http.post(apiConfig.url, updatedSearch, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      service.itinerary.Search = data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function set(itinerary) {
	    service.itinerary = Array.isArray(itinerary) ? itinerary[0] : itinerary;
	    window.svelteStore.setItineraryId('search', service.itinerary.Identifier);
	  }
	
	  function getItinerary(id) {
	    var deferred = $q.defer();
	    var itineraryId = null;
	
	    if (id) {
	      itineraryId = id;
	    } else {
	      var sessionItineraryId = window.svelteStore.getItineraryId('search');
	      itineraryId = sessionItineraryId ? sessionItineraryId : window.itineraryId;
	    }
	
	    var apiConfig = window.svelteStore.apiConfig('itinerary', {
	      itineraryId: itineraryId
	    });
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	
	      if (data) {
	        var itineraryData = _.isArray(data) ? data[0] : data;
	        service.set(itineraryData, false);
	        deferred.resolve(itineraryData);
	      } else {
	        deferred.reject();
	      }
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function searchItineraries(params) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itinerary');
	
	    $http.get(apiConfig.url, { params: params, apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function post(data, id, skipNext) {
	    var deferred = $q.defer();
	
	    var apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId: id });
	
	    $http.post(apiConfig.url, data, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      service.set(data);
	
	      if (!skipNext) {
	        nextStage();
	      }
	
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function save(data, id) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId: id });
	
	    $http.put(apiConfig.url, data, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function find(itineraryId, passengerId) {
	    var deferred = $q.defer();
	
	    var apiConfig = window.svelteStore.apiConfig('itinerary', { itineraryId: itineraryId, passengerId: passengerId });
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      service.set(data);
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function reset() {
	    window.svelteStore.removeItineraryId('search');
	    window.svelteStore.removeItineraryId('manage');
	    window.svelteStore.removeItineraryId('confirmation');
	    service.itinerary = {};
	  }
	
	  function getFareRules(params) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', params, 'farerules');
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function locationSearch(params) {
	    var deferred = $q.defer();
	
	    $http.get('' + APP_CONFIG.api.url + params.type + '/locations/' + params.maxRows + '/' + params.term, {
	      desc: 'retrieving Airport locations from the server'
	    }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function groupPost(id, items, type) {
	    var searchIndexKey = undefined;
	    var searchIndexIncrement = 1;
	
	    switch (type) {
	      case 'Hotels':
	        searchIndexKey = 'Hotel';
	
	        break;
	
	      case 'Flights':
	        searchIndexKey = 'Flight';
	
	        searchIndexIncrement = service.itinerary.Search.Flights.length;
	
	        break;
	
	      case 'Rails':
	        searchIndexKey = 'Rail';
	
	        searchIndexIncrement = service.itinerary.Search.Rails.length;
	
	        break;
	
	      case 'Cars':
	        searchIndexKey = 'Car';
	
	        break;
	
	      default:
	        console.warn('No postType supplied');
	    }
	
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassenger', { itineraryId: id });
	
	    $http.post(apiConfig.url, items, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (searchIndexKey === 'Flight' && service.itinerary.Search.Flights.length === 2 && service.itinerary.Search.Cars.length > 0) {
	        service.get(service.itinerary.Id).then(function () {
	          locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement);
	          nextStage();
	        });
	      } else {
	        service.itinerary.Passengers = data;
	        locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement);
	        nextStage();
	      }
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function deleteSector(itineraryId, passengerId, sectorId, sectorType) {
	    var apiConfig = null;
	
	    switch (sectorType) {
	      case 'Flights':
	        apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', { itineraryId: itineraryId, passengerId: passengerId, sectorId: sectorId });
	        break;
	      case 'Hotels':
	        apiConfig = window.svelteStore.apiConfig('itineraryPassengerHotel', { itineraryId: itineraryId, passengerId: passengerId, sectorId: sectorId });
	        break;
	      case 'Rails':
	        apiConfig = window.svelteStore.apiConfig('itineraryPassengerRail', { itineraryId: itineraryId, passengerId: passengerId, sectorId: sectorId });
	        break;
	      case 'Cars':
	        apiConfig = window.svelteStore.apiConfig('itineraryPassengerCar', { itineraryId: itineraryId, passengerId: passengerId, sectorId: sectorId });
	        break;
	      default:
	        console.warn('No postType supplied');
	    }
	
	    var deferred = $q.defer();
	
	    $http['delete'](apiConfig.url, { apiVersion: apiConfig.version }).then(function () {
	      getItinerary(itineraryId).then(function () {
	        deferred.resolve();
	      });
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function addItems(items, type) {
	    var passengers = service.itinerary.Passengers;
	
	    angular.forEach(service.itinerary.Search.Passengers, function (passenger) {
	      var id = passenger.Identifier;
	      var targetPassenger = _.find(passengers, function (o) {
	        return o.Identifier === id;
	      });
	
	      targetPassenger[type] = _.concat(targetPassenger[type], items);
	    });
	
	    return {
	      itineraryId: service.itinerary.Identifier,
	      items: items,
	      type: type
	    };
	  }
	
	  function nextStage() {
	    locationService.nextPage(service.itinerary.Search, service.isChanging());
	  }
	
	  function invalidSeatsForSector(sector) {
	    var invalidSeats = [];
	
	    if (sector.Seat && sector.Seat.Status === 'Failed') {
	      invalidSeats.push(flight.Seat);
	    }
	
	    _.forEach(flight.Stops, function (stop) {
	      if (stop.Seat.Status === 'Failed') {
	        invalidSeats.push(stop.Seat);
	      }
	    });
	
	    return invalidSeats;
	  }
	
	  function isUsingRailCard() {
	    return _.some(service.itinerary.Search.Rails, function (railSearch) {
	      return railSearch.RailCardCode;
	    });
	  }
	
	  function getLoyaltyPrograms(query) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('loyaltyProgram');
	
	    $http.get(apiConfig.url, { params: { 'q': query }, apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (data) {
	        var mappedData = data.map(function (data) {
	          data.TypeTitleValue = data.Type + ':' + data.Title + ':' + data.Value;
	          return data;
	        });
	        deferred.resolve(mappedData);
	      } else {
	        deferred.reject();
	      }
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getCarSupplierLocations(cityCode) {
	    var path = 'api/Car/depots?citycode=' + cityCode;
	    return $http.get(APP_CONFIG.api.root + path);
	  }
	
	  function postMembership(traveler, membership) {
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerMembership', { itineraryId: traveler.ItineraryIdentifier, passengerId: traveler.Identifier });
	    return $http.post(apiConfig.url, membership, { apiVersion: apiConfig.version });
	  }
	
	  function deleteMembership(traveler, membership) {
	    var data = {};
	    angular.copy(membership, data);
	    delete data.traveler;
	    delete data.requestDelete;
	
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerMembership', { itineraryId: traveler.ItineraryIdentifier, passengerId: traveler.Identifier });
	
	    return $http({
	      method: 'DELETE',
	      url: apiConfig.url,
	      data: data,
	      apiVersion: apiConfig.version
	    });
	  }
	
	  function getApprovers(itineraryId) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryApprovers', itineraryId);
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (data) {
	        var approvers = data.map(function (approver) {
	          approver.fullName = approver.FirstName + ' ' + approver.LastName;
	          return approver;
	        });
	        deferred.resolve(approvers);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getPassengerApprovers(itineraryId) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryApprovers', itineraryId);
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getCompanyReferences(itineraryId) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryCompanyReference', itineraryId);
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getDepartments(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/Department/';
	    $http.get(APP_CONFIG.api.root + path).then(function (res) {
	      var data = res.data;
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getCostCentres(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/CostCentre/';
	    $http.get(APP_CONFIG.api.root + path).then(function (res) {
	      var data = res.data;
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function putFlight(itineraryId, paxId, flightSectorId, flightSector) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/Passenger/' + paxId + '/Flight/' + flightSectorId, flightSector).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function putRail(itineraryId, paxId, railSectorId, railSector) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/Passenger/' + paxId + '/Rail/' + railSectorId, railSector).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function computeBaggageOptions(flight) {
	    var baggage = [];
	    var ancillaryService = flight.AncillaryServices;
	
	    for (var i = 0; i < ancillaryService.length; i++) {
	      if (ancillaryService[i].Type === 'Baggage') {
	        baggage.push(ancillaryService[i]);
	      }
	    }
	
	    flight.baggageOptions = baggage.length > 0 ? [{ Description: 'No baggage required', Code: 'empty' }].concat(baggage) : baggage;
	    return flight;
	  }
	
	  function computeSelectedBaggage(flight) {
	    var baggage = null;
	    var ancillaryServices = flight.AncillaryServices;
	
	    _.forEach(ancillaryServices, function (ancillaryService) {
	      if (ancillaryService.Type === 'Baggage' && ancillaryService.QuantitySelected > 0) baggage = ancillaryService;
	    });
	
	    baggage = baggage || { Description: 'Select Additional Baggage', Code: 'empty' };
	
	    flight.selectedBaggage = baggage;
	    return flight;
	  }
	
	  function computeSeatOptions(flight) {
	    var ancillaryServices = flight.AncillaryServices;
	    var stops = flight.Stops;
	    var flights = [];
	
	    var fullFlight = flight;
	    var totalStops = stops.length;
	
	    var seats = _.filter(ancillaryServices, function (service) {
	      return service.Type === 'Seat';
	    });
	
	    var prevLocationCode = totalStops ? stops[0].ArrivalCode : fullFlight.Arrival.Code;
	
	    if (seats.length) {
	      flights.push({
	        Flight: {
	          Origin: fullFlight.Departure.Code,
	          Destination: prevLocationCode,
	          TravelIdentifier: generateId(fullFlight.FlightIdentifier, 0)
	        },
	        Seats: seats
	      });
	    }
	
	    _.forEach(stops, function (stop, stopIndex) {
	      var stopSeats = _.filter(stop.AncillaryServices, function (service) {
	        return service.Type === 'Seat';
	      });
	
	      if (stopSeats.length) {
	        var isLastStop = stopIndex === totalStops - 1;
	        var nextLocationCode = isLastStop ? fullFlight.Arrival.Code : stops[totalStops - 1].ArrivalCode;
	
	        flights.push({
	          Flight: {
	            Origin: prevLocationCode,
	            Destination: nextLocationCode,
	            TravelIdentifier: generateId(stop.FlightIdentifier, stopIndex + 1)
	          },
	          Seats: stopSeats
	        });
	      }
	    });
	
	    function generateId(flightId, flightIndex) {
	      return fullFlight.PassengerIdentifier + flightIndex + flightId;
	    }
	
	    flight.seatOptions = flights;
	    return flight;
	  }
	
	  function computeSeatPreferences(rail) {
	    var seatPreferenceTypes = ENUMS.railSeatPreferenceTypes;
	
	    rail.SeatPreferences = {};
	
	    _.forIn(seatPreferenceTypes, function (preferenceType) {
	      rail.SeatPreferences[preferenceType] = _.filter(rail.AncillaryServices, function (service) {
	        return service.Type === preferenceType;
	      });
	
	      rail.SeatPreferences[preferenceType] = _.orderBy(rail.SeatPreferences[preferenceType], function (service) {
	        return service.Code === 'No Preference' ? 0 : 1;
	      });
	    });
	
	    return rail;
	  }
	
	  function computeSeatsTotalAmount(flight) {
	    flight.seatsTotalAmount = _.reduce(flight.seatOptions, function (total, options) {
	      var selectedSeat = _.find(options.Seats, function (seat) {
	        return seat.QuantitySelected === 1;
	      });
	
	      return total + (selectedSeat ? selectedSeat.Amount : 0);
	    }, 0);
	
	    return flight;
	  }
	
	  function computeFlightTotalAmount(flight) {
	    var ancillaryServices = flight.AncillaryServices;
	    var feeAmount = flight.FeeAmount;
	    var amount = flight.Amount;
	    var stops = flight.Stops;
	
	    var flightTotalAmount = 0;
	
	    _.forEach(ancillaryServices, function (service) {
	      flightTotalAmount += service.QuantitySelected * service.Amount;
	    });
	
	    _.forEach(stops, function (stop) {
	      _.forEach(stop.AncillaryServices, function (service) {
	        flightTotalAmount += service.QuantitySelected * service.Amount;
	      });
	    });
	
	    flight.flightTotalAmount = flightTotalAmount + amount + feeAmount;
	    return flight;
	  }
	
	  function computeFlightSector(sector) {
	    return _.flowRight(computeFlightTotalAmount, computeSeatsTotalAmount, computeSeatOptions, computeSelectedBaggage, computeBaggageOptions)(sector);
	  }
	
	  function computePaxFlightTotalAmount(pax) {
	    var CreditsUsed = 0;
	    var flights = pax.Flights;
	
	    _.forEach(flights, function (flight) {
	      CreditsUsed += flight.CreditsUsed;
	    });
	
	    return CreditsUsed;
	  }
	
	  function computePaxSectors(pax) {
	    var flights = pax.Flights;
	    var rails = pax.Rails;
	    var hotels = pax.Hotels;
	    var cars = pax.Cars;
	
	    var noTimezoneDateFormat = 'YYYY-MM-DDTHH:mm';
	    var sortingDateFormat = 'YYYYMMDDHHmm';
	    var groupingDateFormat = 'YYYYMMDD';
	    var groupingDateDisplayFormat = 'ddd, DD MMM';
	
	    var sectorsArray = [].concat(flights || [], rails || [], hotels || [], cars || []);
	
	    for (var x = 0; x < sectorsArray.length; x++) {
	      var parsedDate = null;
	
	      try {
	        if (sectorsArray[x].Departure && sectorsArray[x].Departure.Date) {
	          parsedDate = moment(sectorsArray[x].Departure.Date, noTimezoneDateFormat);
	        } else if (sectorsArray[x].DateFrom) {
	          parsedDate = moment(sectorsArray[x].DateFrom, noTimezoneDateFormat);
	        } else if (sectorsArray[x].PickUp && sectorsArray[x].PickUp.Date) {
	          parsedDate = moment(sectorsArray[x].PickUp.Date, noTimezoneDateFormat);
	        }
	      } catch (err) {}
	
	      sectorsArray[x].groupByDate = parsedDate ? parsedDate.format(sortingDateFormat) : null;
	    }
	
	    sectorsArray.sort(function (sectorA, sectorB) {
	      return sectorA.groupByDate > sectorB.groupByDate ? 1 : -1;
	    });
	
	    var groupByDateString = null;
	    var groupId = 0;
	    var unorderedSectors = [];
	
	    for (var y = 0; y < sectorsArray.length; y++) {
	      var groupByDate = sectorsArray[y].groupByDate;
	      var trimmedGroupByDate = null;
	      var groupCopy = {};
	
	      if (groupByDate) {
	        trimmedGroupByDate = groupByDate.substring(0, groupByDate.length - 4);
	      }
	
	      if (trimmedGroupByDate && groupByDateString !== trimmedGroupByDate) {
	        groupId++;
	        groupByDateString = trimmedGroupByDate;
	        sectorsArray[y].groupByDateString = moment(groupByDateString, groupingDateFormat).format(groupingDateDisplayFormat);
	      }
	
	      groupCopy = sectorsArray[y];
	      groupCopy.groupId = groupId;
	      unorderedSectors.push(groupCopy);
	    }
	
	    var matchGroupIds = function matchGroupIds(array) {
	      var x = [];
	      angular.forEach(array, function (obj) {
	        x.push(obj.groupId);
	      });
	      return x;
	    };
	
	    var onlyUnique = function onlyUnique(value, index, self) {
	      return self.indexOf(value) === index;
	    };
	
	    var spiltArray = function spiltArray(array, argumentArray) {
	      var result = [];
	      var argumentIndex = 0;
	      angular.forEach(array, function (obj) {
	        if (obj.groupId !== argumentArray[argumentIndex]) {
	          argumentIndex++;
	        }
	        if (!result[argumentIndex]) {
	          result[argumentIndex] = [obj];
	        } else {
	          result[argumentIndex].push(obj);
	        }
	      });
	      return result;
	    };
	
	    var reorderParentChild = function reorderParentChild(parent) {
	      var ParentReordered = [];
	
	      angular.forEach(parent, function (obj) {
	        var flights = pluckNamedObjectFromArray(obj, 'Flight');
	        var rails = pluckNamedObjectFromArray(obj, 'Rail');
	        var hotels = pluckNamedObjectFromArray(obj, 'Hotel');
	        var cars = pluckNamedObjectFromArray(obj, 'Car');
	        var childReordered = flights.concat(rails, hotels, cars);
	        ParentReordered.push(childReordered);
	      });
	
	      return ParentReordered;
	    };
	
	    var pluckNamedObjectFromArray = function pluckNamedObjectFromArray(array, match) {
	      var matches = [];
	      angular.forEach(array, function (obj) {
	        if (match === 'Flight' && obj.Carrier && !obj.RailNumber) {
	          matches.push(obj);
	        }
	        if (match === 'Rail' && obj.RailNumber) {
	          matches.push(obj);
	        }
	        if (match === 'Hotel' && obj.HotelCode) {
	          matches.push(obj);
	        }
	        if (match === 'Car' && obj.PickUp) {
	          matches.push(obj);
	        }
	      });
	      return matches;
	    };
	
	    var moveAttributeToIndex = function moveAttributeToIndex(array, attr) {
	      var val = '';
	
	      angular.forEach(array, function (childArray, key) {
	        angular.forEach(childArray, function (obj, index) {
	          if (obj[attr]) {
	            val = obj[attr];
	            delete array[key][index][attr];
	          }
	          array[key][0][attr] = val;
	        });
	      });
	
	      return array;
	    };
	
	    var groupsToOrder = matchGroupIds(unorderedSectors);
	    var uniqueGroups = groupsToOrder.filter(onlyUnique);
	    var groupByDay = spiltArray(unorderedSectors, uniqueGroups);
	    var reorderSectorsInDay = reorderParentChild(groupByDay);
	    var moveGroupDate = moveAttributeToIndex(reorderSectorsInDay, 'groupByDateString');
	
	    pax.Sectors = [].concat.apply([], moveGroupDate);
	    return pax;
	  }
	
	  function computePaxFlightTotal(pax) {
	    var flights = pax.Flights;
	    var flightTotal = 0;
	
	    _.forEach(flights, function (flight) {
	      flightTotal += flight.TotalAmount;
	    });
	
	    pax.FlightTotal = flightTotal;
	    return pax;
	  }
	
	  function computePaxRailTotal(pax) {
	    var rails = pax.Rails;
	    var railTotal = 0;
	
	    _.forEach(rails, function (rail) {
	      railTotal += rail.TotalAmount;
	    });
	
	    pax.RailTotal = railTotal;
	    return pax;
	  }
	
	  function computePaxHotelTotal(pax) {
	    var hotels = pax.Hotels;
	    var hotelTotal = 0;
	
	    _.forEach(hotels, function (hotel) {
	      hotelTotal += hotel.TotalAmount;
	    });
	
	    pax.HotelTotal = hotelTotal;
	    return pax;
	  }
	
	  function computePaxCarTotal(pax) {
	    var cars = pax.Cars;
	    var carTotal = 0;
	
	    _.forEach(cars, function (car) {
	      carTotal += car.TotalAmount;
	    });
	
	    pax.CarTotal = carTotal;
	    return pax;
	  }
	
	  function computePaxAmount(pax) {
	    var flightTotal = pax.FlightTotal;
	    var RailTotal = pax.RailTotal;
	    var hotelTotal = pax.HotelTotal;
	    var carTotal = pax.CarTotal;
	
	    pax.Amount = Number(flightTotal) + Number(RailTotal) + Number(hotelTotal) + Number(carTotal);
	
	    return pax;
	  }
	
	  function computePaxFlightLostSavingsTotal(pax) {
	    var flights = pax.Flights;
	    var lostSavingsTotal = 0;
	
	    _.forEach(flights, function (flight) {
	      lostSavingsTotal += flight.LostSavingsAmount;
	    });
	
	    pax.RailLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeRailLostSavingsTotal(pax) {
	    var rails = pax.Rails;
	    var lostSavingsTotal = 0;
	
	    _.forEach(rails, function (rail) {
	      lostSavingsTotal += rail.LostSavingsAmount;
	    });
	
	    pax.RailLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeHotelLostSavingsTotal(pax) {
	    var hotels = pax.Hotels;
	    var lostSavingsTotal = 0;
	
	    _.forEach(hotels, function (hotel) {
	      lostSavingsTotal += hotel.LostSavingsAmount;
	    });
	
	    pax.CarLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeCarLostSavingsTotal(pax) {
	    var cars = pax.Cars;
	    var lostSavingsTotal = 0;
	
	    _.forEach(cars, function (car) {
	      if (typeof car.LostSavingsAmount === 'number') {
	        lostSavingsTotal += car.LostSavingsAmount;
	      }
	    });
	
	    pax.CarLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeLostSavingsAmount(pax) {
	    pax.LostSavingsAmount = Number(pax.FlightLostSavingsTotal) + Number(pax.RailLostSavingsTotal) + Number(pax.HotelLostSavingsTotal) + Number(pax.CarLostSavingsTotal);
	
	    return pax;
	  }
	
	  function computeCreditsUsed(pax) {
	    var flights = pax.Flights;
	    var creditsUsedTotal = 0;
	
	    if (Array.isArray(flights) && flights.length) {
	      _.forEach(flights, function (flight) {
	        if (typeof flight.CreditsUsed === 'number') {
	          creditsUsedTotal += flight.CreditsUsed;
	        }
	      });
	    }
	
	    pax.CreditsUsed = creditsUsedTotal;
	    return pax;
	  }
	
	  function computeHasFlightSectors(pax) {
	    var hasFlights = false;
	    if (!!pax && !!pax.Sectors && pax.Sectors.length > 0) {
	      for (var i = 0; i < pax.Sectors.length; i++) {
	        hasFlights = !!pax.Sectors[i].FlightNumber || hasFlights;
	      }
	    }
	
	    pax.hasFlights = true;
	    return pax;
	  }
	
	  function deletePax(paxId, itineraryId) {
	    var deferred = $q.defer();
	
	    $http['delete'](APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/passenger/' + paxId).then(function () {
	      getItinerary(itineraryId).then(function (res) {
	        deferred.resolve(res);
	      });
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function computePax(pax) {
	    pax.Flights = pax.Flights.map(function (flight) {
	      return computeFlightSector(flight);
	    });
	
	    pax.Rails = pax.Rails.map(function (rail) {
	      return computeRailSector(rail);
	    });
	
	    return pax;
	  }
	
	  function computeTicketOptions(sector) {
	    var ancillaryServices = sector.AncillaryServices;
	
	    var options = _.filter(ancillaryServices, function (service) {
	      return service.Type === 'Ticketing';
	    });
	
	    sector.ticketOptions = _.map(options, function (option) {
	      if (option.Description === 'Collection') {
	        option.Description = 'Pickup on departure - ' + sector.Departure.Location + ' (' + sector.Departure.Code + ')';
	      }
	
	      return option;
	    });
	
	    return sector;
	  }
	
	  function computeItineraryTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var itineraryTotal = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.Amount === 'number') {
	          itineraryTotal += traveler.Amount;
	        }
	      });
	    }
	
	    itinerary.ItineraryTotal = itineraryTotal;
	
	    return itinerary;
	  }
	
	  function computeCreditsUsedTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var totalCreditsUsed = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.CreditsUsed === 'number') {
	          totalCreditsUsed += traveler.CreditsUsed;
	        }
	      });
	    }
	
	    itinerary.CreditsUsedTotal = totalCreditsUsed;
	
	    return itinerary;
	  }
	
	  function computeLostSavingsTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var lostSavingsTotal = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.LostSavingsAmount === 'number') {
	          lostSavingsTotal += traveler.LostSavingsAmount;
	        }
	      });
	    }
	
	    itinerary.LostSavingsTotal = lostSavingsTotal;
	
	    return itinerary;
	  }
	
	  function computeNonRefundableContent(itinerary) {
	    var travelers = itinerary.Passengers;
	    var NonRefundable = false;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        var continueLoop = true;
	        _.forEach(traveler.Sectors, function (sector) {
	          if (sector.Refundable === false) {
	            NonRefundable = true;
	            continueLoop = false;
	            return false;
	          }
	        });
	
	        return continueLoop;
	      });
	    }
	
	    itinerary.NonRefundableContent = NonRefundable;
	
	    return itinerary;
	  }
	
	  function computeRailSector(sector) {
	    return _.flowRight(computeTicketOptions, computeSeatPreferences)(sector);
	  }
	
	  function computeItinerary(itinerary) {
	    if (!itinerary.Passengers && itinerary.Passengers.length === 0) {
	      return itinerary;
	    }
	
	    itinerary.Passengers.map(function (pax) {
	      return _.flowRight(computeHasFlightSectors, computeCreditsUsed, computeLostSavingsAmount, computeCarLostSavingsTotal, computeHotelLostSavingsTotal, computeRailLostSavingsTotal, computePaxFlightLostSavingsTotal, computePaxAmount, computePaxCarTotal, computePaxHotelTotal, computePaxRailTotal, computePaxFlightTotal, computePaxSectors, computePax)(pax);
	    });
	
	    return _.flowRight(computeNonRefundableContent, computeLostSavingsTotal, computeCreditsUsedTotal, computeItineraryTotal)(itinerary);
	  }
	
	  function requiresApproval(itinerary) {
	    return _.some(itinerary.Passengers, function (pax) {
	      return ['Passive', 'PreTrip'].indexOf(pax.ApprovalLevel) > -1;
	    });
	  }
	
	  return service;
	};
	
	itinerariesService.$inject = $inject;
	
	exports['default'] = itinerariesService;
	module.exports = exports['default'];

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment', '$q', '$http', 'APP_CONFIG'];
	
	var seatMapService = function seatMapService(moment, $q, $http, APP_CONFIG) {
	
	  var service = {
	    init: init,
	    get: get,
	    putSeat: putSeat,
	    formatDates: formatDates,
	    setActiveSeatMap: setActiveSeatMap,
	    deactivateSeat: deactivateSeat,
	    findIdentifierIn: findIdentifierIn,
	    setActive: setActive,
	    buildDeck: buildDeck,
	    resetSeatMap: resetSeatMap,
	    cleanActiveSeats: cleanActiveSeats,
	    findSeat: findSeat,
	    showLegs: showLegs,
	    lookUpSeatNumber: lookUpSeatNumber,
	    findReplaceFlight: findReplaceFlight,
	    paxArray: [],
	    activePax: undefined,
	    activeFlight: undefined,
	    activeTransport: undefined,
	    activeSeatMap: undefined,
	    activeDeck: undefined,
	    activeSeat: undefined,
	    showModal: false,
	    showKey: false,
	    showPaymentOptions: false,
	    showSeatSelector: false,
	    savingSeatSelection: false,
	    error: false
	  };
	
	  function init(passengers, paxId) {
	    service.paxArray = [];
	    service.activePax = undefined;
	    service.activeFlight = undefined;
	    service.activeSeatMap = undefined;
	    service.activeDeck = undefined;
	    service.activeSeat = undefined;
	    service.showKey = false;
	    service.showPaymentOptions = false;
	    service.savingSeatSelection = false;
	    service.error = false;
	
	    passengers.forEach(function (pax) {
	      if (pax.Flights.length > 0) {
	        pax.Flights = service.formatDates(pax.Flights);
	        if (pax.Identifier === paxId) {
	          service.paxArray.unshift(pax);
	        } else {
	          service.paxArray.push(pax);
	        }
	      }
	    });
	  }
	
	  function get(itineraryId, passengerId, sectorId) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', { itineraryId: itineraryId, passengerId: passengerId, sectorId: sectorId }, 'seatmap');
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function putSeat(seat, flight, transport, payment) {
	    var deferred = $q.defer();
	
	    var seatObj = {
	      PaymentMethod: null,
	      Seats: {
	        SeatNumber: seat.Id,
	        Carrier: transport.Operator,
	        FlightNumber: transport.Id,
	        OriginLocationCode: transport.Origin,
	        LocationCode: transport.Destination
	      }
	    };
	
	    if (payment && seat.Price) {
	      var thisSeat = seatObj.Seats;
	
	      thisSeat.SeatAmount = seat.Price.Amount;
	      thisSeat.TaxAmount = seat.Price.SeatTaxAmount;
	      thisSeat.SeatCurrencyCode = seat.Price.CurrencyCode;
	      thisSeat.BaseCurrency = {
	        Code: seat.Price.CurrencyCode,
	        TaxAmount: seat.Price.SeatTaxAmount,
	        FeeAmount: 0,
	        Amount: seat.Price.Amount,
	        TotalAmount: seat.Price.Amount
	      };
	
	      seatObj.PaymentMethod = {
	        SectorGroupIdentifier: flight.GroupIdentifier,
	        SectorIdentifier: flight.Identifier,
	        Type: "Seat"
	      };
	
	      if (payment.PaymentType === 'Card') {
	        seatObj.PaymentMethod.Card = payment;
	      }
	
	      if (payment.PaymentType === 'Invoice') {
	        seatObj.PaymentMethod.Invoice = {
	          Reference: 'Invoice'
	        };
	      }
	    }
	
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerFlight', {
	      itineraryId: flight.ItineraryIdentifier,
	      passengerId: flight.PassengerIdentifier,
	      sectorId: flight.Identifier
	    }, 'seat');
	
	    $http.put(apiConfig.url, seatObj, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function formatDates(flights) {
	    return flights.map(function (flight) {
	      flight.dateFormatted = moment(flight.Departure.Date, 'YYYY-MM-DD').format('ddd, MMM M');
	      return flight;
	    });
	  }
	
	  function setActiveSeatMap(seatMap) {
	    service.deactivateSeat();
	    service.activeSeatMap = seatMap;
	  }
	
	  function deactivateSeat() {
	    if (service.activeSeat) {
	      service.activeSeat.active = false;
	    }
	
	    service.activeSeat = undefined;
	  }
	
	  function findIdentifierIn(id, obj, prop) {
	    var result = undefined;
	
	    obj[prop].every(function (x) {
	      if (x.Identifier === id) {
	        result = x;
	        return false;
	      }
	
	      return true;
	    });
	
	    return result;
	  }
	
	  function setActive(data, target) {
	    if (service[target]) {
	      service[target].active = false;
	    }
	
	    data.active = true;
	    service[target] = data;
	
	    return data;
	  }
	
	  function buildDeck(deck) {
	    var formatted = [];
	
	    deck.Cabins.forEach(function (cabin) {
	      cabin.formattedRows = buildRows(cabin.Rows);
	      cabin.maxRowItems = maxRowItems(cabin.formattedRows);
	      formatted.push(cabin);
	    });
	
	    return formatted;
	  }
	
	  function buildRows(rows) {
	    return _.flowRight(functionalRowFormat, purgeEmptyRows, combiningFunctionTypes, addAisles)(rows);
	  }
	
	  function addAisles(rows) {
	    var results = [];
	
	    rows.forEach(function (row, rowIndex) {
	      var insertAt = [];
	
	      results.push({ Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: angular.copy(row.Items) });
	
	      row.Items.forEach(function (item, itemIndex) {
	        if (item.RowLocation === 'WindowAisle' || item.RowLocation === 'Aisle') {
	          insertAt.push({ itemIndex: itemIndex + 1 });
	        }
	      });
	
	      if (insertAt.length > 0) {
	        results[rowIndex].Items.splice(insertAt[0].itemIndex, 0, { FunctionType: 'Aisle' });
	      }
	
	      if (insertAt.length > 1 && insertAt[insertAt.length - 1].itemIndex - insertAt[0].itemIndex > 1) {
	        results[rowIndex].Items.splice(insertAt[insertAt.length - 1].itemIndex, 0, { FunctionType: 'Aisle' });
	      }
	    });
	
	    return results;
	  }
	
	  function combiningFunctionTypes(rows) {
	    var results = [];
	    var rowIndex = 0;
	
	    rows.forEach(function (row) {
	      results.push({ Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: [] });
	      var functionalItemBlock = undefined;
	      var prevItem = undefined;
	
	      row.Items.forEach(function (item) {
	        results[rowIndex].Items.push(item);
	
	        var isFunctionalItem = isFunctionalItemFn(item);
	
	        if (isFunctionalItem && prevItem && prevItem.FunctionType === item.FunctionType && prevItem.Location === item.Location) {
	          item.hide = true;
	          if (functionalItemBlock) {
	            functionalItemBlock.expandRight += 1;
	          } else {
	            functionalItemBlock = prevItem;
	            functionalItemBlock.expandRight = 2;
	          }
	          functionalItemBlock.RowLocation = item.RowLocation;
	        } else {
	          prevItem = undefined;
	          functionalItemBlock = undefined;
	        }
	
	        if (isFunctionalItem) {
	          prevItem = item;
	        }
	      });
	
	      rowIndex = rowIndex + 1;
	    });
	
	    return results;
	  }
	
	  function expandRowVertical(rows) {
	    var prevRow = undefined;
	
	    rows.forEach(function (row) {
	      row.Items.forEach(function (item, itemIndex) {
	        var isFunctionalItem = isFunctionalItemFn(item);
	
	        if (prevRow) {
	          var prevRowItem = prevRow.Items[itemIndex];
	          if (prevRowItem && isFunctionalItem && item.FunctionType === prevRowItem.FunctionType && item.expandRight === prevRowItem.expandRight) {
	            prevRowItem.expandDown = 2; // Limit to 2 as any more looks stupid when rendered.
	            item.hide = true;
	          }
	        }
	      });
	
	      prevRow = row;
	    });
	
	    return rows;
	  }
	
	  function purgeEmptyRows(rows) {
	
	    rows.forEach(function (row) {
	      var hide = true;
	      var noSeats = true;
	
	      row.Items.forEach(function (item) {
	
	        if (!item.hide) {
	          hide = false;
	        }
	
	        if (item.hasOwnProperty('Available')) {
	          noSeats = false;
	        }
	      });
	
	      row.noSeats = noSeats;
	      row.hide = hide;
	    });
	
	    return rows;
	  }
	
	  function functionalRowFormat(rows) {
	
	    rows.forEach(function (row) {
	      if (row.noSeats && !row.hide) {
	        (function () {
	
	          var centreItem = {
	            FunctionType: 'Combined',
	            Location: 'Centre',
	            types: []
	          };
	
	          var indexes = [];
	
	          row.Items.forEach(function (item, index) {
	            if (item.Location === 'Centre' && item.FunctionType != 'Storage') {
	              centreItem.types.push(item.FunctionType);
	              indexes.push(index);
	            }
	          });
	
	          _.pullAt(row.Items, indexes);
	          centreItem.types = _.uniq(centreItem.types);
	
	          if (centreItem.types.length > 0) {
	            row.Items.push(centreItem);
	          }
	        })();
	      }
	    });
	
	    return rows;
	  }
	
	  function maxRowItems(rows) {
	    var max = 0;
	
	    rows.forEach(function (row) {
	      if (row.Items.length > max) {
	        max = row.Items.length;
	      }
	    });
	
	    return max;
	  }
	
	  function isFunctionalItemFn(item) {
	    return item.hasOwnProperty('FunctionType') && item.FunctionType !== 'Aisle' && item.FunctionType !== 'NoSeat';
	  }
	
	  function resetSeatMap() {
	    service.activeSeatMap = undefined;
	
	    if (service.activeDeck) {
	      service.activeDeck.active = false;
	      service.activeDeck = undefined;
	    }
	  }
	
	  function cleanActiveSeats(seats) {
	    seats.Decks.forEach(function (deck) {
	      deck.Cabins.forEach(function (cabin) {
	        if (cabin.formattedRows) {
	          cabin.formattedRows.forEach(function (row) {
	            row.Items.map(function (seat) {
	              seat.active = false;
	              return seat;
	            });
	          });
	        }
	      });
	    });
	  }
	
	  function findSeat(deck, seatNumber) {
	    deck.Cabins.forEach(function (cabin) {
	      cabin.formattedRows.forEach(function (row) {
	        row.Items.map(function (seat) {
	          if (seat.Id === seatNumber) {
	            seat.active = true;
	          }
	          return seat;
	        });
	      });
	    });
	  }
	
	  function showLegs(flight) {
	    if (!flight.showStops) {
	      flight.showStops = true;
	
	      if (flight.showStops) {
	        flight.loadingSeatMaps = true;
	        //const activeFlight = service.setActive(flight, 'activeFlight');
	
	        service.get(flight.ItineraryIdentifier, flight.PassengerIdentifier, flight.Identifier).then(function (data) {
	          flight.loadingSeatMaps = false;
	          flight.seatmaps = true;
	          flight.transports = data.Transport;
	        });
	      } else {
	        flight.seatmaps = false;
	      }
	    }
	  }
	
	  function lookUpSeatNumber(journey, transport) {
	    var origin = transport.Origin;
	
	    if (journey.Seat.OriginLocationCode === origin) {
	      return journey.Seat.SeatNumber;
	    }
	
	    var seat = undefined;
	
	    journey.Stops.forEach(function (stop) {
	      if (stop.DepartsCode === origin) {
	        seat = stop.Seat.SeatNumber;
	      }
	    });
	
	    return seat;
	  }
	
	  function findReplaceFlight(newFlight, paxArray) {
	    var pax = _.find(paxArray, function (pax) {
	      return pax.Identifier === newFlight.PassengerIdentifier;
	    });
	    var flight = _.find(pax.Flights, function (flight) {
	      return flight.Identifier === newFlight.Identifier;
	    });
	
	    _.merge(flight, newFlight);
	  }
	
	  return service;
	};
	
	seatMapService.$inject = $inject;
	
	exports['default'] = seatMapService;
	module.exports = exports['default'];

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', '$q', '$http', 'APP_CONFIG'];
	
	var travellersService = function travellersService($filter, $q, $http, APP_CONFIG) {
	  var service = {};
	
	  service.isTravellerOnly = false;
	  service.options = [];
	  service.selected = [];
	
	  service.init = function init() {
	    service.isTravellerOnly = false;
	    service.options = [];
	    service.selected = [];
	  };
	
	  service.get = function get(query) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('travellers', query);
	
	    $http.get(apiConfig.url, { params: { query: query }, apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      var guests = JSON.parse(sessionStorage.getItem('guestTravellers')) || [];
	      var options = _.filter(_.concat(data, guests), function (option) {
	        return !_.find(service.selected, { 'Email': option.Email });
	      });
	      service.options = $filter('filter')(options, query);
	      deferred.resolve();
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  };
	
	  service.saveGuest = function (guest) {
	    var guests = JSON.parse(sessionStorage.getItem('guestTravellers')) || [];
	
	    var existingGuest = _.find(guests, function (guestTraveller) {
	      return guestTraveller.guestID === guest.guestID;
	    });
	
	    if (existingGuest) {
	      existingGuest = guest;
	    } else {
	      guests = guests.concat([guest]);
	    }
	
	    sessionStorage.setItem('guestTravellers', JSON.stringify(guests));
	
	    return service.selectedTravellers;
	  };
	
	  service.selectTraveller = function selectTraveller(traveller) {
	    if (service.selected.length < 9) {
	      var isExisitingSelectedGuestTraveller = false;
	
	      service.selected = _.map(service.selected, function (selectedTraveller) {
	        if (traveller.isGuest && selectedTraveller.guestID === traveller.guestID) {
	          isExisitingSelectedGuestTraveller = true;
	          return traveller;
	        } else {
	          return selectedTraveller;
	        }
	      });
	
	      if (!isExisitingSelectedGuestTraveller) {
	        service.selected = service.selected.concat([traveller]);
	      }
	    }
	  };
	
	  service.removeTraveller = function (traveller) {
	    service.selected = _.filter(service.selected, function (selectedTraveller) {
	      return selectedTraveller !== traveller;
	    });
	
	    traveller.setActive = false;
	    service.options.push(traveller);
	
	    return service.selected;
	  };
	
	  return service;
	};
	
	travellersService.$inject = $inject;
	
	exports['default'] = travellersService;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__.p = window.resourceBaseUrl + window.resourceBaseUrlAppPath + '/';


/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.6.9' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * sinceVersion="v1.4.0"
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 *
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by AngularJS's `toJson`/`fromJson`.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75);
	module.exports = 'ngCookies';


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define */
	(function (root, factory) {
	  'use strict';
	  if (typeof module !== 'undefined' && module.exports) {
	    if (typeof angular === 'undefined') {
	      factory(__webpack_require__(10));
	    } else {
	      factory(angular);
	    }
	    module.exports = 'angular-google-analytics';
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    factory(root.angular);
	  }
	}(this, function (angular, undefined) {
	  'use strict';
	  angular.module('angular-google-analytics', [])
	    .provider('Analytics', function () {
	      var accounts,
	          analyticsJS = true,
	          cookieConfig = 'auto', // DEPRECATED
	          created = false,
	          crossDomainLinker = false,
	          crossLinkDomains,
	          currency = 'USD',
	          debugMode = false,
	          delayScriptTag = false,
	          displayFeatures = false,
	          disableAnalytics = false,
	          domainName,
	          ecommerce = false,
	          enhancedEcommerce = false,
	          enhancedLinkAttribution = false,
	          experimentId,
	          ignoreFirstPageLoad = false,
	          logAllCalls = false,
	          hybridMobileSupport = false,
	          offlineMode = false,
	          pageEvent = '$routeChangeSuccess',
	          readFromRoute = false,
	          removeRegExp,
	          testMode = false,
	          traceDebuggingMode = false,
	          trackPrefix = '',
	          trackRoutes = true,
	          trackUrlParams = false;
	
	      this.log = [];
	      this.offlineQueue = [];
	
	      /**
	       * Configuration Methods
	       **/
	
	      this.setAccount = function (tracker) {
	        if (angular.isUndefined(tracker) || tracker === false) {
	          accounts = undefined;
	        } else if (angular.isArray(tracker)) {
	          accounts = tracker;
	        } else if (angular.isObject(tracker)) {
	          accounts = [tracker];
	        } else {
	          // In order to preserve an existing behavior with how the _trackEvent function works,
	          // the trackEvent property must be set to true when there is only a single tracker.
	          accounts = [{ tracker: tracker, trackEvent: true }];
	        }
	        return this;
	      };
	
	      this.trackPages = function (val) {
	        trackRoutes = !!val;
	        return this;
	      };
	
	      this.trackPrefix = function (prefix) {
	        trackPrefix = prefix;
	        return this;
	      };
	
	      this.setDomainName = function (domain) {
	        domainName = domain;
	        return this;
	      };
	
	      this.useDisplayFeatures = function (val) {
	        displayFeatures = !!val;
	        return this;
	      };
	
	      this.useAnalytics = function (val) {
	        analyticsJS = !!val;
	        return this;
	      };
	
	      this.useEnhancedLinkAttribution = function (val) {
	        enhancedLinkAttribution = !!val;
	        return this;
	      };
	
	      this.useCrossDomainLinker = function (val) {
	        crossDomainLinker = !!val;
	        return this;
	      };
	
	      this.setCrossLinkDomains = function (domains) {
	        crossLinkDomains = domains;
	        return this;
	      };
	
	      this.setPageEvent = function (name) {
	        pageEvent = name;
	        return this;
	      };
	
	      /* DEPRECATED */
	      this.setCookieConfig = function (config) {
	        cookieConfig = config;
	        return this;
	      };
	
	      this.useECommerce = function (val, enhanced) {
	        ecommerce = !!val;
	        enhancedEcommerce = !!enhanced;
	        return this;
	      };
	
	      this.setCurrency = function (currencyCode) {
	        currency = currencyCode;
	        return this;
	      };
	
	      this.setRemoveRegExp = function (regex) {
	        if (regex instanceof RegExp) {
	          removeRegExp = regex;
	        }
	        return this;
	      };
	
	      this.setExperimentId = function (id) {
	        experimentId = id;
	        return this;
	      };
	
	      this.ignoreFirstPageLoad = function (val) {
	        ignoreFirstPageLoad = !!val;
	        return this;
	      };
	
	      this.trackUrlParams = function (val) {
	        trackUrlParams = !!val;
	        return this;
	      };
	
	      this.disableAnalytics = function (val) {
	        disableAnalytics = !!val;
	        return this;
	      };
	
	      this.setHybridMobileSupport = function (val) {
	        hybridMobileSupport = !!val;
	        return this;
	      };
	
	      this.startOffline = function (val) {
	        offlineMode = !!val;
	        if (offlineMode === true) {
	          this.delayScriptTag(true);
	        }
	        return this;
	      };
	
	      this.delayScriptTag = function (val) {
	        delayScriptTag = !!val;
	        return this;
	      };
	
	      this.logAllCalls = function (val) {
	        logAllCalls = !!val;
	        return this;
	      };
	
	      this.enterTestMode = function () {
	        testMode = true;
	        return this;
	      };
	
	      this.enterDebugMode = function (enableTraceDebugging) {
	        debugMode = true;
	        traceDebuggingMode = !!enableTraceDebugging;
	        return this;
	      };
	      
	      // Enable reading page url from route object
	      this.readFromRoute = function(val) {
	        readFromRoute = !!val;
	        return this;
	      };
	
	      /**
	       * Public Service
	       */
	      this.$get = ['$document', // To read page title 
	                   '$location', //
	                   '$log',      //
	                   '$rootScope',//
	                   '$window',   //
	                   '$injector', // To access ngRoute module without declaring a fixed dependency
	                   function ($document, $location, $log, $rootScope, $window, $injector) {
	        var that = this;
	
	        /**
	         * Side-effect Free Helper Methods
	         **/
	
	        var isPropertyDefined = function (key, config) {
	          return angular.isObject(config) && angular.isDefined(config[key]);
	        };
	
	        var isPropertySetTo = function (key, config, value) {
	          return isPropertyDefined(key, config) && config[key] === value;
	        };
	
	        var generateCommandName = function (commandName, config) {
	          if (angular.isString(config)) {
	            return config + '.' + commandName;
	          }
	          return isPropertyDefined('name', config) ? (config.name + '.' + commandName) : commandName;
	        };
	        
	        // Try to read route configuration and log warning if not possible
	        var $route = {};
	        if (readFromRoute) {
	          if (!$injector.has('$route')) {
	            $log.warn('$route service is not available. Make sure you have included ng-route in your application dependencies.');
	          } else {
	            $route = $injector.get('$route');
	          }
	        }
	
	        // Get url for current page 
	        var getUrl = function () {
	          // Using ngRoute provided tracking urls
	          if (readFromRoute && $route.current && ('pageTrack' in $route.current)) {
	            return $route.current.pageTrack;
	          }
	           
	          // Otherwise go the old way
	          var url = trackUrlParams ? $location.url() : $location.path(); 
	          return removeRegExp ? url.replace(removeRegExp, '') : url;
	        };
	
	        var getUtmParams = function () {
	          var utmToCampaignVar = {
	            utm_source: 'campaignSource',
	            utm_medium: 'campaignMedium',
	            utm_term: 'campaignTerm',
	            utm_content: 'campaignContent',
	            utm_campaign: 'campaignName'
	          };
	          var object = {};
	
	          angular.forEach($location.search(), function (value, key) {
	            var campaignVar = utmToCampaignVar[key];
	
	            if (angular.isDefined(campaignVar)) {
	              object[campaignVar] = value;
	            }
	          });
	
	          return object;
	        };
	
	        /**
	         * get ActionFieldObject
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#action-data
	         * @param id
	         * @param affliation
	         * @param revenue
	         * @param tax
	         * @param shipping
	         * @param coupon
	         * @param list
	         * @param step
	         * @param option
	         */
	        var getActionFieldObject = function (id, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	          var obj = {};
	          if (id) { obj.id = id; }
	          if (affiliation) { obj.affiliation = affiliation; }
	          if (revenue) { obj.revenue = revenue; }
	          if (tax) { obj.tax = tax; }
	          if (shipping) { obj.shipping = shipping; }
	          if (coupon) { obj.coupon = coupon; }
	          if (list) { obj.list = list; }
	          if (step) { obj.step = step; }
	          if (option) { obj.option = option; }
	          return obj;
	        };
	
	        /**
	         * Private Methods
	         */
	
	        var _getProtocol = function (httpPostfix, httpsPostfix) {
	          var protocol = '',
	              isSslEnabled = document.location.protocol === 'https:',
	              isChromeExtension = document.location.protocol === 'chrome-extension:',
	              isHybridApplication = analyticsJS === true && hybridMobileSupport === true;
	          httpPostfix = angular.isString(httpPostfix) ? httpPostfix : '';
	          httpsPostfix = angular.isString(httpsPostfix) ? httpsPostfix : '';
	          if (httpPostfix !== '') {
	            protocol = 'http:' + httpPostfix;
	          }
	          if (isChromeExtension || isHybridApplication || (isSslEnabled && httpsPostfix !== '')) {
	            protocol = 'https:' + httpsPostfix;
	          }
	          return protocol;
	        };
	
	        var _gaJs = function (fn) {
	          if (!analyticsJS && $window._gaq && typeof fn === 'function') {
	            fn();
	          }
	        };
	
	        var _gaq = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (offlineMode === true) {
	            that.offlineQueue.push([_gaq, args]);
	            return;
	          }
	          if (!$window._gaq) {
	            $window._gaq = [];
	          }
	          if (logAllCalls === true) {
	            that._log.apply(that, args);
	          }
	          $window._gaq.push(args);
	        };
	
	        var _analyticsJs = function (fn) {
	          if (analyticsJS && $window.ga && typeof fn === 'function') {
	            fn();
	          }
	        };
	
	        var _ga = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (offlineMode === true) {
	            that.offlineQueue.push([_ga, args]);
	            return;
	          }
	          if (typeof $window.ga !== 'function') {
	            that._log('warn', 'ga function not set on window');
	            return;
	          }
	          if (logAllCalls === true) {
	            that._log.apply(that, args);
	          }
	          $window.ga.apply(null, args);
	        };
	
	        var _gaMultipleTrackers = function (includeFn) {
	          // Drop the includeFn from the arguments and preserve the original command name
	          var args = Array.prototype.slice.call(arguments, 1),
	              commandName = args[0],
	              trackers = [];
	          if (typeof includeFn === 'function') {
	            accounts.forEach(function (account) {
	              if (includeFn(account)) {
	                trackers.push(account);
	              }
	            });
	          } else {
	            // No include function indicates that all accounts are to be used
	            trackers = accounts;
	          }
	
	          // To preserve backwards compatibility fallback to _ga method if no account
	          // matches the specified includeFn. This preserves existing behaviors by
	          // performing the single tracker operation.
	          if (trackers.length === 0) {
	            _ga.apply(that, args);
	            return;
	          }
	
	          trackers.forEach(function (tracker) {
	            // Check tracker 'select' function, if it exists, for whether the tracker should be used with the current command.
	            // If the 'select' function returns false then the tracker will not be used with the current command.
	            if (isPropertyDefined('select', tracker) && typeof tracker.select === 'function' && !tracker.select(args)) {
	              return;
	            }
	            args[0] = generateCommandName(commandName, tracker);
	            _ga.apply(that, args);
	          });
	        };
	
	        this._log = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (args.length > 0) {
	            if (args.length > 1) {
	              switch (args[0]) {
	                case 'debug':
	                case 'error':
	                case 'info':
	                case 'log':
	                case 'warn':
	                  $log[args[0]](args.slice(1));
	                  break;
	              }
	            }
	            that.log.push(args);
	          }
	        };
	
	        /* DEPRECATED */
	        this._createScriptTag = function () {
	          that._registerScriptTags();
	          that._registerTrackers();
	        };
	
	        /* DEPRECATED */
	        this._createAnalyticsScriptTag = function () {
	          that._registerScriptTags();
	          that._registerTrackers();
	        };
	
	        this._registerScriptTags = function () {
	          var document = $document[0],
	              protocol = _getProtocol(),
	              scriptSource;
	
	          if (created === true) {
	            that._log('warn', 'Script tags already created');
	            return;
	          }
	
	          if (disableAnalytics === true) {
	            accounts.forEach(function (trackerObj) {
	              that._log('info', 'Analytics disabled: ' + trackerObj.tracker);
	              $window['ga-disable-' + trackerObj.tracker] = true;
	            });
	          }
	
	          //
	          // Universal Analytics
	          //
	          if (analyticsJS === true) {
	            scriptSource = protocol + '//www.google-analytics.com/' + (debugMode ? 'analytics_debug.js' : 'analytics.js');
	            if (testMode !== true) {
	              // If not in test mode inject the Google Analytics tag
	              (function (i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function (){
	                (i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),
	                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
	              })(window,document,'script',scriptSource,'ga');
	            } else {
	              if (typeof $window.ga !== 'function') {
	                // In test mode create a ga function if none exists that is a noop sink.
	                $window.ga = function () {};
	              }
	              // Log script injection.
	              that._log('inject', scriptSource);
	            }
	
	            if (traceDebuggingMode) {
	              $window.ga_debug = { trace: true };
	            }
	
	            if (experimentId) {
	              var expScript = document.createElement('script'),
	                  s = document.getElementsByTagName('script')[0];
	              expScript.src = protocol + '//www.google-analytics.com/cx/api.js?experiment=' + experimentId;
	              s.parentNode.insertBefore(expScript, s);
	            }
	          //
	          // Classic Analytics
	          //
	          } else {
	            scriptSource = _getProtocol('//www', '//ssl') + '.google-analytics.com/ga.js';
	            if (displayFeatures === true) {
	              scriptSource = protocol + '//stats.g.doubleclick.net/dc.js';
	            }
	
	            if (testMode !== true) {
	              // If not in test mode inject the Google Analytics tag
	              (function () {
	                var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
	                ga.src = scriptSource;
	                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
	              })();
	            } else {
	              // Log the source location for validation
	              that._log('inject', scriptSource);
	            }
	          }
	
	          created = true;
	          return true;
	        };
	
	        this._registerTrackers = function () {
	          if (!accounts || accounts.length < 1) {
	            that._log('warn', 'No accounts to register');
	            return;
	          }
	
	          //
	          // Universal Analytics
	          //
	          if (analyticsJS === true) {
	            accounts.forEach(function (trackerObj) {
	              trackerObj.crossDomainLinker = isPropertyDefined('crossDomainLinker', trackerObj) ? trackerObj.crossDomainLinker : crossDomainLinker;
	              trackerObj.crossLinkDomains = isPropertyDefined('crossLinkDomains', trackerObj) ? trackerObj.crossLinkDomains : crossLinkDomains;
	              trackerObj.displayFeatures = isPropertyDefined('displayFeatures', trackerObj) ? trackerObj.displayFeatures : displayFeatures;
	              trackerObj.enhancedLinkAttribution = isPropertyDefined('enhancedLinkAttribution', trackerObj) ? trackerObj.enhancedLinkAttribution : enhancedLinkAttribution;
	              trackerObj.set = isPropertyDefined('set', trackerObj) ? trackerObj.set : {};
	              trackerObj.trackEcommerce = isPropertyDefined('trackEcommerce', trackerObj) ? trackerObj.trackEcommerce : ecommerce;
	              trackerObj.trackEvent = isPropertyDefined('trackEvent', trackerObj) ? trackerObj.trackEvent : false;
	
	              // Logic to choose the account fields to be used.
	              // cookieConfig is being deprecated for a tracker specific property: fields.
	              var fields = {};
	              if (isPropertyDefined('fields', trackerObj)) {
	                fields = trackerObj.fields;
	              } else if (isPropertyDefined('cookieConfig', trackerObj)) {
	                if (angular.isString(trackerObj.cookieConfig)) {
	                  fields.cookieDomain = trackerObj.cookieConfig;
	                } else {
	                  fields = trackerObj.cookieConfig;
	                }
	              } else if (angular.isString(cookieConfig)) {
	                fields.cookieDomain = cookieConfig;
	              } else if (cookieConfig) {
	                fields = cookieConfig;
	              }
	              if (trackerObj.crossDomainLinker === true) {
	                fields.allowLinker = true;
	              }
	              if (isPropertyDefined('name', trackerObj)) {
	                fields.name = trackerObj.name;
	              }
	              trackerObj.fields = fields;
	
	              _ga('create', trackerObj.tracker, trackerObj.fields);
	
	              // Hybrid mobile application support
	              // https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
	              if (hybridMobileSupport === true) {
	                _ga(generateCommandName('set', trackerObj), 'checkProtocolTask', null);
	              }
	
	              // Send all custom set commands from the trackerObj.set property
	              for (var key in trackerObj.set) {
	                if (trackerObj.set.hasOwnProperty(key)) {
	                  _ga(generateCommandName('set', trackerObj), key, trackerObj.set[key]);
	                }
	              }
	
	              if (trackerObj.crossDomainLinker === true) {
	                _ga(generateCommandName('require', trackerObj), 'linker');
	                if (angular.isDefined(trackerObj.crossLinkDomains)) {
	                  _ga(generateCommandName('linker:autoLink', trackerObj), trackerObj.crossLinkDomains);
	                }
	              }
	
	              if (trackerObj.displayFeatures) {
	                _ga(generateCommandName('require', trackerObj), 'displayfeatures');
	              }
	
	              if (trackerObj.trackEcommerce) {
	                if (!enhancedEcommerce) {
	                  _ga(generateCommandName('require', trackerObj), 'ecommerce');
	                } else {
	                  _ga(generateCommandName('require', trackerObj), 'ec');
	                  _ga(generateCommandName('set', trackerObj), '&cu', currency);
	                }
	              }
	
	              if (trackerObj.enhancedLinkAttribution) {
	                _ga(generateCommandName('require', trackerObj), 'linkid');
	              }
	
	              if (trackRoutes && !ignoreFirstPageLoad) {
	                _ga(generateCommandName('send', trackerObj), 'pageview', trackPrefix + getUrl());
	              }
	            });
	          //
	          // Classic Analytics
	          //
	          } else {
	            if (accounts.length > 1) {
	              that._log('warn', 'Multiple trackers are not supported with ga.js. Using first tracker only');
	              accounts = accounts.slice(0, 1);
	            }
	
	            _gaq('_setAccount', accounts[0].tracker);
	            if(domainName) {
	              _gaq('_setDomainName', domainName);
	            }
	            if (enhancedLinkAttribution) {
	              _gaq('_require', 'inpage_linkid', '//www.google-analytics.com/plugins/ga/inpage_linkid.js');
	            }
	            if (trackRoutes && !ignoreFirstPageLoad) {
	              if (removeRegExp) {
	                _gaq('_trackPageview', getUrl());
	              } else {
	                _gaq('_trackPageview');
	              }
	            }
	          }
	
	          return true;
	        };
	
	        this._ecommerceEnabled = function (warn, command) {
	          var result = ecommerce && !enhancedEcommerce;
	          if (warn === true && result === false) {
	            if (ecommerce && enhancedEcommerce) {
	              that._log('warn', command + ' is not available when Enhanced Ecommerce is enabled with analytics.js');
	            } else {
	              that._log('warn', 'Ecommerce must be enabled to use ' + command + ' with analytics.js');
	            }
	          }
	          return result;
	        };
	
	        this._enhancedEcommerceEnabled = function (warn, command) {
	          var result = ecommerce && enhancedEcommerce;
	          if (warn === true && result === false) {
	            that._log('warn', 'Enhanced Ecommerce must be enabled to use ' + command + ' with analytics.js');
	          }
	          return result;
	        };
	
	        /**
	         * Track page
	         https://developers.google.com/analytics/devguides/collection/gajs/
	         https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
	         * @param url
	         * @param title
	         * @param custom
	         * @private
	         */
	        this._trackPage = function (url, title, custom) {
	          url = url ? url : getUrl();
	          title = title ? title : $document[0].title;
	          _gaJs(function () {
	            // http://stackoverflow.com/questions/7322288/how-can-i-set-a-page-title-with-google-analytics
	            _gaq('_set', 'title', title);
	            _gaq('_trackPageview', (trackPrefix + url));
	          });
	          _analyticsJs(function () {
	            var opt_fieldObject = {
	              'page': trackPrefix + url,
	              'title': title
	            };
	            angular.extend(opt_fieldObject, getUtmParams());
	            if (angular.isObject(custom)) {
	              angular.extend(opt_fieldObject, custom);
	            }
	            _gaMultipleTrackers(undefined, 'send', 'pageview', opt_fieldObject);
	          });
	        };
	
	        /**
	         * Track event
	         https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide
	         https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	         * @param category
	         * @param action
	         * @param label
	         * @param value
	         * @param noninteraction
	         * @param custom
	         * @private
	         */
	        this._trackEvent = function (category, action, label, value, noninteraction, custom) {
	          _gaJs(function () {
	            _gaq('_trackEvent', category, action, label, value, !!noninteraction);
	          });
	          _analyticsJs(function () {
	            var opt_fieldObject = {};
	            var includeFn = function (trackerObj) {
	              return isPropertySetTo('trackEvent', trackerObj, true);
	            };
	
	            if (angular.isDefined(noninteraction)) {
	              opt_fieldObject.nonInteraction = !!noninteraction;
	            }
	            if (angular.isObject(custom)) {
	              angular.extend(opt_fieldObject, custom);
	            }
	            if (!angular.isDefined(opt_fieldObject.page)) {
	              opt_fieldObject.page = getUrl();
	            }
	            _gaMultipleTrackers(includeFn, 'send', 'event', category, action, label, value, opt_fieldObject);
	          });
	        };
	
	        /**
	         * Add transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addTrans
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#addTrans
	         * @param transactionId
	         * @param affiliation
	         * @param total
	         * @param tax
	         * @param shipping
	         * @param city
	         * @param state
	         * @param country
	         * @private
	         */
	        this._addTrans = function (transactionId, affiliation, total, tax, shipping, city, state, country, currency) {
	          _gaJs(function () {
	            _gaq('_addTrans', transactionId, affiliation, total, tax, shipping, city, state, country);
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'addTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ecommerce:addTransaction',
	                {
	                  id: transactionId,
	                  affiliation: affiliation,
	                  revenue: total,
	                  tax: tax,
	                  shipping: shipping,
	                  currency: currency || 'USD'
	                });
	            }
	          });
	        };
	
	        /**
	         * Add item to transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addItem
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#addItem
	         * @param transactionId
	         * @param sku
	         * @param name
	         * @param category
	         * @param price
	         * @param quantity
	         * @private
	         */
	        this._addItem = function (transactionId, sku, name, category, price, quantity) {
	          _gaJs(function () {
	            _gaq('_addItem', transactionId, sku, name, category, price, quantity);
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'addItem')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ecommerce:addItem',
	                {
	                  id: transactionId,
	                  name: name,
	                  sku: sku,
	                  category: category,
	                  price: price,
	                  quantity: quantity
	                });
	            }
	          });
	        };
	
	        /**
	         * Track transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._trackTrans
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#sendingData
	         * @private
	         */
	        this._trackTrans = function () {
	          _gaJs(function () {
	            _gaq('_trackTrans');
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'trackTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ecommerce:send');
	            }
	          });
	        };
	
	        /**
	         * Clear transaction
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#clearingData
	         * @private
	         */
	        this._clearTrans = function () {
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'clearTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ecommerce:clear');
	            }
	          });
	        };
	
	        /**
	         * Enhanced Ecommerce
	         */
	
	        /**
	         * Add Product
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#product-data
	         * @param productId
	         * @param name
	         * @param category
	         * @param brand
	         * @param variant
	         * @param price
	         * @param quantity
	         * @param coupon
	         * @param position
	         * @param custom
	         * @private
	         */
	        this._addProduct = function (productId, name, category, brand, variant, price, quantity, coupon, position, custom) {
	          _gaJs(function () {
	            _gaq('_addProduct', productId, name, category, brand, variant, price, quantity, coupon, position);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addProduct')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	              var details = {
	                id: productId,
	                name: name,
	                category: category,
	                brand: brand,
	                variant: variant,
	                price: price,
	                quantity: quantity,
	                coupon: coupon,
	                position: position
	              };
	              if (angular.isObject(custom)) {
	                angular.extend(details, custom);
	              }
	              _gaMultipleTrackers(includeFn, 'ec:addProduct', details);
	            }
	          });
	        };
	
	        /**
	         * Add Impression
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#impression-data
	         * @param id
	         * @param name
	         * @param list
	         * @param brand
	         * @param category
	         * @param variant
	         * @param position
	         * @param price
	         * @private
	         */
	        this._addImpression = function (id, name, list, brand, category, variant, position, price){
	          _gaJs(function () {
	            _gaq('_addImpression', id, name, list, brand, category, variant, position, price);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addImpression')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ec:addImpression',
	                {
	                  id: id,
	                  name: name,
	                  category: category,
	                  brand: brand,
	                  variant: variant,
	                  list: list,
	                  position: position,
	                  price: price
	                });
	            }
	          });
	        };
	
	        /**
	         * Add Promo
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce
	         * @param productId
	         * @param name
	         * @param creative
	         * @param position
	         * @private
	         */
	        this._addPromo = function (productId, name, creative, position) {
	          _gaJs(function () {
	            _gaq('_addPromo', productId, name, creative, position);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addPromo')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ec:addPromo',
	                {
	                  id: productId,
	                  name: name,
	                  creative: creative,
	                  position: position
	                });
	            }
	          });
	        };
	
	        /**
	         * Set Action
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-actions
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#action-types
	         * @param action
	         * @param obj
	         * @private
	         */
	        this._setAction = function (action, obj){
	          _gaJs(function () {
	            _gaq('_setAction', action, obj);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'setAction')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ec:setAction', action, obj);
	            }
	          });
	        };
	
	        /**
	         * Track Transaction
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-transactions
	         * @param transactionId
	         * @param affiliation
	         * @param revenue
	         * @param tax
	         * @param shipping
	         * @param coupon
	         * @param list
	         * @param step
	         * @param option
	         * @private
	         */
	        this._trackTransaction = function (transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	          this._setAction('purchase', getActionFieldObject(transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option));
	        };
	
	        /**
	         * Track Refund
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-refunds
	         * @param transactionId
	         * @private
	         */
	        this._trackRefund = function (transactionId) {
	          this._setAction('refund', getActionFieldObject(transactionId));
	        };
	
	        /**
	         * Track Checkout
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-checkout
	         * @param step
	         * @param option
	         * @private
	         */
	        this._trackCheckOut = function (step, option) {
	          this._setAction('checkout', getActionFieldObject(null, null, null, null, null, null, null, step, option));
	        };
	
	        /**
	         * Track detail
	         * @private
	         */
	        this._trackDetail = function () {
	          this._setAction('detail');
	          this._pageView();
	        };
	
	        /**
	         * Track add/remove to cart
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#add-remove-cart
	         * @param action
	         * @param list
	         * @private
	         */
	        this._trackCart = function (action, listName) {
	          if (['add', 'remove'].indexOf(action) !== -1) {
	            this._setAction(action, { list: listName });
	            this._trackEvent('UX', 'click', action + (action === 'add' ? ' to cart' : ' from cart'));
	          }
	        };
	
	        /**
	         * Track promo click
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-promo-clicks
	         * @param promotionName
	         * @private
	         */
	        this._promoClick = function (promotionName) {
	          this._setAction('promo_click');
	          this._trackEvent('Internal Promotions', 'click', promotionName);
	        };
	
	        /**
	         * Track product click
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-promo-clicks
	         * @param promotionName
	         * @private
	         */
	        this._productClick = function (listName) {
	          this._setAction('click', getActionFieldObject(null, null, null, null, null, null, listName, null, null));
	          this._trackEvent('UX', 'click', listName);
	        };
	
	        /**
	         * Send page view
	         * @param trackerName
	         * @private
	         */
	        this._pageView = function (trackerName) {
	          _analyticsJs(function () {
	            _ga(generateCommandName('send', trackerName), 'pageview');
	          });
	        };
	
	        /**
	         * Send custom events
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings#implementation
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/social-interactions#implementation
	         * @private
	         */
	        this._send = function () {
	          var args = Array.prototype.slice.call(arguments);
	          args.unshift('send');
	          _analyticsJs(function () {
	            _ga.apply(that, args);
	          });
	        };
	
	        /**
	         * Set custom dimensions, metrics or experiment
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/custom-dims-mets
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#customs
	         * @param name (Required)
	         * @param value (Required)
	         * @param trackerName (Optional)
	         * @private
	         */
	        this._set = function (name, value, trackerName) {
	          _analyticsJs(function () {
	            _ga(generateCommandName('set', trackerName), name, value);
	          });
	        };
	
	        /**
	         * Track user timings
	         * @param timingCategory (Required): A string for categorizing all user timing variables into logical groups(e.g jQuery).
	         * @param timingVar (Required): A string to identify the variable being recorded(e.g. JavaScript Load).
	         * @param timingValue (Required): The number of milliseconds in elapsed time to report to Google Analytics(e.g. 20).
	         * @param timingLabel (Optional): A string that can be used to add flexibility in visualizing user timings in the reports(e.g. Google CDN).
	         * @private
	         */
	        this._trackTimings = function (timingCategory, timingVar, timingValue, timingLabel) {
	          _analyticsJs(function () {
	            _gaMultipleTrackers(undefined, 'send', 'timing', timingCategory, timingVar, timingValue, timingLabel);
	          });
	        };
	
	        /**
	         * Exception tracking
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
	         * @param description (Optional): A description of the exception.
	         * @param isFatal (Optional): true if the exception was fatal, false otherwise.
	         * @private
	         */
	        this._trackException = function (description, isFatal) {
	          _analyticsJs(function () {
	            _gaMultipleTrackers(undefined, 'send', 'exception', { exDescription: description, exFatal: !!isFatal});
	          });
	        };
	
	        // creates the Google Analytics tracker
	        if (!delayScriptTag) {
	          this._registerScriptTags();
	          this._registerTrackers();
	        }
	
	        // activates page tracking
	        if (trackRoutes) {
	          $rootScope.$on(pageEvent, function () {
	            // Apply $route based filtering if configured
	            if (readFromRoute) {
	              // Avoid tracking undefined routes, routes without template (e.g. redirect routes)
	              // and those explicitly marked as 'do not track'
	              if (!$route.current || !$route.current.templateUrl || $route.current.doNotTrack) {
	                return;
	              }
	            }
	            
	            that._trackPage();
	          });
	        }
	
	        return {
	          log: that.log,
	          offlineQueue: that.offlineQueue,
	          configuration: {
	            accounts: accounts,
	            universalAnalytics: analyticsJS,
	            crossDomainLinker: crossDomainLinker,
	            crossLinkDomains: crossLinkDomains,
	            currency: currency,
	            debugMode: debugMode,
	            delayScriptTag: delayScriptTag,
	            disableAnalytics: disableAnalytics,
	            displayFeatures: displayFeatures,
	            domainName: domainName,
	            ecommerce: that._ecommerceEnabled(),
	            enhancedEcommerce: that._enhancedEcommerceEnabled(),
	            enhancedLinkAttribution: enhancedLinkAttribution,
	            experimentId: experimentId,
	            hybridMobileSupport: hybridMobileSupport,
	            ignoreFirstPageLoad: ignoreFirstPageLoad,
	            logAllCalls: logAllCalls,
	            pageEvent: pageEvent,
	            readFromRoute: readFromRoute,
	            removeRegExp: removeRegExp,
	            testMode: testMode,
	            traceDebuggingMode: traceDebuggingMode,
	            trackPrefix: trackPrefix,
	            trackRoutes: trackRoutes,
	            trackUrlParams: trackUrlParams
	          },
	          getUrl: getUrl,
	          /* DEPRECATED */
	          setCookieConfig: function (config) {
	            that._log('warn', 'DEPRECATION WARNING: setCookieConfig method is deprecated. Please use tracker fields instead.');
	            return that._setCookieConfig.apply(that, arguments);
	          },
	          /* DEPRECATED */
	          getCookieConfig: function () {
	            that._log('warn', 'DEPRECATION WARNING: getCookieConfig method is deprecated. Please use tracker fields instead.');
	            return cookieConfig;
	          },
	          /* DEPRECATED */
	          createAnalyticsScriptTag: function (config) {
	            that._log('warn', 'DEPRECATION WARNING: createAnalyticsScriptTag method is deprecated. Please use registerScriptTags and registerTrackers methods instead.');
	            if (config) {
	              cookieConfig = config;
	            }
	            return that._createAnalyticsScriptTag();
	          },
	          /* DEPRECATED */
	          createScriptTag: function () {
	            that._log('warn', 'DEPRECATION WARNING: createScriptTag method is deprecated. Please use registerScriptTags and registerTrackers methods instead.');
	            return that._createScriptTag();
	          },
	          registerScriptTags: function () {
	            return that._registerScriptTags();
	          },
	          registerTrackers: function () {
	            return that._registerTrackers();
	          },
	          offline: function (mode) {
	            if (mode === true && offlineMode === false) {
	              // Go to offline mode
	              offlineMode = true;
	            }
	            if (mode === false && offlineMode === true) {
	              // Go to online mode and process the offline queue
	              offlineMode = false;
	              while (that.offlineQueue.length > 0) {
	                var obj = that.offlineQueue.shift();
	                obj[0].apply(that, obj[1]);
	              }
	            }
	            return offlineMode;
	          },
	          trackPage: function (url, title, custom) {
	            that._trackPage.apply(that, arguments);
	          },
	          trackEvent: function (category, action, label, value, noninteraction, custom) {
	            that._trackEvent.apply(that, arguments);
	          },
	          addTrans: function (transactionId, affiliation, total, tax, shipping, city, state, country, currency) {
	            that._addTrans.apply(that, arguments);
	          },
	          addItem: function (transactionId, sku, name, category, price, quantity) {
	            that._addItem.apply(that, arguments);
	          },
	          trackTrans: function () {
	            that._trackTrans.apply(that, arguments);
	          },
	          clearTrans: function () {
	            that._clearTrans.apply(that, arguments);
	          },
	          addProduct: function (productId, name, category, brand, variant, price, quantity, coupon, position, custom) {
	            that._addProduct.apply(that, arguments);
	          },
	          addPromo: function (productId, name, creative, position) {
	            that._addPromo.apply(that, arguments);
	          },
	          addImpression: function (productId, name, list, brand, category, variant, position, price) {
	            that._addImpression.apply(that, arguments);
	          },
	          productClick: function (listName) {
	            that._productClick.apply(that, arguments);
	          },
	          promoClick : function (promotionName) {
	            that._promoClick.apply(that, arguments);
	          },
	          trackDetail: function () {
	            that._trackDetail.apply(that, arguments);
	          },
	          trackCart: function (action, list) {
	            that._trackCart.apply(that, arguments);
	          },
	          trackCheckout: function (step, option) {
	            that._trackCheckOut.apply(that, arguments);
	          },
	          trackTimings: function (timingCategory, timingVar, timingValue, timingLabel) {
	            that._trackTimings.apply(that, arguments);
	          },
	          trackTransaction: function (transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	            that._trackTransaction.apply(that, arguments);
	          },
	          trackException: function (description, isFatal) {
	            that._trackException.apply(that, arguments);
	          },
	          setAction: function (action, obj) {
	            that._setAction.apply(that, arguments);
	          },
	          pageView: function () {
	            that._pageView.apply(that, arguments);
	          },
	          send: function (obj) {
	            that._send.apply(that, arguments);
	          },
	          set: function (name, value, trackerName) {
	            that._set.apply(that, arguments);
	          }
	        };
	      }];
	    })
	
	    .directive('gaTrackEvent', ['Analytics', '$parse', function (Analytics, $parse) {
	      return {
	        restrict: 'A',
	        link: function (scope, element, attrs) {
	          var options = $parse(attrs.gaTrackEvent);
	          element.bind('click', function () {
	            if(attrs.gaTrackEventIf){
	              if(!scope.$eval(attrs.gaTrackEventIf)){
	                return; // Cancel this event if we don't pass the ga-track-event-if condition
	              }
	            }
	            if (options.length > 1) {
	              Analytics.trackEvent.apply(Analytics, options(scope));
	            }
	          });
	        }
	      };
	    }]);
	  return angular.module('angular-google-analytics');
	}));


/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var forEach;
	var isArray;
	var isString;
	var jqLite;
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * ## Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritize messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, AngularJS may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isString = angular.isString;
	  jqLite = angular.element;
	})
	  .info({ angularVersion: '1.6.9' })
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an AngularJS expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function NgMessagesCtrl($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          if (unmatchedMessages.length !== totalMessages) {
	            $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS);
	          } else {
	            $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	          }
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater && cachedCollection) {
	                ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          // This message node may have already been removed by a call to deregister()
	          if (!messageNode) return;
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   * @priority 1
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is the same as {@link directive:ngMessage `ngMessage`}, but instead of a static
	   * value, it accepts an expression to be evaluated for the message key.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  // If the message element was removed via a call to `detach` then `currentElement` will be null
	                  // So this handler only handles cases where something else removed the message element.
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	
	        // We need to ensure that this directive deregisters itself when it no longer exists
	        // Normally this is done when the attached element is destroyed; but if this directive
	        // gets removed before we attach the message to the DOM there is nothing to watch
	        // in which case we must deregister when the containing scope is destroyed.
	        scope.$on('$destroy', function() {
	          ngMessagesCtrl.deregister(commentNode);
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(80);
	module.exports = 'ngMessages';


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.18.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text());
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function initWindowEvents() {
	  window.onfocus = checkLocalStorageForActiveOAuth;
	  window.onload = checkLocalStorageForActiveOAuth;
	  window.onblur = setSessionOAuthToLocalStorage;
	}
	
	// remove local storage item that may be leftover from previous session
	window.localStorage.removeItem('SIGN_OUT_ALL_USERS');
	
	function checkLocalStorageForActiveOAuth() {
	  var SIGN_OUT_ALL_USERS = window.localStorage.getItem('SIGN_OUT_ALL_USERS');
	  if (SIGN_OUT_ALL_USERS) {
	    localStorage.clear();
	    sessionStorage.clear();
	    window.localStorage.setItem('SIGN_OUT_ALL_USERS', true);
	    return;
	  }
	
	  var oauth = window.sessionStorage.getItem('oauth');
	  if (!oauth) {
	    var localStoreAuth = window.localStorage.getItem('oauth', oauth);
	    if (localStoreAuth) window.sessionStorage.setItem('oauth', localStoreAuth);
	  }
	}
	
	function setSessionOAuthToLocalStorage() {
	  var oauth = window.sessionStorage.getItem('oauth');
	  if (oauth) {
	    window.localStorage.setItem('oauth', oauth);
	  }
	}
	
	initWindowEvents();
	
	__webpack_require__(76);
	__webpack_require__(608);
	__webpack_require__(81);
	__webpack_require__(77);
	__webpack_require__(84);
	__webpack_require__(589);
	__webpack_require__(586);
	__webpack_require__(607);
	__webpack_require__(587);
	__webpack_require__(584);
	__webpack_require__(606);
	__webpack_require__(588);
	__webpack_require__(595);
	__webpack_require__(513);
	
	__webpack_require__(917);
	
	var app = angular.module('app', ['ngCookies', 'duScroll', 'ngMessages', 'ui.router', 'angular-google-analytics', 'angularMoment', 'ui.select', 'vesparny.fancyModal', __webpack_require__(363).name, __webpack_require__(275).name, __webpack_require__(322).name, __webpack_require__(392).name, __webpack_require__(259).name, __webpack_require__(264).name, __webpack_require__(263).name, __webpack_require__(351).name, __webpack_require__(288).name, __webpack_require__(346).name, __webpack_require__(279).name, __webpack_require__(395).name, __webpack_require__(287).name, __webpack_require__(404).name, __webpack_require__(205).name, __webpack_require__(262).name, __webpack_require__(375).name, __webpack_require__(396).name, __webpack_require__(216).name, __webpack_require__(87).name, 'pascalprecht.translate', 'ngSanitize', 'app.lbTooltip', 'ngIdle', 'ngPatternRestrict']);
	
	app.directive('lbSequentialTime', __webpack_require__(512));
	app.directive('lbFutureTime', __webpack_require__(511));
	app.directive('focusOn', __webpack_require__(508));
	app.directive('inputMatch', __webpack_require__(509));
	app.directive('clickOutside', __webpack_require__(510));
	
	app.config(['$compileProvider', '$locationProvider', function ($compileProvider, $locationProvider) {
	  $compileProvider.preAssignBindingsEnabled(true);
	  $locationProvider.hashPrefix('');
	}]);
	
	app.config(['uiSelectConfig', function (uiSelectConfig) {
	  uiSelectConfig.theme = 'selectize';
	}]);
	
	app.config(['$translateProvider', function ($translateProvider) {
	  var Lang = window.sessionStorage.getItem('i18nCode') || 'en-AU';
	  $translateProvider.useSanitizeValueStrategy('sanitize').translations('en-AU', __webpack_require__(936)).translations('en-US', __webpack_require__(938)).translations('en-GB', __webpack_require__(937)).fallbackLanguage(['en-AU', 'en-US', 'en-GB']).preferredLanguage(Lang);
	}]);
	
	app.config(['$compileProvider', function ($compileProvider) {
	  $compileProvider.debugInfoEnabled(false);
	}]);
	
	app.config(['IdleProvider', function (IdleProvider) {
	  IdleProvider.autoResume('notIdle');
	  IdleProvider.idle(60 * 20);
	  IdleProvider.timeout(30);
	}]);
	
	app.constant('APP_CONFIG', __webpack_require__(503));
	app.constant('AUTH_EVENTS', __webpack_require__(506));
	app.constant('ENUMS', __webpack_require__(507));
	
	app.filter('sectorGroupsFilter', __webpack_require__(542));
	app.filter('creditCardNumberFilter', __webpack_require__(521));
	app.filter('startCaseFilter', __webpack_require__(543).startCaseFilter);
	app.filter('paddingFilter', __webpack_require__(538));
	app.filter('noValueFilter', __webpack_require__(537));
	app.filter('cssClassNameFilter', __webpack_require__(59));
	app.filter('genericSortingFilter', __webpack_require__(529));
	app.filter('locationIconFilter', __webpack_require__(535));
	app.filter('distanceFilter', __webpack_require__(523));
	app.filter('secondsToTimeFilter', __webpack_require__(541));
	app.filter('cssClassNameFilter', __webpack_require__(59));
	app.filter('toAddressFilter', __webpack_require__(544));
	app.filter('keyToLabelFilter', __webpack_require__(533));
	app.filter('ancillaryServicesAmountsFilter', __webpack_require__(518));
	app.filter('hotelProviderBrandFilter', __webpack_require__(531));
	app.filter('deepCopyFilter', __webpack_require__(522));
	app.filter('checkinInfoFilter', __webpack_require__(520));
	app.filter('priceWithOperatorFilter', __webpack_require__(540));
	
	app.config(__webpack_require__(545)(app));
	app.config(__webpack_require__(546)(app));
	
	app.config(__webpack_require__(505)(app));
	app.config(__webpack_require__(504)(app));
	
	app.factory('requestInterceptor', __webpack_require__(517));
	app.factory('$exceptionHandler', __webpack_require__(516));
	
	app.service('apiService', __webpack_require__(547));
	app.service('appInsightsService', __webpack_require__(548));
	app.service('authService', __webpack_require__(549));
	app.service('currentUserService', __webpack_require__(20));
	app.service('itinerariesService', __webpack_require__(61));
	app.service('travellersService', __webpack_require__(63));
	app.service('settingsService', __webpack_require__(574));
	app.service('userInfoService', __webpack_require__(582));
	app.service('travelService', __webpack_require__(579));
	app.service('travelFiltersService', __webpack_require__(578));
	app.service('flailService', __webpack_require__(560));
	app.service('changeCartService', __webpack_require__(555));
	app.service('cartService', __webpack_require__(553));
	app.service('carSearchService', __webpack_require__(552));
	app.service('sectorService', __webpack_require__(573));
	app.service('searchFormService', __webpack_require__(571));
	app.service('iataSearchService', __webpack_require__(564));
	app.service('departmentService', __webpack_require__(557));
	app.service('locationsSearchService', __webpack_require__(567));
	app.service('depotSearchService', __webpack_require__(558));
	app.service('citySearchService', __webpack_require__(556));
	app.service('locationService', __webpack_require__(566));
	app.service('toggleService', __webpack_require__(577));
	app.service('stateResolveService', __webpack_require__(575));
	app.service('seatMapService', __webpack_require__(62));
	app.service('seatNumberService', __webpack_require__(572));
	app.service('cdnService', __webpack_require__(554));
	app.service('unusedTicketsService', __webpack_require__(580));
	app.service('breakPolicyService', __webpack_require__(550));
	app.service('timesService', __webpack_require__(576));
	app.service('userProfileService', __webpack_require__(583));
	app.service('userDebtorService', __webpack_require__(581));
	app.service('guestTravellerService', __webpack_require__(561));
	app.service('paymentMethodsService', __webpack_require__(569));
	app.service('duplicateBookingsService', __webpack_require__(559));
	app.service('searchResultsLoaderService', __webpack_require__(374));
	app.service('ndcExpiredService', __webpack_require__(568));
	app.service('lbHotelSearchService', __webpack_require__(565));
	
	app.run(['Analytics', function (Analytics) {
	  // This gets analytics started, must have reference to Analytics
	  window.svelteStore.trackingInit(); //mixpanel init
	}]);
	
	app.run(['$rootScope', '$location', function ($rootScope, $location) {
	  $rootScope.enableDebug = $location.search().enabledebug;
	}]);
	
	app.run(['$rootScope', function ($rootScope) {
	  $rootScope.$on('openDatePicker', function (event, settings) {
	    $rootScope.datePickerSettings = settings;
	    $rootScope.showDatePicker = true;
	  });
	
	  $rootScope.$on('closeDatePicker', function () {
	    $rootScope.datePickerSettings = undefined;
	    $rootScope.showDatePicker = false;
	  });
	}]);
	
	app.run(['$rootScope', '$injector', function ($rootScope, $injector) {
	  $rootScope.$on('$stateChangeSuccess', function () {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	
	  // SEE /vendor/angular.src.js line 4843
	  app.register = $injector.loadModule.bind($injector);
	}]);
	
	app.run(['$rootScope', '$window', '$timeout', 'lbModalService', 'authService', 'AUTH_EVENTS', function ($rootScope, $window, $timeout, lbModalService, authService, AUTH_EVENTS) {
	  $rootScope.$on('IdleStart', function () {
	    $timeout(function () {
	      lbModalService.open('<lb-timeout-modal></lb-timeout-modal>');
	    });
	  });
	
	  $rootScope.$on('IdleTimeout', function () {
	    window.svelteStore.track(window.svelteStore.trackingEvents.TIMED_OUT);
	
	    authService.logout().then(function () {
	      lbModalService.resolve();
	      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
	    });
	  });
	}]);
	
	app.run(['$rootScope', '$state', '$q', '$urlRouter', '$fancyModal', '$injector', '$cookies', 'authService', 'currentUserService', 'itinerariesService', 'locationService', 'settingsService', 'userInfoService', function ($rootScope, $state, $q, $urlRouter, $fancyModal, $injector, $cookies, authService, currentUserService, itinerariesService, locationService, settingsService, userInfoService) {
	  return $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
	    $fancyModal.close();
	    $rootScope.showLoader = !!toState.resolve;
	    toState.resolve = toState.resolve || {};
	    userInfoService.userInfoRequired = toParams.userInfoRequired;
	    settingsService.settingsRequired = toParams.settingsRequired;
	    settingsService.allowNoSettingsForConsultant = toParams.allowNoSettingsForConsultant;
	
	    function loadSettings() {
	      if (toParams.isPublic || settingsService.settingsLoading || settingsService.settings) return;
	
	      if (toParams.settingsRequired && (currentUserService.get('debtor') || !(toParams.allowNoSettingsForConsultant && currentUserService.isConsultant()))) {
	        settingsService.getAny().then(function () {
	          $rootScope.$broadcast('loadSettingsComplete');
	        });
	      } else {
	        $rootScope.$broadcast('loadSettingsComplete');
	      }
	    }
	
	    if ($cookies.get('LIGHTNINGBOOK_API_ACCESSTOKEN')) localStorage.removeItem('SIGN_OUT_ALL_USERS');
	
	    if (!authService.isAuthenticated()) {
	      app.previousSate = {
	        toState: toState,
	        toParams: toParams
	      };
	
	      if (!toParams.isPublic) {
	        $rootScope.showLoader = false;
	        event.preventDefault();
	        $state.go('landing.login');
	        return;
	      }
	    }
	
	    if (toState.redirectTo) {
	      event.preventDefault();
	      $state.go(toState.redirectTo, toParams);
	      return;
	    }
	
	    if (toParams.userInfoRequired) {
	      if (!currentUserService.get('userInfo')) {
	        userInfoService.getInfo().then(function () {
	          $rootScope.$broadcast('loadUserInfoComplete');
	          loadSettings();
	        });
	      } else {
	        $rootScope.$broadcast('loadUserInfoComplete');
	        loadSettings();
	      }
	    } else {
	      $rootScope.$broadcast('loadUserInfoComplete');
	      loadSettings();
	    }
	
	    if (toParams.searchRequired) {
	      toState.resolve.itinerary = ['$q', function ($q) {
	        var defer = $q.defer();
	
	        if (!itinerariesService.itinerary) {
	          itinerariesService.get().then(function () {
	            changeState();
	          }, function () {
	            $rootScope.showLoader = false;
	            defer.reject();
	          });
	        } else {
	          changeState();
	        }
	
	        function changeState() {
	          var hasSearch = false;
	
	          switch (toState.name) {
	            case 'app.booking.flights':
	              hasSearch = !!itinerariesService.itinerary.Search.Flights[locationService.searchIndex.Flight];
	              break;
	
	            case 'app.booking.rail':
	              hasSearch = !!itinerariesService.itinerary.Search.Rails[locationService.searchIndex.Rail];
	              break;
	
	            case 'app.booking.hotels':
	              hasSearch = !!itinerariesService.itinerary.Search.Hotels[locationService.searchIndex.Hotel];
	              break;
	
	            case 'app.booking.cars':
	              hasSearch = !!itinerariesService.itinerary.Search.Cars[locationService.searchIndex.Car];
	              break;
	
	            default:
	              hasSearch = true;
	              break;
	          }
	
	          if (hasSearch) {
	            defer.resolve();
	          } else {
	            $rootScope.showLoader = false;
	            defer.reject();
	          }
	        }
	
	        return defer.promise;
	      }];
	    }
	  });
	}]);
	
	app.run(['$rootScope', '$state', '$window', 'Analytics', 'Idle', 'authService', 'appInsightsService', 'APP_CONFIG', function ($rootScope, $state, $window, Analytics, Idle, authService, appInsightsService, APP_CONFIG) {
	  return $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
	    var pagePath = ($state.href(toState.name, toParams) || '').substr(1);
	    var pageTitle = APP_CONFIG.APP_NAME + (toState.params && toState.params.pageTitle ? ' - ' + toState.params.pageTitle : '');
	
	    $rootScope.showLoader = false;
	
	    $rootScope.bodyClass = toParams.bodyClass || 'bg';
	    $rootScope.pageTitle = pageTitle;
	
	    if (APP_CONFIG.analytics.enabled) {
	      Analytics.set('page', pagePath);
	      Analytics.trackPage(pagePath, $rootScope.pageTitle);
	    }
	
	    if (APP_CONFIG.appInsights.enabled) {
	      appInsightsService.trackPageView(pagePath);
	    }
	
	    window.svelteStore.track('PAGE_VIEW', {
	      path: pagePath,
	      title: toState && toState.params && toState.params.pageTitle || ''
	    });
	
	    if (authService.isAuthenticated()) {
	      if (!Idle.running()) {
	        Idle.watch();
	      }
	    } else {
	      Idle.unwatch();
	    }
	  });
	}]);
	
	app.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
	
	    localStorage.removeItem('SIGN_OUT_ALL_USERS');
	
	    if (app.previousSate && !app.previousSate.toParams.isPublic) {
	      $state.go(app.previousSate.toState, app.previousSate.toParams);
	    } else {
	      $state.go('app.home.search');
	    }
	  });
	}]);
	
	app.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
	    $state.go('landing.login', {}, { reload: true });
	  });
	}]);
	
	app.run(['$rootScope', '$state', 'lbModalService', function ($rootScope, $state, lbModalService) {
	  return $rootScope.$on('httpError', function (event, data, onClose) {
	    onClose = onClose || _.noop;
	    lbModalService.open('<lb-error-modal></lb-error-modal>', {}, data).then(onClose);
	  });
	}]);
	
	app.run(['$rootScope', '$state', function ($rootScope, $state) {
	  $rootScope.$on('$stateChangeError', function () {
	    if ($state.is('authenticate')) {
	      $state.go('landing.login');
	    } else {
	      $state.go('app.home.search');
	    }
	
	    $rootScope.showLoader = false;
	  });
	
	  $rootScope.$on('404Error', function () {
	    $rootScope.showLoader = false;
	    $state.transitionTo('app.error');
	  });
	}]);
	
	exports['default'] = app;
	module.exports = exports['default'];

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lb = angular.module('app.lb', []);
	lb.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
	    var IsFromAuth0 = JSON.parse(sessionStorage.getItem('IsFromAuth0'));
	    var loginPageSignIn = JSON.parse(sessionStorage.getItem('loginPageSignIn'));
	    var NeedsFederatedLogout = JSON.parse(sessionStorage.getItem('NeedsFederatedLogout'));
	
	    sessionStorage.removeItem('IsFromAuth0');
	    sessionStorage.removeItem('loginPageSignIn');
	    sessionStorage.removeItem('NeedsFederatedLogout');
	
	    if (loginPageSignIn) return $state.go('landing.login');
	
	    if (IsFromAuth0) {
	      var returnTo = encodeURIComponent(window.location.origin + '/#/logged-out');
	      var logoutUri = '?returnTo=' + returnTo + '&client_id=' + window.Auth0ClientId + (NeedsFederatedLogout ? '&federated' : '');
	      window.location.href = 'https://' + window.Auth0Domain + '/v2/logout' + logoutUri;
	    } else {
	      if ($state.current.name !== 'landing.login') $state.go('loggedout');
	    }
	  });
	}]);
	
	exports['default'] = lb;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbCarHandlingModal = angular.module('app.lbCarHandlingModal', []);
	
	lbCarHandlingModal.controller('lbCarHandlingModalCtrl', __webpack_require__(207));
	lbCarHandlingModal.component('lbCarHandlingModal', __webpack_require__(206));
	
	exports['default'] = lbCarHandlingModal;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(798);
	
	var $inject = [];
	
	var lbCarHandlingModal = {
	  controller: 'lbCarHandlingModalCtrl as vm',
	  template: __webpack_require__(1015)
	};
	
	lbCarHandlingModal.$inject = $inject;
	
	exports['default'] = lbCarHandlingModal;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'lbModalService'];
	
	var lbCarHandlingModalCtrl = function lbCarHandlingModalCtrl($scope, lbModalService) {
	  var vm = this;
	
	  var params = lbModalService.params();
	  var deliveryActive = !!params.delivery || params.request === 'delivery';
	  var collectionActive = !!params.collection || params.request === 'collection';
	  var usStates = __webpack_require__(208);
	
	  vm.usStates = _.map(_.keysIn(usStates), function (stateCode) {
	    return {
	      code: stateCode,
	      name: usStates[stateCode]
	    };
	  });
	
	  vm.collection = {
	    location: params.collection,
	    isValid: !!params.collection,
	    isEnabled: !!params.collectionEnabled,
	    isActive: collectionActive,
	    isEditing: collectionActive,
	    displaySummary: false
	  };
	
	  vm.delivery = {
	    location: params.delivery,
	    isValid: !!params.location,
	    isEnabled: !!params.deliveryEnabled,
	    isActive: deliveryActive,
	    isEditing: deliveryActive,
	    displaySummary: false
	  };
	
	  vm.edit = edit;
	  vm.request = request;
	  vm.cancel = lbModalService.reject;
	  vm.submit = submit;
	
	  if (vm.collection.location && vm.delivery.location && _.isEqual(vm.collection.location, vm.delivery.location)) {
	    if (params.request === 'delivery') {
	      vm.collection.location = vm.delivery.location;
	      vm.collection.isEditing = false;
	    }
	
	    if (params.request === 'collection') {
	      vm.delivery.location = vm.collection.location;
	      vm.delivery.isEditing = false;
	    }
	  }
	
	  function edit(location) {
	    if (location === 'collection') {
	      vm.collection.location = undefined;
	      vm.collection.isEditing = true;
	    }
	
	    if (location === 'delivery') {
	      vm.delivery.location = undefined;
	      vm.delivery.isEditing = true;
	    }
	  }
	
	  function request(location, value) {
	    if (location === 'collection') {
	      if (value) {
	        vm.collection.location = vm.delivery.location;
	        vm.collection.isEditing = !vm.delivery.isActive;
	      } else {
	        vm.collection.location = undefined;
	        vm.collection.isEditing = false;
	        vm.delivery.isEditing = !vm.collection.isActive;
	      }
	    }
	
	    if (location === 'delivery') {
	      if (value) {
	        vm.delivery.location = vm.collection.location;
	        vm.delivery.isEditing = !vm.collection.isActive;
	      } else {
	        vm.delivery.location = undefined;
	        vm.delivery.isEditing = false;
	        vm.collection.isEditing = !vm.delivery.isActive;
	      }
	    }
	  }
	
	  function submit() {
	    var delivery = _.clone(vm.delivery.location);
	    var collection = _.clone(vm.collection.location);
	
	    lbModalService.resolve({ delivery: delivery, collection: collection });
	  }
	};
	
	lbCarHandlingModalCtrl.$inject = $inject;
	
	exports['default'] = lbCarHandlingModalCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AS: 'American Samoa',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  DC: 'District Of Columbia',
	  FM: 'Federated States Of Micronesia',
	  FL: 'Florida',
	  GA: 'Georgia',
	  GU: 'Guam',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MH: 'Marshall Islands',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  MP: 'Northern Mariana Islands',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PW: 'Palau',
	  PA: 'Pennsylvania',
	  PR: 'Puerto Rico',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VI: 'Virgin Islands',
	  VA: 'Virginia',
	  WA: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(803);
	
	var lbCardIcon = angular.module('app.lbCardIcon', []);
	
	lbCardIcon.component('lbCardIcon', {
	  bindings: {
	    cardType: '<'
	  },
	  controllerAs: 'vm',
	  controller: [controller],
	  template: '<i class="lbCardIcon_{{ vm.cardType }}"></i>'
	});
	
	function controller() {
	  var vm = this;
	}
	
	exports['default'] = lbCardIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = [{ Name: 'Afghanistan', Code: 'AF' }, { Name: 'Åland Islands', Code: 'AX' }, { Name: 'Albania', Code: 'AL' }, { Name: 'Algeria', Code: 'DZ' }, { Name: 'American Samoa', Code: 'AS' }, { Name: 'AndorrA', Code: 'AD' }, { Name: 'Angola', Code: 'AO' }, { Name: 'Anguilla', Code: 'AI' }, { Name: 'Antarctica', Code: 'AQ' }, { Name: 'Antigua and Barbuda', Code: 'AG' }, { Name: 'Argentina', Code: 'AR' }, { Name: 'Armenia', Code: 'AM' }, { Name: 'Aruba', Code: 'AW' }, { Name: 'Australia', Code: 'AU' }, { Name: 'Austria', Code: 'AT' }, { Name: 'Azerbaijan', Code: 'AZ' }, { Name: 'Bahamas', Code: 'BS' }, { Name: 'Bahrain', Code: 'BH' }, { Name: 'Bangladesh', Code: 'BD' }, { Name: 'Barbados', Code: 'BB' }, { Name: 'Belarus', Code: 'BY' }, { Name: 'Belgium', Code: 'BE' }, { Name: 'Belize', Code: 'BZ' }, { Name: 'Benin', Code: 'BJ' }, { Name: 'Bermuda', Code: 'BM' }, { Name: 'Bhutan', Code: 'BT' }, { Name: 'Bolivia', Code: 'BO' }, { Name: 'Bosnia and Herzegovina', Code: 'BA' }, { Name: 'Botswana', Code: 'BW' }, { Name: 'Bouvet Island', Code: 'BV' }, { Name: 'Brazil', Code: 'BR' }, { Name: 'British Indian Ocean Territory', Code: 'IO' }, { Name: 'Brunei Darussalam', Code: 'BN' }, { Name: 'Bulgaria', Code: 'BG' }, { Name: 'Burkina Faso', Code: 'BF' }, { Name: 'Burundi', Code: 'BI' }, { Name: 'Cambodia', Code: 'KH' }, { Name: 'Cameroon', Code: 'CM' }, { Name: 'Canada', Code: 'CA' }, { Name: 'Cape Verde', Code: 'CV' }, { Name: 'Cayman Islands', Code: 'KY' }, { Name: 'Central African Republic', Code: 'CF' }, { Name: 'Chad', Code: 'TD' }, { Name: 'Chile', Code: 'CL' }, { Name: 'China', Code: 'CN' }, { Name: 'Christmas Island', Code: 'CX' }, { Name: 'Cocos (Keeling) Islands', Code: 'CC' }, { Name: 'Colombia', Code: 'CO' }, { Name: 'Comoros', Code: 'KM' }, { Name: 'Congo', Code: 'CG' }, { Name: 'Congo, The Democratic Republic of the', Code: 'CD' }, { Name: 'Cook Islands', Code: 'CK' }, { Name: 'Costa Rica', Code: 'CR' }, { Name: 'Cote D\'Ivoire', Code: 'CI' }, { Name: 'Croatia', Code: 'HR' }, { Name: 'Cuba', Code: 'CU' }, { Name: 'Cyprus', Code: 'CY' }, { Name: 'Czech Republic', Code: 'CZ' }, { Name: 'Denmark', Code: 'DK' }, { Name: 'Djibouti', Code: 'DJ' }, { Name: 'Dominica', Code: 'DM' }, { Name: 'Dominican Republic', Code: 'DO' }, { Name: 'Ecuador', Code: 'EC' }, { Name: 'Egypt', Code: 'EG' }, { Name: 'El Salvador', Code: 'SV' }, { Name: 'Equatorial Guinea', Code: 'GQ' }, { Name: 'Eritrea', Code: 'ER' }, { Name: 'Estonia', Code: 'EE' }, { Name: 'Ethiopia', Code: 'ET' }, { Name: 'Falkland Islands (Malvinas)', Code: 'FK' }, { Name: 'Faroe Islands', Code: 'FO' }, { Name: 'Fiji', Code: 'FJ' }, { Name: 'Finland', Code: 'FI' }, { Name: 'France', Code: 'FR' }, { Name: 'French Guiana', Code: 'GF' }, { Name: 'French Polynesia', Code: 'PF' }, { Name: 'French Southern Territories', Code: 'TF' }, { Name: 'Gabon', Code: 'GA' }, { Name: 'Gambia', Code: 'GM' }, { Name: 'Georgia', Code: 'GE' }, { Name: 'Germany', Code: 'DE' }, { Name: 'Ghana', Code: 'GH' }, { Name: 'Gibraltar', Code: 'GI' }, { Name: 'Greece', Code: 'GR' }, { Name: 'Greenland', Code: 'GL' }, { Name: 'Grenada', Code: 'GD' }, { Name: 'Guadeloupe', Code: 'GP' }, { Name: 'Guam', Code: 'GU' }, { Name: 'Guatemala', Code: 'GT' }, { Name: 'Guernsey', Code: 'GG' }, { Name: 'Guinea', Code: 'GN' }, { Name: 'Guinea-Bissau', Code: 'GW' }, { Name: 'Guyana', Code: 'GY' }, { Name: 'Haiti', Code: 'HT' }, { Name: 'Heard Island and Mcdonald Islands', Code: 'HM' }, { Name: 'Holy See (Vatican City State)', Code: 'VA' }, { Name: 'Honduras', Code: 'HN' }, { Name: 'Hong Kong', Code: 'HK' }, { Name: 'Hungary', Code: 'HU' }, { Name: 'Iceland', Code: 'IS' }, { Name: 'India', Code: 'IN' }, { Name: 'Indonesia', Code: 'ID' }, { Name: 'Iran, Islamic Republic Of', Code: 'IR' }, { Name: 'Iraq', Code: 'IQ' }, { Name: 'Ireland', Code: 'IE' }, { Name: 'Isle of Man', Code: 'IM' }, { Name: 'Israel', Code: 'IL' }, { Name: 'Italy', Code: 'IT' }, { Name: 'Jamaica', Code: 'JM' }, { Name: 'Japan', Code: 'JP' }, { Name: 'Jersey', Code: 'JE' }, { Name: 'Jordan', Code: 'JO' }, { Name: 'Kazakhstan', Code: 'KZ' }, { Name: 'Kenya', Code: 'KE' }, { Name: 'Kiribati', Code: 'KI' }, { Name: 'Korea, Democratic People\'s Republic of', Code: 'KP' }, { Name: 'Korea, Republic of', Code: 'KR' }, { Name: 'Kuwait', Code: 'KW' }, { Name: 'Kyrgyzstan', Code: 'KG' }, { Name: 'Lao People\'s Democratic Republic', Code: 'LA' }, { Name: 'Latvia', Code: 'LV' }, { Name: 'Lebanon', Code: 'LB' }, { Name: 'Lesotho', Code: 'LS' }, { Name: 'Liberia', Code: 'LR' }, { Name: 'Libyan Arab Jamahiriya', Code: 'LY' }, { Name: 'Liechtenstein', Code: 'LI' }, { Name: 'Lithuania', Code: 'LT' }, { Name: 'Luxembourg', Code: 'LU' }, { Name: 'Macao', Code: 'MO' }, { Name: 'Macedonia, The Former Yugoslav Republic of', Code: 'MK' }, { Name: 'Madagascar', Code: 'MG' }, { Name: 'Malawi', Code: 'MW' }, { Name: 'Malaysia', Code: 'MY' }, { Name: 'Maldives', Code: 'MV' }, { Name: 'Mali', Code: 'ML' }, { Name: 'Malta', Code: 'MT' }, { Name: 'Marshall Islands', Code: 'MH' }, { Name: 'Martinique', Code: 'MQ' }, { Name: 'Mauritania', Code: 'MR' }, { Name: 'Mauritius', Code: 'MU' }, { Name: 'Mayotte', Code: 'YT' }, { Name: 'Mexico', Code: 'MX' }, { Name: 'Micronesia, Federated States of', Code: 'FM' }, { Name: 'Moldova, Republic of', Code: 'MD' }, { Name: 'Monaco', Code: 'MC' }, { Name: 'Mongolia', Code: 'MN' }, { Name: 'Montserrat', Code: 'MS' }, { Name: 'Morocco', Code: 'MA' }, { Name: 'Mozambique', Code: 'MZ' }, { Name: 'Myanmar', Code: 'MM' }, { Name: 'Namibia', Code: 'NA' }, { Name: 'Nauru', Code: 'NR' }, { Name: 'Nepal', Code: 'NP' }, { Name: 'Netherlands', Code: 'NL' }, { Name: 'Netherlands Antilles', Code: 'AN' }, { Name: 'New Caledonia', Code: 'NC' }, { Name: 'New Zealand', Code: 'NZ' }, { Name: 'Nicaragua', Code: 'NI' }, { Name: 'Niger', Code: 'NE' }, { Name: 'Nigeria', Code: 'NG' }, { Name: 'Niue', Code: 'NU' }, { Name: 'Norfolk Island', Code: 'NF' }, { Name: 'Northern Mariana Islands', Code: 'MP' }, { Name: 'Norway', Code: 'NO' }, { Name: 'Oman', Code: 'OM' }, { Name: 'Pakistan', Code: 'PK' }, { Name: 'Palau', Code: 'PW' }, { Name: 'Palestinian Territory, Occupied', Code: 'PS' }, { Name: 'Panama', Code: 'PA' }, { Name: 'Papua New Guinea', Code: 'PG' }, { Name: 'Paraguay', Code: 'PY' }, { Name: 'Peru', Code: 'PE' }, { Name: 'Philippines', Code: 'PH' }, { Name: 'Pitcairn', Code: 'PN' }, { Name: 'Poland', Code: 'PL' }, { Name: 'Portugal', Code: 'PT' }, { Name: 'Puerto Rico', Code: 'PR' }, { Name: 'Qatar', Code: 'QA' }, { Name: 'Reunion', Code: 'RE' }, { Name: 'Romania', Code: 'RO' }, { Name: 'Russian Federation', Code: 'RU' }, { Name: 'RWANDA', Code: 'RW' }, { Name: 'Saint Helena', Code: 'SH' }, { Name: 'Saint Kitts and Nevis', Code: 'KN' }, { Name: 'Saint Lucia', Code: 'LC' }, { Name: 'Saint Pierre and Miquelon', Code: 'PM' }, { Name: 'Saint Vincent and the Grenadines', Code: 'VC' }, { Name: 'Samoa', Code: 'WS' }, { Name: 'San Marino', Code: 'SM' }, { Name: 'Sao Tome and Principe', Code: 'ST' }, { Name: 'Saudi Arabia', Code: 'SA' }, { Name: 'Senegal', Code: 'SN' }, { Name: 'Serbia and Montenegro', Code: 'CS' }, { Name: 'Seychelles', Code: 'SC' }, { Name: 'Sierra Leone', Code: 'SL' }, { Name: 'Singapore', Code: 'SG' }, { Name: 'Slovakia', Code: 'SK' }, { Name: 'Slovenia', Code: 'SI' }, { Name: 'Solomon Islands', Code: 'SB' }, { Name: 'Somalia', Code: 'SO' }, { Name: 'South Africa', Code: 'ZA' }, { Name: 'South Georgia and the South Sandwich Islands', Code: 'GS' }, { Name: 'Spain', Code: 'ES' }, { Name: 'Sri Lanka', Code: 'LK' }, { Name: 'Sudan', Code: 'SD' }, { Name: 'Suriname', Code: 'SR' }, { Name: 'Svalbard and Jan Mayen', Code: 'SJ' }, { Name: 'Swaziland', Code: 'SZ' }, { Name: 'Sweden', Code: 'SE' }, { Name: 'Switzerland', Code: 'CH' }, { Name: 'Syrian Arab Republic', Code: 'SY' }, { Name: 'Taiwan, Province of China', Code: 'TW' }, { Name: 'Tajikistan', Code: 'TJ' }, { Name: 'Tanzania, United Republic of', Code: 'TZ' }, { Name: 'Thailand', Code: 'TH' }, { Name: 'Timor-Leste', Code: 'TL' }, { Name: 'Togo', Code: 'TG' }, { Name: 'Tokelau', Code: 'TK' }, { Name: 'Tonga', Code: 'TO' }, { Name: 'Trinidad and Tobago', Code: 'TT' }, { Name: 'Tunisia', Code: 'TN' }, { Name: 'Turkey', Code: 'TR' }, { Name: 'Turkmenistan', Code: 'TM' }, { Name: 'Turks and Caicos Islands', Code: 'TC' }, { Name: 'Tuvalu', Code: 'TV' }, { Name: 'Uganda', Code: 'UG' }, { Name: 'Ukraine', Code: 'UA' }, { Name: 'United Arab Emirates', Code: 'AE' }, { Name: 'United Kingdom', Code: 'GB' }, { Name: 'United States', Code: 'US' }, { Name: 'United States Minor Outlying Islands', Code: 'UM' }, { Name: 'Uruguay', Code: 'UY' }, { Name: 'Uzbekistan', Code: 'UZ' }, { Name: 'Vanuatu', Code: 'VU' }, { Name: 'Venezuela', Code: 'VE' }, { Name: 'Viet Nam', Code: 'VN' }, { Name: 'Virgin Islands, British', Code: 'VG' }, { Name: 'Virgin Islands, U.S.', Code: 'VI' }, { Name: 'Wallis and Futuna', Code: 'WF' }, { Name: 'Western Sahara', Code: 'EH' }, { Name: 'Yemen', Code: 'YE' }, { Name: 'Zambia', Code: 'ZM' }, { Name: 'Zimbabwe', Code: 'ZW' }];
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbCountrySelect = angular.module('app.lbCountrySelect', []);
	
	lbCountrySelect.controller('lbCountrySelectCtrl', __webpack_require__(261));
	lbCountrySelect.component('lbCountrySelect', __webpack_require__(260));
	
	exports['default'] = lbCountrySelect;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(822);
	
	var $inject = [];
	
	var lbCountrySelect = {
	  controller: 'lbCountrySelectCtrl as vm',
	  template: __webpack_require__(1034),
	  bindings: {
	    country: '=',
	    required: '<',
	    disabled: '<'
	  }
	};
	
	lbCountrySelect.$inject = $inject;
	
	exports['default'] = lbCountrySelect;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbCountrySelectCtrl = function lbCountrySelectCtrl() {
	  var vm = this;
	
	  var DEFAULT_PLACEHOLDER = 'Select a country';
	
	  vm.required = vm.required || false;
	  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
	  vm.countries = __webpack_require__(258);
	  vm.showLoader = false;
	};
	
	lbCountrySelectCtrl.$inject = $inject;
	
	exports['default'] = lbCountrySelectCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(823);
	
	var lbCurrencyMessage = angular.module('app.lbCurrencyMessage', []);
	
	lbCurrencyMessage.component('lbCurrencyMessage', {
	  bindings: {
	    mode: '<'
	  },
	  controllerAs: 'vm',
	  controller: ['settingsService', controller],
	  template: __webpack_require__(1035)
	});
	
	function controller(settingsService) {
	
	  var vm = this;
	
	  vm.currencyCode = settingsService.settings.Currency.Code;
	  vm.message = 'ALL PRICES SHOWN HERE IN ' + vm.currencyCode + ' BASED ON THE CURRENT EXCHANGE RATES WE HAVE ON RECORD';
	}
	
	exports['default'] = lbCurrencyMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(824);
	
	var lbDatePicker = angular.module('app.lbDatePicker', ['pickadate']);
	
	lbDatePicker.component('lbDatePicker', {
	  bindings: {
	    settings: '<'
	  },
	  controllerAs: 'vm',
	  controller: ['$document', '$timeout', 'moment', '$filter', controller],
	  template: __webpack_require__(1036)
	});
	
	function controller($document, $timeout, moment, $filter) {
	  var l = document.getElementById('lbDatePickerClose');
	  l.focus();
	
	  var vm = this;
	
	  vm.dateFormat = $filter('translate')('dates.dateFormat');
	  var DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');
	
	  vm.dateSelected = dateSelected;
	  vm.closeDatePicker = closeDatePicker;
	  vm.date = vm.settings.defaultDate;
	
	  $document.on('keydown', function (e) {
	    keyDown(e);
	  });
	
	  function dateSelected(date) {
	    vm.settings.input.focus();
	    vm.settings.input.selectionEnd = vm.settings.input.selectionStart;
	
	    $timeout(function () {
	      $document.unbind('keydown');
	
	      vm.settings.callBack({
	        target: vm.settings.parent,
	        date: date
	      });
	    }, 0);
	  }
	
	  function closeDatePicker() {
	    $document.unbind('keydown');
	    vm.settings.callBack(null, vm.settings.input);
	  }
	
	  function keyDown(e) {
	    e.preventDefault();
	
	    switch (e.keyCode) {
	      case 39:
	        // Right arrow key
	        $timeout(function () {
	          vm.date = moment(vm.date, DATE_FORMAT_UPPER).add(1, 'd').format(DATE_FORMAT_UPPER);
	        }, 0);
	        break;
	
	      case 40:
	        // Down arrow key
	        $timeout(function () {
	          vm.date = moment(vm.date, DATE_FORMAT_UPPER).add(7, 'd').format(DATE_FORMAT_UPPER);
	        }, 0);
	        break;
	
	      case 37:
	        // Left arrow key
	        $timeout(function () {
	          if (vm.date != vm.settings.minDate) vm.date = moment(vm.date, DATE_FORMAT_UPPER).subtract(1, 'd').format(DATE_FORMAT_UPPER);
	        }, 0);
	        break;
	
	      case 38:
	        // Up arrow key
	        $timeout(function () {
	          if (vm.date != vm.settings.minDate) vm.date = moment(vm.date, DATE_FORMAT_UPPER).subtract(7, 'd').format(DATE_FORMAT_UPPER);
	        }, 0);
	        break;
	
	      case 13:
	        // Enter key
	        $timeout(function () {
	          dateSelected(moment(vm.date, DATE_FORMAT_UPPER));
	        }, 0);
	        break;
	
	      case 9:
	        // Tab key
	        $timeout(function () {
	          dateSelected(moment(vm.date, DATE_FORMAT_UPPER));
	        }, 0);
	        break;
	
	      default:
	        console.warn('keyCode not assigned');
	    }
	  }
	}
	
	exports['default'] = lbDatePicker;
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbDateSelect = angular.module('app.lbDateSelect', []);
	
	lbDateSelect.controller('lbDateSelectCtrl', __webpack_require__(266));
	lbDateSelect.component('lbDateSelect', __webpack_require__(265));
	
	exports['default'] = lbDateSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(825);
	
	var $inject = [];
	
	var lbDateSelect = {
	  controller: 'lbDateSelectCtrl as vm',
	  template: __webpack_require__(1037),
	  bindings: {
	    name: '@',
	    date: '=',
	    min: '<',
	    max: '<',
	    rangeFrom: '<',
	    rangeTo: '<',
	    required: '<',
	    disabled: '<'
	  }
	};
	
	lbDateSelect.$inject = $inject;
	
	exports['default'] = lbDateSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$filter', 'moment'];
	
	var lbDateSelectCtrl = function lbDateSelectCtrl($rootScope, $filter, moment) {
	  var vm = this;
	
	  var DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');
	  var DISPLAY_DATE_FORMAT = 'ddd Do MMM, YYYY';
	
	  vm.inputName = vm.name + '.' + vm.index;
	
	  vm.openDatePicker = openDatePicker;
	
	  function openDatePicker($event) {
	    var settings = {
	      input: $event.currentTarget,
	      parent: 'dateSelect',
	      defaultDate: moment(vm.date, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER),
	      callBack: dateCallBack
	    };
	
	    if (vm.min) {
	      settings.minDate = moment(vm.min, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
	    }
	
	    if (vm.max) {
	      settings.maxDate = moment(vm.max, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
	    }
	
	    if (vm.rangeFrom) {
	      settings.rangeFrom = moment(vm.rangeFrom, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
	    }
	
	    if (vm.rangeTo) {
	      settings.rangeTo = moment(vm.rangeTo, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
	    }
	
	    // TODO use service instead of events
	    $rootScope.$broadcast('openDatePicker', settings);
	  }
	
	  function dateCallBack(selection) {
	    if (selection) {
	      var selectedDate = moment(selection.date);
	      vm.date = selectedDate.format(DISPLAY_DATE_FORMAT);
	    }
	
	    $rootScope.$broadcast('closeDatePicker');
	  }
	};
	
	lbDateSelectCtrl.$inject = $inject;
	
	exports['default'] = lbDateSelectCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var lbDialog = angular.module('app.lbDialog', []);
	
	lbDialog.controller('lbDialogCont', __webpack_require__(276));
	lbDialog.directive('lbDialog', __webpack_require__(277));
	lbDialog.service('lbDialogService', __webpack_require__(278));
	
	exports['default'] = lbDialog;
	module.exports = exports['default'];

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['lbDialogService'];
	
	var lbDialogCont = function lbDialogCont(lbDialogService) {
	  var vm = this;
	
	  vm.lbDialogService = lbDialogService;
	};
	
	lbDialogCont.$inject = $inject;
	
	exports['default'] = lbDialogCont;
	module.exports = exports['default'];

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(828);
	
	var $inject = [];
	var lbDialog = function lbDialog() {
	  return {
	    controller: 'lbDialogCont',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(1040),
	    scope: {}
	  };
	};
	
	lbDialog.$inject = $inject;
	
	exports['default'] = lbDialog;
	module.exports = exports['default'];

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$q'];
	
	var lbDialogService = function lbDialogService($q) {
	    var service = {};
	
	    service.visible = false;
	    service.selectedItem = null;
	    service.returnVal = null;
	
	    service.options = {
	        warningLevel: 'info',
	        submitButtonText: 'Submit'
	    };
	
	    service.show = show;
	    service.cancel = cancel;
	    service.submit = submit;
	
	    function show(options) {
	        service.selectedItem = null;
	        service.returnVal = null;
	        service.options = {
	            warningLevel: 'info',
	            submitButtonText: 'Submit',
	            selections: []
	        };
	
	        _.assign(service.options, options);
	
	        service.visible = true;
	
	        service.returnVal = $q.defer();
	
	        service.selectedItem = service.options.selections[0];
	
	        return service.returnVal.promise;
	    }
	
	    function submit() {
	        service.visible = false;
	
	        service.returnVal.resolve({
	            message: 'success',
	            reason: service.selectedItem
	        });
	    }
	
	    function cancel() {
	        service.visible = false;
	
	        service.returnVal.reject({
	            message: 'cancel'
	        });
	    }
	
	    return service;
	};
	
	lbDialogService.$inject = $inject;
	
	exports['default'] = lbDialogService;
	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(829);
	
	var lbErrorModal = angular.module('app.lbErrorModal', []);
	
	lbErrorModal.component('lbErrorModal', {
	  controllerAs: 'vm',
	  controller: ['lbModalService', lbErrorModalCtrl],
	  template: __webpack_require__(1041)
	});
	
	function lbErrorModalCtrl(lbModalService) {
	  var vm = this;
	
	  var DEFAULT_MSG = 'Error';
	  var DEFAULT_ERROR_DESC = 'Whoops, there has been an error. Please try again.';
	  var DEFAULT_ERROR_DESC_INFO = 'We are really sorry about that.';
	  var DEFAULT_REJECTION = {
	    status: '',
	    statusText: '',
	    data: {}
	  };
	
	  var rejection = lbModalService.params().rejection || DEFAULT_REJECTION;
	
	  vm.warnLevel = lbModalService.params().warnLevel || 'warning';
	  vm.errorMessage = DEFAULT_MSG;
	  vm.errorDesc = DEFAULT_ERROR_DESC;
	  vm.instructions = rejection.status + ' ' + rejection.statusText;
	
	  vm.close = lbModalService.resolve;
	
	  if (vm.warnLevel === 'info') {
	    vm.errorDesc = DEFAULT_ERROR_DESC_INFO;
	
	    if (rejection.data.Message) {
	      vm.errorMessage = rejection.data.Message;
	    }
	  }
	
	  if (rejection.data.Instructions) {
	    vm.instructions = rejection.data.Instructions;
	  }
	}
	
	exports['default'] = lbErrorModal;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(832);
	
	var lbFareRulesModal = angular.module('app.lbFareRulesModal', []);
	
	lbFareRulesModal.component('lbFareRulesModal', {
	  controllerAs: 'vm',
	  controller: ['lbModalService', controller],
	  template: __webpack_require__(1044)
	});
	
	function controller(lbModalService) {
	  var vm = this;
	
	  var params = lbModalService.params();
	  var urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
	
	  vm.carrierName = params.trip.CarrierName;
	  vm.rulesType = params.fareRules.Type;
	  vm.fareRulesText = params.fareRules.Data;
	
	  if (vm.rulesType === 'ExternalUrl') {
	    vm.fareRulesText = vm.fareRulesText.replace(urlReg, replaceLink);
	  }
	
	  function replaceLink(str) {
	    return '<a href="' + str + '" target="_blank" rel="noreferrer noopener">' + 'Click here to view fare rules' + '</a>';
	  }
	
	  vm.close = lbModalService.resolve;
	}
	
	exports['default'] = lbFareRulesModal;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbFiveStarRating = angular.module('app.lbFiveStarRating', []);
	
	lbFiveStarRating.controller('lbFiveStarRatingController', __webpack_require__(289));
	lbFiveStarRating.directive('lbFiveStarRating', __webpack_require__(290));
	
	exports['default'] = lbFiveStarRating;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope'];
	var lbFiveStarRatingController = function lbFiveStarRatingController($scope) {
	
	  var vm = this;
	
	  if (vm.rating % 1 != 0) {
	    vm.isDecimal = true;
	  }
	
	  vm.stars = Math.ceil(vm.rating);
	};
	
	lbFiveStarRatingController.$inject = $inject;
	
	exports['default'] = lbFiveStarRatingController;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(833);
	
	var $inject = [];
	
	var lbFiveStarRating = function lbFiveStarRating() {
	  return {
	    template: __webpack_require__(1045),
	    controller: 'lbFiveStarRatingController',
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      rating: '='
	    }
	  };
	};
	
	lbFiveStarRating.$inject = $inject;
	
	exports['default'] = lbFiveStarRating;
	module.exports = exports['default'];

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbLoadingPlaceholder = angular.module('app.lbLoadingPlaceholder', []);
	
	lbLoadingPlaceholder.component('lbLoadingPlaceholder', __webpack_require__(323));
	lbLoadingPlaceholder.component('lbLoadingPlaceholderItem', __webpack_require__(324));
	lbLoadingPlaceholder.controller('lbLoadingPlaceholderItemCtrl', __webpack_require__(325));
	
	exports['default'] = lbLoadingPlaceholder;
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(67);
	
	var $inject = [];
	
	var lbLoadingPlaceholder = {
	  template: __webpack_require__(1059),
	  transclude: true
	};
	
	lbLoadingPlaceholder.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholder;
	module.exports = exports['default'];

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(67);
	
	var $inject = [];
	
	var lbLoadingPlaceholderItem = {
	  template: __webpack_require__(1060),
	  controller: 'lbLoadingPlaceholderItemCtrl',
	  controllerAs: 'vm',
	  bindings: {
	    total: '<',
	    isHeading: '<',
	    maxWidth: '<',
	    minWidth: '<',
	    width: '<',
	    size: '<'
	  }
	};
	
	lbLoadingPlaceholderItem.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholderItem;
	module.exports = exports['default'];

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbLoadingPlaceholderItemCtrl = function lbLoadingPlaceholderItemCtrl() {
	  var vm = this;
	
	  vm.minWidth = vm.minWidth || 20;
	  vm.maxWidth = vm.maxWidth || 80;
	  vm.items = createItems(vm.total);
	
	  vm.getItemWidth = getItemWidth;
	
	  function createItems() {
	    var totalItems = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	
	    return _.map(_.times(totalItems), function (item) {
	      return {
	        width: getItemWidth(item)
	      };
	    });
	  }
	
	  function getItemWidth() {
	    return vm.width || randomWidth();
	  }
	
	  function randomWidth() {
	    return _.random(vm.minWidth, vm.maxWidth) + '%';
	  }
	};
	
	lbLoadingPlaceholderItemCtrl.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholderItemCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(847);
	
	var $inject = [];
	
	var lbLocationSelect = {
	  controller: 'lbLocationSelectCtrl as vm',
	  template: __webpack_require__(1061),
	  bindings: {
	    name: '@',
	    location: '=?',
	    airportCode: '=?',
	    required: '<',
	    isDisabled: '<',
	    placeholder: '<?',
	    sct: '<?',
	    isPublic: '<?'
	  }
	};
	
	lbLocationSelect.$inject = $inject;
	
	exports['default'] = lbLocationSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'iataSearchService'];
	
	var lbLocationSelectCtrl = function lbLocationSelectCtrl($filter, iataSearchService) {
	  var vm = this;
	
	  var MIN_SEARCH_TEXT_LENGTH = 2;
	  var MAX_SEARCH_RESULTS = 10;
	  var DEFAULT_PLACEHOLDER = 'Enter a location';
	
	  vm.required = vm.required || false;
	  vm.isPublic = !!vm.isPublic;
	  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
	  vm.locations = [];
	  vm.showLoader = false;
	  vm.dropdownFooterText = '<strong>Please note</strong>: ' + $filter('translate')('homeSearch.BLOCKED_LOCATION_MESSAGE');
	  vm.showDropdownFooterText = false;
	
	  vm.refreshLocations = refreshLocations;
	  vm.groupBy = groupBy;
	  vm.remove = remove;
	  vm.select = select;
	  vm.showDropdownFooterText = showDropdownFooterText;
	
	  if (vm.airportCode) {
	    vm.showLoader = true;
	
	    iataSearchService.getMetroGrouped({
	      maxRows: MAX_SEARCH_RESULTS,
	      term: vm.airportCode
	    }, vm.isPublic).then(function (result) {
	      vm.location = _.find(result, { 'Value': vm.airportCode });
	      vm.showLoader = false;
	    });
	  }
	
	  function refreshLocations(searchText) {
	    if (searchText && searchText.length > MIN_SEARCH_TEXT_LENGTH) {
	      vm.showLoader = true;
	
	      iataSearchService.getMetroGrouped({
	        maxRows: MAX_SEARCH_RESULTS,
	        term: searchText
	      }, vm.isPublic).then(function (result) {
	        vm.locations = result;
	        vm.showLoader = false;
	        vm.showDropdownFooterText = showDropdownFooterText();
	      });
	    } else {
	      vm.locations = [];
	      vm.showLoader = false;
	      vm.showDropdownFooterText = false;
	    }
	  }
	
	  function groupBy(item) {
	    return item.groupedBy;
	  }
	
	  function remove() {
	    vm.location = null;
	    vm.airportCode = '';
	  }
	
	  function select(location) {
	    vm.airportCode = location.Value;
	  }
	
	  vm.onOpenClose = function (isOpen) {
	    if (!isOpen) {
	      vm.locations = [];
	      vm.showDropdownFooterText = showDropdownFooterText();
	    }
	  };
	
	  function showDropdownFooterText() {
	    return _.some(vm.locations, function (result) {
	      return result.IsBlocked;
	    });
	  }
	};
	
	lbLocationSelectCtrl.$inject = $inject;
	
	exports['default'] = lbLocationSelectCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbModal = angular.module('app.lbModal', []);
	
	lbModal.controller('lbModalCtrl', __webpack_require__(347));
	lbModal.directive('lbModal', __webpack_require__(348));
	lbModal.service('lbModalService', __webpack_require__(349));
	
	exports['default'] = lbModal;
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope'];
	
	var lbModalCtrl = function lbModalCtrl($rootScope) {
	  var vm = this;
	
	  vm.modalContent = null;
	  vm.options = {};
	
	  $rootScope.$on('modals.open', function handleModalOpenEvent(event, modalContent, options) {
	    vm.modalContent = modalContent;
	    vm.options = options;
	  });
	
	  $rootScope.$on('modals.close', function handleModalCloseEvent() {
	    vm.modalContent = null;
	    vm.className = '';
	  });
	};
	
	lbModalCtrl.$inject = $inject;
	
	exports['default'] = lbModalCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(852);
	
	var $inject = ['$compile'];
	
	var lbModal = function lbModal($compile) {
	  return {
	    bindToController: true,
	    controllerAs: 'vm',
	    controller: 'lbModalCtrl',
	    template: __webpack_require__(1063),
	    scope: {
	      width: '<?',
	      className: '<?'
	    },
	    link: function link(scope, ele, attrs) {
	      scope.$watch('vm.modalContent', function (modalContent) {
	        if (modalContent) {
	          var contentEle = ele[0].querySelector('.lbModal_content');
	          contentEle.innerHTML = modalContent;
	          $compile(contentEle)(scope);
	        }
	      });
	    }
	  };
	};
	
	lbModal.$inject = $inject;
	
	exports['default'] = lbModal;
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q'];
	
	var lbModalService = function lbModalService($rootScope, $q) {
	  var service = {};
	
	  var modal = {
	    deferred: null,
	    params: null
	  };
	
	  service.open = open;
	  service.params = params;
	  service.proceedTo = proceedTo;
	  service.reject = reject;
	  service.resolve = resolve;
	
	  function open(type, options, params, pipeResponse) {
	    var previousDeferred = modal.deferred;
	
	    modal.deferred = $q.defer();
	    modal.params = params;
	
	    if (previousDeferred && pipeResponse) {
	
	      modal.deferred.promise.then(previousDeferred.resolve, previousDeferred.reject);
	    } else if (previousDeferred) {
	      previousDeferred.reject();
	    }
	
	    options = options || {};
	
	    if (options.width) {
	      options.width = options.width + 'px';
	    }
	
	    options.scroll = options.scroll || false;
	
	    $rootScope.$emit('modals.open', type, options);
	
	    return modal.deferred.promise;
	  }
	
	  function params() {
	    return modal.params || {};
	  }
	
	  function proceedTo(type, params) {
	    return open(type, params, true);
	  }
	
	  function reject(reason) {
	    if (!modal.deferred) return;
	    if (reason) modal.deferred.reject(reason);
	
	    modal.deferred = modal.params = null;
	    $rootScope.$emit('modals.close');
	  }
	
	  function resolve(response) {
	    if (!modal.deferred) {
	      return;
	    }
	
	    modal.deferred.resolve(response);
	    modal.deferred = modal.params = null;
	    $rootScope.$emit('modals.close');
	  }
	
	  return service;
	};
	
	lbModalService.$inject = $inject;
	
	exports['default'] = lbModalService;
	module.exports = exports['default'];

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbPoiSelect = angular.module('app.lbPoiSelect', []);
	
	lbPoiSelect.controller('lbPoiSelectCtrl', __webpack_require__(353));
	lbPoiSelect.component('lbPoiSelect', __webpack_require__(352));
	lbPoiSelect.filter('poiHighlightFilter', __webpack_require__(354));
	
	exports['default'] = lbPoiSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(855);
	
	var $inject = [];
	
	var lbPoiSelect = {
	  controller: 'lbPoiSelectCtrl as vm',
	  template: __webpack_require__(1066),
	  bindings: {
	    name: '@',
	    location: '=',
	    defaultOptions: '<?',
	    required: '<',
	    disabled: '<',
	    disablePlaceholder: '<',
	    placeholderText: '<?',
	    iconClassName: '<?'
	  }
	};
	
	lbPoiSelect.$inject = $inject;
	
	exports['default'] = lbPoiSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$window', 'locationsSearchService'];
	
	var lbPoiSelectCtrl = function lbPoiSelectCtrl($window, locationsSearchService) {
	  var vm = this;
	
	  var MIN_SEARCH_TEXT_LENGTH = 2;
	  var MAX_SEARCH_RESULTS = 10;
	  var REFRESH_DELAY = 1000;
	  var placeholderText = vm.placeholderText || 'Destination, airport, train station, landmark or hotel';
	
	  vm.allowClear = true;
	  vm.required = vm.required || false;
	  vm.placeholder = vm.disablePlaceholder ? '' : placeholderText;
	  vm.iconClassName = vm.iconClassName || 'ico-marker';
	  vm.options = [];
	  vm.defaultOptions = vm.defaultOptions || [];
	  vm.showLoader = false;
	  vm.refreshDelay = REFRESH_DELAY;
	
	  vm.refreshOptions = refreshOptions;
	  vm.onRemove = onRemove;
	  vm.onSelect = onSelect;
	
	  vm.defaultOptions = _.orderBy(_.map(vm.defaultOptions, function (location) {
	    return {
	      Title: location.HotelName,
	      Latitude: location.Latitude,
	      Longitude: location.Longitude
	    };
	  }), 'Title');
	
	  vm.options = _.clone(vm.defaultOptions);
	
	  function refreshOptions(search) {
	    vm.currentSearch = search;
	
	    if (search.length <= MIN_SEARCH_TEXT_LENGTH) {
	      return vm.defaultOptions;
	    }
	
	    vm.showLoader = true;
	
	    return locationsSearchService.get({
	      maxRows: MAX_SEARCH_RESULTS,
	      term: search
	    }).then(function (result) {
	      vm.options = result;
	    })['finally'](function () {
	      vm.showLoader = false;
	    });
	  }
	
	  function onRemove() {
	    vm.options = _.clone(vm.defaultOptions);
	  }
	
	  function onSelect() {
	    if (!vm.location) return;
	    window.svelteStore.track('POI_SEARCH_ITEM_SELECTED', {
	      'searchText': vm.currentSearch,
	      'itemTitle': vm.location.Title,
	      'itemIndex': vm.options.indexOf(vm.location) + 1,
	      'itemSearchScore': vm.location.SearchScore,
	      'itemType': vm.location.Type
	    });
	  }
	};
	
	lbPoiSelectCtrl.$inject = $inject;
	
	exports['default'] = lbPoiSelectCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var poiHighlightFilter = function poiHighlightFilter() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  function highlight(matchItem, query) {
	    return ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span' + ' class="ui-select-highlight">$&</span>');
	  }
	
	  function stripStopWords(text) {
	    var tokens = text.split(' ');
	    var stopwords = ['an', 'and', 'as', 'at', 'be', 'by', 'for', 'has', 'here', 'if', 'in', 'is', 'it', 'my', 'of', 'on', 'or', 'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'those', 'to', 'too', 'up', 'was', 'way', 'we', 'were', 'what', 'where', 'which', 'while', 'who', 'with', 'would', 'you', 'your', 'a', 'i'];
	
	    return tokens.filter(function (value) {
	      return stopwords.indexOf(value.toLowerCase()) === -1;
	    }).join(' ');
	  }
	
	  return function (matchItem, query) {
	    if (!query || !matchItem) {
	      return matchItem;
	    }
	
	    var highlightedMatchItem = highlight(matchItem, query);
	
	    if (highlightedMatchItem === matchItem) {
	      query = stripStopWords(query);
	      highlightedMatchItem = highlight(matchItem, query);
	    }
	
	    return highlightedMatchItem;
	  };
	};
	
	exports['default'] = poiHighlightFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(862);
	
	var lbResolveLoader = angular.module('app.lbResolveLoader', []);
	
	lbResolveLoader.component('lbResolveLoader', {
	    controller: ['$rootScope', lbResolveLoaderCtrl],
	    template: '\n    <div ng-if="$root.showLoader">\n        <div class="lbResolveLoader_mask"></div>\n        <div class="lbResolveLoader">\n            <div class="lbResolveLoader_container">\n                <i class="button_spinner"></i>\n                <span class="lbResolveLoader_text">Loading</span>\n            </div>\n        </div>\n    </div>\n  '
	});
	
	function lbResolveLoaderCtrl($rootScope) {
	    $rootScope.showLoader = true;
	}
	
	exports['default'] = lbResolveLoader;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var searchResultsLoaderService = function searchResultsLoaderService() {
	  return {
	    isActive: false
	  };
	};
	
	searchResultsLoaderService.$inject = $inject;
	
	exports["default"] = searchResultsLoaderService;
	module.exports = exports["default"];

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(866);
	
	var lbSearchResultsProgress = angular.module('app.lbSearchResultsProgress', []);
	
	lbSearchResultsProgress.component('lbSearchResultsProgress', {
	  bindings: {
	    finalStep: '<'
	  },
	  controllerAs: 'vm',
	  controller: ['locationService', 'itinerariesService', controller],
	  template: __webpack_require__(1077)
	});
	
	function controller(locationService, itinerariesService) {
	  var vm = this;
	
	  vm.itinerariesService = itinerariesService;
	  vm.locationService = locationService;
	  vm.gotoSection = gotoSection;
	  vm.cancelBooking = locationService.cancelBooking;
	
	  function gotoSection(item) {
	    if (!vm.finalStep) {
	      vm.locationService.gotoSection(item);
	    }
	  }
	}
	
	exports['default'] = lbSearchResultsProgress;
	module.exports = exports['default'];

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTimeSelect = angular.module('app.lbTimeSelect', []);
	
	lbTimeSelect.controller('lbTimeSelectCtrl', __webpack_require__(394));
	lbTimeSelect.component('lbTimeSelect', __webpack_require__(393));
	
	exports['default'] = lbTimeSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(871);
	
	var $inject = [];
	
	var lbTimeSelect = {
	  controller: 'lbTimeSelectCtrl as vm',
	  template: __webpack_require__(1084),
	  bindings: {
	    date: '<',
	    time: '=',
	    timeFormat: '@',
	    name: '@',
	    required: '<',
	    disabled: '<',
	    sequentialTime: '@',
	    beforeDate: '<',
	    beforeTime: '<',
	    anytime: '<'
	  }
	};
	
	lbTimeSelect.$inject = $inject;
	
	exports['default'] = lbTimeSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$filter', 'timesService'];
	
	var lbTimeSelectCtrl = function lbTimeSelectCtrl($scope, $filter, timesService) {
	  var vm = this;
	
	  var TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');
	
	  vm.times = timesService.getSelectOptions(TIME_FORMAT, vm.anytime);
	  vm.inputName = vm.name + '.' + vm.index;
	
	  vm.selectedTime = vm.time;
	
	  $scope.$watch('vm.selectedTime', function (selectedTime) {
	    vm.time = selectedTime;
	  });
	};
	
	lbTimeSelectCtrl.$inject = $inject;
	
	exports['default'] = lbTimeSelectCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(872);
	
	var lbTimeoutModal = angular.module('app.lbTimeoutModal', []);
	
	lbTimeoutModal.component('lbTimeoutModal', {
	  controller: ['lbModalService', 'Idle', lbTimeoutModalCtrl],
	  controllerAs: 'vm',
	  template: __webpack_require__(1085)
	});
	
	function lbTimeoutModalCtrl(lbModalService, Idle) {
	  var vm = this;
	
	  vm.timeoutValue = Idle.getTimeout();
	
	  vm.close = close;
	  vm.getCountdownNoun = getCountdownNoun;
	
	  function getCountdownNoun(countdown) {
	    return countdown === 1 ? 'second' : 'seconds';
	  }
	
	  function close() {
	    lbModalService.resolve();
	    Idle.watch();
	  }
	}
	
	exports['default'] = lbTimeoutModal;
	module.exports = exports['default'];

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbToggle = angular.module('app.lbToggle', []);
	
	lbToggle.controller('lbToggleCtrl', __webpack_require__(398));
	lbToggle.component('lbToggle', __webpack_require__(397));
	
	exports['default'] = lbToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(873);
	
	var $inject = [];
	
	var lbToggle = {
	  controller: 'lbToggleCtrl as vm',
	  template: __webpack_require__(1086),
	  bindings: {
	    isActive: '=',
	    onChange: '&'
	  }
	};
	
	lbToggle.$inject = $inject;
	
	exports['default'] = lbToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var lbToggleCtrl = function lbToggleCtrl() {
	  var vm = this;
	
	  vm.toggle = toggle;
	
	  function toggle() {
	    vm.isActive = !vm.isActive;
	    vm.onChange({ isActive: vm.isActive });
	  }
	};
	
	lbToggleCtrl.$inject = $inject;
	
	exports["default"] = lbToggleCtrl;
	module.exports = exports["default"];

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTripOptionsModal = angular.module('app.lbTripOptionsModal', [__webpack_require__(54).name]);
	
	lbTripOptionsModal.controller('lbTripOptionsModalCtrl', __webpack_require__(414));
	lbTripOptionsModal.component('lbTripOptionsModal', __webpack_require__(413));
	lbTripOptionsModal.controller('lbTripOptionsHotelFormCtrl', __webpack_require__(410));
	lbTripOptionsModal.component('lbTripOptionsHotelForm', __webpack_require__(409));
	lbTripOptionsModal.controller('lbTripOptionsHotelFormItemCtrl', __webpack_require__(412));
	lbTripOptionsModal.component('lbTripOptionsHotelFormItem', __webpack_require__(411));
	lbTripOptionsModal.controller('lbTripOptionsCarFormCtrl', __webpack_require__(406));
	lbTripOptionsModal.component('lbTripOptionsCarForm', __webpack_require__(405));
	lbTripOptionsModal.controller('lbTripOptionsCarFormItemCtrl', __webpack_require__(408));
	lbTripOptionsModal.component('lbTripOptionsCarFormItem', __webpack_require__(407));
	
	exports['default'] = lbTripOptionsModal;
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelForm = {
	  controller: 'lbTripOptionsCarFormCtrl as vm',
	  template: __webpack_require__(1090),
	  bindings: {
	    searches: '=',
	    optionsForm: '='
	  }
	};
	
	lbTripOptionsHotelForm.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelForm;
	module.exports = exports['default'];

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'moment'];
	
	var lbTripOptionsCarFormCtrl = function lbTripOptionsCarFormCtrl($scope, moment) {
	  var vm = this;
	
	  var apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  var displayDateFormat = 'ddd Do MMM, YYYY';
	
	  $scope.$watch('vm.searches', validateSearches, true);
	
	  function validateSearches(searches) {
	    _.forEach(searches, function (search, searchIndex) {
	      var dateFromMoment = moment(search.car.pickUp.Date, displayDateFormat);
	      var dateToMoment = moment(search.car.dropOff.Date, displayDateFormat);
	
	      if (dateToMoment.isBefore(dateFromMoment)) {
	        search.car.dropOff.Date = search.car.pickUp.Date;
	      }
	    });
	  }
	};
	
	lbTripOptionsCarFormCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsCarFormCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsCarFormItem = {
	  controller: 'lbTripOptionsCarFormItemCtrl as vm',
	  template: __webpack_require__(1091),
	  bindings: {
	    search: '<',
	    isLast: '<',
	    index: '<'
	  }
	};
	
	lbTripOptionsCarFormItem.$inject = $inject;
	
	exports['default'] = lbTripOptionsCarFormItem;
	module.exports = exports['default'];

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment'];
	
	var lbTripOptionCarFormItemCtrl = function lbTripOptionCarFormItemCtrl($filter, moment) {
	  var vm = this;
	
	  var timeFormat = $filter('translate')('dates.TimeFormatLong');
	
	  vm.flightDateTimeFormat = 'DD MMM[,] YYYY ' + timeFormat;
	};
	
	lbTripOptionCarFormItemCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionCarFormItemCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelForm = {
	  controller: 'lbTripOptionsHotelFormCtrl as vm',
	  template: __webpack_require__(1092),
	  bindings: {
	    searches: '=',
	    optionsForm: '='
	  }
	};
	
	lbTripOptionsHotelForm.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelForm;
	module.exports = exports['default'];

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'moment'];
	
	var lbTripOptionsHotelFormCtrl = function lbTripOptionsHotelFormCtrl($scope, moment) {
	  var vm = this;
	
	  var apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  var displayDateFormat = 'ddd Do MMM, YYYY';
	
	  $scope.$watch('vm.searches', validateSearches, true);
	
	  function validateSearches(searches) {
	    _.forEach(searches, function (search, searchIndex) {
	      var dateFromMoment = moment(search.hotel.dateFrom, displayDateFormat);
	      var dateToMoment = moment(search.hotel.dateTo, displayDateFormat);
	      var minDateFromMoment = moment(search.hotel.minDateFrom, displayDateFormat);
	
	      if (dateFromMoment.isBefore(minDateFromMoment)) {
	        search.hotel.dateFrom = search.hotel.minDateFrom;
	      }
	
	      if (dateToMoment.isBefore(dateFromMoment)) {
	        search.hotel.dateTo = moment(search.hotel.dateFrom, displayDateFormat).add(1, 'days').format(displayDateFormat);
	      }
	    });
	  }
	};
	
	lbTripOptionsHotelFormCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelFormItem = {
	  controller: 'lbTripOptionsHotelFormItemCtrl as vm',
	  template: __webpack_require__(1093),
	  bindings: {
	    search: '<',
	    isLast: '<',
	    index: '<'
	  }
	};
	
	lbTripOptionsHotelFormItem.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormItem;
	module.exports = exports['default'];

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment'];
	
	var lbTripOptionsHotelFormItemCtrl = function lbTripOptionsHotelFormItemCtrl($filter, moment) {
	  var vm = this;
	
	  var timeFormat = $filter('translate')('dates.TimeFormatLong');
	
	  vm.flightDateTimeFormat = 'DD MMM[,] YYYY ' + timeFormat;
	};
	
	lbTripOptionsHotelFormItemCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormItemCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(877);
	
	var $inject = [];
	
	var lbTripOptionsModal = {
	  controller: 'lbTripOptionsModalCtrl as vm',
	  template: __webpack_require__(1094),
	  bindings: {}
	};
	
	lbTripOptionsModal.$inject = $inject;
	
	exports['default'] = lbTripOptionsModal;
	module.exports = exports['default'];

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'lbModalService', 'itinerariesService'];
	
	var lbTripOptionsModalCtrl = function lbTripOptionsModalCtrl($filter, moment, lbModalService, itinerariesService) {
	  var vm = this;
	
	  vm.itinerary = {};
	  vm.searches = {};
	  vm.options = [];
	  vm.activeOptionIndex = 0;
	  vm.form = {};
	  vm.saving = false;
	  vm.datePickerDateFormat = 'ddd Do MMM, YYYY';
	  vm.apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  vm.displayDateFormat = 'ddd Do MMM, YYYY';
	  vm.displayTimeFormat = $filter('translate')('dates.TimeFormatLong');
	
	  vm.prev = prev;
	  vm.next = next;
	  vm.submit = submit;
	  vm.close = close;
	
	  vm.$onInit = function () {
	    vm.itinerary = lbModalService.params().itinerary;
	    vm.searches.flights = lbModalService.params().flights;
	
	    if (lbModalService.params().hasHotels) {
	      vm.options.push('hotel');
	      vm.searches.hotels = [];
	
	      _.forEach(vm.searches.flights, function (flightSearch, flightSearchIndex) {
	        if (flightSearchIndex < vm.searches.flights.length - 1) {
	          vm.searches.hotels.push(hotelSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
	        }
	      });
	    }
	
	    if (lbModalService.params().hasCars) {
	      vm.options.push('car');
	      vm.searches.cars = [];
	
	      _.forEach(vm.searches.flights, function (flightSearch, flightSearchIndex) {
	        if (flightSearchIndex < vm.searches.flights.length - 1) {
	          vm.searches.cars.push(carSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
	        }
	      });
	    }
	  };
	
	  function hotelSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
	    var hotelSearch = {
	      isActive: false
	    };
	
	    hotelSearch.flight = flightSearch;
	
	    hotelSearch.hotel = {
	      key: 'hotel' + flightSearchIndex,
	      maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	      minDateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      dateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      dateTo: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      Location: {
	        Title: flightSearch.Arrival.City,
	        City: {
	          Code: flightSearch.Arrival.Code
	        },
	        Type: 'Airport',
	        Latitude: null,
	        Longitude: null
	      }
	    };
	
	    return hotelSearch;
	  }
	
	  function carSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
	    var carSearch = {
	      isActive: false
	    };
	
	    carSearch.flight = flightSearch;
	
	    carSearch.car = {
	      key: 'car' + flightSearchIndex,
	      pickUp: {
	        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Date: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Time: nearestValidSearchTime(flightSearch.Arrival.Date),
	        Location: {
	          Name: flightSearch.Arrival.Location,
	          Value: flightSearch.Arrival.Code
	        }
	      },
	      dropOff: {
	        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).add(1, 'days').format(vm.displayDateFormat),
	        Date: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Time: nearestValidSearchTime(nextFlightSearch.Departure.Date),
	        Location: {
	          Name: nextFlightSearch.Departure.Location,
	          Value: nextFlightSearch.Departure.Code
	        }
	      }
	    };
	
	    return carSearch;
	  }
	
	  function nearestValidSearchTime(date) {
	    var start = moment(date, vm.apiDateFormat);
	    var remainder = 30 - start.minute() % 30;
	
	    return moment(start).add(remainder, 'minutes').format(vm.displayTimeFormat);
	  }
	
	  function prev() {
	    vm.activeOptionIndex -= 1;
	  }
	
	  function next() {
	    vm.activeOptionIndex += 1;
	  }
	
	  function submit() {
	    if (vm.form.$invalid) {
	      vm.isDisabled = false;
	      return false;
	    }
	
	    vm.saving = true;
	
	    var updatedItinerarySearch = angular.copy(itinerariesService.itinerary.Search);
	    updatedItinerarySearch.Hotels = buildHotelSearches(vm.searches.hotels);
	    updatedItinerarySearch.Cars = buildCarSearches(vm.searches.cars);
	
	    itinerariesService.postSearch(updatedItinerarySearch).then(function () {
	      lbModalService.resolve();
	    })['finally'](function () {
	      vm.saving = false;
	    });
	  }
	
	  function buildHotelSearches(searches) {
	    var hotelSearches = [];
	
	    _.forEach(searches, function (search) {
	      if (search.isActive) {
	        hotelSearches.push({
	          DateFrom: moment(search.hotel.dateFrom, vm.displayDateFormat).format(vm.apiDateFormat),
	          DateTo: moment(search.hotel.dateTo, vm.displayDateFormat).format(vm.apiDateFormat),
	          Location: {
	            Code: search.hotel.Location.City.Code,
	            Name: search.hotel.Location.Title,
	            Type: search.hotel.Location.Type,
	            Latitude: search.hotel.Location.Latitude,
	            Longitude: search.hotel.Location.Longitude
	          }
	        });
	      }
	    });
	
	    return hotelSearches;
	  }
	
	  function buildCarSearches(searches) {
	    var carSearches = [];
	
	    _.forEach(searches, function (search) {
	      if (search.isActive) {
	        carSearches.push({
	          DropOff: {
	            Code: search.car.dropOff.Location.Value,
	            Date: moment('' + search.car.dropOff.Date + search.car.dropOff.Time, '' + vm.displayDateFormat + vm.displayTimeFormat).format(vm.apiDateFormat),
	            Location: search.car.dropOff.Location.Name,
	            depot: {}
	          },
	          PickUp: {
	            Code: search.car.pickUp.Location.Value,
	            Date: moment('' + search.car.pickUp.Date + search.car.pickUp.Time, '' + vm.displayDateFormat + vm.displayTimeFormat).format(vm.apiDateFormat),
	            Location: search.car.pickUp.Location.Name,
	            depot: {}
	          }
	        });
	      }
	    });
	
	    return carSearches;
	  }
	
	  function close() {
	    lbModalService.reject();
	  }
	};
	
	lbTripOptionsModalCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsModalCtrl;
	module.exports = exports['default'];

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var momentFormat = {
	  DATE: 'ddd, MMM D YYYY',
	  DATE_TIME: 'ddd, MMM D YYYY [at] HH:mm',
	  API: 'YYYY-MM-DD[T]HH:mm:ss'
	};
	
	var message = {
	  CONTENT_WARNING: 'Your company will still be charged if booking is not Approved',
	  NO_POLICY_BREAK: 'Within Policy'
	};
	
	var api = {
	  root: '' + window.apiUrl,
	  url: window.apiUrl + 'api/',
	  sctApiUrl: window.sctApiUrl + 'api/',
	  iataSct: window.apiUrl + 'api/Itinerary/IataSearchSct',
	  citySearch: window.apiUrl + 'api/Location/city',
	  depotSearch: window.apiUrl + 'api/Car/depots',
	  car: window.apiUrl + 'api/car',
	  carDetails: window.apiUrl + 'api/car/detail',
	  hotels: window.apiUrl + 'api/hotel',
	  hotelPartial: window.apiUrl + 'api/HotelPartial',
	  hotelRates: window.apiUrl + 'api/hotel/rates',
	  hotelReviews: window.apiUrl + 'api/hotel/reviews',
	  hotelPolicy: window.apiUrl + 'api/Hotel/CheckPolicy',
	  token: window.apiUrl + 'Token',
	  flail: window.apiUrl + 'api/Rail/',
	  supplierLocations: window.apiUrl + 'api/supplierLocations/',
	  poi: window.apiUrl + 'api/PointOfInterest',
	  version: 18,
	  sctVersion: 1
	};
	
	var API = {
	  userActivity: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/activity';
	    }
	  },
	  userPeople: {
	    url: function url(slugs) {
	      return slugs.id ? window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/travellers/' + slugs.id : window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/travellers';
	    }
	  },
	  userProfile: {
	    url: window.sctApiUrl + 'api/v' + api.sctVersion + '/profile'
	  },
	  userDebtor: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId;
	    }
	  },
	  fareForecaster: {
	    url: window.apiUrl + 'api/fareforecaster'
	  },
	  costCentres: {
	    url: window.apiUrl + 'api/CostCentres'
	  },
	  department: {
	    url: window.apiUrl + 'api/Department'
	  },
	  departmentCode: {
	    url: window.apiUrl + 'api/Department/departmentCode'
	  },
	  settings: {
	    url: window.apiUrl + 'api/Setting'
	  },
	  travel: {
	    url: window.apiUrl + 'api/Travel/search'
	  },
	  travelDetail: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/Travel/' + slugs.travelId + '/' + slugs.type + '/details';
	    }
	  },
	  travelFareRules: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/Travel/' + slugs.travelId + '/' + slugs.type + '/fareclasses/' + slugs.fareId + '/farerules';
	    }
	  },
	  travelSeatMap: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/SeatMap/search';
	    }
	  },
	  flightInformation: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/FlightInformation/search';
	    }
	  },
	  debtorSearch: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/DebtorSearch';
	    }
	  },
	  locations: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/location/poi';
	    }
	  },
	  userInfo: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/UserInfo';
	    }
	  },
	  userInvite: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/invites';
	    }
	  },
	  userRegister: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/profile/register';
	    }
	  },
	  forgotPassword: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/resetpassword?email=' + encodeURIComponent(slugs.email);
	    }
	  },
	  resetPassword: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/resetpassword/' + slugs.token;
	    }
	  },
	  completeInvite: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/invites/' + slugs.token + '/complete';
	    }
	  },
	  userContact: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/support/getintouch?message=' + encodeURIComponent(slugs.message);
	    }
	  }
	};
	
	var version = {
	  number: window.lbVersion
	};
	
	var analytics = {
	  enabled: window.ANALYTICS_ENABLED,
	  trackingCode: window.ANALYTICS_CODE
	};
	
	var appInsights = {
	  enabled: window.APPINSIGHTS_ENABLED,
	  key: window.APPINSIGHTS_CODE
	};
	
	var client = {
	  id: window.CLIENT_ID,
	  secret: window.CLIENT_SECRET
	};
	
	var MVC = window.MVC;
	
	var DISABLE_SEATMAPS = window.DISABLE_SEATMAPS;
	var FARE_FORECASTER_ENABLED = window.FareForecasterEnabled;
	var TICKETS_ON_HOLD_ENABLED = window.TicketsOnHoldEnabled;
	var HOTEL_REVIEWS_ENABLED = window.HotelReviewsEnabled;
	var THE_VIBE_ENABLED = window.TheVibeEnabled;
	var RECENT_SEARCHES_ENABLED = window.RecentSearchesEnabled;
	var PREFERRED_FLAG_ENABLED = window.PreferredFlagEnabled;
	var ENABLE_ADD_TO_ITINERARY = window.EnableAddToItinerary;
	var MOBILE_SPLASH_SCREEN_ENABLED = window.MobileSplashScreenEnabled;
	
	exports['default'] = {
	  APP_NAME: window.APP_NAME,
	  analytics: analytics,
	  appInsights: appInsights,
	  version: version,
	  momentFormat: momentFormat,
	  message: message,
	  APP_URL: window.APP_URL,
	  api: api,
	  API: API,
	  client: client,
	  MVC: MVC,
	  DISABLE_SEATMAPS: DISABLE_SEATMAPS,
	  RECENT_SEARCHES_ENABLED: RECENT_SEARCHES_ENABLED,
	  FARE_FORECASTER_ENABLED: FARE_FORECASTER_ENABLED,
	  TICKETS_ON_HOLD_ENABLED: TICKETS_ON_HOLD_ENABLED,
	  HOTEL_REVIEWS_ENABLED: HOTEL_REVIEWS_ENABLED,
	  THE_VIBE_ENABLED: THE_VIBE_ENABLED,
	  PREFERRED_FLAG_ENABLED: PREFERRED_FLAG_ENABLED,
	  ENABLE_ADD_TO_ITINERARY: ENABLE_ADD_TO_ITINERARY,
	  MOBILE_SPLASH_SCREEN_ENABLED: MOBILE_SPLASH_SCREEN_ENABLED
	};
	module.exports = exports['default'];

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (app) {
	  var $inject = ['AnalyticsProvider', 'APP_CONFIG'];
	
	  var GAConfig = function GAConfig(AnalyticsProvider, APP_CONFIG) {
	    if (!APP_CONFIG.analytics.enabled) {
	      return false;
	    }
	
	    AnalyticsProvider.setAccount(APP_CONFIG.analytics.trackingCode);
	    //AnalyticsProvider.setPageEvent('$stateChangeSuccess');
	    AnalyticsProvider.trackPages(false);
	    AnalyticsProvider.useECommerce(true, false);
	
	    if (location.hostname === 'localhost') {
	      AnalyticsProvider.setDomainName('none');
	    }
	  };
	
	  GAConfig.$inject = $inject;
	
	  return GAConfig;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (app) {
	  var $inject = ['$httpProvider', 'APP_CONFIG'];
	
	  var HttpProviderConfig = function HttpProviderConfig($httpProvider, APP_CONFIG) {
	    $httpProvider.defaults.useXDomain = true;
	
	    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
	
	    $httpProvider.defaults.headers.common['X-api-version'] = APP_CONFIG.api.version;
	
	    delete $httpProvider.defaults.headers.common['X-Requested-With'];
	
	    $httpProvider.interceptors.push('requestInterceptor');
	  };
	
	  HttpProviderConfig.$inject = $inject;
	
	  return HttpProviderConfig;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var authConstants = {
	  loginSuccess: 'auth-login-success',
	  loginFailed: 'auth-login-failed',
	  logoutSuccess: 'auth-logout-success',
	  sessionTimeout: 'auth-session-timeout',
	  notAuthenticated: 'auth-not-authenticated',
	  notAuthorized: 'auth-not-authorized',
	  sctAuthSuccess: 'sct-auth-success'
	};
	
	exports['default'] = authConstants;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var enums = {
	  itineraryStatus: {
	    BOOKED: 'booked',
	    PARTIALLY_BOOKING: 'partial'
	  },
	  railSeatPreference: {
	    OPTIONAL: 'NR',
	    MANDATORY: 'SA',
	    AUTO: 'AA'
	  },
	  railSeatPreferenceTypes: {
	    POSITION: 'SeatReservationPosition',
	    DIRECTION: 'SeatReservationDirection',
	    COACH_TYPE: 'SeatReservationCoachType',
	    ATTRIBUTE: 'SeatReservationPreferenceAttribute'
	  }
	};
	
	exports['default'] = enums;
	module.exports = exports['default'];

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$timeout'];
	
	var focusOn = function focusOn($timeout) {
	  return {
	    restrict: 'A',
	    scope: {
	      focusOn: '<',
	      focusOnly: '@'
	    },
	    link: function link($scope, $element, $attr) {
	      $scope.$watch('focusOn', function (_focusVal) {
	        $timeout(function () {
	          if (_focusVal) {
	            $element[0].focus();
	          } else if (!$scope.focusOnly) {
	            $element[0].blur();
	          }
	        });
	      });
	    }
	  };
	};
	
	focusOn.$inject = $inject;
	
	exports['default'] = focusOn;
	module.exports = exports['default'];

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var inputMatch = function inputMatch() {
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ctrl) {
	      var firstPassword = '#' + attrs.inputMatch;
	      elem.add(firstPassword).on('keyup', function () {
	        scope.$apply(function () {
	          var v = elem.val() === $(firstPassword).val();
	          ctrl.$setValidity('inputMatch', v);
	        });
	      });
	    }
	  };
	};
	
	inputMatch.$inject = $inject;
	
	exports['default'] = inputMatch;
	module.exports = exports['default'];

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$document', '$window'];
	var clickOutside = function clickOutside($document, $window) {
	  return {
	    restrict: 'A',
	    scope: {
	      clickOutside: '&'
	    },
	    link: function link(scope, el) {
	      $document.on('click', eventHandler);
	
	      scope.$on('$destroy', function () {
	        $document.off('click', eventHandler);
	      });
	
	      function eventHandler(e) {
	        if (isHidden(el[0])) {
	          return false;
	        }
	
	        if (el !== e.target && !el[0].contains(e.target)) {
	          scope.$apply(function () {
	            scope.$eval(scope.clickOutside);
	          });
	        }
	      }
	
	      function isHidden(element) {
	        var style = $window.getComputedStyle(element);
	        return style.display === 'none';
	      }
	    }
	  };
	};
	
	clickOutside.$inject = $inject;
	
	exports['default'] = clickOutside;
	module.exports = exports['default'];

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	var lbFutureTime = function lbFutureTime(moment) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ngModel) {
	      var validate = function validate(viewValue) {
	        var dateCompare = attrs.dateCompare ? moment(attrs.dateCompare, 'DD MMM, YYYY').format('DD/MM/YYYY') : undefined;
	        var today = dateCompare || moment().add(0, 'day').format('DD/MM/YYYY');
	        var selectedDate = moment(attrs.lbFutureTime, 'DD MMM, YYYY').format('DD/MM/YYYY');
	        var timeFormat = attrs.timeFormat;
	        var inFuture = true;
	
	        if (today === selectedDate) {
	          var timeVal = viewValue.value || viewValue;
	          var selectedTime = parseInt(moment(timeVal, timeFormat).format('Hmm'));
	          var nowTime = 0;
	
	          if (attrs.timeCompare) {
	            nowTime = parseInt(moment(attrs.timeCompare, timeFormat).format('Hmm'));
	          } else {
	            nowTime = parseInt(moment().format('Hmm'));
	          }
	
	          inFuture = nowTime < selectedTime;
	        }
	
	        if (attrs.required) {
	          ngModel.$setValidity('lbFutureTime', inFuture);
	        } else {
	          ngModel.$setValidity('lbFutureTime', true);
	        }
	
	        return viewValue;
	      };
	
	      ngModel.$parsers.unshift(validate);
	      ngModel.$formatters.push(validate);
	
	      attrs.$observe('lbFutureTime', function () {
	        return validate(ngModel.$viewValue);
	      });
	
	      attrs.$observe('timeCompare', function () {
	        return validate(ngModel.$viewValue);
	      });
	
	      attrs.$observe('required', function () {
	        if (attrs.required === false) {
	          ngModel.$setValidity('lbFutureTime', true);
	          return ngModel.$viewValue;
	        } else {
	          return validate(ngModel.$viewValue);
	        }
	      });
	    }
	  };
	};
	
	lbFutureTime.$inject = $inject;
	
	exports['default'] = lbFutureTime;
	module.exports = exports['default'];

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	
	var lbSequentialTime = function lbSequentialTime(moment) {
	
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, ele, attrs, ctrl) {
	      var validatorName = 'isDateAfterPreviousDate';
	      var timeFormat = attrs.timeFormat;
	      var attrWatch = undefined;
	
	      attrs.$observe('lbSequentialTime', onEnabledChange);
	
	      function onEnabledChange(newValue) {
	        var isEnabled = newValue === 'true';
	
	        if (isEnabled) {
	          if (!attrWatch) {
	            attrWatch = scope.$watch(watchAttributes, validate, true);
	          }
	        } else {
	          if (angular.isFunction(attrWatch)) {
	            attrWatch();
	            attrWatch = undefined;
	          }
	
	          ctrl.$setValidity(validatorName, true);
	        }
	      }
	
	      function watchAttributes() {
	        return [attrs.lbSequentialTimeDate, ctrl.$viewValue.value, attrs.lbSequentialTimeBeforeDate, attrs.lbSequentialTimeBeforeTime];
	      }
	
	      function validate(attributes) {
	        var date = attributes[0];
	        var time = attributes[1];
	        var beforeDate = attributes[2];
	        var beforeTime = attributes[3];
	
	        var dateTime = moment(date + ', ' + time, 'ddd Do MMM, YYYY, ' + timeFormat);
	        var beforeDateTime = moment(beforeDate + ', ' + beforeTime, 'ddd Do MMM, YYYY, ' + timeFormat);
	
	        ctrl.$setValidity(validatorName, beforeDateTime.isBefore(dateTime));
	      }
	    }
	  };
	};
	
	lbSequentialTime.$inject = $inject;
	
	exports['default'] = lbSequentialTime;
	module.exports = exports['default'];

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTooltip = angular.module('app.lbTooltip', []);
	
	lbTooltip.controller('lbTooltipController', __webpack_require__(514));
	lbTooltip.directive('lbTooltip', __webpack_require__(515));
	
	exports['default'] = lbTooltip;
	module.exports = exports['default'];

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var lbTooltipController = function lbTooltipController() {
	  var vm = this;
	};
	
	lbTooltipController.$inject = $inject;
	
	exports["default"] = lbTooltipController;
	module.exports = exports["default"];

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(916);
	
	var $inject = ['$sanitize'];
	
	var lbTooltip = function lbTooltip($sanitize) {
	  return {
	    controller: 'lbTooltipController',
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      tooltipContent: '=',
	      tooltipContentFunc: '=',
	      tooltipLoadingText: '=',
	      tooltipClass: '@',
	      tooltipWidth: '@?',
	      tooltipInline: '=?'
	    },
	    link: function link(scope, element) {
	
	      if (!scope.vm.tooltipContent && !scope.vm.tooltipContentFunc) {
	        return false;
	      }
	
	      scope.el = element[0];
	      scope.tooltip = document.createElement('div');
	      scope.$tooltip = angular.element(scope.tooltip);
	      scope.$tooltip.addClass(scope.vm.tooltipClass || 'tooltip');
	      scope.isAsync = !!scope.vm.tooltipContentFunc;
	      scope.isInline = !!scope.vm.tooltipInline;
	      scope.tooltipWidth = scope.vm.tooltipWidth || 200;
	
	      if (scope.isInline) {
	        element.wrap('<div class="tooltipWrap"></div>');
	        scope.wrap = element.parent();
	      }
	
	      if (scope.tooltipClass) {
	        scope.$tooltip.addClass(scope.tooltipClass);
	      }
	
	      scope.$on('$destroy', function handleDestroyEvent() {
	        scope.el.removeEventListener('mouseenter', handleMouseEnter);
	        scope.el.removeEventListener('mouseleave', handleMouseLeave);
	        scope.$tooltip.remove();
	      });
	
	      scope.el.addEventListener('mouseenter', handleMouseEnter);
	      scope.el.addEventListener('mouseleave', handleMouseLeave);
	
	      function buildTooltip() {
	        var elDimensions = scope.el.getBoundingClientRect();
	        var elPos = getPosition(scope.el);
	        var leftOffset = elDimensions.width / 2;
	
	        if (scope.isInline) {
	          scope.docfrag = document.createDocumentFragment();
	          scope.docfrag.appendChild(scope.tooltip);
	
	          scope.$tooltip.css({
	            bottom: elDimensions.height + 'px',
	            left: elDimensions.width / 2 + 'px'
	          });
	        } else {
	          scope.$tooltip.css({
	            bottom: elPos.bottom + 'px',
	            left: elPos.left + leftOffset + 'px',
	            width: scope.tooltipWidth + 'px'
	          });
	        }
	
	        if (!scope.isAsync) {
	          scope.tooltip.innerHTML = $sanitize(scope.vm.tooltipContent);
	        } else {
	          scope.tooltip.innerHTML = '<span class="tooltip-loading">' + (scope.vm.tooltipLoadingText || 'Loading...') + '</span>';
	        }
	
	        if (!scope.tooltipCached && scope.isAsync) {
	          scope.$tooltip.addClass('loading');
	
	          scope.vm.tooltipContentFunc().then(function (data) {
	            scope.tooltipCached = true;
	            scope.tooltip.innerHTML = $sanitize(data);
	            scope.data = data;
	            scope.$tooltip.removeClass('loading');
	          });
	        } else if (scope.isAsync) {
	          scope.tooltip.innerHTML = scope.data;
	        }
	
	        if (scope.isInline) {
	          scope.wrap.append(scope.docfrag);
	        } else {
	          document.body.appendChild(scope.tooltip);
	        }
	      }
	
	      function getPosition(el) {
	        var xPos = 0;
	        var yPos = 0;
	
	        while (el) {
	          xPos += el.offsetLeft + el.clientLeft;
	          yPos += el.offsetTop + el.clientTop;
	
	          el = el.offsetParent;
	        }
	
	        return {
	          left: xPos,
	          top: yPos,
	          bottom: document.body.offsetHeight - yPos
	        };
	      }
	
	      function removeTooltip() {
	        scope.$tooltip.removeClass('open');
	        scope.$tooltip.remove();
	      }
	
	      function handleMouseEnter() {
	        buildTooltip();
	      }
	
	      function handleMouseLeave() {
	        removeTooltip();
	      }
	    }
	  };
	};
	
	lbTooltip.$inject = $inject;
	
	exports['default'] = lbTooltip;
	module.exports = exports['default'];

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$log', 'appInsightsService', 'APP_CONFIG'];
	
	var exceptionHandler = function exceptionHandler($log, appInsightsService, APP_CONFIG) {
	  return function errorCatcherHandler(exception, cause) {
	    $log.error(exception);
	
	    if (APP_CONFIG.appInsights.enabled) {
	      appInsightsService.trackError(exception);
	    }
	  };
	};
	
	exceptionHandler.$inject = $inject;
	
	exports['default'] = exceptionHandler;
	module.exports = exports['default'];

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$injector', '$rootScope', '$window', 'currentUserService', 'AUTH_EVENTS', 'APP_CONFIG'];
	
	var requestInterceptor = function requestInterceptor($q, $injector, $rootScope, $window, currentUserService, AUTH_EVENTS, APP_CONFIG) {
	  var factory = {};
	  factory.request = request;
	  factory.response = response;
	  factory.responseError = responseError;
	
	  var inFlightAuthRequest = null;
	
	  function isAPI(url) {
	    return url.startsWith(APP_CONFIG.api.url) || url.startsWith(APP_CONFIG.api.sctApiUrl);
	  }
	
	  function request(config) {
	    if (config.params) {
	      (function () {
	        var keys = ['q', 'query', 'departmentCode', 'term'];
	        var reg = /[^A-Za-z '@,\-.0-9]+/g;
	
	        Object.keys(config.params).forEach(function (key) {
	          if (keys.includes(key)) config.params[key] = config.params[key].replace(reg, '');
	        });
	      })();
	    }
	
	    var authService = $injector.get('authService');
	    var accessToken = authService.getAccessToken();
	
	    if (isAPI(config.url)) {
	      if (!config.isPublic) {
	        if (accessToken) {
	          config.headers.Authorization = 'Bearer ' + accessToken;
	        } else {
	          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	        }
	      }
	
	      var debtor = currentUserService.get('debtor');
	
	      var activeConsultantDebtor = localStorage.getItem('activeDebtor');
	
	      if (debtor) {
	        config.headers['X-Api-Debtor'] = debtor.Name;
	      }
	
	      if ($rootScope.enableDebug) {
	        config.headers['X-Api-Enable-Debug'] = true;
	      }
	
	      if (config.apiVersion) {
	        config.headers['X-api-version'] = config.apiVersion;
	      }
	
	      if (activeConsultantDebtor) {
	        config.headers['X-Api-Debtor'] = activeConsultantDebtor;
	      }
	    }
	
	    return config;
	  }
	
	  function response(response) {
	    if (isAPI(response.config.url)) {
	      var headers = response.headers();
	      var debugActivityId = headers['x-api-debug-activityid'];
	
	      if (debugActivityId) {
	        $window.LB_DEBUG = $window.LB_DEBUG || [];
	        $window.LB_DEBUG.push({
	          activityId: debugActivityId,
	          requestUrl: response.config.url,
	          responseTime: new Date(Date.now()).toString()
	        });
	      }
	    }
	
	    return response;
	  }
	
	  function responseError(rejection) {
	    var deferred = $q.defer();
	
	    if (rejection.status === 401) {
	      (function () {
	        var authService = $injector.get('authService');
	        var refreshToken = authService.getRefreshToken();
	
	        if (refreshToken) {
	          if (!inFlightAuthRequest) {
	            inFlightAuthRequest = authService.refresh(refreshToken);
	          }
	
	          inFlightAuthRequest.then(function () {
	            inFlightAuthRequest = null;
	            var $http = $injector.get('$http');
	            return deferred.resolve($http(rejection.config));
	          }, function () {
	            inFlightAuthRequest = null;
	
	            authService.logout().then(function () {
	              $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
	            });
	          });
	        } else {
	          $rootScope.showLoader = false;
	          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	        }
	      })();
	    }
	
	    if (rejection.status >= 500 || rejection.status === 417) {
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection
	      });
	
	      /*
	      TRY AGAIN:
	      const $http = $injector.get('$http');
	      deferred.resolve($http(rejection.config));
	      */
	    }
	
	    if (rejection.status === 412) {
	      var newRejection = _.extend({}, rejection, {
	        data: {
	          Message: 'Sorry, another admin has made a change',
	          Instructions: 'To avoid conflicting changes we\'re going to fetch the latest configuration and refresh your browser.'
	        }
	      });
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: newRejection,
	        warnLevel: 'info'
	      }, function () {
	        $window.location.reload();
	      });
	
	      rejection.data.errorIntercepted = true;
	    }
	
	    if (rejection.status === 422) {
	      rejection.data = {
	        OriginalMessage: rejection.data,
	        Message: 'We were unable to update your cart',
	        Instructions: 'Please refresh your browser and try again.'
	      };
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection,
	        warnLevel: 'info'
	      });
	    }
	
	    if (rejection.status === 400) {
	      rejection.data = {
	        OriginalMessage: rejection.data,
	        Message: 'There was a problem with your request.',
	        Instructions: rejection.data.Message
	      };
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection,
	        warnLevel: 'info'
	      });
	    }
	
	    if (rejection.status === 404) {
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection
	      });
	
	      $rootScope.$emit('404Error');
	    }
	
	    return $q.reject(rejection);
	  }
	
	  return factory;
	};
	
	requestInterceptor.$inject = $inject;
	
	exports['default'] = requestInterceptor;
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['ENUMS'];
	
	var ancillaryServicesAmountsFilter = function ancillaryServicesAmountsFilter(ENUMS) {
	  return function (ancillaryServices) {
	    return _.filter(ancillaryServices, function (service) {
	      return service.QuantitySelected > 0 && !_.findKey(ENUMS.railSeatPreferenceTypes, function (preferenceType) {
	        return preferenceType === service.Type;
	      });
	    });
	  };
	};
	
	ancillaryServicesAmountsFilter.$inject = $inject;
	
	exports['default'] = ancillaryServicesAmountsFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var checkinInfoFilter = function checkinInfoFilter() {
	  return function (str) {
	    return str ? _.compact(str.split('\r\n')) : [];
	  };
	};
	
	checkinInfoFilter.$inject = $inject;
	
	exports['default'] = checkinInfoFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var creditCardNumberFilter = function creditCardNumberFilter() {
	  return function (cardNumber) {
	    cardNumber = cardNumber.toString();
	    var cardNumbers = cardNumber.split('');
	    var formattedNumber = '';
	
	    cardNumbers.forEach(function (number, numberIndex) {
	      if (numberIndex !== 0 && numberIndex % 4 === 0) {
	        formattedNumber += '  ';
	      }
	
	      formattedNumber += number;
	    });
	
	    return formattedNumber;
	  };
	};
	
	creditCardNumberFilter.$inject = $inject;
	
	exports['default'] = creditCardNumberFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var deepCopyFilter = function deepCopyFilter() {
	  return deepCopy;
	
	  function deepCopy(o) {
	    if (typeof o !== 'object' || o === null) return o;
	    var newO = undefined,
	        i = undefined;
	
	    if (o instanceof Array) {
	      var l = undefined;
	      newO = [];
	      for (i = 0, l = o.length; i < l; i++) newO[i] = deepCopy(o[i]);
	      return newO;
	    }
	
	    newO = {};
	    for (i in o) if (o.hasOwnProperty(i)) newO[i] = deepCopy(o[i]);
	
	    return newO;
	  }
	};
	
	deepCopyFilter.$inject = $inject;
	
	exports['default'] = deepCopyFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['settingsService'];
	
	var distanceFilter = function distanceFilter(settingsService) {
	  return function (distance) {
	    var isImperial = settingsService.settings.IsImperialSystem;
	    var unit = isImperial ? 'mi' : 'km';
	    var rounding = 2;
	
	    if (distance < 1 && !isImperial) {
	      var metresInKm = 1000;
	      distance *= metresInKm;
	      unit = 'm';
	      rounding = 0;
	    }
	
	    distance = _.round(distance, rounding);
	
	    return distance + ' ' + unit;
	  };
	};
	
	distanceFilter.$inject = $inject;
	
	exports['default'] = distanceFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter'];
	
	var genericSortingFilter = function genericSortingFilter($filter) {
	  return function (collection, expression) {
	    return $filter('orderBy')(collection, expression);
	  };
	};
	
	genericSortingFilter.$inject = $inject;
	
	exports['default'] = genericSortingFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var hotelProviderBrandFilter = function hotelProviderBrandFilter() {
	  return function (room) {
	    if (room.Rates[0].RateSourceName === 'BookingDotCom') return 'BKG';
	    if (room.Rates[0].RateSourceCode === '110') return 'EXP';
	    if (room.Rates[0].IsUnlimitedAllotment) return 'REQ';
	
	    var brand = room.Provider.Brand;
	    var brandParents = {
	      CON: 'CTM'
	    };
	
	    return brandParents[brand] || brand;
	  };
	};
	
	hotelProviderBrandFilter.$inject = $inject;
	
	exports['default'] = hotelProviderBrandFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var keyToLabelFilter = function keyToLabelFilter() {
	  return function (s) {
	    return _.startCase(s);
	  };
	};
	
	keyToLabelFilter.$inject = $inject;
	
	exports["default"] = keyToLabelFilter;
	module.exports = exports["default"];

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var locationIconFilter = function locationIconFilter() {
	  return function (type) {
	    switch (type) {
	      case 'Airport':
	        return 'ico-flight';
	        break;
	
	      case 'RailStation':
	        return 'ico-rail';
	        break;
	
	      case 'PointOfInterest':
	        return 'ico-ic-poi0';
	        break;
	
	      case 'Hotel':
	        return 'ico-hotel0';
	        break;
	
	      default:
	        return 'ico-marker';
	        break;
	    }
	  };
	};
	
	locationIconFilter.$inject = $inject;
	
	exports['default'] = locationIconFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var noValueFilter = function noValueFilter() {
	  return function (input, char) {
	    return input || char;
	  };
	};
	
	noValueFilter.$inject = $inject;
	
	exports["default"] = noValueFilter;
	module.exports = exports["default"];

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var zeroPaddingFilter = function zeroPaddingFilter() {
	  return function (input, char, n) {
	    if (input === undefined) {
	      input = '';
	    }
	
	    return _.padStart(input, n, char);
	  };
	};
	
	zeroPaddingFilter.$inject = $inject;
	
	exports['default'] = zeroPaddingFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var priceWithOperatorFilter = function priceWithOperatorFilter() {
	  return function (amount) {
	    var fractionSize = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	    var append = amount < 0 ? '-' : '+';
	    var price = amount.toFixed(fractionSize);
	
	    return '' + append + price;
	  };
	};
	
	priceWithOperatorFilter.$inject = $inject;
	
	exports['default'] = priceWithOperatorFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var secondsToTimeFilter = function secondsToTimeFilter() {
	  return function (seconds) {
	    if (typeof seconds !== 'number' || seconds < 0) {
	      return '1 mins';
	    }
	
	    var hours = Math.floor(seconds / 3600);
	    var mins = Math.ceil(seconds % 3600 / 60);
	    var times = [];
	
	    if (hours) {
	      times.push(hours + ' h');
	    }
	
	    if (mins) {
	      times.push(mins + ' min');
	    }
	
	    if (times.length === 0) {
	      times.push('1 min');
	    }
	
	    return times.join(' ');
	  };
	};
	
	secondsToTimeFilter.$inject = $inject;
	
	exports['default'] = secondsToTimeFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var sectorGroupsFilter = function sectorGroupsFilter() {
	  return function (paymentMethods, group) {
	    if (group === 'All') {
	      return paymentMethods;
	    }
	
	    return _.filter(paymentMethods, function (paymentMethod) {
	      return paymentMethod.SegmentTypes.indexOf(group) > -1;
	    });
	  };
	};
	
	sectorGroupsFilter.$inject = $inject;
	
	exports['default'] = sectorGroupsFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var startCaseFilter = function startCaseFilter() {
	  return function (string) {
	    return _.startCase(string);
	  };
	};
	
	exports["default"] = {
	  startCaseFilter: startCaseFilter
	};
	module.exports = exports["default"];

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var toAddressFilter = function toAddressFilter() {
	  return function (addressObject) {
	    if (!addressObject) {
	      return '';
	    }
	
	    var addressFields = [];
	
	    if (addressObject.Address) {
	      addressFields.push(addressObject.Address);
	    }
	
	    if (addressObject.City) {
	      addressFields.push(addressObject.City);
	    }
	
	    if (addressObject.State) {
	      addressFields.push(addressObject.State);
	    }
	
	    if (addressObject.Country && addressObject.Country.Name) {
	      addressFields.push(addressObject.Country.Name);
	
	      if (addressObject.Postcode) {
	        addressFields[addressFields.length - 1] = addressFields[addressFields.length - 1] + ' ' + addressObject.Postcode;
	      }
	    } else if (addressObject.Postcode) {
	      addressFields.push(addressObject.Postcode);
	    }
	
	    return addressFields.join(', ');
	  };
	};
	
	toAddressFilter.$inject = $inject;
	
	exports['default'] = toAddressFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var route = function route(resolve) {
	  return {
	    async: ['$q', function ($q) {
	      var defer = $q.defer();
	
	      resolve(defer.resolve);
	
	      return defer.promise;
	    }]
	  };
	};
	
	exports['default'] = function (app) {
	  var $inject = ['$urlRouterProvider', '$stateProvider'];
	
	  var BaseRoutes = function BaseRoutes($urlRouterProvider, $stateProvider) {
	    $urlRouterProvider.when('', '/');
	    $urlRouterProvider.when('/', '/search');
	    $urlRouterProvider.when("/my-bookings", "/manage-bookings");
	    $urlRouterProvider.when("/my-bookings/:itineraryId/:passengerId", "/manage-bookings/:itineraryId/:passengerId");
	
	    $urlRouterProvider.otherwise(function ($injector) {
	      var $state = $injector.get('$state');
	      $state.go('app.error', {}, { location: false });
	    });
	
	    $stateProvider.state('app', {
	      url: '',
	      abstract: true,
	      template: '<ui-view/>',
	      params: {
	        settingsRequired: true,
	        registrationRequired: true,
	        userInfoRequired: true
	      }
	    }).state('app.home', {
	      url: '',
	      abstract: true,
	      template: '<lb-home></lb-home>',
	      resolve: Object.assign({}, route(function (callback) {
	        return __webpack_require__.e/* nsure */(1, function () {
	          var lbHome = __webpack_require__(53).name;
	          callback(app.register(lbHome));
	        });
	      })),
	      params: {
	        allowNoSettingsForConsultant: true
	      }
	    }).state('app.home.manage', {
	      url: '/manage-bookings',
	      template: '<lb-my-bookings ng-class="{\'sct-awaiting-validation\' : vm.sctAwaitingValidation}"></lb-my-bookings>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(14, function () {
	          window.svelteStore.userDebtor.set(JSON.parse(sessionStorage.getItem('CURRENT_USER_debtor')));
	          window.svelteStore.userInfo.set(JSON.parse(sessionStorage.getItem('CURRENT_USER_userInfo')));
	
	          var component = __webpack_require__(337).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Manage Bookings',
	        bodyClass: 'bg-myBookings'
	      }
	    }).state('app.booking', {
	      url: '',
	      abstract: true,
	      template: '<lb-booking></lb-booking>',
	      resolve: Object.assign({}, route(function (callback) {
	        return __webpack_require__.e/* nsure */(8, function () {
	          var component = __webpack_require__(189).name;
	          callback(app.register(component));
	        });
	      })),
	      params: {
	        searchRequired: true
	      }
	    }).state('app.booking.flights', {
	      url: '/flights',
	      template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Search Results - Flights',
	        bodyClass: 'bg-flights',
	        searchRequired: true
	      }
	    }).state('app.booking.flights2', {
	      url: '/flights/{id}',
	      controller: ['$state', function ($state) {
	        window.svelteStore.setItineraryId('search', $state.params.id);
	        $state.go('app.booking.flights');
	      }]
	    }).state('app.booking.rail', {
	      url: '/rail',
	      template: '<lb-search-results search-type="\'Rail\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Search Results - Rail',
	        bodyClass: 'bg-rail',
	        searchRequired: true
	      }
	    }).state('app.booking.rail2', {
	      url: '/rail/{id}',
	      controller: ['$state', function ($state) {
	        window.svelteStore.setItineraryId('search', $state.params.id);
	        $state.go('app.booking.rail');
	      }]
	    }).state('app.booking.cars', {
	      url: '/cars',
	      template: '<lb-search-results search-type="\'Cars\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Search Results - Cars',
	        bodyClass: 'bg-cars',
	        searchRequired: true
	      }
	    }).state('app.booking.cars2', {
	      url: '/cars/{id}',
	      controller: ['$state', function ($state) {
	        window.svelteStore.setItineraryId('search', $state.params.id);
	        $state.go('app.booking.cars');
	      }]
	    }).state('app.bookingConfirmation', {
	      url: '/confirmation',
	      template: '<lb-booking-confirmation></lb-booking-confirmation>',
	      resolve: Object.assign({}, route(function (callback) {
	        return __webpack_require__.e/* nsure */(7, function () {
	          var lbBookingConfirmation = __webpack_require__(191).name;
	          callback(app.register(lbBookingConfirmation));
	        });
	      })),
	      params: {
	        pageTitle: 'Booking Confirmation',
	        bodyClass: 'bg-bookingConfirmation',
	        searchRequired: false
	      }
	    }).state('app.booking.hotels', {
	      url: '/hotels',
	      template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Search Results - Hotels',
	        bodyClass: 'bg-hotels'
	      }
	    }).state('app.booking.hotels2', {
	      url: '/hotels/{id}',
	      controller: ['$state', function ($state) {
	        window.svelteStore.setItineraryId('search', $state.params.id);
	        $state.go('app.booking.hotels');
	      }]
	    }).state('app.home.viewBooking', {
	      url: '/manage-bookings/{pnr:[0-9A-Z]{6}}',
	      template: '<lb-view-booking></lb-view-booking>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(13, function () {
	          var component = __webpack_require__(340).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Manage Bookings - view details'
	      }
	    }).state('app.itinerary', {
	      url: '/itinerary',
	      template: '<lb-itinerary></lb-itinerary>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(3, function () {
	          var lbItinerary = __webpack_require__(146).name;
	          callback(app.register(lbItinerary));
	        });
	      }),
	      params: {
	        pageTitle: 'Itinerary',
	        bodyClass: 'section-itinerary',
	        isRedirect: false
	      }
	    }).state('app.itinerary2', {
	      url: '/itinerary/{id}',
	      controller: ['$state', function ($state) {
	        window.svelteStore.setItineraryId('search', $state.params.id);
	        $state.go('app.itinerary');
	      }]
	    }).state('app.seatmaps', {
	      url: '/seatmaps/{itineraryId}/{paxId}',
	      template: '<lb-seat-maps></lb-seat-maps>',
	      resolve: {
	        route: ['$q', function ($q) {
	          var deferred = $q.defer();
	
	          __webpack_require__.e/* nsure */(6, function () {
	            var lbSeatMaps = __webpack_require__(437).name;
	            deferred.resolve(app.register(lbSeatMaps));
	          });
	
	          return deferred.promise;
	        }],
	        setActivePax: ['$q', '$stateParams', 'stateResolveService', function ($q, $stateParams, stateResolveService) {
	          var deferred = $q.defer();
	          return stateResolveService.setActivePax($stateParams, deferred);
	        }]
	      },
	      params: {
	        pageTitle: 'Seat Maps',
	        bodyClass: 'bg-seat-maps',
	        isRedirect: false
	      }
	    }).state('app.seatmaps.map', {
	      url: '/{activePaxId}/{flightId}/{transportIndex}',
	      template: '<lb-seat-map-container></lb-seat-map-container>',
	      resolve: {
	        route: ['$q', function ($q) {
	          var deferred = $q.defer();
	
	          __webpack_require__.e/* nsure */(5, function () {
	            var lbSeatMapContainer = __webpack_require__(434).name;
	            deferred.resolve(app.register(lbSeatMapContainer));
	          });
	
	          return deferred.promise;
	        }],
	        setActiveSeatMap: ['$q', '$stateParams', 'setActivePax', 'stateResolveService', function ($q, $stateParams, setActivePax, stateResolveService) {
	          var deferred = $q.defer();
	          return stateResolveService.setActiveSeatMap($stateParams, deferred);
	        }]
	      },
	      params: {
	        pageTitle: 'Seat Maps - View Map',
	        bodyClass: 'bg-seat-maps',
	        isRedirect: false
	      }
	    }).state('app.transfers', {
	      url: '/airport-transfers/{itineraryId}',
	      template: '<lb-airport-transfers></lb-airport-transfers>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(12, function () {
	          var component = __webpack_require__(185).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Airport Transfers'
	      }
	    }).state('app.taxis', {
	      url: '/taxis/{itineraryId}/{pnr}',
	      template: '<lb-taxis></lb-taxis>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(10, function () {
	          var component = __webpack_require__(386).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Taxis'
	      }
	    }).state('app.taxis-confirm', {
	      url: '/taxis/{itineraryId}/{pnr}/{taxiId}/confirmation',
	      template: '<lb-taxis-confirmation></lb-taxis-confirmation>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(9, function () {
	          var component = __webpack_require__(389).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Taxis'
	      }
	    });
	  };
	
	  BaseRoutes.$inject = $inject;
	
	  return BaseRoutes;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var route = function route(resolve) {
	  return {
	    async: ['$q', function ($q) {
	      var defer = $q.defer();
	
	      resolve(defer.resolve);
	
	      return defer.promise;
	    }]
	  };
	};
	
	exports['default'] = function (app) {
	  var $inject = ['$urlRouterProvider', '$stateProvider'];
	
	  var LbRoutes = function LbRoutes($urlRouterProvider, $stateProvider) {
	
	    $urlRouterProvider.otherwise(function ($injector) {
	      var $state = $injector.get('$state');
	      $state.go('app.error', {}, { location: false });
	    });
	
	    $stateProvider.state('authenticate', {
	      url: '/authenticate',
	      template: '<lb-authenticate></lb-authenticate>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(19, function () {
	          var lbAuthenticate = __webpack_require__(188).name;
	          callback(app.register(lbAuthenticate));
	        });
	      }),
	      params: {
	        isPublic: true,
	        pageTitle: 'Authenticate',
	        bodyClass: 'bg-login'
	      }
	    }).state('landing', {
	      abstract: true,
	      template: '<ui-view></ui-view>',
	      params: {
	        isPublic: true
	      },
	      onEnter: ['authService', function (authService) {
	        sessionStorage.clear();
	      }]
	    }).state('landing.login', {
	      url: '/login',
	      template: '<lb-login></lb-login>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(15, function () {
	          var lbLogin = __webpack_require__(331).name;
	          callback(app.register(lbLogin));
	        });
	      }),
	      params: {
	        pageTitle: 'Login',
	        bodyClass: 'bg-login'
	      }
	    }).state('deeplink', {
	      url: '/deep-link',
	      template: '<lb-deep-link></lb-deep-link>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(22, function () {
	          var lbDeepLink = __webpack_require__(270).name;
	          callback(app.register(lbDeepLink));
	        });
	      }),
	      params: {
	        isPublic: true
	      }
	    }).state('mobileauth', {
	      url: '/mobile-auth',
	      template: '<lb-mobile-auth></lb-mobile-auth>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(20, function () {
	          var lbMobileAuth = __webpack_require__(343).name;
	          callback(app.register(lbMobileAuth));
	        });
	      }),
	      params: {
	        isPublic: true
	      }
	    }).state('loggedout', {
	      url: '/logged-out',
	      template: '<lb-logged-out></lb-logged-out>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(21, function () {
	          var lbLoggedOut = __webpack_require__(328).name;
	          callback(app.register(lbLoggedOut));
	        });
	      }),
	      params: {
	        isPublic: true
	      }
	    }).state('app.error', {
	      url: '/error',
	      template: '<lb-error-screen></lb-error-screen>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(11, function () {
	          var lbErrorScreen = __webpack_require__(280).name;
	          callback(app.register(lbErrorScreen));
	        });
	      }),
	      params: {
	        pageTitle: 'Page not found',
	        bodyClass: 'bg-error',
	        prev: null
	      }
	    }).state('app.home.search', {
	      url: '/search',
	      template: '<lb-home-search></lb-home-search>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(4, function () {
	          var component = __webpack_require__(312).name;
	          callback(app.register(component));
	        });
	      }),
	
	      params: {
	        pageTitle: 'New Search',
	        bodyClass: 'bg-search'
	      }
	    }).state('app.booking.error', {
	      url: '/booking-error',
	      template: '<lb-nav></lb-nav><lb-booking-error></lb-booking-error>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(23, function () {
	          var lbBookingError = __webpack_require__(194).name;
	          callback(app.register(lbBookingError));
	        });
	      }),
	      params: {
	        pageTitle: 'Booking Error'
	      }
	    }).state('app.booking.change', {
	      abstract: true,
	      template: '<ui-view></ui-view>'
	    }).state('app.booking.change.flights', {
	      url: '/manage-bookings/flights',
	      template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Manage Bookings - change flights results',
	        bodyClass: 'bg-flights',
	        searchRequired: true
	      }
	    }).state('app.booking.change.hotels', {
	      url: '/manage-bookings/hotels/{hotelId}',
	      template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	          var lbSearchResults = __webpack_require__(8).name;
	          callback(app.register(lbSearchResults));
	        });
	      }),
	      params: {
	        pageTitle: 'Manage Bookings - change hotels results',
	        bodyClass: 'bg-hotels',
	        searchRequired: true
	      }
	    }).state('app.change', {
	      url: '',
	      abstract: true,
	      template: '<lb-home></lb-home>',
	      resolve: Object.assign({}, route(function (callback) {
	        return __webpack_require__.e/* nsure */(1/* duplicate */, function () {
	          var lbHome = __webpack_require__(53).name;
	          callback(app.register(lbHome));
	        });
	      }))
	    }).state('app.change.booking', {
	      url: '/manage-bookings/{pnr:[0-9A-Z]{6}}/change',
	      template: '<lb-change-booking></lb-change-booking>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(18, function () {
	          var component = __webpack_require__(242).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Change Booking'
	      }
	    }).state('app.change.sector', {
	      url: '/manage-bookings/{pnr:[0-9A-Z]{6}}/change/{sector}',
	      template: '<lb-change-booking-wizard></lb-change-booking-wizard>',
	      resolve: route(function (callback) {
	        return __webpack_require__.e/* nsure */(17, function () {
	          var component = __webpack_require__(245).name;
	          callback(app.register(component));
	        });
	      }),
	      params: {
	        pageTitle: 'Change Booking'
	      }
	    }).state('app.change.payment', {
	      url: '/manage-bookings/change/payment',
	      template: '<lb-change-payment></lb-change-payment>',
	      resolve: Object.assign({}, route(function (callback) {
	        return __webpack_require__.e/* nsure */(16, function () {
	          var component = __webpack_require__(249).name;
	          callback(app.register(component));
	        });
	      }), {
	        hasItineraryId: ['$q', function ($q) {
	          var deferred = $q.defer();
	
	          var itineraryId = sessionStorage.getItem('change:itineraryId');
	          if (itineraryId) {
	            deferred.resolve(itineraryId);
	          } else {
	            deferred.reject();
	          }
	
	          return deferred.promise;
	        }]
	      }),
	      params: {
	        pageTitle: 'Changed booking payment'
	      }
	    });
	
	    // .state('app.home.slipstream', {
	    //   url: '/slipstream',
	    //   template: '<lb-slipstream></lb-slipstream>',
	    //   resolve: route(callback =>
	    //     require.ensure([], () => {
	    //         const component = require('../components/lbSlipstream').name;
	    //         callback(app.register(component))
	    //       }
	    //     )
	    //   ),
	    //   params: {
	    //     pageTitle: 'Slipstream'
	    //   }
	    // });
	  };
	
	  LbRoutes.$inject = $inject;
	
	  return LbRoutes;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['APP_CONFIG'];
	
	var apiService = function apiService(APP_CONFIG) {
	  var service = {
	    getUrl: getUrl
	  };
	
	  return service;
	
	  function getUrl(name, slugs) {
	    return getFullUrl(APP_CONFIG.API[name].url, slugs);
	  }
	
	  function getFullUrl(apiUrl, slugs) {
	    if (_.isFunction(apiUrl)) {
	      return apiUrl(slugs);
	    }
	
	    return apiUrl;
	  }
	};
	
	apiService.$inject = $inject;
	
	exports['default'] = apiService;
	module.exports = exports['default'];

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var appInsightsService = function appInsightsService() {
	  var service = {};
	
	  service.trackPageView = trackPageView;
	  service.trackEvent = trackEvent;
	  service.trackError = trackError;
	
	  function trackPageView(pageName) {
	    appInsights.trackPageView(pageName);
	  }
	
	  function trackEvent(event, data) {
	    appInsights.trackEvent(event, data);
	  }
	
	  function trackError(error) {
	    appInsights.trackException(error);
	  }
	
	  return service;
	};
	
	appInsightsService.$inject = $inject;
	
	exports["default"] = appInsightsService;
	module.exports = exports["default"];

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$window', '$q', '$http', '$cookies', '$httpParamSerializer', 'moment', 'settingsService', 'userProfileService', 'userDebtorService', 'apiService', 'currentUserService', 'travellersService', 'APP_CONFIG'];
	
	var authService = function authService($window, $q, $http, $cookies, $httpParamSerializer, moment, settingsService, userProfileService, userDebtorService, apiService, currentUserService, travellersService, APP_CONFIG) {
	
	  var service = {};
	
	  service.logout = logout;
	  service.refresh = refresh;
	  service.reset = reset;
	  service.forgot = forgot;
	  service.storeAuth = storeAuth;
	  service.getOauth = getOauth;
	  service.clearOauth = clearOauth;
	  service.getAccessToken = getAccessToken;
	  service.getRefreshToken = getRefreshToken;
	  service.isAuthenticated = isAuthenticated;
	
	  function logout() {
	    var allUsers = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    var deferred = $q.defer();
	
	    localStorage.clear();
	    if (allUsers) localStorage.setItem('SIGN_OUT_ALL_USERS', true);
	
	    clearOauth();
	    currentUserService.clear();
	    settingsService.clear();
	    userProfileService.clear();
	    userDebtorService.clear();
	    travellersService.init();
	    window.svelteStore.logout();
	
	    $window.MIXPANEL_ENABLED && $window.mixpanel.reset();
	
	    deferred.resolve();
	
	    return deferred.promise;
	  }
	
	  function refresh(accessToken) {
	    try {
	      var data = {
	        client_id: APP_CONFIG.client.id,
	        client_secret: APP_CONFIG.client.secret,
	        grant_type: 'refresh_token',
	        refresh_token: accessToken
	      };
	
	      var req = {
	        method: 'POST',
	        url: APP_CONFIG.api.token,
	        headers: {
	          'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	        },
	        data: $httpParamSerializer(data)
	      };
	
	      return $http(req).then(function (res) {
	        var data = res.data;
	        var oauth = {};
	        oauth.refresh_token = data.refresh_token;
	        oauth.access_token = data.access_token;
	
	        localStorage.setItem('oauth', JSON.stringify(oauth));
	        sessionStorage.removeItem('reloadAttempted');
	      });
	    } catch (err) {
	      var reloadAttempted = sessionStorage.getItem('reloadAttempted');
	      if (reloadAttempted) return;
	      sessionStorage.setItem('reloadAttempted', true);
	      console.warn(err);
	      location.reload();
	    }
	  }
	
	  function forgot(email) {
	    var req = {
	      isPublic: true,
	      method: 'POST',
	      url: apiService.getUrl('forgotPassword', { email: email }),
	      headers: {
	        'Content-type': 'application/json'
	      }
	    };
	
	    return $http(req);
	  }
	
	  function reset(token, credentials) {
	    var req = {
	      isPublic: true,
	      method: 'PUT',
	      url: apiService.getUrl('resetPassword', { token: token }),
	      headers: {
	        'Content-type': 'application/json'
	      },
	      data: credentials
	    };
	
	    return $http(req);
	  }
	
	  function getOauth() {
	    var accessToken = $cookies.get('LIGHTNINGBOOK_API_ACCESSTOKEN');
	
	    if (accessToken) {
	      var oauthData = { access_token: accessToken, expires_at: moment().add(14, 'days').format('x') };
	      sessionStorage.setItem('oauth', JSON.stringify(oauthData));
	    }
	
	    return JSON.parse(sessionStorage.getItem('oauth'));
	  }
	
	  function storeAuth(auth) {
	    auth.expires_at = moment().add(auth.expires_in, 's').format('x');
	    sessionStorage.setItem('oauth', JSON.stringify(auth));
	    return getOauth();
	  }
	
	  function clearOauth() {
	    $cookies.remove('LIGHTNINGBOOK_API_ACCESSTOKEN');
	    $cookies.remove('.AspNet.Application');
	
	    var sessionStorageKeys = Object.keys(sessionStorage);
	    var auth0Namespace = 'com.auth0.auth';
	
	    sessionStorageKeys.forEach(function (key) {
	      if (key.includes(auth0Namespace)) {
	        sessionStorage.removeItem(key);
	      }
	    });
	
	    return sessionStorage.removeItem('oauth');
	  }
	
	  function getAccessToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.access_token : '';
	  }
	
	  function getRefreshToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.refresh_token : '';
	  }
	
	  function isAuthenticated() {
	    var oauth = service.getOauth();
	
	    if (!oauth) {
	      var _oauth = window.localStorage.getItem('oauth', oauth);
	      if (_oauth) {
	        oauth = JSON.parse(_oauth);
	        sessionStorage.setItem('oauth', JSON.stringify(oauth));
	      }
	    }
	
	    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
	  }
	
	  return service;
	};
	
	authService.$inject = $inject;
	
	exports['default'] = authService;
	module.exports = exports['default'];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'settingsService'];
	
	var breakPolicyService = function breakPolicyService($filter, moment, settingsService) {
	  var service = {
	    getLeadInTimeMessage: getLeadInTimeMessage,
	    getFlightLostSavingsMessage: getFlightLostSavingsMessage,
	    getHotelLostSavingsMessage: getHotelLostSavingsMessage,
	    getCarLostSavingsMessage: getCarLostSavingsMessage
	  };
	
	  function getLeadInTimeMessage(policyExceptionDetails) {
	    var p = policyExceptionDetails;
	
	    return '\n      Your company requires bookings to be made at least ' + minsToDisplayLabel(p.CompanyPolicyLeadInTimeInMinutes, false) + ' in advance. \n      This selection is ' + minsToDisplayLabel(p.SelectionLeadInTimeInMinutes, true) + ' in advance.\n    ';
	  }
	
	  function minsToDisplayLabel(mins, isSelectionDisplay) {
	    var minsInhour = 60;
	    var hours = Math.floor(mins / minsInhour);
	
	    if (hours === 0) {
	      return isSelectionDisplay ? 'less than an hour' : 'an hour';
	    } else if (hours < 73) {
	      return isSelectionDisplay ? 'only ' + pluralize('hour', hours) : '' + pluralize('hour', hours);
	    } else {
	      var days = Math.floor(hours / 24);
	      var remainingHours = Math.round(hours % 24);
	      remainingHours = remainingHours > 0 ? ', ' + pluralize('hour', remainingHours) : '';
	      return isSelectionDisplay ? 'only ' + pluralize('day', days) + remainingHours : '' + pluralize('day', days) + remainingHours;
	    }
	  }
	
	  function pluralize(word, amount) {
	    return amount.toString() + ' ' + word + (amount === 1 ? '' : 's');
	  }
	
	  function getFlightLostSavingsMessage(policyExceptionDetails) {
	    var p = policyExceptionDetails;
	    var currencyCode = settingsService.currencyCode();
	    var timeFormat = $filter('translate')('dates.TimeFormatLong');
	    var priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
	    var minimumTimeOfCheapestOption = moment(p.MinimumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
	    var maximumTimeOfCheapestOption = moment(p.MaximumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
	
	    var message = '';
	
	    if (p.MultipleCheapestOptions) {
	      var flightText = p.IsCombinableFare ? 'combinable flights' : 'flights';
	
	      if (p.MinimumTimeOfCheapestOption === p.MaximumTimeOfCheapestOption) {
	        message = 'There were multiple cheaper ' + flightText + ' departing at ' + minimumTimeOfCheapestOption + ' for ' + priceCheapestOption + currencyCode;
	      } else {
	        message = 'There were multiple cheaper ' + flightText + ' departing between ' + minimumTimeOfCheapestOption + ' and ' + maximumTimeOfCheapestOption + ', at ' + priceCheapestOption + currencyCode;
	      }
	    } else {
	      if (p.IsCombinableFare) {
	        message = 'Flight ' + p.NameOfCheapestOption + ' departs at ' + maximumTimeOfCheapestOption + ' and has a cheaper combinable option at ' + priceCheapestOption + currencyCode;
	      } else {
	        message = 'Flight ' + p.NameOfCheapestOption + ' departs at ' + maximumTimeOfCheapestOption + ' and is cheaper at ' + priceCheapestOption + currencyCode;
	      }
	    }
	
	    return message;
	  }
	
	  function getHotelLostSavingsMessage(policyExceptionDetails) {
	    var p = policyExceptionDetails;
	    var currencyCode = settingsService.currencyCode();
	    var priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
	
	    return p.NameOfCheapestOption + ' has a cheaper room at ' + priceCheapestOption + currencyCode;
	  }
	
	  function getCarLostSavingsMessage(policyExceptionDetails) {
	    var p = policyExceptionDetails;
	    var currencyCode = settingsService.currencyCode();
	    var priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
	
	    return p.NameOfCheapestOption + ' is a cheaper car at ' + priceCheapestOption + currencyCode;
	  }
	
	  return service;
	};
	
	breakPolicyService.$inject = $inject;
	
	exports['default'] = breakPolicyService;
	module.exports = exports['default'];

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$filter', 'moment', 'APP_CONFIG'];
	
	var carSearchService = function carSearchService($q, $http, $filter, moment, APP_CONFIG) {
	  var service = {};
	
	  var DEAULT_SORT = {
	    sortBy: '',
	    isReverse: false
	  };
	
	  service.hasResults = false;
	  service.resultsMaster = [];
	  service.activeFilters = {};
	  service.activeSort = DEAULT_SORT;
	  service.results = {
	    items: [],
	    sorted: [],
	    PickUpDate: undefined,
	    DropOffDate: undefined,
	    SearchIdentifier: undefined
	  };
	
	  service.get = get;
	  service.getDetails = getDetails;
	  service.getUniqueCategories = getUniqueCategories;
	  service.getUniqueClasses = getUniqueClasses;
	  service.getUniqueVendors = getUniqueVendors;
	  service.getMaxRate = getMaxRate;
	  service.clearResults = clearResults;
	  service.setResults = setResults;
	  service.getLowestTotal = getLowestTotal;
	  service.bulkAddFilters = bulkAddFilters;
	  service.filter = filter;
	  service.sort = sort;
	
	  function get(query) {
	    var deferred = $q.defer();
	
	    service.results.PickUpDate = query.PickUp.Date;
	    service.results.DropOffDate = query.DropOff.Date;
	    service.results.SearchIdentifier = query.Identifier;
	
	    var params = {
	      searchIdentifier: query.Identifier,
	      dateFrom: moment(query.PickUp.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(query.DropOff.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      pickupLocationCode: query.PickUp.Code,
	      dropoffLocationCode: query.DropOff.Code
	    };
	
	    if (query.PickUp.Depot && query.PickUp.Depot.Supplier) {
	      var depot = query.PickUp.Depot;
	      params.supplierCode = depot.Supplier;
	      params.pickupLocationCode = depot.FullCode;
	    }
	
	    if (query.DropOff.Depot && query.DropOff.Depot.Supplier) {
	      var depot = query.DropOff.Depot;
	      params.supplierCode = depot.Supplier;
	      params.dropoffLocationCode = depot.FullCode;
	    }
	
	    var carsUrl = APP_CONFIG.api.car;
	
	    $http.get(carsUrl, { params: params }).then(function (res) {
	      var data = res.data.map(function (car) {
	        car.isHybrid = /(H|I|E|C)/.test(car.Code.slice(-1));
	        return car;
	      });
	
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getDetails(query) {
	    var deferred = $q.defer();
	
	    var params = {
	      currencyCode: query.currencyCode,
	      dateFrom: moment(query.dateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(query.dateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dropoffLocationCode: query.dropoffLocationCode,
	      pickupLocationCode: query.pickupLocationCode,
	      rateCode: query.rateCode,
	      searchIdentifier: query.searchIdentifier,
	      supplierCode: query.supplierCode,
	      vehicleCode: query.vehicleCode
	    };
	
	    var carDetailsUrl = APP_CONFIG.api.carDetails;
	
	    $http.get(carDetailsUrl, { params: params }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getUniqueCategories(results) {
	    var uniqueCategories = _.uniqBy(_.compact(results.map(function (result) {
	      if (!result.Category) {
	        return null;
	      }
	
	      return { value: result.Category, label: result.Category.trim() };
	    })), 'value');
	
	    return _.orderBy(uniqueCategories, function (item) {
	      return item.label;
	    });
	  }
	
	  function getUniqueClasses(results) {
	    var uniqueClasses = _.uniqBy(_.compact(results.map(function (result) {
	      if (!result.Class) {
	        return null;
	      }
	
	      return { value: result.Class, label: result.Class.trim() };
	    })), 'value');
	
	    return _.orderBy(uniqueClasses, function (item) {
	      return item.label;
	    });
	  }
	
	  function getUniqueVendors(results) {
	    var uniqueVendors = _.uniqBy(_.compact(results.map(function (result) {
	      var vendorName = result.Vendor.Title;
	
	      return vendorName ? { value: vendorName, label: vendorName } : null;
	    })), 'value');
	
	    return _.orderBy(uniqueVendors, function (item) {
	      return item.label;
	    });
	  }
	
	  function getMaxRate(results) {
	    return Math.ceil(_.max(_.compact(_.map(results, function (result) {
	      return result.DailyRate;
	    }))));
	  }
	
	  function clearResults() {
	    service.hasResults = false;
	    service.resultsMaster = [];
	    service.results.items = [];
	    service.results.from = 0;
	  }
	
	  function setResults(results) {
	    service.hasResults = true;
	    service.resultsMaster = results;
	    service.results.items = results;
	  }
	
	  function getLowestTotal() {
	    var cheapestCar = _.min(service.resultsMaster, function (car) {
	      return car.Total;
	    });
	
	    return Math.round(cheapestCar.Total);
	  }
	
	  function bulkAddFilters(filters) {
	    _.forOwn(filters, function (filter, key) {
	      service.activeFilters[key] = filter;
	    });
	
	    filter();
	  }
	
	  function filter() {
	    process();
	  }
	
	  function sort(orderBy, isReverse) {
	    if (!orderBy) {
	      service.activeSort = DEAULT_SORT;
	    } else {
	      service.activeSort = { orderBy: orderBy, isReverse: isReverse };
	    }
	
	    process();
	  }
	
	  function process() {
	    var processedResults = angular.copy(service.resultsMaster);
	
	    _.forOwn(service.activeFilters, function (filter) {
	      if (filter.settings.isActive()) {
	        processedResults = $filter(filter.filterName)(processedResults, filter.settings);
	      }
	    });
	
	    service.results.items = $filter('orderBy')(processedResults, service.activeSort.orderBy, service.activeSort.isReverse);
	  }
	
	  /*function applyFilters() {
	    let filteredResults = service.results.master;
	     Object.keys(service.results.activeFilters).forEach(filter => {
	      const filterSettings = service.results.activeFilters[filter];
	       if(filter === 'Price') {
	        let priceFilterSettings = filterSettings[0];
	         if(priceFilterSettings.minValue > priceFilterSettings.defaultMin || priceFilterSettings.maxValue < priceFilterSettings.defaultMax) {
	          filteredResults = $filter('withinRangeFilter')(filteredResults, priceFilterSettings);
	        }
	      } else {
	        const activeFilters = _.filter(filterSettings, (setting) => {
	          return setting.isActive;
	        });
	         if(activeFilters.length) {
	          filteredResults = $filter('inArrayFilter')(filteredResults, activeFilters);
	        }
	      }
	    });
	     service.results.filtered = filteredResults;
	  }*/
	
	  return service;
	};
	
	carSearchService.$inject = $inject;
	
	exports['default'] = carSearchService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q', '$timeout', 'moment', 'itinerariesService', 'carSearchService', 'settingsService'];
	
	var cartService = function cartService($rootScope, $q, $timeout, moment, itinerariesService, carSearchService, settingsService) {
	  var service = {
	    items: [],
	    tickets: [],
	    add: add,
	    remove: remove,
	    addToItinerary: addToItinerary,
	    cartContainsMatchedFare: cartContainsMatchedFare,
	    getTickets: getTickets,
	    getTotal: getTotal,
	    getCarbonTotal: getCarbonTotal,
	    getMatchingTicket: getMatchingTicket,
	    getMatchingItemTotal: getMatchingItemTotal,
	    addTicket: addTicket,
	    removeTicket: removeTicket,
	    clear: clear
	  };
	
	  function getTotal() {
	    var total = 0;
	
	    service.items.forEach(function (item) {
	      var itemAmount = 0;
	
	      switch (item.type) {
	        case 'flight':
	          itemAmount = item.fare.$state.displayMatchedOffset ? item.fare.$state.matchedOffset : item.fare.Amount;
	
	          break;
	
	        case 'rail':
	          itemAmount = item.OffsetAmount === undefined ? item.DisplayFare.Amount : item.OffsetAmount;
	
	          break;
	
	        case 'hotel':
	          itemAmount = item.rate.TotalAmount;
	
	          break;
	
	        case 'car':
	          itemAmount = item.Total;
	
	          break;
	
	        default:
	          console.warn("NO CART ITEM TYPE FOUND!");
	      }
	
	      total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
	    });
	
	    total -= getTicketTotal();
	
	    return total;
	  }
	
	  function getCarbonTotal() {
	    var total = 0;
	
	    service.items.forEach(function (item) {
	      var itemAmount = 0;
	
	      if (item.type === 'flight' && settingsService.settings.CarbonEmissionSetting.IncludeAirEmissionsInTotals) {
	        itemAmount = item.fare.CarbonEmissionAmount || 0;
	      }
	
	      if (item.type === 'hotel' && settingsService.settings.CarbonEmissionSetting.IncludeHotelEmissionsInTotals) {
	        itemAmount = item.hotel.CarbonEmissionAmount || 0;
	      }
	
	      if (item.type === 'car' && settingsService.settings.CarbonEmissionSetting.IncludeCarEmissionsInTotals) {
	        itemAmount = item.CarbonEmissionAmount || 0;
	      }
	
	      total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
	    });
	
	    return total;
	  }
	
	  function getTicketTotal() {
	    return _.reduce(service.tickets, function (total, ticket) {
	      return total + ticket.Value;
	    }, 0);
	  }
	
	  function getTickets() {
	    return _.map(service.tickets, function (ticket) {
	      return _.extend(ticket, {
	        TicketAmount: ticket.Value
	      });
	    });
	  }
	
	  function add(newItem) {
	    if (newItem.hasOwnProperty('OptionAutomatic')) {
	      if (service.items.length) {
	        remove(service.items[0]).then(function () {
	          newItem.type = 'car';
	          newItem.added = true;
	          service.items = [newItem];
	        });
	      } else {
	        newItem.type = 'car';
	        newItem.added = true;
	        service.items = [newItem];
	      }
	    }
	
	    if (newItem.hasOwnProperty('hotel')) {
	      if (service.items.length) {
	        remove(service.items[0]).then(function () {
	          newItem.type = 'hotel';
	          newItem.room.added = true;
	          service.items = [newItem];
	        });
	      } else {
	        newItem.type = 'hotel';
	        newItem.room.added = true;
	        service.items = [newItem];
	      }
	    }
	  }
	
	  function remove(item) {
	    var deferred = $q.defer();
	
	    switch (item.type) {
	      case 'rail':
	        var removeBoth = false;
	
	        if (service.items.length === 2 && item.OffsetAmount === undefined) {
	          removeBoth = true;
	        }
	
	        _.remove(service.items, function (cartItem) {
	          return cartItem === item;
	        });
	
	        item.DisplayFare.isSelected = false;
	        item.DisplayFare = item.CheapestFare;
	        item.parent.itemInCart = false;
	        item.row.selected = false;
	        item.addedToCart = false;
	
	        $rootScope.$broadcast('cartService:rail:removed');
	
	        deferred.resolve();
	
	        break;
	
	      case 'flight':
	
	        _.remove(service.items, function (cartItem) {
	          return cartItem === item;
	        });
	
	        if (removeBoth) {
	          remove(service.items[0]);
	        }
	
	        item.isRemoving = false;
	
	        deferred.resolve();
	
	        break;
	
	      case 'hotel':
	        service.items[0].room.added = false;
	
	        delete service.items[0].PolicyCode;
	        delete service.items[0].PolicyTitle;
	        delete service.items[0].PolicyComments;
	        delete service.items[0].LostSavingsAmount;
	
	        item.isRemoving = false;
	
	        clear();
	
	        deferred.resolve();
	
	        break;
	
	      case 'car':
	        service.items[0].added = false;
	
	        delete service.items[0].PolicyCode;
	        delete service.items[0].PolicyTitle;
	        delete service.items[0].PolicyComments;
	        delete service.items[0].LostSavingsAmount;
	        delete service.items[0].Delivery;
	        delete service.items[0].Collection;
	
	        item.isRemoving = false;
	
	        clear();
	
	        deferred.resolve();
	
	        break;
	
	      default:
	        console.warn('NO CART ITEM TYPE FOUND!');
	
	        deferred.reject();
	    }
	
	    return deferred.promise;
	  }
	
	  function addToItinerary(type, items) {
	    var cleanedItems = {};
	
	    switch (type) {
	      case 'Rails':
	        cleanedItems = items.map(function (item) {
	          var railItem = item;
	
	          if (item.DisplayFare) {
	            railItem = item.DisplayFare;
	          }
	
	          if (item.fareOverride) {
	            railItem = item.fareOverride;
	          }
	
	          if (item.DisplayFare && item.DisplayFare.selectedAdditional) {
	            railItem = item.DisplayFare.selectedAdditional;
	          }
	
	          return {
	            Carrier: item.row.Carrier,
	            RailNumber: item.row.RailNumber,
	            Departure: {
	              Code: item.row.OriginLocationCode,
	              Location: item.row.OriginLocation,
	              Date: item.row.DepartureDateTimeOffset
	            },
	            Arrival: {
	              Code: item.row.DestinationLocationCode,
	              Location: item.row.DestinationLocation,
	              Date: item.row.ArrivalDateTimeOffset
	            },
	            Detail: {
	              Codes: railItem.ResBookDesignCode.join(),
	              Rates: railItem.Code.join(),
	              RailCardCode: railItem.RailCardCode
	            },
	            SearchIdentifier: item.row.SearchIdentifier,
	            Policy: {}
	          };
	        });
	        break;
	
	      case 'Flights':
	        cleanedItems = items.map(function (item) {
	          var policy = null;
	          var lostSavingsAmount = null;
	
	          if (item.fare.PolicyException) {
	            policy = {
	              Code: item.fare.PolicyException.PolicyCode,
	              Title: item.fare.PolicyException.PolicyTitle,
	              Comments: item.fare.PolicyException.PolicyComments
	            };
	
	            lostSavingsAmount = item.fare.PolicyException.LostSavingsAmount;
	          }
	
	          return {
	            Carrier: item.result.Carrier,
	            FlightNumber: item.result.TripNumber,
	            Departure: {
	              Code: item.result.OriginLocationCode,
	              Location: item.result.OriginLocation,
	              City: item.result.OriginCity,
	              Date: item.result.DepartureDateTimeOffset
	            },
	            Arrival: {
	              Code: item.result.DestinationLocationCode,
	              Location: item.result.DestinationLocation,
	              City: item.result.DestinationCity,
	              Date: item.result.ArrivalDateTimeOffset
	            },
	            Detail: {
	              Codes: item.fare.ResBookDesignCode.join(),
	              Rates: item.fare.Code.join()
	            },
	            SearchIdentifier: item.result.SearchIdentifier,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: policy
	          };
	        });
	        break;
	
	      case 'Cars':
	        cleanedItems = items.map(function (C) {
	          var policy = null;
	          var specialRequests = null;
	          var lostSavingsAmount = null;
	
	          if (C.PolicyCode) {
	            policy = {
	              Code: C.PolicyCode,
	              Title: C.PolicyTitle,
	              Comments: C.PolicyComments
	            };
	          }
	
	          if (C.specialRequests) {
	            specialRequests = C.specialRequests;
	          }
	
	          if (C.LostSavingsAmount) {
	            lostSavingsAmount = C.LostSavingsAmount;
	          }
	
	          return {
	            Supplier: {
	              Code: C.Vendor.Code,
	              Title: C.Vendor.Title
	            },
	            Vehicle: {
	              Code: C.Code,
	              Class: C.Class,
	              Title: C.Title
	            },
	            RateCode: C.RateCode,
	            CurrencyCode: C.CurrencyCode,
	            PickUp: {
	              Date: carSearchService.results.PickUpDate,
	              Code: C.PickupLocationCode,
	              Location: C.PickupLocation
	            },
	            DropOff: {
	              Date: carSearchService.results.DropOffDate,
	              Code: C.DropOffLocationCode,
	              Location: C.DropOffLocation
	            },
	            AvailabilityStatus: C.AvailabilityStatus,
	            DeliveryAddress: C.DeliveryAddress,
	            CollectionAddress: C.CollectionAddress,
	            SearchIdentifier: carSearchService.results.SearchIdentifier,
	            Amount: C.Total,
	            TaxAmount: 0.0,
	            SpecialRequests: specialRequests,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: policy
	          };
	        });
	
	        break;
	
	      case 'Hotels':
	        cleanedItems = items.map(function (item) {
	          var currentSearch = itinerariesService.getCurrentSearch();
	          var policy = null;
	          var paymentNarrative = null;
	          var specialRequirements = null;
	          var lostSavingsAmount = null;
	
	          if (item.PolicyCode) {
	            policy = {
	              Code: item.PolicyCode,
	              Title: item.PolicyTitle,
	              Comments: item.PolicyComments
	            };
	          }
	
	          if (item.HotelPaymentNarrative) {
	            paymentNarrative = {
	              Code: item.HotelPaymentNarrative.PaymentCode,
	              Title: item.HotelPaymentNarrative.PaymentNarrative,
	              Description: item.HotelPaymentNarrative.PaymentInstructions,
	              ServiceCode: item.HotelPaymentNarrative.ServiceFeeCode
	            };
	          }
	
	          if (item.specialRequirements) {
	            specialRequirements = item.specialRequirements;
	          }
	
	          if (item.LostSavingsAmount) {
	            lostSavingsAmount = item.LostSavingsAmount;
	          }
	
	          return {
	            DateFrom: item.dateFrom,
	            DateTo: item.dateTo,
	            HotelCode: item.room.HotelCode,
	            HotelName: item.hotel.HotelName,
	            ChainCode: item.hotel.ChainCode,
	            RateCode: item.rate.RateCode,
	            RoomName: item.room.RoomName,
	            Location: {
	              Code: item.hotel.HotelCityCode
	            },
	            SpecialRequirements: specialRequirements,
	            BookingPaymentTypeCode: item.rate.BookingPaymentTypeCode,
	            SearchIdentifier: currentSearch.Identifier,
	            Amount: item.rate.TotalAmount,
	            TaxAmount: item.rate.TaxAmount,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: policy,
	            PaymentNarrative: paymentNarrative
	          };
	        });
	
	        break;
	
	      default:
	        console.warn("NO TYPE FOUND!");
	    }
	
	    return {
	      cleanedItems: cleanedItems,
	      type: type
	    };
	  }
	
	  function cartContainsMatchedFare(matchedFares) {
	    return containsMatchedFare(service.items, matchedFares);
	  }
	
	  function containsMatchedFare(fares, matchedFares) {
	    return _.some(fares, function (cartItem) {
	      return _.some(matchedFares, function (matchedFare) {
	        return matchedFare.Identifier === cartItem.fare.Identifier;
	      });
	    });
	  }
	
	  function getMatchingTicket(ticket) {
	    return _.find(service.tickets, function (selectedTicket) {
	      return ticket.Carrier === selectedTicket.Carrier && ticket.PassengerIdentifier === selectedTicket.PassengerIdentifier;
	    }, 0);
	  }
	
	  function getMatchingItemTotal(ticket) {
	    return _.reduce(service.items, function (total, selectedItem) {
	      var ndcQantasSabre = selectedItem.result.IsNdc && selectedItem.result.Carrier === 'QF' && selectedItem.result.GdsProvider === 'Sabre';
	      var sameCarrier = ticket.Carrier === selectedItem.result.Carrier;
	      var sameProvider = ticket.GdsProvider === selectedItem.result.GdsProvider;
	
	      return total + (!ndcQantasSabre && sameCarrier && sameProvider ? selectedItem.fare.Amount : 0);
	    }, 0);
	  }
	
	  function addTicket(ticket) {
	    if (ticket.isSelected) {
	      return false;
	    }
	
	    ticket.isSelected = true;
	    service.tickets.push(ticket);
	  }
	
	  function removeTicket(ticket) {
	    ticket.isSelected = false;
	
	    service.tickets = _.reject(service.tickets, function (selectedTicket) {
	      return selectedTicket === ticket;
	    });
	  }
	
	  function clear() {
	    service.items = [];
	    service.tickets = [];
	  }
	
	  return service;
	};
	
	cartService.$inject = $inject;
	
	exports['default'] = cartService;
	module.exports = exports['default'];

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$httpParamSerializer'];
	
	var cdnService = function cdnService($httpParamSerializer) {
	  var service = {};
	
	  service.imageResize = imageResize;
	
	  function imageResize(args) {
	    args.options = angular.extend(args.options, {
	      mode: args.mode ? args.mode : 'crop',
	      format: 'jpg',
	      quality: 71
	    });
	
	    return args.imgPath + '?' + $httpParamSerializer(args.options);
	  }
	
	  return service;
	};
	
	cdnService.$inject = $inject;
	
	exports['default'] = cdnService;
	module.exports = exports['default'];

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', '$q', '$filter'];
	
	var changeCartService = function changeCartService($http, $q, $filter) {
	  var service = {
	    canContinue: false,
	    changeFees: [],
	    items: [],
	    totals: {
	      difference: 0,
	      changeFee: 0,
	      serviceFee: 0,
	      total: 0
	    },
	    addChange: addChange,
	    addFlightsForChange: addFlightsForChange,
	    remove: remove,
	    getChangeFees: getChangeFees
	  };
	
	  function calculateTotals() {
	    var feeTotals = {
	      difference: difference(),
	      changeFee: changeFee(),
	      serviceFee: serviceFee()
	    };
	
	    var total = Object.values(feeTotals).reduce(function (accumulatedTotal, feeTotal) {
	      return accumulatedTotal + feeTotal;
	    });
	
	    return {
	      difference: $filter('priceWithOperatorFilter')(feeTotals.difference, 2),
	      changeFee: $filter('currency')(feeTotals.changeFee, '', 2),
	      serviceFee: $filter('currency')(feeTotals.serviceFee, '', 2),
	      total: $filter('currency')(total, '', 2)
	    };
	  }
	
	  function difference() {
	    var initialCartItem = service.items.find(function (item) {
	      return item.fare;
	    });
	    if (!initialCartItem) return 0;
	    return initialCartItem.fare.CostOfChange;
	  }
	
	  function changeFee() {
	    var ticketNumbers = new Map();
	    var fee = 0;
	
	    service.items.forEach(function (cartItem) {
	      var newFareIsAdded = cartItem.fare && cartItem.result;
	
	      if (newFareIsAdded) {
	        var cartItemTicketNumber = cartItem.fare.TicketNumber;
	        var existingTicket = ticketNumbers.get(cartItemTicketNumber);
	
	        if (existingTicket) {
	          if (existingTicket.ChangeFee <= cartItem.fare.ChangeFee) {
	            fee -= existingTicket.ChangeFee;
	            fee += cartItem.fare.ChangeFee;
	            ticketNumbers.set(cartItemTicketNumber, cartItem.fare);
	          }
	        } else {
	          fee += cartItem.fare.ChangeFee;
	          ticketNumbers.set(cartItemTicketNumber, cartItem.fare);
	        }
	      }
	    });
	
	    return fee;
	  }
	
	  function serviceFee() {
	    var ticketNumbers = [];
	    var fee = 0;
	
	    service.items.forEach(function (cartItem) {
	      var newFareIsAdded = cartItem.fare && cartItem.result;
	
	      if (newFareIsAdded) {
	        (function () {
	          var cartItemTicketNumber = cartItem.fare.TicketNumber;
	
	          if (!ticketNumbers.includes(cartItemTicketNumber)) {
	            ticketNumbers.push(cartItemTicketNumber);
	
	            service.changeFees.forEach(function (changeFee) {
	              if (changeFee.Type === 'AgencyChangeFee' && changeFee.TicketNumbers.includes(cartItemTicketNumber)) {
	                fee += changeFee.Amount;
	              }
	            });
	          }
	        })();
	      }
	    });
	
	    return fee;
	  }
	
	  function addChange(index, result, fare) {
	    service.items[index].result = result;
	    service.items[index].fare = fare;
	    service.items[index].ignoreMatches = false;
	    service.items[index].matchingIndex = fare.MatchingResultsIndex;
	
	    service.totals = calculateTotals();
	    service.canContinue = canContinue();
	  }
	
	  function addFlightsForChange(flights, searches) {
	    var cartItems = [];
	
	    var flightsWithSearch = flights.filter(function (flight) {
	      return searches.some(function (search) {
	        return search.ParentIdentifier === flight.Identifier;
	      });
	    });
	
	    flightsWithSearch.forEach(function (flight, flightIndex) {
	      cartItems.push({
	        ignoreMatches: true,
	        result: undefined,
	        fare: undefined,
	        orderBy: flightIndex,
	        flight: flight
	      });
	    });
	
	    service.items = [].concat(cartItems);
	    service.totals = calculateTotals();
	    service.canContinue = canContinue();
	  }
	
	  function remove(orderBy) {
	    var deferred = $q.defer();
	
	    var itemToRemoveChange = service.items.find(function (item) {
	      return item.orderBy === orderBy;
	    });
	
	    itemToRemoveChange.result = undefined;
	    itemToRemoveChange.fare = undefined;
	    itemToRemoveChange.ignoreMatches = true;
	    service.totals = calculateTotals();
	    service.canContinue = canContinue();
	
	    deferred.resolve(itemToRemoveChange);
	
	    return deferred.promise;
	  }
	
	  function getChangeFees(itineraryId, passengerId) {
	    var apiConfig = window.svelteStore.apiConfig('itineraryPassengerChangeFees', {
	      itineraryId: itineraryId,
	      passengerId: passengerId
	    });
	
	    $http.get(apiConfig.url, {
	      apiVersion: apiConfig.version
	    }).then(function (response) {
	      service.changeFees = response.data;
	    });
	  }
	
	  function canContinue() {
	    return service.items.every(function (cartItem) {
	      return cartItem.result && cartItem.fare;
	    });
	  }
	
	  return service;
	};
	
	changeCartService.$inject = $inject;
	
	exports['default'] = changeCartService;
	module.exports = exports['default'];

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'APP_CONFIG'];
	
	var citySearchService = function citySearchService($q, $http, APP_CONFIG) {
	  var service = {};
	
	  service.get = get;
	
	  function get(params) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.citySearch;
	
	    $http.get(url, { params: params }).then(function (response) {
	      response.data.forEach(function (city) {
	        city.Airports.map(function (airport) {
	          airport.Label = airport.Name + ' (' + airport.Value + ')';
	          return airport;
	        });
	        city.cityCountry = city.City + ':' + city.Country;
	        city.label = city.City + ' (' + city.Country + ')';
	      });
	
	      deferred.resolve(response.data);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	citySearchService.$inject = $inject;
	
	exports['default'] = citySearchService;
	module.exports = exports['default'];

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var departmentService = function departmentService($q, $http, apiService) {
	  var service = {
	    getAllDepartments: getAllDepartments,
	    getDepartments: getDepartments,
	    getCostCentres: getCostCentres
	  };
	
	  function getAllDepartments() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('department');
	
	    $http.get(apiUrl).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getDepartments(params) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('department');
	
	    $http.get(apiUrl, { params: params }).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getCostCentres(params) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('costCentres');
	
	    $http.get(apiUrl, { params: params, apiVersion: 20 }).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	departmentService.$inject = $inject;
	
	exports['default'] = departmentService;
	module.exports = exports['default'];

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'APP_CONFIG'];
	
	var depotSearchService = function depotSearchService($q, $http, APP_CONFIG) {
	  var service = {};
	
	  service.get = get;
	
	  function get(params) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.depotSearch;
	
	    $http.get(url, { params: params }).then(function (response) {
	
	      var data = {
	        carSuppliers: [],
	        suppliers: {},
	        supplierLocations: [],
	        anySupplier: {
	          supplierId: '',
	          supplierLogo: 'https://az867575.vo.msecnd.net/static/blank.gif',
	          supplierName: 'Any Supplier'
	        }
	      };
	
	      response.data.forEach(function (supplier) {
	        var thisSupplier = {
	          supplierId: supplier.Code,
	          supplierLogo: supplier.Logo,
	          supplierName: supplier.Title
	        };
	
	        data.carSuppliers.push(thisSupplier);
	
	        data.suppliers[supplier.Code] = thisSupplier;
	
	        supplier.Depots.forEach(function (depot) {
	          data.supplierLocations.push({
	            displayLabel: depot.Name + ' ' + depot.Address,
	            addressLabel: depot.Address,
	            addressLine: depot.Street,
	            cityName: depot.City,
	            cityCode: depot.CityCode,
	            fullCode: depot.FullCode,
	            code: depot.Code,
	            latitude: depot.Latitude,
	            locationCode: depot.Code,
	            longtitude: depot.Longitude,
	            stateCode: depot.State,
	            supplierId: depot.Supplier
	          });
	        });
	      });
	
	      data.suppliers.ANY = data.anySupplier;
	
	      data.carSuppliers.push(data.anySupplier);
	
	      deferred.resolve(data);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	depotSearchService.$inject = $inject;
	
	exports['default'] = depotSearchService;
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var duplicateBookingsService = function duplicateBookingsService() {
	  var service = {};
	
	  service.set = function (flag) {
	    sessionStorage.setItem('loadDuplicateBooking', flag);
	  };
	
	  service.get = function () {
	    var loadDuplicateBooking = sessionStorage.getItem('loadDuplicateBooking');
	    return loadDuplicateBooking ? JSON.parse(loadDuplicateBooking) : true;
	  };
	
	  return service;
	};
	
	duplicateBookingsService.$inject = $inject;
	
	exports['default'] = duplicateBookingsService;
	module.exports = exports['default'];

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', '$q', '$filter', '$rootScope', 'moment', 'APP_CONFIG', 'cartService', 'settingsService'];
	
	var flailService = function flailService($http, $q, $filter, $rootScope, moment, APP_CONFIG, cartService, settingsService) {
	  var service = {
	    resultsMaster: { flail: [] },
	    results: { flail: [] },
	    fareClasses: [],
	    hasResults: false,
	    currentFilter: undefined,
	    init: init,
	    start: start,
	    getResults: getResults,
	    getFareRules: getFareRules,
	    prepData: prepData,
	    addFilter: addFilter,
	    bulkAddFilters: bulkAddFilters,
	    removeFilter: removeFilter,
	    setFilters: setFilters,
	    sort: sort,
	    itemAddedToCart: itemAddedToCart,
	    BulkRemoveFareClassFilter: BulkRemoveFareClassFilter,
	    checkFareFilters: checkFareFilters,
	    orderClasses: orderClasses
	  };
	
	  var TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');
	
	  function init() {
	    service.resultsMaster = { flail: [] };
	    service.results = { flail: [] };
	    service.fareClasses = [];
	    service.hasResults = false;
	    service.currentFilter = undefined;
	
	    $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
	  }
	
	  function start(searches) {
	    service.getResults('Rail', searches).then(function () {
	      service.hasResults = true;
	    });
	  }
	
	  function getResults(type, searches) {
	    var search = searches.Rails[0];
	    var returnSearch = searches.Rails[1];
	
	    var apiUrl = '' + APP_CONFIG.api.url + type + '/search';
	
	    var params = {
	      searchDate: moment(search.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      originLocationCode: search.Origin.Code,
	      destinationLocationCode: search.Destination.Code,
	      paxCount: search.Passengers.length,
	      searchIdentifier: search.Identifier,
	      railCardCode: search.RailCardCode,
	      openReturn: search.OpenReturn
	    };
	
	    if (returnSearch) {
	      params.searchReturnIdentifier = returnSearch.Identifier;
	      params.returnDate = moment(returnSearch.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss');
	      params.openReturn = false;
	    }
	
	    var deferred = $q.defer();
	
	    $http.get(apiUrl, { params: params }).then(function (res) {
	      var data = res.data;
	
	      data.forEach(function (rail, index) {
	        var orderedData = $filter('orderBy')(rail.Results, 'DepartureTime');
	        service.results.flail[index] = prepData(orderedData);
	        service.resultsMaster.flail[index] = _.clone(service.results.flail[index]);
	      });
	
	      deferred.resolve(true);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getFareRules(type, sector, fare) {
	    var deferred = $q.defer();
	
	    if (fare.RemarksCollection) {
	      var fareRuleData = function fareRuleData() {
	        var text = '';
	        _.forEach(fare.RemarksCollection, function (obj) {
	          text = text + obj.Code + '\n' + obj.Value + '\n\n';
	        });
	        return text;
	      };
	
	      var fareRules = {
	        Type: 'Text',
	        Data: fareRuleData()
	      };
	
	      deferred.resolve(fareRules);
	    } else {
	      var apiUrl = '' + APP_CONFIG.api.url + type + '/FareRules';
	
	      var params = {
	        carrierCode: sector.Carrier,
	        railNumber: sector.RailNumber,
	        departureCode: sector.OriginLocationCode,
	        departureDate: sector.DepartureDateTime,
	        destinationCode: sector.DestinationLocationCode,
	        fareCode: fare.Code[0],
	        searchIdentifier: sector.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).then(function (res) {
	        var data = res.data;
	        deferred.resolve(data);
	      })['catch'](function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function prepData(data) {
	
	    var availableFilters = {
	      priceRange: {
	        name: 'priceRange',
	        label: 'Price',
	        labelSuffix: '(' + settingsService.settings.Currency.Code + ')',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Price',
	          filterName: 'flailPriceRangeFilter',
	          defaultMax: 0,
	          defaultMin: 0,
	          maxValue: 0,
	          minValue: 0,
	          step: 1,
	          translateFunc: function translateFunc(value) {
	            return $filter('currency')(value, '', 0);
	          },
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      },
	      departureTimeRange: {
	        name: 'departureTimeRange',
	        label: 'Departure Time',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Departure',
	          filterName: 'flailTimeFilter',
	          defaultMax: 1439,
	          defaultMin: 0,
	          maxValue: 1439,
	          minValue: 0,
	          step: 5,
	          translateFunc: translateMinutesTime,
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      },
	      arrivalTimeRange: {
	        name: 'arrivalTimeRange',
	        label: 'Arrival Time',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Arrival',
	          filterName: 'flailTimeFilter',
	          defaultMax: 1439,
	          defaultMin: 0,
	          maxValue: 1439,
	          minValue: 0,
	          step: 5,
	          translateFunc: translateMinutesTime,
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      }
	    };
	
	    var obj = {
	      searchResults: data,
	      classes: [],
	      activeFilters: {},
	      filters: {
	        options: availableFilters,
	        layout: [['priceRange', 'departureTimeRange', 'arrivalTimeRange']]
	      }
	    };
	
	    angular.forEach(data, function (item) {
	      var fareClasses = item.FareClasses;
	      item.TotalFares = 0;
	      item.HasAdditionalFares = false;
	
	      angular.forEach(fareClasses, function (fare, key) {
	        if (fare == null) {
	          delete fareClasses[key];
	        } else {
	          fare.Class = key;
	          fare.DisplayFare = _.omit(fare, 'AdditionalFares');
	          fare.CheapestFare = fare.DisplayFare;
	
	          fare.AdditionalFares = _.map(fare.AdditionalFares, function (additionalFare) {
	            additionalFare.Class = key;
	            return additionalFare;
	          });
	
	          fare.AdditionalFares.unshift(fare.DisplayFare);
	
	          if (fare.AdditionalFares.length > 1) {
	            item.HasAdditionalFares = true;
	          }
	
	          item.TotalFares += fare.AdditionalFares.length;
	        }
	      });
	
	      obj.classes = obj.classes.concat(Object.keys(fareClasses));
	      var priceFilterSettings = obj.filters.options.priceRange.settings;
	
	      if (item.MaxRate > priceFilterSettings.maxValue) {
	        priceFilterSettings.maxValue = item.MaxRate;
	        priceFilterSettings.defaultMax = item.MaxRate;
	      }
	    });
	
	    buildFareClasses(obj.classes);
	
	    obj.classes = orderClasses(service.fareClasses);
	
	    return obj;
	  }
	
	  function buildFareClasses(classes) {
	    service.fareClasses = service.fareClasses.concat(classes);
	    service.fareClasses = _.uniq(service.fareClasses);
	  }
	
	  function bulkAddFilters(filters, target, index, fareClass) {
	    _.forOwn(filters, function (filter, key) {
	      service.results[target][index].activeFilters[key] = filter;
	    });
	
	    if (fareClass) {
	      service.results[target][index].activeFilters.fareClass = fareClass;
	    }
	
	    service.setFilters(target, index);
	  }
	
	  function addFilter(filter, args, target, index) {
	    service.results[target][index].activeFilters[filter] = args;
	    service.setFilters(target, index);
	  }
	
	  function removeFilter(filter, target, index) {
	    delete service.results[target][index].activeFilters[filter];
	    service.setFilters(target, index);
	  }
	
	  function setFilters(target, index) {
	    service.results[target][index].searchResults = _.clone(service.resultsMaster[target][index].searchResults);
	
	    $filter('flailCleanFilter')(service.results, target, index, ['filtered', 'priceFiltered', 'noMatch']);
	
	    Object.keys(service.results[target][index].activeFilters).forEach(function (filter) {
	      var args = service.results[target][index].activeFilters[filter];
	
	      if (filter === 'flailTimeFilter') {
	        $filter('flailTimeFilter')(service.results, args, target, index, 'DepartureTime');
	      }
	
	      if (filter === 'priceRange' && cartService.items.length === 0) {
	        $filter('flailPriceRangeFilter')(service.results, args.settings, target, index);
	      }
	
	      if (filter === 'departureTimeRange') {
	        var obj = {
	          start: args.settings.minValue,
	          end: args.settings.maxValue
	        };
	
	        $filter('flailTimeFilter')(service.results, obj, target, index, 'DepartureTime');
	      }
	
	      if (filter === 'arrivalTimeRange') {
	        var obj = {
	          start: args.settings.minValue,
	          end: args.settings.maxValue
	        };
	
	        $filter('flailTimeFilter')(service.results, obj, target, index, 'ArrivalTime');
	      }
	
	      if (filter === 'matchingFares') {
	        $filter('matchingFaresFilter')(service.results, args, target, index);
	      }
	
	      if (filter === 'fareClass' && service.results[target][index].itemInCart) {
	        $filter('fareClassFilter')(service.results, args, target, index);
	      }
	    });
	  }
	
	  function sort(filterExpression, index) {
	    if (service.currentFilter != filterExpression) {
	      service.currentFilter = filterExpression;
	      $filter('flailGenericFilter')(service.results, filterExpression, index);
	    } else {
	      service.currentFilter = undefined;
	      $filter('flailGenericFilter')(service.results, 'DepartureTime', index);
	    }
	  }
	
	  function translateMinutesTime(mins) {
	    var hours = Math.floor(mins / 60);
	    var minutes = mins % 60;
	
	    if (hours === 24 && minutes === 0) {
	      hours = 23;
	      minutes = 59;
	    }
	
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	
	    return moment(hours + ':' + minutes, 'H:mm').format(TIME_FORMAT);
	  }
	
	  function itemAddedToCart(parentIndex, row, item) {
	    angular.forEach(service.results.flail, function (flail, flailIndex) {
	      if (flailIndex != parentIndex && cartService.items.length === 0) {
	        addFilter('matchingFares', item.DisplayFare, 'flail', flailIndex);
	        removeFilter('priceRange', 'flail', flailIndex);
	        flail.filters.options.priceRange.settings.maxValue = flail.filters.options.priceRange.settings.defaultMax;
	        flail.filters.options.priceRange.settings.minValue = flail.filters.options.priceRange.settings.defaultMin;
	      }
	
	      if (!flail.itemInCart) {
	        addFilter('fareClass', item.Class, 'flail', flailIndex);
	      }
	    });
	
	    item.orderBy = parentIndex;
	    item.parent = service.results.flail[parentIndex];
	    item.row = row;
	    service.results.flail[parentIndex].itemInCart = true;
	    service.results.flail[parentIndex].currentRow = row;
	    service.results.flail[parentIndex].currentItem = item;
	    item.row.selected = true;
	    item.addedToCart = true;
	    item.type = 'rail';
	
	    cartService.items.push(item);
	  }
	
	  function BulkRemoveFareClassFilter() {
	    angular.forEach(service.results.flail, function (flail, flailIndex) {
	      removeFilter('fareClass', 'flail', flailIndex);
	      removeFilter('matchingFares', 'flail', flailIndex);
	    });
	  }
	
	  function checkFareFilters() {
	    if (cartService.items.length === 0) {
	      BulkRemoveFareClassFilter();
	    }
	  }
	
	  function orderClasses(classes) {
	    var classesOrdered = [];
	
	    settingsService.settings.FlightConfiguration.FareClasses.forEach(function (fareClass) {
	      var match = _.find(classes, function (className) {
	        return fareClass.Name === className;
	      });
	
	      if (match) {
	        classesOrdered.push(match);
	      }
	    });
	
	    return classesOrdered;
	  }
	
	  return service;
	};
	
	flailService.$inject = $inject;
	
	exports['default'] = flailService;
	module.exports = exports['default'];

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	
	var guestTravellerService = function guestTravellerService(moment) {
	  var service = {};
	  service.activeGuest = new Guest();
	
	  service.addLoyaltyProgram = function (programs) {
	    return programs.concat([new LoyaltyProgram()]);
	  };
	
	  service.removeLoyaltyProgram = function (programs) {
	    return programs.slice(0, -1);
	  };
	
	  service.clear = function () {
	    service.activeGuest = new Guest();
	  };
	
	  service.setActiveGuest = function (traveller) {
	    var loyaltyPrograms = _.map(traveller.PersonalMemberships, function (program) {
	      return {
	        number: program.MembershipNumber,
	        supplier: {
	          Value: program.CompanyCode,
	          Title: program.CompanyName,
	          Type: program.MembershipTypeCode
	        }
	      };
	    });
	
	    if (loyaltyPrograms.length === 0) {
	      loyaltyPrograms = loyaltyPrograms.concat([new LoyaltyProgram()]);
	    }
	
	    service.activeGuest = _.extend(new Guest(), {
	      title: traveller.Salutation,
	      firstName: traveller.Firstname,
	      lastName: traveller.Lastname,
	      email: traveller.Email,
	      phone: traveller.Mobile,
	      dob_day: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('D') : null,
	      dob_month: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('MMMM') : null,
	      dob_year: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY') : null,
	      gender: traveller.Gender,
	      guestID: traveller.guestID,
	      costCentre: {
	        Code: traveller.CostCentreCode,
	        Title: traveller.CostCentreName
	      },
	      department: {
	        Code: traveller.DepartmentCode,
	        Title: traveller.DepartmentName
	      },
	      loyaltyPrograms: loyaltyPrograms,
	      postcode: traveller.Postcode
	    });
	  };
	
	  function Guest() {
	    return {
	      title: null,
	      firstName: null,
	      lastName: null,
	      email: null,
	      phone: null,
	      dob_day: null,
	      dob_month: null,
	      dob_year: null,
	      gender: null,
	      loyaltyPrograms: [new LoyaltyProgram()],
	      costCentre: null,
	      department: null,
	      postcode: null
	    };
	  }
	
	  function LoyaltyProgram() {
	    return {
	      supplier: null,
	      number: null
	    };
	  }
	
	  return service;
	};
	
	guestTravellerService.$inject = $inject;
	
	exports['default'] = guestTravellerService;
	module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http'];
	
	var iataSearchService = function iataSearchService($q, $http) {
	  var service = {};
	
	  service.get = get;
	  service.getGrouped = getGrouped;
	  service.getMetroGrouped = getMetroGrouped;
	  service.getIataFromLocation = getIataFromLocation;
	
	  function get(params) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('iata');
	
	    $http.get(apiConfig.url, { params: params, apiVersion: apiConfig.version }).then(function (response) {
	      var responseData = [];
	      var groupKeys = [];
	
	      _.forEach(response.data, function (location) {
	        var groupedBy = groupedByKey(location);
	        var displayLabel = location.Name + ' - ' + location.City + ', ' + location.Country;
	        var hasCode = !!location.Value;
	
	        if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
	          var selectedGroupLabel = groupedBySelectedLabel(location);
	          var groupByLabel = groupedByLabel(location);
	          var groupItem = _.extend({}, location, {
	            isGroupHeader: true,
	            groupedBy: groupedBy,
	            displayLabel: groupByLabel,
	            hasCode: !!location.GroupCode,
	            Label: selectedGroupLabel,
	            Value: location.GroupCode || location.Group
	          });
	
	          responseData.push(groupItem);
	
	          groupKeys.push(groupedBy);
	        }
	
	        location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	        responseData.push(location);
	      });
	
	      deferred.resolve(responseData);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getGrouped(params) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('iata');
	
	    $http.get(apiConfig.url, { params: params, apiVersion: apiConfig.version }).then(function (response) {
	      var responseData = [];
	
	      _.forEach(response.data, function (location) {
	        var groupedBy = groupedByKey(location);
	        var displayLabel = location.Name + ' - ' + location.City + ', ' + location.Country;
	        var hasCode = !!location.Value;
	
	        location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	        responseData.push(location);
	      });
	
	      deferred.resolve(responseData);
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getMetroGrouped(params, isPublic) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig(isPublic ? 'iataSct' : 'iata');
	
	    $http.get(apiConfig.url, { params: params, isPublic: isPublic, apiVersion: apiConfig.version }).then(function (response) {
	      var responseData = [];
	      var groupKeys = [];
	
	      _.forEach(response.data, function (location) {
	        var groupedBy = groupedByMetroKey(location);
	        var displayLabel = location.Name + ' - ' + location.City + ', ' + location.Country;
	        var hasCode = !!location.Value;
	
	        if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
	          var selectedGroupLabel = groupedBySelectedLabel(location);
	          var groupByLabel = groupedByLabel(location);
	          var groupItem = _.extend({}, location, {
	            isGroupHeader: true,
	            groupedBy: groupedBy,
	            displayLabel: groupByLabel,
	            hasCode: !!location.GroupCode,
	            Label: selectedGroupLabel,
	            Value: location.GroupCode || location.Group,
	            IsBlocked: location.IsBlocked
	          });
	
	          responseData.push(groupItem);
	
	          groupKeys.push(groupedBy);
	        }
	
	        location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	        responseData.push(location);
	      });
	
	      deferred.resolve(responseData);
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function groupedByKey(location) {
	    return location.Group ? location.Group + ' (All Airports)' : undefined;
	  }
	
	  function groupedByMetroKey(location) {
	    return location.GroupCode || location.Group || undefined;
	  }
	
	  function groupedByLabel(location) {
	    var label = undefined;
	
	    if (location.Group) {
	      label = location.Group + ' (All Airports) - ' + location.City + ', ' + location.Country;
	    }
	
	    return label;
	  }
	
	  function groupedBySelectedLabel(location) {
	    var label = location.Group;
	
	    if (location.GroupCode) {
	      label += ' (' + location.GroupCode + ')';
	    }
	
	    return label;
	  }
	
	  function getIataFromLocation(location) {
	    return {
	      Value: location.Code,
	      City: location.City,
	      Country: location.Country,
	      CountryCode: location.CountryCode,
	      Name: location.Location,
	      displayLabel: location.Location + ' - ' + location.City + ', ' + location.Country
	    };
	  }
	
	  return service;
	};
	
	iataSearchService.$inject = $inject;
	
	exports['default'] = iataSearchService;
	module.exports = exports['default'];

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$filter', '$rootScope', 'moment', 'APP_CONFIG', '$state'];
	
	var lbHotelSearchService = function lbHotelSearchService($q, $http, $filter, $rootScope, moment, APP_CONFIG, $state) {
	  var service = {};
	
	  service.hasResults = false;
	  service.resultsMaster = [];
	  service.activeFilters = {};
	  service.activeSort = undefined;
	  service.results = {
	    items: [],
	    sorted: [],
	    from: 0,
	    pageSize: 30,
	    matchedItem: null,
	    relevanceOrder: false
	  };
	
	  service.get = get;
	  service.getRates = getRates;
	  service.getReviews = getReviews;
	  service.getPolicy = getPolicy;
	  service.bulkAddFilters = bulkAddFilters;
	  service.filter = filter;
	  service.sort = sort;
	  service.clearResults = clearResults;
	  service.setResults = setResults;
	  service.setUnavailable = setUnavailable;
	  service.getUniqueLocations = getUniqueLocations;
	  service.getMinRateByRating = getMinRateByRating;
	  service.getMaxRate = getMaxRate;
	  service.getMinRate = getMinRate;
	  service.getPolicyTooltipContent = getPolicyTooltipContent;
	  service.getRoomRates = getRoomRates;
	  service.computeRooms = computeRooms;
	
	  function get(params, isPartial) {
	    var deferred = $q.defer();
	
	    var searchParams = {
	      dateFrom: moment(params.DateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(params.DateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      destinationLocationCode: params.Location.Code,
	      paxCount: params.Passengers.length,
	      searchIdentifier: params.Identifier,
	      radiusDistance: params.Location.RadiusDistance,
	      latitude: params.Location.Latitude,
	      longitude: params.Location.Longitude,
	      type: params.Location.Type,
	      name: params.Location.Name
	    };
	
	    if ($state.params && $state.params.hotelId) searchParams.hotelId = $state.params.hotelId;
	
	    var endpoint = 'hotels';
	    var apiUrl = APP_CONFIG.api[endpoint];
	
	    $http.get(apiUrl, { params: searchParams, apiVersion: 21 }).then(function (res) {
	      var data = res.data;
	      data = processResults(data);
	
	      if (!isPartial) {
	        clearFilters();
	        clearSort();
	      }
	
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function computeRooms(rooms) {
	    return rooms.map(function (room) {
	      room.DepositRequired = _.some(room.Rates, { 'GuaranteeType': 'DEP' });
	      room.MinRate = _.reduce(room.Rates, function (rate, prevRate) {
	        return rate.Amount < prevRate.Amount ? rate : prevRate;
	      }, room.Rates[0]);
	      return room;
	    });
	  }
	
	  function processResults(results) {
	    service.results.relevanceOrder = false;
	
	    var processedResults = $filter('deepCopyFilter')(results);
	
	    if (!processedResults.Hotels) {
	      processedResults.Hotels = [];
	    }
	
	    processedResults.Hotels.forEach(function (hotel) {
	      hotel.Rooms = computeRooms(hotel.Rooms);
	
	      if (hotel.Rooms && hotel.Rooms.length) {
	        var cheapestRoom = _.minBy(hotel.Rooms, 'MinRate.Amount');
	        var isDifferentCurrency = hotel.Rooms[0].Rates[0].BaseCurrency.Code != hotel.Rooms[0].Rates[0].Currency;
	
	        hotel.cheapestShowApprox = isDifferentCurrency ? _.some([cheapestRoom], isApprox) : false;
	        hotel.showApprox = isDifferentCurrency ? _.some(hotel.Rooms, isApprox) : false;
	      }
	
	      if (hotel.RelevanceOrder !== null && !service.results.relevanceOrder) {
	        service.results.relevanceOrder = true;
	      }
	    });
	
	    return processedResults;
	  }
	
	  function getRates(params) {
	    var deferred = $q.defer();
	
	    params.dateFrom = moment(params.dateFrom, APP_CONFIG.momentFormat.API).format('YYYY-MM-DD[T]HH:mm:ss');
	    params.dateTo = moment(params.dateTo, APP_CONFIG.momentFormat.API).format('YYYY-MM-DD[T]HH:mm:ss');
	
	    var apiUrl = APP_CONFIG.api.hotelRates;
	
	    $http.get(apiUrl, { params: params }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getReviews(hotelId) {
	    var deferred = $q.defer();
	
	    var searchParams = {
	      hotelId: hotelId
	    };
	
	    var apiUrl = APP_CONFIG.api.hotelReviews;
	
	    $http.get(apiUrl, { params: searchParams }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getPolicy(params) {
	    var deferred = $q.defer();
	
	    var apiUrl = APP_CONFIG.api.hotelPolicy;
	
	    $http.get(apiUrl, { params: params }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function clearFilters() {
	    _.forIn(service.activeFilters, function (filter) {
	      filter.settings.clear();
	    });
	  }
	
	  function clearSort() {
	    service.activeSort = undefined;
	  }
	
	  function clearResults() {
	    service.hasResults = false;
	    service.resultsMaster = [];
	    service.results.items = [];
	    service.results.matchedItem = null;
	    service.results.from = 0;
	  }
	
	  function setResults(results) {
	    service.hasResults = true;
	    service.resultsMaster = results;
	    service.results.items = results;
	    service.results.matchedItem = _.find(results, 'MatchedItem');
	  }
	
	  function setUnavailable(results) {
	    service.unavailable = results;
	  }
	
	  function getUniqueLocations(results) {
	    var locations = [];
	
	    _.forEach(results, function (result) {
	      if (result.Area) {
	        locations.push(result.Area);
	      }
	    });
	
	    return _.uniq(locations);
	  }
	
	  function getMinRateByRating(results, ratings) {
	    var resultsWithRate = _.filter(results, 'DisplayRate');
	
	    var groupedResults = _.groupBy(resultsWithRate, function (result) {
	      return result.Rating;
	    });
	
	    ratings.forEach(function (rating) {
	      rating.minRate = Math.round(_.min(_.map(groupedResults[rating.value], 'DisplayRate')));
	    });
	
	    return ratings;
	  }
	
	  function getMinRate(results) {
	    return Math.ceil(_.min(_.compact(_.map(results, 'DisplayRate'))));
	  }
	
	  function getMaxRate(results) {
	    return Math.ceil(_.max(_.compact(_.map(results, 'DisplayRate'))));
	  }
	
	  function bulkAddFilters(filters) {
	    _.forOwn(filters, function (filter, key) {
	      service.activeFilters[key] = filter;
	    });
	
	    $rootScope.$emit('hotelPaginationReset', true);
	
	    filter();
	  }
	
	  function filter() {
	    process();
	
	    service.results.from = 0;
	  }
	
	  function sort(sortOption) {
	    service.activeSort = sortOption;
	
	    process();
	  }
	
	  function process() {
	    var processedResults = _.clone(service.resultsMaster);
	
	    _.forOwn(service.activeFilters, function (filter) {
	      if (filter.settings.isActive()) {
	        processedResults = $filter(filter.filterName)(processedResults, filter.settings, filter.handleResult);
	      }
	    });
	
	    if (service.activeSort) {
	      processedResults = _.sortBy(processedResults, function (item) {
	        if (service.activeSort.expression === 'DisplayRate') {
	          return item[service.activeSort.expression] || Number.MAX_VALUE;
	        } else {
	          return item[service.activeSort.expression];
	        }
	      });
	
	      if (service.activeSort.isReverse) {
	        processedResults = processedResults.reverse();
	      }
	    }
	
	    service.results.items = processedResults;
	  }
	
	  function isApprox(room) {
	    return room.Provider.Brand === 'EAN' && _.some(room.Rates, { 'PostPaid': true });
	  }
	
	  function getPolicyTooltipContent(rate) {
	    var toolTipContent = '';
	
	    if (rate.Cancellation) {
	      toolTipContent += '<strong>' + rate.Cancellation + '</strong>';
	
	      if (rate.Guarantee) {
	        toolTipContent += '<span>' + rate.Guarantee + '</span>';
	      }
	    }
	
	    return toolTipContent;
	  }
	
	  function getRoomRates(params) {
	    var deferred = $q.defer();
	
	    var searchParams = {
	      dateFrom: moment(params.DateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(params.DateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      destinationLocationCode: params.Location.Code,
	      paxCount: params.Passengers.length,
	      searchIdentifier: params.Identifier,
	      radiusDistance: params.Location.RadiusDistance,
	      latitude: params.Location.Latitude,
	      longitude: params.Location.Longitude,
	      HotelSupplierId: params.HotelSupplierId
	    };
	
	    var apiUrl = APP_CONFIG.api.hotelPartial;
	
	    $http.get(apiUrl, { params: searchParams, apiVersion: 21 }).then(function (res) {
	      var data = res.data;
	      data.Rooms.forEach(function (room) {
	        room.MinRate = _.reduce(room.Rates, function (rate, prevRate) {
	          return rate.Amount < prevRate.Amount ? rate : prevRate;
	        }, room.Rates[0]);
	      });
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	lbHotelSearchService.$inject = $inject;
	
	exports['default'] = lbHotelSearchService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$state', 'lbDialogService'];
	
	var locationService = function locationService($state, lbDialogService) {
	  var searchDefaults = {
	    Hotel: 0,
	    Car: 0,
	    Rail: 0,
	    Flight: 0
	  };
	
	  var service = {
	    currentSearchType: undefined,
	    searchIndex: searchDefaults,
	    reset: reset,
	    updateCurrentSearchType: updateCurrentSearchType,
	    increaseSearchIndex: increaseSearchIndex,
	    nextPage: nextPage,
	    gotoSection: gotoSection,
	    cancelBooking: cancelBooking
	  };
	
	  var sessionSearchIndex = JSON.parse(sessionStorage.getItem('locationService:searchIndex'));
	
	  if (sessionSearchIndex) {
	    service.searchIndex = sessionSearchIndex;
	  }
	
	  function reset() {
	    service.currentSearchType = undefined;
	    service.searchIndex = searchDefaults;
	
	    sessionStorage.removeItem('locationService:currentSearchType');
	    sessionStorage.removeItem('locationService:searchIndex');
	  }
	
	  function updateCurrentSearchType(type) {
	    service.currentSearchType = type;
	    sessionStorage.setItem('locationService:currentSearchType', service.currentSearchType);
	  }
	
	  function increaseSearchIndex(type, increment) {
	    increment = increment || 1;
	
	    var newIndex = service.searchIndex[type] + increment;
	
	    setSearchIndex(type, newIndex);
	  }
	
	  function setSearchIndex(type, value) {
	    service.searchIndex[type] = value;
	    sessionStorage.setItem('locationService:searchIndex', JSON.stringify(service.searchIndex));
	  }
	
	  function nextPage(search, isItineraryChanging, amendSearch) {
	    var searchTypes = search.SearchTypes;
	    var type = service.currentSearchType;
	    var nextType = type;
	
	    if (type) {
	      var searchTypeCompleted = search[type + 's'].length === service.searchIndex[type];
	
	      if (searchTypeCompleted) {
	        setSearchIndex(type, 0);
	
	        var searchTypeIndex = searchTypes.indexOf(type);
	        var nextSearchTypeIndex = searchTypeIndex + 1;
	
	        if (nextSearchTypeIndex < searchTypes.length) {
	          nextType = searchTypes[nextSearchTypeIndex];
	        } else {
	          nextType = 'Confirm';
	        }
	      }
	    } else {
	      nextType = searchTypes[0];
	    }
	
	    gotoSection(nextType, isItineraryChanging, amendSearch);
	  }
	
	  function gotoSection(section, isChanging, amendSearch) {
	    var stateParent = isChanging ? 'app.booking.change' : 'app.booking';
	    if (isChanging && section === 'Car') section = 'Confirm';
	
	    switch (section) {
	      case 'Flight':
	        $state.go(stateParent + '.flights', {}, { reload: true });
	
	        break;
	      case 'Rail':
	        $state.go(stateParent + '.rail', {}, { reload: true });
	
	        break;
	      case 'Hotel':
	        if (isChanging) {
	          var hotelIds = JSON.parse(sessionStorage.getItem('change:HotelIds'));
	          var hotelIdIndex = 0;
	          if ($state.params.hotelId) hotelIdIndex = hotelIds.findIndex(function (hotel) {
	            return '' + hotel === $state.params.hotelId;
	          }) + (amendSearch ? 0 : 1);
	          $state.go(stateParent + '.hotels', { hotelId: hotelIds[hotelIdIndex] }, { reload: true });
	        } else {
	          $state.go(stateParent + '.hotels', {}, { reload: true });
	        }
	
	        break;
	      case 'Car':
	        $state.go(stateParent + '.cars', {}, { reload: true });
	
	        break;
	      case 'Confirm':
	        if (isChanging) {
	          var returnToChangeBookingWizard = sessionStorage.getItem('returnToChangeBookingWizard');
	          if (returnToChangeBookingWizard) {
	            var _JSON$parse = JSON.parse(returnToChangeBookingWizard);
	
	            var sector = _JSON$parse.sector;
	            var pnr = _JSON$parse.pnr;
	
	            $state.go('app.change.sector', { sector: sector, pnr: pnr }, { reload: true });
	          } else {
	            $state.go('app.change.payment', {}, { reload: true });
	          }
	        } else {
	          $state.go('app.itinerary', {}, { reload: true });
	        }
	        break;
	
	      default:
	        console.warn('NO NEXTPAGE FOUND!');
	    }
	  }
	
	  function cancelBooking() {
	    var dialogOptions = {
	      title: 'This will cancel the current search',
	      message: 'Are you sure you want to do this?',
	      warningLevel: 'warning',
	      submitButtonText: 'OK'
	    };
	
	    return lbDialogService.show(dialogOptions);
	  }
	
	  return service;
	};
	
	locationService.$inject = $inject;
	
	exports['default'] = locationService;
	module.exports = exports['default'];

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var locationsSearchService = function locationsSearchService($q, $http, apiService) {
	  var service = {};
	  service.get = get;
	  service.getPoiFromSearchLocation = getPoiFromSearchLocation;
	
	  function get(params) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('locations');
	
	    $http.get(apiUrl, { params: params }).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getPoiFromSearchLocation(searchLocation) {
	    return _.extend({}, searchLocation, {
	      Title: searchLocation.Name,
	      City: {
	        Code: searchLocation.Code
	      }
	    });
	  }
	
	  return service;
	};
	
	locationsSearchService.$inject = $inject;
	
	exports['default'] = locationsSearchService;
	module.exports = exports['default'];

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	
	var ndcExpiredService = function ndcExpiredService(moment) {
	  var service = {};
	
	  service.activeExpirationTime = null;
	
	  service.checkForExpired = function checkForExpired(fare) {
	    if (!fare || !fare.FlightExpirationTimeLimit) return;
	
	    var diff = moment(fare.FlightExpirationTimeLimit).diff(new Date(), 'minutes');
	    console.log('expires in ' + diff + ' mins');
	
	    if (diff <= 0) {
	      service.hasExpired = true;
	    }
	  };
	
	  service.hasExpired = false;
	
	  return service;
	};
	
	ndcExpiredService.$inject = $inject;
	
	exports['default'] = ndcExpiredService;
	module.exports = exports['default'];

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', '$q', 'APP_CONFIG'];
	
	var paymentMethodsService = function paymentMethodsService($http, $q, APP_CONFIG) {
	  var service = {
	    get: get,
	    set: set,
	    getTravellerSectorsGrouped: getTravellerSectorsGrouped,
	    getAllTravellerSectorsGrouped: getAllTravellerSectorsGrouped,
	    findGroupIdsFoundInEverySector: findGroupIdsFoundInEverySector,
	    getAllTravellerAllSectorsGrouped: getAllTravellerAllSectorsGrouped,
	    addPaymentMethod: addPaymentMethod,
	    populateEachPaxWithSelectedPaymentMethods: populateEachPaxWithSelectedPaymentMethods,
	    doGroupIdsMatchToInvoicePaymentMethod: doGroupIdsMatchToInvoicePaymentMethod,
	    checkAllPaxPaymentsSelected: checkAllPaxPaymentsSelected,
	    purgeDuplicatePaymentMethods: purgeDuplicatePaymentMethods,
	    checkForCVV: checkForCVV,
	    addCVVsToPayments: addCVVsToPayments,
	    updatedPaxWithPayments: undefined,
	    paymentMethods: [],
	    activeGroupedSectors: [],
	    activeAllSectors: [],
	    activeSelectedAllPayment: undefined,
	    overrideSectorPaymentChoice: {},
	    selectedPaymentMethods: {},
	    tabIndex: 2
	  };
	
	  function get(itineraryId) {
	    var deferred = $q.defer();
	    var apiConfig = window.svelteStore.apiConfig('itineraryPaymentMethod', itineraryId);
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function set(data) {
	    service.paymentMethods = data;
	  }
	
	  function getTravellerSectorsGrouped(traveller) {
	    return _.flowRight(createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray, createSectorArray)(traveller);
	  }
	
	  function getAllTravellerSectorsGrouped(travellers) {
	    var sectors = [];
	
	    _.forEach(travellers, function (traveller) {
	      sectors.push(createSectorArray(traveller));
	    });
	
	    sectors = _.flatten(sectors);
	
	    return _.flowRight(checkPaymentMethodsIncludeEveryGroupId, combineGroupIds, groupSectorTypes, createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray)(sectors);
	  }
	
	  function createSectorArray(traveller) {
	    var sectors = [];
	
	    if (traveller.Flights.length > 0) {
	      sectors.push({
	        sectorType: 'flights',
	        sectors: traveller.Flights
	      });
	    }
	
	    if (traveller.Hotels.length > 0) {
	      sectors.push({
	        sectorType: 'hotels',
	        sectors: traveller.Hotels
	      });
	    }
	
	    if (traveller.Cars.length > 0) {
	      sectors.push({
	        sectorType: 'cars',
	        sectors: traveller.Cars
	      });
	    }
	
	    if (traveller.Rails.length > 0) {
	      sectors.push({
	        sectorType: 'rails',
	        sectors: traveller.Rails
	      });
	    }
	
	    return sectors;
	  }
	
	  function createSectorGrpArray(sectors) {
	    return _.map(sectors, function (sectorType) {
	
	      sectorType.groups = [];
	
	      _.forEach(sectorType.sectors, function (sector) {
	
	        var group = _.find(sectorType.groups, function (group) {
	          return group.groupId === sector.GroupIdentifier;
	        });
	
	        if (!group) {
	          sectorType.groups.push({
	            groupId: sector.GroupIdentifier,
	            sectors: [sector]
	          });
	        } else {
	          group.sectors.push(sector);
	        }
	      });
	
	      return sectorType;
	    });
	  }
	
	  function createPaymentOptionsArray(groupedSectors) {
	    var paymentMethods = service.paymentMethods;
	
	    return _.map(groupedSectors, function (sectorType) {
	
	      _.forEach(sectorType.groups, function (group) {
	        group.paymentOptions = _.filter(paymentMethods, function (paymentMethod) {
	          return paymentMethod.SectorGroups.indexOf(group.groupId) > -1;
	        });
	      });
	
	      return sectorType;
	    });
	  }
	
	  function createGroupDescriptions(groupedSectors) {
	    return _.map(groupedSectors, function (sectorGroup) {
	      _.forEach(sectorGroup.groups, function (group) {
	        var descriptions = [];
	
	        if (sectorGroup.sectorType === 'flights') {
	          _.forEach(group.sectors, function (sector) {
	            descriptions.push(sector.Carrier + ' ' + sector.FlightNumber);
	          });
	        }
	
	        if (sectorGroup.sectorType === 'hotels') {
	          _.forEach(group.sectors, function (sector) {
	            descriptions.push('' + sector.HotelName);
	          });
	        }
	
	        group.groupDescriptions = descriptions.join(', ');
	      });
	
	      return sectorGroup;
	    });
	  }
	
	  function findGroupIdsFoundInEverySector(sectors) {
	
	    var allGroupIdsInSectors = [];
	    var paymentMethodsFoundInAllActiveGroupIds = [];
	
	    _.forEach(sectors, function (sector) {
	      _.forEach(sector.groups, function (group) {
	        allGroupIdsInSectors.push(group.groupId);
	      });
	    });
	
	    allGroupIdsInSectors = _.uniq(allGroupIdsInSectors);
	
	    _.forEach(service.paymentMethods, function (paymentMethod) {
	      var intersection = _.intersection(allGroupIdsInSectors, paymentMethod.SectorGroups);
	
	      if (intersection.length === allGroupIdsInSectors.length) {
	        paymentMethodsFoundInAllActiveGroupIds.push(paymentMethod);
	      }
	    });
	
	    return paymentMethodsFoundInAllActiveGroupIds;
	  }
	
	  function addPaymentMethod(newPaymentMethod) {
	    var allGroupIds = [];
	
	    _.forEach(service.paymentMethods, function (paymentMethod) {
	      if (paymentMethod.Payment.PaymentType != 'Invoice' && !paymentMethod.IsPaymentOptionLocked) {
	        allGroupIds.push(paymentMethod.SectorGroups);
	      }
	    });
	
	    var groupIds = _.flowRight(_.uniq, _.flatten)(allGroupIds);
	
	    var newPaymentObj = {
	      Payment: {
	        ExpiryMonth: newPaymentMethod.cardExpiryMonth,
	        ExpiryYear: newPaymentMethod.cardExpiryYear,
	        Holder: newPaymentMethod.cardHolder,
	        Number: newPaymentMethod.cardNumber,
	        PaymentType: "Card",
	        Reference: null,
	        SecurityCode: null,
	        SecurityCodeRequired: true,
	        Type: {
	          Code: newPaymentMethod.Card.Type.Code,
	          Value: newPaymentMethod.Card.Type.Code
	        }
	      },
	      SectorGroups: groupIds
	    };
	
	    service.paymentMethods.push(newPaymentObj);
	    service.activeAllSectors.push(newPaymentObj);
	    service.activeSelectedAllPayment = newPaymentObj;
	  }
	
	  function groupSectorTypes(sectorGroups) {
	    var sectorsByGroup = {
	      flights: [],
	      rails: [],
	      hotels: [],
	      cars: []
	    };
	
	    _.forEach(sectorGroups, function (sectorGroup) {
	      sectorsByGroup[sectorGroup.sectorType].push(sectorGroup);
	    });
	
	    return sectorsByGroup;
	  }
	
	  function combineGroupIds(sectorsByGroup) {
	    var groupIDsBySectorType = {};
	
	    _.forEach(sectorsByGroup, function (sectors, sectorType) {
	      if (sectors.length > 0) {
	        groupIDsBySectorType[sectorType] = [];
	        _.forEach(sectors, function (sector) {
	          _.forEach(sector.groups, function (group) {
	            groupIDsBySectorType[sectorType].push(group.groupId);
	          });
	        });
	      }
	    });
	
	    return groupIDsBySectorType;
	  }
	
	  function checkPaymentMethodsIncludeEveryGroupId(groupIDsBySectorType) {
	    // forgive me
	    var paymentsAvailableToEachSectorType = {};
	
	    _.forEach(groupIDsBySectorType, function (sectorGroupIds, sectorType) {
	      paymentsAvailableToEachSectorType[sectorType] = [];
	
	      _.forEach(service.paymentMethods, function (paymentMethod) {
	        var existsInAll = sectorGroupIds.every(function (v, i) {
	          return paymentMethod.SectorGroups.indexOf(v) !== -1;
	        });
	
	        if (existsInAll) {
	          paymentsAvailableToEachSectorType[sectorType].push(paymentMethod);
	        }
	      });
	    });
	
	    return paymentsAvailableToEachSectorType;
	  }
	
	  function getAllTravellerAllSectorsGrouped(groupedSectorPayments) {
	    return _.flowRight(findPaymentMethodByGroupIds, findGroupIdsFoundInEverySectorGroup)(groupedSectorPayments);
	  }
	
	  function findGroupIdsFoundInEverySectorGroup(groupedSectorPayments) {
	    var groupIds = [];
	
	    _.forIn(groupedSectorPayments, function (sectorPaymentGroup) {
	      _.forEach(sectorPaymentGroup, function (sectorPayment) {
	        groupIds.push(sectorPayment.SectorGroups);
	      });
	    });
	
	    return _.uniq(_.flatten(groupIds));
	  }
	
	  function findPaymentMethodByGroupIds(groupIds) {
	    var matchedPayments = [];
	    if (groupIds.length > 0) {
	      _.forEach(service.paymentMethods, function (paymentMethod) {
	        if (_.difference(groupIds, paymentMethod.SectorGroups).length === 0) {
	          matchedPayments.push(paymentMethod);
	        }
	      });
	    }
	    return matchedPayments;
	  }
	
	  function populateEachPaxWithSelectedPaymentMethods(paymentMethods, travellers, cachedTravelers) {
	    return matchPaymentsToTravellers(paymentMethods, travellers, cachedTravelers);
	  }
	
	  function matchPaymentsToTravellers(paymentMethods, travellers, cachedTravelers) {
	    var paymentMissing = 0;
	
	    _.forEach(travellers, function (pax, paxIndex) {
	      var paymentsCopy = angular.copy(pax.Configurations.PaymentMethod.PaymentItems);
	      pax.Configurations.PaymentMethod.PaymentItems = [];
	
	      _.forEach(pax.Flights, function (flight) {
	        if (paymentMethods.allPax && paymentMethods.allPax.flights) {
	          (function () {
	            var matchedCache = cachedTravelers[paxIndex].Configurations.PaymentMethod.PaymentItems.find(function (item) {
	              return item.SectorGroupIdentifier === flight.GroupIdentifier;
	            });
	
	            var locked = false;
	            if (matchedCache && matchedCache.Card) {
	              var paymentMatch = service.paymentMethods.find(function (paymentMethod) {
	                return paymentMethod.Payment.Reference === matchedCache.Card.Reference;
	              });
	              if (paymentMatch && paymentMatch.IsPaymentOptionLocked) locked = true;
	            }
	
	            if (locked) {
	              pax.Configurations.PaymentMethod.PaymentItems.push(matchedCache);
	            } else {
	              pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.flights.Payment, flight.GroupIdentifier, 'Flight'));
	            }
	          })();
	        } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier]) {
	
	          if (!paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Rails, function (rail) {
	
	        if (paymentMethods.allPax && paymentMethods.allPax.rails) {
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.rails.Payment, rail.GroupIdentifier, 'Rail'));
	        } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier]) {
	
	          if (!paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Hotels, function (hotel) {
	
	        if (paymentMethods.allPax && paymentMethods.allPax.hotels) {
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel'));
	        } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier]) {
	
	          if (!paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Cars, function (car) {
	
	        if (paymentMethods.allPax && paymentMethods.allPax.cars) {
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.cars.Payment, car.GroupIdentifier, 'Car'));
	        } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].cars[car.GroupIdentifier]) {
	
	          if (!paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	    });
	
	    return {
	      travellers: travellers,
	      missingPayments: paymentMissing > 0
	    };
	  }
	
	  function doGroupIdsMatchToInvoicePaymentMethod(grpIds, paymentMethods) {
	    var typeInvoice = false;
	
	    _.each(grpIds, function (grpId) {
	      if (!typeInvoice) {
	        _.each(paymentMethods, function (payment) {
	          if (payment.SectorGroups.indexOf(grpId) > -1 && !typeInvoice && payment.Payment.PaymentType === 'Invoice') {
	            typeInvoice = true;
	          }
	        });
	      }
	    });
	
	    return typeInvoice;
	  }
	
	  function buildPaymentObj(Payment, grpId, type) {
	    var paymentObj = {};
	
	    if (Payment.PaymentType === 'Invoice') {
	      paymentObj = {
	        Card: null,
	        Invoice: {
	          PaymentType: 'Invoice',
	          Reference: 'Invoice'
	        },
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    } else {
	      paymentObj = {
	        Card: Payment,
	        Invoice: null,
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    }
	
	    return paymentObj;
	  }
	
	  function checkAllPaxPaymentsSelected(pax) {
	    if (!pax) {
	      return;
	    }
	    var eachSectorHasPayment = true;
	    var sectorGrpIds = [];
	
	    _.forEach(pax.Flights, function (flight) {
	      sectorGrpIds.push(flight.GroupIdentifier);
	    });
	
	    _.forEach(pax.Rails, function (rail) {
	      sectorGrpIds.push(rail.GroupIdentifier);
	    });
	
	    _.forEach(pax.Hotels, function (hotel) {
	      sectorGrpIds.push(hotel.GroupIdentifier);
	    });
	
	    _.forEach(pax.Cars, function (car) {
	      sectorGrpIds.push(car.GroupIdentifier);
	    });
	
	    sectorGrpIds = _.uniq(sectorGrpIds);
	
	    sectorGrpIds.every(function (grpId) {
	      if (eachSectorHasPayment) {
	        var findMatch = _.find(pax.Configurations.PaymentMethod.PaymentItems, function (PaymentItem) {
	          return PaymentItem.SectorGroupIdentifier === grpId;
	        });
	
	        eachSectorHasPayment = !!findMatch;
	      }
	
	      return eachSectorHasPayment;
	    });
	
	    return eachSectorHasPayment;
	  }
	
	  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
	    return _.find(payments, function (payment) {
	      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
	    });
	  }
	
	  function purgeDuplicatePaymentMethods(payments) {
	    var grpIds = [];
	
	    return _.filter(payments, function (payment) {
	      if (grpIds.indexOf(payment.SectorGroupIdentifier) === -1) {
	        grpIds.push(payment.SectorGroupIdentifier);
	        return true;
	      } else {
	        return false;
	      }
	    });
	  }
	
	  function checkForCVV(PaymentItems, cvvObj) {
	    var allCVVsPresent = true;
	
	    PaymentItems.every(function (payment) {
	      if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired) {
	        allCVVsPresent = cvvObj[payment.Card.Reference];
	      }
	
	      return allCVVsPresent;
	    });
	
	    return allCVVsPresent;
	  }
	
	  function addCVVsToPayments(paymentItems, cvvObj) {
	    return _.forEach(paymentItems, function (payment) {
	      if (payment.Card && payment.Card.SecurityCodeRequired) {
	        payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
	      }
	    });
	  }
	
	  return service;
	};
	
	paymentMethodsService.$inject = $inject;
	
	exports['default'] = paymentMethodsService;
	module.exports = exports['default'];

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', 'moment', 'itinerariesService', '$filter'];
	
	var searchFormService = function searchFormService($q, moment, itinerariesService, $filter) {
	  var service = {
	    activeSearchTypes: {
	      Flights: { active: true, showForm: true },
	      Rail: { active: false, showForm: false },
	      Hotels: { active: false, showForm: false },
	      Cars: { active: false, showForm: false }
	    },
	    railOptions: {
	      'return': true,
	      openReturn: false
	    },
	    flightLegs: 2,
	    updateSearchChoices: updateSearchChoices,
	    updateFlightLegs: updateFlightLegs,
	    updateRailReturn: updateRailReturn,
	    updateRailOpenReturn: updateRailOpenReturn,
	    validateThenPostForm: validateThenPostForm,
	    prepRailFormData: prepRailFormData,
	    prepCarFormData: prepCarFormData,
	    prepHotelFormData: prepHotelFormData
	  };
	
	  var DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');
	  var TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');
	
	  function prepCarFormData(searchForm) {
	    var DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');
	    var pickUpDateTime = searchForm.pickUpDate.$modelValue + ' ' + searchForm.pickUpTime.$modelValue;
	    var pickUpDateTimeParsed = moment(pickUpDateTime, DATE_FORMAT_MEDIUM + ' ' + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	
	    var dropOffDateTime = searchForm.dropOffDate.$modelValue + ' ' + searchForm.dropOffTime.$modelValue;
	    var dropOffDateTimeParsed = moment(dropOffDateTime, DATE_FORMAT_MEDIUM + ' ' + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	    var pickupLocation = searchForm.pickUpDepot.$modelValue.Name;
	    var pickupCode = searchForm.pickUpDepot.$modelValue.Value;
	    var pickupCity = searchForm.pickUpCity.$modelValue.City;
	    var pickupCityCode = searchForm.pickUpCity.$modelValue.CityCode;
	    var pickupCountry = searchForm.pickUpCity.$modelValue.Country;
	    var pickupCountryCode = searchForm.pickUpCity.$modelValue.CountryCode;
	    var pickupIsInternational = searchForm.pickUpCity.$modelValue.IsInternational;
	
	    var dropoffLocation = searchForm.dropOffDepot.$modelValue.Name;
	    var dropoffCode = searchForm.dropOffDepot.$modelValue.Value;
	    var dropoffCity = searchForm.dropOffCity.$modelValue.City;
	    var dropoffCityCode = searchForm.dropOffCity.$modelValue.CityCode;
	    var dropoffCountry = searchForm.dropOffCity.$modelValue.Country;
	    var dropoffCountryCode = searchForm.dropOffCity.$modelValue.CountryCode;
	    var dropoffIsInternational = searchForm.pickUpCity.$modelValue.IsInternational;
	
	    var searchObject = {
	      PickUp: {
	        Date: pickUpDateTimeParsed,
	        Location: pickupLocation,
	        Code: pickupCode,
	        City: pickupCity,
	        CityCode: pickupCityCode,
	        Country: pickupCountry,
	        CountryCode: pickupCountryCode,
	        IsInternational: pickupIsInternational
	      },
	      DropOff: {
	        Date: dropOffDateTimeParsed,
	        Location: dropoffLocation,
	        Code: dropoffCode,
	        City: dropoffCity,
	        CityCode: dropoffCityCode,
	        Country: dropoffCountry,
	        CountryCode: dropoffCountryCode,
	        IsInternational: dropoffIsInternational
	      }
	    };
	
	    if (pickupCode === 'other') {
	      var pickUpDepot = {};
	
	      pickUpDepot.Address = searchForm.pickUpOtherLocation.$modelValue.addressLabel;
	      pickUpDepot.Code = searchForm.pickUpOtherLocation.$modelValue.code;
	      pickUpDepot.FullCode = searchForm.pickUpOtherLocation.$modelValue.fullCode;
	      pickUpDepot.Supplier = searchForm.pickUpOtherLocation.$modelValue.supplierId;
	
	      searchObject.PickUp.Code = searchForm.pickUpCity.$modelValue.CityCode;
	      searchObject.PickUp.Location = pickUpDepot.address;
	
	      searchObject.PickUp.Depot = pickUpDepot;
	    }
	
	    if (dropoffCode === 'other') {
	      var dropOffDepot = {};
	
	      dropOffDepot.Address = searchForm.dropOffOtherLocation.$modelValue.addressLabel;
	      dropOffDepot.Code = searchForm.dropOffOtherLocation.$modelValue.code;
	      dropOffDepot.FullCode = searchForm.dropOffOtherLocation.$modelValue.fullCode;
	      dropOffDepot.Supplier = searchForm.dropOffOtherLocation.$modelValue.supplierId;
	
	      searchObject.DropOff.Code = searchForm.dropOffCity.$modelValue.CityCode;
	      searchObject.DropOff.Location = dropOffDepot.address;
	
	      searchObject.DropOff.Depot = dropOffDepot;
	    }
	
	    return searchObject;
	  }
	
	  function prepHotelFormData(searchForm) {
	    var DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');
	    var location = searchForm.hotelLocation.$modelValue;
	    var radius = searchForm.radius.$modelValue.value;
	
	    var checkIn = moment(searchForm.checkInDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD[T]HH:mm:ss');
	    var checkOut = moment(searchForm.checkOutDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD[T]HH:mm:ss');
	
	    return {
	      DateFrom: checkIn,
	      DateTo: checkOut,
	      Location: {
	        City: location.City.Name,
	        Country: location.Country.Name,
	        CountryCode: location.Country.Code,
	        Location: location.Address,
	        IsInternational: '',
	        Code: location.City.Code,
	        Name: location.Title,
	        Type: location.Type,
	        Latitude: location.Latitude,
	        Longitude: location.Longitude,
	        RadiusDistance: radius
	      }
	    };
	  }
	
	  function updateSearchChoices(choice) {
	    var t = service.activeSearchTypes;
	    var r = service.railOptions;
	
	    switch (choice) {
	      case "Flights":
	
	        if (!t.Rail.active && !t.Hotels.active && !t.Cars.active) {
	          t.Flights = { active: true, showForm: true };
	        } else {
	          t.Flights = { active: !t.Flights.active, showForm: !t.Flights.showForm };
	        }
	
	        if (t.Flights.active) {
	          r.openReturn = false;
	          r['return'] = true;
	          t.Rail = { active: false, showForm: false };
	          t.Hotels.showForm = false;
	          t.Cars.showForm = false;
	        } else {
	          t.Hotels.showForm = t.Hotels.active;
	          t.Cars.showForm = t.Cars.active;
	        }
	
	        if ((t.Cars.active || t.Hotels.active) && service.flightLegs === 1) {
	          t.Cars = { active: false, showForm: false };
	          t.Hotels = { active: false, showForm: false };
	          t.Flights = { active: true, showForm: true };
	        }
	
	        break;
	
	      case "Rail":
	
	        if (!t.Flights.active && !t.Hotels.active && !t.Cars.active) {
	          t.Rail.active = { active: true, showForm: true };
	        } else {
	          t.Rail = { active: !t.Rail.active, showForm: !t.Rail.showForm };
	        }
	
	        if (t.Rail.active) {
	          t.Flights = { active: false, showForm: false };
	          t.Hotels.showForm = false;
	          t.Cars = { active: false, showForm: false };
	        } else {
	          t.Hotels.showForm = t.Hotels.active;
	        }
	
	        if (t.Rail.active && !service.railOptions['return']) {
	          t.Hotels = { active: false, showForm: false };
	        }
	
	        if (service.railOptions.openReturn) {
	          t.Hotels = { active: false, showForm: false };
	        }
	
	        break;
	
	      case "Hotels":
	        var hotelActive = t.Hotels.active;
	
	        if (!t.Flights.active && !t.Rail.active && !t.Cars.active) {
	          t.Hotels = { active: true, showForm: true };
	        } else {
	          t.Hotels = { active: !t.Hotels.active, showForm: !t.Hotels.showForm };
	        }
	
	        if (t.Flights.active) {
	          t.Hotels.showForm = false;
	        }
	
	        if (!t.Cars.active && service.flightLegs === 1) {
	          t.Hotels = { active: false, showForm: false };
	        }
	
	        if (t.Flights.active && service.flightLegs === 1) {
	          t.Hotels = { active: true, showForm: true };
	          t.Flights = { active: false, showForm: false };
	        }
	
	        if (t.Rail.active) {
	          if (!r['return'] || r.openReturn) {
	            r.openReturn = false;
	            r['return'] = true;
	            t.Rail = { active: false, showForm: false };
	            t.Hotels = { active: true, showForm: true };
	          } else {
	            if (hotelActive) {
	              t.Hotels = { active: false, showForm: false };
	            } else {
	              t.Hotels = { active: true, showForm: false };
	            }
	          }
	        }
	
	        break;
	
	      case "Cars":
	
	        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active) {
	          t.Cars = { active: true, showForm: true };
	        } else {
	          t.Cars = { active: !t.Cars.active, showForm: !t.Cars.showForm };
	        }
	
	        if (t.Flights.active || t.Rail.active) {
	          t.Cars.showForm = false;
	        }
	
	        if (t.Rail.active) {
	          r.openReturn = false;
	          r['return'] = true;
	          t.Rail = { active: false, showForm: false };
	          t.Cars = { active: true, showForm: true };
	          t.Hotels.showForm = t.Hotels.active;
	        }
	
	        if (t.Flights.active && service.flightLegs === 1) {
	          t.Cars = { active: true, showForm: true };
	          t.Flights = { active: false, showForm: false };
	        }
	
	        break;
	      default:
	        console.warn("NO CART ITEM TYPE FOUND!");
	    }
	  }
	
	  function updateFlightLegs(legs) {
	    var t = service.activeSearchTypes;
	    service.flightLegs = legs;
	
	    if (service.flightLegs === 1) {
	      t.Hotels = { active: false, showForm: false };
	      t.Cars = { active: false, showForm: false };
	    }
	  }
	
	  function updateRailReturn() {
	    var t = service.activeSearchTypes;
	
	    if (!service.railOptions['return']) {
	      t.Hotels = { active: false, showForm: false };
	      t.Cars = { active: false, showForm: false };
	    }
	  }
	
	  function updateRailOpenReturn() {
	    var t = service.activeSearchTypes;
	
	    if (service.railOptions.openReturn) {
	      t.Hotels = {
	        active: false,
	        showForm: false
	      };
	    }
	  }
	
	  function validateThenPostForm(searchForm, travellers) {
	    var DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium').replace(',', '[,]');
	
	    var deferred = $q.defer();
	
	    if (searchForm.$invalid) {
	      deferred.reject();
	    }
	
	    var t = service.activeSearchTypes;
	
	    var orderNumber = searchForm.orderNumber ? searchForm.orderNumber.$modelValue : undefined;
	    if (orderNumber) {
	      orderNumber = orderNumber.hasOwnProperty('Value') ? orderNumber.Value : orderNumber;
	    }
	
	    var searchParams = {
	      search: {
	        Passengers: travellers,
	        Reason: searchForm.reasonForTravel ? searchForm.reasonForTravel.$modelValue.Value : undefined,
	        OrderNumber: orderNumber
	      }
	    };
	    if (t.Flights.showForm) {
	
	      var flightsAmount = searchForm.flightSearch.flightsAmount.$modelValue;
	
	      for (var i = 0; i < flightsAmount; i++) {
	        var flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
	        var flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
	        var flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	
	        var destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
	        var destinationCode = destination.Value;
	        var destinationName = destination.City + ', ' + destination.Country;
	        var originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;
	
	        searchParams = addFlight(searchParams, flightDateTime, originCode, destinationCode);
	
	        if (t.Hotels.active && i != flightsAmount - 1) {
	          var nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
	          var checkOut = moment(nextFlightDate + '0:00 AM', DATE_FORMAT_MEDIUM + 'h:mm A').format('YYYY-MM-DD[T]HH:mm:ss');
	          var checkIn = moment(flightDate + '0:00 AM', DATE_FORMAT_MEDIUM + 'h:mm A').format('YYYY-MM-DD[T]HH:mm:ss');
	          var _location = {
	            Title: destinationName,
	            Code: destinationCode,
	            Type: 'Airport'
	          };
	
	          searchParams = addHotel(searchParams, checkIn, checkOut, _location);
	        }
	
	        if (t.Cars.active && i != flightsAmount - 1) {
	          var nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
	          var nextFlightTime = searchForm.flightSearch['flight' + (i + 2) + 'Time'].$modelValue;
	          var dropOffDateTime = moment(nextFlightDate + nextFlightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	          var dropOffCode = searchForm.flightSearch['flight' + (i + 2) + 'Departure'].$modelValue.Value;
	
	          var searchObject = {
	            PickUp: {
	              Date: flightDateTime,
	              Code: destinationCode
	            },
	            DropOff: {
	              Date: dropOffDateTime,
	              Code: dropOffCode
	            }
	          };
	
	          searchParams = addCar(searchParams, searchObject);
	        }
	      }
	    }
	
	    if (t.Rail.showForm) {
	      searchParams = service.prepRailFormData(searchForm, searchParams);
	
	      if (t.Hotels.active) {
	        var checkIn = searchParams.search.Rails[0].Date;
	        var checkOut = searchParams.search.Rails[1].Date;
	
	        var _location2 = {
	          Title: searchForm.railTo.$modelValue.CityName + ', ' + searchForm.railTo.$modelValue.CountryName,
	          Code: searchForm.railTo.$modelValue.Iata,
	          Type: 'Airport'
	        };
	
	        searchParams = addHotel(searchParams, checkIn, checkOut, _location2);
	      }
	    }
	
	    if (t.Hotels.showForm) {
	      var checkIn = moment(searchForm.checkInDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD');
	      var checkOut = moment(searchForm.checkOutDate.$modelValue, DATE_FORMAT_MEDIUM).format('YYYY-MM-DD');
	      var _location3 = searchForm.hotelLocation.$modelValue;
	      _location3.Code = _location3.City.Code;
	
	      searchParams = addHotel(searchParams, checkIn, checkOut, _location3);
	    }
	
	    if (t.Cars.showForm) {
	      var searchObject = prepCarFormData(searchForm);
	      searchParams = addCar(searchParams, searchObject);
	    }
	
	    itinerariesService.post(searchParams).then(function (itineraryResponse) {
	      deferred.resolve(itineraryResponse);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function addFlight(searchParams, dateTime, originCode, destinationCode) {
	    searchParams.search.Flights = searchParams.search.Flights || [];
	    searchParams.search.Flights.push({
	      Origin: {
	        Code: originCode
	      },
	      Destination: {
	        Code: destinationCode
	      },
	      Date: dateTime
	    });
	
	    return searchParams;
	  }
	
	  function addHotel(searchParams, checkIn, checkOut, location) {
	    searchParams.search.Hotels = searchParams.search.Hotels || [];
	
	    searchParams.search.Hotels.push({
	      dateFrom: checkIn,
	      dateTo: checkOut,
	      Location: {
	        Code: location.Code,
	        Name: location.Title,
	        Type: location.Type,
	        Latitude: location.Latitude,
	        Longitude: location.Longitude
	      }
	    });
	
	    return searchParams;
	  }
	
	  function addCar(searchParams, searchObject) {
	    searchParams.search.Cars = searchParams.search.Cars || [];
	    searchParams.search.Cars.push(searchObject);
	
	    return searchParams;
	  }
	
	  function prepRailFormData(searchForm, searchParams) {
	    var from = { Code: searchForm.railFrom.$modelValue.Code };
	    var to = { Code: searchForm.railTo.$modelValue.Code };
	    var fromDate = searchForm.outboundDate.$modelValue + ' ' + searchForm.outboundTime.$modelValue;
	    var fromDateParsed = moment(fromDate, 'DD MMM, YYYY ' + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	    var toDate = searchForm.returnDate.$modelValue + ' ' + searchForm.returnTime.$modelValue;
	    var toDateParsed = moment(toDate, 'DD MMM, YYYY ' + TIME_FORMAT).format('YYYY-MM-DD[T]HH:mm:ss');
	    var railCardCode = undefined;
	    var openReturn = searchForm.openReturn.$modelValue;
	
	    if (searchForm.railCard && searchForm.railCard.$modelValue) {
	      railCardCode = searchForm.railCard.$modelValue.InternalCode;
	    }
	
	    searchParams.search.Rails = [{
	      Origin: from,
	      Destination: to,
	      Date: fromDateParsed,
	      RailCardCode: railCardCode,
	      OpenReturn: openReturn
	    }];
	
	    if (searchForm.railReturn.$modelValue && !openReturn) {
	      searchParams.search.Rails.push({
	        Origin: to,
	        Destination: from,
	        Date: toDateParsed,
	        RailCardCode: railCardCode
	      });
	    }
	
	    return searchParams;
	  }
	
	  return service;
	};
	
	searchFormService.$inject = $inject;
	
	exports['default'] = searchFormService;
	module.exports = exports['default'];

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var seatNumberService = function seatNumberService() {
	  var service = {};
	
	  service.activeSeat = null;
	  service.set = set;
	
	  return service;
	
	  function set(seat) {
	    service.activeSeat = seat;
	  }
	};
	
	seatNumberService.$inject = $inject;
	
	exports["default"] = seatNumberService;
	module.exports = exports["default"];

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment', '$filter'];
	
	var sectorService = function sectorService(moment, $filter) {
	  return {
	    reorder: reorder,
	    abridge: abridge,
	    priceSummary: priceSummary,
	    currentStatus: currentStatus
	  };
	
	  function reorder(obj) {
	
	    var allSectors = [].concat(obj.Flights, obj.Rails, obj.Hotels, obj.Cars);
	    var sectorTypeOrder = ['flight', 'rail', 'hotel', 'car'];
	
	    angular.forEach(allSectors, function (sector) {
	      if (sector.Carrier) {
	        sector.sectorType = sectorTypeOrder[0];
	        sector.date = sector.Departure.Date;
	      }
	
	      if (sector.RailNumber) {
	        sector.sectorType = sectorTypeOrder[1];
	        sector.date = sector.Departure.Date;
	      }
	
	      if (sector.HotelCode) {
	        sector.sectorType = sectorTypeOrder[2];
	        sector.date = sector.DateFrom;
	      }
	
	      if (sector.PickUp) {
	        sector.sectorType = sectorTypeOrder[3];
	        sector.date = sector.PickUp.Date;
	      }
	    });
	
	    allSectors.sort(function (x, y) {
	      var n = moment(x.date, 'YYYY-MM-DD').format('YYYYMMDD') - moment(y.date, 'YYYY-MM-DD').format('YYYYMMDD');
	
	      return n !== 0 ? n : sectorTypeOrder.indexOf(x.sectorType) - sectorTypeOrder.indexOf(y.sectorType);
	    });
	
	    return allSectors;
	  }
	
	  function abridge(sectors) {
	
	    var DATE_FORMAT_LONG = $filter('translate')('dates.DateFormatLong');
	
	    var trip = {
	      travelType: '',
	      flights: []
	    };
	
	    var hotels = [];
	    var cars = [];
	    var land = [];
	    var start = undefined;
	    var end = undefined;
	
	    angular.forEach(sectors, function (sector) {
	
	      var location = {};
	
	      if (sector.sectorType === 'flight' || sector.sectorType === 'rail') {
	        location.startLocation = sector.Departure.Code;
	        location.endLocation = sector.Arrival.Code;
	        location.startDate = sector.Departure.Date;
	        location.endDate = sector.Arrival.Date;
	
	        trip.flights.push(location);
	      }
	
	      if (sector.sectorType === 'hotel') {
	        location.startLocation = sector.Location.Code;
	        location.endLocation = sector.Location.Code;
	        location.startDate = sector.DateFrom;
	        location.endDate = sector.DateTo;
	
	        hotels.push(location);
	        land.push(location);
	      }
	
	      if (sector.sectorType === 'car') {
	        location.startLocation = sector.PickUp.Code;
	        location.endLocation = sector.DropOff.Code;
	        location.startDate = sector.PickUp.Date;
	        location.endDate = sector.DropOff.Date;
	
	        cars.push(location);
	        land.push(location);
	      }
	    });
	
	    if (trip.flights.length === 1) {
	      trip.travelType = 'oneway';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[0].endDate;
	    } else if (trip.flights.length === 2 && trip.flights[0].startLocation === trip.flights[trip.flights.length - 1].endLocation) {
	      trip.travelType = 'return';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[1].endDate;
	    } else if (trip.flights.length > 1) {
	      trip.travelType = 'multi';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[trip.flights.length - 1].endDate;
	    } else {
	      if (hotels.length && cars.length) {
	        trip.travelType = 'land';
	
	        start = land[0].startDate;
	        end = land[land.length - 1].endDate;
	      } else if (hotels.length) {
	        trip.travelType = 'hotel';
	
	        start = hotels[0].startDate;
	        end = hotels[hotels.length - 1].endDate;
	      } else if (cars.length) {
	        trip.travelType = 'car';
	
	        start = cars[0].startDate;
	        end = cars[cars.length - 1].endDate;
	      }
	    }
	
	    if (start && end) {
	      var startMoment = moment(start, 'YYYY-MM-DD').startOf('day');
	      var endMoment = moment(end, 'YYYY-MM-DD').startOf('day');
	
	      trip.length = endMoment.diff(startMoment, 'days');
	      trip.startDate = startMoment.format(DATE_FORMAT_LONG);
	      trip.endDate = endMoment.format(DATE_FORMAT_LONG);
	    }
	
	    trip.title = tripTitle(trip);
	
	    return trip;
	  }
	
	  function priceSummary(sectors, config) {
	
	    var priceTotals = {
	      Flight: [],
	      Rail: [],
	      Hotel: [],
	      Car: [],
	      Seat: [],
	      flights: 0,
	      rails: 0,
	      hotels: 0,
	      cars: 0,
	      combined: 0,
	      lostSavings: 0
	    };
	
	    _.forEach(config.PaymentMethod.PaymentItems, function (paymentMethod) {
	      paymentMethod = buildPaymentMethodTitle(paymentMethod, sectors);
	
	      if (paymentMethod.Invoice) {
	        paymentMethod.Invoice.titleArray = paymentMethod.sectorTitlesArray;
	        priceTotals[paymentMethod.Type].push(paymentMethod.Invoice);
	      } else {
	        paymentMethod.Card.titleArray = paymentMethod.sectorTitlesArray;
	        priceTotals[paymentMethod.Type].push(paymentMethod.Card);
	      }
	    });
	
	    angular.forEach(sectors, function (sector) {
	      priceTotals.lostSavings += sector.LostSavingsAmount;
	
	      if (sector.sectorType === 'flight') {
	        priceTotals.flights += sector.TotalAmount;
	      }
	
	      if (sector.sectorType === 'rail') {
	        priceTotals.rails += sector.TotalAmount;
	      }
	
	      if (sector.sectorType === 'hotel') {
	        priceTotals.hotels += sector.TotalAmount;
	      }
	
	      if (sector.sectorType === 'car') {
	        priceTotals.cars += sector.TotalAmount;
	      }
	    });
	
	    priceTotals.combined = priceTotals.flights + priceTotals.rails + priceTotals.hotels + priceTotals.cars;
	
	    return priceTotals;
	  }
	
	  function currentStatus(passenger) {
	    var approvalStates = {
	      Auto: {
	        id: 'AU',
	        message: 'Auto approval',
	        'class': 'approvalApproved'
	      },
	      Pending: {
	        id: 'AW',
	        message: 'Awaiting approval',
	        'class': 'approvalPending'
	      },
	      Approved: {
	        id: 'AP',
	        message: 'Approved',
	        'class': 'approvalApproved'
	      },
	      Declined: {
	        id: 'DN',
	        message: 'Denied',
	        'class': 'approvalDenied'
	      },
	      Expired: {
	        id: 'EX',
	        message: 'Expired',
	        'class': 'approvalExpired'
	      }
	    };
	
	    return approvalStates[passenger.ApprovalState];
	  }
	
	  function tripTitle(trip) {
	    switch (trip.travelType) {
	      case 'oneway':
	        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
	        break;
	      case 'return':
	        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
	        break;
	      case 'multi':
	        return _.join(_.map(trip.flights, 'startLocation'), ' > ');
	        break;
	      case 'land':
	        return 'Hotel and Car Booking';
	        break;
	      case 'hotel':
	        return 'Hotel booking';
	        break;
	      case 'car':
	        return 'Car booking';
	        break;
	      default:
	        return 'Lightning booking';
	    }
	  }
	
	  function buildPaymentMethodTitle(paymentMethod, sectors) {
	    var grpId = paymentMethod.SectorGroupIdentifier;
	
	    paymentMethod.sectorTitlesArray = [];
	
	    _.forEach(sectors, function (sector) {
	
	      if (sector.GroupIdentifier === grpId && sector.sectorType === 'flight') {
	        paymentMethod.sectorTitlesArray.push(sector.Carrier + ' ' + sector.FlightNumber);
	      }
	    });
	
	    return paymentMethod;
	  }
	};
	
	sectorService.$inject = $inject;
	
	exports['default'] = sectorService;
	module.exports = exports['default'];

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$translate', '$window', 'apiService'];
	
	var settingsService = function settingsService($q, $http, $translate, $window, apiService) {
	  var service = {};
	
	  service.settings = null;
	  service.settingsRequired = true;
	  service.settingsLoading = false;
	  service.allowNoSettingsForConsultant = false;
	  service.getAny = getAny;
	  service.get = get;
	  service.clear = clear;
	  service.isOneWayFare = isOneWayFare;
	  service.getRailCards = getRailCards;
	  service.currencyCode = currencyCode;
	  service.getHotelPaymentNarrativesByIds = getHotelPaymentNarrativesByIds;
	
	  function getAny() {
	    if (service.settings) {
	      var deferred = $q.defer();
	      deferred.resolve(service.settings);
	      return deferred.promise;
	    } else {
	      return get();
	    }
	  }
	
	  function get() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('settings');
	
	    var request = {};
	    request.method = 'GET';
	    request.url = apiUrl;
	    request.apiVersion = 20;
	
	    service.settingsLoading = true;
	    $http(request).then(function (res) {
	      var data = res.data;
	
	      service.settingsLoading = false;
	      service.settings = data;
	      window.sessionStorage.setItem('NeedsFederatedLogout', data.NeedsFederatedLogout);
	      window.sessionStorage.setItem('CarbonEmissionSetting', JSON.stringify(data.CarbonEmissionSetting));
	      $window.settings = data;
	
	      if (data.Locale) {
	        setLocale(data.Locale);
	      }
	
	      if (data.Location) {
	        setLocation(data.Location);
	      }
	
	      deferred.resolve(data);
	    });
	
	    return deferred.promise;
	  }
	
	  function clear() {
	    service.settings = null;
	  }
	
	  function setLocale(localeCode) {
	    window.sessionStorage.setItem('i18nCode', localeCode);
	    $translate.use(localeCode);
	  }
	
	  function setLocation(locationCode) {
	    window.sessionStorage.setItem('locationCode', locationCode);
	  }
	
	  function isOneWayFare(origin, destination) {
	    return _.some(service.settings.FlightConfiguration.OneWayFareRules, function (rule) {
	      return rule.Origin === origin.CountryCode && rule.Destination === destination.CountryCode;
	    });
	  }
	
	  function getRailCards() {
	    if (!service.settings.RailConfiguration || !service.settings.RailConfiguration.RailCard) {
	      return undefined;
	    }
	
	    return service.settings.RailConfiguration.RailCard;
	  }
	
	  function currencyCode() {
	    return service.settings.Currency.Code;
	  }
	
	  function getHotelPaymentNarrativesByIds(codes) {
	    return _.filter(service.settings.HotelConfiguration.PaymentNarratives, function (narrative) {
	      return _.includes(codes, narrative.PaymentCode);
	    });
	  }
	
	  return service;
	};
	
	settingsService.$inject = $inject;
	
	exports['default'] = settingsService;
	module.exports = exports['default'];

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$state', 'itinerariesService', 'seatMapService'];
	
	var stateResolveService = function stateResolveService($q, $state, itinerariesService, seatMapService) {
	
	  var service = {
	    setActivePax: setActivePax,
	    setActiveSeatMap: setActiveSeatMap,
	    setTransport: setTransport
	  };
	
	  function setActivePax($stateParams, deferred) {
	    itinerariesService.get($stateParams.itineraryId).then(function () {
	      seatMapService.init(itinerariesService.itinerary.Passengers, $stateParams.paxId);
	
	      var activePaxId = seatMapService.findIdentifierIn($stateParams.paxId, itinerariesService.itinerary, 'Passengers');
	
	      if (activePaxId) {
	        deferred.resolve();
	      } else {
	        deferred.reject('No passenger found');
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function setActiveSeatMap($stateParams, deferred) {
	    var activePax = seatMapService.findIdentifierIn($stateParams.activePaxId, seatMapService, 'paxArray');
	
	    if (!activePax) {
	      seatMapService.error = true;
	      deferred.reject('No passenger found');
	      return;
	    }
	
	    seatMapService.setActive(activePax, 'activePax');
	
	    var flight = seatMapService.findIdentifierIn($stateParams.flightId, seatMapService.activePax, 'Flights');
	
	    if (!flight) {
	      seatMapService.error = true;
	      deferred.reject('No flight found');
	      return;
	    }
	
	    flight.showStops = true;
	    flight.seatmaps = true;
	    seatMapService.setActive(flight, 'activeFlight');
	
	    if (!seatMapService.activeSeatMap) {
	      //seatMapService.activeSeatMap = true;
	
	      seatMapService.get($stateParams.itineraryId, $stateParams.activePaxId, $stateParams.flightId).then(function (data) {
	        flight.transports = data.Transport;
	        service.setTransport($stateParams.transportIndex, flight);
	
	        deferred.resolve();
	      });
	    } else {
	      service.setTransport($stateParams.transportIndex, flight);
	
	      deferred.resolve();
	    }
	
	    return deferred.promise;
	  }
	
	  function setTransport(transportIndex, flight) {
	    if (flight.transports.length === 0) {
	      return;
	    }
	
	    seatMapService.setActiveSeatMap(flight.transports[transportIndex]);
	    seatMapService.setActive(flight.transports[transportIndex], 'activeTransport');
	
	    if (seatMapService.activeSeatMap.Decks.length > 0) {
	      seatMapService.setActive(seatMapService.activeSeatMap.Decks[0], 'activeDeck');
	      seatMapService.activeDeck.formatted = seatMapService.buildDeck(seatMapService.activeDeck);
	    }
	  }
	
	  return service;
	};
	
	stateResolveService.$inject = $inject;
	
	exports['default'] = stateResolveService;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment'];
	
	var timesService = function timesService($filter, moment) {
	  var service = {
	    getSelectOptions: getSelectOptions
	  };
	
	  return service;
	
	  function getSelectOptions(timeFormat, includeAnytime) {
	    var timeOptions = [];
	
	    if (includeAnytime) {
	      timeOptions.push({
	        value: moment('12:00 AM', 'h:mm A').format(timeFormat),
	        label: 'Anytime'
	      });
	    }
	
	    for (var i = 0; i <= 23; i++) {
	      var amPm = i < 12 ? 'AM' : 'PM';
	      var j = i > 12 || i === 0 ? Math.abs(i - 12) : i;
	      var startHour = j + ':00 ' + amPm;
	      var halfHour = j + ':30 ' + amPm;
	
	      timeOptions.push({
	        value: moment(startHour, 'h:mm A').format(timeFormat),
	        label: moment(startHour, 'h:mm A').format(timeFormat)
	      });
	
	      timeOptions.push({
	        value: moment(halfHour, 'h:mm A').format(timeFormat),
	        label: moment(halfHour, 'h:mm A').format(timeFormat)
	      });
	    }
	
	    return timeOptions;
	  }
	};
	
	timesService.$inject = $inject;
	
	exports['default'] = timesService;
	module.exports = exports['default'];

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$document', '$timeout', '$q'];
	
	var toggleService = function toggleService($document, $timeout, $q) {
	  var service = {
	    elements: []
	  };
	
	  $document.bind('mousedown', function (event) {
	
	    var isClickedElementChildOfPopup = false;
	    var scope = undefined;
	
	    angular.forEach(service.elements, function (element) {
	
	      if (!isClickedElementChildOfPopup) {
	        isClickedElementChildOfPopup = element[0].contains(event.target);
	      }
	
	      scope = element.pageScope;
	    });
	
	    if (!isClickedElementChildOfPopup) {
	      angular.forEach(service[scope], function (item, key) {
	        service[scope][key] = false;
	      });
	
	      $timeout(function () {
	        service[scope] = service[scope];
	      }, 0);
	    } else {
	      event.preventDefault();
	      event.stopPropagation();
	    }
	  });
	
	  service.subscribe = function subscribe(scope, name, element) {
	    element.pageScope = scope;
	    service.elements.push(element);
	
	    service[scope] = service[scope] || {};
	
	    service[scope][name] = false;
	  };
	
	  service.reset = function reset(scope) {
	    delete service[scope];
	    service.elements = [];
	  };
	
	  service.remove = function reset(scope, key) {
	    if (service.hasOwnProperty(scope)) {
	      delete service[scope][key];
	    }
	  };
	
	  service.toggle = function toggle(scope, name) {
	    var deferred = $q.defer();
	
	    angular.forEach(service[scope], function (item, key) {
	      if (name == key) {
	        service[scope][key] = !service[scope][key];
	      } else {
	        service[scope][key] = false;
	      }
	    });
	
	    deferred.resolve(service[scope][name]);
	
	    return deferred.promise;
	  };
	
	  return service;
	};
	
	toggleService.$inject = $inject;
	
	exports['default'] = toggleService;
	module.exports = exports['default'];

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'settingsService', 'cartService'];
	
	var travelFiltersService = function travelFiltersService($filter, moment, settingsService, cartService) {
	  var service = {};
	
	  var TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');
	
	  service.getFilters = getFilters;
	
	  function getFilters() {
	    return new Filters();
	  }
	
	  function Filters() {
	    this.clean = {
	      filterName: 'travelCleanFilter',
	      settings: {
	        isActive: function isActive() {
	          return true;
	        }
	      }
	    };
	
	    this.cartItems = {
	      label: 'Cart',
	      filterName: 'cartItemsFilter',
	      settings: {
	        cartItems: cartService.items,
	        resultsIndex: 0,
	        isActive: function isActive() {
	          return this.cartItems.length;
	        }
	      }
	    };
	
	    this.cheapestFare = {
	      name: 'cheapestFare',
	      filterName: 'cheapestFareFilter',
	      clearActiveFilters: true,
	      settings: {
	        enabled: false,
	        isActive: function isActive() {
	          return this.enabled;
	        }
	      }
	    };
	
	    this.timeRange = {
	      filterName: 'timeOfDayFilter',
	      settings: {
	        reference: 'DepartureTime',
	        start: 0,
	        end: 1440,
	        val: 'All',
	        isActive: function isActive() {
	          return this.start > 0 || this.end < 1440;
	        }
	      }
	    };
	
	    this.priceRange = {
	      label: 'Price',
	      labelSuffix: '(' + settingsService.settings.Currency.Code + ')',
	      filterName: 'travelPriceRangeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'Price',
	        defaultMax: 0,
	        defaultMin: 0,
	        maxValue: 0,
	        minValue: 0,
	        step: 1,
	        translateFunc: function translateFunc(value) {
	          return $filter('currency')(value, '', 0);
	        },
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.departureTimeRange = {
	      label: 'Departure Time',
	      filterName: 'travelTimeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'DepartureTime',
	        defaultMax: 1439,
	        defaultMin: 0,
	        maxValue: 1439,
	        minValue: 0,
	        step: 5,
	        translateFunc: translateMinutesTime,
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.arrivalTimeRange = {
	      label: 'Arrival Time',
	      filterName: 'travelTimeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'ArrivalTime',
	        defaultMax: 1439,
	        defaultMin: 0,
	        maxValue: 1439,
	        minValue: 0,
	        step: 5,
	        translateFunc: translateMinutesTime,
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.carrier = {
	      label: 'Airlines',
	      filterName: 'anyInCollectionFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'multiSelect',
	        reference: 'Carrier',
	        selectedReference: 'value',
	        options: [],
	        selected: [],
	        isActive: function isActive() {
	          return this.selected.length > 0;
	        },
	        clear: function clear() {
	          this.selected = [];
	        }
	      }
	    };
	
	    this.stopsOptionList = {
	      label: 'Stops',
	      filterName: 'anyInArrayFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'checkboxGroup',
	        reference: 'Stops',
	        options: [{
	          value: 0,
	          label: 'Nonstop',
	          id: 'Stops-0'
	        }, {
	          value: 1,
	          label: '1 stop',
	          id: 'Stops-1'
	        }, {
	          value: 2,
	          label: '2 stops',
	          id: 'Stops-2'
	        }, {
	          value: 3,
	          label: '3 stops',
	          id: 'Stops-3'
	        }],
	        selected: [],
	        isActive: function isActive() {
	          return this.selected.length;
	        },
	        clear: function clear() {
	          this.selected = [];
	        }
	      }
	    };
	
	    this.displayFare = {
	      filterName: 'travelDisplayFareFilter',
	      settings: {
	        isActive: function isActive() {
	          return true;
	        }
	      }
	    };
	  }
	
	  function translateMinutesTime(mins) {
	    var hours = Math.floor(mins / 60);
	    var minutes = mins % 60;
	
	    if (hours === 24 && minutes === 0) {
	      hours = 23;
	      minutes = 59;
	    }
	
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	
	    return moment(hours + ':' + minutes, 'H:mm').format(TIME_FORMAT);
	  }
	
	  return service;
	};
	
	travelFiltersService.$inject = $inject;
	
	exports['default'] = travelFiltersService;
	module.exports = exports['default'];

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var $inject = ['$http', '$q', '$filter', '$rootScope', 'moment', 'apiService', 'cartService', 'changeCartService', 'settingsService', 'travelFiltersService'];
	
	var travelService = function travelService($http, $q, $filter, $rootScope, moment, apiService, cartService, changeCartService, settingsService, travelFiltersService) {
	  var service = {
	    resultsMaster: [],
	    results: [],
	    economyClasses: [],
	    fareClasses: [],
	    hasResults: false,
	    init: init,
	    getResults: getResults,
	    getSeatMap: getSeatMap,
	    computeSearches: computeSearches,
	    getFlightInfo: getFlightInfo,
	    getTravelDetail: getTravelDetail,
	    getFareRules: getFareRules,
	    prepData: prepData,
	    addFilter: addFilter,
	    addFilters: addFilters,
	    updateFilters: updateFilters,
	    removeFilter: removeFilter,
	    process: process,
	    sort: sort,
	    itemAddedToCart: itemAddedToCart
	  };
	
	  $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
	
	  function init() {
	    service.resultsMaster = [];
	    service.results = [];
	    service.economyClasses = [];
	    service.fareClasses = [];
	    service.hasResults = false;
	  }
	
	  function getResults(searches, isChanging) {
	    var searchRequest = _.clone(searches);
	    var apiConfig = window.svelteStore.apiConfig('travelSearch');
	
	    _.forEach(searchRequest, function (search) {
	      search.PaxCount = search.Passengers.length;
	      search.Searches = [{
	        Identifier: search.Identifier,
	        Type: 'Flight'
	      }];
	    });
	
	    $http['post'](apiConfig.url, searchRequest, {
	      errorMessage: 'searching for travel',
	      apiVersion: apiConfig.version
	    }).then(function (res) {
	      var data = res.data;
	
	      _.forEach(data, function (result, resultIndex) {
	        service.results[resultIndex] = prepData(result, resultIndex, data.length, isChanging);
	      });
	
	      service.resultsMaster = $filter('deepCopyFilter')(service.results);
	
	      service.hasResults = true;
	    });
	  }
	
	  function getSeatMap(flights) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('travelSeatMap');
	
	    $http.post(apiUrl, { SeatMapSearches: flights }, { apiVersion: 21 }).then(function (res) {
	      var data = res.data;
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getFareClassGroupTypes(flight, from, to, legacyMode) {
	    if (legacyMode) {
	      var _ret = (function () {
	        var groupTypes = {};
	
	        _.forEach(flight.FareClasses, function (fareClass) {
	          if (fareClass) {
	            fareClass.Fares.forEach(function (fare) {
	              if (fare && !groupTypes[fare.GroupType]) {
	                groupTypes[fare.GroupType] = fare.CabinCode;
	              }
	            });
	          }
	        });
	
	        return {
	          v: _.isEmpty(groupTypes) ? undefined : groupTypes
	        };
	      })();
	
	      if (typeof _ret === 'object') return _ret.v;
	    } else {
	      var _ret2 = (function () {
	        var groupTypes = [];
	
	        _.forEach(flight.FareClasses, function (fareClass) {
	          _.forEach(fareClass.Fares, function (_ref) {
	            var CabinCode = _ref.CabinCode;
	            var GroupType = _ref.GroupType;
	            var ResBookDesignCode = _ref.ResBookDesignCode;
	            var OriginLocationCode = _ref.OriginLocationCode;
	            var DestinationLocationCode = _ref.DestinationLocationCode;
	
	            if (from === OriginLocationCode && to === DestinationLocationCode) {
	              groupTypes.push({
	                CabinCode: CabinCode,
	                CabinName: GroupType,
	                BookingCode: ResBookDesignCode
	              });
	            }
	          });
	        });
	
	        return {
	          v: Array.from(new Set(groupTypes.map(function (item) {
	            return JSON.stringify(item);
	          })), function (item) {
	            return JSON.parse(item);
	          })
	        };
	      })();
	
	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }
	
	  function computeFlightData(gdsProvider, from, to, outboundFlight, inboundFlight, parentFlight, legacyMode) {
	    return {
	      OriginLocationCode: from,
	      DestinationLocationCode: to,
	      FlightNumber: outboundFlight.TripNumber,
	      CarrierCode: outboundFlight.Carrier,
	      OperatingCarrierCode: outboundFlight.OperatingCarrier,
	      OperatingCarrierFlightNumber: outboundFlight.OperatingCarrierTripNumber,
	      DepartureDateTimeOffset: outboundFlight.DepartureDateTimeOffset,
	      ArrivalDateTimeOffset: inboundFlight.DepartureDateTimeOffset,
	      GdsProvider: gdsProvider,
	      FareClassGroupTypes: getFareClassGroupTypes(parentFlight, from, to, legacyMode)
	    };
	  }
	
	  function computeSearches(_ref2) {
	    var flight = _ref2.flight;
	    var legacyMode = _ref2.legacyMode;
	
	    var searches = [];
	
	    if (flight.Legs.length === 0) {
	      searches.push(computeFlightData(flight.GdsProvider, flight.OriginLocationCode, flight.DestinationLocationCode, flight, flight, flight, legacyMode));
	    } else {
	      searches.push(computeFlightData(flight.GdsProvider, flight.OriginLocationCode, flight.Legs[0].Origin.Code, flight, flight.Legs[0], flight, legacyMode));
	
	      _.forEach(flight.Legs, function (leg, legIndex) {
	        if (legIndex === flight.Legs.length - 1) {
	          searches.push(computeFlightData(flight.GdsProvider, leg.Origin.Code, flight.DestinationLocationCode, leg, flight, flight, legacyMode));
	        } else {
	          searches.push(computeFlightData(flight.GdsProvider, leg.Origin.Code, flight.Legs[legIndex + 1].Origin.Code, leg, flight.Legs[legIndex + 1], flight, legacyMode));
	        }
	      });
	    }
	
	    return searches;
	  }
	
	  function getTravelDetail(travel) {
	    var deferred = $q.defer();
	
	    if (travel.Details.length) {
	      deferred.resolve(travel.Details);
	    } else {
	      var apiUrl = apiService.getUrl('travelDetail', {
	        type: travel.Type,
	        travelId: travel.Identifier
	      });
	
	      var params = {
	        searchIdentifier: travel.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).then(function (res) {
	        var data = res.data;
	        travel.Details = data;
	        deferred.resolve(travel.Details);
	      })['catch'](function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function getFlightInfo(flight) {
	    var deferred = $q.defer();
	
	    if (flight.Information) {
	      deferred.resolve(flight.Information);
	    } else {
	      var apiUrl = apiService.getUrl("flightInformation");
	
	      var searchData = computeSearches({ flight: flight, legacyMode: true });
	
	      $http.post(apiUrl, {
	        FlightInformationSearches: searchData
	      }).then(function (res) {
	        var data = res.data;
	        flight.Information = data;
	        deferred.resolve(flight.Details);
	      })['catch'](function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function getFareRules(sector, fare) {
	    var deferred = $q.defer();
	
	    if (fare.RemarksCollection) {
	      var fareRuleData = function fareRuleData() {
	        var text = '';
	        _.forEach(fare.RemarksCollection, function (obj) {
	          text = text + obj.Code + '\n' + obj.Value + '\n\n';
	        });
	        return text;
	      };
	
	      var fareRules = {
	        Type: 'Text',
	        Data: fareRuleData()
	      };
	
	      deferred.resolve(fareRules);
	    } else {
	      var apiUrl = apiService.getUrl('travelFareRules', {
	        type: sector.Type,
	        travelId: sector.Identifier,
	        fareId: fare.Identifier
	      });
	
	      var params = {
	        searchIdentifier: sector.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).then(function (res) {
	        var data = res.data;
	        deferred.resolve(data);
	      })['catch'](function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function prepData(data, index, totalSets, isChanging) {
	    var obj = {
	      selected: false,
	      matchingResultsIndex: data.MatchingResultsIndex,
	      searchDate: data.Date,
	      destination: data.Destination,
	      origin: data.Origin,
	      searchResults: data.Results,
	      classes: [],
	      activeSort: null,
	      resultLimitIncrement: 20,
	      resultLimit: getResultLimit(totalSets),
	      resultsFilters: {
	        filters: travelFiltersService.getFilters(),
	        searchFilterTotal: 0
	      }
	    };
	
	    _.forEach(data.Results, function (item) {
	      var fareClasses = item.FareClasses;
	
	      item.$state = {};
	      item.TotalFares = 0;
	      item.SupplierName = item.SupplierName || item.CarrierName;
	      item.ReturnPricing = _.isInteger(obj.matchingResultsIndex);
	
	      // TODO move to a filter
	      if (item.Rating) {
	        item.Rating.OnTimeLevel = item.Rating.OntimePercent < 0.7 ? 'low' : item.Rating.OntimePercent < 0.9 ? 'mid' : 'high';
	      }
	
	      angular.forEach(fareClasses, function (fare, key) {
	        if (fare === null) {
	          return delete fareClasses[key];
	        }
	
	        fare.$state = {};
	        fare.Class = key;
	
	        var defaultFare = _.omit(fare, 'AdditionalFares');
	
	        fare.AdditionalFares.unshift(defaultFare);
	
	        fare.AdditionalFares = _.map(fare.AdditionalFares, function (additionalFare) {
	          additionalFare.$state = {};
	          additionalFare.FareCode = additionalFare.FareCode || additionalFare.FareName;
	          additionalFare.MatchingResultsIndex = data.MatchingResultsIndex;
	          additionalFare.Class = key;
	
	          return additionalFare;
	        });
	
	        if (fare.GroupType === 'Economy') {
	          if (!service.economyClasses.includes(fare.Class)) {
	            service.economyClasses.push(fare.Class);
	          }
	        }
	
	        item.TotalFares += fare.AdditionalFares.length;
	      });
	
	      obj.classes = obj.classes.concat(Object.keys(fareClasses));
	
	      var priceFilterSettings = obj.resultsFilters.filters.priceRange.settings;
	
	      if (item.MaxRate > priceFilterSettings.maxValue) {
	        var roundedMaxRate = Math.ceil(item.MaxRate);
	        priceFilterSettings.maxValue = roundedMaxRate;
	        priceFilterSettings.defaultMax = roundedMaxRate;
	      }
	    });
	
	    obj.resultsFilters.filters.carrier.settings.options = getCarrierOptions(data.Results);
	
	    var maxRate = getMaxRate(data.Results);
	    obj.resultsFilters.filters.priceRange.settings.defaultMax = maxRate;
	    obj.resultsFilters.filters.priceRange.settings.maxValue = maxRate;
	
	    obj.resultsFilters.filters.cartItems.settings.resultsIndex = index;
	    obj.resultsFilters.filters.cartItems.settings.matchingResultsIndex = data.MatchingResultsIndex;
	
	    if (isChanging) {
	      obj.resultsFilters.filters.cartItems.settings.cartItems = changeCartService.items;
	    }
	
	    buildFareClasses(obj.classes);
	
	    obj.classes = service.fareClasses;
	    return obj;
	  }
	
	  function getResultLimit(totalSets) {
	    var MAX_TOTAL = 100;
	
	    return totalSets === 3 ? 30 : MAX_TOTAL / totalSets;
	  }
	
	  function getMaxRate(results) {
	    return _.reduce(results, function (maxRate, result) {
	      return Math.ceil(result.MaxRate > maxRate ? result.MaxRate : maxRate);
	    }, 0);
	  }
	
	  function getCarrierOptions(results) {
	    var uniqueResults = _.uniqBy(results, function (item) {
	      return item.Carrier;
	    });
	
	    var orderedResults = _.orderBy(uniqueResults, function (item) {
	      return item.CarrierName.toLowerCase();
	    });
	
	    return _.map(orderedResults, function (item) {
	      return {
	        value: item.Carrier,
	        label: item.CarrierName,
	        id: 'Carrier-' + item.Carrier
	      };
	    });
	  }
	
	  function orderFareClasses(fareClasses) {
	    var fareBucketClasses = settingsService.settings.FlightConfiguration.FareBucketClasses;
	
	    if (!fareBucketClasses) {
	      return fareClasses;
	    }
	
	    return _.orderBy(fareClasses, function (fareClass) {
	      var fareBucketClassSettings = _.find(fareBucketClasses, function (bucketClass) {
	        return bucketClass.Name === fareClass;
	      });
	
	      return fareBucketClassSettings ? fareBucketClassSettings.Sort : Number.MAX_SAFE_INTEGER;
	    });
	  }
	
	  function buildFareClasses(classes) {
	    service.fareClasses = service.fareClasses.concat(classes);
	    service.fareClasses = _.uniq(service.fareClasses);
	    service.fareClasses = orderFareClasses(service.fareClasses);
	
	    angular.forEach(service.results, function (result) {
	      result.classes = service.fareClasses;
	    });
	  }
	
	  function addFilters(filters, index, clear) {
	    if (clear) {
	      service.results[index].resultsFilters.filters = {};
	    }
	
	    _.forOwn(filters, function (filter, key) {
	      service.results[index].resultsFilters.filters[key] = filter;
	    });
	
	    process(index);
	  }
	
	  function updateFilters(filters, index, clear) {
	    if (clear) {
	      service.results[index].resultsFilters.filters = {};
	    }
	
	    _.forOwn(filters, function (filter, key) {
	      service.results[index].resultsFilters.filters[key] = filter;
	    });
	
	    process(index);
	  }
	
	  function clearFilters(index) {
	    service.results[index].selected = false;
	
	    _.forOwn(service.results[index].resultsFilters.filters, function (filter) {
	      if (_.isFunction(filter.settings.clear)) {
	        filter.settings.clear();
	      }
	    });
	  }
	
	  function addFilter(filter, index, clear) {
	    if (clear) {
	      clearFilters(index);
	    }
	
	    if (filter) {
	      service.results[index].resultsFilters.filters[filter.name] = filter;
	    }
	
	    process(index);
	  }
	
	  function removeFilter(filterName, index) {
	    delete service.results[index].resultsFilters.filters[filterName];
	
	    process(index);
	  }
	
	  function sort(sortOption, index) {
	    service.results[index].activeSort = sortOption;
	    process(index);
	  }
	
	  function process(index) {
	    if (index === null) return;
	
	    var resultsSet = service.results[index];
	    var processedResults = _.clone(service.resultsMaster[index].searchResults);
	    var clearActiveFilters = false;
	
	    resultsSet.resultsFilters.searchFilterTotal = 0;
	
	    _.forOwn(resultsSet.resultsFilters.filters, function (filter) {
	      if (filter.settings.isActive()) {
	        if (filter.clearActiveFilters) {
	          clearActiveFilters = true;
	        }
	
	        if (clearActiveFilters && _.isFunction(filter.settings.clear)) {
	          filter.settings.clear();
	        } else {
	          if (filter.isResultsFilter) {
	            resultsSet.resultsFilters.searchFilterTotal += 1;
	          }
	
	          processedResults = $filter(filter.filterName)(processedResults, filter.settings);
	        }
	      }
	    });
	
	    if (resultsSet.activeSort) {
	      processedResults = _.orderBy(processedResults, function (result) {
	        if (resultsSet.activeSort.sortField === 'MinCarbonEmissionAmount') {
	          var carbonEmissions = Object.values(result.FareClasses).map(function (fare) {
	            return fare.CarbonEmissionAmount;
	          });
	          return Math.min.apply(Math, _toConsumableArray(carbonEmissions));
	        } else {
	          return result[resultsSet.activeSort.sortField];
	        }
	      });
	
	      if (resultsSet.activeSort.isReverse) {
	        processedResults = processedResults.reverse();
	      }
	    }
	
	    resultsSet.searchResults = processedResults;
	    $rootScope.$broadcast('flightDataProcessed');
	  }
	
	  function itemAddedToCart(parentIndex, result, fare, isChanging) {
	    var resultsSet = service.results[parentIndex];
	    resultsSet.selected = true;
	
	    if (isChanging) {
	      changeCartService.addChange(parentIndex, result, fare);
	    } else {
	      cartService.items.push({
	        type: 'flight',
	        fare: fare,
	        result: result,
	        orderBy: parentIndex,
	        matchingIndex: resultsSet.matchingResultsIndex
	      });
	    }
	
	    process(parentIndex);
	
	    if (_.isInteger(resultsSet.matchingResultsIndex)) {
	      process(resultsSet.matchingResultsIndex);
	    }
	  }
	
	  return service;
	};
	
	travelService.$inject = $inject;
	
	exports['default'] = travelService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q', '$http', 'moment', 'cartService', 'apiService', 'itinerariesService'];
	
	var unusedTicketsService = function unusedTicketsService($rootScope, $q, $http, moment, cartService, apiService, itinerariesService) {
	  var service = {
	    isActive: false,
	    isEnabled: false,
	    tickets: [],
	    getTickets: getTickets,
	    toggle: toggle,
	    clear: clear,
	    autoAllocate: true
	  };
	
	  $rootScope.$watchCollection(function () {
	    return cartService.items;
	  }, validate);
	
	  $rootScope.$watchCollection(function () {
	    return cartService.tickets;
	  }, validate);
	
	  return service;
	
	  function getTickets() {
	    var deferred = $q.defer();
	
	    var apiConfig = window.svelteStore.apiConfig('ticketsOnHold', itinerariesService.itinerary.Identifier);
	
	    $http.get(apiConfig.url, { apiVersion: apiConfig.version }).then(function (res) {
	      var data = res.data;
	      service.tickets = data;
	      validate();
	      deferred.resolve(service.tickets);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function validate() {
	    var orderedTickets = _.orderBy(service.tickets, 'Amount');
	
	    orderedTickets.forEach(function (ticket) {
	      var matchingTicket = cartService.getMatchingTicket(ticket);
	      var matchingCartItemTotal = cartService.getMatchingItemTotal(ticket);
	
	      ticket.isDisabled = !matchingCartItemTotal || !!matchingTicket;
	
	      if (matchingCartItemTotal < ticket.Value) {
	        cartService.removeTicket(ticket);
	        ticket.isDisabled = true;
	      }
	    });
	
	    var activeTickets = orderedTickets.filter(function (ticket) {
	      return !ticket.isDisabled;
	    });
	    if (activeTickets.length > 0 && service.autoAllocate) {
	      autoAllocate(activeTickets);
	    } else {
	      service.autoAllocate = true;
	    }
	  }
	
	  function autoAllocate(tickets) {
	    if (tickets.length === 1) {
	      return cartService.addTicket(tickets[0]);
	    }
	
	    var expiries = tickets.sort(function (left, right) {
	      return moment.utc(left.ExpiryDate).diff(moment.utc(right.ExpiryDate));
	    }).reverse();
	
	    if (expiries[0].ExpiryDate === expiries[1].ExpiryDate) {
	      var earliestDate = expiries.filter(function (ticket) {
	        return ticket.ExpiryDate === expiries[0].ExpiryDate;
	      });
	      var highestValue = earliestDate.sort(function (left, right) {
	        return left.Value - right.Value;
	      }).pop();
	      return cartService.addTicket(highestValue);
	    } else {
	      return cartService.addTicket(expiries[0]);
	    }
	  }
	
	  function toggle() {
	    service.isActive = !service.isActive;
	  }
	
	  function clear() {
	    service.isActive = false;
	    service.isEnabled = false;
	    service.tickets = [];
	  }
	};
	
	unusedTicketsService.$inject = $inject;
	
	exports['default'] = unusedTicketsService;
	module.exports = exports['default'];

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var userDebtorService = function userDebtorService($q, $http, apiService) {
	  var service = {};
	  service.debtor = null;
	  service.get = get;
	  service.getAny = getAny;
	  service.update = update;
	  service.bookingRules = bookingRules;
	  service.paymentMethod = paymentMethod;
	  service.paymentMethods = paymentMethods;
	  service.removePaymentMethod = removePaymentMethod;
	  service.clear = clear;
	
	  return service;
	
	  function getAny(debtorId) {
	    var deferred = $q.defer();
	
	    if (service.debtor) {
	      deferred.resolve(service.debtor);
	    } else {
	      deferred.resolve(get(debtorId));
	    }
	
	    return deferred.promise;
	  }
	
	  function get(debtorId) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });
	
	    $http.get(apiUrl).then(function (res) {
	      var data = res.data;
	      var headers = res.headers;
	      service.debtor = _.merge(data, { ETag: headers('ETag') });
	      deferred.resolve(service.debtor);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function update(debtor) {
	    var deferred = $q.defer();
	    var debtorId = debtor.Name;
	
	    var apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });
	
	    $http.put(apiUrl, _.omit(debtor, 'ETag'), {
	      headers: {
	        'If-Match': debtor.ETag
	      }
	    }).then(function () {
	      return get(debtorId).then(function (response) {
	        deferred.resolve(response);
	      }, function (error) {
	        deferred.reject(error);
	      });
	    })['catch'](function (error) {
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  }
	
	  function bookingRules() {
	    return _.merge({}, _.pick(service.debtor, ['CompanyReference', 'Policy']));
	  }
	
	  function paymentMethod(id) {
	    return _.cloneDeep(_.find(service.debtor.DebtorAgencyCreditCards, function (paymentMethod) {
	      return paymentMethod.Id === id;
	    }));
	  }
	
	  function paymentMethods() {
	    return _.clone(service.debtor.DebtorAgencyCreditCards);
	  }
	
	  function removePaymentMethod(debtor, paymentMethod) {
	    debtor.DebtorAgencyCreditCards = _.filter(debtor.DebtorAgencyCreditCards, function (card) {
	      return card.Id !== paymentMethod.Id;
	    });
	
	    return debtor;
	  }
	
	  function clear() {
	    service.debtor = null;
	  }
	};
	
	userDebtorService.$inject = $inject;
	
	exports['default'] = userDebtorService;
	module.exports = exports['default'];

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var _currentUserService = __webpack_require__(20);
	
	var _currentUserService2 = _interopRequireDefault(_currentUserService);
	
	var $inject = ['$window', '$q', '$http', 'apiService', 'currentUserService'];
	
	var userInfoService = function userInfoService($window, $q, $http, apiService, currentUserService) {
	  var service = {};
	  service.getInfo = getInfo;
	  service.userInfoRequired = true;
	
	  function getInfo() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('userInfo');
	
	    $http.get(apiUrl, { apiVersion: 20 }).then(function (response) {
	      var data = response.data;
	
	      currentUserService.store('userInfo', data);
	
	      window.svelteStore.setTrackingIdentity(data.TravellerId);
	
	      var _data$Name$split = data.Name.split(' ');
	
	      var _data$Name$split2 = _toArray(_data$Name$split);
	
	      var firstName = _data$Name$split2[0];
	
	      var lastName = _data$Name$split2.slice(1);
	
	      lastName = lastName.join(' ');
	      window.svelteStore.trackUser(firstName, lastName, data.Email, data.DebtorIdentifier);
	
	      deferred.resolve(data);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	userInfoService.$inject = $inject;
	
	exports['default'] = userInfoService;
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var userProfileService = function userProfileService($q, $http, apiService) {
	  var service = {};
	  service.profile = null;
	  service.getPerson = getPerson;
	  service.getAny = getAny;
	  service.updatePerson = updatePerson;
	  service.register = register;
	  service.clear = clear;
	  service.store = store;
	
	  return service;
	
	  function getAny() {
	    if (service.profile) {
	      var deferred = $q.defer();
	      deferred.resolve(service.profile);
	      return deferred.promise;
	    } else {
	      return getPerson();
	    }
	  }
	
	  function getPerson() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('userProfile');
	
	    $http.get(apiUrl).then(function (res) {
	      var data = res.data;
	      service.profile = data;
	      deferred.resolve(service.profile);
	    });
	
	    return deferred.promise;
	  }
	
	  function updatePerson(profile) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userProfile');
	    var userProfile = profile || service.profile;
	
	    $http.put(apiUrl, userProfile).then(function () {
	      service.profile = userProfile;
	      deferred.resolve(service.profile);
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function register(profile) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userRegister');
	
	    $http.post(apiUrl, profile).then(function () {
	      deferred.resolve();
	    })['catch'](function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function clear() {
	    sessionStorage.removeItem('profile');
	  }
	
	  function store(profile) {
	    service.profile = profile;
	    return service.profile;
	  }
	};
	
	userProfileService.$inject = $inject;
	
	exports['default'] = userProfileService;
	module.exports = exports['default'];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * angular-addtocalendar v1.1.3
	 * An AngularJS directive for adding an event to calendar apps.
	 *
	 * Controller and directive.
	 */
	'use strict';
	
	angular.module('jshor.angular-addtocalendar', []).config(['$compileProvider', function ($compileProvider) {
	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(http(s)?|data):/);
	}]).controller('AddtocalendarCtrl', ['$scope', function ($scope) {
	
	  $scope.description = $scope.description || '';
	
	  /**
	   * Renders a .ics file and downloads it to the client browser.
	   * The name of the file will be the event title with alphanumeric chars
	   * having the extension `.ics`.
	   *
	   * @param  {Boolean} encodeUri  encode the
	   * @return {String}  ics calendar data
	   */
	  function getIcsCalendar(encodeUri) {
	
	    function formatIcsText(s, maxLength) {
	      if (!s || !s.length) return s;
	      return wrap(s.replace(/\n/g, '\\n'), maxLength);
	    }
	
	    function wrap(s, maxLength) {
	      if (!maxLength) maxLength = 75;
	      if (!s || s.length <= maxLength) {
	        return s;
	      } else {
	        return s.substring(0, maxLength).replace(/\n/g, '\\n') + "\r\n " + wrap(s.substring(maxLength), 75);
	      }
	    }
	
	    var elements = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'CLASS:PUBLIC', 'DESCRIPTION:' + formatIcsText($scope.description, 62), 'DTSTART;VALUE=DATE:' + $scope.startDate, 'DTEND;VALUE=DATE:' + $scope.endDate, 'LOCATION:' + formatIcsText($scope.location, 64), 'SUMMARY:' + formatIcsText($scope.title, 66), 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR'];
	
	    return elements.join('\n');
	  }
	
	  /**
	   * Generates a url to add event to Yahoo! Calendar.
	   *
	   * @return {String} yahoo cal url
	   */
	  function getYahooCalendarUrl() {
	
	    var yahooCalendarUrl = 'http://calendar.yahoo.com/?v=60&view=d&type=20';
	    yahooCalendarUrl += '&title=' + encodeURIComponent($scope.title);
	    yahooCalendarUrl += '&st=' + encodeURIComponent($scope.startDate) + '&et=' + encodeURIComponent($scope.endDate);
	    yahooCalendarUrl += '&desc=' + encodeURIComponent($scope.description);
	    yahooCalendarUrl += '&in_loc=' + encodeURIComponent($scope.location);
	
	    return yahooCalendarUrl;
	  };
	
	  /**
	   * Generates a url to add event to Google Calendar.
	   *
	   * @return {String} google cal url
	   */
	  function getGoogleCalendarUrl() {
	
	    var googleCalendarUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
	    googleCalendarUrl += '&text=' + encodeURIComponent($scope.title);
	    googleCalendarUrl += '&dates=' + encodeURIComponent($scope.startDate) + '/' + encodeURIComponent($scope.endDate);
	    googleCalendarUrl += '&details=' + encodeURIComponent($scope.description);
	    googleCalendarUrl += '&location=' + encodeURIComponent($scope.location);
	
	    return googleCalendarUrl;
	  };
	
	  /**
	   * Generates a url to add event to Windows Live Calendar.
	   *
	   * @return {String} microsoft cal url
	   */
	  function getMicrosoftCalendarUrl() {
	
	    var microsoftCalendarUrl = 'http://calendar.live.com/calendar/calendar.aspx?rru=addevent';
	    microsoftCalendarUrl += '&summary=' + encodeURIComponent($scope.title);
	    microsoftCalendarUrl += '&dtstart=' + encodeURIComponent($scope.startDate) + '&dtend=' + encodeURIComponent($scope.endDate);
	    microsoftCalendarUrl += '&description=' + encodeURIComponent($scope.description);
	    microsoftCalendarUrl += '&location=' + encodeURIComponent($scope.location);
	
	    return microsoftCalendarUrl;
	  };
	
	  function dlIcal() {
	    var fileName = $scope.fileName.replace(/[^\w ]+/g, '') + '.ics';
	
	    __webpack_require__(754)(getIcsCalendar(), fileName, 'application/octet-stream');
	  }
	
	  $scope.calendarUrl = {
	    microsoft: getMicrosoftCalendarUrl(),
	    google: getGoogleCalendarUrl(),
	    yahoo: getYahooCalendarUrl(),
	    icalendar: getIcsCalendar(),
	    dlIcal: dlIcal
	  };
	}]).directive('addtocalendar', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      startDate: '@',
	      endDate: '@',
	      title: '@',
	      fileName: '@',
	      description: '@',
	      location: '@',
	      className: '@',
	      btnText: '@'
	    },
	    controller: 'AddtocalendarCtrl',
	    template: '<a class="{{ className }}" ng-click="calendarUrl.dlIcal()" title="Add to calendar"><i class="ico-cal"></i> <span>Add to calendar</span></a>'
	  };
	});

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.0 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'use strict';
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(69); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if (typeof moment === 'undefined') {
				if (true) {
					moment = requireMoment();
				} else {
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
	   * @ngdoc overview
	   * @name angularMoment
	   *
	   * @description
	   * angularMoment module provides moment.js functionality for angular.js apps.
	   */
			angular.module('angularMoment', [])
	
			/**
	   * @ngdoc object
	   * @name angularMoment.config:angularMomentConfig
	   *
	   * @description
	   * Common configuration of the angularMoment module
	   */
			.constant('angularMomentConfig', {
				/**
	    * @ngdoc property
	    * @name angularMoment.config.angularMomentConfig#preprocess
	    * @propertyOf angularMoment.config:angularMomentConfig
	    * @returns {function} A preprocessor function that will be applied on all incoming dates
	    *
	    * @description
	    * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
	    * `amCalendar`, etc.). The function must return a `moment` object.
	    *
	    * @example
	    *   // Causes angular-moment to always treat the input values as unix timestamps
	    *   angularMomentConfig.preprocess = function(value) {
	    * 	   return moment.unix(value);
	    *   }
	    */
				preprocess: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.angularMomentConfig#timezone
	    * @propertyOf angularMoment.config:angularMomentConfig
	    * @returns {string} The default timezone
	    *
	    * @description
	    * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
	    * any timezone shift).
	    *
	    * NOTE: This option requires moment-timezone >= 0.3.0.
	    */
				timezone: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.angularMomentConfig#format
	    * @propertyOf angularMoment.config:angularMomentConfig
	    * @returns {string} The pre-conversion format of the date
	    *
	    * @description
	    * Specify the format of the input date. Essentially it's a
	    * default and saves you from specifying a format in every
	    * element. Overridden by element attr. Null by default.
	    */
				format: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.angularMomentConfig#statefulFilters
	    * @propertyOf angularMoment.config:angularMomentConfig
	    * @returns {boolean} Whether angular-moment filters should be stateless (or not)
	    *
	    * @description
	    * Specifies whether the filters included with angular-moment are stateful.
	    * Stateful filters will automatically re-evaluate whenever you change the timezone
	    * or locale settings, but may negatively impact performance. true by default.
	    */
				statefulFilters: true
			})
	
			/**
	   * @ngdoc object
	   * @name angularMoment.object:moment
	   *
	   * @description
	   * moment global (as provided by the moment.js library)
	   */
			.constant('moment', moment)
	
			/**
	   * @ngdoc object
	   * @name angularMoment.config:amTimeAgoConfig
	   * @module angularMoment
	   *
	   * @description
	   * configuration specific to the amTimeAgo directive
	   */
			.constant('amTimeAgoConfig', {
				/**
	    * @ngdoc property
	    * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
	    * @propertyOf angularMoment.config:amTimeAgoConfig
	    * @returns {boolean} Whether to include a suffix in am-time-ago directive
	    *
	    * @description
	    * Defaults to false.
	    */
				withoutSuffix: false,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.amTimeAgoConfig#serverTime
	    * @propertyOf angularMoment.config:amTimeAgoConfig
	    * @returns {number} Server time in milliseconds since the epoch
	    *
	    * @description
	    * If set, time ago will be calculated relative to the given value.
	    * If null, local time will be used. Defaults to null.
	    */
				serverTime: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.amTimeAgoConfig#titleFormat
	    * @propertyOf angularMoment.config:amTimeAgoConfig
	    * @returns {string} The format of the date to be displayed in the title of the element. If null,
	    *        the directive set the title of the element.
	    *
	    * @description
	    * The format of the date used for the title of the element. null by default.
	    */
				titleFormat: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
	    * @propertyOf angularMoment.config:amTimeAgoConfig
	    * @returns {number} The minimum number of days for showing a full date instead of relative time
	    *
	    * @description
	    * The threshold for displaying a full date. The default is null, which means the date will always
	    * be relative, and full date will never be displayed.
	    */
				fullDateThreshold: null,
	
				/**
	    * @ngdoc property
	    * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
	    * @propertyOf angularMoment.config:amTimeAgoConfig
	    * @returns {string} The format to use when displaying a full date.
	    *
	    * @description
	    * Specify the format of the date when displayed as full date. null by default.
	    */
				fullDateFormat: null,
	
				fullDateThresholdUnit: 'day'
			})
	
			/**
	   * @ngdoc directive
	   * @name angularMoment.directive:amTimeAgo
	   * @module angularMoment
	   *
	   * @restrict A
	   */
			.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
				return function (scope, element, attr) {
					var activeTimeout = null;
					var currentValue;
					var withoutSuffix = amTimeAgoConfig.withoutSuffix;
					var titleFormat = amTimeAgoConfig.titleFormat;
					var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
					var fullDateFormat = amTimeAgoConfig.fullDateFormat;
					var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
					var localDate = new Date().getTime();
					var modelName = attr.amTimeAgo;
					var currentFrom;
					var isTimeElement = 'TIME' === element[0].nodeName.toUpperCase();
					var setTitleTime = !element.attr('title');
	
					function getNow() {
						var now;
						if (currentFrom) {
							now = currentFrom;
						} else if (amTimeAgoConfig.serverTime) {
							var localNow = new Date().getTime();
							var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
							now = moment(nowMillis);
						} else {
							now = moment();
						}
						return now;
					}
	
					function cancelTimer() {
						if (activeTimeout) {
							$window.clearTimeout(activeTimeout);
							activeTimeout = null;
						}
					}
	
					function updateTime(momentInstance) {
						var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
						var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
						if (showFullDate) {
							element.text(momentInstance.format(fullDateFormat));
						} else {
							element.text(momentInstance.from(getNow(), withoutSuffix));
						}
	
						if (titleFormat && setTitleTime) {
							element.attr('title', momentInstance.format(titleFormat));
						}
	
						if (!showFullDate) {
							var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
							var secondsUntilUpdate = 3600;
							if (howOld < 1) {
								secondsUntilUpdate = 1;
							} else if (howOld < 60) {
								secondsUntilUpdate = 30;
							} else if (howOld < 180) {
								secondsUntilUpdate = 300;
							}
	
							activeTimeout = $window.setTimeout(function () {
								updateTime(momentInstance);
							}, secondsUntilUpdate * 1000);
						}
					}
	
					function updateDateTimeAttr(value) {
						if (isTimeElement) {
							element.attr('datetime', value);
						}
					}
	
					function updateMoment() {
						cancelTimer();
						if (currentValue) {
							var momentValue = amMoment.preprocessDate(currentValue);
							updateTime(momentValue);
							updateDateTimeAttr(momentValue.toISOString());
						}
					}
	
					scope.$watch(modelName, function (value) {
						if (isUndefinedOrNull(value) || value === '') {
							cancelTimer();
							if (currentValue) {
								element.text('');
								updateDateTimeAttr('');
								currentValue = null;
							}
							return;
						}
	
						currentValue = value;
						updateMoment();
					});
	
					if (angular.isDefined(attr.amFrom)) {
						scope.$watch(attr.amFrom, function (value) {
							if (isUndefinedOrNull(value) || value === '') {
								currentFrom = null;
							} else {
								currentFrom = moment(value);
							}
							updateMoment();
						});
					}
	
					if (angular.isDefined(attr.amWithoutSuffix)) {
						scope.$watch(attr.amWithoutSuffix, function (value) {
							if (typeof value === 'boolean') {
								withoutSuffix = value;
								updateMoment();
							} else {
								withoutSuffix = amTimeAgoConfig.withoutSuffix;
							}
						});
					}
	
					attr.$observe('amFullDateThreshold', function (newValue) {
						fullDateThreshold = newValue;
						updateMoment();
					});
	
					attr.$observe('amFullDateFormat', function (newValue) {
						fullDateFormat = newValue;
						updateMoment();
					});
	
					attr.$observe('amFullDateThresholdUnit', function (newValue) {
						fullDateThresholdUnit = newValue;
						updateMoment();
					});
	
					scope.$on('$destroy', function () {
						cancelTimer();
					});
	
					scope.$on('amMoment:localeChanged', function () {
						updateMoment();
					});
				};
			}])
	
			/**
	   * @ngdoc service
	   * @name angularMoment.service.amMoment
	   * @module angularMoment
	   */
			.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
				var defaultTimezone = null;
	
				/**
	    * @ngdoc function
	    * @name angularMoment.service.amMoment#changeLocale
	    * @methodOf angularMoment.service.amMoment
	    *
	    * @description
	    * Changes the locale for moment.js and updates all the am-time-ago directive instances
	    * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
	    *
	    * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
	    * @param {object} customization object of locale strings to override
	    */
				this.changeLocale = function (locale, customization) {
					var result = moment.locale(locale, customization);
					if (angular.isDefined(locale)) {
						$rootScope.$broadcast('amMoment:localeChanged');
					}
					return result;
				};
	
				/**
	    * @ngdoc function
	    * @name angularMoment.service.amMoment#changeTimezone
	    * @methodOf angularMoment.service.amMoment
	    *
	    * @description
	    * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
	    * `amMoment:timezoneChanged` event on $rootScope.
	    *
	    * Note: this method works only if moment-timezone > 0.3.0 is loaded
	    *
	    * @param {string} timezone Timezone name (e.g. UTC)
	    */
				this.changeTimezone = function (timezone) {
					if (moment.tz && moment.tz.setDefault) {
						moment.tz.setDefault(timezone);
						$rootScope.$broadcast('amMoment:timezoneChanged');
					} else {
						$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
					}
					angularMomentConfig.timezone = timezone;
					defaultTimezone = timezone;
				};
	
				/**
	    * @ngdoc function
	    * @name angularMoment.service.amMoment#preprocessDate
	    * @methodOf angularMoment.service.amMoment
	    *
	    * @description
	    * Preprocess a given value and convert it into a Moment instance appropriate for use in the
	    * am-time-ago directive and the filters. The behavior of this function can be overriden by
	    * setting `angularMomentConfig.preprocess`.
	    *
	    * @param {*} value The value to be preprocessed
	    * @return {Moment} A `moment` object
	    */
				this.preprocessDate = function (value) {
					// Configure the default timezone if needed
					if (defaultTimezone !== angularMomentConfig.timezone) {
						this.changeTimezone(angularMomentConfig.timezone);
					}
	
					if (angularMomentConfig.preprocess) {
						return angularMomentConfig.preprocess(value);
					}
	
					if (!isNaN(parseFloat(value)) && isFinite(value)) {
						// Milliseconds since the epoch
						return moment(parseInt(value, 10));
					}
	
					// else just returns the value as-is.
					return moment(value);
				};
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amParse
	   * @module angularMoment
	   */
			.filter('amParse', ['moment', function (moment) {
				return function (value, format) {
					return moment(value, format);
				};
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amFromUnix
	   * @module angularMoment
	   */
			.filter('amFromUnix', ['moment', function (moment) {
				return function (value) {
					return moment.unix(value);
				};
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amUtc
	   * @module angularMoment
	   */
			.filter('amUtc', ['moment', function (moment) {
				return function (value) {
					return moment.utc(value);
				};
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amUtcOffset
	   * @module angularMoment
	   *
	   * @description
	   * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
	   * '+0300', '-0300' or 'Z'.
	   */
			.filter('amUtcOffset', ['amMoment', function (amMoment) {
				function amUtcOffset(value, offset) {
					return amMoment.preprocessDate(value).utcOffset(offset);
				}
	
				return amUtcOffset;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amLocal
	   * @module angularMoment
	   */
			.filter('amLocal', ['moment', function (moment) {
				return function (value) {
					return moment.isMoment(value) ? value.local() : null;
				};
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amTimezone
	   * @module angularMoment
	   *
	   * @description
	   * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
	   *
	   * You need to include moment-timezone.js for timezone support.
	   */
			.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
				function amTimezone(value, timezone) {
					var aMoment = amMoment.preprocessDate(value);
	
					if (!timezone) {
						return aMoment;
					}
	
					if (aMoment.tz) {
						return aMoment.tz(timezone);
					} else {
						$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
						return aMoment;
					}
				}
	
				return amTimezone;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amCalendar
	   * @module angularMoment
	   */
			.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amCalendarFilter(value, referenceTime, formats) {
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					var date = amMoment.preprocessDate(value);
					return date.isValid() ? date.calendar(referenceTime, formats) : '';
				}
	
				// Since AngularJS 1.3, filters have to explicitly define being stateful
				// (this is no longer the default).
				amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amCalendarFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amDifference
	   * @module angularMoment
	   */
			.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amDifferenceFilter(value, otherValue, unit, usePrecision) {
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					var date = amMoment.preprocessDate(value);
					var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
					if (!date.isValid() || !date2.isValid()) {
						return '';
					}
	
					return date.diff(date2, unit, usePrecision);
				}
	
				amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amDifferenceFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amDateFormat
	   * @module angularMoment
	   * @function
	   */
			.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amDateFormatFilter(value, format) {
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					var date = amMoment.preprocessDate(value);
					if (!date.isValid()) {
						return '';
					}
	
					return date.format(format);
				}
	
				amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amDateFormatFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amDurationFormat
	   * @module angularMoment
	   * @function
	   */
			.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amDurationFormatFilter(value, format, suffix) {
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					return moment.duration(value, format).humanize(suffix);
				}
	
				amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amDurationFormatFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amTimeAgo
	   * @module angularMoment
	   * @function
	   */
			.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amTimeAgoFilter(value, suffix, from) {
					var date, dateFrom;
	
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					value = amMoment.preprocessDate(value);
					date = moment(value);
					if (!date.isValid()) {
						return '';
					}
	
					dateFrom = moment(from);
					if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
						return date.from(dateFrom, suffix);
					}
	
					return date.fromNow(suffix);
				}
	
				amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amTimeAgoFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amSubtract
	   * @module angularMoment
	   * @function
	   */
			.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amSubtractFilter(value, amount, type) {
	
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					return moment(value).subtract(parseInt(amount, 10), type);
				}
	
				amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amSubtractFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amAdd
	   * @module angularMoment
	   * @function
	   */
			.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amAddFilter(value, amount, type) {
	
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					return moment(value).add(parseInt(amount, 10), type);
				}
	
				amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amAddFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amStartOf
	   * @module angularMoment
	   * @function
	   */
			.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amStartOfFilter(value, type) {
	
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					return moment(value).startOf(type);
				}
	
				amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amStartOfFilter;
			}])
	
			/**
	   * @ngdoc filter
	   * @name angularMoment.filter:amEndOf
	   * @module angularMoment
	   * @function
	   */
			.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amEndOfFilter(value, type) {
	
					if (isUndefinedOrNull(value)) {
						return '';
					}
	
					return moment(value).endOf(type);
				}
	
				amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
				return amEndOfFilter;
			}]);
	
			return 'angularMoment';
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && typeof require === 'function') {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

	'use strict';
	
	;(function (angular) {
	  'use strict';
	  var indexOf = [].indexOf || function (item) {
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (i in this && this[i] === item) return i;
	    }
	    return -1;
	  };
	
	  function map(items, property) {
	    var mappedArray = [];
	    angular.forEach(items, function (item) {
	      mappedArray.push(angular.isFunction(property) ? property(item) : item[property]);
	    });
	    return mappedArray;
	  }
	
	  angular.module('pickadate', []).provider('pickadateI18n', function () {
	    var defaults = {
	      'prev': 'prev',
	      'next': 'next'
	    };
	
	    this.translations = {};
	
	    this.$get = function () {
	      var translations = this.translations;
	
	      return {
	        t: function t(key) {
	          return translations[key] || defaults[key];
	        }
	      };
	    };
	  }).factory('pickadateModalBindings', ['$window', '$document', function ($window, $document) {
	    var supportPageOffset = $window.pageXOffset !== undefined,
	        isCSS1Compat = ($document.compatMode || "") === "CSS1Compat";
	
	    var computeStyles = function computeStyles(element) {
	      var scrollX = supportPageOffset ? $window.pageXOffset : isCSS1Compat ? $document.documentElement.scrollLeft : $document.body.scrollLeft,
	          scrollY = supportPageOffset ? $window.pageYOffset : isCSS1Compat ? $document.documentElement.scrollTop : $document.body.scrollTop,
	          innerWidth = $window.innerWidth || $document.documentElement.clientWidth || $document.body.clientWidth,
	          styles = { top: scrollY + element.getBoundingClientRect().bottom + 'px' };
	
	      if (innerWidth - element.getBoundingClientRect().left >= 300) {
	        styles.left = scrollX + element.getBoundingClientRect().left + 'px';
	      } else {
	        styles.right = innerWidth - element.getBoundingClientRect().right - scrollX + 'px';
	      }
	
	      return styles;
	    };
	
	    var isDescendant = function isDescendant(parent, child) {
	      var node = child.parentNode;
	      while (node !== null) {
	        if (node === parent) return true;
	        node = node.parentNode;
	      }
	      return false;
	    };
	
	    return function (scope, element, rootNode) {
	      var togglePicker = function togglePicker(toggle) {
	        scope.displayPicker = toggle;
	        scope.$apply();
	      };
	
	      element.on('focus', function () {
	        scope.modalStyles = computeStyles(element[0]);
	        togglePicker(true);
	      });
	
	      element.on('keydown', function (e) {
	        if (indexOf.call([9, 13, 27], e.keyCode) >= 0) togglePicker(false);
	      });
	
	      $document.on('click', function (e) {
	        if (isDescendant(rootNode, e.target) || e.target === element[0]) return;
	        togglePicker(false);
	      });
	    };
	  }]).factory('pickadateDateHelper', ['$locale', 'dateFilter', function ($locale, dateFilter) {
	
	    function getPartName(part) {
	      switch (part) {
	        case 'dd':
	          return 'day';
	        case 'MM':
	          return 'month';
	        case 'yyyy':
	          return 'year';
	      }
	    }
	
	    return function (format, options) {
	      var minDate, maxDate, formattedFrom, formattedTo, fromDate, toDate, showBetween, disabledDates, currentDate, weekStartsOn, noExtraRows;
	
	      options = options || {};
	      format = format || 'yyyy-MM-dd';
	      weekStartsOn = options.weekStartsOn;
	      noExtraRows = options.noExtraRows;
	
	      if (!angular.isNumber(weekStartsOn) || weekStartsOn < 0 || weekStartsOn > 6) weekStartsOn = 0;
	
	      return {
	
	        parseDate: function parseDate(dateString) {
	          if (!dateString) return;
	          if (angular.isDate(dateString)) return new Date(dateString);
	
	          var formatRegex = '(dd|MM|yyyy)',
	              separator = format.match(/[-|/]/)[0],
	              dateParts = dateString.split(separator),
	              regexp = new RegExp([formatRegex, formatRegex, formatRegex].join(separator)),
	              formatParts = format.match(regexp),
	              dateObj = {};
	
	          formatParts.shift();
	
	          angular.forEach(formatParts, function (part, i) {
	            dateObj[getPartName(part)] = parseInt(dateParts[i], 10);
	          });
	
	          if (isNaN(dateObj.year) || isNaN(dateObj.month) || isNaN(dateObj.day)) return;
	
	          return new Date(dateObj.year, dateObj.month - 1, dateObj.day, 3);
	        },
	
	        setRestrictions: function setRestrictions(restrictions) {
	          formattedFrom = restrictions.rangeFrom || null;
	          formattedTo = restrictions.rangeTo || null;
	          fromDate = this.parseDate(restrictions.rangeFrom);
	          toDate = this.parseDate(restrictions.rangeTo);
	          showBetween = fromDate && toDate;
	          minDate = this.parseDate(restrictions.minDate) || new Date(0);
	          maxDate = this.parseDate(restrictions.maxDate) || new Date(99999999999999);
	          currentDate = restrictions.currentDate;
	          disabledDates = restrictions.disabledDates || [];
	        },
	
	        allowPrevMonth: function allowPrevMonth() {
	          return currentDate > minDate;
	        },
	
	        allowNextMonth: function allowNextMonth() {
	          var nextMonth = angular.copy(currentDate);
	          nextMonth.setMonth(nextMonth.getMonth() + 1);
	          return nextMonth <= maxDate;
	        },
	
	        buildDateObject: function buildDateObject(date) {
	          var localDate = angular.copy(date),
	              formattedDate = dateFilter(localDate, format),
	              disabled = indexOf.call(disabledDates, formattedDate) >= 0,
	              monthOffset = this.getMonthOffset(localDate, currentDate),
	              outOfMinRange = localDate < minDate,
	              outOfMaxRange = localDate > maxDate,
	              outOfMonth = monthOffset === -1 && !options.previousMonthSelectable || monthOffset === 1 && !options.nextMonthSelectable;
	
	          return {
	            date: localDate,
	            formattedDate: formattedDate,
	            today: formattedDate === dateFilter(new Date(), format),
	            fromDate: formattedDate === formattedFrom,
	            toDate: formattedDate === formattedTo,
	            betweenDate: showBetween && localDate > fromDate && localDate < toDate,
	            disabled: disabled,
	            outOfMinRange: outOfMinRange,
	            outOfMaxRange: outOfMaxRange,
	            monthOffset: monthOffset,
	            outOfMonth: outOfMonth,
	            enabled: !(disabled || outOfMinRange || outOfMaxRange || outOfMonth)
	          };
	        },
	
	        buildDates: function buildDates(year, month, options) {
	          var dates = [],
	              date = new Date(year, month, 1, 3),
	              lastDate = new Date(year, month + 1, 0, 3);
	
	          options = options || {};
	          currentDate = angular.copy(date);
	
	          while (date.getDay() !== weekStartsOn) date.setDate(date.getDate() - 1);
	
	          for (var i = 0; i < 42; i++) {
	            // 42 == 6 rows of dates
	            if (noExtraRows && date.getDay() === weekStartsOn && date > lastDate) break;
	
	            dates.push(this.buildDateObject(date));
	            date.setDate(date.getDate() + 1);
	          }
	
	          return dates;
	        },
	
	        buildDayNames: function buildDayNames() {
	          var dayNames = $locale.DATETIME_FORMATS.SHORTDAY;
	
	          if (weekStartsOn) {
	            dayNames = dayNames.slice(0);
	            for (var i = 0; i < weekStartsOn; i++) dayNames.push(dayNames.shift());
	          }
	          return dayNames;
	        },
	
	        getMonthOffset: function getMonthOffset(date1, date2) {
	          return date1.getMonth() - date2.getMonth() + 12 * (date1.getFullYear() - date2.getFullYear());
	        }
	      };
	    };
	  }]).directive('pickadate', ['$locale', '$sce', '$compile', '$document', '$window', 'pickadateDateHelper', 'pickadateI18n', 'pickadateModalBindings', 'filterFilter', 'moment', function ($locale, $sce, $compile, $document, $window, dateHelperFactory, i18n, modalBindings, filter, moment) {
	
	    var TEMPLATE = '<div class="pickadate" ng-show="displayPicker" ng-style="modalStyles">' + '<div class="pickadate-header">' + '<div class="pickadate-prev" ng-click="changeMonth(-1)" ng-show="allowPrevMonth">' + '<i class="ico-chevron-left"></i>' + '</div>' + '<div class="pickadate-next" ng-click="changeMonth(1)" ng-show="allowNextMonth">' + '<i class="ico-chevron-right"></i>' + '</div>' + '<h3 class="pickadate-centered-heading">' + '{{currentDate | date:"MMMM yyyy"}}' + '</h3>' + '</div>' + '<div class="pickadate-body">' + '<div class="pickadate-main">' + '<ul class="pickadate-cell pickadate-cell-header">' + '<li class="pickadate-head" ng-repeat="dayName in dayNames">' + '{{dayName}}' + '</li>' + '</ul>' + '<ul class="pickadate-cell">' + '<li ng-repeat="dateObj in dates" ng-click="setDate(dateObj)" ng-class="classesFor(dateObj)"' + ' ng-mouseenter="dateOver(dateObj)" ng-mouseleave="dateOut(dateObj)">' + '<span>' + '{{dateObj.date | date:"d"}}' + '</span>' + '</li>' + '</ul>' + '</div>' + '</div>' + '</div>';
	
	    return {
	      require: 'ngModel',
	      scope: {
	        defaultDate: '=',
	        minDate: '=',
	        maxDate: '=',
	        rangeFrom: '=',
	        rangeTo: '=',
	        disabledDates: '=',
	        weekStartsOn: '=',
	        onDateSelect: '&'
	      },
	
	      link: function link(scope, element, attrs, ngModel) {
	
	        var allowMultiple = attrs.hasOwnProperty('multiple'),
	            selectedDates = [],
	            wantsModal = element[0] instanceof HTMLInputElement,
	            compiledHtml = $compile(TEMPLATE)(scope),
	            format = (attrs.format || 'yyyy-MM-dd').replace(/m/g, 'M'),
	            dateHelper = dateHelperFactory(format, {
	          previousMonthSelectable: /^(previous|both)$/.test(attrs.selectOtherMonths),
	          nextMonthSelectable: /^(next|both)$/.test(attrs.selectOtherMonths),
	          weekStartsOn: scope.weekStartsOn,
	          noExtraRows: attrs.hasOwnProperty('noExtraRows')
	        });
	
	        scope.displayPicker = !wantsModal;
	
	        scope.setDate = function (dateObj) {
	          if (!dateObj.enabled) return;
	          selectedDates = allowMultiple ? toggleDate(dateObj, selectedDates) : [dateObj];
	
	          setViewValue(selectedDates);
	          scope.onDateSelect(dateObj);
	
	          scope.changeMonth(dateObj.monthOffset);
	          scope.displayPicker = !wantsModal;
	        };
	
	        scope.dateOver = function (dateObj) {
	          /*var overDate = moment(dateObj.formattedDate, 'dd/mm/yyyy');
	            _.forEach(scope.dates, (date) => {
	           var thisDate = moment(date.formattedDate, 'dd/mm/yyyy');
	            if(thisDate.isBefore(overDate)) {
	           console.log(date.formattedDate + 'is before');
	           date.classNames.push('pickadate-rangeBetween');
	           }
	           });*/
	        };
	
	        scope.dateOut = function (dateObj) {
	          /*_.forEach(scope.dates, (date) => {
	           _.remove(date.classNames, function (className) {
	           return className === 'pickadate-rangeBetween';
	           });
	           });*/
	        };
	
	        var $render = ngModel.$render = function (options) {
	          if (angular.isArray(ngModel.$viewValue)) {
	            selectedDates = ngModel.$viewValue;
	          } else if (ngModel.$viewValue) {
	            selectedDates = [ngModel.$viewValue];
	          }
	
	          scope.currentDate = dateHelper.parseDate(scope.defaultDate || selectedDates[0]) || new Date();
	
	          dateHelper.setRestrictions(scope);
	
	          selectedDates = map(selectedDates, function (date) {
	            return dateHelper.buildDateObject(dateHelper.parseDate(date));
	          });
	
	          selectedDates = filter(selectedDates, { enabled: true });
	
	          setViewValue(selectedDates, options);
	          render();
	        };
	
	        scope.classesFor = function (date) {
	          var formattedDates = map(selectedDates, 'formattedDate');
	          var classes = indexOf.call(formattedDates, date.formattedDate) >= 0 ? 'pickadate-active' : null;
	          return date.classNames.concat(classes);
	        };
	
	        scope.changeMonth = function (offset) {
	          if (!offset) return;
	          // If the current date is January 31th, setting the month to date.getMonth() + 1
	          // sets the date to March the 3rd, since the date object adds 30 days to the current
	          // date. Settings the date to the 2nd day of the month is a workaround to prevent this
	          // behaviour
	          scope.currentDate.setDate(1);
	          scope.currentDate.setMonth(scope.currentDate.getMonth() + offset);
	          render();
	        };
	
	        // Workaround to watch multiple properties. XXX use $scope.$watchGroup in angular 1.3
	        scope.$watch(function () {
	          return angular.toJson([scope.minDate, scope.maxDate, scope.disabledDates]);
	        }, $render);
	
	        // Insert datepicker into DOM
	        if (wantsModal) {
	          modalBindings(scope, element, compiledHtml[0]);
	
	          // if the user types a date, update the picker and set validity
	          scope.$watch(function () {
	            return ngModel.$viewValue;
	          }, function (val) {
	            var isValidDate = dateHelper.parseDate(val);
	
	            if (isValidDate) $render({ skipRenderInput: true });
	            ngModel.$setValidity('date', !!isValidDate);
	          });
	
	          // if the input element has a value, set it as the ng-model
	          scope.$$postDigest(function () {
	            if (attrs.value) {
	              ngModel.$viewValue = attrs.value;
	              $render();
	            }
	          });
	
	          element.after(compiledHtml.addClass('pickadate-modal'));
	        } else {
	          element.append(compiledHtml);
	        }
	
	        function render() {
	          var dates = dateHelper.buildDates(scope.currentDate.getFullYear(), scope.currentDate.getMonth());
	
	          scope.allowPrevMonth = dateHelper.allowPrevMonth();
	          scope.allowNextMonth = dateHelper.allowNextMonth();
	          scope.dayNames = dateHelper.buildDayNames();
	
	          scope.dates = map(dates, function (date) {
	            date.classNames = [date.enabled ? 'pickadate-enabled' : 'pickadate-disabled'];
	
	            if (date.outOfMonth) date.classNames.push('pickadate-outOfMonth');
	            if (date.today) date.classNames.push('pickadate-today');
	            if (date.disabled) date.classNames.push('pickadate-unavailable');
	            if (date.fromDate && date.fromDate !== date.toDate) date.classNames.push('pickadate-rangeStart');
	            if (date.toDate && date.toDate !== date.fromDate) date.classNames.push('pickadate-rangeEnd');
	            if (date.betweenDate) date.classNames.push('pickadate-rangeBetween');
	
	            return date;
	          });
	        }
	
	        function setViewValue(value, options) {
	          options = options || {};
	
	          if (allowMultiple) {
	            ngModel.$setViewValue(map(value, 'formattedDate'));
	          } else {
	            ngModel.$setViewValue(value[0] && value[0].formattedDate);
	          }
	
	          if (!options.skipRenderInput) element.val(ngModel.$viewValue);
	        }
	
	        function toggleDate(dateObj, dateArray) {
	          var index = indexOf.call(dateArray, dateObj);
	          if (index === -1) {
	            dateArray.push(dateObj);
	          } else {
	            dateArray.splice(index, 1);
	          }
	          return dateArray;
	        }
	      }
	    };
	  }]);
	})(window.angular);

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	'use strict';
	
	(function (window, angular) {
	  'use strict';
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	  /**
	   * @ngdoc module
	   * @name ngSanitize
	   * @description
	   *
	   * # ngSanitize
	   *
	   * The `ngSanitize` module provides functionality to sanitize HTML.
	   *
	   *
	   * <div doc-module-components="ngSanitize"></div>
	   *
	   * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	   */
	
	  /**
	   * @ngdoc service
	   * @name $sanitize
	   * @kind function
	   *
	   * @description
	   *   Sanitizes an html string by stripping all potentially dangerous tokens.
	   *
	   *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	   *   then serialized back to properly escaped html string. This means that no unsafe input can make
	   *   it into the returned string.
	   *
	   *   The whitelist for URL sanitization of attribute values is configured using the functions
	   *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	   *   `$compileProvider`}.
	   *
	   *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	   *
	   * @param {string} html HTML input.
	   * @returns {string} Sanitized HTML.
	   *
	   * @example
	     <example module="sanitizeExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	           angular.module('sanitizeExample', ['ngSanitize'])
	             .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	               $scope.snippet =
	                 '<p style="color:blue">an html\n' +
	                 '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	                 'snippet</p>';
	               $scope.deliberatelyTrustDangerousSnippet = function() {
	                 return $sce.trustAsHtml($scope.snippet);
	               };
	             }]);
	       </script>
	       <div ng-controller="ExampleController">
	          Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <td>Directive</td>
	             <td>How</td>
	             <td>Source</td>
	             <td>Rendered</td>
	           </tr>
	           <tr id="bind-html-with-sanitize">
	             <td>ng-bind-html</td>
	             <td>Automatically uses $sanitize</td>
	             <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind-html="snippet"></div></td>
	           </tr>
	           <tr id="bind-html-with-trust">
	             <td>ng-bind-html</td>
	             <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	             <td>
	             <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	  &lt;/div&gt;</pre>
	             </td>
	             <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	           </tr>
	           <tr id="bind-default">
	             <td>ng-bind</td>
	             <td>Automatically escapes</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	         </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should sanitize the html snippet by default', function() {
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	       });
	  
	       it('should inline raw snippet if bound to a trusted value', function() {
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	           toBe("<p style=\"color:blue\">an html\n" +
	                "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	                "snippet</p>");
	       });
	  
	       it('should escape snippet without any filter', function() {
	         expect(element(by.css('#bind-default div')).getInnerHtml()).
	           toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	                "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	                "snippet&lt;/p&gt;");
	       });
	  
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	           toBe('new <b>text</b>');
	         expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	           'new <b onclick="alert(1)">text</b>');
	         expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	           "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	       });
	     </file>
	     </example>
	   */
	
	  /**
	   * @ngdoc provider
	   * @name $sanitizeProvider
	   *
	   * @description
	   * Creates and configures {@link $sanitize} instance.
	   */
	  function $SanitizeProvider() {
	    var svgEnabled = false;
	
	    this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
	      if (svgEnabled) {
	        angular.extend(validElements, svgElements);
	      }
	      return function (html) {
	        var buf = [];
	        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
	          return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	        }));
	        return buf.join('');
	      };
	    }];
	
	    /**
	     * @ngdoc method
	     * @name $sanitizeProvider#enableSvg
	     * @kind function
	     *
	     * @description
	     * Enables a subset of svg to be supported by the sanitizer.
	     *
	     * <div class="alert alert-warning">
	     *   <p>By enabling this setting without taking other precautions, you might expose your
	     *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	     *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	     *   link). Such behavior can then result in phishing incidents.</p>
	     *
	     *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	     *   tags within the sanitized content:</p>
	     *
	     *   <br>
	     *
	     *   <pre><code>
	     *   .rootOfTheIncludedContent svg {
	     *     overflow: hidden !important;
	     *   }
	     *   </code></pre>
	     * </div>
	     *
	     * @param {boolean=} regexp New regexp to whitelist urls with.
	     * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	     *    without an argument or self for chaining otherwise.
	     */
	    this.enableSvg = function (enableSvg) {
	      if (angular.isDefined(enableSvg)) {
	        svgEnabled = enableSvg;
	        return this;
	      } else {
	        return svgEnabled;
	      }
	    };
	  }
	
	  function sanitizeText(chars) {
	    var buf = [];
	    var writer = htmlSanitizeWriter(buf, angular.noop);
	    writer.chars(chars);
	    return buf.join('');
	  }
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap("area,br,col,hr,img,wbr");
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	      optionalEndTagInlineElements = toMap("rp,rt"),
	      optionalEndTagElements = angular.extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap("address,article," + "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," + "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	  // Inline Elements - HTML5
	  var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," + "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," + "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," + "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," + "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap("script,style");
	
	  var validElements = angular.extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' + 'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' + 'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' + 'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' + 'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' + 'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' + 'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' + 'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' + 'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' + 'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' + 'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' + 'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' + 'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' + 'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' + 'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = angular.extend({}, uriAttrs, svgAttrs, htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {},
	        items = str.split(','),
	        i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function (window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument("inert");
	    } else {
	      throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParser(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1:
	          // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3:
	          // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType == 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	            if (node.nodeType == 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while (node = inertBodyElement.firstChild) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + ((hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000) + ';';
	    }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriter(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = angular.bind(buf, buf.push);
	    return {
	      start: function start(tag, attrs) {
	        tag = angular.lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          angular.forEach(attrs, function (value, key) {
	            var lkey = angular.lowercase(key);
	            var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
	            if (validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function end(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function chars(_chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(_chars));
	        }
	      }
	    };
	  }
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    if (node.nodeType === window.Node.ELEMENT_NODE) {
	      var attrs = node.attributes;
	      for (var i = 0, l = attrs.length; i < l; i++) {
	        var attrNode = attrs[i];
	        var attrName = attrNode.name.toLowerCase();
	        if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
	          node.removeAttributeNode(attrNode);
	          i--;
	          l--;
	        }
	      }
	    }
	
	    var nextNode = node.firstChild;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	
	    nextNode = node.nextSibling;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	  }
	
	  // define ngSanitize module and register $sanitize service
	  angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	  /* global sanitizeText: false */
	
	  /**
	   * @ngdoc filter
	   * @name linky
	   * @kind function
	   *
	   * @description
	   * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	   * plain email address links.
	   *
	   * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	   *
	   * @param {string} text Input text.
	   * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	   * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	   *
	   *    Can be one of:
	   *
	   *    - `object`: A map of attributes
	   *    - `function`: Takes the url as a parameter and returns a map of attributes
	   *
	   *    If the map of attributes contains a value for `target`, it overrides the value of
	   *    the target parameter.
	   *
	   *
	   * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	   *
	   * @usage
	     <span ng-bind-html="linky_expression | linky"></span>
	   *
	   * @example
	     <example module="linkyExample" deps="angular-sanitize.js">
	       <file name="index.html">
	         <div ng-controller="ExampleController">
	         Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	         <table>
	           <tr>
	             <th>Filter</th>
	             <th>Source</th>
	             <th>Rendered</th>
	           </tr>
	           <tr id="linky-filter">
	             <td>linky filter</td>
	             <td>
	               <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	             </td>
	             <td>
	               <div ng-bind-html="snippet | linky"></div>
	             </td>
	           </tr>
	           <tr id="linky-target">
	            <td>linky target</td>
	            <td>
	              <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	            </td>
	            <td>
	              <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	            </td>
	           </tr>
	           <tr id="linky-custom-attributes">
	            <td>linky custom attributes</td>
	            <td>
	              <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	            </td>
	            <td>
	              <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	            </td>
	           </tr>
	           <tr id="escaped-html">
	             <td>no filter</td>
	             <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	             <td><div ng-bind="snippet"></div></td>
	           </tr>
	         </table>
	       </file>
	       <file name="script.js">
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithSingleURL = 'http://angularjs.org/';
	           }]);
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should linkify the snippet with urls', function() {
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	         });
	  
	         it('should not linkify snippet without the linky filter', function() {
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	               toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                    'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	           expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	         });
	  
	         it('should update', function() {
	           element(by.model('snippet')).clear();
	           element(by.model('snippet')).sendKeys('new http://link.');
	           expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	               toBe('new http://link.');
	           expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	           expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	               .toBe('new http://link.');
	         });
	  
	         it('should work with the target property', function() {
	          expect(element(by.id('linky-target')).
	              element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	              toBe('http://angularjs.org/');
	          expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	         });
	  
	         it('should optionally add custom attributes', function() {
	          expect(element(by.id('linky-custom-attributes')).
	              element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	              toBe('http://angularjs.org/');
	          expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	         });
	       </file>
	     </example>
	   */
	  angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
	    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	        MAILTO_REGEXP = /^mailto:/i;
	
	    var linkyMinErr = angular.$$minErr('linky');
	    var isString = angular.isString;
	
	    return function (text, target, attributes) {
	      if (text == null || text === '') return text;
	      if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	      var match;
	      var raw = text;
	      var html = [];
	      var url;
	      var i;
	      while (match = raw.match(LINKY_URL_REGEXP)) {
	        // We can not end in these as they are sometimes found at the end of the sentence
	        url = match[0];
	        // if we did not match ftp/http/www/mailto then assume mailto
	        if (!match[2] && !match[4]) {
	          url = (match[3] ? 'http://' : 'mailto:') + url;
	        }
	        i = match.index;
	        addText(raw.substr(0, i));
	        addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	        raw = raw.substring(i + match[0].length);
	      }
	      addText(raw);
	      return $sanitize(html.join(''));
	
	      function addText(text) {
	        if (!text) {
	          return;
	        }
	        html.push(sanitizeText(text));
	      }
	
	      function addLink(url, text) {
	        var key;
	        html.push('<a ');
	        if (angular.isFunction(attributes)) {
	          attributes = attributes(url);
	        }
	        if (angular.isObject(attributes)) {
	          for (key in attributes) {
	            html.push(key + '="' + attributes[key] + '" ');
	          }
	        } else {
	          attributes = {};
	        }
	        if (angular.isDefined(target) && !('target' in attributes)) {
	          html.push('target="', target, '" ');
	        }
	        html.push('href="', url.replace(/"/g, '&quot;'), '">');
	        addText(text);
	        html.push('</a>');
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * x is a value between 0 and 1, indicating where in the animation you are.
	 */
	'use strict';
	
	var duScrollDefaultEasing = function duScrollDefaultEasing(x) {
	  'use strict';
	
	  if (x < 0.5) {
	    return Math.pow(x * 2, 2) / 2;
	  }
	  return 1 - Math.pow((1 - x) * 2, 2) / 2;
	};
	
	var duScroll = angular.module('duScroll', ['duScroll.scrollspy', 'duScroll.smoothScroll', 'duScroll.scrollContainer', 'duScroll.spyContext', 'duScroll.scrollHelpers'])
	//Default animation duration for smoothScroll directive
	.value('duScrollDuration', 350)
	//Scrollspy debounce interval, set to 0 to disable
	.value('duScrollSpyWait', 100)
	//Wether or not multiple scrollspies can be active at once
	.value('duScrollGreedy', false)
	//Default offset for smoothScroll directive
	.value('duScrollOffset', 0)
	//Default easing function for scroll animation
	.value('duScrollEasing', duScrollDefaultEasing)
	//Which events on the container (such as body) should cancel scroll animations
	.value('duScrollCancelOnEvents', 'scroll mousedown mousewheel touchmove keydown')
	//Whether or not to activate the last scrollspy, when page/container bottom is reached
	.value('duScrollBottomSpy', false)
	//Active class name
	.value('duScrollActiveClass', 'active');
	
	if (typeof module !== 'undefined' && module && module.exports) {
	  module.exports = duScroll;
	}
	
	angular.module('duScroll.scrollHelpers', ['duScroll.requestAnimation']).run(["$window", "$q", "cancelAnimation", "requestAnimation", "duScrollEasing", "duScrollDuration", "duScrollOffset", "duScrollCancelOnEvents", function ($window, $q, cancelAnimation, requestAnimation, duScrollEasing, duScrollDuration, duScrollOffset, duScrollCancelOnEvents) {
	  'use strict';
	
	  var proto = {};
	
	  var isDocument = function isDocument(el) {
	    return typeof HTMLDocument !== 'undefined' && el instanceof HTMLDocument || el.nodeType && el.nodeType === el.DOCUMENT_NODE;
	  };
	
	  var isElement = function isElement(el) {
	    return typeof HTMLElement !== 'undefined' && el instanceof HTMLElement || el.nodeType && el.nodeType === el.ELEMENT_NODE;
	  };
	
	  var unwrap = function unwrap(el) {
	    return isElement(el) || isDocument(el) ? el : el[0];
	  };
	
	  proto.duScrollTo = function (left, top, duration, easing) {
	    var aliasFn;
	    if (angular.isElement(left)) {
	      aliasFn = this.duScrollToElement;
	    } else if (angular.isDefined(duration)) {
	      aliasFn = this.duScrollToAnimated;
	    }
	    if (aliasFn) {
	      return aliasFn.apply(this, arguments);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollTo(left, top);
	    }
	    el.scrollLeft = left;
	    el.scrollTop = top;
	  };
	
	  var scrollAnimation, deferred;
	  proto.duScrollToAnimated = function (left, top, duration, easing) {
	    if (duration && !easing) {
	      easing = duScrollEasing;
	    }
	    var startLeft = this.duScrollLeft(),
	        startTop = this.duScrollTop(),
	        deltaLeft = Math.round(left - startLeft),
	        deltaTop = Math.round(top - startTop);
	
	    var startTime = null,
	        progress = 0;
	    var el = this;
	
	    var cancelScrollAnimation = function cancelScrollAnimation($event) {
	      if (!$event || progress && $event.which > 0) {
	        if (duScrollCancelOnEvents) {
	          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
	        }
	        cancelAnimation(scrollAnimation);
	        deferred.reject();
	        scrollAnimation = null;
	      }
	    };
	
	    if (scrollAnimation) {
	      cancelScrollAnimation();
	    }
	    deferred = $q.defer();
	
	    if (duration === 0 || !deltaLeft && !deltaTop) {
	      if (duration === 0) {
	        el.duScrollTo(left, top);
	      }
	      deferred.resolve();
	      return deferred.promise;
	    }
	
	    var animationStep = function animationStep(timestamp) {
	      if (startTime === null) {
	        startTime = timestamp;
	      }
	
	      progress = timestamp - startTime;
	      var percent = progress >= duration ? 1 : easing(progress / duration);
	
	      el.scrollTo(startLeft + Math.ceil(deltaLeft * percent), startTop + Math.ceil(deltaTop * percent));
	      if (percent < 1) {
	        scrollAnimation = requestAnimation(animationStep);
	      } else {
	        if (duScrollCancelOnEvents) {
	          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
	        }
	        scrollAnimation = null;
	        deferred.resolve();
	      }
	    };
	
	    //Fix random mobile safari bug when scrolling to top by hitting status bar
	    el.duScrollTo(startLeft, startTop);
	
	    if (duScrollCancelOnEvents) {
	      el.bind(duScrollCancelOnEvents, cancelScrollAnimation);
	    }
	
	    scrollAnimation = requestAnimation(animationStep);
	    return deferred.promise;
	  };
	
	  proto.duScrollToElement = function (target, offset, duration, easing) {
	    var el = unwrap(this);
	    if (!angular.isNumber(offset) || isNaN(offset)) {
	      offset = duScrollOffset;
	    }
	    var top = this.duScrollTop() + unwrap(target).getBoundingClientRect().top - offset;
	    if (isElement(el)) {
	      top -= el.getBoundingClientRect().top;
	    }
	    return this.duScrollTo(0, top, duration, easing);
	  };
	
	  proto.duScrollLeft = function (value, duration, easing) {
	    if (angular.isNumber(value)) {
	      return this.duScrollTo(value, this.duScrollTop(), duration, easing);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
	    }
	    return el.scrollLeft;
	  };
	  proto.duScrollTop = function (value, duration, easing) {
	    if (angular.isNumber(value)) {
	      return this.duScrollTo(this.duScrollLeft(), value, duration, easing);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
	    }
	    return el.scrollTop;
	  };
	
	  proto.duScrollToElementAnimated = function (target, offset, duration, easing) {
	    return this.duScrollToElement(target, offset, duration || duScrollDuration, easing);
	  };
	
	  proto.duScrollTopAnimated = function (top, duration, easing) {
	    return this.duScrollTop(top, duration || duScrollDuration, easing);
	  };
	
	  proto.duScrollLeftAnimated = function (left, duration, easing) {
	    return this.duScrollLeft(left, duration || duScrollDuration, easing);
	  };
	
	  angular.forEach(proto, function (fn, key) {
	    angular.element.prototype[key] = fn;
	
	    //Remove prefix if not already claimed by jQuery / ui.utils
	    var unprefixed = key.replace(/^duScroll/, 'scroll');
	    if (angular.isUndefined(angular.element.prototype[unprefixed])) {
	      angular.element.prototype[unprefixed] = fn;
	    }
	  });
	}]);
	
	//Adapted from https://gist.github.com/paulirish/1579671
	angular.module('duScroll.polyfill', []).factory('polyfill', ["$window", function ($window) {
	  'use strict';
	
	  var vendors = ['webkit', 'moz', 'o', 'ms'];
	
	  return function (fnName, fallback) {
	    if ($window[fnName]) {
	      return $window[fnName];
	    }
	    var suffix = fnName.substr(0, 1).toUpperCase() + fnName.substr(1);
	    for (var key, i = 0; i < vendors.length; i++) {
	      key = vendors[i] + suffix;
	      if ($window[key]) {
	        return $window[key];
	      }
	    }
	    return fallback;
	  };
	}]);
	
	angular.module('duScroll.requestAnimation', ['duScroll.polyfill']).factory('requestAnimation', ["polyfill", "$timeout", function (polyfill, $timeout) {
	  'use strict';
	
	  var lastTime = 0;
	  var fallback = function fallback(callback, element) {
	    var currTime = new Date().getTime();
	    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	    var id = $timeout(function () {
	      callback(currTime + timeToCall);
	    }, timeToCall);
	    lastTime = currTime + timeToCall;
	    return id;
	  };
	
	  return polyfill('requestAnimationFrame', fallback);
	}]).factory('cancelAnimation', ["polyfill", "$timeout", function (polyfill, $timeout) {
	  'use strict';
	
	  var fallback = function fallback(promise) {
	    $timeout.cancel(promise);
	  };
	
	  return polyfill('cancelAnimationFrame', fallback);
	}]);
	
	angular.module('duScroll.spyAPI', ['duScroll.scrollContainerAPI']).factory('spyAPI', ["$rootScope", "$timeout", "$window", "$document", "scrollContainerAPI", "duScrollGreedy", "duScrollSpyWait", "duScrollBottomSpy", "duScrollActiveClass", function ($rootScope, $timeout, $window, $document, scrollContainerAPI, duScrollGreedy, duScrollSpyWait, duScrollBottomSpy, duScrollActiveClass) {
	  'use strict';
	
	  var createScrollHandler = function createScrollHandler(context) {
	    var timer = false,
	        queued = false;
	    var handler = function handler() {
	      queued = false;
	      var container = context.container,
	          containerEl = container[0],
	          containerOffset = 0,
	          bottomReached;
	
	      if (typeof HTMLElement !== 'undefined' && containerEl instanceof HTMLElement || containerEl.nodeType && containerEl.nodeType === containerEl.ELEMENT_NODE) {
	        containerOffset = containerEl.getBoundingClientRect().top;
	        bottomReached = Math.round(containerEl.scrollTop + containerEl.clientHeight) >= containerEl.scrollHeight;
	      } else {
	        var documentScrollHeight = $document[0].body.scrollHeight || $document[0].documentElement.scrollHeight; // documentElement for IE11
	        bottomReached = Math.round($window.pageYOffset + $window.innerHeight) >= documentScrollHeight;
	      }
	      var compareProperty = duScrollBottomSpy && bottomReached ? 'bottom' : 'top';
	
	      var i, currentlyActive, toBeActive, spies, spy, pos;
	      spies = context.spies;
	      currentlyActive = context.currentlyActive;
	      toBeActive = undefined;
	
	      for (i = 0; i < spies.length; i++) {
	        spy = spies[i];
	        pos = spy.getTargetPosition();
	        if (!pos) continue;
	
	        if (duScrollBottomSpy && bottomReached || pos.top + spy.offset - containerOffset < 20 && (duScrollGreedy || (pos.top + spy.offsetBottom) * -1 + containerOffset) < pos.height) {
	          //Find the one closest the viewport top or the page bottom if it's reached
	          if (!toBeActive || toBeActive[compareProperty] < pos[compareProperty]) {
	            toBeActive = {
	              spy: spy
	            };
	            toBeActive[compareProperty] = pos[compareProperty];
	          }
	        }
	      }
	
	      if (toBeActive) {
	        toBeActive = toBeActive.spy;
	      }
	      if (currentlyActive === toBeActive || duScrollGreedy && !toBeActive) return;
	      if (currentlyActive) {
	        currentlyActive.$element.removeClass(duScrollActiveClass);
	        $rootScope.$broadcast('duScrollspy:becameInactive', currentlyActive.$element, angular.element(currentlyActive.getTargetElement()));
	      }
	      if (toBeActive) {
	        toBeActive.$element.addClass(duScrollActiveClass);
	        $rootScope.$broadcast('duScrollspy:becameActive', toBeActive.$element, angular.element(toBeActive.getTargetElement()));
	      }
	      context.currentlyActive = toBeActive;
	    };
	
	    if (!duScrollSpyWait) {
	      return handler;
	    }
	
	    //Debounce for potential performance savings
	    return function () {
	      if (!timer) {
	        handler();
	        timer = $timeout(function () {
	          timer = false;
	          if (queued) {
	            handler();
	          }
	        }, duScrollSpyWait, false);
	      } else {
	        queued = true;
	      }
	    };
	  };
	
	  var contexts = {};
	
	  var createContext = function createContext($scope) {
	    var id = $scope.$id;
	    var context = {
	      spies: []
	    };
	
	    context.handler = createScrollHandler(context);
	    contexts[id] = context;
	
	    $scope.$on('$destroy', function () {
	      destroyContext($scope);
	    });
	
	    return id;
	  };
	
	  var destroyContext = function destroyContext($scope) {
	    var id = $scope.$id;
	    var context = contexts[id],
	        container = context.container;
	    if (container) {
	      container.off('scroll', context.handler);
	    }
	    delete contexts[id];
	  };
	
	  var defaultContextId = createContext($rootScope);
	
	  var getContextForScope = function getContextForScope(_x) {
	    var _again = true;
	
	    _function: while (_again) {
	      var scope = _x;
	      _again = false;
	
	      if (contexts[scope.$id]) {
	        return contexts[scope.$id];
	      }
	      if (scope.$parent) {
	        _x = scope.$parent;
	        _again = true;
	        continue _function;
	      }
	      return contexts[defaultContextId];
	    }
	  };
	
	  var getContextForSpy = function getContextForSpy(spy) {
	    var context,
	        contextId,
	        scope = spy.$scope;
	    if (scope) {
	      return getContextForScope(scope);
	    }
	    //No scope, most likely destroyed
	    for (contextId in contexts) {
	      context = contexts[contextId];
	      if (context.spies.indexOf(spy) !== -1) {
	        return context;
	      }
	    }
	  };
	
	  var isElementInDocument = function isElementInDocument(element) {
	    while (element.parentNode) {
	      element = element.parentNode;
	      if (element === document) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  var addSpy = function addSpy(spy) {
	    var context = getContextForSpy(spy);
	    if (!context) return;
	    context.spies.push(spy);
	    if (!context.container || !isElementInDocument(context.container)) {
	      if (context.container) {
	        context.container.off('scroll', context.handler);
	      }
	      context.container = scrollContainerAPI.getContainer(spy.$scope);
	      context.container.on('scroll', context.handler).triggerHandler('scroll');
	    }
	  };
	
	  var removeSpy = function removeSpy(spy) {
	    var context = getContextForSpy(spy);
	    if (spy === context.currentlyActive) {
	      $rootScope.$broadcast('duScrollspy:becameInactive', context.currentlyActive.$element);
	      context.currentlyActive = null;
	    }
	    var i = context.spies.indexOf(spy);
	    if (i !== -1) {
	      context.spies.splice(i, 1);
	    }
	    spy.$element = null;
	  };
	
	  return {
	    addSpy: addSpy,
	    removeSpy: removeSpy,
	    createContext: createContext,
	    destroyContext: destroyContext,
	    getContextForScope: getContextForScope
	  };
	}]);
	
	angular.module('duScroll.scrollContainerAPI', []).factory('scrollContainerAPI', ["$document", function ($document) {
	  'use strict';
	
	  var containers = {};
	
	  var setContainer = function setContainer(scope, element) {
	    var id = scope.$id;
	    containers[id] = element;
	    return id;
	  };
	
	  var getContainerId = function getContainerId(_x2) {
	    var _again2 = true;
	
	    _function2: while (_again2) {
	      var scope = _x2;
	      _again2 = false;
	
	      if (containers[scope.$id]) {
	        return scope.$id;
	      }
	      if (scope.$parent) {
	        _x2 = scope.$parent;
	        _again2 = true;
	        continue _function2;
	      }
	      return;
	    }
	  };
	
	  var getContainer = function getContainer(scope) {
	    var id = getContainerId(scope);
	    return id ? containers[id] : $document;
	  };
	
	  var removeContainer = function removeContainer(scope) {
	    var id = getContainerId(scope);
	    if (id) {
	      delete containers[id];
	    }
	  };
	
	  return {
	    getContainerId: getContainerId,
	    getContainer: getContainer,
	    setContainer: setContainer,
	    removeContainer: removeContainer
	  };
	}]);
	
	angular.module('duScroll.smoothScroll', ['duScroll.scrollHelpers', 'duScroll.scrollContainerAPI']).directive('duSmoothScroll', ["duScrollDuration", "duScrollOffset", "scrollContainerAPI", function (duScrollDuration, duScrollOffset, scrollContainerAPI) {
	  'use strict';
	
	  return {
	    link: function link($scope, $element, $attr) {
	      $element.on('click', function (e) {
	        if ((!$attr.href || $attr.href.indexOf('#') === -1) && $attr.duSmoothScroll === '') return;
	
	        var id = $attr.href ? $attr.href.replace(/.*(?=#[^\s]+$)/, '').substring(1) : $attr.duSmoothScroll;
	
	        var target = document.getElementById(id) || document.getElementsByName(id)[0];
	        if (!target || !target.getBoundingClientRect) return;
	
	        if (e.stopPropagation) e.stopPropagation();
	        if (e.preventDefault) e.preventDefault();
	
	        var offset = $attr.offset ? parseInt($attr.offset, 10) : duScrollOffset;
	        var duration = $attr.duration ? parseInt($attr.duration, 10) : duScrollDuration;
	        var container = scrollContainerAPI.getContainer($scope);
	
	        container.duScrollToElement(angular.element(target), isNaN(offset) ? 0 : offset, isNaN(duration) ? 0 : duration);
	      });
	    }
	  };
	}]);
	
	angular.module('duScroll.spyContext', ['duScroll.spyAPI']).directive('duSpyContext', ["spyAPI", function (spyAPI) {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function compile(tElement, tAttrs, transclude) {
	      return {
	        pre: function preLink($scope, iElement, iAttrs, controller) {
	          spyAPI.createContext($scope);
	        }
	      };
	    }
	  };
	}]);
	
	angular.module('duScroll.scrollContainer', ['duScroll.scrollContainerAPI']).directive('duScrollContainer', ["scrollContainerAPI", function (scrollContainerAPI) {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function compile(tElement, tAttrs, transclude) {
	      return {
	        pre: function preLink($scope, iElement, iAttrs, controller) {
	          iAttrs.$observe('duScrollContainer', function (element) {
	            if (angular.isString(element)) {
	              element = document.getElementById(element);
	            }
	
	            element = angular.isElement(element) ? angular.element(element) : iElement;
	            scrollContainerAPI.setContainer($scope, element);
	            $scope.$on('$destroy', function () {
	              scrollContainerAPI.removeContainer($scope);
	            });
	          });
	        }
	      };
	    }
	  };
	}]);
	
	angular.module('duScroll.scrollspy', ['duScroll.spyAPI']).directive('duScrollspy', ["spyAPI", "duScrollOffset", "$timeout", "$rootScope", function (spyAPI, duScrollOffset, $timeout, $rootScope) {
	  'use strict';
	
	  var Spy = function Spy(targetElementOrId, $scope, $element, offset, offsetBottom) {
	    if (angular.isElement(targetElementOrId)) {
	      this.target = targetElementOrId;
	    } else if (angular.isString(targetElementOrId)) {
	      this.targetId = targetElementOrId;
	    }
	    this.$scope = $scope;
	    this.$element = $element;
	    this.offset = offset;
	    this.offsetBottom = offsetBottom;
	  };
	
	  Spy.prototype.getTargetElement = function () {
	    if (!this.target && this.targetId) {
	      this.target = document.getElementById(this.targetId) || document.getElementsByName(this.targetId)[0];
	    }
	    return this.target;
	  };
	
	  Spy.prototype.getTargetPosition = function () {
	    var target = this.getTargetElement();
	    if (target) {
	      return target.getBoundingClientRect();
	    }
	  };
	
	  Spy.prototype.flushTargetCache = function () {
	    if (this.targetId) {
	      this.target = undefined;
	    }
	  };
	
	  return {
	    link: function link($scope, $element, $attr) {
	      var href = $attr.ngHref || $attr.href;
	      var targetId;
	
	      if (href && href.indexOf('#') !== -1) {
	        targetId = href.replace(/.*(?=#[^\s]+$)/, '').substring(1);
	      } else if ($attr.duScrollspy) {
	        targetId = $attr.duScrollspy;
	      } else if ($attr.duSmoothScroll) {
	        targetId = $attr.duSmoothScroll;
	      }
	      if (!targetId) return;
	
	      // Run this in the next execution loop so that the scroll context has a chance
	      // to initialize
	      var timeoutPromise = $timeout(function () {
	        var spy = new Spy(targetId, $scope, $element, -($attr.offset ? parseInt($attr.offset, 10) : duScrollOffset), -($attr.offsetBottom ? parseInt($attr.offsetBottom, 10) : 0));
	        spyAPI.addSpy(spy);
	
	        $scope.$on('$locationChangeSuccess', spy.flushTargetCache.bind(spy));
	        var deregisterOnStateChange = $rootScope.$on('$stateChangeSuccess', spy.flushTargetCache.bind(spy));
	        $scope.$on('$destroy', function () {
	          spyAPI.removeSpy(spy);
	          deregisterOnStateChange();
	        });
	      }, 0, false);
	      $scope.$on('$destroy', function () {
	        $timeout.cancel(timeoutPromise);
	      });
	    }
	  };
	}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)(module)))

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

	/**
	 * angular-fancy-modal - the definitive modal/popup/dialog solution for AngularJS.
	 * @author Alessandro Arnodo
	 * @author Arseny Peisakhov
	 *    06-08-2015 - modified module to re-use an existing overlay and disable animations
	 * @url http://alessandro.arnodo.net
	 * @version v0.1.5
	 * @link https://github.com/vesparny/angular-fancy-modal
	 * @license MIT
	 */
	'use strict';
	
	(function (angular, document, window, undefined) {
	    'use strict';
	    angular.module('vesparny.fancyModal', []).provider('$fancyModal', function () {
	        var defaults = this.defaults = {
	            templateUrl: '',
	            template: '<div></div>',
	            resolve: {},
	            controller: '',
	            scope: '',
	            showCloseButton: true,
	            closeOnEscape: true,
	            closeOnOverlayClick: true,
	            overlay: true,
	            themeClass: '',
	            openingClass: 'fancymodal-content-opening',
	            closingClass: 'fancymodal-content-closing',
	            openingOverlayClass: 'fancymodal-overlay-opening',
	            closingOverlayClass: 'fancymodal-overlay-closing',
	            bodyClass: 'fancymodal-open'
	        };
	
	        /**
	         * [setDefaults overriding defaults]
	         * @param {[Object]} options [new defaults]
	         */
	        this.setDefaults = function (options) {
	            angular.extend(this.defaults, options);
	        };
	
	        this.$get = ['$controller', '$timeout', '$rootScope', '$injector', '$compile', '$http', '$templateCache', '$window', '$document', '$q', function ($controller, $timeout, $rootScope, $injector, $compile, $http, $templateCache, $window, $document, $q) {
	
	            var isieEdge = navigator.appName == "Netscape" && navigator.appVersion.indexOf('Trident') === -1;
	            var modalCounter = 0;
	            var incrementalId = 0;
	            var isClosing = false;
	
	            var style = (document.body || document.documentElement).style;
	
	            var animationEndSupport = angular.isDefined(style.animation) || angular.isDefined(style.WebkitAnimation) || angular.isDefined(style.MozAnimation) || angular.isDefined(style.MsAnimation) || angular.isDefined(style.OAnimation);
	
	            var animationEndEvent = 'animationend webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend';
	
	            var $body = angular.element(document).find('body');
	            var $html = angular.element(document).find('html');
	
	            // private methds
	
	            function onKeydown(event) {
	                if (event.keyCode === 27) {
	                    _close();
	                }
	            }
	
	            //http://davidwalsh.name/detect-scrollbar-width
	            function getScrollBarWidth() {
	                var scrollDiv = document.createElement('div');
	
	                scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
	
	                document.body.appendChild(scrollDiv);
	
	                var size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	                document.body.removeChild(scrollDiv);
	
	                return size;
	            }
	
	            function hasScrollbars() {
	                return $body[0].scrollHeight > $window.innerHeight;
	            }
	
	            function getTemplatePromise(options) {
	                var deferred = $q.defer();
	
	                if (options.templateUrl) {
	                    $http.get(options.templateUrl, {
	                        cache: $templateCache
	                    }).then(function (result) {
	                        deferred.resolve(result.data);
	                    });
	                } else {
	                    deferred.resolve(options.template);
	                }
	
	                return deferred.promise;
	            }
	
	            function getResolvePromises(resolves) {
	                var promisesArr = [];
	
	                angular.forEach(resolves, function (value) {
	                    promisesArr.push($q.when($injector.invoke(value)));
	                });
	
	                return promisesArr;
	            }
	
	            function cleanUp($modal) {
	                var elementId = $modal.attr('id');
	
	                //$modal.scope().$destroy();
	                $modal.remove();
	
	                isClosing = false;
	
	                if (modalCounter <= 0) {
	                    // Updated by Seny
	                    $body.removeClass(defaults.bodyClass);
	                    $html.css('margin-right', '');
	                }
	
	                $rootScope.$emit('$fancyModal.closed', elementId);
	            }
	
	            function bodyFreezeScroll() {
	                var $bod = $(window.document.body);
	                var bodyWidth = $bod.innerWidth();
	                $bod.css('overflow', 'hidden');
	                $bod.css('marginRight', ($bod.css('marginRight') ? '+=' : '') + ($bod.innerWidth() - bodyWidth));
	            }
	
	            function bodyUnfreezeScroll() {
	                var $bod = $(window.document.body);
	                var bodyWidth = $bod.innerWidth();
	                $bod.css('marginRight', '-=' + (bodyWidth - $body.innerWidth()));
	                $bod.css('overflow', 'auto');
	            }
	
	            function closeModal(modal) {
	                var $modal = angular.element(modal);
	                var options = $modal.data('options');
	
	                isClosing = true;
	
	                $modal.unbind('click');
	
	                if (modalCounter === 1) {
	                    $document.unbind('keydown');
	                }
	
	                modalCounter -= 1;
	
	                // Updated by Seny
	                var overlay = $('body > .fancymodal-overlay');
	
	                if (animationEndSupport && !$body.hasClass('quickModalTransition')) {
	                    var content = angular.element(modal.children[0]);
	
	                    if (options.overlay) {
	                        // Updated by Seny
	                        if (overlay.length) {
	                            overlay.removeClass(options.openingOverlayClass).addClass(options.closingOverlayClass);
	                        } else {
	                            overlay = angular.element(modal.children[0]);
	                            overlay.addClass(options.closingOverlayClass);
	                            content = angular.element(modal.children[1]);
	                        }
	                    }
	
	                    content.unbind(animationEndEvent).bind(animationEndEvent, function () {
	                        content.remove();
	                        cleanUp($modal);
	                    }).removeClass(options.openingClass).addClass(options.closingClass);
	                } else {
	                    cleanUp($modal);
	                }
	
	                // Updated by Seny
	                if ($body.hasClass('noModalAnimation')) {
	                    $body.removeClass('quickModalTransition noModalAnimation');
	                    overlay.removeClass(options.openingOverlayClass);
	                }
	            }
	
	            function closeAll() {
	                var modals = document.querySelectorAll('.fancymodal');
	
	                angular.forEach(modals, function (modal) {
	                    closeModal(modal);
	                });
	            }
	
	            // public API
	
	            /**
	             * open a modal
	             * @param  {[object]} opts [modal params]
	             * @return Promise
	             */
	            function _open(opts) {
	
	                function closeByAction(event) {
	                    var overlay = angular.element(event.target).hasClass('fancymodal-overlay');
	                    var closeBtn = angular.element(event.target).hasClass('fancymodal-close');
	
	                    if (overlay && options.closeOnOverlayClick || closeBtn) {
	                        _close(modal.attr('id'));
	                    }
	                }
	
	                function execOpen($modal) {
	                    var defer = $q.defer();
	                    var htmlTemplate;
	
	                    getTemplatePromise(options).then(function (template) {
	                        htmlTemplate = template;
	                        return $q.all(getResolvePromises(options.resolve));
	                    }).then(function (locals) {
	                        if (!isClosing) {
	                            var data = {};
	                            var resolveCounter = 0;
	                            var ctrl;
	                            angular.forEach(options.resolve, function (value, key) {
	                                data[key] = locals[resolveCounter];
	                                resolveCounter += 1;
	                            });
	                            scope.$modal = $modal;
	                            data.$scope = scope;
	                            if (options.controller) {
	                                ctrl = $controller(options.controller, data);
	                            }
	
	                            if (isieEdge) {
	                                $timeout(function () {
	                                    contentData.append($compile(htmlTemplate)(scope));
	                                }, 0);
	                            } else {
	                                contentData.append($compile(htmlTemplate)(scope));
	                            }
	
	                            $rootScope.$emit('$fancyModal.opened', modal);
	                            defer.resolve();
	                        } else {
	                            defer.reject();
	                        }
	                    });
	
	                    return defer.promise;
	                }
	
	                var options = angular.copy(defaults);
	                opts = opts || {};
	                angular.extend(options, opts);
	                modalCounter += 1;
	                incrementalId += 1;
	
	                $body.addClass(options.bodyClass);
	
	                if (hasScrollbars()) {
	                    $html.css('margin-right', getScrollBarWidth() + 'px');
	                }
	
	                var scope = (options.scope || $rootScope).$new();
	
	                var modal = angular.element('<div id="fancymodal-' + incrementalId + '" class="fancymodal"></div>').addClass(options.themeClass);
	
	                modal.data('options', options);
	                var content = angular.element('<div>').addClass('fancymodal-content');
	
	                if (options.showCloseButton) {
	                    var closeButton = angular.element('<div>').addClass('fancymodal-close');
	                    content.append(closeButton);
	                }
	
	                if (options.closeOnEscape) {
	                    $document.bind('keydown', onKeydown);
	                }
	
	                var contentData = angular.element('<div>').addClass('fancymodal-data');
	
	                if (options.overlay) {
	                    var overlay = $('body > .fancymodal-overlay');
	
	                    if (overlay.length) {
	                        $('body > .fancymodal-overlay').removeClass(options.closingOverlayClass).addClass(options.openingOverlayClass);
	                    } else {
	                        overlay = angular.element('<div>').addClass('fancymodal-overlay').addClass(options.openingOverlayClass);
	
	                        modal.append(overlay);
	                    }
	                }
	
	                content.append(contentData);
	                content.addClass(options.openingClass);
	
	                modal.bind('click', closeByAction);
	                modal.append(content);
	
	                if (isieEdge) {
	                    $timeout(function () {
	                        $body.append($compile(modal)(scope));
	                    }, 0);
	                } else {
	                    $body.append($compile(modal)(scope));
	                }
	
	                //$body.append($compile(modal)(scope));
	
	                var id = 'fancymodal-' + incrementalId;
	                var $modal = {
	                    id: id,
	                    close: function close() {
	                        return _close(id);
	                    }
	                };
	                // open the dialog
	                var openPromise = execOpen($modal);
	
	                return angular.extend({
	                    opened: openPromise
	                }, $modal);
	            }
	            /**
	             * [close close a modal]
	             * @param  {[integer]} id [the id of the modal to be closed]
	             */
	            function _close(id) {
	                var modal = document.getElementById(id);
	                if (modal) {
	                    closeModal(modal);
	                } else {
	                    closeAll();
	                }
	            }
	
	            return {
	                open: function open(options) {
	                    return _open(options);
	                },
	                close: function close(id) {
	                    return _close(id);
	                },
	                getDefaults: function getDefaults() {
	                    return angular.copy(defaults);
	                }
	            };
	        }];
	    }).directive('fancyModal', ['$fancyModal', function ($fancyModal) {
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                var modal;
	                var options;
	                // Trigger
	                element.on(attrs.trigger || 'click', function () {
	                    options = $fancyModal.getDefaults();
	                    angular.forEach(Object.keys(options), function (key) {
	                        if (angular.isDefined(attrs[key])) {
	                            //TODO fix this, it sucks bad
	                            if (attrs[key] === 'true') {
	                                options[key] = true;
	                            } else if (attrs[key] === 'false') {
	                                options[key] = false;
	                            } else {
	                                options[key] = attrs[key];
	                            }
	                        }
	                    });
	                    modal = $fancyModal.open(options);
	                });
	
	                // Garbage collection
	                scope.$on('$destroy', function () {
	                    if (modal) {
	                        modal.opened.then(function () {
	                            modal.close();
	                            modal = null;
	                        });
	                    } else {
	                        modal = null;
	                    }
	                    options = null;
	                });
	            }
	        };
	    }]);
	})(angular, document, window);

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	/*** Directives and services for responding to idle users in AngularJS
	* @author Mike Grabski <me@mikegrabski.com>
	* @version v1.2.2
	* @link https://github.com/HackedByChinese/ng-idle.git
	* @license MIT
	*/
	'use strict';
	
	(function (window, angular, undefined) {
	  'use strict';
	  angular.module('ngIdle', ['ngIdle.keepalive', 'ngIdle.idle', 'ngIdle.countdown', 'ngIdle.title', 'ngIdle.localStorage']);
	  angular.module('ngIdle.keepalive', []).provider('Keepalive', function () {
	    var options = {
	      http: null,
	      interval: 10 * 60
	    };
	
	    this.http = function (value) {
	      if (!value) throw new Error('Argument must be a string containing a URL, or an object containing the HTTP request configuration.');
	      if (angular.isString(value)) {
	        value = {
	          url: value,
	          method: 'GET'
	        };
	      }
	
	      value.cache = false;
	
	      options.http = value;
	    };
	
	    var setInterval = this.interval = function (seconds) {
	      seconds = parseInt(seconds);
	
	      if (isNaN(seconds) || seconds <= 0) throw new Error('Interval must be expressed in seconds and be greater than 0.');
	      options.interval = seconds;
	    };
	
	    this.$get = ['$rootScope', '$log', '$interval', '$http', function ($rootScope, $log, $interval, $http) {
	
	      var state = {
	        ping: null
	      };
	
	      function handleResponse(data, status) {
	        $rootScope.$broadcast('KeepaliveResponse', data, status);
	      }
	
	      function _ping() {
	        $rootScope.$broadcast('Keepalive');
	
	        if (angular.isObject(options.http)) {
	          $http(options.http).then(handleResponse)['catch'](handleResponse);
	        }
	      }
	
	      return {
	        _options: function _options() {
	          return options;
	        },
	        setInterval: setInterval,
	        start: function start() {
	          $interval.cancel(state.ping);
	
	          state.ping = $interval(_ping, options.interval * 1000);
	          return state.ping;
	        },
	        stop: function stop() {
	          $interval.cancel(state.ping);
	        },
	        ping: function ping() {
	          _ping();
	        }
	      };
	    }];
	  });
	
	  angular.module('ngIdle.idle', ['ngIdle.keepalive', 'ngIdle.localStorage']).provider('Idle', function () {
	    var options = {
	      idle: 20 * 60, // in seconds (default is 20min)
	      timeout: 30, // in seconds (default is 30sec)
	      autoResume: 'idle', // lets events automatically resume (unsets idle state/resets warning)
	      interrupt: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
	      windowInterrupt: null,
	      keepalive: true
	    };
	
	    /**
	     *  Sets the number of seconds a user can be idle before they are considered timed out.
	     *  @param {Number|Boolean} seconds A positive number representing seconds OR 0 or false to disable this feature.
	     */
	    var _setTimeout = this.timeout = function (seconds) {
	      if (seconds === false) options.timeout = 0;else if (angular.isNumber(seconds) && seconds >= 0) options.timeout = seconds;else throw new Error('Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.');
	    };
	
	    this.interrupt = function (events) {
	      options.interrupt = events;
	    };
	
	    this.windowInterrupt = function (events) {
	      options.windowInterrupt = events;
	    };
	
	    var _setIdle = this.idle = function (seconds) {
	      if (seconds <= 0) throw new Error('Idle must be a value in seconds, greater than 0.');
	
	      options.idle = seconds;
	    };
	
	    this.autoResume = function (value) {
	      if (value === true) options.autoResume = 'idle';else if (value === false) options.autoResume = 'off';else options.autoResume = value;
	    };
	
	    this.keepalive = function (enabled) {
	      options.keepalive = enabled === true;
	    };
	
	    this.$get = ['$interval', '$log', '$rootScope', '$document', 'Keepalive', 'IdleLocalStorage', '$window', function ($interval, $log, $rootScope, $document, Keepalive, LocalStorage, $window) {
	      var state = {
	        idle: null,
	        timeout: null,
	        idling: false,
	        running: false,
	        countdown: null
	      };
	
	      var id = new Date().getTime();
	
	      function startKeepalive() {
	        if (!options.keepalive) return;
	
	        if (state.running) Keepalive.ping();
	
	        Keepalive.start();
	      }
	
	      function stopKeepalive() {
	        if (!options.keepalive) return;
	
	        Keepalive.stop();
	      }
	
	      function toggleState() {
	        state.idling = !state.idling;
	        var name = state.idling ? 'IdleStart' : 'IdleEnd';
	
	        if (state.idling) {
	          $rootScope.$broadcast(name);
	          stopKeepalive();
	          if (options.timeout) {
	            state.countdown = options.timeout;
	            countdown();
	            state.timeout = $interval(countdown, 1000, options.timeout, false);
	          }
	        } else {
	          startKeepalive();
	          $rootScope.$broadcast(name);
	        }
	
	        $interval.cancel(state.idle);
	      }
	
	      function countdown() {
	
	        // check not called when no longer idling
	        // possible with multiple tabs
	        if (!state.idling) {
	          return;
	        }
	
	        // countdown has expired, so signal timeout
	        if (state.countdown <= 0) {
	          timeout();
	          return;
	        }
	
	        // countdown hasn't reached zero, so warn and decrement
	        $rootScope.$broadcast('IdleWarn', state.countdown);
	        state.countdown--;
	      }
	
	      function timeout() {
	        stopKeepalive();
	        $interval.cancel(state.idle);
	        $interval.cancel(state.timeout);
	
	        state.idling = true;
	        state.running = false;
	        state.countdown = 0;
	
	        $rootScope.$broadcast('IdleTimeout');
	      }
	
	      function changeOption(self, fn, value) {
	        var reset = self.running();
	
	        self.unwatch();
	        fn(value);
	        if (reset) self.watch();
	      }
	
	      function getExpiry() {
	        var obj = LocalStorage.get('expiry');
	
	        return obj && obj.time ? new Date(obj.time) : null;
	      }
	
	      function setExpiry(date) {
	        if (!date) LocalStorage.remove('expiry');else LocalStorage.set('expiry', { id: id, time: date });
	      }
	
	      var svc = {
	        _options: function _options() {
	          return options;
	        },
	        _getNow: function _getNow() {
	          return new Date();
	        },
	        getIdle: function getIdle() {
	          return options.idle;
	        },
	        getTimeout: function getTimeout() {
	          return options.timeout;
	        },
	        setIdle: function setIdle(seconds) {
	          changeOption(this, _setIdle, seconds);
	        },
	        setTimeout: function setTimeout(seconds) {
	          changeOption(this, _setTimeout, seconds);
	        },
	        isExpired: function isExpired() {
	          var expiry = getExpiry();
	          return expiry !== null && expiry <= this._getNow();
	        },
	        running: function running() {
	          return state.running;
	        },
	        idling: function idling() {
	          return state.idling;
	        },
	        watch: function watch(noExpiryUpdate) {
	          $interval.cancel(state.idle);
	          $interval.cancel(state.timeout);
	
	          // calculate the absolute expiry date, as added insurance against a browser sleeping or paused in the background
	          var timeout = !options.timeout ? 0 : options.timeout;
	          if (!noExpiryUpdate) setExpiry(new Date(new Date().getTime() + (options.idle + timeout) * 1000));
	
	          if (state.idling) toggleState(); // clears the idle state if currently idling
	          else if (!state.running) startKeepalive(); // if about to run, start keep alive
	
	          state.running = true;
	
	          state.idle = $interval(toggleState, options.idle * 1000, 0, false);
	        },
	        unwatch: function unwatch() {
	          $interval.cancel(state.idle);
	          $interval.cancel(state.timeout);
	
	          state.idling = false;
	          state.running = false;
	          setExpiry(null);
	
	          stopKeepalive();
	        },
	        interrupt: function interrupt(anotherTab) {
	          if (!state.running) return;
	
	          if (options.timeout && this.isExpired()) {
	            timeout();
	            return;
	          }
	
	          // note: you can no longer auto resume once we exceed the expiry; you will reset state by calling watch() manually
	          if (anotherTab || options.autoResume === 'idle' || options.autoResume === 'notIdle' && !state.idling) this.watch(anotherTab);
	        }
	      };
	
	      var lastMove = {
	        clientX: null,
	        clientY: null,
	        swap: function swap(event) {
	          var last = { clientX: this.clientX, clientY: this.clientY };
	          this.clientX = event.clientX;
	          this.clientY = event.clientY;
	          return last;
	        },
	        hasMoved: function hasMoved(event) {
	          var last = this.swap(event);
	          if (this.clientX === null || event.movementX || event.movementY) return true;else if (last.clientX != event.clientX || last.clientY != event.clientY) return true;else return false;
	        }
	      };
	
	      $document.find('html').on(options.interrupt, function (event) {
	        if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
	          return; // Fix for Chrome desktop notifications, triggering mousemove event.
	        }
	
	        if (event.type !== 'mousemove' || lastMove.hasMoved(event)) {
	          svc.interrupt();
	        }
	      });
	
	      if (options.windowInterrupt) {
	        var eventList = options.windowInterrupt.split(' ');
	        var fn = function fn() {
	          svc.interrupt();
	        };
	
	        for (var i = 0; i < eventList.length; i++) {
	          if ($window.addEventListener) $window.addEventListener(eventList[i], fn, false);else $window.attachEvent(eventList[i], fn);
	        }
	      }
	
	      var wrap = function wrap(event) {
	        if (event.key === 'ngIdle.expiry' && event.newValue && event.newValue !== event.oldValue) {
	          var val = angular.fromJson(event.newValue);
	          if (val.id === id) return;
	          svc.interrupt(true);
	        }
	      };
	
	      if ($window.addEventListener) $window.addEventListener('storage', wrap, false);else $window.attachEvent('onstorage', wrap);
	
	      return svc;
	    }];
	  });
	
	  angular.module('ngIdle.countdown', ['ngIdle.idle']).directive('idleCountdown', ['Idle', function (Idle) {
	    return {
	      restrict: 'A',
	      scope: {
	        value: '=idleCountdown'
	      },
	      link: function link($scope) {
	        // Initialize the scope's value to the configured timeout.
	        $scope.value = Idle.getTimeout();
	
	        $scope.$on('IdleWarn', function (e, countdown) {
	          $scope.$evalAsync(function () {
	            $scope.value = countdown;
	          });
	        });
	
	        $scope.$on('IdleTimeout', function () {
	          $scope.$evalAsync(function () {
	            $scope.value = 0;
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('ngIdle.title', []).provider('Title', function () {
	    var options = {
	      enabled: true
	    };
	
	    var setEnabled = this.enabled = function (enabled) {
	      options.enabled = enabled === true;
	    };
	
	    function padLeft(nr, n, str) {
	      return new Array(n - String(nr).length + 1).join(str || '0') + nr;
	    }
	
	    this.$get = ['$document', '$interpolate', function ($document, $interpolate) {
	      var state = {
	        original: null,
	        idle: '{{minutes}}:{{seconds}} until your session times out!',
	        timedout: 'Your session has expired.'
	      };
	
	      return {
	        setEnabled: setEnabled,
	        isEnabled: function isEnabled() {
	          return options.enabled;
	        },
	        original: function original(val) {
	          if (angular.isUndefined(val)) return state.original;
	
	          state.original = val;
	        },
	        store: function store(overwrite) {
	          if (overwrite || !state.original) state.original = this.value();
	        },
	        value: function value(val) {
	          if (angular.isUndefined(val)) return $document[0].title;
	
	          $document[0].title = val;
	        },
	        idleMessage: function idleMessage(val) {
	          if (angular.isUndefined(val)) return state.idle;
	
	          state.idle = val;
	        },
	        timedOutMessage: function timedOutMessage(val) {
	          if (angular.isUndefined(val)) return state.timedout;
	
	          state.timedout = val;
	        },
	        setAsIdle: function setAsIdle(countdown) {
	          this.store();
	
	          var remaining = { totalSeconds: countdown };
	          remaining.minutes = Math.floor(countdown / 60);
	          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);
	
	          this.value($interpolate(this.idleMessage())(remaining));
	        },
	        setAsTimedOut: function setAsTimedOut() {
	          this.store();
	
	          this.value(this.timedOutMessage());
	        },
	        restore: function restore() {
	          if (this.original()) this.value(this.original());
	        }
	      };
	    }];
	  }).directive('title', ['Title', function (Title) {
	    return {
	      restrict: 'E',
	      link: function link($scope, $element, $attr) {
	        if (!Title.isEnabled() || $attr.idleDisabled) return;
	
	        Title.store(true);
	
	        $scope.$on('IdleStart', function () {
	          Title.original($element[0].innerText);
	        });
	
	        $scope.$on('IdleWarn', function (e, countdown) {
	          Title.setAsIdle(countdown);
	        });
	
	        $scope.$on('IdleEnd', function () {
	          Title.restore();
	        });
	
	        $scope.$on('IdleTimeout', function () {
	          Title.setAsTimedOut();
	        });
	      }
	    };
	  }]);
	
	  angular.module('ngIdle.localStorage', []).service('IdleStorageAccessor', ['$window', function ($window) {
	    return {
	      get: function get() {
	        return $window.localStorage;
	      }
	    };
	  }]).service('IdleLocalStorage', ['IdleStorageAccessor', function (IdleStorageAccessor) {
	    function AlternativeStorage() {
	      var storageMap = {};
	
	      this.setItem = function (key, value) {
	        storageMap[key] = value;
	      };
	
	      this.getItem = function (key) {
	        if (typeof storageMap[key] !== 'undefined') {
	          return storageMap[key];
	        }
	        return null;
	      };
	
	      this.removeItem = function (key) {
	        storageMap[key] = undefined;
	      };
	    }
	
	    function getStorage() {
	      try {
	        var s = IdleStorageAccessor.get();
	        s.setItem('ngIdleStorage', '');
	        s.removeItem('ngIdleStorage');
	
	        return s;
	      } catch (err) {
	        return new AlternativeStorage();
	      }
	    }
	
	    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
	    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
	    // to avoid the entire page breaking, without having to do a check at each usage of Storage.
	    var storage = getStorage();
	
	    return {
	      set: function set(key, value) {
	        storage.setItem('ngIdle.' + key, angular.toJson(value));
	      },
	      get: function get(key) {
	        return angular.fromJson(storage.getItem('ngIdle.' + key));
	      },
	      remove: function remove(key) {
	        storage.removeItem('ngIdle.' + key);
	      },
	      _wrapped: function _wrapped() {
	        return storage;
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.18.1 - 2016-07-10T00:18:10.535Z
	 * License: MIT
	 */
	
	"use strict";
	
	(function () {
	  "use strict";
	  var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91: "COMMAND", 8: "BACKSPACE", 9: "TAB", 13: "ENTER", 16: "SHIFT", 17: "CTRL", 18: "ALT", 19: "PAUSEBREAK", 20: "CAPSLOCK", 27: "ESC", 32: "SPACE", 33: "PAGE_UP", 34: "PAGE_DOWN", 35: "END", 36: "HOME", 37: "LEFT", 38: "UP", 39: "RIGHT", 40: "DOWN", 43: "+", 44: "PRINTSCREEN", 45: "INSERT", 46: "DELETE", 48: "0", 49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 59: ";", 61: "=", 65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M", 78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NUMLOCK", 145: "SCROLLLOCK", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'"
	    },
	
	    isControl: function isControl(e) {
	      var k = e.which;
	      switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	          return true;
	      }
	
	      if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	      return false;
	    },
	    isFunctionKey: function isFunctionKey(k) {
	      k = k.which ? k.which : k;
	      return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function isVerticalMovement(k) {
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function isHorizontalMovement(k) {
	      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function toSeparator(k) {
	      var sep = ({ ENTER: "\n", TAB: "\t", SPACE: " " })[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	  /**
	   * Add querySelectorAll() to jqLite.
	   *
	   * jqLite find() is limited to lookups by tag name.
	   * TODO This will change with future versions of AngularJS, to be removed when this happens
	   *
	   * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	   * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	   */
	  if (angular.element.prototype.querySelectorAll === undefined) {
	    angular.element.prototype.querySelectorAll = function (selector) {
	      return angular.element(this[0].querySelectorAll(selector));
	    };
	  }
	
	  /**
	   * Add closest() to jqLite.
	   */
	  if (angular.element.prototype.closest === undefined) {
	    angular.element.prototype.closest = function (selector) {
	      var elem = this[0];
	      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	      while (elem) {
	        if (matchesSelector.bind(elem)(selector)) {
	          return elem;
	        } else {
	          elem = elem.parentElement;
	        }
	      }
	      return false;
	    };
	  }
	
	  var latestId = 0;
	
	  var uis = angular.module('ui.select', []).constant('uiSelectConfig', {
	    theme: 'bootstrap',
	    searchEnabled: true,
	    sortable: false,
	    placeholder: '', // Empty by default, like HTML tag <select>
	    refreshDelay: 1000, // In milliseconds
	    closeOnSelect: true,
	    skipFocusser: false,
	    dropdownPosition: 'auto',
	    removeSelected: true,
	    generateId: function generateId() {
	      return latestId++;
	    },
	    appendToBody: false,
	    virtualRepeat: false
	  })
	
	  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	  .service('uiSelectMinErr', function () {
	    var minErr = angular.$$minErr('ui.select');
	    return function () {
	      var error = minErr.apply(this, arguments);
	      var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	      return new Error(message);
	    };
	  })
	
	  // Recreates old behavior of ng-transclude. Used internally.
	  .directive('uisTranscludeAppend', function () {
	    return {
	      link: function link(scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	  })
	
	  /**
	   * Highlights text that matches $select.search.
	   *
	   * Taken from AngularUI Bootstrap Typeahead
	   * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	   */
	  .filter('highlight', function () {
	    function escapeRegexp(queryToEscape) {
	      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function (matchItem, query) {
	      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	    };
	  })
	
	  /**
	   * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	   *
	   * Taken from AngularUI Bootstrap Position:
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	   */
	  .factory('uisOffset', ['$document', '$window', function ($document, $window) {
	
	    return function (element) {
	      var boundingClientRect = element[0].getBoundingClientRect();
	      return {
	        width: boundingClientRect.width || element.prop('offsetWidth'),
	        height: boundingClientRect.height || element.prop('offsetHeight'),
	        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	      };
	    };
	  }]);
	
	  /**
	   * Debounces functions
	   *
	   * Taken from UI Bootstrap $$debounce source code
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	   *
	   */
	  uis.factory('$$uisDebounce', ['$timeout', function ($timeout) {
	    return function (callback, debounceTime) {
	      var timeoutPromise;
	
	      return function () {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function () {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	  uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window', function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-choices');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/choices.tpl.html';
	      },
	
	      compile: function compile(tElement, tAttrs) {
	
	        if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	        // var repeat = RepeatParser.parse(attrs.repeat);
	        var groupByExp = tAttrs.groupBy;
	        var groupFilterExp = tAttrs.groupFilter;
	
	        if (groupByExp) {
	          var groups = tElement.querySelectorAll('.ui-select-choices-group');
	          if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	          groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	        }
	
	        var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	        var choices = tElement.querySelectorAll('.ui-select-choices-row');
	        if (choices.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	        }
	
	        choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp));
	
	        if (tElement.parent().attr('virtual-repeat')) {
	          choices.wrap('<div vs-repeat="{scrollParent:\'.ui-select-choices-content\',autoresize:true}"></div>');
	        }
	
	        //.attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	        var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	        if (rowsInner.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	        }
	        rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after
	        // choices
	        // element has
	        // ngRepeat
	
	        // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	        var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	        clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	        return function link(scope, element, attrs, $select) {
	
	          $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp);
	          $select.footerText = attrs.footerText;
	          $select.showGroupHeaders = !attrs.disableGroupHeaders;
	          $select.disableChoiceExpression = attrs.uiDisableChoice;
	          $select.onHighlightCallback = attrs.onHighlight;
	
	          $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	          // attrs.$observe('showFooterText', function(showFooterText) {
	          //   $select.showFooterText = scope.$eval(showFooterText);
	          // });
	
	          scope.$on('$destroy', function () {
	            //choices.remove();
	          });
	
	          scope.$watch('$select.search', function (newValue) {
	            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
	            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	              $select.refresh(attrs.refresh);
	            } else {
	              $select.items = [];
	            }
	          });
	
	          attrs.$observe('refreshDelay', function () {
	            // $eval() is needed otherwise we get a string instead of a number
	            var refreshDelay = scope.$eval(attrs.refreshDelay);
	            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	          });
	        };
	      }
	    };
	  }]);
	
	  /**
	   * Contains ui-select "intelligence".
	   *
	   * The goal is to limit dependency on the DOM whenever possible and
	   * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	   */
	  uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window', function ($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	    var ctrl = this;
	
	    var EMPTY_SEARCH = '';
	
	    ctrl.virtualRepeat = uiSelectConfig.virtualRepeat;
	    ctrl.placeholder = uiSelectConfig.placeholder;
	    ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	    ctrl.sortable = uiSelectConfig.sortable;
	    ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	    ctrl.paste = uiSelectConfig.paste;
	
	    ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	    ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	    ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	    ctrl.search = EMPTY_SEARCH;
	
	    ctrl.activeIndex = 0; //Dropdown of choices
	    ctrl.items = []; //All available choices
	
	    ctrl.open = false;
	    ctrl.focus = false;
	    ctrl.disabled = false;
	    ctrl.selected = undefined;
	
	    ctrl.dropdownPosition = 'auto';
	
	    ctrl.focusser = undefined; //Reference to input element used to handle focus events
	    ctrl.resetSearchInput = true;
	    ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	    ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	    ctrl.tagging = { isActivated: false, fct: undefined };
	    ctrl.taggingTokens = { isActivated: false, tokens: undefined };
	    ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	    ctrl.clickTriggeredSelect = false;
	    ctrl.$filter = $filter;
	    ctrl.$element = $element;
	
	    // Use $injector to check for $animate and store a reference to it
	    ctrl.$animate = (function () {
	      try {
	        return $injector.get('$animate');
	      } catch (err) {
	        // $animate does not exist
	        return null;
	      }
	    })();
	
	    ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	    if (ctrl.searchInput.length !== 1) {
	      throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	    }
	
	    ctrl.isEmpty = function () {
	      return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === '' || ctrl.multiple && ctrl.selected.length === 0;
	    };
	
	    function _findIndex(collection, predicate, thisArg) {
	      if (collection.findIndex) {
	        return collection.findIndex(predicate, thisArg);
	      } else {
	        var list = Object(collection);
	        var length = list.length >>> 0;
	        var value;
	
	        for (var i = 0; i < length; i++) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	        return -1;
	      }
	    }
	
	    // Most of the time the user does not want to empty the search input when in typeahead mode
	    function _resetSearchInput() {
	      if (ctrl.resetSearchInput || ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput) {
	        ctrl.search = EMPTY_SEARCH;
	        //reset activeIndex
	        if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	          ctrl.activeIndex = _findIndex(ctrl.items, function (item) {
	            return angular.equals(this, item);
	          }, ctrl.selected);
	        }
	      }
	    }
	
	    function _groupsFilter(groups, groupNames) {
	      var i,
	          j,
	          result = [];
	      for (i = 0; i < groupNames.length; i++) {
	        for (j = 0; j < groups.length; j++) {
	          if (groups[j].name == [groupNames[i]]) {
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	    // When the user clicks on ui-select, displays the dropdown list
	    ctrl.activate = function (initSearchValue, avoidReset) {
	      if (!ctrl.disabled && !ctrl.open) {
	        if (!avoidReset) _resetSearchInput();
	
	        $scope.$broadcast('uis:activate');
	
	        ctrl.open = true;
	
	        ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	
	        // ensure that the index is set to zero for tagging variants
	        // that where first option is auto-selected
	        if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
	          ctrl.activeIndex = 0;
	        }
	
	        var container = $element.querySelectorAll('.ui-select-choices-content');
	        var searchInput = $element.querySelectorAll('.ui-select-search');
	        if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	          var animateHandler = function animateHandler(elem, phase) {
	            if (phase === 'start' && ctrl.items.length === 0) {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            } else if (phase === 'close') {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('enter', container[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            }
	          };
	
	          if (ctrl.items.length > 0) {
	            ctrl.$animate.on('enter', container[0], animateHandler);
	          } else {
	            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	          }
	        } else {
	          $timeout(function () {
	            ctrl.focusSearchInput(initSearchValue);
	            if (ctrl.items.length > 1) {
	              _ensureHighlightVisible();
	            }
	          });
	        }
	      }
	    };
	
	    ctrl.focusSearchInput = function (initSearchValue) {
	      ctrl.search = initSearchValue || ctrl.search;
	      ctrl.searchInput[0].focus();
	    };
	
	    ctrl.findGroupByName = function (name) {
	      return ctrl.groups && ctrl.groups.filter(function (group) {
	        return group.name === name;
	      })[0];
	    };
	
	    ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
	      function updateGroups(items) {
	        var groupFn = $scope.$eval(groupByExp);
	        ctrl.groups = [];
	        angular.forEach(items, function (item) {
	          var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	          var group = ctrl.findGroupByName(groupName);
	          if (group) {
	            group.items.push(item);
	          } else {
	            ctrl.groups.push({ name: groupName, items: [item] });
	          }
	        });
	        if (groupFilterExp) {
	          var groupFilterFn = $scope.$eval(groupFilterExp);
	          if (angular.isFunction(groupFilterFn)) {
	            ctrl.groups = groupFilterFn(ctrl.groups);
	          } else if (angular.isArray(groupFilterFn)) {
	            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	          }
	        }
	        ctrl.items = [];
	        ctrl.groups.forEach(function (group) {
	          ctrl.items = ctrl.items.concat(group.items);
	        });
	      }
	
	      function setPlainItems(items) {
	        ctrl.items = items;
	      }
	
	      ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	      ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	      ctrl.isGrouped = !!groupByExp;
	      ctrl.itemProperty = ctrl.parserResult.itemName;
	
	      //If collection is an Object, convert it to Array
	
	      var originalSource = ctrl.parserResult.source;
	
	      //When an object is used as source, we better create an array and use it as 'source'
	      var createArrayFromObject = function createArrayFromObject() {
	        var origSrc = originalSource($scope);
	        $scope.$uisSource = Object.keys(origSrc).map(function (v) {
	          var result = {};
	          result[ctrl.parserResult.keyName] = v;
	          result.value = origSrc[v];
	          return result;
	        });
	      };
	
	      if (ctrl.parserResult.keyName) {
	        // Check for (key,value) syntax
	        createArrayFromObject();
	        ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	        $scope.$watch(originalSource, function (newVal, oldVal) {
	          if (newVal !== oldVal) createArrayFromObject();
	        }, true);
	      }
	
	      ctrl.refreshItems = function (data) {
	        data = data || ctrl.parserResult.source($scope);
	        var selectedItems = ctrl.selected;
	        //TODO should implement for single mode removeSelected
	        if (ctrl.isEmpty() || angular.isArray(selectedItems) && !selectedItems.length || !ctrl.multiple || !ctrl.removeSelected) {
	          ctrl.setItemsFn(data);
	        } else {
	          if (data !== undefined && data !== null) {
	            var filteredItems = data.filter(function (i) {
	              return angular.isArray(selectedItems) ? selectedItems.every(function (selectedItem) {
	                return !angular.equals(i, selectedItem);
	              }) : !angular.equals(i, selectedItems);
	            });
	            ctrl.setItemsFn(filteredItems);
	          }
	        }
	        if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
	          $scope.calculateDropdownPos();
	        }
	
	        $scope.$broadcast('uis:refresh');
	      };
	
	      // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	      $scope.$watchCollection(ctrl.parserResult.source, function (items) {
	        if (items === undefined || items === null) {
	          // If the user specifies undefined or null => reset the collection
	          // Special case: items can be undefined if the user did not initialized the collection on the scope
	          // i.e $scope.addresses = [] is missing
	          ctrl.items = [];
	        } else {
	          if (!angular.isArray(items)) {
	            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	          } else {
	            //Remove already selected items (ex: while searching)
	            //TODO Should add a test
	            ctrl.refreshItems(items);
	
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
	              ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	          }
	        }
	      });
	    };
	
	    var _refreshDelayPromise;
	
	    /**
	     * Typeahead mode: lets the user refresh the collection using his own function.
	     *
	     * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	     */
	    ctrl.refresh = function (refreshAttr) {
	      if (refreshAttr !== undefined) {
	
	        // Debounce
	        // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	        // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	        if (_refreshDelayPromise) {
	          $timeout.cancel(_refreshDelayPromise);
	        }
	        _refreshDelayPromise = $timeout(function () {
	          $scope.$eval(refreshAttr);
	        }, ctrl.refreshDelay);
	      }
	    };
	
	    ctrl.isActive = function (itemScope) {
	      if (!ctrl.open) {
	        return false;
	      }
	      var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	      var isActive = itemIndex == ctrl.activeIndex;
	
	      if (!isActive || itemIndex < 0) {
	        return false;
	      }
	
	      if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	        itemScope.$eval(ctrl.onHighlightCallback);
	      }
	
	      return isActive;
	    };
	
	    var _isItemSelected = function _isItemSelected(item) {
	      return ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
	        return angular.equals(selection, item);
	      }).length > 0;
	    };
	
	    var disabledItems = [];
	
	    function _updateItemDisabled(item, isDisabled) {
	      var disabledItemIndex = disabledItems.indexOf(item);
	      if (isDisabled && disabledItemIndex === -1) {
	        disabledItems.push(item);
	      }
	
	      if (!isDisabled && disabledItemIndex > -1) {
	        disabledItems.splice(disabledItemIndex, 0);
	      }
	    }
	
	    function _isItemDisabled(item) {
	      return disabledItems.indexOf(item) > -1;
	    }
	
	    ctrl.isDisabled = function (itemScope) {
	
	      if (!ctrl.open) return;
	
	      var item = itemScope[ctrl.itemProperty];
	      var itemIndex = ctrl.items.indexOf(item);
	      var isDisabled = false;
	
	      if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	        if (item.isTag) return false;
	
	        if (ctrl.multiple) {
	          isDisabled = _isItemSelected(item);
	        }
	
	        if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	          isDisabled = !!itemScope.$eval(ctrl.disableChoiceExpression);
	        }
	
	        _updateItemDisabled(item, isDisabled);
	      }
	
	      return isDisabled;
	    };
	
	    // When the user selects an item with ENTER or clicks the dropdown
	    ctrl.select = function (item, skipFocusser, $event) {
	      if (item === undefined || !_isItemDisabled(item)) {
	
	        if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
	
	        if (!item || !_isItemDisabled(item)) {
	          if (ctrl.tagging.isActivated) {
	            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	            if (ctrl.taggingLabel === false) {
	              if (ctrl.activeIndex < 0) {
	                if (item === undefined) {
	                  item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	                }
	                if (!item || angular.equals(ctrl.items[0], item)) {
	                  return;
	                }
	              } else {
	                // keyboard nav happened first, user selected from dropdown
	                item = ctrl.items[ctrl.activeIndex];
	              }
	            } else {
	              // tagging always operates at index zero, taggingLabel === false pushes
	              // the ctrl.search value without having it injected
	              if (ctrl.activeIndex === 0) {
	                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	                // for `item` if it is a detected duplicate
	                if (item === undefined) return;
	
	                // create new item on the fly if we don't already have one;
	                // use tagging function if we have one
	                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
	                  item = ctrl.tagging.fct(item);
	                  if (!item) return;
	                  // if item type is 'string', apply the tagging label
	                } else if (typeof item === 'string') {
	                    // trim the trailing space
	                    item = item.replace(ctrl.taggingLabel, '').trim();
	                  }
	              }
	            }
	            // search ctrl.selected for dupes potentially caused by tagging and return early if found
	            if (_isItemSelected(item)) {
	              ctrl.close(skipFocusser);
	              return;
	            }
	          }
	
	          $scope.$broadcast('uis:select', item);
	
	          var locals = {};
	          locals[ctrl.parserResult.itemName] = item;
	
	          $timeout(function () {
	            ctrl.onSelectCallback($scope, {
	              $item: item,
	              $model: ctrl.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          if (ctrl.closeOnSelect) {
	            ctrl.close(skipFocusser);
	          }
	          if ($event && $event.type === 'click') {
	            ctrl.clickTriggeredSelect = true;
	          }
	        }
	      }
	    };
	
	    // Closes the dropdown
	    ctrl.close = function (skipFocusser) {
	      if (!ctrl.open) return;
	      if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	      _resetSearchInput();
	      ctrl.open = false;
	
	      $scope.$broadcast('uis:close', skipFocusser);
	    };
	
	    ctrl.setFocus = function () {
	      if (!ctrl.focus) ctrl.focusInput[0].focus();
	    };
	
	    ctrl.clear = function ($event) {
	      ctrl.select(undefined);
	      $event.stopPropagation();
	      $timeout(function () {
	        ctrl.focusser[0].focus();
	      }, 0, false);
	    };
	
	    // Toggle dropdown
	    ctrl.toggle = function (e) {
	      if (ctrl.open) {
	        ctrl.close();
	        e.preventDefault();
	        e.stopPropagation();
	      } else {
	        ctrl.activate();
	      }
	    };
	
	    // Set default function for locked choices - avoids unnecessary
	    // logic if functionality is not being used
	    ctrl.isLocked = function () {
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	    }, _initaliseLockedChoices);
	
	    function _initaliseLockedChoices(doInitalise) {
	      if (!doInitalise) return;
	
	      var lockedItems = [];
	
	      function _updateItemLocked(item, isLocked) {
	        var lockedItemIndex = lockedItems.indexOf(item);
	        if (isLocked && lockedItemIndex === -1) {
	          lockedItems.push(item);
	        }
	
	        if (!isLocked && lockedItemIndex > -1) {
	          lockedItems.splice(lockedItemIndex, 0);
	        }
	      }
	
	      function _isItemlocked(item) {
	        return lockedItems.indexOf(item) > -1;
	      }
	
	      ctrl.isLocked = function (itemScope, itemIndex) {
	        var isLocked = false,
	            item = ctrl.selected[itemIndex];
	
	        if (item) {
	          if (itemScope) {
	            isLocked = !!itemScope.$eval(ctrl.lockChoiceExpression);
	            _updateItemLocked(item, isLocked);
	          } else {
	            isLocked = _isItemlocked(item);
	          }
	        }
	
	        return isLocked;
	      };
	    }
	
	    var sizeWatch = null;
	    var updaterScheduled = false;
	    ctrl.sizeSearchInput = function () {
	
	      var input = ctrl.searchInput[0],
	          container = ctrl.searchInput.parent().parent()[0],
	          calculateContainerWidth = function calculateContainerWidth() {
	        if (!container) return;
	        // Return the container width only if the search input is visible
	        return container.clientWidth * !!input.offsetParent;
	      },
	          updateIfVisible = function updateIfVisible(containerWidth) {
	        if (containerWidth === 0) {
	          return false;
	        }
	        var inputWidth = containerWidth - input.offsetLeft - 10;
	        if (inputWidth < 50) inputWidth = containerWidth;
	        ctrl.searchInput.css('width', inputWidth - 5 + 'px');
	        return true;
	      };
	
	      ctrl.searchInput.css('width', '10px');
	      $timeout(function () {
	        //Give tags time to render correctly
	        if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	          sizeWatch = $scope.$watch(function () {
	            if (!updaterScheduled) {
	              updaterScheduled = true;
	              $scope.$$postDigest(function () {
	                updaterScheduled = false;
	                if (updateIfVisible(calculateContainerWidth())) {
	                  sizeWatch();
	                  sizeWatch = null;
	                }
	              });
	            }
	          }, angular.noop);
	        }
	      });
	    };
	
	    function _handleDropDownSelection(key) {
	      var processed = true;
	      switch (key) {
	        case KEY.DOWN:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex < ctrl.items.length - 1) {
	              ctrl.activeIndex++;
	            }
	          break;
	        case KEY.UP:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex > 0 || ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1) {
	              ctrl.activeIndex--;
	            }
	          break;
	        case KEY.TAB:
	          if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	          break;
	        case KEY.ENTER:
	          if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
	            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	          } else {
	              ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	            }
	          break;
	        case KEY.ESC:
	          ctrl.close();
	          break;
	        default:
	          processed = false;
	      }
	      return processed;
	    }
	
	    function isDisabled(item) {
	      return !eval(ctrl.disableChoiceExpression);
	    }
	
	    // Bind to keyboard shortcuts
	    ctrl.searchInput.on('keydown', function (e) {
	
	      var key = e.which;
	
	      if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      // if(~[KEY.ESC,KEY.TAB].indexOf(key)){
	      //   //TODO: SEGURO?
	      //   ctrl.close();
	      // }
	
	      $scope.$apply(function () {
	
	        var tagged = false;
	
	        if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	          _handleDropDownSelection(key);
	          if (ctrl.taggingTokens.isActivated) {
	            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	              if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
	                // make sure there is a new value to push via tagging
	                if (ctrl.search.length > 0) {
	                  tagged = true;
	                }
	              }
	            }
	            if (tagged) {
	              $timeout(function () {
	                ctrl.searchInput.triggerHandler('tagged');
	                var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
	                if (ctrl.tagging.fct) {
	                  newItem = ctrl.tagging.fct(newItem);
	                }
	                if (newItem) ctrl.select(newItem, true);
	              });
	            }
	          }
	        }
	      });
	
	      if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
	        _ensureHighlightVisible();
	      }
	
	      if (key === KEY.ENTER || key === KEY.ESC) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    });
	
	    ctrl.searchInput.on('paste', function (e) {
	      var data;
	
	      if (window.clipboardData && window.clipboardData.getData) {
	        // IE
	        data = window.clipboardData.getData('Text');
	      } else {
	        data = (e.originalEvent || e).clipboardData.getData('text/plain');
	      }
	
	      // Prepend the current input field text to the paste buffer.
	      data = ctrl.search + data;
	
	      if (data && data.length > 0) {
	        // If tagging try to split by tokens and add items
	        if (ctrl.taggingTokens.isActivated) {
	          var items = [];
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            // split by first token that is contained in data
	            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	            if (data.indexOf(separator) > -1) {
	              items = data.split(separator);
	              break; // only split by one token
	            }
	          }
	          if (items.length === 0) {
	            items = [data];
	          }
	          var oldsearch = ctrl.search;
	          angular.forEach(items, function (item) {
	            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	            if (newItem) {
	              ctrl.select(newItem, true);
	            }
	          });
	          ctrl.search = oldsearch || EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (ctrl.paste) {
	          ctrl.paste(data);
	          ctrl.search = EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      }
	    });
	
	    ctrl.searchInput.on('tagged', function () {
	      $timeout(function () {
	        _resetSearchInput();
	      });
	    });
	
	    // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	    function _ensureHighlightVisible() {
	      if (ctrl.virtualRepeat) {
	        $scope.$emit('uis:highlightedUpdate', ctrl.activeIndex);
	        return;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var choices = container.querySelectorAll('.ui-select-choices-row');
	      if (choices.length < 1) {
	        throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      if (ctrl.activeIndex < 0) {
	        return;
	      }
	
	      var highlighted = choices[ctrl.activeIndex];
	      var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	      var height = container[0].offsetHeight;
	
	      if (posY > height) {
	        container[0].scrollTop += posY - height;
	      } else if (posY < highlighted.clientHeight) {
	        if (ctrl.isGrouped && ctrl.activeIndex === 0) container[0].scrollTop = 0; //To make group header visible when going all the way up
	        else container[0].scrollTop -= highlighted.clientHeight - posY;
	      }
	    }
	
	    var onResize = $$uisDebounce(function () {
	      ctrl.sizeSearchInput();
	    }, 50);
	
	    angular.element($window).bind('resize', onResize);
	
	    $scope.$on('$destroy', function () {
	      ctrl.searchInput.off('keyup keydown tagged blur paste');
	      angular.element($window).off('resize', onResize);
	    });
	  }]);
	
	  uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout', function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	    return {
	      restrict: 'EA',
	      templateUrl: function templateUrl(tElement, tAttrs) {
	        var theme = tAttrs.theme || uiSelectConfig.theme;
	        return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	      },
	      replace: true,
	      transclude: true,
	      require: ['uiSelect', '^ngModel'],
	      scope: true,
	
	      controller: 'uiSelectCtrl',
	      controllerAs: '$select',
	      compile: function compile(tElement, tAttrs) {
	
	        // Allow setting ngClass on uiSelect
	        var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	        if (match) {
	          var combined = '{' + match[1] + ', ' + match[2] + '}';
	          tAttrs.ngClass = combined;
	          tElement.attr('ng-class', combined);
	        }
	
	        //Multiple or Single depending if multiple attribute presence
	        if (angular.isDefined(tAttrs.multiple)) tElement.append('<ui-select-multiple/>').removeAttr('multiple');else tElement.append('<ui-select-single/>');
	
	        if (tAttrs.inputId) tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	        return function (scope, element, attrs, ctrls, transcludeFn) {
	
	          var $select = ctrls[0];
	          var ngModel = ctrls[1];
	
	          $select.generatedId = uiSelectConfig.generateId();
	          $select.baseTitle = attrs.title || 'Select box';
	          $select.focusserTitle = $select.baseTitle + ' focus';
	          $select.focusserId = 'focusser-' + $select.generatedId;
	
	          $select.closeOnSelect = (function () {
	            if (angular.isDefined(attrs.closeOnSelect)) {
	              return $parse(attrs.closeOnSelect)();
	            } else {
	              return uiSelectConfig.closeOnSelect;
	            }
	          })();
	
	          scope.$watch('skipFocusser', function () {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	          });
	
	          $select.onSelectCallback = $parse(attrs.onSelect);
	          $select.onRemoveCallback = $parse(attrs.onRemove);
	
	          //Set reference to ngModel from uiSelectCtrl
	          $select.ngModel = ngModel;
	
	          $select.choiceGrouped = function (group) {
	            return $select.isGrouped && group && group.name;
	          };
	
	          if (attrs.tabindex) {
	            attrs.$observe('tabindex', function (value) {
	              $select.focusInput.attr('tabindex', value);
	              element.removeAttr('tabindex');
	            });
	          }
	
	          scope.$watch(function () {
	            return scope.$eval(attrs.virtualRepeat);
	          }, function (newVal) {
	            $select.virtualRepeat = newVal !== undefined ? newVal : uiSelectConfig.virtualRepeat;
	          });
	
	          scope.$watch(function () {
	            return scope.$eval(attrs.searchEnabled);
	          }, function (newVal) {
	            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	          });
	
	          scope.$watch('sortable', function () {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	          });
	
	          attrs.$observe('limit', function () {
	            //Limit the number of selections allowed
	            $select.limit = angular.isDefined(attrs.limit) ? parseInt(attrs.limit, 10) : undefined;
	          });
	
	          scope.$watch('removeSelected', function () {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	          });
	
	          attrs.$observe('disabled', function () {
	            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	          });
	
	          attrs.$observe('resetSearchInput', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	          });
	
	          attrs.$observe('paste', function () {
	            $select.paste = scope.$eval(attrs.paste);
	          });
	
	          attrs.$observe('tagging', function () {
	            if (attrs.tagging !== undefined) {
	              // $eval() is needed otherwise we get a string instead of a boolean
	              var taggingEval = scope.$eval(attrs.tagging);
	              $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
	            } else {
	              $select.tagging = { isActivated: false, fct: undefined };
	            }
	          });
	
	          attrs.$observe('taggingLabel', function () {
	            if (attrs.tagging !== undefined) {
	              // check eval for FALSE, in this case, we disable the labels
	              // associated with tagging
	              if (attrs.taggingLabel === 'false') {
	                $select.taggingLabel = false;
	              } else {
	                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	              }
	            }
	          });
	
	          attrs.$observe('taggingTokens', function () {
	            if (attrs.tagging !== undefined) {
	              var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
	              $select.taggingTokens = { isActivated: true, tokens: tokens };
	            }
	          });
	
	          //Automatically gets focus when loaded
	          if (angular.isDefined(attrs.autofocus)) {
	            $timeout(function () {
	              $select.setFocus();
	            });
	          }
	
	          //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	          if (angular.isDefined(attrs.focusOn)) {
	            scope.$on(attrs.focusOn, function () {
	              $timeout(function () {
	                $select.setFocus();
	              });
	            });
	          }
	
	          function onDocumentClick(e) {
	            if (!$select.open) return; //Skip it if dropdown is close
	
	            var contains = false;
	
	            if (window.jQuery) {
	              // Firefox 3.6 does not support element.contains()
	              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	              contains = window.jQuery.contains(element[0], e.target);
	            } else {
	              contains = element[0].contains(e.target);
	            }
	
	            if (!contains && !$select.clickTriggeredSelect) {
	              var skipFocusser;
	              if (!$select.skipFocusser) {
	                //Will lose focus only with certain targets
	                var focusableControls = ['input', 'button', 'textarea', 'select'];
	                var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	                skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	                if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	              } else {
	                  skipFocusser = true;
	                }
	              $select.close(skipFocusser);
	              scope.$digest();
	            }
	            $select.clickTriggeredSelect = false;
	          }
	
	          // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	          $document.on('click', onDocumentClick);
	
	          scope.$on('$destroy', function () {
	            $document.off('click', onDocumentClick);
	          });
	
	          // Move transcluded elements to their correct position in main template
	          transcludeFn(scope, function (clone) {
	            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	            // One day jqLite will be replaced by jQuery and we will be able to write:
	            // var transcludedElement = clone.filter('.my-class')
	            // instead of creating a hackish DOM element:
	            var transcluded = angular.element('<div>').append(clone);
	
	            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	            if (transcludedMatch.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	            }
	            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	            if (transcludedChoices.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	            }
	            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	            if (transcludedNoChoice.length == 1) {
	              element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	            }
	          });
	
	          // Support for appending the select field to the body when its open
	          var appendToBody = scope.$eval(attrs.appendToBody);
	          if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	            scope.$watch('$select.open', function (isOpen) {
	              if (isOpen) {
	                positionDropdown();
	              } else {
	                resetDropdown();
	              }
	            });
	
	            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	            // it might stick around when the user routes away or the select field is otherwise removed
	            scope.$on('$destroy', function () {
	              resetDropdown();
	            });
	          }
	
	          // Hold on to a reference to the .ui-select-container element for appendToBody support
	          var placeholder = null,
	              originalWidth = '';
	
	          function positionDropdown() {
	            // Remember the absolute position of the element
	            var offset = uisOffset(element);
	
	            // Clone the element into a placeholder element to take its original place in the DOM
	            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	            placeholder[0].style.width = offset.width + 'px';
	            placeholder[0].style.height = offset.height + 'px';
	            element.after(placeholder);
	
	            // Remember the original value of the element width inline style, so it can be restored
	            // when the dropdown is closed
	            originalWidth = element[0].style.width;
	
	            // Now move the actual dropdown element to the end of the body
	            $document.find('body').append(element);
	
	            element[0].style.position = 'absolute';
	            element[0].style.left = offset.left + 'px';
	            element[0].style.top = offset.top + 'px';
	            element[0].style.width = offset.width + 'px';
	          }
	
	          function resetDropdown() {
	            if (placeholder === null) {
	              // The dropdown has not actually been display yet, so there's nothing to reset
	              return;
	            }
	
	            // Move the dropdown element back to its original location in the DOM
	            placeholder.replaceWith(element);
	            placeholder = null;
	
	            element[0].style.position = '';
	            element[0].style.left = '';
	            element[0].style.top = '';
	            element[0].style.width = originalWidth;
	
	            // Set focus back on to the moved element
	            $select.setFocus();
	          }
	
	          // Hold on to a reference to the .ui-select-dropdown element for direction support.
	          var dropdown = null,
	              directionUpClassName = 'direction-up';
	
	          // Support changing the direction of the dropdown if there isn't enough space to render it.
	          scope.$watch('$select.open', function () {
	
	            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
	              scope.calculateDropdownPos();
	            }
	          });
	
	          var setDropdownPosUp = function setDropdownPosUp(offset, offsetDropdown) {
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = 'absolute';
	            dropdown[0].style.top = offsetDropdown.height * -1 + 'px';
	            element.addClass(directionUpClassName);
	          };
	
	          var setDropdownPosDown = function setDropdownPosDown(offset, offsetDropdown) {
	
	            element.removeClass(directionUpClassName);
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	          };
	
	          var calculateDropdownPosAfterAnimation = function calculateDropdownPosAfterAnimation() {
	            // Delay positioning the dropdown until all choices have been added so its height is correct.
	            $timeout(function () {
	              if ($select.dropdownPosition === 'up') {
	                //Go UP
	                setDropdownPosUp();
	              } else {
	                //AUTO
	                element.removeClass(directionUpClassName);
	
	                var offset = uisOffset(element);
	                var offsetDropdown = uisOffset(dropdown);
	
	                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                // Determine if the direction of the dropdown needs to be changed.
	                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                  //Go UP
	                  setDropdownPosUp(offset, offsetDropdown);
	                } else {
	                  //Go DOWN
	                  setDropdownPosDown(offset, offsetDropdown);
	                }
	              }
	
	              // Display the dropdown once it has been positioned.
	              // Reset position
	              dropdown[0].style.position = 'absolute';
	              dropdown[0].style.opacity = 1;
	            });
	          };
	
	          scope.calculateDropdownPos = function () {
	
	            if ($select.open) {
	              dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	              if (dropdown.length === 0) {
	                return;
	              }
	
	              // Hide the dropdown so there is no flicker until $timeout is done executing.
	              // Take out of flow to prevent scrollbar flicker
	              dropdown[0].style.opacity = 0;
	              dropdown[0].style.position = 'fixed';
	
	              if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	                var needsCalculated = true;
	
	                $select.$animate.on('enter', dropdown, function (elem, phase) {
	                  if (phase === 'close' && needsCalculated) {
	                    calculateDropdownPosAfterAnimation();
	                    needsCalculated = false;
	                  }
	                });
	              } else {
	                calculateDropdownPosAfterAnimation();
	              }
	            } else {
	              if (dropdown === null || dropdown.length === 0) {
	                return;
	              }
	
	              // Reset the position of the dropdown.
	              dropdown[0].style.opacity = 0;
	              dropdown[0].style.position = '';
	              dropdown[0].style.top = '';
	              element.removeClass(directionUpClassName);
	            }
	          };
	        };
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectMatch', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-match');
	
	        var parent = tElement.parent();
	        // Gets theme attribute from parent (ui-select)
	        var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	        var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	        return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
	      },
	      link: function link(scope, element, attrs, $select) {
	        $select.lockChoiceExpression = attrs.uiLockChoice;
	
	        attrs.$observe('placeholder', function (placeholder) {
	          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	        });
	
	        function setAllowClear(allow) {
	          $select.allowClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : false;
	        }
	
	        attrs.$observe('allowClear', setAllowClear);
	        setAllowClear(attrs.allowClear);
	
	        function setAllowBackspaceClear(allow) {
	          $select.allowBackspaceClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : true;
	        }
	
	        attrs.$observe('allowBackspaceClear', setAllowBackspaceClear);
	        setAllowBackspaceClear(attrs.allowBackspaceClear);
	
	        if ($select.multiple) {
	          $select.sizeSearchInput();
	        }
	      }
	    };
	
	    function getAttribute(elem, attribute) {
	      if (elem[0].hasAttribute(attribute)) return elem.attr(attribute);
	
	      if (elem[0].hasAttribute('data-' + attribute)) return elem.attr('data-' + attribute);
	
	      if (elem[0].hasAttribute('x-' + attribute)) return elem.attr('x-' + attribute);
	    }
	  }]);
	
	  uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function (uiSelectMinErr, $timeout) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	
	      controller: ['$scope', '$timeout', function ($scope, $timeout) {
	
	        var ctrl = this,
	            $select = $scope.$select,
	            ngModel;
	
	        if (angular.isUndefined($select.selected)) $select.selected = [];
	
	        //Wait for link fn to inject it
	        $scope.$evalAsync(function () {
	          ngModel = $scope.ngModel;
	        });
	
	        ctrl.activeMatchIndex = -1;
	
	        ctrl.updateModel = function () {
	          ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	          ctrl.refreshComponent();
	        };
	
	        ctrl.refreshComponent = function () {
	          //Remove already selected items
	          //e.g. When user clicks on a selection, the selected array changes and
	          //the dropdown should remove that item
	          if ($select.refreshItems) {
	            $select.refreshItems();
	          }
	          if ($select.sizeSearchInput) {
	            $select.sizeSearchInput();
	          }
	        };
	
	        // Remove item from multiple select
	        ctrl.removeChoice = function (index) {
	
	          // if the choice is locked, don't remove it
	          if ($select.isLocked(null, index)) return false;
	
	          var removedChoice = $select.selected[index];
	
	          var locals = {};
	          locals[$select.parserResult.itemName] = removedChoice;
	
	          $select.selected.splice(index, 1);
	          ctrl.activeMatchIndex = -1;
	          $select.sizeSearchInput();
	
	          // Give some time for scope propagation.
	          $timeout(function () {
	            $select.onRemoveCallback($scope, {
	              $item: removedChoice,
	              $model: $select.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          ctrl.updateModel();
	
	          return true;
	        };
	
	        ctrl.getPlaceholder = function () {
	          //Refactor single?
	          if ($select.selected && $select.selected.length) return;
	          return $select.placeholder;
	        };
	      }],
	      controllerAs: '$selectMultiple',
	
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = scope.ngModel = ctrls[1];
	        var $selectMultiple = scope.$selectMultiple;
	
	        //$select.selected = raw selected objects (ignoring any property binding)
	
	        $select.multiple = true;
	
	        //Input that will handle focus
	        $select.focusInput = $select.searchInput;
	
	        //Properly check for empty if set to multiple
	        ngModel.$isEmpty = function (value) {
	          return !value || value.length === 0;
	        };
	
	        //From view --> model
	        ngModel.$parsers.unshift(function () {
	          var locals = {},
	              result,
	              resultMultiple = [];
	          for (var j = $select.selected.length - 1; j >= 0; j--) {
	            locals = {};
	            locals[$select.parserResult.itemName] = $select.selected[j];
	            result = $select.parserResult.modelMapper(scope, locals);
	            resultMultiple.unshift(result);
	          }
	          return resultMultiple;
	        });
	
	        // From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (!data) return inputValue;
	          var resultMultiple = [];
	          var checkFnMultiple = function checkFnMultiple(list, value) {
	            if (!list || !list.length) return;
	            for (var p = list.length - 1; p >= 0; p--) {
	              locals[$select.parserResult.itemName] = list[p];
	              result = $select.parserResult.modelMapper(scope, locals);
	              if ($select.parserResult.trackByExp) {
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
	                  if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
	                    resultMultiple.unshift(list[p]);
	                    return true;
	                  }
	                }
	              }
	              if (angular.equals(result, value)) {
	                resultMultiple.unshift(list[p]);
	                return true;
	              }
	            }
	            return false;
	          };
	          if (!inputValue) return resultMultiple; //If ngModel was undefined
	          for (var k = inputValue.length - 1; k >= 0; k--) {
	            //Check model array of currently selected items
	            if (!checkFnMultiple($select.selected, inputValue[k])) {
	              //Check model array of all items available
	              if (!checkFnMultiple(data, inputValue[k])) {
	                //If not found on previous lists, just add it directly to resultMultiple
	                resultMultiple.unshift(inputValue[k]);
	              }
	            }
	          }
	          return resultMultiple;
	        });
	
	        //Watch for external model changes
	        scope.$watchCollection(function () {
	          return ngModel.$modelValue;
	        }, function (newValue, oldValue) {
	          if (oldValue != newValue) {
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ngModel.$modelValue)) {
	              ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	            $selectMultiple.refreshComponent();
	          }
	        });
	
	        ngModel.$render = function () {
	          // Make sure that model value is array
	          if (!angular.isArray(ngModel.$viewValue)) {
	            // Have tolerance for null or undefined values
	            if (angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null) {
	              ngModel.$viewValue = [];
	            } else {
	              throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	            }
	          }
	          $select.selected = ngModel.$viewValue;
	          $selectMultiple.refreshComponent();
	          scope.$evalAsync(); //To force $digest
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          if ($select.selected.length >= $select.limit) {
	            return;
	          }
	          $select.selected.push(item);
	          $selectMultiple.updateModel();
	        });
	
	        scope.$on('uis:activate', function () {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	
	        scope.$watch('$select.disabled', function (newValue, oldValue) {
	          // As the search input field may now become visible, it may be necessary to recompute its size
	          if (oldValue && !newValue) $select.sizeSearchInput();
	        });
	
	        $select.searchInput.on('keydown', function (e) {
	          var key = e.which;
	          scope.$apply(function () {
	            var processed = false;
	            // var tagged = false; //Checkme
	            if (KEY.isHorizontalMovement(key)) {
	              processed = _handleMatchSelection(key);
	            }
	            if (processed && key != KEY.TAB) {
	              //TODO Check si el tab selecciona aun correctamente
	              //Crear test
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          });
	        });
	        function _getCaretPosition(el) {
	          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
	          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	          else return el.value.length;
	        }
	        // Handles selected options in "multiple" mode
	        function _handleMatchSelection(key) {
	          var caretPosition = _getCaretPosition($select.searchInput[0]),
	              length = $select.selected.length,
	
	          // none  = -1,
	          first = 0,
	              last = length - 1,
	              curr = $selectMultiple.activeMatchIndex,
	              next = $selectMultiple.activeMatchIndex + 1,
	              prev = $selectMultiple.activeMatchIndex - 1,
	              newIndex = curr;
	
	          if (caretPosition > 0 || $select.search.length && key == KEY.RIGHT) return false;
	
	          $select.close();
	
	          function getNewActiveMatchIndex() {
	            switch (key) {
	              case KEY.LEFT:
	                // Select previous/first item
	                if (~$selectMultiple.activeMatchIndex) return prev;
	                // Select last item
	                else return last;
	                break;
	              case KEY.RIGHT:
	                // Open drop-down
	                if (! ~$selectMultiple.activeMatchIndex || curr === last) {
	                  $select.activate();
	                  return false;
	                }
	                // Select next/last item
	                else return next;
	                break;
	              case KEY.BACKSPACE:
	                // Remove selected item and select previous/first
	                if (~$selectMultiple.activeMatchIndex) {
	                  if ($selectMultiple.removeChoice(curr)) {
	                    return prev;
	                  } else {
	                    return curr;
	                  }
	                } else {
	                  // If nothing yet selected, select last item
	                  return last;
	                }
	                break;
	              case KEY.DELETE:
	                // Remove selected item and select next item
	                if (~$selectMultiple.activeMatchIndex) {
	                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                  return curr;
	                } else return false;
	            }
	          }
	
	          newIndex = getNewActiveMatchIndex();
	
	          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
	
	          return true;
	        }
	
	        $select.searchInput.on('keyup', function (e) {
	
	          if (!KEY.isVerticalMovement(e.which)) {
	            scope.$evalAsync(function () {
	              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            });
	          }
	          // Push a "create new" item into array if there is a search string
	          if ($select.tagging.isActivated && $select.search.length > 0) {
	
	            // return early with these keys
	            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
	              return;
	            }
	            // always reset the activeIndex to the first item when tagging
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            // taggingLabel === false bypasses all of this
	            if ($select.taggingLabel === false) return;
	
	            var items = angular.copy($select.items);
	            var stashArr = angular.copy($select.items);
	            var newItem;
	            var item;
	            var hasTag = false;
	            var dupeIndex = -1;
	            var tagItems;
	            var tagItem;
	
	            // case for object tagging via transform `$select.tagging.fct` function
	            if ($select.tagging.fct !== undefined) {
	              tagItems = $select.$filter('filter')(items, { 'isTag': true });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	              if (items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.tagging.fct($select.search);
	              // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	              if (stashArr.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              }) || $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })) {
	                scope.$evalAsync(function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	                return;
	              }
	              if (newItem) newItem.isTag = true;
	              // handle newItem string and stripping dupes in tagging string context
	            } else {
	                // find any tagging items already in the $select.items array and store them
	                tagItems = $select.$filter('filter')(items, function (item) {
	                  return item.match($select.taggingLabel);
	                });
	                if (tagItems.length > 0) {
	                  tagItem = tagItems[0];
	                }
	                item = items[0];
	                // remove existing tag item if found (should only ever be one tag item)
	                if (item !== undefined && items.length > 0 && tagItem) {
	                  hasTag = true;
	                  items = items.slice(1, items.length);
	                  stashArr = stashArr.slice(1, stashArr.length);
	                }
	                newItem = $select.search + ' ' + $select.taggingLabel;
	                if (_findApproxDupe($select.selected, $select.search) > -1) {
	                  return;
	                }
	                // verify the the tag doesn't match the value of an existing item from
	                // the searched data set or the items already selected
	                if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
	                  // if there is a tag from prev iteration, strip it / queue the change
	                  // and return early
	                  if (hasTag) {
	                    items = stashArr;
	                    scope.$evalAsync(function () {
	                      $select.activeIndex = 0;
	                      $select.items = items;
	                    });
	                  }
	                  return;
	                }
	                if (_findCaseInsensitiveDupe(stashArr)) {
	                  // if there is a tag from prev iteration, strip it
	                  if (hasTag) {
	                    $select.items = stashArr.slice(1, stashArr.length);
	                  }
	                  return;
	                }
	              }
	            if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
	            // dupe found, shave the first item
	            if (dupeIndex > -1) {
	              items = items.slice(dupeIndex + 1, items.length - 1);
	            } else {
	              items = [];
	              if (newItem) items.push(newItem);
	              items = items.concat(stashArr);
	            }
	            scope.$evalAsync(function () {
	              $select.activeIndex = 0;
	              $select.items = items;
	
	              if ($select.isGrouped) {
	                // update item references in groups, so that indexOf will work after angular.copy
	                var itemsWithoutTag = newItem ? items.slice(1) : items;
	                $select.setItemsFn(itemsWithoutTag);
	                if (newItem) {
	                  // add tag item as a new group
	                  $select.items.unshift(newItem);
	                  $select.groups.unshift({ name: '', items: [newItem], tagging: true });
	                }
	              }
	            });
	          }
	        });
	        function _findCaseInsensitiveDupe(arr) {
	          if (arr === undefined || $select.search === undefined) {
	            return false;
	          }
	          var hasDupe = arr.filter(function (origItem) {
	            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
	              return false;
	            }
	            return origItem.toUpperCase() === $select.search.toUpperCase();
	          }).length > 0;
	
	          return hasDupe;
	        }
	        function _findApproxDupe(haystack, needle) {
	          var dupeIndex = -1;
	          if (angular.isArray(haystack)) {
	            var tempArr = angular.copy(haystack);
	            for (var i = 0; i < tempArr.length; i++) {
	              // handle the simple string version of tagging
	              if ($select.tagging.fct === undefined) {
	                // search the array for the match
	                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
	                  dupeIndex = i;
	                }
	                // handle the object tagging implementation
	              } else {
	                  var mockObj = tempArr[i];
	                  if (angular.isObject(mockObj)) {
	                    mockObj.isTag = true;
	                  }
	                  if (angular.equals(mockObj, needle)) {
	                    dupeIndex = i;
	                  }
	                }
	            }
	          }
	          return dupeIndex;
	        }
	
	        $select.searchInput.on('blur', function () {
	          $timeout(function () {
	            $selectMultiple.activeMatchIndex = -1;
	          });
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectNoChoice', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-no-choice');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/no-choice.tpl.html';
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectSingle', ['$timeout', '$compile', function ($timeout, $compile) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        //From view --> model
	        ngModel.$parsers.unshift(function (inputValue) {
	          var locals = {},
	              result;
	          locals[$select.parserResult.itemName] = inputValue;
	          result = $select.parserResult.modelMapper(scope, locals);
	          return result;
	        });
	
	        //From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (data) {
	            var checkFnSingle = function checkFnSingle(d) {
	              locals[$select.parserResult.itemName] = d;
	              result = $select.parserResult.modelMapper(scope, locals);
	              return result === inputValue;
	            };
	            //If possible pass same object stored in $select.selected
	            if ($select.selected && checkFnSingle($select.selected)) {
	              return $select.selected;
	            }
	            for (var i = data.length - 1; i >= 0; i--) {
	              if (checkFnSingle(data[i])) return data[i];
	            }
	          }
	          return inputValue;
	        });
	
	        //Update viewValue if model change
	        scope.$watch('$select.selected', function (newValue) {
	          if (ngModel.$viewValue !== newValue) {
	            ngModel.$setViewValue(newValue);
	          }
	        });
	
	        ngModel.$render = function () {
	          $select.selected = ngModel.$viewValue;
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          $select.selected = item;
	        });
	
	        scope.$on('uis:close', function (event, skipFocusser) {
	          $timeout(function () {
	            $select.focusser.prop('disabled', false);
	            if (!skipFocusser) $select.focusser[0].focus();
	          }, 0, false);
	        });
	
	        scope.$on('uis:activate', function () {
	          focusser.prop('disabled', true); //Will reactivate it on .close()
	        });
	
	        //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	        $compile(focusser)(scope);
	        $select.focusser = focusser;
	
	        //Input that will handle focus
	        $select.focusInput = focusser;
	
	        element.parent().append(focusser);
	        focusser.bind("focus", function () {
	          scope.$evalAsync(function () {
	            $select.focus = true;
	          });
	        });
	        focusser.bind("blur", function () {
	          scope.$evalAsync(function () {
	            $select.focus = false;
	          });
	        });
	        focusser.bind("keydown", function (e) {
	
	          if (e.which === KEY.BACKSPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            if ($select.allowBackspaceClear) {
	              $select.select(undefined);
	              scope.$apply();
	            }
	
	            return;
	          }
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	            return;
	          }
	
	          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.activate();
	          }
	
	          scope.$digest();
	        });
	
	        focusser.bind("keyup input", function (e) {
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	            return;
	          }
	
	          $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	          focusser.val('');
	          scope.$digest();
	        });
	      }
	    };
	  }]);
	
	  // Make multiple matches sortable
	  uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function ($timeout, uiSelectConfig, uiSelectMinErr) {
	    return {
	      require: ['^^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	        if (scope[attrs.uiSelectSort] === null) {
	          throw uiSelectMinErr('sort', 'Expected a list to sort');
	        }
	
	        var $select = ctrls[0];
	        var $ngModel = ctrls[1];
	
	        var options = angular.extend({
	          axis: 'horizontal'
	        }, scope.$eval(attrs.uiSelectSortOptions));
	
	        var axis = options.axis;
	        var draggingClassName = 'dragging';
	        var droppingClassName = 'dropping';
	        var droppingBeforeClassName = 'dropping-before';
	        var droppingAfterClassName = 'dropping-after';
	
	        scope.$watch(function () {
	          return $select.sortable;
	        }, function (newValue) {
	          if (newValue) {
	            element.attr('draggable', true);
	          } else {
	            element.removeAttr('draggable');
	          }
	        });
	
	        element.on('dragstart', function (event) {
	          element.addClass(draggingClassName);
	
	          (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	        });
	
	        element.on('dragend', function () {
	          removeClass(draggingClassName);
	        });
	
	        var move = function move(from, to) {
	          /*jshint validthis: true */
	          this.splice(to, 0, this.splice(from, 1)[0]);
	        };
	
	        var removeClass = function removeClass(className) {
	          angular.forEach($select.$element.querySelectorAll('.' + className), function (el) {
	            angular.element(el).removeClass(className);
	          });
	        };
	
	        var dragOverHandler = function dragOverHandler(event) {
	          event.preventDefault();
	
	          var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	          if (offset < this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2) {
	            removeClass(droppingAfterClassName);
	            element.addClass(droppingBeforeClassName);
	          } else {
	            removeClass(droppingBeforeClassName);
	            element.addClass(droppingAfterClassName);
	          }
	        };
	
	        var dropTimeout;
	
	        var dropHandler = function dropHandler(event) {
	          event.preventDefault();
	
	          var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	          // prevent event firing multiple times in firefox
	          $timeout.cancel(dropTimeout);
	          dropTimeout = $timeout(function () {
	            _dropHandler(droppedItemIndex);
	          }, 20);
	        };
	
	        var _dropHandler = function _dropHandler(droppedItemIndex) {
	          var theList = scope.$eval(attrs.uiSelectSort);
	          var itemToMove = theList[droppedItemIndex];
	          var newIndex = null;
	
	          if (element.hasClass(droppingBeforeClassName)) {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index - 1;
	            } else {
	              newIndex = scope.$index;
	            }
	          } else {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index;
	            } else {
	              newIndex = scope.$index + 1;
	            }
	          }
	
	          move.apply(theList, [droppedItemIndex, newIndex]);
	
	          $ngModel.$setViewValue(Date.now());
	
	          scope.$apply(function () {
	            scope.$emit('uiSelectSort:change', {
	              array: theList,
	              item: itemToMove,
	              from: droppedItemIndex,
	              to: newIndex
	            });
	          });
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('drop', dropHandler);
	        };
	
	        element.on('dragenter', function () {
	          if (element.hasClass(draggingClassName)) {
	            return;
	          }
	
	          element.addClass(droppingClassName);
	
	          element.on('dragover', dragOverHandler);
	          element.on('drop', dropHandler);
	        });
	
	        element.on('dragleave', function (event) {
	          if (event.target != element) {
	            return;
	          }
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('dragover', dragOverHandler);
	          element.off('drop', dropHandler);
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	    return {
	      restrict: 'A',
	      require: 'uiSelect',
	      link: function link(scope, element, attrs, $select) {
	        $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	        scope.$watch('$select.open', function (isOpen, previousState) {
	          if (isOpen !== previousState) {
	            $timeout(function () {
	              $select.onOpenCloseCallback(scope, {
	                isOpen: isOpen
	              });
	            });
	          }
	        });
	      }
	    };
	  }]);
	
	  /**
	   * Parses "repeat" attribute.
	   *
	   * Taken from AngularJS ngRepeat source code
	   * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	   *
	   * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	   * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	   */
	
	  uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function (uiSelectMinErr, $parse) {
	    var self = this;
	
	    /**
	     * Example:
	     * expression = "address in addresses | filter: {street: $select.search} track by $index"
	     * itemName = "address",
	     * source = "addresses | filter: {street: $select.search}",
	     * trackByExp = "$index",
	     */
	    self.parse = function (expression) {
	
	      var match;
	      //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	      // If an array is used as collection
	
	      // if (isObjectCollection){
	      // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	      match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      // 1 Alias
	      // 2 Item
	      // 3 Key on (key,value)
	      // 4 Value on (key,value)
	      // 5 Source expression (including filters)
	      // 6 Track by
	
	      if (!match) {
	        throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
	      }
	
	      var source = match[5],
	          filters = '';
	
	      // When using (key,value) ui-select requires filters to be extracted, since the object
	      // is converted to an array for $select.items
	      // (in which case the filters need to be reapplied)
	      if (match[3]) {
	        // Remove any enclosing parenthesis
	        source = match[5].replace(/(^\()|(\)$)/g, '');
	        // match all after | but not after ||
	        var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	        if (filterMatch && filterMatch[1].trim()) {
	          filters = filterMatch[1];
	          source = source.replace(filters, '');
	        }
	      }
	
	      return {
	        itemName: match[4] || match[2], // (lhs) Left-hand side,
	        keyName: match[3], //for (key, value) syntax
	        source: $parse(source),
	        filters: filters,
	        trackByExp: match[6],
	        modelMapper: $parse(match[1] || match[4] || match[2]),
	        repeatExpression: function repeatExpression(grouped) {
	          var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	          if (this.trackByExp) {
	            expression += ' track by ' + this.trackByExp;
	          }
	          return expression;
	        }
	      };
	    };
	
	    self.getGroupNgRepeatExpression = function () {
	      return '$group in $select.groups';
	    };
	  }]);
	})();
	angular.module("ui.select").run(["$templateCache", function ($templateCache) {
	  $templateCache.put("bootstrap/choices.tpl.html", "<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" role=\"listbox\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><a href=\"\" class=\"ui-select-choices-row-inner\"></a></div></li></ul>");
	  $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	  $templateCache.put("bootstrap/match.tpl.html", "<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	  $templateCache.put("bootstrap/no-choice.tpl.html", "<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	  $templateCache.put("bootstrap/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("bootstrap/select.tpl.html", "<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"form-control ui-select-search\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.searchEnabled && $select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	  $templateCache.put("select2/choices.tpl.html", "<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	  $templateCache.put("select2/match-multiple.tpl.html", "<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	  $templateCache.put("select2/match.tpl.html", "<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	  $templateCache.put("select2/no-choice.tpl.html", "<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("select2/select-multiple.tpl.html", "<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	  $templateCache.put("select2/select.tpl.html", "<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	  $templateCache.put("selectize/choices.tpl.html", "<div ng-show=\"$select.open\" class=\"ui-select-choices" + " ui-select-dropdown selectize-dropdown single\" ng-class=\"{'ui-select-choices-has-footer-text' :" + " $select.footerText && $select.showFooterText}\"><div class=\"ui-select-choices-content" + " selectize-dropdown-content\"><div" + " class=\"ui-select-choices-group optgroup\" ng-class=\"{'ui-select-choices-ungrouped' : !$group.name}\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-if=\"$group.name && $select.showGroupHeaders\"" + " ng-bind-html=\"$group.name | highlight: $select.search\"></div><div role=\"option\"" + " class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled:" + " $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\"" + " data-selectable=\"\"></div></div></div><div class=\"selectize-dropdown-footer\" ng-if=\"$select.footerText &&" + " $select.showFooterText\"" + " ng-bind-html=\"$select.footerText\"></div></div></div>");
	  //$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	  $templateCache.put("selectize/match.tpl.html", "<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span><span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude></span></div></div>");
	  $templateCache.put("selectize/no-choice.tpl.html", "<div class=\"ui-select-no-choice selectize-dropdown\"" + " ng-show=\"$select.items.length == 0 && $select.open\"><div class=\"selectize-dropdown-content\"><div" + " data-selectable=\"\"" + " ng-transclude=\"\"></div></div></div>");
	  $templateCache.put("selectize/select.tpl.html", "<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.searchEnabled || (!$select.isEmpty() && !$select.open)\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	}]);

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.4.2
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	"use strict";
	
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	  /*jshint globalstrict:true*/
	  /*global angular:false*/
	  'use strict';
	
	  var isDefined = angular.isDefined,
	      isFunction = angular.isFunction,
	      isString = angular.isString,
	      isObject = angular.isObject,
	      isArray = angular.isArray,
	      forEach = angular.forEach,
	      extend = angular.extend,
	      copy = angular.copy,
	      toJson = angular.toJson;
	
	  function inherit(parent, extra) {
	    return extend(new (extend(function () {}, { prototype: parent }))(), extra);
	  }
	
	  function merge(dst) {
	    forEach(arguments, function (obj) {
	      if (obj !== dst) {
	        forEach(obj, function (value, key) {
	          if (!dst.hasOwnProperty(key)) dst[key] = value;
	        });
	      }
	    });
	    return dst;
	  }
	
	  /**
	   * Finds the common ancestor path between two states.
	   *
	   * @param {Object} first The first state.
	   * @param {Object} second The second state.
	   * @return {Array} Returns an array of state names in descending order, not including the root.
	   */
	  function ancestors(first, second) {
	    var path = [];
	
	    for (var n in first.path) {
	      if (first.path[n] !== second.path[n]) break;
	      path.push(first.path[n]);
	    }
	    return path;
	  }
	
	  /**
	   * IE8-safe wrapper for `Object.keys()`.
	   *
	   * @param {Object} object A JavaScript object.
	   * @return {Array} Returns the keys of the object as an array.
	   */
	  function objectKeys(object) {
	    if (Object.keys) {
	      return Object.keys(object);
	    }
	    var result = [];
	
	    forEach(object, function (val, key) {
	      result.push(key);
	    });
	    return result;
	  }
	
	  /**
	   * IE8-safe wrapper for `Array.prototype.indexOf()`.
	   *
	   * @param {Array} array A JavaScript array.
	   * @param {*} value A value to search the array for.
	   * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	   */
	  function indexOf(array, value) {
	    if (Array.prototype.indexOf) {
	      return array.indexOf(value, Number(arguments[2]) || 0);
	    }
	    var len = array.length >>> 0,
	        from = Number(arguments[2]) || 0;
	    from = from < 0 ? Math.ceil(from) : Math.floor(from);
	
	    if (from < 0) from += len;
	
	    for (; from < len; from++) {
	      if (from in array && array[from] === value) return from;
	    }
	    return -1;
	  }
	
	  /**
	   * Merges a set of parameters with all parameters inherited between the common parents of the
	   * current state and a given destination state.
	   *
	   * @param {Object} currentParams The value of the current state parameters ($stateParams).
	   * @param {Object} newParams The set of parameters which will be composited with inherited params.
	   * @param {Object} $current Internal definition of object representing the current state.
	   * @param {Object} $to Internal definition of object representing state to transition to.
	   */
	  function inheritParams(currentParams, newParams, $current, $to) {
	    var parents = ancestors($current, $to),
	        parentParams,
	        inherited = {},
	        inheritList = [];
	
	    for (var i in parents) {
	      if (!parents[i] || !parents[i].params) continue;
	      parentParams = objectKeys(parents[i].params);
	      if (!parentParams.length) continue;
	
	      for (var j in parentParams) {
	        if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	        inheritList.push(parentParams[j]);
	        inherited[parentParams[j]] = currentParams[parentParams[j]];
	      }
	    }
	    return extend({}, inherited, newParams);
	  }
	
	  /**
	   * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	   *
	   * @param {Object} a The first object.
	   * @param {Object} b The second object.
	   * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	   *                     it defaults to the list of keys in `a`.
	   * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	   */
	  function equalForKeys(a, b, keys) {
	    if (!keys) {
	      keys = [];
	      for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	    }
	
	    for (var i = 0; i < keys.length; i++) {
	      var k = keys[i];
	      if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	    }
	    return true;
	  }
	
	  /**
	   * Returns the subset of an object, based on a list of keys.
	   *
	   * @param {Array} keys
	   * @param {Object} values
	   * @return {Boolean} Returns a subset of `values`.
	   */
	  function filterByKeys(keys, values) {
	    var filtered = {};
	
	    forEach(keys, function (name) {
	      filtered[name] = values[name];
	    });
	    return filtered;
	  }
	
	  // like _.indexBy
	  // when you know that your index values will be unique, or you want last-one-in to win
	  function indexBy(array, propName) {
	    var result = {};
	    forEach(array, function (item) {
	      result[item[propName]] = item;
	    });
	    return result;
	  }
	
	  // extracted from underscore.js
	  // Return a copy of the object only containing the whitelisted properties.
	  function pick(obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    forEach(keys, function (key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  }
	
	  // extracted from underscore.js
	  // Return a copy of the object omitting the blacklisted properties.
	  function omit(obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    for (var key in obj) {
	      if (indexOf(keys, key) == -1) copy[key] = obj[key];
	    }
	    return copy;
	  }
	
	  function pluck(collection, key) {
	    var result = isArray(collection) ? [] : {};
	
	    forEach(collection, function (val, i) {
	      result[i] = isFunction(key) ? key(val) : val[key];
	    });
	    return result;
	  }
	
	  function filter(collection, callback) {
	    var array = isArray(collection);
	    var result = array ? [] : {};
	    forEach(collection, function (val, i) {
	      if (callback(val, i)) {
	        result[array ? result.length : i] = val;
	      }
	    });
	    return result;
	  }
	
	  function map(collection, callback) {
	    var result = isArray(collection) ? [] : {};
	
	    forEach(collection, function (val, i) {
	      result[i] = callback(val, i);
	    });
	    return result;
	  }
	
	  // issue #2676 #2889
	  function silenceUncaughtInPromise(promise) {
	    return promise.then(undefined, function () {}) && promise;
	  }
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.util
	   *
	   * @description
	   * # ui.router.util sub-module
	   *
	   * This module is a dependency of other sub-modules. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   *
	   */
	  angular.module('ui.router.util', ['ng']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.router
	   * 
	   * @requires ui.router.util
	   *
	   * @description
	   * # ui.router.router sub-module
	   *
	   * This module is a dependency of other sub-modules. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   */
	  angular.module('ui.router.router', ['ui.router.util']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router.state
	   * 
	   * @requires ui.router.router
	   * @requires ui.router.util
	   *
	   * @description
	   * # ui.router.state sub-module
	   *
	   * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	   * in your angular app (use {@link ui.router} module instead).
	   * 
	   */
	  angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	  /**
	   * @ngdoc overview
	   * @name ui.router
	   *
	   * @requires ui.router.state
	   *
	   * @description
	   * # ui.router
	   * 
	   * ## The main module for ui.router 
	   * There are several sub-modules included with the ui.router module, however only this module is needed
	   * as a dependency within your angular app. The other modules are for organization purposes. 
	   *
	   * The modules are:
	   * * ui.router - the main "umbrella" module
	   * * ui.router.router - 
	   * 
	   * *You'll need to include **only** this module as the dependency within your angular app.*
	   * 
	   * <pre>
	   * <!doctype html>
	   * <html ng-app="myApp">
	   * <head>
	   *   <script src="js/angular.js"></script>
	   *   <!-- Include the ui-router script -->
	   *   <script src="js/angular-ui-router.min.js"></script>
	   *   <script>
	   *     // ...and add 'ui.router' as a dependency
	   *     var myApp = angular.module('myApp', ['ui.router']);
	   *   </script>
	   * </head>
	   * <body>
	   * </body>
	   * </html>
	   * </pre>
	   */
	  angular.module('ui.router', ['ui.router.state']);
	
	  angular.module('ui.router.compat', ['ui.router']);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$resolve
	   *
	   * @requires $q
	   * @requires $injector
	   *
	   * @description
	   * Manages resolution of (acyclic) graphs of promises.
	   */
	  $Resolve.$inject = ['$q', '$injector'];
	  function $Resolve($q, $injector) {
	
	    var VISIT_IN_PROGRESS = 1,
	        VISIT_DONE = 2,
	        NOTHING = {},
	        NO_DEPENDENCIES = [],
	        NO_LOCALS = NOTHING,
	        NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$resolve#study
	     * @methodOf ui.router.util.$resolve
	     *
	     * @description
	     * Studies a set of invocables that are likely to be used multiple times.
	     * <pre>
	     * $resolve.study(invocables)(locals, parent, self)
	     * </pre>
	     * is equivalent to
	     * <pre>
	     * $resolve.resolve(invocables, locals, parent, self)
	     * </pre>
	     * but the former is more efficient (in fact `resolve` just calls `study` 
	     * internally).
	     *
	     * @param {object} invocables Invocable objects
	     * @return {function} a function to pass in locals, parent and self
	     */
	    this.study = function (invocables) {
	      if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	      var invocableKeys = objectKeys(invocables || {});
	
	      // Perform a topological sort of invocables to build an ordered plan
	      var plan = [],
	          cycle = [],
	          visited = {};
	      function visit(value, key) {
	        if (visited[key] === VISIT_DONE) return;
	
	        cycle.push(key);
	        if (visited[key] === VISIT_IN_PROGRESS) {
	          cycle.splice(0, indexOf(cycle, key));
	          throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	        }
	        visited[key] = VISIT_IN_PROGRESS;
	
	        if (isString(value)) {
	          plan.push(key, [function () {
	            return $injector.get(value);
	          }], NO_DEPENDENCIES);
	        } else {
	          var params = $injector.annotate(value);
	          forEach(params, function (param) {
	            if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	          });
	          plan.push(key, value, params);
	        }
	
	        cycle.pop();
	        visited[key] = VISIT_DONE;
	      }
	      forEach(invocables, visit);
	      invocables = cycle = visited = null; // plan is all that's required
	
	      function isResolve(value) {
	        return isObject(value) && value.then && value.$$promises;
	      }
	
	      return function (locals, parent, self) {
	        if (isResolve(locals) && self === undefined) {
	          self = parent;parent = locals;locals = null;
	        }
	        if (!locals) locals = NO_LOCALS;else if (!isObject(locals)) {
	          throw new Error("'locals' must be an object");
	        }
	        if (!parent) parent = NO_PARENT;else if (!isResolve(parent)) {
	          throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	        }
	
	        // To complete the overall resolution, we have to wait for the parent
	        // promise and for the promise for each invokable in our plan.
	        var resolution = $q.defer(),
	            result = silenceUncaughtInPromise(resolution.promise),
	            promises = result.$$promises = {},
	            values = extend({}, locals),
	            wait = 1 + plan.length / 3,
	            merged = false;
	
	        silenceUncaughtInPromise(result);
	
	        function done() {
	          // Merge parent values we haven't got yet and publish our own $$values
	          if (! --wait) {
	            if (!merged) merge(values, parent.$$values);
	            result.$$values = values;
	            result.$$promises = result.$$promises || true; // keep for isResolve()
	            delete result.$$inheritedValues;
	            resolution.resolve(values);
	          }
	        }
	
	        function fail(reason) {
	          result.$$failure = reason;
	          resolution.reject(reason);
	        }
	
	        // Short-circuit if parent has already failed
	        if (isDefined(parent.$$failure)) {
	          fail(parent.$$failure);
	          return result;
	        }
	
	        if (parent.$$inheritedValues) {
	          merge(values, omit(parent.$$inheritedValues, invocableKeys));
	        }
	
	        // Merge parent values if the parent has already resolved, or merge
	        // parent promises and wait if the parent resolve is still in progress.
	        extend(promises, parent.$$promises);
	        if (parent.$$values) {
	          merged = merge(values, omit(parent.$$values, invocableKeys));
	          result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	          done();
	        } else {
	          if (parent.$$inheritedValues) {
	            result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	          }
	          parent.then(done, fail);
	        }
	
	        // Process each invocable in the plan, but ignore any where a local of the same name exists.
	        for (var i = 0, ii = plan.length; i < ii; i += 3) {
	          if (locals.hasOwnProperty(plan[i])) done();else invoke(plan[i], plan[i + 1], plan[i + 2]);
	        }
	
	        function invoke(key, invocable, params) {
	          // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	          var invocation = $q.defer(),
	              waitParams = 0;
	          function onfailure(reason) {
	            invocation.reject(reason);
	            fail(reason);
	          }
	          // Wait for any parameter that we have a promise for (either from parent or from this
	          // resolve; in that case study() will have made sure it's ordered before us in the plan).
	          forEach(params, function (dep) {
	            if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	              waitParams++;
	              promises[dep].then(function (result) {
	                values[dep] = result;
	                if (! --waitParams) proceed();
	              }, onfailure);
	            }
	          });
	          if (!waitParams) proceed();
	          function proceed() {
	            if (isDefined(result.$$failure)) return;
	            try {
	              invocation.resolve($injector.invoke(invocable, self, values));
	              invocation.promise.then(function (result) {
	                values[key] = result;
	                done();
	              }, onfailure);
	            } catch (e) {
	              onfailure(e);
	            }
	          }
	          // Publish promise synchronously; invocations further down in the plan may depend on it.
	          promises[key] = silenceUncaughtInPromise(invocation.promise);
	        }
	
	        return result;
	      };
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$resolve#resolve
	     * @methodOf ui.router.util.$resolve
	     *
	     * @description
	     * Resolves a set of invocables. An invocable is a function to be invoked via 
	     * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	     * An invocable can either return a value directly,
	     * or a `$q` promise. If a promise is returned it will be resolved and the 
	     * resulting value will be used instead. Dependencies of invocables are resolved 
	     * (in this order of precedence)
	     *
	     * - from the specified `locals`
	     * - from another invocable that is part of this `$resolve` call
	     * - from an invocable that is inherited from a `parent` call to `$resolve` 
	     *   (or recursively
	     * - from any ancestor `$resolve` of that parent).
	     *
	     * The return value of `$resolve` is a promise for an object that contains 
	     * (in this order of precedence)
	     *
	     * - any `locals` (if specified)
	     * - the resolved return values of all injectables
	     * - any values inherited from a `parent` call to `$resolve` (if specified)
	     *
	     * The promise will resolve after the `parent` promise (if any) and all promises 
	     * returned by injectables have been resolved. If any invocable 
	     * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	     * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	     * same error. A rejection of a `parent` promise (if specified) will likewise be 
	     * propagated immediately. Once the `$resolve` promise has been rejected, no 
	     * further invocables will be called.
	     * 
	     * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	     * to throw an error. As a special case, an injectable can depend on a parameter 
	     * with the same name as the injectable, which will be fulfilled from the `parent` 
	     * injectable of the same name. This allows inherited values to be decorated. 
	     * Note that in this case any other injectable in the same `$resolve` with the same
	     * dependency would see the decorated value, not the inherited value.
	     *
	     * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	     * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	     * exception.
	     *
	     * Invocables are invoked eagerly as soon as all dependencies are available. 
	     * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	     *
	     * As a special case, an invocable can be a string, in which case it is taken to 
	     * be a service name to be passed to `$injector.get()`. This is supported primarily 
	     * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	     * routes.
	     *
	     * @param {object} invocables functions to invoke or 
	     * `$injector` services to fetch.
	     * @param {object} locals  values to make available to the injectables
	     * @param {object} parent  a promise returned by another call to `$resolve`.
	     * @param {object} self  the `this` for the invoked methods
	     * @return {object} Promise for an object that contains the resolved return value
	     * of all invocables, as well as any inherited and local values.
	     */
	    this.resolve = function (invocables, locals, parent, self) {
	      return this.study(invocables)(locals, parent, self);
	    };
	  }
	
	  angular.module('ui.router.util').service('$resolve', $Resolve);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactoryProvider
	   *
	   * @description
	   * Provider for $templateFactory. Manages which template-loading mechanism to
	   * use, and will default to the most recent one ($templateRequest on Angular
	   * versions starting from 1.3, $http otherwise).
	   */
	  function TemplateFactoryProvider() {
	    var shouldUnsafelyUseHttp = angular.version.minor < 3;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
	     * @methodOf ui.router.util.$templateFactoryProvider
	     *
	     * @description
	     * Forces $templateFactory to use $http instead of $templateRequest. This
	     * might cause XSS, as $http doesn't enforce the regular security checks for
	     * templates that have been introduced in Angular 1.3. Note that setting this
	     * to false on Angular older than 1.3.x will crash, as the $templateRequest
	     * service (and the security checks) are not implemented on these versions.
	     *
	     * See the $sce documentation, section
	     * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
	     * Impact on loading templates</a> for more details about this mechanism.
	     *
	     * @param {boolean} value
	     */
	    this.shouldUnsafelyUseHttp = function (value) {
	      shouldUnsafelyUseHttp = !!value;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.util.$templateFactory
	     *
	     * @requires $http
	     * @requires $templateCache
	     * @requires $injector
	     *
	     * @description
	     * Service. Manages loading of templates.
	     */
	    this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
	      return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);
	    }];
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$templateFactory
	   *
	   * @requires $http
	   * @requires $templateCache
	   * @requires $injector
	   *
	   * @description
	   * Service. Manages loading of templates.
	   */
	  function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromConfig
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template from a configuration object. 
	     *
	     * @param {object} config Configuration object for which to load a template. 
	     * The following properties are search in the specified order, and the first one 
	     * that is defined is used to create the template:
	     *
	     * @param {string|object} config.template html string template or function to 
	     * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	     * @param {string|object} config.templateUrl url to load or a function returning 
	     * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	     * @param {Function} config.templateProvider function to invoke via 
	     * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	     * @param {object} params  Parameters to pass to the template function.
	     * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	     * via a `templateProvider`. Defaults to `{ params: params }`.
	     *
	     * @return {string|object}  The template html as a string, or a promise for 
	     * that string,or `null` if no template is configured.
	     */
	    this.fromConfig = function (config, params, locals) {
	      return isDefined(config.template) ? this.fromString(config.template, params) : isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) : isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) : null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromString
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template from a string or a function returning a string.
	     *
	     * @param {string|object} template html template as a string or function that 
	     * returns an html template as a string.
	     * @param {object} params Parameters to pass to the template function.
	     *
	     * @return {string|object} The template html as a string, or a promise for that 
	     * string.
	     */
	    this.fromString = function (template, params) {
	      return isFunction(template) ? template(params) : template;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromUrl
	     * @methodOf ui.router.util.$templateFactory
	     * 
	     * @description
	     * Loads a template from the a URL via `$http` and `$templateCache`.
	     *
	     * @param {string|Function} url url of the template to load, or a function 
	     * that returns a url.
	     * @param {Object} params Parameters to pass to the url function.
	     * @return {string|Promise.<string>} The template html as a string, or a promise 
	     * for that string.
	     */
	    this.fromUrl = function (url, params) {
	      if (isFunction(url)) url = url(params);
	      if (url == null) return null;else {
	        if (!shouldUnsafelyUseHttp) {
	          return $injector.get('$templateRequest')(url);
	        } else {
	          return $http.get(url, { cache: $templateCache, headers: { Accept: 'text/html' } }).then(function (response) {
	            return response.data;
	          });
	        }
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$templateFactory#fromProvider
	     * @methodOf ui.router.util.$templateFactory
	     *
	     * @description
	     * Creates a template by invoking an injectable provider function.
	     *
	     * @param {Function} provider Function to invoke via `$injector.invoke`
	     * @param {Object} params Parameters for the template.
	     * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	     * `{ params: params }`.
	     * @return {string|Promise.<string>} The template html as a string, or a promise 
	     * for that string.
	     */
	    this.fromProvider = function (provider, params, locals) {
	      return $injector.invoke(provider, null, locals || { params: params });
	    };
	  }
	
	  angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);
	
	  var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Matches URLs against patterns and extracts named parameters from the path or the search
	   * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	   * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	   * do not influence whether or not a URL is matched, but their values are passed through into
	   * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	   *
	   * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	   * syntax, which optionally allows a regular expression for the parameter to be specified:
	   *
	   * * `':'` name - colon placeholder
	   * * `'*'` name - catch-all placeholder
	   * * `'{' name '}'` - curly placeholder
	   * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	   *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	   *
	   * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	   * must be unique within the pattern (across both path and search parameters). For colon
	   * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	   * number of characters other than '/'. For catch-all placeholders the path parameter matches
	   * any number of characters.
	   *
	   * Examples:
	   *
	   * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	   *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	   * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	   *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	   * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	   * * `'/user/{id:[^/]*}'` - Same as the previous example.
	   * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	   *   parameter consists of 1 to 8 hex digits.
	   * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	   *   path into the parameter 'path'.
	   * * `'/files/*path'` - ditto.
	   * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	   *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	   *
	   * @param {string} pattern  The pattern to compile into a matcher.
	   * @param {Object} config  A configuration object hash:
	   * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	   *   an existing UrlMatcher
	   *
	   * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	   * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	   *
	   * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	   *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	   *   non-null) will start with this prefix.
	   *
	   * @property {string} source  The pattern that was passed into the constructor
	   *
	   * @property {string} sourcePath  The path portion of the source property
	   *
	   * @property {string} sourceSearch  The search portion of the source property
	   *
	   * @property {string} regex  The constructed regex that will be used to match against the url when
	   *   it is time to determine which url will match.
	   *
	   * @returns {Object}  New `UrlMatcher` object
	   */
	  function UrlMatcher(pattern, config, parentMatcher) {
	    config = extend({ params: {} }, isObject(config) ? config : {});
	
	    // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	    //   '*' name
	    //   ':' name
	    //   '{' name '}'
	    //   '{' name ':' regexp '}'
	    // The regular expression is somewhat complicated due to the need to allow curly braces
	    // inside the regular expression. The placeholder regexp breaks down as follows:
	    //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	    //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	    //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	    //    [^{}\\]+                       - anything other than curly braces or backslash
	    //    \\.                            - a backslash escape
	    //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	    var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	        searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	        compiled = '^',
	        last = 0,
	        m,
	        segments = this.segments = [],
	        parentParams = parentMatcher ? parentMatcher.params : {},
	        params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	        paramNames = [];
	
	    function addParameter(id, type, config, location) {
	      paramNames.push(id);
	      if (parentParams[id]) return parentParams[id];
	      if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	      if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	      params[id] = new $$UMFP.Param(id, type, config, location);
	      return params[id];
	    }
	
	    function quoteRegExp(string, pattern, squash, optional) {
	      var surroundPattern = ['', ''],
	          result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	      if (!pattern) return result;
	      switch (squash) {
	        case false:
	          surroundPattern = ['(', ')' + (optional ? "?" : "")];break;
	        case true:
	          result = result.replace(/\/$/, '');
	          surroundPattern = ['(?:\/(', ')|\/)?'];
	          break;
	        default:
	          surroundPattern = ['(' + squash + "|", ')?'];break;
	      }
	      return result + surroundPattern[0] + pattern + surroundPattern[1];
	    }
	
	    this.source = pattern;
	
	    // Split into static segments separated by path parameter placeholders.
	    // The number of segments is always 1 more than the number of parameters.
	    function matchDetails(m, isSearch) {
	      var id, regexp, segment, type, cfg, arrayMode;
	      id = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	      cfg = config.params[id];
	      segment = pattern.substring(last, m.index);
	      regexp = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	      if (regexp) {
	        type = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	      }
	
	      return {
	        id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	      };
	    }
	
	    var p, param, segment;
	    while (m = placeholder.exec(pattern)) {
	      p = matchDetails(m, false);
	      if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	      param = addParameter(p.id, p.type, p.cfg, "path");
	      compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	      segments.push(p.segment);
	      last = placeholder.lastIndex;
	    }
	    segment = pattern.substring(last);
	
	    // Find any search parameter names and remove them from the last segment
	    var i = segment.indexOf('?');
	
	    if (i >= 0) {
	      var search = this.sourceSearch = segment.substring(i);
	      segment = segment.substring(0, i);
	      this.sourcePath = pattern.substring(0, last + i);
	
	      if (search.length > 0) {
	        last = 0;
	        while (m = searchPlaceholder.exec(search)) {
	          p = matchDetails(m, true);
	          param = addParameter(p.id, p.type, p.cfg, "search");
	          last = placeholder.lastIndex;
	          // check if ?&
	        }
	      }
	    } else {
	        this.sourcePath = pattern;
	        this.sourceSearch = '';
	      }
	
	    compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	    segments.push(segment);
	
	    this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	    this.prefix = segments[0];
	    this.$$paramNames = paramNames;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#concat
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Returns a new matcher for a pattern constructed by appending the path part and adding the
	   * search parameters of the specified pattern to this pattern. The current pattern is not
	   * modified. This can be understood as creating a pattern for URLs that are relative to (or
	   * suffixes of) the current pattern.
	   *
	   * @example
	   * The following two matchers are equivalent:
	   * <pre>
	   * new UrlMatcher('/user/{id}?q').concat('/details?date');
	   * new UrlMatcher('/user/{id}/details?q&date');
	   * </pre>
	   *
	   * @param {string} pattern  The pattern to append.
	   * @param {Object} config  An object hash of the configuration for the matcher.
	   * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	   */
	  UrlMatcher.prototype.concat = function (pattern, config) {
	    // Because order of search parameters is irrelevant, we can add our own search
	    // parameters to the end of the new pattern. Parse the new pattern by itself
	    // and then join the bits together, but it's much easier to do this on a string level.
	    var defaultConfig = {
	      caseInsensitive: $$UMFP.caseInsensitive(),
	      strict: $$UMFP.strictMode(),
	      squash: $$UMFP.defaultSquashPolicy()
	    };
	    return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	  };
	
	  UrlMatcher.prototype.toString = function () {
	    return this.source;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#exec
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Tests the specified path against this matcher, and returns an object containing the captured
	   * parameter values, or null if the path does not match. The returned object contains the values
	   * of any search parameters that are mentioned in the pattern, but their value may be null if
	   * they are not present in `searchParams`. This means that search parameters are always treated
	   * as optional.
	   *
	   * @example
	   * <pre>
	   * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	   *   x: '1', q: 'hello'
	   * });
	   * // returns { id: 'bob', q: 'hello', r: null }
	   * </pre>
	   *
	   * @param {string} path  The URL path to match, e.g. `$location.path()`.
	   * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	   * @returns {Object}  The captured parameter values.
	   */
	  UrlMatcher.prototype.exec = function (path, searchParams) {
	    var m = this.regexp.exec(path);
	    if (!m) return null;
	    searchParams = searchParams || {};
	
	    var paramNames = this.parameters(),
	        nTotal = paramNames.length,
	        nPath = this.segments.length - 1,
	        values = {},
	        i,
	        j,
	        cfg,
	        paramName;
	
	    if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	    function decodePathArray(string) {
	      function reverseString(str) {
	        return str.split("").reverse().join("");
	      }
	      function unquoteDashes(str) {
	        return str.replace(/\\-/g, "-");
	      }
	
	      var split = reverseString(string).split(/-(?!\\)/);
	      var allReversed = map(split, reverseString);
	      return map(allReversed, unquoteDashes).reverse();
	    }
	
	    var param, paramVal;
	    for (i = 0; i < nPath; i++) {
	      paramName = paramNames[i];
	      param = this.params[paramName];
	      paramVal = m[i + 1];
	      // if the param value matches a pre-replace pair, replace the value before decoding.
	      for (j = 0; j < param.replace.length; j++) {
	        if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	      }
	      if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	      if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	      values[paramName] = param.value(paramVal);
	    }
	    for (; /**/i < nTotal; i++) {
	      paramName = paramNames[i];
	      values[paramName] = this.params[paramName].value(searchParams[paramName]);
	      param = this.params[paramName];
	      paramVal = searchParams[paramName];
	      for (j = 0; j < param.replace.length; j++) {
	        if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	      }
	      if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	      values[paramName] = param.value(paramVal);
	    }
	
	    return values;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#parameters
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Returns the names of all path and search parameters of this pattern in an unspecified order.
	   *
	   * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	   *    pattern has no parameters, an empty array is returned.
	   */
	  UrlMatcher.prototype.parameters = function (param) {
	    if (!isDefined(param)) return this.$$paramNames;
	    return this.params[param] || null;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#validates
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Checks an object hash of parameters to validate their correctness according to the parameter
	   * types of this `UrlMatcher`.
	   *
	   * @param {Object} params The object hash of parameters to validate.
	   * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	   */
	  UrlMatcher.prototype.validates = function (params) {
	    return this.params.$$validates(params);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:UrlMatcher#format
	   * @methodOf ui.router.util.type:UrlMatcher
	   *
	   * @description
	   * Creates a URL that matches this pattern by substituting the specified values
	   * for the path and search parameters. Null values for path parameters are
	   * treated as empty strings.
	   *
	   * @example
	   * <pre>
	   * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	   * // returns '/user/bob?q=yes'
	   * </pre>
	   *
	   * @param {Object} values  the values to substitute for the parameters in this pattern.
	   * @returns {string}  the formatted URL (path and optionally search part).
	   */
	  UrlMatcher.prototype.format = function (values) {
	    values = values || {};
	    var segments = this.segments,
	        params = this.parameters(),
	        paramset = this.params;
	    if (!this.validates(values)) return null;
	
	    var i,
	        search = false,
	        nPath = segments.length - 1,
	        nTotal = params.length,
	        result = segments[0];
	
	    function encodeDashes(str) {
	      // Replace dashes with encoded "\-"
	      return encodeURIComponent(str).replace(/-/g, function (c) {
	        return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase();
	      });
	    }
	
	    for (i = 0; i < nTotal; i++) {
	      var isPathParam = i < nPath;
	      var name = params[i],
	          param = paramset[name],
	          value = param.value(values[name]);
	      var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	      var squash = isDefaultValue ? param.squash : false;
	      var encoded = param.type.encode(value);
	
	      if (isPathParam) {
	        var nextSegment = segments[i + 1];
	        var isFinalPathParam = i + 1 === nPath;
	
	        if (squash === false) {
	          if (encoded != null) {
	            if (isArray(encoded)) {
	              result += map(encoded, encodeDashes).join("-");
	            } else {
	              result += encodeURIComponent(encoded);
	            }
	          }
	          result += nextSegment;
	        } else if (squash === true) {
	          var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	          result += nextSegment.match(capture)[1];
	        } else if (isString(squash)) {
	          result += squash + nextSegment;
	        }
	
	        if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	      } else {
	        if (encoded == null || isDefaultValue && squash !== false) continue;
	        if (!isArray(encoded)) encoded = [encoded];
	        if (encoded.length === 0) continue;
	        encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	        result += (search ? '&' : '?') + (name + '=' + encoded);
	        search = true;
	      }
	    }
	
	    return result;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.type:Type
	   *
	   * @description
	   * Implements an interface to define custom parameter types that can be decoded from and encoded to
	   * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	   * objects when matching or formatting URLs, or comparing or validating parameter values.
	   *
	   * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	   * information on registering custom types.
	   *
	   * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	   *        properties will override the default methods and/or pattern in `Type`'s public interface.
	   * @example
	   * <pre>
	   * {
	   *   decode: function(val) { return parseInt(val, 10); },
	   *   encode: function(val) { return val && val.toString(); },
	   *   equals: function(a, b) { return this.is(a) && a === b; },
	   *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	   *   pattern: /\d+/
	   * }
	   * </pre>
	   *
	   * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	   *           coming from a substring of a URL.
	   *
	   * @returns {Object}  Returns a new `Type` object.
	   */
	  function Type(config) {
	    extend(this, config);
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#is
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Detects whether a value is of a particular type. Accepts a native (decoded) value
	   * and determines whether it matches the current `Type` object.
	   *
	   * @param {*} val  The value to check.
	   * @param {string} key  Optional. If the type check is happening in the context of a specific
	   *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	   *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	   * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	   */
	  Type.prototype.is = function (val, key) {
	    return true;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#encode
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	   * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	   * only needs to be a representation of `val` that has been coerced to a string.
	   *
	   * @param {*} val  The value to encode.
	   * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	   *        meta-programming of `Type` objects.
	   * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	   */
	  Type.prototype.encode = function (val, key) {
	    return val;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#decode
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Converts a parameter value (from URL string or transition param) to a custom/native value.
	   *
	   * @param {string} val  The URL parameter value to decode.
	   * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	   *        meta-programming of `Type` objects.
	   * @returns {*}  Returns a custom representation of the URL parameter value.
	   */
	  Type.prototype.decode = function (val, key) {
	    return val;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.type:Type#equals
	   * @methodOf ui.router.util.type:Type
	   *
	   * @description
	   * Determines whether two decoded values are equivalent.
	   *
	   * @param {*} a  A value to compare against.
	   * @param {*} b  A value to compare against.
	   * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	   */
	  Type.prototype.equals = function (a, b) {
	    return a == b;
	  };
	
	  Type.prototype.$subPattern = function () {
	    var sub = this.pattern.toString();
	    return sub.substr(1, sub.length - 2);
	  };
	
	  Type.prototype.pattern = /.*/;
	
	  Type.prototype.toString = function () {
	    return "{Type:" + this.name + "}";
	  };
	
	  /** Given an encoded string, or a decoded object, returns a decoded object */
	  Type.prototype.$normalize = function (val) {
	    return this.is(val) ? val : this.decode(val);
	  };
	
	  /*
	   * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	   * e.g.:
	   * - urlmatcher pattern "/path?{queryParam[]:int}"
	   * - url: "/path?queryParam=1&queryParam=2
	   * - $stateParams.queryParam will be [1, 2]
	   * if `mode` is "auto", then
	   * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	   * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	   */
	  Type.prototype.$asArray = function (mode, isSearch) {
	    if (!mode) return this;
	    if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	    function ArrayType(type, mode) {
	      function bindTo(type, callbackName) {
	        return function () {
	          return type[callbackName].apply(type, arguments);
	        };
	      }
	
	      // Wrap non-array value as array
	      function arrayWrap(val) {
	        return isArray(val) ? val : isDefined(val) ? [val] : [];
	      }
	      // Unwrap array value for "auto" mode. Return undefined for empty array.
	      function arrayUnwrap(val) {
	        switch (val.length) {
	          case 0:
	            return undefined;
	          case 1:
	            return mode === "auto" ? val[0] : val;
	          default:
	            return val;
	        }
	      }
	      function falsey(val) {
	        return !val;
	      }
	
	      // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	      function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	          if (isArray(val) && val.length === 0) return val;
	          val = arrayWrap(val);
	          var result = map(val, callback);
	          if (allTruthyMode === true) return filter(result, falsey).length === 0;
	          return arrayUnwrap(result);
	        };
	      }
	
	      // Wraps type (.equals) functions to operate on each value of an array
	      function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	          var left = arrayWrap(val1),
	              right = arrayWrap(val2);
	          if (left.length !== right.length) return false;
	          for (var i = 0; i < left.length; i++) {
	            if (!callback(left[i], right[i])) return false;
	          }
	          return true;
	        };
	      }
	
	      this.encode = arrayHandler(bindTo(type, 'encode'));
	      this.decode = arrayHandler(bindTo(type, 'decode'));
	      this.is = arrayHandler(bindTo(type, 'is'), true);
	      this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	      this.pattern = type.pattern;
	      this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	      this.name = type.name;
	      this.$arrayMode = mode;
	    }
	
	    return new ArrayType(this, mode);
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	   * is also available to providers under the name `$urlMatcherFactoryProvider`.
	   */
	  function $UrlMatcherFactory() {
	    $$UMFP = this;
	
	    var isCaseInsensitive = false,
	        isStrictMode = true,
	        defaultSquashPolicy = false;
	
	    // Use tildes to pre-encode slashes.
	    // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	    // and bidirectional encoding/decoding fails.
	    // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	    function valToString(val) {
	      return val != null ? val.toString().replace(/(~|\/)/g, function (m) {
	        return ({ '~': '~~', '/': '~2F' })[m];
	      }) : val;
	    }
	    function valFromString(val) {
	      return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) {
	        return ({ '~~': '~', '~2F': '/' })[m];
	      }) : val;
	    }
	
	    var $types = {},
	        enqueue = true,
	        typeQueue = [],
	        injector,
	        defaultTypes = {
	      "string": {
	        encode: valToString,
	        decode: valFromString,
	        // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	        // In 0.2.x, string params are optional by default for backwards compat
	        is: function is(val) {
	          return val == null || !isDefined(val) || typeof val === "string";
	        },
	        pattern: /[^/]*/
	      },
	      "int": {
	        encode: valToString,
	        decode: function decode(val) {
	          return parseInt(val, 10);
	        },
	        is: function is(val) {
	          return val !== undefined && val !== null && this.decode(val.toString()) === val;
	        },
	        pattern: /\d+/
	      },
	      "bool": {
	        encode: function encode(val) {
	          return val ? 1 : 0;
	        },
	        decode: function decode(val) {
	          return parseInt(val, 10) !== 0;
	        },
	        is: function is(val) {
	          return val === true || val === false;
	        },
	        pattern: /0|1/
	      },
	      "date": {
	        encode: function encode(val) {
	          if (!this.is(val)) return undefined;
	          return [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join("-");
	        },
	        decode: function decode(val) {
	          if (this.is(val)) return val;
	          var match = this.capture.exec(val);
	          return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	        },
	        is: function is(val) {
	          return val instanceof Date && !isNaN(val.valueOf());
	        },
	        equals: function equals(a, b) {
	          return this.is(a) && this.is(b) && a.toISOString() === b.toISOString();
	        },
	        pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	        capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	      },
	      "json": {
	        encode: angular.toJson,
	        decode: angular.fromJson,
	        is: angular.isObject,
	        equals: angular.equals,
	        pattern: /[^/]*/
	      },
	      "any": { // does not encode/decode
	        encode: angular.identity,
	        decode: angular.identity,
	        equals: angular.equals,
	        pattern: /.*/
	      }
	    };
	
	    function getDefaultConfig() {
	      return {
	        strict: isStrictMode,
	        caseInsensitive: isCaseInsensitive
	      };
	    }
	
	    function isInjectable(value) {
	      return isFunction(value) || isArray(value) && isFunction(value[value.length - 1]);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    $UrlMatcherFactory.$$getDefaultValue = function (config) {
	      if (!isInjectable(config.value)) return config.value;
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      return injector.invoke(config.value);
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns {boolean} the current value of caseInsensitive
	     */
	    this.caseInsensitive = function (value) {
	      if (isDefined(value)) isCaseInsensitive = value;
	      return isCaseInsensitive;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#strictMode
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns {boolean} the current value of strictMode
	     */
	    this.strictMode = function (value) {
	      if (isDefined(value)) isStrictMode = value;
	      return isStrictMode;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * @param {string} value A string that defines the default parameter URL squashing behavior.
	     *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *             the parameter value from the URL and replace it with this string.
	     */
	    this.defaultSquashPolicy = function (value) {
	      if (!isDefined(value)) return defaultSquashPolicy;
	      if (value !== true && value !== false && !isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	      defaultSquashPolicy = value;
	      return value;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#compile
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	     *
	     * @param {string} pattern  The URL pattern.
	     * @param {Object} config  The config object hash.
	     * @returns {UrlMatcher}  The UrlMatcher.
	     */
	    this.compile = function (pattern, config) {
	      return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#isMatcher
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	     *
	     * @param {Object} object  The object to perform the type check against.
	     * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    this.isMatcher = function (o) {
	      if (!isObject(o)) return false;
	      var result = true;
	
	      forEach(UrlMatcher.prototype, function (val, name) {
	        if (isFunction(val)) {
	          result = result && isDefined(o[name]) && isFunction(o[name]);
	        }
	      });
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.util.$urlMatcherFactory#type
	     * @methodOf ui.router.util.$urlMatcherFactory
	     *
	     * @description
	     * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	     * generate URLs with typed parameters.
	     *
	     * @param {string} name  The type name.
	     * @param {Object|Function} definition   The type definition. See
	     *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	     * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	     *        runtime starts.  The result of this function is merged into the existing `definition`.
	     *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	     *
	     * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	     *
	     * @example
	     * This is a simple example of a custom type that encodes and decodes items from an
	     * array, using the array index as the URL-encoded value:
	     *
	     * <pre>
	     * var list = ['John', 'Paul', 'George', 'Ringo'];
	     *
	     * $urlMatcherFactoryProvider.type('listItem', {
	     *   encode: function(item) {
	     *     // Represent the list item in the URL using its corresponding index
	     *     return list.indexOf(item);
	     *   },
	     *   decode: function(item) {
	     *     // Look up the list item by index
	     *     return list[parseInt(item, 10)];
	     *   },
	     *   is: function(item) {
	     *     // Ensure the item is valid by checking to see that it appears
	     *     // in the list
	     *     return list.indexOf(item) > -1;
	     *   }
	     * });
	     *
	     * $stateProvider.state('list', {
	     *   url: "/list/{item:listItem}",
	     *   controller: function($scope, $stateParams) {
	     *     console.log($stateParams.item);
	     *   }
	     * });
	     *
	     * // ...
	     *
	     * // Changes URL to '/list/3', logs "Ringo" to the console
	     * $state.go('list', { item: "Ringo" });
	     * </pre>
	     *
	     * This is a more complex example of a type that relies on dependency injection to
	     * interact with services, and uses the parameter name from the URL to infer how to
	     * handle encoding and decoding parameter values:
	     *
	     * <pre>
	     * // Defines a custom type that gets a value from a service,
	     * // where each service gets different types of values from
	     * // a backend API:
	     * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	     *
	     *   // Matches up services to URL parameter names
	     *   var services = {
	     *     user: Users,
	     *     post: Posts
	     *   };
	     *
	     *   return {
	     *     encode: function(object) {
	     *       // Represent the object in the URL using its unique ID
	     *       return object.id;
	     *     },
	     *     decode: function(value, key) {
	     *       // Look up the object by ID, using the parameter
	     *       // name (key) to call the correct service
	     *       return services[key].findById(value);
	     *     },
	     *     is: function(object, key) {
	     *       // Check that object is a valid dbObject
	     *       return angular.isObject(object) && object.id && services[key];
	     *     }
	     *     equals: function(a, b) {
	     *       // Check the equality of decoded objects by comparing
	     *       // their unique IDs
	     *       return a.id === b.id;
	     *     }
	     *   };
	     * });
	     *
	     * // In a config() block, you can then attach URLs with
	     * // type-annotated parameters:
	     * $stateProvider.state('users', {
	     *   url: "/users",
	     *   // ...
	     * }).state('users.item', {
	     *   url: "/{user:dbObject}",
	     *   controller: function($scope, $stateParams) {
	     *     // $stateParams.user will now be an object returned from
	     *     // the Users service
	     *   },
	     *   // ...
	     * });
	     * </pre>
	     */
	    this.type = function (name, definition, definitionFn) {
	      if (!isDefined(definition)) return $types[name];
	      if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	      $types[name] = new Type(extend({ name: name }, definition));
	      if (definitionFn) {
	        typeQueue.push({ name: name, def: definitionFn });
	        if (!enqueue) flushTypeQueue();
	      }
	      return this;
	    };
	
	    // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	    function flushTypeQueue() {
	      while (typeQueue.length) {
	        var type = typeQueue.shift();
	        if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	        angular.extend($types[type.name], injector.invoke(type.def));
	      }
	    }
	
	    // Register default types. Store them in the prototype of $types.
	    forEach(defaultTypes, function (type, name) {
	      $types[name] = new Type(extend({ name: name }, type));
	    });
	    $types = inherit($types, {});
	
	    /* No need to document $get, since it returns this */
	    this.$get = ['$injector', function ($injector) {
	      injector = $injector;
	      enqueue = false;
	      flushTypeQueue();
	
	      forEach(defaultTypes, function (type, name) {
	        if (!$types[name]) $types[name] = new Type(type);
	      });
	      return this;
	    }];
	
	    this.Param = function Param(id, type, config, location) {
	      var self = this;
	      config = unwrapShorthand(config);
	      type = getType(config, type, location);
	      var arrayMode = getArrayMode();
	      type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	      if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined) config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	      var isOptional = config.value !== undefined;
	      var squash = getSquashPolicy(config, isOptional);
	      var replace = getReplace(config, arrayMode, isOptional, squash);
	
	      function unwrapShorthand(config) {
	        var keys = isObject(config) ? objectKeys(config) : [];
	        var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 && indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	        if (isShorthand) config = { value: config };
	        config.$$fn = isInjectable(config.value) ? config.value : function () {
	          return config.value;
	        };
	        return config;
	      }
	
	      function getType(config, urlType, location) {
	        if (config.type && urlType) throw new Error("Param '" + id + "' has two type configurations.");
	        if (urlType) return urlType;
	        if (!config.type) return location === "config" ? $types.any : $types.string;
	
	        if (angular.isString(config.type)) return $types[config.type];
	        if (config.type instanceof Type) return config.type;
	        return new Type(config.type);
	      }
	
	      // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	      function getArrayMode() {
	        var arrayDefaults = { array: location === "search" ? "auto" : false };
	        var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	        return extend(arrayDefaults, arrayParamNomenclature, config).array;
	      }
	
	      /**
	       * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	       */
	      function getSquashPolicy(config, isOptional) {
	        var squash = config.squash;
	        if (!isOptional || squash === false) return false;
	        if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	        if (squash === true || isString(squash)) return squash;
	        throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	      }
	
	      function getReplace(config, arrayMode, isOptional, squash) {
	        var replace,
	            configuredKeys,
	            defaultPolicy = [{ from: "", to: isOptional || arrayMode ? undefined : "" }, { from: null, to: isOptional || arrayMode ? undefined : "" }];
	        replace = isArray(config.replace) ? config.replace : [];
	        if (isString(squash)) replace.push({ from: squash, to: undefined });
	        configuredKeys = map(replace, function (item) {
	          return item.from;
	        });
	        return filter(defaultPolicy, function (item) {
	          return indexOf(configuredKeys, item.from) === -1;
	        }).concat(replace);
	      }
	
	      /**
	       * [Internal] Get the default value of a parameter, which may be an injectable function.
	       */
	      function $$getDefaultValue() {
	        if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	        var defaultValue = injector.invoke(config.$$fn);
	        if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	        return defaultValue;
	      }
	
	      /**
	       * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	       * default value, which may be the result of an injectable function.
	       */
	      function $value(value) {
	        function hasReplaceVal(val) {
	          return function (obj) {
	            return obj.from === val;
	          };
	        }
	        function $replace(value) {
	          var replacement = map(filter(self.replace, hasReplaceVal(value)), function (obj) {
	            return obj.to;
	          });
	          return replacement.length ? replacement[0] : value;
	        }
	        value = $replace(value);
	        return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	      }
	
	      function toString() {
	        return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}";
	      }
	
	      extend(this, {
	        id: id,
	        type: type,
	        location: location,
	        array: arrayMode,
	        squash: squash,
	        replace: replace,
	        isOptional: isOptional,
	        value: $value,
	        dynamic: undefined,
	        config: config,
	        toString: toString
	      });
	    };
	
	    function ParamSet(params) {
	      extend(this, params || {});
	    }
	
	    ParamSet.prototype = {
	      $$new: function $$new() {
	        return inherit(this, extend(new ParamSet(), { $$parent: this }));
	      },
	      $$keys: function $$keys() {
	        var keys = [],
	            chain = [],
	            parent = this,
	            ignore = objectKeys(ParamSet.prototype);
	        while (parent) {
	          chain.push(parent);parent = parent.$$parent;
	        }
	        chain.reverse();
	        forEach(chain, function (paramset) {
	          forEach(objectKeys(paramset), function (key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	          });
	        });
	        return keys;
	      },
	      $$values: function $$values(paramValues) {
	        var values = {},
	            self = this;
	        forEach(self.$$keys(), function (key) {
	          values[key] = self[key].value(paramValues && paramValues[key]);
	        });
	        return values;
	      },
	      $$equals: function $$equals(paramValues1, paramValues2) {
	        var equal = true,
	            self = this;
	        forEach(self.$$keys(), function (key) {
	          var left = paramValues1 && paramValues1[key],
	              right = paramValues2 && paramValues2[key];
	          if (!self[key].type.equals(left, right)) equal = false;
	        });
	        return equal;
	      },
	      $$validates: function $$validate(paramValues) {
	        var keys = this.$$keys(),
	            i,
	            param,
	            rawVal,
	            normalized,
	            encoded;
	        for (i = 0; i < keys.length; i++) {
	          param = this[keys[i]];
	          rawVal = paramValues[keys[i]];
	          if ((rawVal === undefined || rawVal === null) && param.isOptional) break; // There was no parameter value, but the param is optional
	          normalized = param.type.$normalize(rawVal);
	          if (!param.type.is(normalized)) return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	          encoded = param.type.encode(normalized);
	          if (angular.isString(encoded) && !param.type.pattern.exec(encoded)) return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	        }
	        return true;
	      },
	      $$parent: undefined
	    };
	
	    this.ParamSet = ParamSet;
	  }
	
	  // Register as a provider so it's available to other providers
	  angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	  angular.module('ui.router.util').run(['$urlMatcherFactory', function ($urlMatcherFactory) {}]);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider
	   *
	   * @requires ui.router.util.$urlMatcherFactoryProvider
	   * @requires $locationProvider
	   *
	   * @description
	   * `$urlRouterProvider` has the responsibility of watching `$location`. 
	   * When `$location` changes it runs through a list of rules one by one until a 
	   * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	   * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	   *
	   * There are several methods on `$urlRouterProvider` that make it useful to use directly
	   * in your module config.
	   */
	  $UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	  function $UrlRouterProvider($locationProvider, $urlMatcherFactory) {
	    var rules = [],
	        otherwise = null,
	        interceptDeferred = false,
	        listener;
	
	    // Returns a string that is a prefix of all strings matching the RegExp
	    function regExpPrefix(re) {
	      var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	      return prefix != null ? prefix[1].replace(/\\(.)/g, "$1") : '';
	    }
	
	    // Interpolates matched values into a String.replace()-style pattern
	    function interpolate(pattern, match) {
	      return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	        return match[what === '$' ? 0 : Number(what)];
	      });
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#rule
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Defines rules that are used by `$urlRouterProvider` to find matches for
	     * specific URLs.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // Here's an example of how you might allow case insensitive urls
	     *   $urlRouterProvider.rule(function ($injector, $location) {
	     *     var path = $location.path(),
	     *         normalized = path.toLowerCase();
	     *
	     *     if (path !== normalized) {
	     *       return normalized;
	     *     }
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {function} rule Handler function that takes `$injector` and `$location`
	     * services as arguments. You can use them to return a valid path as a string.
	     *
	     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	     */
	    this.rule = function (rule) {
	      if (!isFunction(rule)) throw new Error("'rule' must be a function");
	      rules.push(rule);
	      return this;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.router.$urlRouterProvider#otherwise
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Defines a path that is used when an invalid route is requested.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   // if the path doesn't match any of the urls you configured
	     *   // otherwise will take care of routing the user to the
	     *   // specified url
	     *   $urlRouterProvider.otherwise('/index');
	     *
	     *   // Example of using function rule as param
	     *   $urlRouterProvider.otherwise(function ($injector, $location) {
	     *     return '/a/valid/url';
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {string|function} rule The url path you want to redirect to or a function 
	     * rule that returns the url path. The function version is passed two params: 
	     * `$injector` and `$location` services, and must return a url string.
	     *
	     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	     */
	    this.otherwise = function (rule) {
	      if (isString(rule)) {
	        var redirect = rule;
	        rule = function () {
	          return redirect;
	        };
	      } else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	      otherwise = rule;
	      return this;
	    };
	
	    function handleIfMatch($injector, handler, match) {
	      if (!match) return false;
	      var result = $injector.invoke(handler, handler, { $match: match });
	      return isDefined(result) ? result : true;
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#when
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Registers a handler for a given url matching. 
	     * 
	     * If the handler is a string, it is
	     * treated as a redirect, and is interpolated according to the syntax of match
	     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	     *
	     * If the handler is a function, it is injectable. It gets invoked if `$location`
	     * matches. You have the option of inject the match object as `$match`.
	     *
	     * The handler can return
	     *
	     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	     *   will continue trying to find another one that matches.
	     * - **string** which is treated as a redirect and passed to `$location.url()`
	     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	     *     if ($state.$current.navigable !== state ||
	     *         !equalForKeys($match, $stateParams) {
	     *      $state.transitionTo(state, $match, false);
	     *     }
	     *   });
	     * });
	     * </pre>
	     *
	     * @param {string|object} what The incoming path that you want to redirect.
	     * @param {string|function} handler The path you want to redirect your user to.
	     */
	    this.when = function (what, handler) {
	      var redirect,
	          handlerIsString = isString(handler);
	      if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	      if (!handlerIsString && !isFunction(handler) && !isArray(handler)) throw new Error("invalid 'handler' in when()");
	
	      var strategies = {
	        matcher: function matcher(what, handler) {
	          if (handlerIsString) {
	            redirect = $urlMatcherFactory.compile(handler);
	            handler = ['$match', function ($match) {
	              return redirect.format($match);
	            }];
	          }
	          return extend(function ($injector, $location) {
	            return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	          }, {
	            prefix: isString(what.prefix) ? what.prefix : ''
	          });
	        },
	        regex: function regex(what, handler) {
	          if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	          if (handlerIsString) {
	            redirect = handler;
	            handler = ['$match', function ($match) {
	              return interpolate(redirect, $match);
	            }];
	          }
	          return extend(function ($injector, $location) {
	            return handleIfMatch($injector, handler, what.exec($location.path()));
	          }, {
	            prefix: regExpPrefix(what)
	          });
	        }
	      };
	
	      var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	      for (var n in check) {
	        if (check[n]) return this.rule(strategies[n](what, handler));
	      }
	
	      throw new Error("invalid 'what' in when()");
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.router.$urlRouterProvider#deferIntercept
	     * @methodOf ui.router.router.$urlRouterProvider
	     *
	     * @description
	     * Disables (or enables) deferring location change interception.
	     *
	     * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	     * defer a transition but maintain the current URL), call this method at configuration time.
	     * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	     * `$locationChangeSuccess` event handler.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router.router']);
	     *
	     * app.config(function ($urlRouterProvider) {
	     *
	     *   // Prevent $urlRouter from automatically intercepting URL changes;
	     *   // this allows you to configure custom behavior in between
	     *   // location changes and route synchronization:
	     *   $urlRouterProvider.deferIntercept();
	     *
	     * }).run(function ($rootScope, $urlRouter, UserService) {
	     *
	     *   $rootScope.$on('$locationChangeSuccess', function(e) {
	     *     // UserService is an example service for managing user state
	     *     if (UserService.isLoggedIn()) return;
	     *
	     *     // Prevent $urlRouter's default handler from firing
	     *     e.preventDefault();
	     *
	     *     UserService.handleLogin().then(function() {
	     *       // Once the user has logged in, sync the current URL
	     *       // to the router:
	     *       $urlRouter.sync();
	     *     });
	     *   });
	     *
	     *   // Configures $urlRouter's listener *after* your custom listener
	     *   $urlRouter.listen();
	     * });
	     * </pre>
	     *
	     * @param {boolean} defer Indicates whether to defer location change interception. Passing
	              no parameter is equivalent to `true`.
	     */
	    this.deferIntercept = function (defer) {
	      if (defer === undefined) defer = true;
	      interceptDeferred = defer;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.router.$urlRouter
	     *
	     * @requires $location
	     * @requires $rootScope
	     * @requires $injector
	     * @requires $browser
	     *
	     * @description
	     *
	     */
	    this.$get = $get;
	    $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	    function $get($location, $rootScope, $injector, $browser, $sniffer) {
	
	      var baseHref = $browser.baseHref(),
	          location = $location.url(),
	          lastPushedUrl;
	
	      function appendBasePath(url, isHtml5, absolute) {
	        if (baseHref === '/') return url;
	        if (isHtml5) return baseHref.slice(0, -1) + url;
	        if (absolute) return baseHref.slice(1) + url;
	        return url;
	      }
	
	      // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	      function update(evt) {
	        if (evt && evt.defaultPrevented) return;
	        var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	        lastPushedUrl = undefined;
	        // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	        //if (ignoreUpdate) return true;
	
	        function check(rule) {
	          var handled = rule($injector, $location);
	
	          if (!handled) return false;
	          if (isString(handled)) $location.replace().url(handled);
	          return true;
	        }
	        var n = rules.length,
	            i;
	
	        for (i = 0; i < n; i++) {
	          if (check(rules[i])) return;
	        }
	        // always check otherwise last to allow dynamic updates to the set of rules
	        if (otherwise) check(otherwise);
	      }
	
	      function _listen() {
	        listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	        return listener;
	      }
	
	      if (!interceptDeferred) _listen();
	
	      return {
	        /**
	         * @ngdoc function
	         * @name ui.router.router.$urlRouter#sync
	         * @methodOf ui.router.router.$urlRouter
	         *
	         * @description
	         * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	         * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	         * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	         * with the transition by calling `$urlRouter.sync()`.
	         *
	         * @example
	         * <pre>
	         * angular.module('app', ['ui.router'])
	         *   .run(function($rootScope, $urlRouter) {
	         *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	         *       // Halt state change from even starting
	         *       evt.preventDefault();
	         *       // Perform custom logic
	         *       var meetsRequirement = ...
	         *       // Continue with the update and state transition if logic allows
	         *       if (meetsRequirement) $urlRouter.sync();
	         *     });
	         * });
	         * </pre>
	         */
	        sync: function sync() {
	          update();
	        },
	
	        listen: function listen() {
	          return _listen();
	        },
	
	        update: function update(read) {
	          if (read) {
	            location = $location.url();
	            return;
	          }
	          if ($location.url() === location) return;
	
	          $location.url(location);
	          $location.replace();
	        },
	
	        push: function push(urlMatcher, params, options) {
	          var url = urlMatcher.format(params || {});
	
	          // Handle the special hash param, if needed
	          if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	          }
	
	          $location.url(url);
	          lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	          if (options && options.replace) $location.replace();
	        },
	
	        /**
	         * @ngdoc function
	         * @name ui.router.router.$urlRouter#href
	         * @methodOf ui.router.router.$urlRouter
	         *
	         * @description
	         * A URL generation method that returns the compiled URL for a given
	         * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	         *
	         * @example
	         * <pre>
	         * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	         *   person: "bob"
	         * });
	         * // $bob == "/about/bob";
	         * </pre>
	         *
	         * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	         * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	         * @param {object=} options Options object. The options are:
	         *
	         * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	         *
	         * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	         */
	        href: function href(urlMatcher, params, options) {
	          if (!urlMatcher.validates(params)) return null;
	
	          var isHtml5 = $locationProvider.html5Mode();
	          if (angular.isObject(isHtml5)) {
	            isHtml5 = isHtml5.enabled;
	          }
	
	          isHtml5 = isHtml5 && $sniffer.history;
	
	          var url = urlMatcher.format(params);
	          options = options || {};
	
	          if (!isHtml5 && url !== null) {
	            url = "#" + $locationProvider.hashPrefix() + url;
	          }
	
	          // Handle special hash param, if needed
	          if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	          }
	
	          url = appendBasePath(url, isHtml5, options.absolute);
	
	          if (!options.absolute || !url) {
	            return url;
	          }
	
	          var slash = !isHtml5 && url ? '/' : '',
	              port = $location.port();
	          port = port === 80 || port === 443 ? '' : ':' + port;
	
	          return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	        }
	      };
	    }
	  }
	
	  angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$stateProvider
	   *
	   * @requires ui.router.router.$urlRouterProvider
	   * @requires ui.router.util.$urlMatcherFactoryProvider
	   *
	   * @description
	   * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	   * on state.
	   *
	   * A state corresponds to a "place" in the application in terms of the overall UI and
	   * navigation. A state describes (via the controller / template / view properties) what
	   * the UI looks like and does at that place.
	   *
	   * States often have things in common, and the primary way of factoring out these
	   * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	   * nested states.
	   *
	   * The `$stateProvider` provides interfaces to declare these states for your app.
	   */
	  $StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	  function $StateProvider($urlRouterProvider, $urlMatcherFactory) {
	
	    var root,
	        states = {},
	        $state,
	        queue = {},
	        abstractKey = 'abstract';
	
	    // Builds state properties from definition passed to registerState()
	    var stateBuilder = {
	
	      // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	      // state.children = [];
	      // if (parent) parent.children.push(state);
	      parent: function parent(state) {
	        if (isDefined(state.parent) && state.parent) return findState(state.parent);
	        // regex matches any valid composite state name
	        // would match "contact.list" but not "contacts"
	        var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	        return compositeName ? findState(compositeName[1]) : root;
	      },
	
	      // inherit 'data' from parent and override by own values (if any)
	      data: function data(state) {
	        if (state.parent && state.parent.data) {
	          state.data = state.self.data = inherit(state.parent.data, state.data);
	        }
	        return state.data;
	      },
	
	      // Build a URLMatcher if necessary, either via a relative or absolute URL
	      url: function url(state) {
	        var url = state.url,
	            config = { params: state.params || {} };
	
	        if (isString(url)) {
	          if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	          return (state.parent.navigable || root).url.concat(url, config);
	        }
	
	        if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	        throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	      },
	
	      // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	      navigable: function navigable(state) {
	        return state.url ? state : state.parent ? state.parent.navigable : null;
	      },
	
	      // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	      ownParams: function ownParams(state) {
	        var params = state.url && state.url.params || new $$UMFP.ParamSet();
	        forEach(state.params || {}, function (config, id) {
	          if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	        });
	        return params;
	      },
	
	      // Derive parameters for this state and ensure they're a super-set of parent's parameters
	      params: function params(state) {
	        var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	        return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	      },
	
	      // If there is no explicit multi-view configuration, make one up so we don't have
	      // to handle both cases in the view directive later. Note that having an explicit
	      // 'views' property will mean the default unnamed view properties are ignored. This
	      // is also a good time to resolve view names to absolute names, so everything is a
	      // straight lookup at link time.
	      views: function views(state) {
	        var views = {};
	
	        forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	          if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	          view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	          views[name] = view;
	        });
	        return views;
	      },
	
	      // Keep a full path from the root down to this state as this is needed for state activation.
	      path: function path(state) {
	        return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	      },
	
	      // Speed up $state.contains() as it's used a lot
	      includes: function includes(state) {
	        var includes = state.parent ? extend({}, state.parent.includes) : {};
	        includes[state.name] = true;
	        return includes;
	      },
	
	      $delegates: {}
	    };
	
	    function isRelative(stateName) {
	      return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	    }
	
	    function findState(stateOrName, base) {
	      if (!stateOrName) return undefined;
	
	      var isStr = isString(stateOrName),
	          name = isStr ? stateOrName : stateOrName.name,
	          path = isRelative(name);
	
	      if (path) {
	        if (!base) throw new Error("No reference point given for path '" + name + "'");
	        base = findState(base);
	
	        var rel = name.split("."),
	            i = 0,
	            pathLength = rel.length,
	            current = base;
	
	        for (; i < pathLength; i++) {
	          if (rel[i] === "" && i === 0) {
	            current = base;
	            continue;
	          }
	          if (rel[i] === "^") {
	            if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	            current = current.parent;
	            continue;
	          }
	          break;
	        }
	        rel = rel.slice(i).join(".");
	        name = current.name + (current.name && rel ? "." : "") + rel;
	      }
	      var state = states[name];
	
	      if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) {
	        return state;
	      }
	      return undefined;
	    }
	
	    function queueState(parentName, state) {
	      if (!queue[parentName]) {
	        queue[parentName] = [];
	      }
	      queue[parentName].push(state);
	    }
	
	    function flushQueuedChildren(parentName) {
	      var queued = queue[parentName] || [];
	      while (queued.length) {
	        registerState(queued.shift());
	      }
	    }
	
	    function registerState(state) {
	      // Wrap a new object around the state so we can store our private details easily.
	      state = inherit(state, {
	        self: state,
	        resolve: state.resolve || {},
	        toString: function toString() {
	          return this.name;
	        }
	      });
	
	      var name = state.name;
	      if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	      if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	      // Get parent name
	      var parentName = name.indexOf('.') !== -1 ? name.substring(0, name.lastIndexOf('.')) : isString(state.parent) ? state.parent : isObject(state.parent) && isString(state.parent.name) ? state.parent.name : '';
	
	      // If parent is not registered yet, add state to queue and register later
	      if (parentName && !states[parentName]) {
	        return queueState(parentName, state.self);
	      }
	
	      for (var key in stateBuilder) {
	        if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	      }
	      states[name] = state;
	
	      // Register the state in the global state list and with $urlRouter if necessary.
	      if (!state[abstractKey] && state.url) {
	        $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	          if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	            $state.transitionTo(state, $match, { inherit: true, location: false });
	          }
	        }]);
	      }
	
	      // Register any queued children
	      flushQueuedChildren(name);
	
	      return state;
	    }
	
	    // Checks text to see if it looks like a glob.
	    function isGlob(text) {
	      return text.indexOf('*') > -1;
	    }
	
	    // Returns true if glob matches current $state name.
	    function doesStateMatchGlob(glob) {
	      var globSegments = glob.split('.'),
	          segments = $state.$current.name.split('.');
	
	      //match single stars
	      for (var i = 0, l = globSegments.length; i < l; i++) {
	        if (globSegments[i] === '*') {
	          segments[i] = '*';
	        }
	      }
	
	      //match greedy starts
	      if (globSegments[0] === '**') {
	        segments = segments.slice(indexOf(segments, globSegments[1]));
	        segments.unshift('**');
	      }
	      //match greedy ends
	      if (globSegments[globSegments.length - 1] === '**') {
	        segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	        segments.push('**');
	      }
	
	      if (globSegments.length != segments.length) {
	        return false;
	      }
	
	      return segments.join('') === globSegments.join('');
	    }
	
	    // Implicit root state that is always active
	    root = registerState({
	      name: '',
	      url: '^',
	      views: null,
	      'abstract': true
	    });
	    root.navigable = null;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$stateProvider#decorator
	     * @methodOf ui.router.state.$stateProvider
	     *
	     * @description
	     * Allows you to extend (carefully) or override (at your own peril) the 
	     * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	     * to add custom functionality to ui-router, for example inferring templateUrl 
	     * based on the state name.
	     *
	     * When passing only a name, it returns the current (original or decorated) builder
	     * function that matches `name`.
	     *
	     * The builder functions that can be decorated are listed below. Though not all
	     * necessarily have a good use case for decoration, that is up to you to decide.
	     *
	     * In addition, users can attach custom decorators, which will generate new 
	     * properties within the state's internal definition. There is currently no clear 
	     * use-case for this beyond accessing internal states (i.e. $state.$current), 
	     * however, expect this to become increasingly relevant as we introduce additional 
	     * meta-programming features.
	     *
	     * **Warning**: Decorators should not be interdependent because the order of 
	     * execution of the builder functions in non-deterministic. Builder functions 
	     * should only be dependent on the state definition object and super function.
	     *
	     *
	     * Existing builder functions and current return values:
	     *
	     * - **parent** `{object}` - returns the parent state object.
	     * - **data** `{object}` - returns state data, including any inherited data that is not
	     *   overridden by own values (if any).
	     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	     *   or `null`.
	     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	     *   navigable).
	     * - **params** `{object}` - returns an array of state params that are ensured to 
	     *   be a super-set of parent's params.
	     * - **views** `{object}` - returns a views object where each key is an absolute view 
	     *   name (i.e. "viewName@stateName") and each value is the config object 
	     *   (template, controller) for the view. Even when you don't use the views object 
	     *   explicitly on a state config, one is still created for you internally.
	     *   So by decorating this builder function you have access to decorating template 
	     *   and controller properties.
	     * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	     *   not including any params defined by ancestor states.
	     * - **path** `{string}` - returns the full path from the root down to this state. 
	     *   Needed for state activation.
	     * - **includes** `{object}` - returns an object that includes every state that 
	     *   would pass a `$state.includes()` test.
	     *
	     * @example
	     * <pre>
	     * // Override the internal 'views' builder with a function that takes the state
	     * // definition, and a reference to the internal function being overridden:
	     * $stateProvider.decorator('views', function (state, parent) {
	     *   var result = {},
	     *       views = parent(state);
	     *
	     *   angular.forEach(views, function (config, name) {
	     *     var autoName = (state.name + '.' + name).replace('.', '/');
	     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	     *     result[name] = config;
	     *   });
	     *   return result;
	     * });
	     *
	     * $stateProvider.state('home', {
	     *   views: {
	     *     'contact.list': { controller: 'ListController' },
	     *     'contact.item': { controller: 'ItemController' }
	     *   }
	     * });
	     *
	     * // ...
	     *
	     * $state.go('home');
	     * // Auto-populates list and item views with /partials/home/contact/list.html,
	     * // and /partials/home/contact/item.html, respectively.
	     * </pre>
	     *
	     * @param {string} name The name of the builder function to decorate. 
	     * @param {object} func A function that is responsible for decorating the original 
	     * builder function. The function receives two parameters:
	     *
	     *   - `{object}` - state - The state config object.
	     *   - `{object}` - super - The original builder function.
	     *
	     * @return {object} $stateProvider - $stateProvider instance
	     */
	    this.decorator = decorator;
	    function decorator(name, func) {
	      /*jshint validthis: true */
	      if (isString(name) && !isDefined(func)) {
	        return stateBuilder[name];
	      }
	      if (!isFunction(func) || !isString(name)) {
	        return this;
	      }
	      if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	        stateBuilder.$delegates[name] = stateBuilder[name];
	      }
	      stateBuilder[name] = func;
	      return this;
	    }
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$stateProvider#state
	     * @methodOf ui.router.state.$stateProvider
	     *
	     * @description
	     * Registers a state configuration under a given state name. The stateConfig object
	     * has the following acceptable properties.
	     *
	     * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	     * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	     * @param {object} stateConfig State configuration object.
	     * @param {string|function=} stateConfig.template
	     * <a id='template'></a>
	     *   html template as a string or a function that returns
	     *   an html template as a string which should be used by the uiView directives. This property 
	     *   takes precedence over templateUrl.
	     *   
	     *   If `template` is a function, it will be called with the following parameters:
	     *
	     *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	     *     applying the current state
	     *
	     * <pre>template:
	     *   "<h1>inline template definition</h1>" +
	     *   "<div ui-view></div>"</pre>
	     * <pre>template: function(params) {
	     *       return "<h1>generated template</h1>"; }</pre>
	     * </div>
	     *
	     * @param {string|function=} stateConfig.templateUrl
	     * <a id='templateUrl'></a>
	     *
	     *   path or function that returns a path to an html
	     *   template that should be used by uiView.
	     *   
	     *   If `templateUrl` is a function, it will be called with the following parameters:
	     *
	     *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	     *     applying the current state
	     *
	     * <pre>templateUrl: "home.html"</pre>
	     * <pre>templateUrl: function(params) {
	     *     return myTemplates[params.pageId]; }</pre>
	     *
	     * @param {function=} stateConfig.templateProvider
	     * <a id='templateProvider'></a>
	     *    Provider function that returns HTML content string.
	     * <pre> templateProvider:
	     *       function(MyTemplateService, params) {
	     *         return MyTemplateService.getTemplate(params.pageId);
	     *       }</pre>
	     *
	     * @param {string|function=} stateConfig.controller
	     * <a id='controller'></a>
	     *
	     *  Controller fn that should be associated with newly
	     *   related scope or the name of a registered controller if passed as a string.
	     *   Optionally, the ControllerAs may be declared here.
	     * <pre>controller: "MyRegisteredController"</pre>
	     * <pre>controller:
	     *     "MyRegisteredController as fooCtrl"}</pre>
	     * <pre>controller: function($scope, MyService) {
	     *     $scope.data = MyService.getData(); }</pre>
	     *
	     * @param {function=} stateConfig.controllerProvider
	     * <a id='controllerProvider'></a>
	     *
	     * Injectable provider function that returns the actual controller or string.
	     * <pre>controllerProvider:
	     *   function(MyResolveData) {
	     *     if (MyResolveData.foo)
	     *       return "FooCtrl"
	     *     else if (MyResolveData.bar)
	     *       return "BarCtrl";
	     *     else return function($scope) {
	     *       $scope.baz = "Qux";
	     *     }
	     *   }</pre>
	     *
	     * @param {string=} stateConfig.controllerAs
	     * <a id='controllerAs'></a>
	     * 
	     * A controller alias name. If present the controller will be
	     *   published to scope under the controllerAs name.
	     * <pre>controllerAs: "myCtrl"</pre>
	     *
	     * @param {string|object=} stateConfig.parent
	     * <a id='parent'></a>
	     * Optionally specifies the parent state of this state.
	     *
	     * <pre>parent: 'parentState'</pre>
	     * <pre>parent: parentState // JS variable</pre>
	     *
	     * @param {object=} stateConfig.resolve
	     * <a id='resolve'></a>
	     *
	     * An optional map&lt;string, function&gt; of dependencies which
	     *   should be injected into the controller. If any of these dependencies are promises, 
	     *   the router will wait for them all to be resolved before the controller is instantiated.
	     *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	     *   and the values of the resolved promises are injected into any controllers that reference them.
	     *   If any  of the promises are rejected the $stateChangeError event is fired.
	     *
	     *   The map object is:
	     *   
	     *   - key - {string}: name of dependency to be injected into controller
	     *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	     *     it is injected and return value it treated as dependency. If result is a promise, it is 
	     *     resolved before its value is injected into controller.
	     *
	     * <pre>resolve: {
	     *     myResolve1:
	     *       function($http, $stateParams) {
	     *         return $http.get("/api/foos/"+stateParams.fooID);
	     *       }
	     *     }</pre>
	     *
	     * @param {string=} stateConfig.url
	     * <a id='url'></a>
	     *
	     *   A url fragment with optional parameters. When a state is navigated or
	     *   transitioned to, the `$stateParams` service will be populated with any 
	     *   parameters that were passed.
	     *
	     *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	     *   more details on acceptable patterns )
	     *
	     * examples:
	     * <pre>url: "/home"
	     * url: "/users/:userid"
	     * url: "/books/{bookid:[a-zA-Z_-]}"
	     * url: "/books/{categoryid:int}"
	     * url: "/books/{publishername:string}/{categoryid:int}"
	     * url: "/messages?before&after"
	     * url: "/messages?{before:date}&{after:date}"
	     * url: "/messages/:mailboxid?{before:date}&{after:date}"
	     * </pre>
	     *
	     * @param {object=} stateConfig.views
	     * <a id='views'></a>
	     * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	     * manually/explicitly.
	     *
	     * Examples:
	     *
	     * Targets three named `ui-view`s in the parent state's template
	     * <pre>views: {
	     *     header: {
	     *       controller: "headerCtrl",
	     *       templateUrl: "header.html"
	     *     }, body: {
	     *       controller: "bodyCtrl",
	     *       templateUrl: "body.html"
	     *     }, footer: {
	     *       controller: "footCtrl",
	     *       templateUrl: "footer.html"
	     *     }
	     *   }</pre>
	     *
	     * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	     * <pre>views: {
	     *     'header@top': {
	     *       controller: "msgHeaderCtrl",
	     *       templateUrl: "msgHeader.html"
	     *     }, 'body': {
	     *       controller: "messagesCtrl",
	     *       templateUrl: "messages.html"
	     *     }
	     *   }</pre>
	     *
	     * @param {boolean=} [stateConfig.abstract=false]
	     * <a id='abstract'></a>
	     * An abstract state will never be directly activated,
	     *   but can provide inherited properties to its common children states.
	     * <pre>abstract: true</pre>
	     *
	     * @param {function=} stateConfig.onEnter
	     * <a id='onEnter'></a>
	     *
	     * Callback function for when a state is entered. Good way
	     *   to trigger an action or dispatch an event, such as opening a dialog.
	     * If minifying your scripts, make sure to explicitly annotate this function,
	     * because it won't be automatically annotated by your build tools.
	     *
	     * <pre>onEnter: function(MyService, $stateParams) {
	     *     MyService.foo($stateParams.myParam);
	     * }</pre>
	     *
	     * @param {function=} stateConfig.onExit
	     * <a id='onExit'></a>
	     *
	     * Callback function for when a state is exited. Good way to
	     *   trigger an action or dispatch an event, such as opening a dialog.
	     * If minifying your scripts, make sure to explicitly annotate this function,
	     * because it won't be automatically annotated by your build tools.
	     *
	     * <pre>onExit: function(MyService, $stateParams) {
	     *     MyService.cleanup($stateParams.myParam);
	     * }</pre>
	     *
	     * @param {boolean=} [stateConfig.reloadOnSearch=true]
	     * <a id='reloadOnSearch'></a>
	     *
	     * If `false`, will not retrigger the same state
	     *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	     *   Useful for when you'd like to modify $location.search() without triggering a reload.
	     * <pre>reloadOnSearch: false</pre>
	     *
	     * @param {object=} stateConfig.data
	     * <a id='data'></a>
	     *
	     * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	     *   prototypally inherited.  In other words, adding a data property to a state adds it to
	     *   the entire subtree via prototypal inheritance.
	     *
	     * <pre>data: {
	     *     requiredRole: 'foo'
	     * } </pre>
	     *
	     * @param {object=} stateConfig.params
	     * <a id='params'></a>
	     *
	     * A map which optionally configures parameters declared in the `url`, or
	     *   defines additional non-url parameters.  For each parameter being
	     *   configured, add a configuration object keyed to the name of the parameter.
	     *
	     *   Each parameter configuration object may contain the following properties:
	     *
	     *   - ** value ** - {object|function=}: specifies the default value for this
	     *     parameter.  This implicitly sets this parameter as optional.
	     *
	     *     When UI-Router routes to a state and no value is
	     *     specified for this parameter in the URL or transition, the
	     *     default value will be used instead.  If `value` is a function,
	     *     it will be injected and invoked, and the return value used.
	     *
	     *     *Note*: `undefined` is treated as "no default value" while `null`
	     *     is treated as "the default value is `null`".
	     *
	     *     *Shorthand*: If you only need to configure the default value of the
	     *     parameter, you may use a shorthand syntax.   In the **`params`**
	     *     map, instead mapping the param name to a full parameter configuration
	     *     object, simply set map it to the default parameter value, e.g.:
	     *
	     * <pre>// define a parameter's default value
	     * params: {
	     *     param1: { value: "defaultValue" }
	     * }
	     * // shorthand default values
	     * params: {
	     *     param1: "defaultValue",
	     *     param2: "param2Default"
	     * }</pre>
	     *
	     *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	     *     treated as an array of values.  If you specified a Type, the value will be
	     *     treated as an array of the specified Type.  Note: query parameter values
	     *     default to a special `"auto"` mode.
	     *
	     *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	     *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	     *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	     *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	     *     value (e.g.: `{ foo: '1' }`).
	     *
	     * <pre>params: {
	     *     param1: { array: true }
	     * }</pre>
	     *
	     *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	     *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	     *     configured default squash policy.
	     *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	     *
	     *   There are three squash settings:
	     *
	     *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	     *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	     *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	     *       This can allow for cleaner looking URLs.
	     *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	     *
	     * <pre>params: {
	     *     param1: {
	     *       value: "defaultId",
	     *       squash: true
	     * } }
	     * // squash "defaultValue" to "~"
	     * params: {
	     *     param1: {
	     *       value: "defaultValue",
	     *       squash: "~"
	     * } }
	     * </pre>
	     *
	     *
	     * @example
	     * <pre>
	     * // Some state name examples
	     *
	     * // stateName can be a single top-level name (must be unique).
	     * $stateProvider.state("home", {});
	     *
	     * // Or it can be a nested state name. This state is a child of the
	     * // above "home" state.
	     * $stateProvider.state("home.newest", {});
	     *
	     * // Nest states as deeply as needed.
	     * $stateProvider.state("home.newest.abc.xyz.inception", {});
	     *
	     * // state() returns $stateProvider, so you can chain state declarations.
	     * $stateProvider
	     *   .state("home", {})
	     *   .state("about", {})
	     *   .state("contacts", {});
	     * </pre>
	     *
	     */
	    this.state = state;
	    function state(name, definition) {
	      /*jshint validthis: true */
	      if (isObject(name)) definition = name;else definition.name = name;
	      registerState(definition);
	      return this;
	    }
	
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$state
	     *
	     * @requires $rootScope
	     * @requires $q
	     * @requires ui.router.state.$view
	     * @requires $injector
	     * @requires ui.router.util.$resolve
	     * @requires ui.router.state.$stateParams
	     * @requires ui.router.router.$urlRouter
	     *
	     * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	     * you'd like to test against the current active state.
	     * @property {object} current A reference to the state's config object. However 
	     * you passed it in. Useful for accessing custom data.
	     * @property {object} transition Currently pending transition. A promise that'll 
	     * resolve or reject.
	     *
	     * @description
	     * `$state` service is responsible for representing states as well as transitioning
	     * between them. It also provides interfaces to ask for current state or even states
	     * you're coming from.
	     */
	    this.$get = $get;
	    $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	    function $get($rootScope, $q, $view, $injector, $resolve, $stateParams, $urlRouter, $location, $urlMatcherFactory) {
	
	      var TransitionSupersededError = new Error('transition superseded');
	
	      var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	      var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	      var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	      var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	      // Handles the case where a state which is the target of a transition is not found, and the user
	      // can optionally retry or defer the transition
	      function handleRedirect(redirect, state, params, options) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateNotFound
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when a requested state **cannot be found** using the provided state name during transition.
	         * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	         * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	         * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	         * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	         * @param {State} fromState Current state object.
	         * @param {Object} fromParams Current state params.
	         *
	         * @example
	         *
	         * <pre>
	         * // somewhere, assume lazy.state has not been defined
	         * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	         *
	         * // somewhere else
	         * $scope.$on('$stateNotFound',
	         * function(event, unfoundState, fromState, fromParams){
	         *     console.log(unfoundState.to); // "lazy.state"
	         *     console.log(unfoundState.toParams); // {a:1, b:2}
	         *     console.log(unfoundState.options); // {inherit:false} + default options
	         * })
	         * </pre>
	         */
	        var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	        if (evt.defaultPrevented) {
	          $urlRouter.update();
	          return TransitionAborted;
	        }
	
	        if (!evt.retry) {
	          return null;
	        }
	
	        // Allow the handler to return a promise to defer state lookup retry
	        if (options.$retry) {
	          $urlRouter.update();
	          return TransitionFailed;
	        }
	        var retryTransition = $state.transition = $q.when(evt.retry);
	
	        retryTransition.then(function () {
	          if (retryTransition !== $state.transition) {
	            $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	            return TransitionSuperseded;
	          }
	          redirect.options.$retry = true;
	          return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	        }, function () {
	          return TransitionAborted;
	        });
	        $urlRouter.update();
	
	        return retryTransition;
	      }
	
	      root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	      $state = {
	        params: {},
	        current: root.self,
	        $current: root,
	        transition: null
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#reload
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A method that force reloads the current state. All resolves are re-resolved,
	       * controllers reinstantiated, and events re-fired.
	       *
	       * @example
	       * <pre>
	       * var app angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.reload = function(){
	       *     $state.reload();
	       *   }
	       * });
	       * </pre>
	       *
	       * `reload()` is just an alias for:
	       * <pre>
	       * $state.transitionTo($state.current, $stateParams, { 
	       *   reload: true, inherit: false, notify: true
	       * });
	       * </pre>
	       *
	       * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	       * @example
	       * <pre>
	       * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	       * //and current state is 'contacts.detail.item'
	       * var app angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.reload = function(){
	       *     //will reload 'contact.detail' and 'contact.detail.item' states
	       *     $state.reload('contact.detail');
	       *   }
	       * });
	       * </pre>
	       *
	       * `reload()` is just an alias for:
	       * <pre>
	       * $state.transitionTo($state.current, $stateParams, { 
	       *   reload: true, inherit: false, notify: true
	       * });
	       * </pre>
	        * @returns {promise} A promise representing the state of the new transition. See
	       * {@link ui.router.state.$state#methods_go $state.go}.
	       */
	      $state.reload = function reload(state) {
	        return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true });
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#go
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Convenience method for transitioning to a new state. `$state.go` calls 
	       * `$state.transitionTo` internally but automatically sets options to 
	       * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	       * This allows you to easily use an absolute or relative to path and specify 
	       * only the parameters you'd like to update (while letting unspecified parameters 
	       * inherit from the currently active ancestor states).
	       *
	       * @example
	       * <pre>
	       * var app = angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.changeState = function () {
	       *     $state.go('contact.detail');
	       *   };
	       * });
	       * </pre>
	       * <img src='../ngdoc_assets/StateGoExamples.png'/>
	       *
	       * @param {string} to Absolute state name or relative state path. Some examples:
	       *
	       * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	       * - `$state.go('^')` - will go to a parent state
	       * - `$state.go('^.sibling')` - will go to a sibling state
	       * - `$state.go('.child.grandchild')` - will go to grandchild state
	       *
	       * @param {object=} params A map of the parameters that will be sent to the state, 
	       * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	       * defined parameters. Only parameters specified in the state definition can be overridden, new 
	       * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	       * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	       * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	       * will get you all current parameters, etc.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	       *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	       * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	       * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	       *    have changed.  It will reload the resolves and views of the current state and parent states.
	       *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	       *    the transition reloads the resolves and views for that matched state, and all its children states.
	       *
	       * @returns {promise} A promise representing the state of the new transition.
	       *
	       * Possible success values:
	       *
	       * - $state.current
	       *
	       * <br/>Possible rejection values:
	       *
	       * - 'transition superseded' - when a newer transition has been started after this one
	       * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	       * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	       *   when a `$stateNotFound` `event.retry` promise errors.
	       * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	       * - *resolve error* - when an error has occurred with a `resolve`
	       *
	       */
	      $state.go = function go(to, params, options) {
	        return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#transitionTo
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	       * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	       *
	       * @example
	       * <pre>
	       * var app = angular.module('app', ['ui.router']);
	       *
	       * app.controller('ctrl', function ($scope, $state) {
	       *   $scope.changeState = function () {
	       *     $state.transitionTo('contact.detail');
	       *   };
	       * });
	       * </pre>
	       *
	       * @param {string} to State name.
	       * @param {object=} toParams A map of the parameters that will be sent to the state,
	       * will populate $stateParams.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	       *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	       * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	       * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	       *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	       *    use this when you want to force a reload when *everything* is the same, including search params.
	       *    if String, then will reload the state with the name given in reload, and any children.
	       *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	       *
	       * @returns {promise} A promise representing the state of the new transition. See
	       * {@link ui.router.state.$state#methods_go $state.go}.
	       */
	      $state.transitionTo = function transitionTo(to, toParams, options) {
	        toParams = toParams || {};
	        options = extend({
	          location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	        }, options || {});
	
	        var from = $state.$current,
	            fromParams = $state.params,
	            fromPath = from.path;
	        var evt,
	            toState = findState(to, options.relative);
	
	        // Store the hash param for later (since it will be stripped out by various methods)
	        var hash = toParams['#'];
	
	        if (!isDefined(toState)) {
	          var redirect = { to: to, toParams: toParams, options: options };
	          var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	          if (redirectResult) {
	            return redirectResult;
	          }
	
	          // Always retry once if the $stateNotFound was not prevented
	          // (handles either redirect changed or state lazy-definition)
	          to = redirect.to;
	          toParams = redirect.toParams;
	          options = redirect.options;
	          toState = findState(to, options.relative);
	
	          if (!isDefined(toState)) {
	            if (!options.relative) throw new Error("No such state '" + to + "'");
	            throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	          }
	        }
	        if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	        if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	        if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	        toParams = toState.params.$$values(toParams);
	        to = toState;
	
	        var toPath = to.path;
	
	        // Starting from the root of the path, keep all levels that haven't changed
	        var keep = 0,
	            state = toPath[keep],
	            locals = root.locals,
	            toLocals = [];
	
	        if (!options.reload) {
	          while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	            locals = toLocals[keep] = state.locals;
	            keep++;
	            state = toPath[keep];
	          }
	        } else if (isString(options.reload) || isObject(options.reload)) {
	          if (isObject(options.reload) && !options.reload.name) {
	            throw new Error('Invalid reload state object');
	          }
	
	          var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	          if (options.reload && !reloadState) {
	            throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	          }
	
	          while (state && state === fromPath[keep] && state !== reloadState) {
	            locals = toLocals[keep] = state.locals;
	            keep++;
	            state = toPath[keep];
	          }
	        }
	
	        // If we're going to the same state and all locals are kept, we've got nothing to do.
	        // But clear 'transition', as we still want to cancel any other pending transitions.
	        // TODO: We may not want to bump 'transition' if we're called from a location change
	        // that we've initiated ourselves, because we might accidentally abort a legitimate
	        // transition initiated from code?
	        if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	          if (hash) toParams['#'] = hash;
	          $state.params = toParams;
	          copy($state.params, $stateParams);
	          copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	          if (options.location && to.navigable && to.navigable.url) {
	            $urlRouter.push(to.navigable.url, toParams, {
	              $$avoidResync: true, replace: options.location === 'replace'
	            });
	            $urlRouter.update(true);
	          }
	          $state.transition = null;
	          return $q.when($state.current);
	        }
	
	        // Filter parameters before we pass them to event handlers etc.
	        toParams = filterByKeys(to.params.$$keys(), toParams || {});
	
	        // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	        if (hash) toParams['#'] = hash;
	
	        // Broadcast start event and cancel the transition if requested
	        if (options.notify) {
	          /**
	           * @ngdoc event
	           * @name ui.router.state.$state#$stateChangeStart
	           * @eventOf ui.router.state.$state
	           * @eventType broadcast on root scope
	           * @description
	           * Fired when the state transition **begins**. You can use `event.preventDefault()`
	           * to prevent the transition from happening and then the transition promise will be
	           * rejected with a `'transition prevented'` value.
	           *
	           * @param {Object} event Event object.
	           * @param {State} toState The state being transitioned to.
	           * @param {Object} toParams The params supplied to the `toState`.
	           * @param {State} fromState The current state, pre-transition.
	           * @param {Object} fromParams The params supplied to the `fromState`.
	           *
	           * @example
	           *
	           * <pre>
	           * $rootScope.$on('$stateChangeStart',
	           * function(event, toState, toParams, fromState, fromParams){
	           *     event.preventDefault();
	           *     // transitionTo() promise will be rejected with
	           *     // a 'transition prevented' error
	           * })
	           * </pre>
	           */
	          if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	            if ($state.transition == null) $urlRouter.update();
	            return TransitionPrevented;
	          }
	        }
	
	        // Resolve locals for the remaining states, but don't update any global state just
	        // yet -- if anything fails to resolve the current state needs to remain untouched.
	        // We also set up an inheritance chain for the locals here. This allows the view directive
	        // to quickly look up the correct definition for each view in the current state. Even
	        // though we create the locals object itself outside resolveState(), it is initially
	        // empty and gets filled asynchronously. We need to keep track of the promise for the
	        // (fully resolved) current locals, and pass this down the chain.
	        var resolved = $q.when(locals);
	
	        for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	          locals = toLocals[l] = inherit(locals);
	          resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	        }
	
	        // Once everything is resolved, we are ready to perform the actual transition
	        // and return a promise for the new state. We also keep track of what the
	        // current promise is, so that we can detect overlapping transitions and
	        // keep only the outcome of the last transition.
	        var transition = $state.transition = resolved.then(function () {
	          var l, entering, exiting;
	
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          // Exit 'from' states not kept
	          for (l = fromPath.length - 1; l >= keep; l--) {
	            exiting = fromPath[l];
	            if (exiting.self.onExit) {
	              $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	            }
	            exiting.locals = null;
	          }
	
	          // Enter 'to' states not kept
	          for (l = keep; l < toPath.length; l++) {
	            entering = toPath[l];
	            entering.locals = toLocals[l];
	            if (entering.self.onEnter) {
	              $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	            }
	          }
	
	          // Run it again, to catch any transitions in callbacks
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          // Update globals in $state
	          $state.$current = to;
	          $state.current = to.self;
	          $state.params = toParams;
	          copy($state.params, $stateParams);
	          $state.transition = null;
	
	          if (options.location && to.navigable) {
	            $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	              $$avoidResync: true, replace: options.location === 'replace'
	            });
	          }
	
	          if (options.notify) {
	            /**
	             * @ngdoc event
	             * @name ui.router.state.$state#$stateChangeSuccess
	             * @eventOf ui.router.state.$state
	             * @eventType broadcast on root scope
	             * @description
	             * Fired once the state transition is **complete**.
	             *
	             * @param {Object} event Event object.
	             * @param {State} toState The state being transitioned to.
	             * @param {Object} toParams The params supplied to the `toState`.
	             * @param {State} fromState The current state, pre-transition.
	             * @param {Object} fromParams The params supplied to the `fromState`.
	             */
	            $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	          }
	          $urlRouter.update(true);
	
	          return $state.current;
	        }).then(null, function (error) {
	          // propagate TransitionSuperseded error without emitting $stateChangeCancel
	          // as it was already emitted in the success handler above
	          if (error === TransitionSupersededError) return TransitionSuperseded;
	
	          if ($state.transition !== transition) {
	            $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	            return TransitionSuperseded;
	          }
	
	          $state.transition = null;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.$state#$stateChangeError
	           * @eventOf ui.router.state.$state
	           * @eventType broadcast on root scope
	           * @description
	           * Fired when an **error occurs** during transition. It's important to note that if you
	           * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	           * they will not throw traditionally. You must listen for this $stateChangeError event to
	           * catch **ALL** errors.
	           *
	           * @param {Object} event Event object.
	           * @param {State} toState The state being transitioned to.
	           * @param {Object} toParams The params supplied to the `toState`.
	           * @param {State} fromState The current state, pre-transition.
	           * @param {Object} fromParams The params supplied to the `fromState`.
	           * @param {Error} error The resolve error object.
	           */
	          evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	          if (!evt.defaultPrevented) {
	            $urlRouter.update();
	          }
	
	          return $q.reject(error);
	        });
	
	        silenceUncaughtInPromise(transition);
	        return transition;
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#is
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	       * but only checks for the full state name. If params is supplied then it will be
	       * tested for strict equality against the current active params object, so all params
	       * must match with none missing and no extras.
	       *
	       * @example
	       * <pre>
	       * $state.$current.name = 'contacts.details.item';
	       *
	       * // absolute name
	       * $state.is('contact.details.item'); // returns true
	       * $state.is(contactDetailItemStateObject); // returns true
	       *
	       * // relative name (. and ^), typically from a template
	       * // E.g. from the 'contacts.details' template
	       * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	       * </pre>
	       *
	       * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	       * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	       * to test against the current active state.
	       * @param {object=} options An options object.  The options are:
	       *
	       * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	       * test relative to `options.relative` state (or name).
	       *
	       * @returns {boolean} Returns true if it is the state.
	       */
	      $state.is = function is(stateOrName, params, options) {
	        options = extend({ relative: $state.$current }, options || {});
	        var state = findState(stateOrName, options.relative);
	
	        if (!isDefined(state)) {
	          return undefined;
	        }
	        if ($state.$current !== state) {
	          return false;
	        }
	
	        return !params || objectKeys(params).reduce(function (acc, key) {
	          var paramDef = state.params[key];
	          return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	        }, true);
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#includes
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A method to determine if the current active state is equal to or is the child of the
	       * state stateName. If any params are passed then they will be tested for a match as well.
	       * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	       *
	       * @example
	       * Partial and relative names
	       * <pre>
	       * $state.$current.name = 'contacts.details.item';
	       *
	       * // Using partial names
	       * $state.includes("contacts"); // returns true
	       * $state.includes("contacts.details"); // returns true
	       * $state.includes("contacts.details.item"); // returns true
	       * $state.includes("contacts.list"); // returns false
	       * $state.includes("about"); // returns false
	       *
	       * // Using relative names (. and ^), typically from a template
	       * // E.g. from the 'contacts.details' template
	       * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	       * </pre>
	       *
	       * Basic globbing patterns
	       * <pre>
	       * $state.$current.name = 'contacts.details.item.url';
	       *
	       * $state.includes("*.details.*.*"); // returns true
	       * $state.includes("*.details.**"); // returns true
	       * $state.includes("**.item.**"); // returns true
	       * $state.includes("*.details.item.url"); // returns true
	       * $state.includes("*.details.*.url"); // returns true
	       * $state.includes("*.details.*"); // returns false
	       * $state.includes("item.**"); // returns false
	       * </pre>
	       *
	       * @param {string} stateOrName A partial name, relative name, or glob pattern
	       * to be searched for within the current state name.
	       * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	       * that you'd like to test against the current active state.
	       * @param {object=} options An options object.  The options are:
	       *
	       * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	       * .includes will test relative to `options.relative` state (or name).
	       *
	       * @returns {boolean} Returns true if it does include the state
	       */
	      $state.includes = function includes(stateOrName, params, options) {
	        options = extend({ relative: $state.$current }, options || {});
	        if (isString(stateOrName) && isGlob(stateOrName)) {
	          if (!doesStateMatchGlob(stateOrName)) {
	            return false;
	          }
	          stateOrName = $state.$current.name;
	        }
	
	        var state = findState(stateOrName, options.relative);
	        if (!isDefined(state)) {
	          return undefined;
	        }
	        if (!isDefined($state.$current.includes[state.name])) {
	          return false;
	        }
	        if (!params) {
	          return true;
	        }
	
	        var keys = objectKeys(params);
	        for (var i = 0; i < keys.length; i++) {
	          var key = keys[i],
	              paramDef = state.params[key];
	          if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	            return false;
	          }
	        }
	
	        return objectKeys(params).reduce(function (acc, key) {
	          var paramDef = state.params[key];
	          return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
	        }, true);
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#href
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * A url generation method that returns the compiled url for the given state populated with the given params.
	       *
	       * @example
	       * <pre>
	       * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	       * </pre>
	       *
	       * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	       * @param {object=} params An object of parameter values to fill the state's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	       *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	       *    ancestor with a valid url).
	       * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	       * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	       *    defines which state to be relative from.
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       * 
	       * @returns {string} compiled state url
	       */
	      $state.href = function href(stateOrName, params, options) {
	        options = extend({
	          lossy: true,
	          inherit: true,
	          absolute: false,
	          relative: $state.$current
	        }, options || {});
	
	        var state = findState(stateOrName, options.relative);
	
	        if (!isDefined(state)) return null;
	        if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	
	        var nav = state && options.lossy ? state.navigable : state;
	
	        if (!nav || nav.url === undefined || nav.url === null) {
	          return null;
	        }
	        return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	          absolute: options.absolute
	        });
	      };
	
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$state#get
	       * @methodOf ui.router.state.$state
	       *
	       * @description
	       * Returns the state configuration object for any specific state or all states.
	       *
	       * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	       * the requested state. If not provided, returns an array of ALL state configs.
	       * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	       * @returns {Object|Array} State configuration object or array of all objects.
	       */
	      $state.get = function (stateOrName, context) {
	        if (arguments.length === 0) return map(objectKeys(states), function (name) {
	          return states[name].self;
	        });
	        var state = findState(stateOrName, context || $state.$current);
	        return state && state.self ? state.self : null;
	      };
	
	      function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	        // Make a restricted $stateParams with only the parameters that apply to this state if
	        // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	        // we also need $stateParams to be available for any $injector calls we make during the
	        // dependency resolution process.
	        var $stateParams = paramsAreFiltered ? params : filterByKeys(state.params.$$keys(), params);
	        var locals = { $stateParams: $stateParams };
	
	        // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	        // We're also including $stateParams in this; that way the parameters are restricted
	        // to the set that should be visible to the state, and are independent of when we update
	        // the global $state and $stateParams values.
	        dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	        var promises = [dst.resolve.then(function (globals) {
	          dst.globals = globals;
	        })];
	        if (inherited) promises.push(inherited);
	
	        function resolveViews() {
	          var viewsPromises = [];
	
	          // Resolve template and dependencies for all views.
	          forEach(state.views, function (view, name) {
	            var injectables = view.resolve && view.resolve !== state.resolve ? view.resolve : {};
	            injectables.$template = [function () {
	              return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	            }];
	
	            viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	              // References to the controller (only instantiated at link time)
	              if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	                var injectLocals = angular.extend({}, injectables, dst.globals);
	                result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	              } else {
	                result.$$controller = view.controller;
	              }
	              // Provide access to the state itself for internal use
	              result.$$state = state;
	              result.$$controllerAs = view.controllerAs;
	              result.$$resolveAs = view.resolveAs;
	              dst[name] = result;
	            }));
	          });
	
	          return $q.all(viewsPromises).then(function () {
	            return dst.globals;
	          });
	        }
	
	        // Wait for all the promises and then return the activation object
	        return $q.all(promises).then(resolveViews).then(function (values) {
	          return dst;
	        });
	      }
	
	      return $state;
	    }
	
	    function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	      // Return true if there are no differences in non-search (path/object) params, false if there are differences
	      function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	        // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	        function notSearchParam(key) {
	          return fromAndToState.params[key].location != "search";
	        }
	        var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	        var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	        var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	        return nonQueryParamSet.$$equals(fromParams, toParams);
	      }
	
	      // If reload was not explicitly requested
	      // and we're transitioning to the same state we're already in
	      // and    the locals didn't change
	      //     or they changed in a way that doesn't merit reloading
	      //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	      // Then return true.
	      if (!options.reload && to === from && (locals === from.locals || to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams))) {
	        return true;
	      }
	    }
	  }
	
	  angular.module('ui.router.state').factory('$stateParams', function () {
	    return {};
	  }).constant("$state.runtime", { autoinject: true }).provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	  $ViewProvider.$inject = [];
	  function $ViewProvider() {
	
	    this.$get = $get;
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$view
	     *
	     * @requires ui.router.util.$templateFactory
	     * @requires $rootScope
	     *
	     * @description
	     *
	     */
	    $get.$inject = ['$rootScope', '$templateFactory'];
	    function $get($rootScope, $templateFactory) {
	      return {
	        // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	        /**
	         * @ngdoc function
	         * @name ui.router.state.$view#load
	         * @methodOf ui.router.state.$view
	         *
	         * @description
	         *
	         * @param {string} name name
	         * @param {object} options option object.
	         */
	        load: function load(name, options) {
	          var result,
	              defaults = {
	            template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	          };
	          options = extend(defaults, options);
	
	          if (options.view) {
	            result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	          }
	          return result;
	        }
	      };
	    }
	  }
	
	  angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	   */
	  function $ViewScrollProvider() {
	
	    var useAnchorScroll = false;
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	     * @methodOf ui.router.state.$uiViewScrollProvider
	     *
	     * @description
	     * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	     * scrolling based on the url anchor.
	     */
	    this.useAnchorScroll = function () {
	      useAnchorScroll = true;
	    };
	
	    /**
	     * @ngdoc object
	     * @name ui.router.state.$uiViewScroll
	     *
	     * @requires $anchorScroll
	     * @requires $timeout
	     *
	     * @description
	     * When called with a jqLite element, it scrolls the element into view (after a
	     * `$timeout` so the DOM has time to refresh).
	     *
	     * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	     * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	     */
	    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	      if (useAnchorScroll) {
	        return $anchorScroll;
	      }
	
	      return function ($element) {
	        return $timeout(function () {
	          $element[0].scrollIntoView();
	        }, 0, false);
	      };
	    }];
	  }
	
	  angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-view
	   *
	   * @requires ui.router.state.$state
	   * @requires $compile
	   * @requires $controller
	   * @requires $injector
	   * @requires ui.router.state.$uiViewScroll
	   * @requires $document
	   *
	   * @restrict ECA
	   *
	   * @description
	   * The ui-view directive tells $state where to place your templates.
	   *
	   * @param {string=} name A view name. The name should be unique amongst the other views in the
	   * same state. You can have views of the same name that live in different states.
	   *
	   * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	   * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	   * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	   * scroll ui-view elements into view when they are populated during a state activation.
	   *
	   * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	   * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	   *
	   * @param {string=} onload Expression to evaluate whenever the view updates.
	   *
	   * @example
	   * A view can be unnamed or named.
	   * <pre>
	   * <!-- Unnamed -->
	   * <div ui-view></div>
	   *
	   * <!-- Named -->
	   * <div ui-view="viewName"></div>
	   * </pre>
	   *
	   * You can only have one unnamed view within any template (or root html). If you are only using a
	   * single view and it is unnamed then you can populate it like so:
	   * <pre>
	   * <div ui-view></div>
	   * $stateProvider.state("home", {
	   *   template: "<h1>HELLO!</h1>"
	   * })
	   * </pre>
	   *
	   * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	   * config property, by name, in this case an empty name:
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "": {
	   *       template: "<h1>HELLO!</h1>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * But typically you'll only use the views property if you name your view or have more than one view
	   * in the same template. There's not really a compelling reason to name a view if its the only one,
	   * but you could if you wanted, like so:
	   * <pre>
	   * <div ui-view="main"></div>
	   * </pre>
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "main": {
	   *       template: "<h1>HELLO!</h1>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * Really though, you'll use views to set up multiple views:
	   * <pre>
	   * <div ui-view></div>
	   * <div ui-view="chart"></div>
	   * <div ui-view="data"></div>
	   * </pre>
	   *
	   * <pre>
	   * $stateProvider.state("home", {
	   *   views: {
	   *     "": {
	   *       template: "<h1>HELLO!</h1>"
	   *     },
	   *     "chart": {
	   *       template: "<chart_thing/>"
	   *     },
	   *     "data": {
	   *       template: "<data_thing/>"
	   *     }
	   *   }    
	   * })
	   * </pre>
	   *
	   * Examples for `autoscroll`:
	   *
	   * <pre>
	   * <!-- If autoscroll present with no expression,
	   *      then scroll ui-view into view -->
	   * <ui-view autoscroll/>
	   *
	   * <!-- If autoscroll present with valid expression,
	   *      then scroll ui-view into view if expression evaluates to true -->
	   * <ui-view autoscroll='true'/>
	   * <ui-view autoscroll='false'/>
	   * <ui-view autoscroll='scopeVariable'/>
	   * </pre>
	   *
	   * Resolve data:
	   *
	   * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	   * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	   *
	   * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	   * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	   * depends on `$resolve` data.
	   *
	   * Example usage of $resolve in a view template
	   * <pre>
	   * $stateProvider.state('home', {
	   *   template: '<my-component user="$resolve.user"></my-component>',
	   *   resolve: {
	   *     user: function(UserService) { return UserService.fetchUser(); }
	   *   }
	   * });
	   * </pre>
	   */
	  $ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	  function $ViewDirective($state, $injector, $uiViewScroll, $interpolate, $q) {
	
	    function getService() {
	      return $injector.has ? function (service) {
	        return $injector.has(service) ? $injector.get(service) : null;
	      } : function (service) {
	        try {
	          return $injector.get(service);
	        } catch (e) {
	          return null;
	        }
	      };
	    }
	
	    var service = getService(),
	        $animator = service('$animator'),
	        $animate = service('$animate');
	
	    // Returns a set of DOM manipulation functions based on which Angular version
	    // it should use
	    function getRenderer(attrs, scope) {
	      var statics = function statics() {
	        return {
	          enter: function enter(element, target, cb) {
	            target.after(element);cb();
	          },
	          leave: function leave(element, cb) {
	            element.remove();cb();
	          }
	        };
	      };
	
	      if ($animate) {
	        return {
	          enter: function enter(element, target, cb) {
	            if (angular.version.minor > 2) {
	              $animate.enter(element, null, target).then(cb);
	            } else {
	              $animate.enter(element, null, target, cb);
	            }
	          },
	          leave: function leave(element, cb) {
	            if (angular.version.minor > 2) {
	              $animate.leave(element).then(cb);
	            } else {
	              $animate.leave(element, cb);
	            }
	          }
	        };
	      }
	
	      if ($animator) {
	        var animate = $animator && $animator(scope, attrs);
	
	        return {
	          enter: function enter(element, target, cb) {
	            animate.enter(element, null, target);cb();
	          },
	          leave: function leave(element, cb) {
	            animate.leave(element);cb();
	          }
	        };
	      }
	
	      return statics();
	    }
	
	    var directive = {
	      restrict: 'ECA',
	      terminal: true,
	      priority: 400,
	      transclude: 'element',
	      compile: function compile(tElement, tAttrs, $transclude) {
	        return function (scope, $element, attrs) {
	          var previousEl,
	              currentEl,
	              currentScope,
	              latestLocals,
	              onloadExp = attrs.onload || '',
	              autoScrollExp = attrs.autoscroll,
	              renderer = getRenderer(attrs, scope),
	              inherited = $element.inheritedData('$uiView');
	
	          scope.$on('$stateChangeSuccess', function () {
	            updateView(false);
	          });
	
	          updateView(true);
	
	          function cleanupLastView() {
	            if (previousEl) {
	              previousEl.remove();
	              previousEl = null;
	            }
	
	            if (currentScope) {
	              currentScope.$destroy();
	              currentScope = null;
	            }
	
	            if (currentEl) {
	              var $uiViewData = currentEl.data('$uiViewAnim');
	              renderer.leave(currentEl, function () {
	                $uiViewData.$$animLeave.resolve();
	                previousEl = null;
	              });
	
	              previousEl = currentEl;
	              currentEl = null;
	            }
	          }
	
	          function updateView(firstTime) {
	            var newScope,
	                name = getUiViewName(scope, attrs, $element, $interpolate),
	                previousLocals = name && $state.$current && $state.$current.locals[name];
	
	            if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	            newScope = scope.$new();
	            latestLocals = $state.$current.locals[name];
	
	            /**
	             * @ngdoc event
	             * @name ui.router.state.directive:ui-view#$viewContentLoading
	             * @eventOf ui.router.state.directive:ui-view
	             * @eventType emits on ui-view directive scope
	             * @description
	             *
	             * Fired once the view **begins loading**, *before* the DOM is rendered.
	             *
	             * @param {Object} event Event object.
	             * @param {string} viewName Name of the view.
	             */
	            newScope.$emit('$viewContentLoading', name);
	
	            var clone = $transclude(newScope, function (clone) {
	              var animEnter = $q.defer(),
	                  animLeave = $q.defer();
	              var viewAnimData = {
	                $animEnter: animEnter.promise,
	                $animLeave: animLeave.promise,
	                $$animLeave: animLeave
	              };
	
	              clone.data('$uiViewAnim', viewAnimData);
	              renderer.enter(clone, $element, function onUiViewEnter() {
	                animEnter.resolve();
	                if (currentScope) {
	                  currentScope.$emit('$viewContentAnimationEnded');
	                }
	
	                if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                  $uiViewScroll(clone);
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentEl = clone;
	            currentScope = newScope;
	            /**
	             * @ngdoc event
	             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	             * @eventOf ui.router.state.directive:ui-view
	             * @eventType emits on ui-view directive scope
	             * @description
	             * Fired once the view is **loaded**, *after* the DOM is rendered.
	             *
	             * @param {Object} event Event object.
	             * @param {string} viewName Name of the view.
	             */
	            currentScope.$emit('$viewContentLoaded', name);
	            currentScope.$eval(onloadExp);
	          }
	        };
	      }
	    };
	
	    return directive;
	  }
	
	  $ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	  function $ViewDirectiveFill($compile, $controller, $state, $interpolate) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      compile: function compile(tElement) {
	        var initial = tElement.html();
	        if (tElement.empty) {
	          tElement.empty();
	        } else {
	          // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
	          tElement[0].innerHTML = null;
	        }
	
	        return function (scope, $element, attrs) {
	          var current = $state.$current,
	              name = getUiViewName(scope, attrs, $element, $interpolate),
	              locals = current && current.locals[name];
	
	          if (!locals) {
	            $element.html(initial);
	            $compile($element.contents())(scope);
	            return;
	          }
	
	          $element.data('$uiView', { name: name, state: locals.$$state });
	          $element.html(locals.$template ? locals.$template : initial);
	
	          var resolveData = angular.extend({}, locals);
	          scope[locals.$$resolveAs] = resolveData;
	
	          var link = $compile($element.contents());
	
	          if (locals.$$controller) {
	            locals.$scope = scope;
	            locals.$element = $element;
	            var controller = $controller(locals.$$controller, locals);
	            if (locals.$$controllerAs) {
	              scope[locals.$$controllerAs] = controller;
	              scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	            }
	            if (isFunction(controller.$onInit)) controller.$onInit();
	            $element.data('$ngControllerController', controller);
	            $element.children().data('$ngControllerController', controller);
	          }
	
	          link(scope);
	        };
	      }
	    };
	  }
	
	  /**
	   * Shared ui-view code for both directives:
	   * Given scope, element, and its attributes, return the view's name
	   */
	  function getUiViewName(scope, attrs, element, $interpolate) {
	    var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	    var uiViewCreatedBy = element.inheritedData('$uiView');
	    return name.indexOf('@') >= 0 ? name : name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : '');
	  }
	
	  angular.module('ui.router.state').directive('uiView', $ViewDirective);
	  angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	  function parseStateRef(ref, current) {
	    var preparsed = ref.match(/^\s*({[^}]*})\s*$/),
	        parsed;
	    if (preparsed) ref = current + '(' + preparsed[1] + ')';
	    parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	    return { state: parsed[1], paramExpr: parsed[3] || null };
	  }
	
	  function stateContext(el) {
	    var stateData = el.parent().inheritedData('$uiView');
	
	    if (stateData && stateData.state && stateData.state.name) {
	      return stateData.state;
	    }
	  }
	
	  function getTypeInfo(el) {
	    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	    var isForm = el[0].nodeName === "FORM";
	
	    return {
	      attr: isForm ? "action" : isSvg ? 'xlink:href' : 'href',
	      isAnchor: el.prop("tagName").toUpperCase() === "A",
	      clickable: !isForm
	    };
	  }
	
	  function clickHook(el, $state, $timeout, type, current) {
	    return function (e) {
	      var button = e.which || e.button,
	          target = current();
	
	      if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	        // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	        var transition = $timeout(function () {
	          $state.go(target.state, target.params, target.options);
	        });
	        e.preventDefault();
	
	        // if the state has no URL, ignore one preventDefault from the <a> directive.
	        var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
	
	        e.preventDefault = function () {
	          if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	        };
	      }
	    };
	  }
	
	  function defaultOpts(el, $state) {
	    return { relative: stateContext(el) || $state.$current, inherit: true };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref
	   *
	   * @requires ui.router.state.$state
	   * @requires $timeout
	   *
	   * @restrict A
	   *
	   * @description
	   * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	   * URL, the directive will automatically generate & update the `href` attribute via
	   * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	   * the link will trigger a state transition with optional parameters.
	   *
	   * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	   * handled natively by the browser.
	   *
	   * You can also use relative state paths within ui-sref, just like the relative
	   * paths passed to `$state.go()`. You just need to be aware that the path is relative
	   * to the state that the link lives in, in other words the state that loaded the
	   * template containing the link.
	   *
	   * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	   * and `reload`.
	   *
	   * @example
	   * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	   * following template:
	   * <pre>
	   * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	   *
	   * <ul>
	   *     <li ng-repeat="contact in contacts">
	   *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	   *     </li>
	   * </ul>
	   * </pre>
	   *
	   * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	   * <pre>
	   * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	   *
	   * <ul>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	   *     </li>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	   *     </li>
	   *     <li ng-repeat="contact in contacts">
	   *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	   *     </li>
	   * </ul>
	   *
	   * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	   * </pre>
	   *
	   * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	   * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   */
	  $StateRefDirective.$inject = ['$state', '$timeout'];
	  function $StateRefDirective($state, $timeout) {
	    return {
	      restrict: 'A',
	      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	      link: function link(scope, element, attrs, uiSrefActive) {
	        var ref = parseStateRef(attrs.uiSref, $state.current.name);
	        var def = { state: ref.state, href: null, params: null };
	        var type = getTypeInfo(element);
	        var active = uiSrefActive[1] || uiSrefActive[0];
	        var unlinkInfoFn = null;
	        var hookFn;
	
	        def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	        var update = function update(val) {
	          if (val) def.params = angular.copy(val);
	          def.href = $state.href(ref.state, def.params, def.options);
	
	          if (unlinkInfoFn) unlinkInfoFn();
	          if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	          if (def.href !== null) attrs.$set(type.attr, def.href);
	        };
	
	        if (ref.paramExpr) {
	          scope.$watch(ref.paramExpr, function (val) {
	            if (val !== def.params) update(val);
	          }, true);
	          def.params = angular.copy(scope.$eval(ref.paramExpr));
	        }
	        update();
	
	        if (!type.clickable) return;
	        hookFn = clickHook(element, $state, $timeout, type, function () {
	          return def;
	        });
	        element[element.on ? 'on' : 'bind']("click", hookFn);
	        scope.$on('$destroy', function () {
	          element[element.off ? 'off' : 'unbind']("click", hookFn);
	        });
	      }
	    };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-state
	   *
	   * @requires ui.router.state.uiSref
	   *
	   * @restrict A
	   *
	   * @description
	   * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	   * params and override options.
	   *
	   * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	   * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	   * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	   */
	  $StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	  function $StateRefDynamicDirective($state, $timeout) {
	    return {
	      restrict: 'A',
	      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	      link: function link(scope, element, attrs, uiSrefActive) {
	        var type = getTypeInfo(element);
	        var active = uiSrefActive[1] || uiSrefActive[0];
	        var group = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	        var watch = '[' + group.map(function (val) {
	          return val || 'null';
	        }).join(', ') + ']';
	        var def = { state: null, params: null, options: null, href: null };
	        var unlinkInfoFn = null;
	        var hookFn;
	
	        function runStateRefLink(group) {
	          def.state = group[0];def.params = group[1];def.options = group[2];
	          def.href = $state.href(def.state, def.params, def.options);
	
	          if (unlinkInfoFn) unlinkInfoFn();
	          if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	          if (def.href) attrs.$set(type.attr, def.href);
	        }
	
	        scope.$watch(watch, runStateRefLink, true);
	        runStateRefLink(scope.$eval(watch));
	
	        if (!type.clickable) return;
	        hookFn = clickHook(element, $state, $timeout, type, function () {
	          return def;
	        });
	        element[element.on ? 'on' : 'bind']("click", hookFn);
	        scope.$on('$destroy', function () {
	          element[element.off ? 'off' : 'unbind']("click", hookFn);
	        });
	      }
	    };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref-active
	   *
	   * @requires ui.router.state.$state
	   * @requires ui.router.state.$stateParams
	   * @requires $interpolate
	   *
	   * @restrict A
	   *
	   * @description
	   * A directive working alongside ui-sref to add classes to an element when the
	   * related ui-sref directive's state is active, and removing them when it is inactive.
	   * The primary use-case is to simplify the special appearance of navigation menus
	   * relying on `ui-sref`, by having the "active" state's menu button appear different,
	   * distinguishing it from the inactive menu items.
	   *
	   * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	   * ui-sref-active found at the same level or above the ui-sref will be used.
	   *
	   * Will activate when the ui-sref's target state or any child state is active. If you
	   * need to activate only when the ui-sref target state is active and *not* any of
	   * it's children, then you will use
	   * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	   *
	   * @example
	   * Given the following template:
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active="active" class="item">
	   *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   *
	   * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	   * the resulting HTML will appear as (note the 'active' class):
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active="active" class="item active">
	   *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   * The class name is interpolated **once** during the directives link time (any further changes to the
	   * interpolated value are ignored).
	   *
	   * Multiple classes may be specified in a space-separated format:
	   * <pre>
	   * <ul>
	   *   <li ui-sref-active='class1 class2 class3'>
	   *     <a ui-sref="app.user">link</a>
	   *   </li>
	   * </ul>
	   * </pre>
	   *
	   * It is also possible to pass ui-sref-active an expression that evaluates
	   * to an object hash, whose keys represent active class names and whose
	   * values represent the respective state names/globs.
	   * ui-sref-active will match if the current active state **includes** any of
	   * the specified state names/globs, even the abstract ones.
	   *
	   * @Example
	   * Given the following template, with "admin" being an abstract state:
	   * <pre>
	   * <div ui-sref-active="{'active': 'admin.*'}">
	   *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	   * </div>
	   * </pre>
	   *
	   * When the current state is "admin.roles" the "active" class will be applied
	   * to both the <div> and <a> elements. It is important to note that the state
	   * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ui.router.state.directive:ui-sref-active-eq
	   *
	   * @requires ui.router.state.$state
	   * @requires ui.router.state.$stateParams
	   * @requires $interpolate
	   *
	   * @restrict A
	   *
	   * @description
	   * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	   * when the exact target state used in the `ui-sref` is active; no child states.
	   *
	   */
	  $StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	  function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	    return {
	      restrict: "A",
	      controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	        var states = [],
	            activeClasses = {},
	            activeEqClass,
	            uiSrefActive;
	
	        // There probably isn't much point in $observing this
	        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	        // slight difference in logic routing
	        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	        try {
	          uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	        } catch (e) {
	          // Do nothing. uiSrefActive is not a valid expression.
	          // Fall back to using $interpolate below
	        }
	        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	        if (isObject(uiSrefActive)) {
	          forEach(uiSrefActive, function (stateOrName, activeClass) {
	            if (isString(stateOrName)) {
	              var ref = parseStateRef(stateOrName, $state.current.name);
	              addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	            }
	          });
	        }
	
	        // Allow uiSref to communicate with uiSrefActive[Equals]
	        this.$$addStateInfo = function (newState, newParams) {
	          // we already got an explicit state provided by ui-sref-active, so we
	          // shadow the one that comes from ui-sref
	          if (isObject(uiSrefActive) && states.length > 0) {
	            return;
	          }
	          var deregister = addState(newState, newParams, uiSrefActive);
	          update();
	          return deregister;
	        };
	
	        $scope.$on('$stateChangeSuccess', update);
	
	        function addState(stateName, stateParams, activeClass) {
	          var state = $state.get(stateName, stateContext($element));
	          var stateHash = createStateHash(stateName, stateParams);
	
	          var stateInfo = {
	            state: state || { name: stateName },
	            params: stateParams,
	            hash: stateHash
	          };
	
	          states.push(stateInfo);
	          activeClasses[stateHash] = activeClass;
	
	          return function removeState() {
	            var idx = states.indexOf(stateInfo);
	            if (idx !== -1) states.splice(idx, 1);
	          };
	        }
	
	        /**
	         * @param {string} state
	         * @param {Object|string} [params]
	         * @return {string}
	         */
	        function createStateHash(state, params) {
	          if (!isString(state)) {
	            throw new Error('state should be a string');
	          }
	          if (isObject(params)) {
	            return state + toJson(params);
	          }
	          params = $scope.$eval(params);
	          if (isObject(params)) {
	            return state + toJson(params);
	          }
	          return state;
	        }
	
	        // Update route state
	        function update() {
	          for (var i = 0; i < states.length; i++) {
	            if (anyMatch(states[i].state, states[i].params)) {
	              addClass($element, activeClasses[states[i].hash]);
	            } else {
	              removeClass($element, activeClasses[states[i].hash]);
	            }
	
	            if (exactMatch(states[i].state, states[i].params)) {
	              addClass($element, activeEqClass);
	            } else {
	              removeClass($element, activeEqClass);
	            }
	          }
	        }
	
	        function addClass(el, className) {
	          $timeout(function () {
	            el.addClass(className);
	          });
	        }
	        function removeClass(el, className) {
	          el.removeClass(className);
	        }
	        function anyMatch(state, params) {
	          return $state.includes(state.name, params);
	        }
	        function exactMatch(state, params) {
	          return $state.is(state.name, params);
	        }
	
	        update();
	      }]
	    };
	  }
	
	  angular.module('ui.router.state').directive('uiSref', $StateRefDirective).directive('uiSrefActive', $StateRefActiveDirective).directive('uiSrefActiveEq', $StateRefActiveDirective).directive('uiState', $StateRefDynamicDirective);
	
	  /**
	   * @ngdoc filter
	   * @name ui.router.state.filter:isState
	   *
	   * @requires ui.router.state.$state
	   *
	   * @description
	   * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	   */
	  $IsStateFilter.$inject = ['$state'];
	  function $IsStateFilter($state) {
	    var isFilter = function isFilter(state, params) {
	      return $state.is(state, params);
	    };
	    isFilter.$stateful = true;
	    return isFilter;
	  }
	
	  /**
	   * @ngdoc filter
	   * @name ui.router.state.filter:includedByState
	   *
	   * @requires ui.router.state.$state
	   *
	   * @description
	   * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	   */
	  $IncludedByStateFilter.$inject = ['$state'];
	  function $IncludedByStateFilter($state) {
	    var includesFilter = function includesFilter(state, params, options) {
	      return $state.includes(state, params, options);
	    };
	    includesFilter.$stateful = true;
	    return includesFilter;
	  }
	
	  angular.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
	// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
	// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
	// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
	// v4 adds AMD/UMD, commonJS, and plain browser support
	// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
	// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
	// https://github.com/rndme/download
	
	(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.download = factory();
	  }
	}(this, function () {
	
		return function download(data, strFileName, strMimeType) {
	
			var self = window, // this script is only for browsers anyway...
				defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
				mimeType = strMimeType || defaultMime,
				payload = data,
				url = !strFileName && !strMimeType && payload,
				anchor = document.createElement("a"),
				toString = function(a){return String(a);},
				myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
				fileName = strFileName || "download",
				blob,
				reader;
				myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
		  
			if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
				payload=[payload, mimeType];
				mimeType=payload[0];
				payload=payload[1];
			}
	
	
			if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
				fileName = url.split("/").pop().split("?")[0];
				anchor.href = url; // assign href prop to temp anchor
			  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
	        		var ajax=new XMLHttpRequest();
	        		ajax.open( "GET", url, true);
	        		ajax.responseType = 'blob';
	        		ajax.onload= function(e){ 
					  download(e.target.response, fileName, defaultMime);
					};
	        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
				    return ajax;
				} // end if valid url?
			} // end if url?
	
	
			//go ahead and download dataURLs right away
			if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
			
				if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
					payload=dataUrlToBlob(payload);
					mimeType=payload.type || defaultMime;
				}else{			
					return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
						navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
						saver(payload) ; // everyone else can save dataURLs un-processed
				}
				
			}else{//not data url, is it a string with special needs?
				if(/([\x80-\xff])/.test(payload)){			  
					var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
					for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
				 	payload=new myBlob([tempUiArr], {type: mimeType});
				}		  
			}
			blob = payload instanceof myBlob ?
				payload :
				new myBlob([payload], {type: mimeType}) ;
	
	
			function dataUrlToBlob(strUrl) {
				var parts= strUrl.split(/[:;,]/),
				type= parts[1],
				decoder= parts[2] == "base64" ? atob : decodeURIComponent,
				binData= decoder( parts.pop() ),
				mx= binData.length,
				i= 0,
				uiArr= new Uint8Array(mx);
	
				for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);
	
				return new myBlob([uiArr], {type: type});
			 }
	
			function saver(url, winMode){
	
				if ('download' in anchor) { //html5 A[download]
					anchor.href = url;
					anchor.setAttribute("download", fileName);
					anchor.className = "download-js-link";
					anchor.innerHTML = "downloading...";
					anchor.style.display = "none";
					document.body.appendChild(anchor);
					setTimeout(function() {
						anchor.click();
						document.body.removeChild(anchor);
						if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
					}, 66);
					return true;
				}
	
				// handle non-a[download] safari as best we can:
				if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
					if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
					if(!window.open(url)){ // popup blocked, offer direct download:
						if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
					}
					return true;
				}
	
				//do iframe dataURL download (old ch+FF):
				var f = document.createElement("iframe");
				document.body.appendChild(f);
	
				if(!winMode && /^data:/.test(url)){ // force a mime that will download:
					url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				}
				f.src=url;
				setTimeout(function(){ document.body.removeChild(f); }, 333);
	
			}//end saver
	
	
	
	
			if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
				return navigator.msSaveBlob(blob, fileName);
			}
	
			if(self.URL){ // simple fast and modern way using Blob and URL:
				saver(self.URL.createObjectURL(blob), true);
			}else{
				// handle non-Blob()+non-URL browsers:
				if(typeof blob === "string" || blob.constructor===toString ){
					try{
						return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
					}catch(y){
						return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
					}
				}
	
				// Blob but not URL support:
				reader=new FileReader();
				reader.onload=function(e){
					saver(this.result);
				};
				reader.readAsDataURL(blob);
			}
			return true;
		}; /* end download() */
	}));


/***/ }),

/***/ 798:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

	module.exports = {"general":{"Traveler":"Traveller","traveler":"traveller","travelers":"travellers","Travelers":"Travellers","traveler_s":"traveller's","traveling":"travelling","Cost_Centre":"Cost Centre"},"dates":{"dateFormat":"dd/mm/yyyy","DateFormat":"DD/MM/YYYY","DateFormatMedium":"DD MMM, YYYY","DateFormatLong":"ddd Do MMM YYYY","DateTimeFormat":"dddd Do MMM h:mma","DateTimeFormatLong":"ddd, D MMM YYYY [at] h:mma","TimeFormat":"h:mm","TimeFormatLong":"h:mma","TimeFormatMeridiem":"a","TimeDateFormatLong":"h:mma [-] ddd Do MMM YYYY"},"modals":{"costCentre":{"HEADER":"Select Cost Centre"},"department":{"HEADER":"Select Department"},"paymentMethod":{"HEADER":"Select Payment Method"},"companyReference":{"HEADER":"Set Company References"},"addFlightSector":{"HEADER":"Add flights to your trip","SUBHEADING":"Select your flights","INSTRUCTIONS":"One ticket will be booked for each individual traveller on this trip for each flight chosen."},"addHotelSector":{"HEADER":"Add a hotel to your trip","SUBHEADING":"Select travellers who need a room","INSTRUCTIONS":"One identical room will be booked in the name of each selected traveller","SELECT_HOTEL_SUBHEADING":"Select hotel details","SELECT_HOTEL_INSTRUCTIONS":"All travellers will need to stay at the same hotel on the same days","SELECT_LOCATION_LABEL":"Location","SELECT_CHECK_IN_LABEL":"Check in","SELECT_CHECK_OUT_LABEL":"Check out"},"addCarSector":{"HEADER":"Add a car to your trip","SUBHEADING":"Select travellers who need a car","INSTRUCTIONS":"One identical car will be booked in the name of each selected traveller","SELECT_PICK_UP_LOCATION":"Pick up","SELECT_DROP_OFF_LOCATION":"Drop off","ALL_CARS_SAME_LOCATION":"All cars will need to be picked up at the same location on the same day","ALL_CARS_SAME_DROP_LOCATION":"All cars will need to be dropped off at the same location on the same day","NO_RESULTS":"No results"},"errorMessage":{"FORM":"Your inputs did not validate successfully","TECHNICAL":"We're sorry, there seems to be a technical error","ITINERARY_INCOMPLETE":"Your itinerary is incomplete","MISSING_DATA_APPROVER":"Missing data for approver section"},"approver":{"HEADER":"Select Approver","ADD_A_COMMENT_FOR_APPROVER_OPTIONAL":"Add a comment for approver (optional)","NON_REFUNDABLE":"Non-refundable. Your company will still be charged if your booking is not approved by your chosen approver."}},"http":{"NONE":"Service is inaccessible","OTHER":"Request may not have been correctly formatted","NOT_FOUND":"A resource with the specified identifier could not be found","GATEWAY_TIMEOUT":"Server did not respond in a timely manner","SERVICE_UNAVAILABLE":"Service is unavailable. Please try again later","INTERNAL_SERVER_ERROR":"Server experienced a critical error","METHOD_NOT_ALLOWED":"Access to the service is denied","UNAUTHORISED":"You do not have permission to access this service. Your Access Token may have expired, please try logging in again."},"validation":{"INVALID_ALPHA":"May only contain letters. ","INVALID_ALPHA_SPACE":"May only contain letters and spaces. ","INVALID_ALPHA_NUM":"May only contain letters and numbers. ","INVALID_ALPHA_NUM_SPACE":"May only contain letters, numbers and spaces. ","INVALID_ALPHA_DASH":"May only contain letters, numbers and dashes. ","INVALID_ALPHA_DASH_SPACE":"May only contain letters, numbers, dashes and spaces. ","INVALID_BETWEEN_CHAR":"Text must be between {0} and {1} characters in length. ","INVALID_BETWEEN_NUM":"Needs to be a numeric value, between {0} and {1}. ","INVALID_BOOLEAN":"May only contain a true or false value. ","INVALID_CREDIT_CARD":"Must be a valid credit card number. ","INVALID_DATE_EURO_LONG":"Must be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy). ","INVALID_DATE_EURO_LONG_BETWEEN":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy) between {0} and {1}. ","INVALID_DATE_EURO_LONG_MAX":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy), equal to, or lower than {0}. ","INVALID_DATE_EURO_LONG_MIN":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy), equal to, or higher than {0}. ","INVALID_DATE_EURO_SHORT":"Must be a valid date format (dd-mm-yy) OR (dd/mm/yy). ","INVALID_DATE_EURO_SHORT_BETWEEN":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy) between {0} and {1}. ","INVALID_DATE_EURO_SHORT_MAX":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy), equal to, or lower than {0}. ","INVALID_DATE_EURO_SHORT_MIN":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy), equal to, or higher than {0}. ","INVALID_DATE_ISO":"Must be a valid date format (yyyy-mm-dd). ","INVALID_DATE_ISO_BETWEEN":"Needs to be a valid date format (yyyy-mm-dd) between {0} and {1}. ","INVALID_DATE_ISO_MAX":"Needs to be a valid date format (yyyy-mm-dd), equal to, or lower than {0}. ","INVALID_DATE_ISO_MIN":"Needs to be a valid date format (yyyy-mm-dd), equal to, or higher than {0}. ","INVALID_DATE_US_LONG":"Must be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy). ","INVALID_DATE_US_LONG_BETWEEN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy) between {0} and {1}. ","INVALID_DATE_US_LONG_MAX":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or lower than {0}. ","INVALID_DATE_US_LONG_MIN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or higher than {0}. ","INVALID_DATE_US_SHORT":"Must be a valid date format (mm/dd/yy) OR (mm-dd-yy). ","INVALID_DATE_US_SHORT_BETWEEN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy) between {0} and {1}. ","INVALID_DATE_US_SHORT_MAX":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or lower than {0}. ","INVALID_DATE_US_SHORT_MIN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or higher than {0}. ","INVALID_EMAIL":"Must be a valid email address. ","INVALID_EXACT_LEN":"Must have a length of exactly {0} characters. ","INVALID_FLOAT":"May only contain a positive float value (integer excluded). ","INVALID_FLOAT_SIGNED":"May only contain a positive or negative float value (integer excluded). ","INVALID_IBAN":"Must be a valid IBAN. ","INVALID_INPUT_MATCH":"Confirmation field does not match specified field \"{0}\". ","INVALID_INTEGER":"Must be a positive integer. ","INVALID_INTEGER_SIGNED":"Must be a positive or negative integer. ","INVALID_IPV4":"Must be a valid IP (IPV4). ","INVALID_IPV6":"Must be a valid IP (IPV6). ","INVALID_IPV6_HEX":"Must be a valid IP (IPV6 Hex). ","INVALID_KEY_CHAR":"Invalid keyboard entry on a field of type \"number\". ","INVALID_MAX_CHAR":"May not be greater than {0} characters. ","INVALID_MAX_NUM":"Needs to be a numeric value, equal to, or lower than {0}. ","INVALID_MIN_CHAR":"Must be at least {0} characters. ","INVALID_MIN_NUM":"Needs to be a numeric value, equal to, or higher than {0}. ","INVALID_NUMERIC":"Must be a positive number. ","INVALID_NUMERIC_SIGNED":"Must be a positive or negative number. ","INVALID_PATTERN":"Must be following this format: {0}. ","INVALID_REQUIRED":"Field is required. ","INVALID_URL":"Must be a valid URL. ","INVALID_TIME":"Must be a valid time format (hh:mm) OR (hh:mm:ss). ","INVALID_CHECKBOX_SELECTED":"Checkbox must be selected. ","ERRORS":"Errors","FIRST_NAME":"First Name","LAST_NAME":"Last Name","RESET_FORM":"Reset Form","SAVE":"Save","SHOW_VALIDATION_SUMMARY":"Show Validation Summary","INVALID_DATE_AUSTRALIA":"Please enter a valid date in the format: dd/mm/yyyy","INVALID_TIME_AUSTRALIA":"Please enter a valid time","COST_CENTRES_REQUIRED":"Please select a Cost Centre for all travellers","DEPARTMENTS_REQUIRED":"Please select a Department for all travellers","PAYMENT_METHODS_REQUIRED":"Please select a Payment Method for all travellers","ALL_MANDATORY_REQUIRED":"Please fill out all mandatory fields","CREDIT_CARD_NUMBER_REQUIRED":"Please enter a valid card number","CREDIT_CARD_EXPIRY_MM_REQUIRED":"Please enter a valid expiry month","CREDIT_CARD_EXPIRY_YYYY_REQUIRED":"Please enter a valid expiry year","CREDIT_CARD_HOLDER_REQUIRED":"Please enter the card holder's name","CREDIT_CARD_HOLDER_INVALID":"Please enter a valid card holder's name","CREDIT_CARD_CCV_REQUIRED":"Please enter a valid CVV","PASSENGER_SELECTION_REQUIRED":"Please select at least one passenger","DEPARTURE_LOCATION_REQUIRED":"Please specify your departure location","ARRIVAL_LOCATION_REQUIRED":"Please specify your arrival location","HOTEL_LOCATION_REQUIRED":"Please specify your hotel location","HOTEL_CHECK_IN_DATE_REQUIRED":"Please specify your hotel check in date","HOTEL_CHECK_OUT_DATE_REQUIRED":"Please specify your hotel check out date","PICK_UP_LOCATION_REQUIRED":"Please select a pick-up city","PICK_UP_DEPOT_REQUIRED":"Please select a pick-up location","PICK_UP_DATE_REQUIRED":"Please select a pick-up date","PICK_UP_TIME_REQUIRED":"Please select a pick-up time","DROP_OFF_LOCATION_REQUIRED":"Please select a drop-off city","DROP_OFF_DEPOT_REQUIRED":"Please select a drop-off location","DROP_OFF_DATE_REQUIRED":"Please select a drop-off date","DROP_OFF_TIME_REQUIRED":"Please select a drop-off time","INVALID_PICK_UP_TIME_AUSTRALIA":"Please select a valid pick-up time","INVALID_DROP_OFF_TIME_AUSTRALIA":"Please select a valid drop-off time","APPROVER_REQUIRED":"Please select an Approver"},"homeSearch":{"SELECT_PICK_UP":"Pick up city","SELECT_DROP_OFF":"Drop off city","DEPOT":"Location","PICK_UP_DATE":"Pick up date","DROP_OFF_DATE":"Drop off date","BLOCKED_LOCATION_MESSAGE":"Disabled destinations are blocked by your company's travel policy."}}

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

	module.exports = {"dates":{"DateTimeFormat":"dddd Do MMM HH:mm","DateTimeFormatLong":"ddd, D MMM YYYY [at] HH:mm","TimeFormat":"HH:mm","TimeFormatLong":"HH:mm","TimeFormatMeridiem":""}}

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

	module.exports = {"general":{"Traveler":"Traveler","traveler":"traveler","travelers":"travelers","Travelers":"Travelers","traveler_s":"traveler's","traveling":"traveling","Cost_Centre":"Cost Center"},"dates":{"dateFormat":"mm/dd/yyyy","DateFormat":"MM/DD/YYYY"},"modals":{"costCentre":{"HEADER":"Select Cost Center","INSTRUCTIONS":"One ticket will be booked for each individual traveler on this trip for each flight chosen."},"department":{},"paymentMethod":{},"companyReference":{},"addFlightSector":{"INSTRUCTIONS":"One ticket will be booked for each individual traveler on this trip for each flight chosen."},"addHotelSector":{"SUBHEADING":"Select travelers who need a room","INSTRUCTIONS":"One identical room will be booked in the name of each selected traveler","SELECT_HOTEL_INSTRUCTIONS":"All travelers will need to stay at the same hotel on the same days"},"addCarSector":{"SUBHEADING":"Select travelers who need a car","INSTRUCTIONS":"One identical car will be booked in the name of each selected traveler"},"errorMessage":{},"approver":{}},"http":{},"validation":{"INVALID_DATE_EURO_LONG":"Must be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy). ","INVALID_DATE_EURO_LONG_BETWEEN":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy) between {0} and {1}. ","INVALID_DATE_EURO_LONG_MAX":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy), equal to, or lower than {0}. ","INVALID_DATE_EURO_LONG_MIN":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy), equal to, or higher than {0}. ","INVALID_DATE_EURO_SHORT":"Must be a valid date format (mm-dd-yy) OR (mm/dd/yy). ","INVALID_DATE_EURO_SHORT_BETWEEN":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy) between {0} and {1}. ","INVALID_DATE_EURO_SHORT_MAX":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy), equal to, or lower than {0}. ","INVALID_DATE_EURO_SHORT_MIN":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy), equal to, or higher than {0}. ","INVALID_DATE_ISO":"Must be a valid date format (yyyy-mm-dd). ","INVALID_DATE_ISO_BETWEEN":"Needs to be a valid date format (yyyy-mm-dd) between {0} and {1}. ","INVALID_DATE_ISO_MAX":"Needs to be a valid date format (yyyy-mm-dd), equal to, or lower than {0}. ","INVALID_DATE_ISO_MIN":"Needs to be a valid date format (yyyy-mm-dd), equal to, or higher than {0}. ","INVALID_DATE_US_LONG":"Must be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy). ","INVALID_DATE_US_LONG_BETWEEN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy) between {0} and {1}. ","INVALID_DATE_US_LONG_MAX":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or lower than {0}. ","INVALID_DATE_US_LONG_MIN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or higher than {0}. ","INVALID_DATE_US_SHORT":"Must be a valid date format (mm/dd/yy) OR (mm-dd-yy). ","INVALID_DATE_US_SHORT_BETWEEN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy) between {0} and {1}. ","INVALID_DATE_US_SHORT_MAX":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or lower than {0}. ","INVALID_DATE_US_SHORT_MIN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or higher than {0}. ","INVALID_TIME":"Must be a valid time format (hh:mm) OR (hh:mm:ss). ","INVALID_DATE_AUSTRALIA":"Please enter a valid date in the format: mm/dd/yyyy","COST_CENTRES_REQUIRED":"Please select a Cost Center for all travelers","DEPARTMENTS_REQUIRED":"Please select a Department for all travelers","PAYMENT_METHODS_REQUIRED":"Please select a Payment Method for all travelers"},"homeSearch":{}}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<form id=\"carHandlingForm\" name=\"vm.form\" ng-submit=\"vm.form.$valid && vm.submit()\" novalidate autocomplete=\"off\">\n<div class=\"lbCarHandlingModal_body\">\n<button class=\"lbModal_close\" type=\"button\" ng-click=\"vm.cancel()\"><span>close</span></button>\n<h2>Get your car delivered/collected</h2>\n<p>Some depots offer to deliver and/or collect your requested vehicle at an address of your choosing. If you would like to request this service please do so below.</p>\n<div class=\"lbCarHandlingModal_validation\" ng-if=\"vm.form.$invalid && vm.form.$submitted\">\n<strong>Incomplete form</strong><br/>\nAll form fields are required.\n<button type=\"button\" class=\"carHandlingModal_validation_close\" ng-click=\"vm.form.$submitted = false;\">\n<i class=\"ico-cancel\"></i>\n</button>\n</div>\n<div class=\"lbCarHandlingModal_toggle\" ng-if=\"vm.delivery.isEnabled\">\n<input type=\"checkbox\" ng-change=\"vm.request('delivery', vm.delivery.isActive)\" ng-model=\"vm.delivery.isActive\" id=\"deliveryToggle\">\n<label for=\"deliveryToggle\">Deliver my car to me</label>\n</div>\n<ng-form name=\"vm.deliveryForm\" ng-if=\"vm.delivery.isActive\">\n<div class=\"carHandlingModal_form\">\n<div class=\"carHandlingModal_alert\" ng-show=\"!vm.delivery.isEditing\">\n<span ng-if=\"vm.deliveryForm.$valid\">\n{{ vm.delivery.location | toAddressFilter }}\n</span>\n<span ng-if=\"vm.deliveryForm.$invalid\">\nSame as collection address\n</span>\n<a ng-click=\"vm.edit('delivery');\">edit</a>\n</div>\n<div ng-show=\"vm.delivery.isEditing\">\n<div class=\"carHandlingModal_formRow\">\n<label>Address*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.Address\" maxlength=\"60\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\">\n<label>City*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.City\" maxlength=\"30\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Country*</label>\n<lb-country-select required=\"true\" country=\"vm.delivery.location.Country\"></lb-country-select>\n</div>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\" ng-if=\"vm.delivery.location.Country.Code === 'US'\">\n<label>State*</label>\n<ui-select ng-model=\"vm.delivery.location.State\" ng-required=\"true\">\n<ui-select-match placeholder=\"Select a state\">\n{{ $select.selected.name }}\n</ui-select-match>\n<ui-select-choices repeat=\"state.code as state in vm.usStates | filter: $select.search\">\n<span ng-bind-html=\"state.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Postcode*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.Postcode\" maxlength=\"10\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n</div>\n</div>\n</div>\n</ng-form>\n<div class=\"lbCarHandlingModal_toggle\" ng-if=\"vm.collection.isEnabled\">\n<input type=\"checkbox\" ng-change=\"vm.request('collection', vm.collection.isActive)\" ng-model=\"vm.collection.isActive\" id=\"collectionToggle\">\n<label for=\"collectionToggle\">Collect my car from me</label>\n</div>\n<ng-form name=\"vm.collectionForm\" ng-if=\"vm.collection.isActive\">\n<div class=\"carHandlingModal_form\">\n<div class=\"carHandlingModal_alert\" ng-show=\"!vm.collection.isEditing\">\n<span ng-if=\"vm.collectionForm.$valid\">\n{{ vm.collection.location | toAddressFilter }}\n</span>\n<span ng-if=\"vm.collectionForm.$invalid\">\nSame as delivery address\n</span>\n<a ng-click=\"vm.edit('collection');\">edit</a>\n</div>\n<div ng-show=\"vm.collection.isEditing\">\n<div class=\"carHandlingModal_formRow\">\n<label>Address*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.Address\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\">\n<label>City*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.City\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Country*</label>\n<lb-country-select required=\"true\" country=\"vm.collection.location.Country\"></lb-country-select>\n</div>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\" ng-if=\"vm.collection.location.Country.Code === 'US'\">\n<label>State*</label>\n<ui-select ng-model=\"vm.collection.location.State\" ng-required=\"true\">\n<ui-select-match placeholder=\"Select a state\">\n{{ $select.selected.name }}\n</ui-select-match>\n<ui-select-choices repeat=\"state.code as state in vm.usStates | filter: $select.search\">\n<span ng-bind-html=\"state.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Postcode*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.Postcode\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n</div>\n</div>\n</div>\n</ng-form>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n<button class=\"button-primary\" type=\"submit\">Save</button>\n</div>\n</form>";
	var id1="components/lbCarHandlingModal/lbCarHandlingModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1034:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbCountrySelect\">\n<ui-select class=\"lbCountrySelect_input\" ng-model=\"vm.country\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\">\n<ui-select-match placeholder=\"{{ ::vm.placeholder }}\">\n{{ $select.selected.Name }}\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.countries | filter: $select.search\">\n<span ng-bind-html=\"item.Name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>";
	var id1="components/lbCountrySelect/lbCountrySelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbCurrencyMessage\">\n<div ng-if=\"vm.mode === 'carbon'\" class=\"lbCurrencyMessage_flight\">\n<span>CO<sub class=\"co2\">2</sub> emissions data is inclusive of RFI and is based on multiple factors, including flight route, aircraft type and cabin class &nbsp; <i class=\"infoIcon\"></i></span>\n<a href=\"https://www.travelctm.com/guide-to-ctm-carbon-emissions-calculations/?utm_campaign=carbon-emissions-calculations&utm_medium=OBT&utm_source=CTMT&utm_content=link-carbon-emissions-calculations\" target=\"_blank\">Click here for more information</a>\n</div>\n<span ng-if=\"vm.mode === 'carbon-car'\">CO<sub class=\"co2\">2</sub> emissions data is based on an average use of 160km per day &nbsp; <i class=\"infoIcon\"></i></span>\n<span ng-if=\"vm.mode === null\">\nAll prices shown in {{ vm.currencyCode }} &nbsp;\n<i class=\"infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</span>\n</div>\n";
	var id1="components/lbCurrencyMessage/lbCurrencyMessage.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1036:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbDatePicker\" ng-click=\"vm.closeDatePicker()\">\n<div class=\"lbDatePicker_calendar\" ng-click=\"$event.stopPropagation()\">\n<div pickadate ng-model=\"vm.date\" format=\"{{ vm.dateFormat }}\" on-date-select=\"vm.dateSelected(date)\" min-date=\"vm.settings.minDate\" max-date=\"vm.settings.maxDate\" range-from=\"vm.settings.rangeFrom\" range-to=\"vm.settings.rangeTo\">\n</div>\n<div class=\"lbDatePicker_close\">\n<button class=\"lbDatePicker_close_button\" ng-click=\"vm.closeDatePicker()\" id=\"lbDatePickerClose\">\nClose\n</button>\n</div>\n</div>\n</div>";
	var id1="components/lbDatePicker/lbDatePicker.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1037:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"form_date\">\n<i class=\"ico-calendar\"></i>\n<input type=\"text\" name=\"{{ ::vm.name }}\" ng-model=\"vm.date\" class=\"form_date_input\" ng-click=\"vm.openDatePicker($event)\" ng-focus=\"vm.openDatePicker($event)\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" readonly=\"readonly\">\n</div>";
	var id1="components/lbDateSelect/lbDateSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbDialog\" ng-if=\"vm.lbDialogService.visible\" ng-class=\"vm.lbDialogService.options.warningLevel\">\n<div class=\"lbDialog_bg\" ng-click=\"vm.lbDialogService.cancel()\"></div>\n<div class=\"lbDialog_modalBoxWrapper\">\n<div class=\"lbDialog_modalBox\">\n<header class=\"lbDialog_header\">\n<h3 class=\"lbDialog_heading\">\n<em></em> <span ng-bind-html=\"vm.lbDialogService.options.title\"></span>\n</h3>\n<button class=\"lbDialog_cancel ico-cancel\" ng-click=\"vm.lbDialogService.cancel()\" title=\"cancel\"></button>\n</header>\n<div class=\"lbDialog_content\">\n<div class=\"lbDialog_content_message\" ng-bind-html=\"::vm.lbDialogService.options.message\"></div>\n<div class=\"lbDialog_content_message\" ng-bind-html=\"::vm.lbDialogService.options.message2\" ng-if=\"::vm.lbDialogService.options.message2\"></div>\n<ui-select ng-model=\"vm.lbDialogService.selectedItem\" class=\"lbDialog_select\" ng-if=\"vm.lbDialogService.options.selections.length > 0\">\n<ui-select-match class=\"lbDialog_selected\">\n<span ng-bind=\"$select.selected.name\"></span>\n</ui-select-match>\n<ui-select-choices repeat=\"item in (vm.lbDialogService.options.selections) track by item.name\">\n<span ng-bind=\"item.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"lbDialog_actions\">\n<button class=\"button-link\" ng-click=\"vm.lbDialogService.cancel()\">Cancel</button>\n<button class=\"button-primary\" ng-click=\"vm.lbDialogService.submit()\">{{ ::vm.lbDialogService.options.submitButtonText }}</button>\n</div>\n</div>\n</div>\n</div>";
	var id1="components/lbDialog/lbDialog.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbErrorModal\" ng-class=\"{ 'lbErrorModal-warning': vm.warnLevel === 'warning' }\">\n<header class=\"lbModal_header\" ng-switch=\"vm.warnLevel\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2 ng-switch-when=\"info\">\n<i class=\"ico-info-circle\"></i> {{ ::vm.errorMessage }}\n</h2>\n<h2 ng-switch-default>\n<i class=\"ico-fontawesome-webfont\"></i> {{ ::vm.errorMessage }}\n</h2>\n</header>\n<div class=\"lbModal_body\">\n<p>{{ ::vm.errorDesc }}</p>\n<p class=\"modal_note\" ng-if=\"vm.instructions\">\n{{ ::vm.instructions }}\n</p>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>\n</div>\n";
	var id1="components/lbErrorModal/lbErrorModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2>Fare Conditions - {{ vm.carrierName }}</h2>\n</header>\n<div class=\"lbModal_body\" ng-switch=\"vm.rulesType\">\n<div ng-switch-when=\"ExternalUrl\" ng-bind-html=\"vm.fareRulesText\"></div>\n<pre ng-switch-default>{{ vm.fareRulesText }}</pre>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>";
	var id1="components/lbFareRulesModal/lbFareRulesModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbHotelResultsCardItem_rating rating-stars {{ 'rating-' + vm.stars }}\" ng-class=\"{ half: vm.isDecimal }\" ng-attr-title=\"{{::vm.rating}} out of 5\">\n<i class=\"ico-star star1\"></i>\n<i class=\"ico-star star2\"></i>\n<i class=\"ico-star star3\"></i>\n<i class=\"ico-star star4\"></i>\n<i class=\"ico-star star5\"></i>\n</div>\n";
	var id1="components/lbFiveStarRating/lbFiveStarRatingTemplate.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLoadingPlaceholder\">\n<div class=\"lbLoadingPlaceholder_content\" ng-transclude></div>\n</div>";
	var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholder.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLoadingPlaceholderItem\" ng-class=\"{\n      'lbLoadingPlaceholderItem-heading': vm.isHeading,\n      'lbLoadingPlaceholderItem-small': vm.size === 'small'\n     }\" style=\"width: {{ ::item.width }};\" ng-repeat=\"item in ::vm.items\">\n</div>";
	var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1061:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLocationSelect\">\n<ui-select class=\"lbLocationSelect_input\" name=\"{{ ::vm.name }}\" on-select=\"vm.select($select.selected)\" ng-model=\"vm.location\" ng-required=\"vm.required\" ng-disabled=\"vm.isDisabled\" use-custom-group-label=\"true\" ng-class=\"{ sctUiSelect: vm.sct }\" uis-open-close=\"vm.onOpenClose(isOpen)\">\n<ui-select-match class=\"lbLocationSelect_match\" allow-clear=\"true\" placeholder=\"{{ vm.placeholder }}\">\n<i class=\"ico-marker lbLocationSelect_inputIcon\"></i> <span>{{ $select.selected.displayLabel || $select.selected.Name }}</span>\n<a ng-if=\"$select.selected\" ng-click=\"vm.remove()\" class=\"lbLocationSelect_remove\">\n<i class=\"ico-cancel\"></i>\n</a>\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.locations | orderBy:'IsBlocked'\" refresh=\"vm.refreshLocations($select.search)\" refresh-delay=\"200\" group-by=\"vm.groupBy\" disable-group-headers=\"true\" footer-text=\"{{vm.dropdownFooterText}}\" show-footer-text=\"{{vm.showDropdownFooterText}}\" ui-disable-choice=\"item.IsBlocked\">\n<span class=\"location_choice\" ng-class=\"{ 'location_choice_header': item.isGroupHeader }\">\n<span ng-if=\"item.hasCode\" ng-bind-html=\"item.Value | highlight: $select.search\" class=\"location_choice_code\"></span>\n<span ng-bind-html=\"item.displayLabel | highlight: $select.search\"></span>\n</span>\n</ui-select-choices>\n</ui-select>\n<i class=\"button_spinner lbLocationSelect_loader\" ng-if=\"vm.showLoader\"></i>\n</div>\n";
	var id1="components/lbLocationSelect/lbLocationSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1063:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div role=\"dialog\" class=\"lbModal {{ ::vm.options.className }}\" ng-class=\"{ 'lbModal-scroll': vm.options.scroll }\" ng-if=\"vm.modalContent\">\n<div class=\"lbModal_wrapper\" ng-style=\"{ width: vm.options.width }\">\n<div class=\"lbModal_content\"></div>\n</div>\n</div>";
	var id1="components/lbModal/lbModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbPoiSelect\">\n<ui-select class=\"lbPoiSelect_input\" name=\"{{ ::vm.name }}\" ng-model=\"vm.location\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" on-select=\"vm.onSelect()\">\n<ui-select-match placeholder=\"{{ ::vm.placeholder }}\">\n{{ $select.selected.Title }}\n<i class=\"ico-cancel lbPoiSelect_clear\" ng-if=\"vm.allowClear\" ng-click=\"$select.clear($event);vm.onRemove();\"></i>\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.options\" refresh=\"vm.refreshOptions($select.search)\" refresh-delay=\"vm.refreshDelay\">\n<i class=\"ui-select-choices-row_icon {{ item.Type | locationIconFilter }}\"></i>\n<span ng-bind-html=\"item.Title | poiHighlightFilter: $select.search\"></span>\n</ui-select-choices>\n</ui-select>\n<i class=\"{{ ::vm.iconClassName }} lbPoiSelect_icon\"></i>\n<i class=\"button_spinner lbPoiSelect_loader\" ng-if=\"vm.showLoader\"></i>\n</div>\n";
	var id1="components/lbPoiSelect/lbPoiSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbSearchResultsProgress\">\n<div class=\"lbSearchResultsProgress_mask\" ng-if=\"vm.finalStep\"></div>\n<ul class=\"lbSearchResultsProgress_list\">\n<li class=\"lbSearchResultsProgress_list_item\" ng-repeat=\"item in vm.itinerariesService.itinerary.Search.SearchTypes\" ng-class=\"{ active: vm.locationService.currentSearchType === item && !vm.finalStep }\" ng-click=\"vm.gotoSection(item)\">\n<div ng-if=\"item === 'Flight'\">\n<i class=\"ico-flight item_travelIcon\"></i> Flight\n</div>\n<div ng-if=\"item === 'Rail'\">\n<i class=\"ico-rail item_travelIcon\"></i> Rail\n</div>\n<div ng-if=\"item === 'Hotel'\">\n<i class=\"ico-bed item_travelIcon\"></i> Hotel\n</div>\n<div ng-if=\"item === 'Car'\">\n<i class=\"ico-car item_travelIcon\"></i> Car\n</div>\n</li>\n<li class=\"lbSearchResultsProgress_list_item lbSearchResultsProgress_list_item-last\" ng-class=\"{ active: vm.finalStep, 'lbSearchResultsProgress_list_item-inactive': !vm.finalStep }\">\n<div>\n<i class=\"ico-check-1 item_travelIcon\"></i> Confirm\n</div>\n</li>\n</ul>\n</div>";
	var id1="components/lbSearchResultsProgress/lbSearchResultsProgress.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTimeSelect\">\n<ui-select name=\"{{ ::vm.name }}\" ng-model=\"vm.selectedTime\" search-enabled=\"true\" ng-required=\"vm.required\" time-format=\"{{ vm.timeFormat }}\" lb-future-time=\"{{ vm.date }}\" lb-sequential-time=\"{{ vm.sequentialTime }}\" lb-sequential-time-date=\"{{ vm.date }}\" lb-sequential-time-before-date=\"{{ vm.beforeDate }}\" lb-sequential-time-before-time=\"{{ vm.beforeTime }}\">\n<ui-select-match>\n<i class=\"ico-clock bookingform_match_icon\"></i>\n<span class=\"bookingform_match_span\">{{ $select.selected.label }}</span>\n</ui-select-match>\n<ui-select-choices repeat=\"time.value as time in vm.times | filter: $select.search\">\n{{ time.label }}\n</ui-select-choices>\n</ui-select>\n</div>\n";
	var id1="components/lbTimeSelect/lbTimeSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbModal_header\">\n<h2><i class=\"ico-fontawesome-webfont\"></i> Idle Timeout</h2>\n</header>\n<div class=\"lbModal_body\" idle-countdown=\"countdown\">\n<p ng-switch=\"countdown\">\nYou will be logged out in {{ countdown }} {{ vm.getCountdownNoun(countdown) }} due to inactivity.\n</p>\n<div class=\"modalProgress\"><span class=\"modalProgress_indicator\" ng-show=\"countdown > 0\" style=\"width:{{\n    (countdown / vm.timeoutValue) * 100 }}%\"></span></div>\n</div>\n<div class=\"lbModal_actions\">\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.close()\">Continue using Lightning book</button>\n</div>";
	var id1="components/lbTimeoutModal/lbTimeoutModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbToggle\" ng-click=\"vm.toggle()\" ng-class=\"{ 'lbToggle-active': vm.isActive }\">\n<div class=\"lbToggle_icon\"></div>\n</div>";
	var id1="components/lbToggle/lbToggle.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<ng-form name=\"vm.lbTripOptionsCarForm\" class=\"lbTripOptionsCarForm\">\n<div ng-repeat=\"search in vm.searches track by $index\">\n<lb-trip-options-car-form-item search=\"search\" is-last=\"$last\" index=\"$index\">\n</lb-trip-options-car-form-item>\n</div>\n</ng-form>";
	var id1="components/lbTripOptionsModal/lbTripOptionsCarForm.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTripOptionsFormItem\" ng-class=\"{\n         'lbTripOptionsFormItem-disabled': !vm.search.isActive,\n         'lbTripOptionsFormItem-last': vm.isLast\n     }\">\n<div class=\"lbTripOptionsFormItem_flightDetails\">\n<h3 class=\"lbTripOptionsFormItem_flightDetails_title\">\n<i>{{ vm.index + 1 }}.</i>\n{{ ::vm.search.flight.Arrival.Location }} ({{ ::vm.search.flight.Arrival.Code }})\n</h3>\n<div class=\"lbTripOptionsFormItem_flightDetails_times\">\n<div title=\"Departure time\">\n<i class=\"ico-icon-takeoff\"></i> {{ ::vm.search.flight.Departure.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n<div title=\"Arrival time\">\n<i class=\"ico-icon-landing\"></i> {{ ::vm.search.flight.Arrival.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n</div>\n<lb-toggle is-active=\"vm.search.isActive\"></lb-toggle>\n</div>\n<div class=\"lbTripOptionsFormItem_form\">\n<div class=\"lbTripOptionsFormItem_form_row\">\n<div class=\"lbTripOptionsCarFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Pick up</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-location-select name=\"{{ 'carPickUpLocation.' + vm.index }}\" location=\"vm.search.car.pickUp.Location\" required=\"vm.search.isActive\" is-disabled=\"!vm.search.isActive\">\n</lb-location-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Date</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'carPickUpDate.' + vm.index }}\" date=\"vm.search.car.pickUp.Date\" min=\"vm.search.car.pickUp.minDate\" max=\"vm.search.car.pickUp.maxDate\" range-from=\"vm.search.car.pickUp.Date\" range-to=\"vm.search.car.dropOff.Date\" required=\"vm.search.isActive\" is-disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Time</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-time-select name=\"{{ 'carPickUpTime.' + vm.index }}\" date=\"vm.search.car.pickUp.Date\" time=\"vm.search.car.pickUp.Time\" sequential-time=\"false\" anytime=\"false\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-time-select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"lbTripOptionsFormItem_form_row\">\n<div class=\"lbTripOptionsCarFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Drop off</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-location-select name=\"{{ 'carDropOffLocation.' + vm.index }}\" location=\"vm.search.car.dropOff.Location\" required=\"vm.search.isActive\" is-disabled=\"!vm.search.isActive\">\n</lb-location-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Date</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'carDropOffDate.' + vm.index }}\" date=\"vm.search.car.dropOff.Date\" min=\"vm.search.car.dropOff.minDate\" max=\"vm.search.car.dropOff.maxDate\" range-from=\"vm.search.car.pickUp.Date\" range-to=\"vm.search.car.dropOff.Date\" required=\"vm.search.isActive\" is-disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Time</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-time-select name=\"{{ 'carDropOffTime.' + vm.index }}\" date=\"vm.search.car.dropOff.Date\" time=\"vm.search.car.dropOff.Time\" sequential-time=\"false\" anytime=\"false\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-time-select>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
	var id1="components/lbTripOptionsModal/lbTripOptionsCarFormItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<ng-form name=\"vm.lbTripOptionsHotelForm\" class=\"lbTripOptionsHotelForm\">\n<div ng-repeat=\"search in vm.searches track by $index\">\n<lb-trip-options-hotel-form-item search=\"search\" is-last=\"$last\" index=\"$index\">\n</lb-trip-options-hotel-form-item>\n</div>\n</ng-form>";
	var id1="components/lbTripOptionsModal/lbTripOptionsHotelForm.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTripOptionsFormItem\" ng-class=\"{\n         'lbTripOptionsFormItem-disabled': !vm.search.isActive,\n         'lbTripOptionsFormItem-last': vm.isLast\n     }\">\n<div class=\"lbTripOptionsFormItem_flightDetails\">\n<h3 class=\"lbTripOptionsFormItem_flightDetails_title\">\n<i>{{ vm.index + 1 }}.</i>\n{{ ::vm.search.flight.Arrival.Location }} ({{ ::vm.search.flight.Arrival.Code }})\n</h3>\n<div class=\"lbTripOptionsFormItem_flightDetails_times\">\n<div title=\"Departure time\">\n<i class=\"ico-icon-takeoff\"></i> {{ ::vm.search.flight.Departure.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n<div title=\"Arrival time\">\n<i class=\"ico-icon-landing\"></i> {{ ::vm.search.flight.Arrival.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n</div>\n<lb-toggle is-active=\"vm.search.isActive\"></lb-toggle>\n</div>\n<div class=\"lbTripOptionsFormItem_form\">\n<div class=\"lbTripOptionsHotelFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Location</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-poi-select name=\"{{ 'hoteLocation.' + vm.index }}\" required=\"vm.search.isActive\" location=\"vm.search.hotel.Location\" disabled=\"!vm.search.isActive\" disable-placeholder=\"true\">\n</lb-poi-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Check in</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'hotelCheckIn.' + vm.index }}\" date=\"vm.search.hotel.dateFrom\" min=\"vm.search.hotel.minDateFrom\" max=\"vm.search.hotel.maxDate\" range-from=\"vm.search.hotel.dateFrom\" range-to=\"vm.search.hotel.dateTo\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Check out</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'hotelCheckOut.' + vm.index }}\" date=\"vm.search.hotel.dateTo\" min=\"vm.search.hotel.dateFrom\" max=\"vm.search.hotel.maxDate\" range-from=\"vm.search.hotel.dateFrom\" range-to=\"vm.search.hotel.dateTo\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n</div>\n</div>\n</div>";
	var id1="components/lbTripOptionsModal/lbTripOptionsHotelFormItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbTripOptionsModal_header-hotel\" ng-if=\"vm.options[vm.activeOptionIndex] === 'hotel'\">\n<div class=\"lbTripOptionsModal_headerIcon\">\n<i class=\"ico-bed lbTripOptionsModal_headerIcon-main\"></i>\n<i class=\"ico-add lbTripOptionsModal_headerIcon-sub\"></i>\n</div>\n<p class=\"lbTripOptionsModal_headerIntro\">Add a hotel to your trip</p>\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n</header>\n<header class=\"lbTripOptionsModal_header-car\" ng-if=\"vm.options[vm.activeOptionIndex] === 'car'\">\n<div class=\"lbTripOptionsModal_headerIcon\">\n<i class=\"ico-car lbTripOptionsModal_headerIcon-main\"></i>\n<i class=\"ico-add lbTripOptionsModal_headerIcon-sub\"></i>\n</div>\n<p class=\"lbTripOptionsModal_headerIntro\">Add a car to your trip</p>\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n</header>\n<form name=\"vm.form\" ng-submit=\"vm.submit()\" novalidate>\n<div class=\"lbModal_body lbTripOptionsModal_body\">\n<div class=\"lbTripOptionsModal_validation\" ng-if=\"vm.form.$invalid && vm.form.$submitted\">\n<div class=\"lbTripOptionsModal_validation_error\" ng-if=\"vm.form['vm.lbTripOptionsHotelForm'].$invalid\">\nPlease check all active hotel searches\n</div>\n<div class=\"lbTripOptionsModal_validation_error\" ng-if=\"vm.form['vm.lbTripOptionsCarForm'].$invalid\">\nPlease check all active car searches\n</div>\n<button type=\"button\" class=\"lbTripOptionsModal_validation_close\" ng-click=\"vm.form.$submitted = false;\">\n<i class=\"ico-cancel\"></i>\n</button>\n</div>\n<div ng-show=\"vm.options[vm.activeOptionIndex] === 'hotel'\">\n<lb-trip-options-hotel-form searches=\"vm.searches.hotels\" options-form=\"vm.form\"></lb-trip-options-hotel-form>\n</div>\n<div ng-show=\"vm.options[vm.activeOptionIndex] === 'car'\">\n<lb-trip-options-car-form searches=\"vm.searches.cars\" options-form=\"vm.form\"></lb-trip-options-car-form>\n</div>\n</div>\n<div class=\"lbModal_actions lbTripOptionsModal_actions\">\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.prev()\" ng-if=\"vm.activeOptionIndex > 0\">\n<i class=\"ico-chevron-left\"></i> Prev\n</button>\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.next()\" ng-if=\"vm.activeOptionIndex === 0 && vm.options.length > 1\">\nNext <i class=\"ico-chevron-right\"></i>\n</button>\n<button type=\"submit\" class=\"lbTripOptionsModal_submit button-primary\" ng-disabled=\"vm.saving\" ng-switch=\"vm.saving\" ng-if=\"vm.activeOptionIndex === vm.options.length - 1\">\n<span ng-switch-when=\"true\"><i class=\"button_spinner\"></i> Updating...</span>\n<span ng-switch-default>Update &amp; Continue <i class=\"ico-chevron-right\"></i></span>\n</button>\n</div>\n</form>";
	var id1="components/lbTripOptionsModal/lbTripOptionsModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAPAAA/+EDL2h0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBQ0JEOTFFNjEyQTgxMUU3OTg2MUQ2N0M3NzY4MjdBQSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBQ0JEOTFFNTEyQTgxMUU3OTg2MUQ2N0M3NzY4MjdBQSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4RDNGOERERTg3MkMxMUU1QjlBNTlFMkM1RDE3RkQwNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4RDNGOERERjg3MkMxMUU1QjlBNTlFMkM1RDE3RkQwNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEAAYEBAQFBAYFBQYJBgUGCQsIBgYICwwKCgsKCgwQDAwMDAwMEAwODxAPDgwTExQUExMcGxsbHB8fHx8fHx8fHx8BBwcHDQwNGBAQGBoVERUaHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fH//AABEIBDgHgAMBEQACEQEDEQH/xABqAAEBAQEBAQEBAQAAAAAAAAABAAIDBAcGBQgBAQEBAQEBAQEAAAAAAAAAAAABAgMEBwYFEAEBAQEBAQADAQEBAQEAAAAAARECEgMhMRNBYVFxgREBAQEBAQAAAAAAAAAAAAAAABEBEgL/2gAMAwEAAhEDEQA/APwzyP4KBAgQIECBAgOAlVAgMBYCRUCBAgQHAAIECBAgRgFEmiQQCrgFAIgFUZqgBUAoKYM2qM2gLWmWaoAFqozVBaAUFAaoGkACgAQIECA4CwFgHAWCoCCwDIBwFgHAWAsA4CwDgGQFgIDAWIqAAsAYoMBYCxUWKM4UGLQWAMUF5EZsUFijOKCwRmxQYozigxRmwBigwBigwQYoMUAqwQVcBQABcUYogFAKAFVGRQoAAJVGCrADQsRcGAsaUUEABYCwCCFWAcBYCwFgCggGAsBWAMaBYAwFgLAWKLAWAAOK0sEWBUIgCiBAgQIEBUQAFgqwFgVKqBAMBYABCpRVQAgQIECwKAqFWAgQIECBY0iwFgIFgIECBAlVAgQMggKiAAlgtIHaQWxAggZ1oMBAgKCESiAggQIEGPpD8S5IECBAgQIFiqcBQDgLAQJFQLAOAsBAgQIEABAgQBUQIEioQWqDQQIBaozauDIqAWqgXAWqM0TRojNaBoaLRGbVwC4M1QVQVcTQogZBAsBYCwEBDFgpwFgasEhxFOAcBYCkA4CwDgLBViBwCCwDICwFgLAWKHAGAsAYCsUGAMBKLAGLUFgDFBigsBmwRmxQYoLFGLFBigsEZsUZsUGKCxRmwBYAxoAKgBBYAxQWLihQYCAWKDAWALFGVVYKLAALFUYCAVcBlA4KMBYCwFiqsKLAWC4fIHzUofJReSi81asXkoPJUHkoPKi8gMAYC8/8Wg8gvKgwFgLFBgLAUgJRYAsBYoAIICoMBZQQIECBAgCqlABxFFXBYoMBYCBAgWAMFSgBAgQIECBAgQICogAIEogQIXEogQCggQIACaECBAgQIEBgIEBEIIECBAgQPpD8S5IECBAgQICqoCCBAkqkECBAgQIEC0FoAEQVECiBANBaA0EQBBaotBnVgP2AAVQKm6LSFZtUotEZtWAtUrNEFqwC4C1Rm0BqpRVwSiAYCwFgRYEQQ4EWCmRA4UWFDiCwGsBYCwELCEQQgsBYBBAcBAsKHCiwosKLFoigKLAWAMAYorAAJQCDFBVBgCxVZsEgsVIzeVILFpGbFIzYqM2AzYtBYtBYozigwBYoLFAAwRWAyoMUFhVCiAYoMBAAZxaqUWCjAGLRYKMBYCwosFqwFi0WIsWFF5KHytVeUo14KLylGvBVXgpD5/4VR4KDwUF4WpBeFoPBUHlaDyUGKLBYMCLyEHlaisXNGcKLFBYCxaAECUGAsAglRAgQIFgoxREAQSqgQIEFWFKlACwFgowFgIFgDBVgixVWAgAIDAKgwFgIECAAsUIIBRcSiBAMBYCAKIglECBIqVECBAdBAgIERAgQIECWD6Q/EOSBAgQIEBgICqoECQMFQIECBAgVAaCBAtVACBANqitTQaAUIIGdAaoNACpU1CMgKuGs2qgoC0GWgCC0GWgAKoKAVBVwSiBAgQqgHAQHE0KBwFgHAQHCiwqpBAcBAYosA4CBYBBAkDgDAQJRAsAKIECAVQYCwACxQYqCwzRmxaqxUGAzYozYYDGhmxcRmxRmwBYozYqM2KDFGeouAAYAVEDOKAFRWWhAAWKCwBgDFVYCwUYCwBiiwVeQHkFgHBcWFU+QXkD5A+UUzkGpwgfBRrwVcXhKq8UovBReFozeAZvC5qaLytQXlaC8lGfC0XkrQ8lB5Wg8qyLyAvKgsUFgDFBgKxQKLAWCLAWKLAAIECBKqUGAsBYKAQIECVECFWAsACoECwACBAgSiFQJRAgGggQIEogQCi4lECBAgABcEogQIEiiqICIgQEEBAiIECBAgGtD6S/ERyQJBAgQIDAQFVQIEBSCBaKgQIACBAtVBQQIBTAKLQAIFoBQaC0QUEA1QUAA1UC4M1cBVGaAEFUZqgoJQABNCgUWAsUWJocQOLVWIKQDiBBYKQMgIFgHAWAcBSAQQIFlA4CBAgILAP4BZAOCrAFn4AYIsUWALAWKLAWALPyoMAYCxQYAwF5UHlRm8lQYozYtGbytGbyqM3loZsBnFBYqM2KDFGbAZxRAMUGALFBgLzVoMKLyUGUFYosFHkVXkB5UHmgvIo8gvILwtD4KLxUrS8FD4KHwUM+aUa8FUz5pRqfNKrU+aUjU+ZVa/mlF/Iof5FUX5FB/JaD+a1Gb81ozfmtGbwUF+a1B/NaQfzKovzWg8FBeVozeFqazeVqM+VBeVozYoziixQYAxRYIsAAgWKLAWAsAAlwWKqBfgECQSiVFgqsAAgAIEKsBAgAqBAsBYAUSiBLggFRUogQIEAqqgQIEuDKiBAgQLRRoAECAwCCEQECC0ECBAgQIH0jX4txq0KtSFJBIIECA6C0CKoogQIECBAgQKgAQLQGkAotAAtAAtUGiDQQIBoLQZ1RALSFZaiDTMBa0M6ABCM1cAoKQSgoJYgwFgLAS0WAsQhwqlBCnAOAsA4BnILEoVFICwFgHAWAsBSARaBDgIDgpwFgRYEWAQWAsAYEWKRYEGBBikWFIikQQKRYEWALyA8hF5WovJRmxaC8gz5WjN5WjN5azUZvK0ZvK1IxeVGbFGbAFjVRnFBYDOKLFBgDAWLRYUGFFhQeSqvJRZSi8lVeVovJReaVYPBReCh8FWLwUi8FIfBVPhKGcFVqfNKGfMo1PmlGp8qlWNT5VOhufKp0rU+RVM+SUa/l/wov5f8SkV+S9DN+VWjN+ZUZvz/41Ri/NaC/JaM35LRn+ZQfzXoX81oz/ADKM35rRm/OrUYvDVIzeFqMXlRm8tUZvKgxQXkBigxUGAMBYCKJRAgCwQJVQIECwFgLCosUWAMBYKsBYAwFgLFFiABChRCpBYosUAJcECACoECBLACoECAaoFECBAhRgLAQIEBBAgSwSIgIIEBBAgSwfRn4pwWgQOgtSLSCQQIEC0DoLQKqAWgtBaC0FoLQAIgNUWgASgBUQANBAAWgtUZoIFpCs2qg0FVGauAUAChoogq4BcFVACAYCwFgLAWAZAWAsFOAcA4lDIUWFDgHAWAsKKQocKLFECAgAQIDgLAKKgMiiQIqwDgiwosKLFUYAsBYIrAGKqwFig8gfILyA8lD5Kg8lBeVBeCjPhaM3laRm8tZqMXlRm8rRi8riM3lUYsUZsUFjQLBGbGsBgDAXkF5BeQXkF5hVPkqrwUXgofBVg8FF4KHwVYv5lF/OlF/MqmfMof5xKH+ZVM+aUM+ZRqfNOlanyTdI1/IpG58kqtT5M7o3PlUo3PiVYZ8ko1/Iov5Uqi/KlNZvzWozfmtGL81ozfm1Rm/NaD+a0ZvyKD+a0ZvyWjN+S0F+a1GL81oxfmtHO8NVGLx+Gs1GLwtGLy0M3lcGcVBeVGbDAYqjFQUEAUQIEogQIECBAAQFRKIEABYCwBYCVUAQQCqoUQEVAKAXBAgFBCoEuABCoECBloQIECBAhUCBAsBAgQJRAhECBAdBaC0FoPo+vxbggQICggOgdiRagSCBAgQIECBAlEQSqNBaABAFEAEQAEAAKIACAVUABRUGWgAgFABqEZaACUGAsBYCwFgHAWJQ4VVItDiBwDiBwFguHCqcBYIsBYCwNWKhwVYGoRCoEEQIDICwUwDiCkQanILyB80F5oLzQV5AeQHlaLFoMKLFosKLCkXkpDhReUD5gsXgFeFqDwUF4WjN4KM3haM3hrNGLytRnrlqoxeVo53lc0ZvLVRi8qM3laM3lqoMWgwoshReYUXkF5Sh8FD4KsM4KHwlVTgof5pVi/mUP8yqv5lF/Mof5lD/ADKpnySh/kUM+SUanyKrU+SdEanyKrU+SUanySjc+KdLG58k3VjU+TNI3PklDPkUP8yh/mUZvzWjN+a0ZvzaqRi/NaMX5rQX5rRm/MoP5LRn+S0F+RRm/JaM35NUc781zUY6+bWaOfXzazRz6+bVHPr5rmjneGqyxeGs0YvKjN5qgxRmxUFiqzYqDACgwFgJRCIECBAgQLAWKLAWAVECxAWKoAWKqAAsAVRCoEABAKuKgQIAKgS4CghUCAKBRAgQIBgpBAgQIECUWggQIRAgQIECBA+jen4xwXoDKgdBAgOoLQWgtA6kWrSFWkKtIVaQp2EKthCjVKtCrQotCrQo1Yi0XFoAEA0EoAWhUA0ACCi1UABYIBoBoAIBgIAEGLQWCJRYKsBYCwDgLAWIHChwocFhnKEM5CHyEWBDgq8gvILzQWAsVFgQAhUogQIDgLAOAZEDOSjU5QMgGc1KHzUqnyUXkovK0XkoPJReCg8qReQXmFB5UXkD5Sh8FDOCqf5lIf5pSL+ZSL+a0jN4KC/NajF4WkZvDWaRi8LUjHXDVHO8LmpGOuGs0c7y0jF5VGbytGbytSDytIPK0i8lIvJSHwlIZwVTOEo1OKVTPmlWNT5lIZ80pGv5lUz5pRfyKp/kUP8AIov5VKH+RVhnxKQz4p0RqfJKrU+RRqfJOhqfI6WNT5JSNz4pSNT5JWm58k6G58k6DPklGp8ii/mUX8igvyWjF+a0ZvzWoxfmtGb8mqkZ/mUgvyWkH8lpB/Iqxm/JakF+S0jF+S56I59fJqjn182s0cuvm1mo59fNrNHPr5tZo5dfNrNSOfXDWaMXitVGLytGLy1RixaM2LUZsUGKDAGKABVABEQJRAsA4CBAgQIECBKDBQAxRCoBigBCoFgAFi4oBAgAqWABAlioAogWAsAAgQIVAgQIECWABAgMoLQQiBAgSiIIg+iPxbgtAygZfyB1A6C0ECBAdBaC0FoBBAgQJRfgBoLQQIXFoDVFaA0KtCi0EIqKAAiXAAASiAAK0AECAYCBYAxReSosFWAsA4gsA4LD5CHyC8lDiVThQ4EPkVSCHAWAsBYAxUVgDBQCUWAsUWIEFgGAZEGpAaxAzkqtTlKNTlKHzUqnwUh8FF4Kq8UoPBQXlaDytSLyUi8FReCrF4KRqcFUzhKGcFGpwlD4KLwUX8yqL81qM35rmjHXzWjF+bVRjr5rRzvLWakY64Wo59cNZo59cN5qRi8rUYvK0Y8tEF5VB4KHyCnEBrwKZwlGpwm6Nz5s1Y1PmlVufIoZ8kqtfyToM+Rvoa/knSn+R0Qz5FF/JKp/kUanyKH+KVWp8Uo1PkdDU+SdLGp8k6Gp8kqtT4pRufIo1PklGp80qmfIof5lF/MoP5rUZvzKM35tUZvzWoxfmtGb81oP5rQX5lB/JaD+ZQX5FBfktGL82s0c+vm1mmuXXzazUcuvm1mjl382s1HLr5t5o5dcNZo5dcNVNc+uGs1HPrlrNGOuWhzvKjN5aRjqLgzjQxQCgBKowRCIEogMBAgQIECBAgSqgFAAKqoEAqgFSoqKEEuKAQIAKFECUQIUKIECBAqABAgQIEKgSgoIECBAdBCIECXBKIH0OV+Lec6ggQHQMoLQWgdBaC9Iq9AvQLQWgtILSC0FoDQWqLQGgtBaA0FoLQQAFoAEC1QAFECoBcAosBYCwFgLAGAsBYCygfJVi8lDOUofJQ+Si8lU+UofJQ+Sh8oLyB8lU+SkPkF5CLytB5KDKtRYAwIMUGAsBYCxRSIHAXkGsAzlBqclVucs0anKUanCVW5wlUzhKNeCqZwlF4KK8FILwtIPC0HgqLwtF4KLwVV/MoZwUanCUanCVY1PmlD/ADKHwUX8yjN+a0F+a0YvC1GOuGs1HPr5tUc+vmuakc+uGs0c+uG81HLrhc1GOuG81HO8NZozeFqM+FovBRTgoZwlG5wlWNThKrc4Sjc+aUb5+bNVufNKsanySkanzKrU+TPQ1/L/AIdB/l/w6DPknSwz5HRD/IpDPkVWv5JRqfJKQz5FVqfJKNT5pRqfMqtT5JRqfNKNT5lD4KLxP/Ci8FF4KC8KM3haM3hajF4WjN4Wg8LQeFoLwUX8yg/mUF+a0ZvzWozfmtHPr5rmjl18280cu/m1mo498N5o5d/NrNHLrhvNRy64azRy64azRy64azWXLrhrNHO8t5o52NDFi4jHUUYsaGaAqgVUIKIlECAwECBAlECBAgQIAKASqsUAKgyogQIUCoBQSgFAIEogQIUKIECBAgQIEABAlECFQAECBAoBESqqoAIPoOvxkeVEDqBlFOoIEC0FoLQX5FX5BfkFoLaC2gvyC/IL8glECAAtBaC0FoLQWggQAFQABRAgVALgFEBkBYlFhViwpD5pSLyUi8lD5SqfILyB8oHyUM5KHylU+Sh8FD4Sh8FWHyUhnJSHyUivBSDyUi8qQeSmiwqDFoLyoPKgwosBYqLAWAcQMhVMgNzlmjU5SrG5wlG5ylVucM1Y1OEpG580qxqcJQ+EqrwtF4KDwVBeItBeFpB4KkXgpFOCqfBRqcFVqfNOhqfNKGcJRr+ZReCivBQeFozeFzRi8NUY64XNSOfXDWakc+uGs1HPrhrNHLrhrNSOXXDeajn1w1Uc7y1mjN4WkZ8LReCh8AZwlI3OEo1zwlV05+abo6c/NmrHSfNndXMbnzSkbnySrG58maRqfIpD/JKsanyKGfJKp/kUP80oZ8yhnzKNT5JQz5nSn+Z0NT5pRqfNN0anzpVhnzSkPgpD4KReCkF5WoPK0ZvK0ZvKjN5UZvMVGbytB4Wg/mUXgovBReCivC0YvC0ZvC0Y64XNRy64bo5dfNrNSOPfDeaOPXDWaOXXzbzUceuGs0cuuG80cuuGs1HHrhrEcuuW80cuuWqOfXLWDnYqMWNDFigUZqiUBBCIFgEECBAlECBAgQIAqgEKlAIhQogAIUAhUoAFgoBKEEoKggSiBAvwCA4AwWrAqwKlBYCwACBCoRWAsFGUDiiIi1VFBAgfv5X455ToHUDqC0hTpCrUhV6Cr0KvQL0C9AvQL0B0Fv8AwFt/8Bbf/AW0BoLQWgtBaotILSC0VbEEC0FoAEA0EogQKgFwCjWIKQDiBwaWAcA+QXlN0PlKHyBnKVT4KNTgofKUPgoZwlWGcJSNTgqnwUPgoZyUi8lIvJReCqPK1BeCjN4WgvK1GbytQeVB5KDyUXlaLyUM5KHyUM5SjU5/KK3zylI3OWd1W5wlV0nCUbnDO6rc4ZqtThKNThKGcFU/zKDwUF4WoPC0HgovC0X8yi8FDOEoZwUanCVWpwUa8IHwUP8AMoPBQXhaC8LRz64WozePwuaOfXDeaOfXDWajl3w1mjl1w1msuXXDeaOfXDWamufXDWajF4WjPhaLwUM4KNThKNzhKOnPzZqx05+abo6c/Nmq6T5s7qunPzSq3PmzRqfNKrc+ZQz5pRqfMof5lF/NKH+ZVP8AMofBRr+aVYZ8ykP80pGpxChnCUa8lVeSh8lF5hQeVqC8rhrN5EZsUYsawZsUZsVBgLFovJReSi8lF5KC8lBeGqMXlRjrj8Lmjl1y1mo59cN4OPfDWaa49cN1HLrhrNHHrhvEcuuGs0ceuG81HHvlvEceuWsHLrlvBx6jWDnYqOdjeDFUYqgVQqJQCKIEECBAgSqhECBAgQoqiUAqAKiACqgBUABCpRUBQZFQJQqIAglEBwECBAgSiILRUAAYCoAECURBIJcVKAECA4D95r8e8i9IHQOgdSC0U6CIIgtILSC0gtILUFtBbQPoB6Fxb/0FoLQWgNBaodBaC0FoHUFoIFqKNBAlECBUFASiQIuGQGsFOMhkAzmlVqcpQzhKNThKsanCUM4KrU4ShnzSjU4KH+ZVhnzTdIf5pSH+ZVhnzKH+ZReCkXgpF/MpBeFqRm8LSM3haM3lakZ8LQXhaDwtB4WovBSHwUinBRrwlUzhKNzhN0anCVXTnhndVucM7o6Thmq3OEqtzhKNThKNTgqnwUi8pSLwtIPJQeFqDxCg8LReChnBSGcFI1OEqxqcQpGpwlD5SqfJUXkovMKovK5qM3lajHXKjF5azRzvLWajHXDWaOXXDWaOXXDeay5dcNZo59cNZqOfXDVSOd4WkHhai8QoZwVY1zxE3VdJwzR054SjpzwzurmOnPDO6rrzwzRucJVbnCUbnH/EqtThKHwUM4/4lD5KLz/wo15hVXgofNSh8lUzlKNTkQ+Z/wCFUzmJQ4IsUVhijFBYozYqazVRlRmxRixcBiiyCLAGKpkQOCLAFgM2KM2NZo52NDn1y1iOfUawce43iOPXLWDl1y3g5dc/hrEceuWsHHvlvEce+W8Rx75awceuW8HHrlrBy6jWI5dRvBixoYoM4oKuAUSi/wBRECBAgQJRCoECAAlECUCioAECBVVZoJFSgFQIACwFiqgFUQIECBAgQIECBAGhAgSAwVYCwFYuAUQIECwVAhED9zr8hHkWkDqRToHUDKC0F6BegXoF6BegXoF6FXoF6A7AWgtCrYAvQL0C0ItCLQh1FWgdAggQJFSogSKgQLAQIDILDIGNSIrUiUanKDU5Krc5SrDOUpGpwlI3OGarU4KuY1PmlI1PmlI1Pmm6sM+aUjX80qn+ZQ/zKGfMof5pSLwUi8FIvBSDwtBeFozeFoxeFqQXhakYvC0gvK0HlaDwVF4hQ+ChnBVjU4KQzhKRucJurG5wzRvnhKrpOGd1Y3OGaRucJVjc4SkanMSq14KHyUHkovK0ZvJQeVovMKkHkpF5WkPlKLyVWpyUanKUanIHEDgLAXmFBeVGbytRi8rSMXlqo53lRjrlrNRy65azRz65bzRy65azUc+uW81HPrhajN4UZvCkE4CNzgo1zwlVucM0dOeEpHTnhndXHXnlndVvnhKrpOGd0bnKUanKUanKVT5KQ+UpD5KReVpD5iVVkA+QM5A+QM5AyIHAWAsUACxUZVRVTWLGkZsUZqjNhgMUWAsBYoZASCxUGAzYozYoxY1g59RrEc+o1g49RvEcuo1g5dRvBy7jWI49ctYOXfLeI498t4OHXLWI4d8t4OXfLWDj1G8Ry6jWDn1GsHPqKM2KM2KBRKJEQIECBaoNFWgtBaotBAlEQSgBUACBAqqs0EipRABUABKIEoqAFQIFgLAWCLAWAfwCwFigxVQAECBYCIqAKLAAIECBAgfttfkXkOgtQOhToH0gvVIq9UgtILYQWwgthBbAQLQWgdqC2gtoLaC1RaKNAygtQa0VaB0FoFBAtAwECRUCBAgMBqRGmpEo1IDU5QbnKLjU5SjpOWa03OEo1OGarc4Sq3OEo1OEqtz5pQz5pujU+ZRr+aVTPmUh/mlIf5lWL+ZSHwlIv51aQX50qDwUF4WjN4azRi/OLRm8FRm8LRm/Nag8L0L+a0Xj/hQ/zKGfMoZwlVqcJRqcJRvnhKrpOGd1Y3zwlG5wzVbnBRqcpRqcpQ+UosKDItBYoMBYqM3n8qq8gsoLAMgNSIhgpkRTgGFEUWAMEFijNjQxeVqOd5awjHUaxHPrlrEcuuWhz65azRz65azUYvLVGLwtSDytIpyUjU4SkbnCVW+eEo3zwzVdOeE3R054ZHTnlFbnLI1IDc5RT5RTgHICyAsA4CwFgHAMgHAKCwFgBVQgqoyqs1U1mtIzQZaGaYDFFgLAOAgQJRAxVRmqOfTSOfTWDHTWDl01iOXTeDl3GsHLuNYjl1Gxy7jWDj3GsTXDvlvEce43g49xrBx6jeI49RrBz6jWDn1GhiqM1VZqiEQiBKIEKKoAQIEBUQIAogWgAQIECqqAAqBABUABKIECUQIECBCoRAgWAZFFgDASiAYKsBYCUFBABUCBYAoIEo/Z6/JPFT6IGVA6C2pFp0VaC1BaBBAgWgtBaC0FtIHSKtILSC0gtBbAWgUFpFOgdBIpAwCCQQFFQIDIBwDIitSIrc5QanKVW5zWasdOeUpjfPCbqunPDO6rpPmzuq3z80qx0nzZpG5803VanzSjU+aVY3PmlIZ80qxr+aUh/mUP8/8AhQ/zSi8f8KLwUXhaC8FBeFpGbwtRm8LmjN+a0ZvzWpGLwtIP5lF4WpB4WkX8yrD/ADKQz5lDPmlGp80pG580qxufNKrc4Sjc4Zo1OEqtThKrU5KLL/4gcAWKgsUZoiUYqiUQiwEBAgkUwVqJEagIEAq4DFGbFGLFGbFxHPqN4jnY0MdRrBy65VHO8tZozeWqjNig8gpyDU5Bqcorc5Zo6c8pRvnlFdJGRqRB05iK1IgYKUCCwCCBKIEBAoIDoHQQCqCgKuDFUFVNZrSM0GaolBiiwFgL/gLAQJUFBirgxWhjppHPpcHPqt4jn00OXTWDn01g5dN4jn00OXTWI49tYjj1GsHHuN4OPcawceo3iOPUawcuo1g59RoYsawYqgoMqiBAlVAgSgBAsBYCUQIAogAIECBAqqgAKgQJVQAACUQIECBAgQIFihwECBAQAIACBKDFVYAwECBAlUAgAP2Hp+TjwmUD6RTOiB9EF6Iq9RIU+oFXqBV6Cr1FhV6QXoFop0F+UFtBbQWgtBbQWgtFMqB0gtA6inQOop0DAOgU0WIpBAcAyCxrEpGpEVqRBuc1NVvnlndV1nLNV054TdHTnhjdWOnPCbqx15+bG6sdOfmlV0nzZqxufNN1canzZo3PmlWNT5pSH+ZSNeEpF/MpD4KsP8ypFeIVYPBSLwVIPC0gvBSM3haM3hqozeFozeFozfmtQfzKReFpF/MpF/MpF/MpDPmUjU4SrGp80o1OCkanCVY1PmzSNThKNzkU+QOAMBYDNXECjNEH+KM1RKDRBqqdBaB2AZUCBlRWpRFqQWkFVUfkQWNIzVVixUY6jRGOouI59RrBz6jaMdcgxY1gPK0HkofMWhkSjUiUbnKUbkRW5EG5GRuQGpEXDEVqAcQWAQQIFqgBAdA6ClBpBbgLYA1RCM2ris1oFVNZqozQZq4JQKIECBAtBKjNqjFq4MWtIx1VHO1rBz6rWI59N4OXTWDn0qMdN4OXTQ59T8tYjl3GsRx7jQ5dxrBw7jeI49RvBx7jWDl1Ghz6jWDnYozY1gzYIMUAEBigwECBAlVAlBgiBCpRAMAAgQIgKqoAKgSiBAFUYCBAgWAsBYCUQHAQERAgQIECBAMVVgDFECwAKMIHCAVUFQDAfrNflXgxekVqVA6C0VaB0D6SA0Fqi0FoLQOgtRT6IVeiKfQi9VFXoFoLQOoLQOimUDKmh1AimIuECDSapQQHAakQakRoyA3OUG5yzVdOeU3VdOeGN1XXnhndV154Z3VdeeGd1XTn5s1XXn5sbqx15+bO6sbnCVY6T5s7pGp80pGpwlVqcFDPmlU+Ch8JReIUXhaLwUXgBeAHmqDytQXgoz4aozeFqRm8FBeFoPC1F/MqrwVF4Wi8JRrwUPhKpnBSNThKrU4Sh8lGpyCxA4CxQVRmgzVxAqM2qMWrAWqg1VFoDVFoLQOkD6SBnRA+galQMoHRUghFVRiqrNUY6bGOlxNYrSOfUawYsVGLFBiiwFgGQG+YmjciDUgrcZGog0g1E1cagpgJBAVFoDQWiLVFoLQq0DqB0U6CBaILVis2qDVBVxNZqoKAXAVRYoAQIEAqgtEZtaGLVGOq0jna0M2rg5dVrEc+q1g59VrBitI52tYOfTQ59NYjn00jj20OXUawce40OPUbxHHuNYOXUaHPqN4OdioxVxWaqDFFgDASgBCIXEqjFECAUxECBKIBf0KAQIEqgECAChRKIECAWCrAUAggQLFFgICIgQIFghBAgQBcVKAEKASiACoEAoqB+o9Py0eA6QWgZ0gdQOir0C0VehF6IHSC0irSC1IGURaKtBaB0Foq1A7RVqBA6gQMFagFAorURWgIFlTIDUiLjciDU5Sq1OUqunPDNHTnhN1XTnhjdV154Z3Vx154Z3Wo688Mbqu3HzZ3Vjrz82N1XXn5s1XXn5s7qtz5s0bnCVWpwlGvBQzhKHyVV5KLyUPhAeVovILyoPK0HkqDytBeQZvNWg8rQXlagvBQeFovBReCi8FDOChnJQ+UofJVOJQ+ShwFgLAQCqjNUZqjFq4jNrSM2rgzaozaozaoL0sQeliD0QXogfRBeiDU6IrU6SKZ0kGpUg16AyoHQFqjKgqjHS4MdNYmudVGb+msHOtILFGcUAHAagNRNGkVqJo1EGoDUZDoHRWkVaItBaqDQWrAaC1RaC2gdSB0gtI0dIHQWkBqg0BasZZ1QAFEoKBUFAAVADNqozaozaox1WkYtXBztazDWOq0jn1WsHPqtYOfVVGLWhi1rE1ztUY6axHLpoc+mhy6awcuo0OPcaxHLqN4OPUUc+o1iOdjQxYuDFjSLFBgBRYAwFgLAGCpRAlUWCIAogQIAqighUAAKIEKlEABAgQqBKIECwECBARECAiIEAXBKFAGCVVgLACgRUuCACoEAsFfpdfl3886KdBaB1ILRToVaQq1IU6FWqVaFWhVqFMpBeqQPpILSB2IqBaB0FKLTqKdSDWoGUVqUGogUVqIrUBqIGIrUiLG5EMakqK3zyyrpzymq6c8s0jrzwxuq688M1Y688M7rTtzwxuq7cfP/jG6sdeeGd1Y7c/NjdWOnPDO6sdOeE3VbnDNG5wlVqcJSHwlIfJVi8lIfMEi8qReSrB5KkHlReQHlQYUGFBi1BYtB5WjPlReQXkovP8AwovJReCi8FD5KLyUPkD5BeQWAsBfgBVGaqM1Ri1RitZiM2rEYtawZtUYtXMSs3prMGb0oL0sQeiC9kB6/wCkDOiDU7INTtINTtIrU6INypFOoHQQABaqM9VcHPppGaox1+msGK0jNANDIEGoDUTRpFaiDUA6g1EDoGUDqRVaC0RWrAaQWqDYsB6IL0QXpRegOgdSKZ0Qp0hVpBaC2KM6IFACUWgCC1RUACqjNqg1UZtWDFqjHVaxHO1cwrHVazEc+umhz6rWDHVaRztUYtaGLVRi1oYtXEc60OfTQ5VrEcumlc+o1iOPUawcu40OfUaxHOxorn1FGbFQYoMBYAsUWVRYCwBYAwAqpRCgEIMUQIEqiwAKgQCxQKqBAgQAECBCpRAgQIEBBCICIgSi/BBf/AWVRZQWAgAFQCoACwUfgBRQoUH6LX5iPAdBaKpQOoi0U6C0FtBbQW0DoLQXoDOkir0QOpA6C0U7URagdAinRToUxFaZUwG4mjUQwxGm4DUZ1W5EG5EabkQbnLO6rrzwzuq6c8M7quvPDO6rrz82N1Y7cfNirHbn5s7qx25+bFajrx82N1Y7c/NndV154Z3Vb54Zquk4Zo3OEqxrwlD4KHyUXkovJReQWAsUGAsAYoLAHlUGAMUGFB5UHlai8lF5KLAiwIsCHAiwFgLAOAsUQCgzVBf0qM1RiqMVrE1i1rBi1pGLVGLVxNYtaRm1Rm9NQZtWA9LEHogPSQPpYH0kGp0kVudpBqdINzog3Oki1qdJBbRVojNqwZqozVwYrQx01gzVRmgzWgAYBgNRNGkDKK1Kg1KQOoHQOgdBaQWkFoC1QaoNAaotID0QXogfRA+iB9AfQH0gvSi0gNBaA1QKLQWggS4IBaqM2qM2qMWtIxaDFrQxa1iOfVaHO1rBi1pGOqo52qMWtMsdVRi1Ri1rMGLWhz6UYrWI5dNK5dNYjl1FHPqNYOXUaxNYsaRizVGbFBYoMBeQGKLCgxaDFBYAwAAUStKiAEogVBlVQAVAgSgsUAIVAgQAECBLVIiBABUBEUEIIECUCqYIRECFQAECUAqACjASgooB+g1+YeBaB2gZQOxBaB0EC0VaC2CLUVaB0FoHQWgdRToHUDoq1BqVEIqBqVNVrUUwVqVBuJo1yyrcgrcjOq6TllXTmJqt88s7qu3PLO6rrzwxuq68cM7qx254Y3VdefmxutO3HzZ3Vjtzwxuq7c/NjdV254Z3VdOeGd1XXnhmq3zyzRucpSNzlKpkQOCrAWAgWRUGAMAYoMBUBkUWKDAGRQYIsUZwFgHAHkFgLAPlReQGRQ4IAKjNAKM1QURitDHVVGKuDHVaxGOmhitDna1iMWqjFrQzaoxa0gtBm9LBeiC9EDOiDU6SDU6SDpOkitc9JBudJBuVAypBasBoC1Ri1Rm1oZrSMUGLWgAVEBgGVAyoNSwGtQOgdFWgdA6C0F6BWgNAWrAWrEFqwGgPSi9AfQH0kDOiB9ED6Iq0iLSC0FoLQWqIEBAANUFqjNq4M2qjFqjFrQxao59VpHO1pGOq1g52tDHVXE1i1oYtVGLVGaoxa1gx1WhigxWsRz6XBy6awc61g5dNYOfUVHOxrEZsaBgDFBgLyCsUGALFBijOKCwGcAKKxQCqqAECBKooDAGKqBAlQUUCoRAgQqBKIECBAgQIRLglCyBcEohTBCIgQJRAgVgoAUVAFVWAAFgr+7r8y8B0FoHUFoLQOgtpBaRVoH0iL0C0U7CC0CC1A6B0DqBlFwywCyGCmVAwXGpRa3EVqMjfKaNcsrjpEV05ms6rrzyy0688s7quvPDO6uO3PDG6rtzwxutR244Y3VduPmxurHbn5sbrUduPmxurHbn5sbquvPDNWOvPDO6OnPCVXScVmq3OEo1OUocRTgLAOAMAYohFgBQYAsMAoMUQDAWKDFBgi8gsAYCwFgEFigxRYtEIyCUFoMqCqM1UZqjn0qaxWsRitDHTQxVHOtYyx1WsHOtDNrWYMWqjFqgtWINWA9EDOiDU6Zg1Okiuk6SDfPSQbnSRW50gdSB0FoM2qC1Ri1oZtVGbVGVBVAoQOwFqDUoGVA6B0D6iQMoHQWgZQWgNFGgtUZtWINUHoBqoPQq9AfQGdED6INeiB9AvUA7EF6BegOwFsBbAWqLQAC1Rm1oYtVGLWhztUYtWDFrWYjna0jna0MWqjFrWYMWtIxaqs2riMWqM2tIx1VGKqsVcRz6Uc+msHPprBz6axGLFKxY0jNigygMUXkF5AeVF5BmxaCwGbFGbGhmwGcUSgooqgBAgSqgGKBRYgsFCoqKMoIEABCpRAgQIECBAVQKIUogUQqEIEEIlECBAqKAAqUAqBYAB/b1+aeFfkDqC0EB0FoLQWgtQWgZQQEFoHUgdAoq0DoHQMorWshlQQrUqDUouNSpqtxNVvlnR05ZXHTmJrTtxGNXHXjlnVduOWN1p3441z3Vd+OGN1qO3HDG61Hfj5sbqx34+bG6rtz82N1Xbj5sbquvPzZquvPDO6rpOGd1cbnCUbnLNVucpQ4ByAsgIAoqAxQAKAxRCCmAUWAMUWAFBgIEAqmoRAgQLFFgCgFQKC/pRmqABVRmqMLgxVRitIxWhjpoYv7aHO/61jLn01g51UYrYx1RGLWsGbVGbVFqil/KDU6INc1INzpncHTnpFbnSRW50kGpUDoLQGgLVGa0jNqjFUFqg1Yg0Fqh0DKgZSKdIHUDoLUDoHQWgdBaA1RaYDVGb0oNUZ0QelF6UXogvRA+iDU6SKfRAzogvSQMpA6C0DqB0FoLQWqLVGbRGbWhi1Ri1oY6q4a52tI52tYMWtI52qMWtYjFrSMWisWtIzauDNqoxaoxaqs1UY6rWDFUc+mhirg59NIzYqM2LRm8lFii8gvMWiwoMAXlRm8qM3lRmxRixcGbFGMUFUQoUABRAhUAUQiFCiAAgWCiggAFRAMFQIEsFgLASiBAgQiAggQFUQIECFFBKIAKgQAUA/tPzTwrQWgtA6C1BaB0FoIECBaDW1BQCCloNSoIDKKdQILaDWpqnUUyg1KmjcqK3GdV05TVdOWNXHbmM61jtxGN1Xfjljdad+OHPdax6OOHPdazHo44Y3Vjvxw57rT0cfNjdWO3HzjG61Hbn5s7qu3PzY3R054ZrUdJyzR0nKVWpylGpEDIgcA+UVeVwFioAFBKCwAosUAgpgMUCiBUBigBYAAKIIhEogQBQWqIQAKozWhnQFEZrWDNUYqozVRzrQx00MVoc+msZc+msHPprEc+mhiqjFawYtUZtqi1RaBlQaloNSpo6c9MQb56RW5UGpSDXogtILSAtUZtBm1cGVBa0M1UQIFoHQMoHUU6B0F6A+gWgdAaC9AtIK1Yg2kGbVUasQWrBn0sBpBeqQU6WB9IH0DXoDOgOkDqKZSB1IGUDoLQWgtAbVBaqM2gxa0MdVpGLVHPqtYOfVaxGOqo52tYjFrSMdVcGLWhm1Ri1Rm1UYtVWaozaqMVoZoOfTQzVGLFRmyLgzioMA4tF5Kq8gvIK8KM3kozYtRjrlRixoYsXBixoYqgqgFF/SgESqgWCgECxUAqAKIACBKqAYCBAgQJQKqEQIVKiAggQIECAghECFFBKIBQQqBABUD+w/NPCtBaBBAgQLQOgtgIFoLQaiCAoIDKgdgEUoIDoHQMorUrIZRW+ayOkTWnThnVduIxrWO/EY1cejjlz3Wno45Y3Wsenjly3Wsejjhz3Wno+fzY3Wsx6OPm57rUejjhz3Vx254Zqu3PH5Y3VdeeGd1cbnKVW5yzRucpujU5RTiBkBAgS4D8gsVGbDAfhQUAolAIDBKDFEAoJQUAAVFRQFQiUQLVGdAKARaAtaGVBQFEZrWDNUYq4jNaRzqjPTQxWsHLprGXPprBz6axHPpoc6qMVrBitDNUGrBaQMqBlBuVBrnpIOkrO4NyorUqDUoHQWgLQZtUFqgtVGdUFUGgtBSgQQHQOgtA6C0DoLQWgtUWoC1QbFgzaoLVGbVB6IC1cwo0KtCmUKfQVr0kDOiB9EDqBnQNaB0DKB0FqC0Bqg1YM2rBm1cHO1pGLVHPqtYOfVaRjqqOfVaRi1pGLVVm1UYtUZtaxGOqqs0GaqM1RitDNUYqjNUZqozYuAwoMpUMgHFU+RV5Sg8qDyqM3laMWLUjn1Pw0Odi4MdRoYsaGQFVRYoMEGUVZQSqsAYCVBgJVAIEAwEqoEoAX4QQIEoFVAgQJUIIECBAgQIEC0F+ASiBABUCBABUD+u/NPCgQICC0FoLQQEEBVEgoitaCA6ggIHUgZQQHRUg1AMqK1EXG+U1XXlnVdOGNV34jGtPT8+WNax6fny57rWPT8+XLdax6fnw5brePV8+HPdXHp+fDnut49HHDnuq78cMbqu3PDO6rrzyxutOk5Zo3OUo1IlWNSJo1gqEWAsBAAQCtIKYDFGVACqgBGAVEAqgBVQUBVQaKA1CLVBoLQFrQAVESjNAVQVRmmAqoKozVGOlwZrSMVUY6aGOlwc+m8ZcumsHPtrEcumhitYjn1+2hiqM1RnWk1aB0DKityoNSoN81BuVkalFalQOkFtIK1QALVRlQKDQSiAAgOgQWgtA6ClBegXoF6WC0grQGqDQFqjNqpo1RlQW4C9EF6WCnRA+kgdFalAygdSBlA6DXpIH0B9IL1FgvRBeiDNqgtUY6rQxaqOfVXBjqtYMWtI59VcTWK0jHVVWLWkY6qjNUZrSMUVmrgLVRiqM1VYq4jNUFUZoM1UWAsA4BxQ4CxBYozYqs2Ax1Gkc+o1hrl1GsRixRzsaGbFBYq4AWKAEAVQCBAFQWKoBAgQKgATSoEAqCBKBVQIECVCCBAgQIECBAlECBEAqpNQgDVQIAo/rvzLxIECBAgQIEBAggKokFBSg0CQQIDKB0D+EVSgZQalQaiauOnLOtOvLOq68Mar0cRjW8er5z8OetPV8uXL1rWPV8uXLdbx6/nw5brWPV8+HLdax6vnw57rT0ccRz3WnbjhjdWOvPLO6rrOYzRuSM7q41OUUyAYinAQiAgFAAETRGTDUqM2AMUCgsBAsigogqgBVQVRn/AAAqLQALVBaAUQiBKC1Rm0EAqoyuAqjNBmqM1UZ6awYqox00MVrBz6axly6rWDn1WsRy7aHOtYjFawYq4MVpAoAIGA3yzqtQG4g1Kg3ECKYBQQgqgqjNUQBQaC0AopQOggOkFpBf/oJTVtEq2hUFRCjVgNAW0BasBtaADNrUBaQGgtBaB2gZaQalSKdA+iI1Km4p0gZQOoHSB0FoDQFqgtawYtVKx1QYtbzBjqqjnaox1WsTWLWkc6ozVGLWhnVRiqrIM1UFUZqjCqzVRm/tQAyAsUWKhkAgYBxFWArFRmz8KM2KrHSo59RrBz6jQ59RcI59RoZsaRnAFiqsAYCxQYAUQqoBUVkxVZwFgLAVAKAVKIECBYAwFiiwECBAgSiBAlAioECBKIRLghUCBaABAgQP7D8y8QBAgQIECBAgIECqIFEUoECCQQICC0UyoEGoDfP6Z1cdOUadeP0xqu/zjGtY9PzjnrWPV8+a5em3r+XLj61rHs+XLlut49fy4ct1rHq+fFct1rMer58Vz3Wsd+OHPdad+eWN1cdOeWarpIitSIGCnEDgLAIiBAFBQAgaUCaBAoyoqAUGAgFUFVACqjNqg/wBaqDVBoD8qLRFoAFVwWqABQACqgawFBmqM0RitDNq4jFUZ6v5aHO1rEc+q1iOXVawc+m8Ry6UYrWI51rBitYM1UCiUQGINRNVuINRBuINSkGoikFqC1cxAsFQZqgBKMggTQgQLRFop0FoATUogWgtgC1QaoLQCgqgtBm1QWqDQWgtA6B0DKB0DKg1KB9Ip0gfRAypA6otIC0gLVBaqaxaozasGLWsRztUYtUYrSax0oxVRmrgxWhmqjNqqyozRGbWhmqrIM1UZv7UAABVFIqEDAMRTAIDFQUGK0rHUVHPprBz6aHPqLgx1GsGbFRnFBgLFVYAsBmxUGKqwACxQX9KAUAgV1QIJQKqBAlRAgQIECUQIEKKCBKAVAgQIFoitVVoLQAIECBAtB/ZfmXiQAEABAgQIEBVEDQIEgUDBUB1BAgQIGoKdAxB05/TOrjpyjTtxHPVej5xjW8er5Ry1rHr+XLl61rHs+XLjut49ny4cvWt49ny5cd1vHq+fDnutPT8+XLdax355Y3VduOWNV0nKK1IlU4gcBpEQIAqoECogBVUFaVkAAaZFAAsUAAEoFRkFVGOlQAFwC4BRaINBaoNBWqDQQAFVBVRmqCgzaozauYmsWtIzaoxb+FGLWsHPqtYy59VrBz6rWDn1WsRy6rWI59NYMVoYqjNaQAVFAMQaiDcRWog1EGoDSaNABUuCEF/YBQUBVAuCUQITUCBAlEC0BoLVBoLQGqAFqg0BauDNqgtUAC1cAgtUOkDoGUDoHUDoHQOgZQOoL0QOgNUVoM2qMWqC1pGLVGLVHOqyza0MWisWtYjNrQyIxWlZqjNEZqgq4M1VZVGaAv7UZoCqIECAgYBgEEqM0Ga0rFVHOrg59RoYsaxGLFGbFwZsUFgDFFgDFFiqzZ+QFggUSrjKqAQBQgKAAVVQIDiosBYAwEogQIECBUUKIAKsBAgQBRAgQIFoLQQoBKP7ePzDwrCgBAMBYCwECxUWAgMAggSBiBgqBAUEBBCkDgNcxkbkTWsdeIzqu/EY1rHo+Uc9ax6/ny47rWPZ8eXL1rePb8uXH1rePZ8uXH1rePZ8+XHdber58Oe61j08cxz3Vd+eYxrTpzGdVuMjWINSQDgCggSqAQICqDAABoFAALFZCgwACAYoFBQFVBVGKqCqM2rgKoFQaoNoAECBAlFoC1UFUFqjNoMW1UZtUYtawZtXEY6rWYjna1CsdVUc7Whz6rWDn1Wojla1mIx1Whi1oYtU1lUWggMBqA1EGoitRBuIGA0BIEUAhBVAAqgoBcEogFE1AhYlIgiACJRWqABoKqDTAasBpAW1QKAGbc/Sg2qLakFtUX5AgtA6DWpBSkDpBrUFKB0DoLQWgzaoNWDNqjNqozaoxWsGKrLFqjNUYrWDFUFVGKqiqM0RmqCrgwqiqjNAVRmgKogSogMBainQOqIGRGa0rNVHPpRitKxVRmqjKgsaBeYAyAMUGALFBYozYAqgUFiqBUAUQIBgBRZAWAlECBKLAWAAQIECFCiAAliggiCIIECBaKqAWCQQJYIH93y/LV4llWoMBYAxRYAwFgLFRYCwEBBAkDEDBSCAoIEBkFIGA3zGVxuT8s6uOvEZ1cejiMa1j0/Lly1rHs+XLluumPZ8ef04+tax7fjy4+tbx7fly4etbx6/ny5brb1fPlz3Wsejjlz1XbmM606SMjUiK0iEEAoJVAIECAqCgBBigoJQKyLBQoyIgWKCqM0BVQVRiqjNUZq4CqgUZtUWgNBKIEC0BqiVBoM2qM2gxa1iM2riMWtDFqjFrWIxa0jn1VzBztaHPqtYjn1WsHPqtYjHVaGLVGa0CiBQoGA1AbiDURWog1EGoBAgRQCEFUACqCgFwSgtBCalEKgQIEqAAoAQBQVcAoAFqgoM6Aq4BRKIECAyiECKdBIHQMpA6kFpBaotAaAqjNqjNqozaoxWhmqjFqjNVGLVGaqCqMVVFUZEZqgq4MKoqozQFUZoCqIEqIEBFWgtBaCqozVVmqjnVGa0MdKjNigUGKCxQWUFgM4AUFijNijFUSgsUZGkABKIECAYosBKiBAFVAgWAgAIEKFEAXBCgECBaCACoEuCBIJcECB+ivL8pXjg81ajN5KCxaDyVFigwFgDFFhRFRFEUWFDiBFIICgcRVgHAOAZyg1ORY1IyrpxE1cduYxuq7/AD5Y3Wser5cue63j2fLlx9a3j2fLlx9a1j2/Hlw9a3j2/Lly9a6Y9fz5ctax6uOXPWnfiOerjrzGFbkRWoiGAQQAEqgECBAVEAEFEC4oqiqgAWAFZAJRmgFGaqM1RmqjNUZrSM1QVRlRaABAgQi1QaC1Rm1Rm0RnWkYtWDFrQx10ox1WsRi1pHO1cGL00jn101g59VrBztaxGOq0OdqjNv5XEZtaBoIDAaQa5Fxvlkb/ANQaiDUBoFAIIECAVQAKuAaAJqBYABKIVAgCogCioABVBVGaC1QKCgKDNaABUZBGBUQKAZQOoICB0DAWgQQIAAqjFUFVGKozVGelRitIzVGKoFxGaozRWVGaIL+lBVwYVVVRkGaozQFUQDVRAtAggGgtVRqgtBmqgqjFVBYozYoziiwFigxVWAzYoxYIFGbGhmxRkFVGaq4BRRECUQIVKJUGAgQBVQIEC/wACVUABAFwQoBAgCqjRIJRAgQIECFfp/D8lXjF4KjN4WkF4WjPlag8lB5KDFqLCgwFiiwFgLEDgLAOFDiUM5KpkQa8lDOCh8JVhnJVjU5qUanCVXTnlndV255Y3Vej58sbrWPT8uXLdbx7Plz+nL1rWPb8uf04+tdMez48uHprHt+XLlrePX845brWPRxHPdbx35jGq6xka5/KK1IiEEC0AqoACAglECAYIhGauKsUABRAMEFUCoKDNUZqoKoxVRmqMtYjNqjNUFUFAasREEQGkFqi0BaozaRGb1+GswYvSxGLWsGLVSsdVrMKxasRjrprMHPqtZgx1Wojn1Vwc+q1mIx1Whz6rWDFqxKxa0C0BoLQalBqVBuUG+UGpWVbgNRBoDAQIECoCqAAAaAqagQLFFgLAooUAlFoBQaCAVRlQKBQUBQFqgVEA1VCgBAtqhlQIGAYBgJAwCBAUFgJRmgzVGaqM1oZqjFqoxVQVRiqM1cGaozQVVGKAv6UFUZsVQqCoM2NDKgoCgFAIgSiIqILVBoC0GbVQVRlSL/FILAgxQYCxaDFSixSs2KM2AzigsUYrQzYAqgsUZotQgxRCoECXBKJYopBAEolECBAKCVUAoBYIVAAQIAqoECBAgSiBfhALFfsLw/G15YzeFqRm8LSM3hakZ8LQXgqM3haDytQWf8AFB5AeSoMUWAcSiwDgHBTOUGpyVY1OWarU4SkanFKQzhKpnBSNThKRqcJWo6c8M7o68cMbqvR8+GN1vHp+XLnutPX8uXLdax7fly4+tdMez5Rx9a1j2fKOOt49XzjnrWPRxHPWsd+WdV0jKtREaiCBAACqgQIEotAggQARmrglEDNUQIBRGa0goCqMVUFUYqozWhlcRiqCrgyoLVwFECi0FoDVBoC1Rm1UZtXEYtaGeqqOdrSMWtYMddLmDna1Bi1rEY6qjna1BjqtYjn1VGLWsGLWkZtEZtUH5FMqhlQalQblQblTRuVlW5fwDcqBBqfoECBAqAqgBAGsGaGpUSiBAgFAKIACUAIBVwZaAAqgoCgzf2uCVFVGRQqIECVVEGgUBqAYBQOAsAggQBRnoGaoKqMVoZqjFXEYqozVwZUZq4M1RkFVRiqCgKozVUCCgK0MVQUUUAqARAtVRqi0BoDQAKqgv6UZVV/igESiwBYAsVBVBVGLFGaozVGaozVBVGaoACiBAgSiAYqpVQAACBAgSgFQIBQCqgQIACAKqBAgQJQKqTRIBofur8n4fp54zfm1UjF+a56Rm/Nehm/NakZvC0jN4WpGbwtBeFozeCoLwtIPK1F5KLyUU5SqZwUjU4SjU4Sq1OEqxucJSNT5pVbnzShnzOlh/mz0sanzOiNT5pVjpz82d0jrxwzurHfjhjdax6Pny57rWPV8+XLdbx7PlHL1rWPZ8o4+m8ev5xy1p6eI5629HH6Y1cdeWNV05ZVqCNRBAKqgECBAtUVAAgQIE0iBmgqogFBAKIGkZUFMGWsRiqM1UYq4M1pGKoKYCqjNUABoX5AaAtVBaDNqozaoLWsGL0o59dNYyxa0MdVRi1rEYtawc+umhi1UY6q4OdrQ59VUYtaGbVGLVBqi0RaKZUGpQblQdOag3Kg1KyrcoNSgdA6C0FoLQFoJQUEAXAKIRAlFgIXAArSAEAUFAVcA0BECjNFC4CqIQVcAoAQJRCqAQakQakA4gZEGsBYB8oLFFgDFGbFGLFBVRitDFUYq4jFVGa1gyozVGaAUFVGQFBlcGVUKgwADNUFXAKAGauCqgAWgBVogVEAAWqBVQLAWKiUAABVRlRmtDNBmqM1oYqg/wAUZqgBKAECUSiBAKrSBAhBYKsAAlFRRYCAVQCpUICioEAFVXAAgQC/tVAIECB9Fvzfgs1xjF+bVSMX5rSM35rUjF+a1Izfm1SMXhakZvzWpGbwtIzeGqkZvC0HgovBReCinBRqcJSNT51Ksa5+aVY6T5pVb5+bO6RufJnfSxufJOljU+SdLyZ8k6I1PkdLGp8k6I1Pmm6sdOfmzurHbj5sbqx344Y3Wser58uW61j1fLlz3W8ev5xy9NY9Pzctax6eI56078MauOvLOq6RFa5RDqC1VWgAKgoAAIQWgtWC0gtIDVFoL8AFEAACKqM39qgqjNqgv6VGLVRi1cGbWhmqjFUZqgtWIzVBSA1UGqC0hQoLViMWrBm1YM2qjFrUKxa0jFqjFrWYjFq5gxa0MWtDnaqMWtYMWrErFrWYMdVRi1RmqgoDSC0gYDcoNSorfPSDcqQblSDcqFalIUyop0FoHQQJQAgCwQCqlQJRAgWgLVAAUSgAUBaoFAIFGVigBVEqMqKgAQJVOIKQGpCjUgHEGpEGpylWGcpSNYUiwIvIRYtIzYqMWAzY0M1pGOlzRitDFioxVNYrWIzVGaozQZUVVGaAoMtKMAAKqM0BYozVwCgAVcAoMAUAKKIlFRAAxVCiBAVBRACxRmqQKRmxSM2KjFUZrQzVGVBYozQSiAAlEogQLCrRYpUCBABQogQKqoBAAS4IUUEABCqrgFECAUVYCwFgLAfTr8/+PnuawzfktRi/NrpIxfktSMX5/wDFpGL82qkYvz/4uekjN+bVIxfn/wAWpGb81ozfmtQXhaQfzOiL+ZSGfMpGp80pG58/+JVb5+f/ABndWOnPyTpY3z8v+M7qx05+TO6sdJ8meiNT5JVP8kqxqfIpDPkdEanyTpY3z82d1Y68/NndV244Y3Vx345Y3Wsen58ue609PzjnrT0/OOet49HDnqu3DC47cs6rURW+f0gUQKqBAqqAEABLglECBANBaCUGgtEGglQUGVAozVAqMVUYrWDNVBVGKozVGVQVRlRmqgtAaoLVRm1Rm1UZtVWLWsRi1pGbVHO1YM9VrEYtaHO1rBi1UYtUZtXDXO1pGbVGLVGKuA1UZpgNUILQalQalBqVFbnSDcqQblSBlINyop0DpBaQX4A6CAAmhaJoBKIECAAFECUCgoCgKoFAqCgy0oAUFf0qMqKgBVgLFGsQagGRBqRBqcg1OWRuQUzlAzkofJReSgxRm8rUZ6gMWNYOfUaGOouIxWhjpRzraaxVxGaozVGaYBQVUZoKgzjSgAAVGQFUZpgFUKjNUCgAX9gAFFSoqAETSigAQFUFAAlBVxWb+lBVxGOlRmqMVoZUCjNUFAKIACUSiBAgFUQqBAFUAgSiooEQoBLghRQQAVKKgFECBCoEIgQPq9+b5zUjF+a0jN+a1GL81oxfm1UZ6+a5qRzvzaqRi/Nc0jN+bVIxfmtSM35rUjN+f/FpF/P/AIUi/mdEanzTojU+SdLG+fklWOnPyZ30sdOfkz0R05+Sb6ajpz8md9LHSfJnfRGp8k6Vr+KdKZ8joh/knRDPkdEanzTpY3z82d1XXnhndV244Y3Vd/nyxrePRxHPVx6PnGNXHbhjWnbhhcdYmq3GVaiBlBAlwQIZFAAP9aVUECBGA1UWgtBAgFAKi1QWgCDNrSC1Ri1Rm1cRi1cRm1RmrgzqmitYjNUZUFBmqjNqozaoNUZtVGbVVi1rGWbWhi0GLWsRjqtYM1Ri1oYtVGLWhiqMVcNYrSM1RiqjNXBmqAAogQGVBqUGpQalRWpUG5UGp0DUqBlBrQOoLQWkU6C0EqIECUQIEoKAAqD/AEFQZVBVxRQCgUACrgzVACxUFMAoRUBwDIgZAbkQbnKVWpyg1OUo3OUGpylFhQ4UWFGbFGbGhixcNY6iox1GsHOtYjn00MdKOVaxNZq4jFaB1+lGKuAoCqgoAGVwWKoVGaAxQUGaDNVRigogxQKAGRUAxRKixANCAYCwEqIGVEAq4rKgq4jNVGP9UZ6XBloZ/wAUZqgBKAFQCiUQIEoBUCVUAtACpRABECVQCBAKKgS4JVAAECBAlEggSj7BeI+aVYzfmtRi8LmjN4WjF+a1Ixfm1UjF+a0jF+bVSM35rmkYvzWpGb81pB/NakX8ykX8ikM+Sb6WNz5JSOnPyZqunPyTfSx05+TG+ljrz8md9NR05+SdLG58meiNz5RKsM+cToh/nDoi/mUi/mVYf5pSNz5pVjfPCVXTnlndHbiMbrTvzGdXHbhjVx14Y1p25YV0iK3Kg1qBFSCVCA0RWihYBUotCrQoCpRfkItCLQGqARaC0BrQrQZtWAtVGLVSs2qVm1YM2rEZtWDNqjOqC1UZtUZtUZtWJRaozaqM1Rm1Rm1Ri1rEZtVGLVGbVGLWkZtaGLVGLWsRiqM2qMVRm1rBiqjFqjKjNVGaoKoAGqLQMqBlBqUGpUGpUg1OiBlRWp0DU6QPoGp0C1A6B0KtCr8AdBaC1RaC0CoMBAlACUZAVcBQSjKiwGcAWKBRKiwFhQYqrAMiDUiDU5QbnKLG5ylG5ylGpEVucpRqcpReSh8wqC8maM2NUZsXNGLGjXPqNI59RrBzsaxHPprBzqjnWsTWOmsRmqM9fpRirgACoFAQFVQAVBYABlQWALFwZFFioFBQFijOAsFCiwQArFAogGglRAyogFVWf8UFVGaqMVRmtDKjNUFUZBVQAqoASiBasAKgQJVGgASqgWgBEKFECBAKqoECVQABAgQJRAgQPs15fMK2LytGbwtSM3haRm/NakYvzWkYvzaqRi/NakZvzaqRm/NaRm/M6IP5rRfzKQ/zOiGfL/ib6I3PknRHTn5M1qOnPyZ30sdefkzVjpz8md1Y6z5M76WNz5M1Y1PkbpDPklWH+R0RfzOiD+ZSH+ZSGcFGpwm6uNzhKR05jOq68xnVdeYzq46csa06xkdIjTcQaiaHUEKhFoi1YoBANVkGCUGgNqi/IIEogGgtAANWAtUFqozaozaqM2qM2qjNqjNqjNqgtVGdUFUZojNaGbVRm1QWqjFqqza0M2qjFqoxauDNrQxaqM2tDHVUZqoxVwZrQzVGKuDFaRiqAGaqM1QX9KAAogQLQalAyoNSg1Kg1KQalQMoHUUygZQOpAygdA6ClA6BBAgChgJRAACiALgADQAAKgFwZsUSiwRYCwVSINYUanKDciLjc5SjpOWRqcpVbnKUanKDU5A+QFgDAZsVGLGsGOo1ia5dRrBzrWDnWk1z6bwc6o51rE1jprEYqjPX6UYq4AAqBQKooLAFVAAsBmxQUAYCxVZsUGCCqDAGKCijACiqoAFUQCglEDKojAVVZqgojNaGaqM1oYqgqjNUZBVQAquAUQKrgBUCBKotAAgSioAECVQCBAlAKgQJVQAAogQIECBA+1Y+XOgwB5aBeSozeVozeVzUYvC0ZvC1IzeGqM3hag8FF4KLwUhnzKNc/NKsdOfmm6Rvn5s1Y6c/NndWOvPzZ3Vjpz82d1Y3z82d1cx0nzSrGp80qn+ZSLwUivBSDwUi8FIpyEPkGpCjUjKtxNV05Z1cdIyOnNRW+aityoGVFalQKiBAgAmgQqCgzqiIINGqg0gtVV6AaItUAJYM2hrNqoLVGLVQWqMWqM2qC1QWqjKg1Rm1UZtAWqjNaxWVTWaozaoxa0jNqoxaozVGemsRitDNBmqjNUYrWDNUYqozWhiqMdAGhjpcQUBf0ozQColECA6BlBqX8INSoplINSoHQOgZQOpFOkDoHUDoGUDoLQOgdBAgKiBAMAKLAACqDGhYAwBgLAZxaLCixQ4gZDVxqRBuQG+eWd0bnKDc5Sq6TlnRqcg3jIZAWALFwGKax1FxGOmsHPprE1z6awcumsHKtJrHTeDlVHOtJrHX7axGKozVGKuCUFEFXBmqoBYAVFgABgDAGKCwBYqs2ALFQYoLFGaKMBAMVAoFACAWKoVFQBiCqoUZEFaGL+1RmtDNUZqjPSjIJQUMDWKlQCoECFFUAIVKIQKJBAlECACpRABVBCoBpAlGQQIECBAgfbHy51iEGALFGcKCxRmxaQXlajPlc1B5Wg8QIvEKGcRKNTiFVqcJRvnhmrHTnhKY6c8M1Y6c8M7qunPDO6sbnESrjc5Zo1OUofJReSgvMWgvJQeVoMFMiixBqQGog1LlTVdIyrcqDfNRa3Kg1KgZUWtaFWhVqFWhUqAAoLQSgUFoi0gFB+1VANEWqC0BaqUWrBm1cwZtIjNrQzegZ1UZ1QWrAKM2qDRKzrQLRGbVzAWqM2qM2tDFqpWbVGaqMWtDKjNVGa0MUGa0jNUZpgzWhixRmtIxVGOlBVGOlxBf0oyAUCoNBaItFMBQRqUVqUDqKZQa0gdSClIHSB0gfSQPogZSKdQalA6BQIGAQQLAWAsUWKCwBgDFosXNBgKxQYCwBgLAXlaNYgZBcanKUanKUdOeU3Rucs1W5Eo3Ig3IinEoZDNRYoLFGaox0uI51rBjprE1y6awc+msHKtJrlW8HPpRzrSax1+2sRiqM1RiqJUFAWKBVFBAAWAMVFgCwFgDFGbyUFiqzYoMVBYozYAwBYKMVBigwoLFBQSqKIMUQjNVRVGaIL+lGP8AWkZrQzVGaozVGVEoKKKoNUiBCgFqgBEEqjQWiJRAhUIlVEACBAMAglGVVAtFAIECBAgQPtuPlzqsEAIBYAsUZwoLFpBioMA4C8gfINTlKrU4TdHScM1W+eGd1XTnlKsdJyzSNzllpucg1Ig1iBwBgDFBgKwGbFoMBYoQaiaGIrpKkVqUG5WRqVFalQalQOgZQOgtBaC0GaoAQBUBgLVEoNUGkFoC1QaINUZtUZtUZtVGbVGbVBaIza0M2qC0GbVTRqg1UFqwZtUFoM2rgza0jFqozaozaoxVBaozWkFUYoM1pBVGKYM1oZqjFaRiqMdKM1RnpcQf4oyAUZqogQgAgQWg1op0UygdQOgdBaB0DpA6KZ0g16QMoNSoNSgYBAoGAQSCVYMVFgLFBgKxcBgLFBgLICxReQPlA4UMguNzlkanKDciK6c8oNyMjc5RTgNIIwFVBVGK0MdLiOdawY6/TWJrl21g5dNYOVaTXO/63g59KOdbTWOv2uIxVGaoxWlQyKCBloQqBYAwFgLAWAMBeVGbAGKgvJRmxoZsBmxQWKM0UKgUFRBVUKCqooBUQgqqzQZqoP8AFwY/1pGemhmqM1RmqM1QLgFUAlVAFEABLghUAEQJRAhUIlxUoKCBIJRAgZVVQAqBAgQIECUfbXy12QkWCjBEIKAwAAxcFiiyAZAanKDU5RpvmINyM6OnMZadOYmjcjI3IitSCtSJo0ggQCxcGVQUGb+1AogQKVBqUg1KK1Kg3OkVqVBuVBqVApFMoHUDsBbAGqACIKoyoKAqgtWAEGqDQWqM2hRasGdWILVGLVBaoxaqM60C0TWbVBqozaoPSqNEFqoLVVm1Rm1U1m1UFqjNqjFqgqozVAoKoyDNaRm/sGauDNaGaox0uDFVHPpRmtIzVGaozVAqDRAABAgaUMAwU6irQOgtA6C0DoGdAZSB0DKg1KK1KkGpUG5QMqBBr/UCinAWAsWkGKiwFhRYosBYCwF5A4KsBZQMhQzko3OUo1Iyrc5QbkQbkRW5EDgHBBgoUZqoxWhjprEc60OXTSOfTWDl01g59NI59NDn00jFaRz6VWKqM1RlpVRkALAQJcAqrEqHyUPkF5BeRV5AeQF5UZvIC8qM3lUY6iqzYqM2KM2KM2CixpBQCgoBVFAVUFAVRkGVQVoYqqOmkYq4jNXDGGmhVBVRmqqBAKAUQqUQCghEogQIEAoqUSiBAgQIEDKqgF/YqUQIECoIED7a+WuyBAhAIAQBYBRAcSrDIhGoEakTVb5iaOkjKt8xFdIg1GVbiDQrUQKCBALVGaqCgzaoFFqg0FoGVINSkDOkg3KkGp0i1uVFanSbg1qRWtQpgVAgQEBogtWDNUGqC1YMqgtBLAaAtVGbSAtUrN6WDNqwZtagzasRm1Ri1YlFqwZtWINIC1YM2rBelGb0sQaQrN6WFF6UZvSozasGbVAoLViMqAFVGaDNioKozVGbFGbFHPprBiqjFUYrSM1Ri1QVUZqoACiIEggShlA6BFq0KtCrQq0KdCrUimdAdAykGpUGpQalRWp0g3KDTIYDUQaIrQJBYCsBYpFikWBFgReQhwpFhSLyUMhQ+ShnKVTOSjciDU5SjciDUiK3IUakQQEBQZqlYtaiMdVRjqtYjn1WsHLqtYjn00OfTeDn0qOdawcq0kYrWDFaRigzVGVFVQAgQJRYtDIinEFgQ4EPkovKUXlQXkozeVozeVozYtGOuVwYsUYsVBYoxVVmqjNUGKIGVBVBQABRkBVQWNDFiqzWkYsXBmrhGbGlFijNVGaqoBqgBAlVAqIFECBAgQIAsVAlECBAgQIgyqoFgBVQIDgCggQPtj5a6LRahEAoIAolBQU/aK0imQGoDUiDcZ0biK6corcQajKtxAwVqAdZFqg0gNUGiM2qBQVYDVBoi0DoGUimVBqVBuVkb5ouNysq1KBlQalSB0CgUBWgUAoFGaAqjNVAorQZ1oFojNoM2qM2qC1Ri1pGbVGbVGLVRm9LiDWoovUIjNqwFqgtIM2tYmjVRm9AL0uA0gNUFVBauDOqKgFACBlUZqgqjNUYq4MdLgxWkc+v2oxWkYqjNUZv6aRmiBRAAIFRAYCBbVFoLQWgtFWgtAygdRTKDUoNSoNSorcqDUoNysjUQagNQVqJoUDAQIFjQZEEBxA4BwDkBSQD5A+SqZEo1OSjUjI1IVWpEo0DQIBQFXBm1Uc7WhnqqOdaxHPqtYOfTWGufVaxHPprBz6axHOtDnVGK1iaxWsRiqM1cGREoqAA4CkA4BwUyINeUGpyB8gpyC8gLyDN5UZvKjHXLQxeVGLFHOxRixpGOp+VVmqjNUABRmrgqozQABRkBVQVoYqqy0jNXFZv6XBitAqjNVGaqoGVVAlBoIRKq0EIgQIFVxRoJRAgQIECIBRABUCAYqoEBBAsAA+2PlrrEEQgDENJQX9KgEMBCllTAagNIN8orfLOjcRW4g1EGpU1WpUDoHQWgNBXpRm0wZ1QWqjNqg1QaQWgtUalQMoNSorUrI3Kg3KityoVqVFalQOpAygdBWqAEDNUFaTWaDKitBm1oZtEFoM2qM2qM2tDNqoxaoza1mJrFqozqwZvSwF6UZvSwZvSxNZvTUQegF6WDPogPSwHpcwXoQWqDVFpAKIFoABVAqCgAZrWDFUY6XDXPppHPr9qMVrEYqjFaGKoKrI0Bqi1VIICCBoEABaC0BaqLQWgtA6B0GpU1calRWpUG5UG5RWpWRuVBuVBqUVqVkMqh1AggMAwDAIGQCBkShwDgNYimQDiDUiK1IBBoEDIi0GbWsGbVGLVRi1rBz6rWDn1Wkc7WsHPqtYMWqjl03gxVHO/61gx0uJrF/TSM1RmqM0RKIEBwFguGQVuRNRqRBqcoNTko1OUofAq8AzeRGby0M3kHO8tDHXLWDnYqufUaxHPqKjNijFiqzVwZqozVBTAKoAKjNUFUZqqFRmgy0jNaVmqMVRmris1oF/SozVUAgCogSiBAgQq0A0IECBAgQIwCiBUUAgQEACoqxRAgQLFH2t8sdkAokQRLFQgv6UAi0DopZUwGoDSDfNRW+ag1EVuVBqVBqVIGVIp0gvRBaQXogKqVnVzAWrAWgzasBqwHpYlHohV6IUykK1qbitSoNypBqVNxW5WYNyoNSpFzW5UWtQgZUDqQSiALAVYM2qjNAVoZtIM1UFqjNoM1UrNrUGbVGbVGLVzErFrWYbrFrURm1Rm9LEZvSwrN6WFZvSlZvSoL0ozelgPREHpYo9Ki9AvSwHogtBaC0FoLVgtAKgooBmtYjNUc+v0uGufTSOfX7XBz6/TWIxWhiriM1Ss6qDVgtIBVOgQWgQWggQLRAsBQWqIFoLSDUoGVFalSFblRWpUG5UG5RWpUg3Okg3KzFplCtaFMqQOkDpA6gZQagNQDAaAoFNU4gcAw0axBrBToIGgGiC1QWqMWrgzao52tYjFq5gx1Wolc+q1g59XGsGOq0jnauYOdawY6rWIxVVjprE1iqjNUZq4DFiAEBwDFU4gZEG5Eo3OUVucpSNzlCNTmBFiVT5KC8rmjF5WpGOuVRz65awc+o1g59Roc+oo59RoYqo51RiqoqozVGTAY0AAAqjNAYoKozYozY0RmxoZqjFijNXFZqjNjSM1VAJQCJVWghECFWqBRAgQIECBEAogQIUAgIIEAURFRBEEQSj7Xj5Y7IBQSiECiogBAp+0VpFMBoGkGoitRBuIrUoNSoNagdFWgdBaA0B6IgtUFqjNqjNqxBqlGiLQWgpQa1IuNSorcqDUqDcqK3KyNyoNSityoplQOgdQS4IGaozVQKM1RmqgqjFoM6prNqoza0M2qMWqMWtIxa1iMWqM2tQYvSxNZvSozelGb0sGbVgLVgzelgPQg9KD0C9EFv8A1Yi0DoL0otA6CBAgF/Yo/wBAVrEYqjn1+lw1zrSOfX7rWDn1+msRiqMdftrEYqoyAv7aAKgMAgoBBAlRaA0FqgoIBoLVwQrUqIZQalRWp0ityoNSg3OkVqdINyojU6IrU6SBnRBrUUygZUGtAyoNSkG5UDKDUBqIFNVpAgTRqIEVAQQg1QWqM2qM6oxaqMWtYMdVrE1z6rWDFq4OfVawYt/DSMVoc6ox0uJrNaVi/pcTWKqM1RmtYJUGILAIKKrURW5E1G5GRvmIrciK3Ig1IgfJReSgvJmjN5aGOouI59RpHLqNYOfUaHLqKOfcbwc7FGOoqOdVWaqCqM0wFaGaAoBQAFBYoLPwoxYqixrEYsaVmwGLGsGcUZqozWlABQCJVQiBAqqhRAgQIECBAFECBAgQqBAgQJcAqoECBA+2PljsgAIAohEAxQgkVIEGoDSDURrG5+0GgKDUAoKAtBaC0Fqg0BaoLQZtaZFoDVGdFWgtAyiGVBqUGpUablQblQblZVuVBuUVqVkalDGpWVKiAUAqC0GVGWkZqjNqjFoM2tDNqozaoxauYmsdVpGLWkYtXFYtagxa0yxaozaozasGLVBelRm9KM+lgvSxBpAaQWkDsILYoZQOgdBIEEB0EozQZqjNXBz6XBz6aRz6/dawc+msRz6UY6aRiqgqjKi0VaCAygtAqiBAlBaA0BVwGirQWqh0FqK1KBlIjUqDUqLjc6SK1Kg1KDU6RWp0g1OganQGdJBqdEDOkg1OiDU6RcblBqdMwalQalBqVBqUGpQalZUgYBiKVwQi0BauDNqozaozao52tYMWtI52rgxa0MWqMWtYMWtDFqoxaoxWsGOmsRiqjNUZoD/WjUIAUAwCK1E0biDfKDpzE1cdJGVbkZGpAawFgM2AzY0MdRUcrGsRy7jWDn1Ghy6awc+msHKtDFVGKqsVUZqgoMqAAogZUFBYuAsUZsVWbGhmxUYsXFZsaRixcVixpGaozVUKBcECEQIFVUKIECBAgRgFECBAgQIEKgQIECANKgQIH2x8sdkABAMBKIRAgQqxBqA1IBQbiLjURWgMQOgtBaC0FpBeiA9LEo9LCi9GYC1Yg9KM2gNUotCoKgq0KZUGp0K3KkK1Km4rcqQblZG5UVqUG5WdxWpSDU6SLWvQLQWgKIyoLVGaqM9VRi1Rm1qDHVVGbVGLVSsWtZhusdVqIxaoxa1mIxa0Vi1YjFqjNqwYvTUGb0qM3pYM2rCs6oL0RB6UXoFqh0DKgdA6BlAyoHSBlA6AtAaAtUYqjHTWDn0qOfTWDl01iMVoc+lRmqjKgqgFSogOgkU6qLQWgLVBqwFooEWgPwsDKC0DKKZQOgZUGpUGpQrUqQrU6SKZ0QanSQrU6IGdINTsitTpINToDOgbnSbg1Oki1udJBqdJBqdJBudJBqUG5UGpUitSgUDqRSuYiUGgNUZtVGbVgxasGLWswc7WkY6rWYMWrBjqtDFq4MWtIxaoxasGbWsGLVRmqjNUZoD/AFoAiAgoBgrcTRuRB05QdJGdVuIrpIyNQGsBYAoMWKMdRrEjl1GsHLuNYjl00OXUawc+o1g5VoY6io52KrNVGaoyAqjOCpUADForAGAsWjOKM2NKzYuDPUawYsaRz6i4rNaxGLFGbFVlQKIECBCIUKJRAgQHAGAsKJQAgQIECBKIVIJREAqoEBB9rfLHZAgQDAWKLAGCHBViBkAyA1IDUiDUZ1cMFaoGIIFqg0FoD0sBpmJq1UGqC0UaA1QCatEALQGgQIpgVqVFalDG5WVblZG+ehW5UGpUVuVBrUGtQWgdAVQUGauDNaRjqqM0GLWkZtaGLVGLVZYtazBjqtYMWqMWtJrna1iMWtDFqjFqozelGLVGdVGb00C0zAasBpBaQMpAykDoLQalA6gZQOgZQO0gAQCqMWqMdLg59NI51Rz6bRiqOd/aozVRlQVQCpUQIDoLQWgtUC4DRRoDVRAAShBaBlA6BlQOitSoNToiGVIuNSkUzpIH0QanSQPog1OkgZ0DU7SK1OyDc6QanSQbnRFxudMwanRBvnpmDc6QblBqVFa1BrQWgQZtUCjNojFrQza0Odq4MWtIxa1gx1VGLWhi1cRi1oZoMVoZqjFVGaqM1QVcB/qoKABoFAagrUTRvlB05/xkdYmtNxBuMjUBoEABiqMVrBy6axNc+2sRy6aHLprBz6Ucuo1gx00jn0qsVUZqjNMBVUUAqIBgLFECAY0M2KrNjWDHUVGLGsVjqLiOdaVitIzVVmrgypqEQqBAgSixQYBwFgIECAKAECBAgSigqQQJcEoBUCAqPtj5W7DAQIECwFgDAOKJBrAMiDUgrUjKmQRrAQpgL8gzaA1cTVqg0Rm1VFoDasFoi0BqgtILSAUQIEBgHUg1KK1Kg3Kg3KyrUqDUqK6c1BqUG5WYGUUyoHQWqMqgoM1oYoM9VrEYtUY6XE1itDFrWIxaoxa1g52tYyxa0MWqMWtDFq4MdVUYtaRi1RnVGbVBaoNAaqLVFqB0DpBqUgdQMoNSpFOgdBbAWgrQFqjNoMdVrBz6aRzqjHTY51UYv7VNZqozVUUACVECA6oAQCqqEABUQAE0qlBaC0DoLQOgdQOoHQMop9AfSBnQNTogfSKZ0DU6QanQNTog1O0g1OkitztINTtB0nSQb56SLjpOmYNc9JBudIrUoNSg1oLUBqgtUZtVGbVHPqtYmsWtDFrWDn1VGLWkYtUZtUYtUZtUZqjNrQxVZZqjNXAKIQVcAqpNRqINKpiK6RlHTlB05qarcZV0jI1AaBAKDFaGa0OPSprn21iOfTQ49NYOfTQ5VcGOmkc7+1ViqjNUFAKMiqqgBAgSiBYuAsUYsVWbGkc+o0rHUaRzsaxWLGkYsVWaDKgESiFQIEogOAsBYosBYCwBlKJRAKogQIACwVAlEBEFFxKqB9tx8rdgCwEABAgQHAMgFBqRKrUhQyMq0BwECxQXMBlQWqms2qDVBog0KtWA0AotAaC0ECBAdBAdA6DUqQalSK3KhW+azFzWpUityoVuVBqUGpUhWpUgtIL0QGqDSDNrQxaozauIxVGOq1iaxauYjFbKxao52tYjFrSOfVawYtUYtag52qjFrQzaqMWqM2qM2rmFZtVBqiUQLQOoGUDoNSkDKkGvRFq1Cn0FWkKdIVbCFFqwrNqlY6qpWOlGLWsxHPpoYtUYqozVwZqgoBUQIECUQJYAAA1UQIBoBpUCBaCA6BA6C0DqQWqHUDtAygfRA+ki0+iBnRBqdJCtToitTpINTpINTpINTpIOk6SK3z2kHTntItdJ0zB05qQblSK1Kg1oLQFqgtUZtVGOqox1Wsw1ztaRi1oYtUYtWIxWhmqM2rBi1Rm1RnViVmqjNqgtUCiVGaohUBlSI1KK1EHTmoNxkdOamrjpKyrcqDcqBlBWgKDFaGemsHLpU1y6axHPqtYOXTWDn1WsHKtYMdKjnVVi/tUZqgpAKMiqqgwDgLAX4UWAlFi0ZsVXOxrBnqNUc+o0jl1FxWK1UYqqzYozigEWKDBVgHAOAsBYBkBYAxRYCBYoLDAKCwFiiBAgQJQYCwUiIUYFSj7c+Vu6AYABYKsEWAsBrAQNSINSM6rUgpkQawECwBQCjFUFrSaxVBcEGrAasBqwWgtAaC0FoLQOgtBaClAgpUG5QMqDcqK1KhjcqK3KyNSoY1KK1Kg1KB1ILSCtUZtUZBmtYM1UYqjHSprHTWIxWkc+msVjprE1iqjnWsGK1g59VpGLVwYq4jFrQzVGLVGVQKCqAEBlUKC0DoNaBlA6B1BaB0FoLQFpAWqMWqMWqMWtYjFXBitDNBmriM1RlUQIEogQC1cFoCglQAgFAANaVAgAp0CC2gtA6C0FoGdCHQWgZQOgdA7CBnSQanRFwzpIrU6SDc6QanQNzpIOnPTO4rpz0kHTnplXXnpBudINyoNSgvSQWqC1Rm1Ri1oY6rWGsWqjna0MWriMWtDNqjFqjNqjNqjPVVNZtVGaoKDLSoZFXAKqBAYDUQaiDfKDcQdOWVdIitz9INSoEgdQFXBmqMVrBz6aTXHprEc+lwc+msHLprBzrQx0qOdXFYv7VGb+lAqgGQSov9BAgIEFigsXBmtDGLis9RpHKxpXPqNYMWKMWNIxYqixRkFgLFwWAcBYBwFgHAWAsBYAwFjQMAYAqgAYogQJRAgQIECBlVfcHyp3QCgsUGAsA4CA4BkTVakZVqQGpEGsBAQFAAx0uDNaRmqMWqjNqg1oGgNBaCBaC0CCBAgSogIGIpgNRBqVAyorcqDcqK1KkGpUitSg1qC0gdBaA1QWrEZqjNoMWqMVpGOq1gx00jnWhjprBztXGWLWsGLWhz6VGK1gx0qMWtDHVUZq4MqgqgtAAlEodQWgdA6B0DoH0gZ0QXogvRBeiA0BaozaozaqMWqMdNDFUYv7aQAKqMggSiBAqAVQIgCogQM1VFUQAFoqBAhDoEECUQIDoGUFoLVDqC0VrSBnQH0g1KitTog1Okg3OmYNzpB156FdeemB15qLjpzWRuVBuUFoLQHVUYtUZtaiMWtYOfVUYtaGLVwYtaGbRGLVGaoza0jNoM1UCgqjKhVGaYCqq0FoEGoDUQbiDfKaN81kdOaiukqK1ECC0BQZtUY6rWDHX6XE1y6aRy6awc7WsHLtrBzqjHSo51cVmqjNUZqqKqCgAQEEBgEEolGVGa1gx01g5VpWOoqOdaVmxUYsUZsVRgLFosKLyUPkoZylD5KGclF5KHyUWLRXkUeQF5VGbFwGKDAFMGcUSgMEogQIEuiQQBVfcMfKHoWKBaiKLCiwFiikBqRFjU5QakZUyA1IgcA4CBmxQUGOmsGK0yxVGbVGaozVBVACBKHURAUUggSiEQICKdQOg1KgZUGpUVqdIVuVIrUpBqdINaQMpFOpBasBpAaqM2qM2gxaqM2tYjFrWDHVUc+q1EY6awrna1mIxWsHPqqMdNYjGqax1WkYqjNUYqlZ1UFUGgNUWgtUMBAkCB0FoHQWgdBaC0Bq4DSAvX4VGLVGbVRi1Ss2tYVm1RkAqAECUWgtAKIBoCqgAgLVgzaKlAC0AqoSoCBEQIFoLVDpBaQXogvRFOkFpBaB0FoHQanSRaZ0kK3OiFbnSRW+emdwdeekHXnpmK68dM7g6c1FrpOkg3KgdBWgza0DQc7WkYtaGKoxa0MWqMWqjFqjNaBaDFqoyqC1QasBqgBWrACCqqBApQalBqINxBvmoN8oNyoOnNRWpUVqUFoABao59VpK59VcHPppHLqrg59VrBy6aGKo59VUYtUYrQzQZVRaqAECA6CAwDCBUFUGKMVoZ6i4OfUaGOo0OdijFjQzYoLyA81VWIHzVF5BrygfJQzmlDOQPkF4BeQXkBeVGbytGbyZozeVGcUFijNigsAVQKLAQIgFCkEQGqr7lj5Q9AwFigwFgLFRYBkRWpAakZVqQGpEUyAcQKgoM0RmqOdawY6rTLFaGLVGbVBVQaA2qi0FopQMAgoilUQIECBAgINRFMqDUoNSsq1KGNSorUoNTpA+gOgNBaotBm0GbVGbVRitYjNVHO1rFYrWJrFVHOtYMWtDn00MVcRiqaxWkYqjNUYrSBQX9AzVACUIDQOgdBaqLQWgdRVqi0RaRV6IDRBaozaAtVKzaozaqMVcAqjVQUAogAJRAgFAURKIBQDSigAFFQiUIiBAgWgtA6A1cVaotBAgILQWgdgKUDoGVIHQalRW5UV05qaOvNZHTnplXXipo689MjpKityoHSB1QWgxaoxa0jHVUYtawc+q0MWqjNq4MWqC1Rm1Rm1WWbVBTAVpQIrVAoLQGgtVECFaiDcBqINxBvlkblBuVlW5RTqB0BqjNqjHVVHLqriMdVocumsHPpRy6rQxVHPprEYqjFqjNUZooVBoLQWgQMAqEECUCozVVjpoZ6jWIx1FHOxVZsVWbGkGAvILyofKVT5KNTipRqcFGpwUPhBeAPgoLxCivC5ozeCjN5aozeVoxeVoxYozYozYuDNUZqiwEoKuABAgQAV92x8nekYCxQYCwoMWiwoZEGpEDIDfMRWsQMAggZqjNVGKuDnWsGK0yx0uDFrQzVRmqC0QAtA6B0CKYgYBBAgVVWQQGUDoHUQygZUVqdJAykVqdJBr0kDOiB9EK16IVeiFXohRego9ALVGbWkZtXBi1Ri1oc7Wk1jqqjFawYrWDFVHO1oY6XBmtIxVGKuGs1UZUGqBQAgAJYiBAtoHaC0Dqi0FoDQWqDSAtEFqjNojNqgtUZtVRqoyCUFBAlVCAEAVECAWqDQCqAGggSogWgtBaotVVoLQQJRCIEBAAhUKgMoh0DqBlBqUGpWVdOag6c1IrtzWdV05rI681B1lZVuVA6C0Ba1hrNqoxaoxauDFrQ52tDFqozaozaozauDNUZVkLgLQCqNESgUFAKIEI0KYDUQagNxnRvmpo3Kg1KjTcqB0FqitBm1RjqiOfVaRz6rWDn1Vwcuq1g59NDnVHO1UZqjHSjNqjNqgAaC1RaB0DoEFoEAuCaBQZqjN/TSMWNDFiqLAZ8rVXlaLz/woZwlDOCjU4KNTlKNTjSjU4SjU+ZRr+aUX8/8AhQfzWgvBRm8KMXhaMdctZo59cqOfXLWDFjQzYoxYozgBRKIBQCiBAhX3fHyavSMAYosBYAwFgHAakAyINyIpQIIEozVGKqMdNYOfS4lYrSMdVcGK0M2qjNqoASiQQEGpRTKBiC0FqqtBbBBoVaFWqVaFUop1Br0BlA6kDLSDWpAzpIH0QPpIH0QXogvSwHogLVgzqjNqjNrUGLViVi1oYtVGK0MWqjFqjnWhmtYMVUZqjFXDWa0jNUZoCqAFaqDQSiA6C0FoLQWgtAaovQg9KUego0gLViC1YM2qotgM6qAFoBRAlBoIACqoAQLVgKqigAWgFEItBaABaqrQGqLQWkFoFUQLQWgtBaC/Iq/KlOoIEpTqKZRGpUG4g3zU1cdOaiu3NZ1XTmsjtzUG+emYtdJQq9IU6sKzaqM2qMWrBi1rBjqqMWqjFqjNqjNrUGbVBaDNqsjVBqgUQCgNUAJRAhGgQrcQagNRBuVncGpUG5RpqVBqVILVBaozaJWOqoxa0jn1VHLqtYOfVXBz6aHPqqOfVVGbWhi1Rm1RmgAALVFoLQOrA6QMpA6QCwSgoCqM1UZsaVmxRYAwFih8gZylVqcFRufNKrU4Sjc4SjU+ZRqfNKGfMofBQfzWjN4M0ZvDVHPrhaMdctDl1yuDn1y3g5dRrNGLFGLGhigLFAogFIBRAgQr71j5I9I8qDyoMBYCxRYCkQakFakQMiBwDgKgAZ6awYtVHPprE1z6aGKqMdVcGK0M1UFVAAUMBIGAYBBSjRBAqAE0aqLQHpReiB0aOohlCn0RTpA6kD6AzogfSRDOgPoF6BeoRR6ID0ozelgLVgzelGLWmWLVzBi1Rm1pGLVGOquDNaRjqrgzVGKox00aFRiqD/QFUFVAA0Fqi0FoIEogWgtUGiUaC1UGgLVBoM6qi1UFAUBqg0FoDVVaItAAhCoAVqgVRQQCigRVQCIFqgIJVQIBVwWgREC0DoLQWggSiBAYBACkG4mjUQb5rOrjryiunNTVdeazo6c1B0lZG5QOgtUFoMWqM2tDFqjFqjFq4jNqjNqjLQzaAUZoyGlFMRaoNAVRAAWqiBAYBgrUFalRGpUGpUGpUG5UaalA6C0FomsWriM2qMWtDn1VHO1cHLqrg52tDHSjnWkZtUYqqxVQWgNUGgAILQWtKdA6C0Foh1QUBVAqAFjQMFWCmcg1OUqNTko3OUo3OEqtzhKN88JUanBRucVKGfMovBQXhaM3harneFox1w1mo5dctDl3y1iuXXLWI5dctYrn1Gkcuo1isWKCqMqJcBQAIECB99sfI3rFigsKDFFgDFRYBkFOIGQGogQQCgKoxVRjqtYmudaxHPr9qMVRitYM1RmtIKGgQKGAgQGUCgRpAtAaoKJo1Yg1RaC0gvRA6QW/9IH0BnQH0B9pBeyB9ED7IL2kU+yC9rCj0QXpYjN6IC9LBm9LBi1qDNqjNqozaoxaozaqMWtDNqjNUZ6XBiqjNUZrQzQACqgAAVBoLQSiAbVRaA0Fog1RaA1QWqrNAaAtVAC1Rm1RaABAgQJUQIAqpQaAAAgSoAQCrihRAlEA0ECAiIEov9AggQKAQQIVAQMBqA1GWm+U0dImjryiunLOjrEG+ag3KgdAWgNUZtUYtUZtaGLVGbRGLWgVRhQAKoyqKqgUVBmqIAov9AUQggQGCtIGVRqINyoNSgZUVqVA+iC0BaAtVGLVGOqox1Whz6q4OXVaGOlHPqrgxVRi1cGKqs1UFUZBUBqqtBaB1RSgdEWqHQWiLRQCUSogaFWA1IK1IDU5SjpOUqN88JVdJwlRucJRucpQzgGvILyAvK0YvC0Y65aHLvlcVy65azRx65bwce41g5dRocuo1iOXUbVixcGaozVAuCBkECBA/wBAeXyF61igsUZvJRYtBgLAWAsBqQDICBAKAtUc6qMdNYmudaRi/tRitDFaGaozRBYoAixUQIECA6KfyFWhRoUWrCi1cwF6EGqDQXoFoLQWgfQL0B9AfQH0C9AfRA+iC9EF6BeiA9KC9EGb0uYC1YjNqxWb0qM2qM3pRm1Rm1UZtUZtUZ1YMWrgzVQVRi1QVQaQZtVACBa0AEC0RaoNAaIgGqLVgAGqoAVUGgAFv4UGrAaABaCBAhEogWrAUUKLQAKgFRLBaQBFGqAEA1RaCFQiAiFRAoBBAgUAggQqAgYBgNxlW4it8oOvKDpzUiukqDcqDUqQOkFaoLQZtWDFrQzaDNUYtWIyoLVGVBVGQCoKqJQUAogCg/YhgEACA6KYB0VqVEa0DKg1KQOkDqC0BaoLQZtUYtUc+q0MdVcHO1RjqqOdqjFUZq4MVRiqCqg0AoFVaC0Foi0Fqh0DoLQGgdBaodAwGpAMgrfMQbnJR0nKVG+eWd0dJylG5wlG5ylG5yUa8wofJQ+f+FGbyoxeVGOuWsHLvlrBx75axXHuNZo498t5o49RtHHqNK5dRoc61gxYozVAuCAAAQIH+g8fIHrGKDFBgDAFii8gsUWAQQH/AAAAoMVrEYqjHTWJrHVaRzqqzVxGK0M1UACqowArKBAtBaLi0Foi1QbVBaoLQZtAWqC0wHpRaQWkF6Ih0FKB0F6IH0QXsgZ0RT6IL1SC9AvSg9AvSxBejMGfSjN6UF6Bm9KM6qC1Rm1Rm1Rm1rBmqM0AprNEZXAVcGaqAEoKCUFBaqAAC0QKLQADWhaKNAaqC0AAtUZ1QUVCIEqDQWgdAaotAKqBAAQCqIRLihQUACAUwFVVgEEIhFAaUQGAgWAQQIDgLBVgIDAMBuJqtxFbiDpyyOkoOkrKtygZUDoDVFaDNrQzaDFqjNoMtIKozQFUZqgq4mhQCKqBQAgZBKiBCqA0qBFMopgHQalEOoHQOgdBaA0Gb0DNqjNqjHVUYtaGLVHPqqMVRiqM1RigyoKqM0BVAqjQWiLVDoLQWgtFWqHURAQMBqA1AbkFb5gjfMQdOYyOnMQdOYg6cxBuRBuRBqQU4IsBmxoZ6ijnYuDl1G8HHuNYrh3G8Rx7jeDh3GsHHqN4rl01iOfTSsVRmqM1cEAoAECB/oZ8fesYtUWAzY0DAWCDADQgQHQAABVGOlxGOqoxa3iMdKOdUFXEYrQFBggqqAFVAJoBAlwSgqwSQGgLVGbQZtWA1UFqwGrBaQXogvSwGkQ6QXogdpBeqQXogZ1SKfRBbSC9UgvVILSC9KC9AzegHpRnViC1QWqM2qC0BaozaDNrQyIKozVAoKIzVAoKABVQVUQARKqFAgqoFEKLQZVFaAAKM1VAiAKiBAlUKIECBAqABAlQAgVUCqKABAFEKgQIRAsAggaBAQQFRfgECA4CwFIDUgNRFb5RXSfoG+f2zo3EG4itxA6B0Bqg1QWgzqjNBmtDJiDprBkFVGQQMtIqqAAoAQMqIECBKLaBBAQIHUForWgtEWgtIDSAtBm1Rm1cGLWhi0GOq1gxVGaDNUYqjNUZAKjNAVRmqqACLVFoLQQLRVqh2gpQalAyg1LUG5RG5UG4K6cpqOnLI6coOnKaOnKDcRW4g1AIFQWKjFjWDnVHLuNYOPbeDh3G8HDtrBx6bwcO2sVy7bxHPppWKoxVGauCBAFECB/obHx161iqLAZsaBYAxUFgDFAogQIADNrQxaqMdVcGLWmWLVViqgv7aGLFEAqoLFUAMAVU0YJAsAsEA1QWgLQFqjNqjNqjNqxBqwWgzqi9AvQLVRegXoD6BegXoF6SB9EU+iC9LEXogPQq9ERelgzaQXoGbWsBaAtUGqC0GdUotUo0KNVBb+AYqgUFECgUFAKK0QaoBAKlFRRogXESqLQFqoNAALVgLQZqqhBREogQJVAJQUECBAgQBUQIBVVAKogAJaIosoLBVgLKBwDgLKBwDghwD5KLKCyiryCxUWUDgLAKK1IDciarc/QNRkdIg1BWpQMoHQWgNBm1QWgzaoyoFQdLgyCqjOAlGVRUQKCqAAAVUCBKyhUCBAdBaB0FoHQWgtBaA0BaQZvSwZtaGbQZtUYtXBiqM0GaozVGaoyA1RmgKDNUH5BaqBRaC0FsFWgtUWgpQalBqUGpQb5qDcqI3KK6c1nUdOag6c0HTmsjpzUHTm/hFbgNQGgQgqjNawc+lHLprBx7bwcO28HDtrBw6bwcemsVx7bxHPpoYqjFVRVwAIAogQP9EY+OvYFQUVmqCrgzVQUBQDQgGggFUZtVGLVGLWsGK0yx0qs1UZqgqgBAFQYAVWaoFQKgUFAaAtAWqM2qM6ozasRnVBaoPQjOqLQWgPSi0FtBaQM6IL0Qp9AvSwPr/pBeiC9EFpBelgL0A9ANUGkBoLVGbQWrBnVQWqIBVGQFAVQUQKBQf6ogZv7VBQAiGl/qg0AIlxAqiqgoABVGauCFAARKiBAgGgtUCqgQIECBAFRAgSqMBYCxRYCwFgLEDiiwF5A4BkA+QWA15A+QWIGcqLyC8gPK4q80FgLAOA1IlVqA1EGoDcTRuIEUwCA0AAqgoM1cA0AQVcBQFUCgBlUVEFUZoKqBVAIECVlAgQqBAgWgdBaC0Fqg0BaoL0QZtBm1QWqM0GKuA/1RmqM0Gaozf2ozQZAKCgACjKoqoAQIEKlEC0DoNaDUoNSoOnNEblQdOazo3z0g6c0HXmoOnNZHSUG5QblBqUFoDVGao51Rz6bHHtrFcO28HDtrEcO28HHptXHtrEc+mhirisVQVcACAAlED/RD469gVBQZtUFUZUFBnVBVEAoDVQWqM2qMdVrEYqjPVUYVGauAUQMgqolQUGaqixRlUZVBVBaDNAWrgLVGbVRm1QWtDFoC1UZoBRWqDQGrEWirQGkQ6QWkD6pBaC0Dqi0FoLQWi4tAbFBbAGrAaRBqwWgFEA0GbVEAqgUFBmiJQf6ogZqgomgRUaCmiqiUQM0AqCggCjJgKqoGRCqIEA0AolVAgQIECBAsBYqLAWKqwECBYBwFgHAXkF5A+QWAZAPkDhQzlKp8lD5KGclD5KDyVV5XNQeVosKi8lXF5KpkgNSIGQGoDciaNRAimCHIAFCgoM1oABUACrgAFUABQKgECgUFAKqwRUAogQIECBAgQJQAgSg1QaAtBmgFGbQZ1QVRkBVGaDICxRmyAzVBQFijICqMqJUAIECBCj/VCCBqAZQblQblEbnSDfPSDfNQdOag6c9A6c9IOvNQblQblBuUDoC1Rm1Ri1Ry6reDj3WsVw7bwce63iOHbeDh20rl01iOfTQ51cVmqM1RAgSgoIH+h3x16xqg0GdUFUGqM2/hRlQANUGkBaqDVGbVGLWsxNZtVGLVVnVQUwCi/IDAVUCoKDNVRVGVRmqgqjNAWgzVwZqjNrWIzaoLVGLRBrWDNpAaoLVBoVaINUWgNBaQOrBaClA6QXogfRBeiA0gtILRVsaQWwBoJRANgLYQVpBnVEA/IBRKCgzQSoFEDNUFDQMqqoDRRE0ooCgFQUEDKgAVVAgUWCEUUAqIVKIECBAgQIEocBAsoHAWUUzkQ+UqnyUXmgfNA+CqvAi8gvN/8KGc0ofINeAM5Bqcop8lDOSi8lB4AXirUXmgPN/8WkXkovAqnINTkDOSjWAZDRqIHBTBEAFCgoM2NABCBRmxcEAUFBmqBUAgUCiBlVQioBRAgQLAWAsBYCBKAFVwGqCgNBmqAADNANDNAAKozQFAWKM2AzVGbAFUFgM2KBQAAQJRCIBn5FKiAgQalQblEM6Qb56B05qK6c1Eb56QdOegdeekHTnpINzoG5QOgLYqi1UYqjn01g49N4OPbWDh3W8HDqt4OPdaVx6bxGOlHOtKzQZqiBAtXAAgf6FtfHnrFqg1QWgzaozaqC1QaozaYC1QaoLQFqjFrSM2qjNqqzVGaqAECBAKoKqIGaqs1QVUYaRm0GaozasGbSAtVGa0M1Rm0Rm1QWqM2rgzaqDQGqDaAtBasBqi0FpA6QOgvQH0C0FoLVFoIBqi0EA0FoDVEogQIBQFUACgKCVAogZqgoaBkKIAolUUBRAoACgoAAqgRKiBCiqBRAgQIECBAhTgGRRYBxA4BnIh8gZygZyK15FM5ShnJQ+f+FF5Wi8lD5/4lFOSh8lGpyUM4KNThKHwUPkovH/CivBQeCg8LQeVoPILyopyB8gfIHBTgHAOAsBYAwBYoMAYAsXAKDFQVcGcAAK1gAZVBQFVAogZqqgQIFgLAWAcVFgLAWAsAYAxQWLgMUFBmgKoKAAAzVBigwBYAsAYoLFBZ+AYsUZsAWAzYoLAZsUCqAAJUU/QIRAhUoYCgNRBqCNSg1KDcqK3zUHTmojpzQdOag680G5UVqUGtBaqC1Ri1cHPtrEcuq1g4dVvFcO28HHtrFce28Ry6axXPpUYrSs0GVEogBggQP8AQWvkD1jQFqoLVgLQZtUZtUFqg2rAaQZ1YlGrCi9LBm1UZtUZqjNqgAaCUWgtBAqAVGaqs1RmriMVpGbQZtUZrSM0GaoLVGOqozVRm1oGqM2iC1RmgNUGgLVECESiBEFpBaQIp0FoJRaC0BtBbVFpAaC0EC1RaC0FoIwFUAIRmqIBVEDN/aoKAEVVQpBQSgoCqgAKCgzf2ogACglRAhRVAogQIECBAcFQHAakEUgNYBkQMgrU5SkanKUa8FUzgqtThKHwUPilF4pReaUPkF5A+QM4pRqcAZwg15Kh8FU+IUHgqC8CjwtB4BeFzUHkovC0XkovBQ+CqvMKHyovJRYUGLRYAwBgDFBYozYAUGKgsXBmwAoKoyqCgKqM2KIFkAYosBYKcBYBwFghwFgLAHkFgo8qjN5WgsKM2KM2KCwBYoMAYAxRYUFhRm8qCwBYAvKjNgCxaM2AzYozYDNigsBnFBYKMUGAlRAgQICCUan7QIjQEG5aDUqDpzSDpzWR0lB05tQdJQblBqUFoC1Rm1Ucum8Vz6rWI4d1rFce63g4dVvBx6awcq3g59Lgyqs1UZFSiBZAWQAD7/a+Qx6xqxBpAWrBm9LAXpSs3pYC1YM2xYg0gNWINUF6Bm1QWxRm1QaAtUWgNA6CBAqAqozVVmriMWtYMWqjNqjFqgtVGbVwZtUZtUZtUZ1UZtUZqpotBnVBoCrAKIQbFBtUWgtBaC0DoLRToiBehRoLVFoLdAqAEBBAgQIACqgES4M0EoKCEZqgogUVGgoqqABQFVAAUFBm/tVQgAUEqIEAqgVUCBAgQEUwDII1gGQDiDUgGcpVanKUbnKVW5wDU4SjU5RWpyUM4KHwUXgovBReCinBQ+APgGpyBnCDU4KGcJQ+Ci8LQXgovBRnwtIPC0F4KLwC8LReCi80F5Wi8lFigsBYA8qDyoMAWALFGbAZsUGKmiyrgzYozYoAZsVGaqCqAFiiwBgLAOAcAyAZyBwDICwF5AeQWFGbytBeaUZvKjNijNgCxRmxQZQGAvNUXkBlAYAvIC8rQXlRm8gzYozYDN5UYvNUFijNgM4AsUGCixQYIlECBAcBAZAawQgQagNwG4DpyitxB05qI6Sg3KDUoLQFqoza0OfVXFcu63iOHdaxXHqt4OPbWDj1WsHOtjn0uDKqzVRkEogQIB+BX3v0+SR6h6IlF6WKL0DN6WIL0sGdUXpUFoC1RnQGqC0BqwFqjNoJQAgQICCBf4qM1VZoM1rE1iriMVRi1cGaqM2tDKjNqjNqozaoLVGLVBaqM2gAFXAVoSILVwCg0ECBAgQLQWqLQIqIIgtii0Q6ABEFqwOoqlAqIBQAIQVcBRUqCgFQURKBQDQBX9KgAAKqAAoKDN/aqhAAoiUQIBVAqoECBAoK1AOA1II1IDUiBkQanKK3OUManKK3zwDc4Sjc4Sq1OEo1OChnCUPn/hReSh8RaLwUHgovJRrwUM5KGcpRqcg15Fw+UF4KLwUHlQeSgvC1NHgoPK0XlaLwUHiLReSi8gPK0HkovJQeVBeVoPJRm8rQXlRnAFijNiozYozYuDNjQzYDNi4yzVBYoAWAsUWAcAzkD5QM5BryBnKB8gvILyUXkoLyAvKgvKjN4Bi8KM3laC8qM3kBeVB5/wCAvKi8gvADyCvKjN5AXkGbwozeFGLyDNijF5UZvKjF5AYozYAsUGKowFgLFRYCwFgGQDIBwQyA1gGQGpAdJAbiK3yDpyg3ERuA0C1cAqMVVc+msRy7rWDj3W8Vx7awcem8HLprBzrQ59Lgyqs1UZoJRAgQLBX3X0+TPSvRAelgL1SDOqgvSwFoDVBqi0gNAWrgNUADVBoIEohECAwECoM1VZqjFaxNYqoxVGaoxa1iM2qM2qMWqM2qgtWDNqwZtVKzQFoC1qA0QANWCtUAIEAoLQWgtBaC1cDqiBfgF+AQIEC1RaC0CCBCnQQAEIKuKyBVBRAoKIlUVRIBSimAaQUBQABQAzf2qiiJUSAUQJVFAKIECBCnAagGQRuQGpEGpEVqcoNzlCNzlFbnKUbkRW5ylG5yg3OUqtThN0jU4KQ+IUHiFF5hSLytIPKovIHyLD5CGchG5yzQzko15SiwovJReVoPJQXhaDwUi8xSDxCkHmLReYtIPJmosWgsAeVF5KM3laC8gPKgvIM3lcGbyozeVGbyuDN5XEYsaozYuDNijNgjNijONIMBYCwDhQ4DUgNYgZyUa8pQ+Sh8pQzkofBReCg8lBeVozeVGbytGbyoxeIZozeVoLytGfJReQXlaLyUXkovEKDwtBeFoLwUYvBRm8KM3hRzvCjF5UZvKjF5Bm8qCxRnAF5WgwVWKDAWAsA4B8gcEXkDOQanINSCNSA1IDcgrfMRHSRBuA1AIKqCqjFrSufS4jl23iuPbWDj23g49VrBy6bwc+lGKuKy0M0QYCUAIECB9x9PlD0jVB6ILSAvSg0BasBaRFqwGkBqi2Ko0FoDQGgtVFoLQIIDAWgLYDNVWaqMVrBiqjFUYtaRm1cGbVGLVGbWkZtMGbWsGbQZtVBaDOqJRKgoDVACBAgAJQaC1RaC0FoHYA0wWqLQQIDoLQIEECBCoECBmrgFCIKqABREuLgoalBRAYBoVBmgACgBmqCglRAASiFFUAqBAgUgNQGpAakEbiDUiDciK3ImjciK3zE0bkQb55RXTnlBvnlB0nKK1OUofKCyAfIDyovKgvILyC8rRTko1OQakZGpAMiBwFkA+QHkFeVoPJQeVoPJReVoPKg8rgPJUHkBeVB4AeVorFoPIM2KM3lRm8qM3lRmxRixRixpGbFGLFGbFGLFTRiosAYocAyINSAZAakSjU5QanINTlAzkGvILyC8gPIDyUZvK5ozeFGbytGbyozef+FB4UF4AeFovALwC8AvAK8LRm8lBeFozeFoxeFoxeVGOuFHO8qMdcqMXkGbyozeVBeQGALFBgLyovILyBnIGcgfJQ+Sh8A1OAM5Bqcg1OQanINyJqNyA1IBAgqqCqOdaVjprEce2sVy7/TWDj3+28HHprByreDn0oxVwZaVmiJQUACBAgfbPT5U9K0Fqg9EBqxF6IUaQGqg1RegGgtFxaA0EogIIEBBAgQCqrNoM1plm1oc6uDFUYtaxGbVGLVGbVwYtVGauDKmiqjIC1RkDVRlcBVECBAgFBAq0AECBAgCiBAgMBAgQGAQIIEKjBKKAzQSpqAVU0CCglXFQ0KoqJoaAqKgzQCgAVcGQFESi/0BVAqoFQAqBAgINQRqA1Ig3Ig1IK6cxNG5EVvmINyMjfMRXXmIOnMTVxuRkbkQanKUanJQ+f8AiA8rReSg8rgMUWAsBSA1gGQCg1AOJQyAfKCxVWCDFFeQF5AeVB5UF5XAeQGKDyJq8rQeQZvK0HlQXlaM3lRmwGbGhjrlcGbFRzsaGLFGbyoxYozYqaLFxGcVVghxRqRAyFG5yyNTkGpyg3OQanKBnIHyUPlBeQXhaM3kBeQZvKjN5UZvK0ZvC0F5AeVB4UXgF4BeAPgF4BnwAvC0ZvBRi8rRjrhqjn1wtGLwtHO8LRi8KM3hRm8qM3kB4UZ8gvIDzQXkD5UM5AzkGpyBnIjU5A+QM5BryBnANTkGpyBnINYBwFgKxUZqjFaVzv8ArWI49tYrl3+m8HHr9tYOPTeDnWsHPpRzq4M1pQqAEAwBVEKgfaPT5XHdev8ApBelhR6Ii1QWrAeiC0gtBaA0FtBbVVaItBCoKtA6KdRCCBAzaqiqjFqozWhjqrg51pGLVwZrQxVGaIxWhm1RmqjNoC1QKARAzauCUQIECAUEArQgQIAIlggqBCoECAwCCUIJFWrAiIEKAAJUFUAmoApEKKCUZ1YiAKgoCgKoAFXBkBREogVUZVUCoAECFUBqAYDcEaiDcQbkFdOYzo3Iit8wHSRkb5iK6cxB05jOrjciDfMZ0bkQOARVgDAVjVGcKiwFiiA4BiBgNSA1IyEUgsBYCwFi0ZwBiorFoMAYoMWgwxNGKLAFi4M4oMBmxQXlRixRnqNYOdioz1FHOxrBmxRzsaSjFGbFQYqrBDgGRKNSINSA3Ig3OQanKDUiDUiBkA4CwFgDFBeQZvK0ZvK0ZvKjN5BnyoryoPNBeVofJReQXkF5AeQF5Bm8KMXhRi8FGLw1mjn1w0Od5UYvC0YvBRm8tDN5AXlaDwA8AvEBeFF4A+AanAGcINeAM4A+BGpwB8A14FPgQzgDOVGvILAWKCxRmxUc+o0rn1FxHLuN4rj1GsHHuN4OPUawc+o3g59RRzq4MqoxpBgAEAoLFFgPsfp8tj0L1CIvQK9KDQWqLQWiDQWgdBaKgQEECBC4YBQWgdAWqrNAWtIxVRm1Rjqrgxa0jFXBitDFVGbVGbVGKqazVGaDKiVNQC1QGCUQIECAUECaBgIEAMRKIEGIVAlECQMUIEVGCAiIEKFAIgFUAiDAqoBQF/TSAEqABQFAVQAzVwAKqgBAr+lGVVAqABAhTBCK1Aa5EbiDcQbgrpGdGoiunMBuMq6RnR05B05Z1cbjI3ymjcQagLBTgDAWAzYuIsUGKICBQIGA3GQimQCCwFgDAWLgMVBgBQYCxRmxU0AsUGAMUZxQWKCxRiwGbFTWOuWhixoYsXBixRzvLSCxUZxQYCwDgGQGpEG5AbnKUanKUakQakBqQFiDWAsBYKMEGKCxRm8qM3lRnyA8qDyCyLReQHkD5WiwFgLyA8gzeVozeAYvCjHXCjneFox1w1Ri8LRi8KMXj/ijN4/4tB5KC8KDyC8AvCh8lD4ShnBRqcFGvBQzgo14SofChnBQzgofBQzgovIHyovILFRm8qrFi4jFjQ5dRcVy7jeI49RrFce43g5dRrBy6jeDl1GkYsXFYsUZUFXBYCyAMBYCUfXtfL3dbAWgdBbRFqi0gtILSCIIVIHQQHQWgQQKARpAgQCqms1cRm1oY6BjprBjpUYaGaoxWkYoM1oZqozQZUZUQgoBoQIECBAgVAYCaEA0AogQIECBKIECAwCCBQUgf8Af4CBKBUF/QAEIKKlBQQCtIBAogAMqCgqKyoBlVQAL+1UKIEABAgQNQCBgrcEbiDUQdJ+xW+WdG+RW+f2g3GR05RXTlB05Z1cbiDcQbn6ZGoDQAVAgGAsEDQAWA1AUBqAYmjURSDQIECoM1cAqKqCgACgq4mhRAAQMtAsBmqM2KM4qMWKMWNYMdRRixRmxoYsVNZxUWAsBYBkBuQGpEVuREakQakBqQGsQWIrWAKCBKgUZoCqM1oGALAGKDKBwFgLAWKLFVZQViIzeVBeQZvKjF4UY64UYvK0YvCjF4XBi8KC8KM3goLwtB4KLwtF4BTgGvBUM4AzgGpwg1OAPkDOQM4A+APlReAPkF5UV5AXlRm8qjF5XNVz65aRz65XFcuufw1iOPXLeK498t4OPXLWDl1y1g59ctjn1FGLFwYsVRYuIMUGAsBYCwH1rXzB3PpYi2kF6pA+iC0EotBaB0DKioEBBAkDoICCFqUWioSirmIzVwZqjFqjFXBitIxVwYtaGaqM1cwYqjNVGbVGaAVBVAQSiBAgQIECBAmgUEAwoMUQIECUQIECAgQQKCkECUQJQCCgAQAEqUKIgzVBoiUFAAFBVBRQAVFQAgv7VQogWgAQIFFGhCKYitwG+RGog6RBvlFbiK3P2g3Kg3KiunLOjpKg3zU1W5WRuVINyoNAhUCwAAUGKiwFgEDAMAwGogYitfgECAAKuIGgUACUZtWJRoJRaABAy0CgKoKoxVRmxRixRnqNDFgMWNJWbFGcaQYCwDIBkBqQGpEVuREakQagGIrUAoIECAKgUFBmqBoAJQYABAQWAsA4tFkKLEBeQF5WjN5Bm8qM3laMXhRi8KrN4WozeFozeFozeCgvC0HgovCi8AZwBnAhnAGcA1OAanAHwUXgD4A+APgF5KLytB5oReSgvK1Gby1VYvK1GOuVzVcuuGs1HPrhrNHLvhrNHDrlvNVx75bzRy65aHHrlvNHPrlcGLytGLyozeVoMWgxQYIgqUr6vr5i9BEQIFoHQUAqEEgQMqKgQHQWgkCBBAlXEAtVBVGaDNqjHTWDFUYv7aRmqMVUZqjNawYoM1UYqgqgogq4BRANBaBBAgQIECxoQIACMAoASiBAgQICBBAoKQQJRKIAiCqAEAAKiUCgACJQUBQCgqqKAAVUVACCqoUQoEQIEBn7VCBgpgNxFb5EaiDcQdIitSityoN81BuIrfNZ0dJUG+ag6Ssq3AalZG5fwgRSCBkEoFRAgQGAYBgGVNCg0C0Fqg1QWgNUFAWrgNAVpECAArQQMtAoCqBRnoRmtDFUZsaGLAYsVkWNDNigUQLAakAyINSA3EGpEGoBkRTAKCUQC1BLiBcGbWhm0EoyogAIEsEQMEKKoBA4CwBgKwGLyoLyozeVGLwozeFGfADwtB4UZvBQXhaDwC8KHyVD5KHyUM5KHyUM5Qa8gZytD5QXkF5qi8gvJRZ/woLyoPKoLyUYvLWarF5VHPrlrNVy65aqOPfLWK5d8t5qOPXLWarj3y3mjj1y1mjl1y3gxeVRzsaGbyoLFGcAWLhowQKPqkr5k9B0GpRFoHRalEBQQEEgYBgEEioEC1Q6C2AtgLQWqC0GbVGaoxaozVRitDHSjNVGKuDNawYoCqjFUFUAgq4BQUEMoVaKgMBAgQJoQIEApgFFgLAWAFECAwECFaBAgQJRKJEFAVQAqoAAJcQVQKgBUBQFAKCqqAKjNBAFBYogAooD/AEQglQwCBgNCmIrcBuCNxBqVGsblQalQblBvmoNyorpzWdG5UHSVCtyorcrI1KDUrIdBaKASiqoAQIFAINKKIEDqC1RaC1QaDNoC1Rm1U1bVBoLQWgtAWrgtUGgtUACqjFUFUYqgrQzQc6rIaGauAUQGAYBgN8s6NINQDAaAxBIoVFVBoC1Rm1QWqDQZtWA1RaC0RaotA6CQOgQIFFQHAWALAGKjNgrN5UF4WozeVUXgBeVQeQF4UHgF4UXkVeQPkDOQPkDOQOAvIHyCxQ4CwRYCwQXmFBjSs3kBeVRi8rVc7y1mo59ctZquXXLWajj1w1mq5d8N5o4dcNUcuuG80ceuGs1NcuuW81GOuWhi8gxYoz5aBYAxRYD6fK+aPQdAyiGUCBlAgUKtFQECgtAkVSkDpBagNXBaodBAgGgrVGaDNrUGKDNaxGaox0oxVRmrgy1gxVSigxVBWgUiM1RAKJUGIVKIFECCBAmhAgQCwFhQKIEBUQIECBCkECwFgHFFggAVQAsAVQAFEIKoKqABQSgoAEqgBVBRACxQAKoKKASohCCgEDAaFMBuUVrmojcqDUFrUCtSsq3Kg3Kg6ToG5WVbnSQblQb5tQdJUg1KitagZUDqKlEA1UQIECA6oQWgUFoLVFoK1Rm9GYC1YlZvRCi1rBaQHogvRBegWkF+wSoqoNUGgFgzQFqjFUFaRirCs1UZqgq4DFBAIGAf8BuINRBqIGA1oLUBoLVBaAvSwZtXMGdUF6WAtWA1QaRFqwWkVaRDoHUDoIGgMQIpgJA4CwFijN5QHlaLFQXkVm8qC8qC8gPIi8qDzAXmAvKh8gfIHICkA+YCwFgHzCiwosKLCi8wFigxaC8lRmxrNVm8rUY64Wjn1w1Ry64azVcuuGs1HHrhrNHHrhvNK49cN5pXLrhrNRy64azRyvDdGOuFo53lRnyozeVGbFFio+ma+avQQMoEEBlQalBARVKg0BBABToLQWgtBaC0EoQGgLQFqjNUZ/xUZq4M1Rjr9KMVUZqjLWJrFUFBitAqgqoyCAURKYhUokFAIIECUMBAAQIBiiwECUQIECA4KsA4CBAlCIKAqjIIBVAAUSozQFVEAoJQUACVQABKgwAAxRKM2CgEqL/RCCgFQwCKYDcBqINSorcojUoGVlpuVINyg3Kg3Kzo3Kit81B0lQblQblRWpUDqDWggQIECBKIECA6C0Fqi0FoM+lgzaJo1QasBqwWkFqi0FoIDoi0BaYBRaozqgtBmtABmqjFrSCgzWsBVAAgECBBuIrURGoBQIIEAtUZtWDNqwZtUZtUZvSwHpYC9CDf+qq3/oHQUoHQMoGUiNSoGVBqA1AKKUCCBYCwBgKxaDyIPNUV5AeVBeSg8qq8gvILyqLyCkA4CwDgLFFIBwFgLAWAsBYoMAWALFRm8rRi8qrHXK5qOd4bqufXDWajl1w1TXHrhrNRx64bzRy74/LWaOPXDWaOXXDeaOfXLVHO8rRi8tDN5UYvKjOKj6Rr5u9B0DoHUDoEDKgZQIqgNQCgtAqCgtBaC0FoLRVoLQGqDTBKjNoM1cGa0CqMdLgzf0qMqMVU1mqM1cGKoKqCqAAAoJcEoAUAgoBBAYBBAgFBfgAogQDAOKLAWFVRA4CBGCUQJRKJECgoABVAAxRKjNECiBUAoL+jAKqAUECVBgCgFBiioMihUIgUQKKpBqA1AalRGpRTKkGpRW5UGpRGpUXGpUV0lQalQdJUG5UVvms6NyoNyoN838Jq41KgdSBlBaBBAlACUQL0A0FqwXogLSJq1QXogz6WAvSwHpQXogvSwWiLQOgtBaC0FoDVwWqM6qC0MGqrNqss1VZqoLVGa0AACUWgYg1AMRW4BgNSpqHUFoM2tYC0gzaoxaozelgzemsxGb0qs+lQeiC9EDOlDoGUDqDWgZUVqEQyoNRBqAYilAwGgQIECAKIQYCxQYA8gvKiwoMVTgLAWKiwDgLEQ4CwBgHAWKBVWAsBYUGKDBGby0MXlVYvKo59cNZqOXXDWaOXXDWaOPXDeaOXXDWaOXXzbzRx64azRz64/DVHLrhrNGLw1UYvK0Y65aoxeVH0KV85eikDKQalIGUgdSBiBgGIpAgdBaC9AtBaA0Fqi0FtFWgtBKDRBaoEAoy0CqMVcGaqMgzWhixSM1cRmxQKM1UAABQC4LVECBaBAggMAggAIECxQYCwFgLAOKJBAhUsEBwECUWKIQUAAAWKMglBVQCDFACAYoAWFEqgECxUFgDAGKCqCgLBWVQiBVVoJQqGUGpUDAalBqINRBqCtSoNSg3KhWpUK3KityoNyoOkqK3KzBuVBqVBuVNwrWop0CC1BKIAoLQWqlClGhVoVego9LAasBasGb0sBeiA1UWhVoVegMoLQO0FoLQWgNXMBqwGqyKKL0pWbVBaqM2qM6oK0C0BoLQWrBqIGA1EDqDUoplEWkFaQGqVm1Ri9LBm9KMXpYM3ppGb0uYDVgNILVU6gZQalAyojUAxBqVFagNREaiDUAorUBaBQOAsBYosEWAsAYosAYCwFijKqgQEFAWCHBFgLAWAgQEACBYtUYuaDAGKjNjQzeVKx1ytRzvLWaOXXDWDl1w1mjl1w1mjl1w3mjl182s0cevm1mjn1w3Uc+uFo59cNZo59ctZo59ctUfvdfO3fCKYgZQOg1KgZQKBgEUgUEAUQIEC0FoIEotAEFqiAIBRloFUZXBmqjFMBWsGKoxVxBVGVGaqABQFUFBKIECA6CgEDAIIEKqABKiBAgQIECBClRAgQJQqAAAEACqAAoKqARVRmghUqAEAVVgLACogFgLFBVGbBWQCohBa0oBQCqGAYDUFMQalBqVBrQalQalBuVBqVBqVFx0lRW5UG+ag3Kit81kblQblQalRTqB0DoIAA1pKLQGqLQGrAaQGtQHogPSgvSwZtWA9EFoi9AvSwUpAyoLQOgtBasFoLVBaQFqsi1VZtEGqC1Rm1QaoLVACALggaiBBqUGpUEB0ECBm9KMXpRm9NZiMXpYMWrBm9NZgNWA0FoLQMoGA1KDUTRqINRBqfoGoitREagNRAxBqAgIpgERAgQIBgLFEAwFgBRGCVUCBCIDgiwFgLAQL/AOAAWAsXFWKM2AMVNZsaRm8qMdcqOfXLWaOfXDVHLrhrNHPrhqjj1w1mjl1w1mjn1w3UcuuGs0cuuGqOd4azRz65XNH7bXz+O5AxA6B1Ayi4YDUQKDWioECBAgQIgqotBAFEBBAgQCgzWgUwZsUZsVGbFGaoxVTWa1gzVwYqgqoyAqiqjNBAgQIBFGgIGIEFAQqkBYoAQiBAgQIEuCFIIECBKFRAKAoM0RKCgKoKqMglQC4rBQCBYolRAgGAsUGCCwAozVGaKP9VBVxGaqoEqICBgNQDKDUoGVFalBqVBqVBqUG5UG5UGpUV05qK3Kg3zUHSVFalZG5UGpUCB0DsIq0TRqg0BoC1oGkBpAWrBm1UGqC9LAelgLTMB6WA1RaB0DoHUFpA6QWkDpAaorRNZ0BqoLVFqjOgNaBaA1Rm0BtWCBCICBlFblQOgdBaC9ALVGbVRi1Rm1VYtaRi1VZtaQaDKhBA1KDUqDUQagNRNVqIjcQaiKQbn6RCgYDUQIEDAIIECBAgQLFgKCUAICAVUIQQIECEQIECBYBBAFBioLAFijNijNjQxeVGOuVzRz64ao59cNZo5dcNZo5dcNZo5dcN5qOXXDWaOXXDWaOfXDWaOXXLWaP1z8E7tQFoGVNGogYi41AMoNRNCkERSQQIEsEQQCgtWA0Fqi0gdQIIEABYtGcUFijFgM1pGbFGKprFjWIzVwZsUZqoKDNUVUZoIBoiCohUqkDoFIEgdIKClRABFQAIECBKIEKdBAgQHFEogGAAFggqgwBVAorBGVFgYBVgDFEJUogQIEoMEFgCqM1RixQYAtXBlRKDRFoGUDKo1KBgNIGUGpRWpUg1KQalQalSDcqDcqK3KityoN81B0lZVuVBqVBqVBrQOgtCrQADVgNWA1cwFqjN6EZtUVqwZtWAtWDPpQXoQeqsKtoVbQpnQUzohT6SFPoKdCr0FXoKPSwovRBaINUGqC1QaotBnVBqwZUQU6REQQGARTKkDpBSkDpAaAtVGb0sGLVVm1rMRi1cwZtUZtaGbRVqxFKIRTEGoDcQaiDcTRuINRBqIpgNz9IhQMAoGKNQEB1BAQQJREEAUVBACCIEAogIIECBCLAWAgIIECBKBUWAAFijPlaM2LRm8qOfXMazRjrlqjn1w1mjn1xGqOXXC5o5dcN5qOXXDWaOPXDWaOXfDeaP078K7mIEDAajI1BcMAoNSpoQMoqA6C0EoAWiC38gNBaotVVqBQMAggQIGaoKozVGK0jFBitDFaxGauAqjFVBQZqiqjNBABEohENEEDQEEBgpBABFQCiQQIEogSqgKCUKCqiUQIGQVEZqiAKBQUAqAMWChRAgSogQIEoBBQZv6awZqqzRGaIz0uKyolQaotAwCBlBqUGgMqBlBqUGpRW4yGUG4g3KityorcqDcqDpzWVblQalQalSDUpA6C0FaQGkBqgtUZvSjNqg1YjNqwHoBa0M3oB6WA1YmjRFqi0DoHUDKB0DoLQWgNBaC1QaoNBaoAFqg1RnQSogQJRAQMQIEEC2ANBm1pWbQZtaRi1cGbWhm0GLVBqqdVFohiDUFaiDcTRqINxNG4g1EGoimA3P0iFAwDAM/YECCQMAglECUQIBQQBVQhBAgQIECA4IoCAQCCBAlVEErKAAlBYDFjQLFGbyDF5aoxeWs0cuuVHPrhrNHPrhpHLrhrNHLriN5o4dcNZo/QvxDuogQIGUGomq1EDCBQaAyoLVFoHQGgtAUEogQIECiq1E0KCBAsAVcGVGaozVRitDHX+qMVUYrWAq4jFUFAVQVRmmJoVECBAhoggMAgQQpoAEIlECBAtBAlCAVTAIBBAVFQQCgAFXBlQ/wCKjNAAKogQCqgDCqgRAgQJQCCqM1RiqrIjNrQzVwFogUH5BaqoDAagjUQMBqAYBiDURW5QalQalBuVFb5qI6SouN81FblZG+ag1KitSgdQOgtBaC1YM6sBaqM6AtaGbVBaozaDNrWYDSA1WRauA0FqwMoHUDpAypA6B0FoLQGrBaA0EolBoDQFq4ARKJQWgtBWmCiqUQoGUDsUWwBaQFqqzaDNqoxWlZVGbWhm0GVEIGlMBqIhRWog3E0biDfKaNxkagNRFaBqfpEMQMAwDAIIGgQIECBaotBKIACFQhBCIEKgUAghEAAgv9BKJVUAghkWgtBAMUACxoZsUZsBi81oYvK5o59ctUc+uWs0cuuGhy64bzUce+Gs0f2dfincgtQIEGoitEGtA6gYBQWgtAgFFpBEECAasCQQLRTKgUCBBAzVwCjNUYqoxWsGOlGKqMVoFXEYqgoCqM2qlFUAiFiCLVhEinQQGAQIIDoBYIggWgFEQRA6QQLQQECCBQVYogQCgAFXAKL/AARmqAglACEoqoBVqlQIBqiIiIDVgKDNqjNUrFqwZtUZqjNVFoDVEKtAg1KB0DKDcEKDUIGIrUBuUg1KyNyoNyoN80XG4ityswblQalQanQplA6kFpEXpYM2qDQotUFqwZtUZvSoNWFZtWFGrmFGrCs6sRaC0BoGUDoHSClBqUFoLQWgtILQWglAC1YM6CUREWgKuAVUCAgZUiLSB0glVAtBm1UFoMWqM2tDNUZqjKgURAKEDKkGog1zUG4DcZG+UG4g1Kg1AaiKZ+kiGUg1ECBlA6CA6CBaotBaCBAtUQiFQVAQQIEIgIIEA/YEECVUQShBAhIhEAwEuAwFYozYYM2NAsBi8tZoxeVo59ctUc+uWs0cuuPy1mjj1w1mo/pPxzuUCgoDUAwVrQMQaiBgHUEBBaCUQIBoLVEogKAFaAxNCgdAaAq4M1RmqM1UYrWDHSmsdNYjCpov7XBiqCgzVBWsRkRAhpVcAClQIGAYBA6CBKIECAUEogQIEItUMRSBBAoqkACAUAAq4CqIRm/pcAogFE0WqgIKqDRRqotBaotAaAtUFoM2qM2iM2tKzaqM2qMgrVB+VVIGAQMBoDAaRGgMBqA1EVqCtRlG4DUBvmsq3KK3Kg1KkG5UDqKZ0B9AtEWgNUFoM2qDVBaoxaqaNVBasGdXMBqi0Bqi0FoLQOgdAygdA7QWgtBaC0FoAEuCwQKIEAURgFVUF/gIDAIIFoIEDNVBVGb+1VmqjNUZqjKgq4gVUCAwGog1GRuA6RBqIrcZRqINQGoikGgMZQgYBAggQJRKIECBAtEWggILRUoUEIoBAUF+wIIECXFSiAggQITUIgFXBAqDK4CxQWKCwHOxoZ6jQ5dcqOfXLWaOXXLSPY/IO6AgUDEDAMBuClAwDEDAWgQQIBoKrglUAgQGAUCC0DqC0AoKDFrSM1cGKoxWk1iqM1rEYqgoMqBQLiMiKgFaQIEBAwCCAimCIECFSpoBAqqMgQIIRC4oK1ECqr/AQIECBlRVQVEZq4M1cEoKoKJoEFVUoNEGqLVBoLQF6BnQVqozemsGbVGaDNqjNoDVUAVRAQMA/wCCmIGA1AagNREMBqA1EGoK3EGog1KDfNRXSVFMqaNINSkDKgtBasFoC0BqgtUZtUZtVkaoLVGVBaC1RnWlWgtBAQIIDE1CgdBAgWglwQiBLggQBRAlUAlRVFUAqiAggQIBQFBmtYMqoqozVGaDKqyuIqoNAygZQagNRlGpUVvkG5UG5WValRG5QMoGJo1EUwCBBqIiBAv/AIqnREAEWgtBAtA6C0FAIEECAggQIEuKlECBAQQIECBAgS4IQCKrgyojAVRiwGbGhixcHPrlocuo1mjs/JOyIh0U6gUCBl/INSinQMv5BqUDqBBagtBKAioEoNEWioCB0FoFILQIC1Rm0GaqM2tQY6qwYqoxWhm1cRmqCgzVBaqM1UACipVQDQIGAQIIEDUBAgSlQAFqoLQAh0FoEELhgpgEEKsBYCwEDNUVUFIjNXBmqIGdVKKYUKDViC0gFgLVBoD0C1Si0B6WIzelii0GbVQWrFZvSoLQZWKgKokGoBgGAYitRYHUDKDUojUQagGEGpUVqVINxBqA1KDcqRa3Kmq1KB1IHSC0gtILQGqM2kSjVgNWKNWMs2qDVBqg0BVAqoRECKtRDAQGAdAkFKQWkFpBaBESioLQGrBKoAgKCVEC/QEEB0ECBAKAoM1oZVRVRmwGaozVwFXAVQAgOg1AaiRGpWValB0lQalSFaiDcBqVAyoNSoEKQOikDKiEEogQiBaC1QaRVpBaQJBaQOkDqIQQHQQIECVUUSiwFgEECBAhEFQVLhUFWBRYuIKoAWKM2AzYozYuDFjQ5dcqNR+UdUokCKYBQINRFIGA1AIFBIIEotVUAEQDQWgtAyinQILQGgNEGqCrgxa0M2qmsWqM1RmriM1RkBWhmriaKIAH+quIUUEBAwEBBAQIGAgCiBAKqARAgMAghcMFUBoFBSCBUAAq4BU0VRmmDKgqjKozaINUFqjNqg9ALRRqotEZ9LFHpYC0BaqDQFqjNqqNAKLRFoJQg1EDAMAxFaiohWkDAan6EaiDUAitRBuINQGog1KDcqauGVFa0DoLQWwBaoNIDVZGi4tXFZaZGgzqi2LAANVQIdBaoQSaGIiUILUEBgLQIIFAWqIEAaVAgKoKABAaBBAv8AggQCgKozf2qiqCiM1RnpRmqM1cRmqqAaBUMqDUoNSojcqDUqK3Kg3KiNSitSoplRGpQalSDUoHUVQCIdAgtEGggQJVCiBAdBQCBZRoFAUAggQIEolVQCCBAgQITUIgSiBAgFaBiioCgzYDNjQxYox1y0MPyrsYIhVAaQUAg1AMRcaiBAygQOghUAEQIGQQJRaCAgtBaC0BqgtMAozVGKqazWgVRmqjIMqM1UFUFEC4AENKrgAUAgZQSBi4ECCBAgQIEqAFghBC4hTAMAoGKqgHAWAsAYAq4M1U0VRjpcGaJrNawZtUZtVBaoxegGgNVGb0sBaRRqi1UGgNUFoC0GdVUotEGggUArgYDUQIGAYDQGCpBoGoI1EDAaFagGIN8g1EGkGpRcMFINS/hNFqC0BauC1QUwFaxNZAKg1RaDLSqmIFECBAQMBIi1VMAxEUAggIIECBLgFVAgWKiwFAIIECBAoBBKJAKCgKYBVZqozVGaoyqsVcQKABoFUMoNaKZUG5U1GpUVuVBqUG5URqVBqUDKyrUoNSg1KyiAgdBaC0FqqFECBKHQWgQUQIEDE0KIYCBQCAq4qUOMolxUogQIEMoECBKIEAoBoRglAAAdRRmxRixRwj8w6lBasU6kFqQOkDpBqAYhWoi0ygdAygQQIVCC0FoAFVBoLVFoLQWkFpBaQWrAWqC0GaDNVNZrQzVBRGVADNWozVIKqAAoNGlaqLVFoGVBCkgYBA6CBAgQEAqIEIhYhVgNYBkA4BwDICwFgqwAAsBmxrBmiMdNYM0TWLWhi1UZtaGLQZtUo0zBm9LAasBqi0QaoPQD0oLRRoLVEIlEQRBT9kCBgNRAg1AMgEDBUg0DUAwRqUGoitQDAaiDcSDUQMFxqClKEEQWIKrgFFQZqoKqCtDNAKBRAtUWkEQWkAoZUCQWkDKQOkQ6ggIICCBAlwCqgIJUQIECBAgQKAQSi0AApAKoUZojNqjFqjNq4rNXEZqgtUGiLQMoNSg1KRWpUGpURuVBqUVqVBqUGpURqVIrUpEalRTKg1KkDpA6C0FpBaQSg0FoHVECA6BAoEDECQKIgOggViqMKEglECBAgQygQDSLDqwi1YQaRFaQChAKAEAsBmxRmxR5n5l1QIUgogQMBpAxBqA1EUgZ+wIIECAUACoBQKIECBKIEA1RUBQFUZq4aKuIzVAajNigsBmxQWKM1WWQFBYrQqpoUQGf6GGIpgECCAwEBwCCBAgGKHAWQDgHEDgKRVaxA4CwFgLAGALFGOouDNVHPprBjpcTXOtIxaoxaozasRm1VZtUFqg0iDVB6Bm1VWgNUWggQiUQFRAp+waQUBqIEGoBgECikCBgNQDP2DcRCDUFa5/SK1BG4gYi41EVpA4CwEAq4LFAoAZqsitDNAKBoVAAlECBAYBBQEBgFlDAIKAQQIEuAVUBBKiBAgQIEogUAggAIGaqq0GaqM0Gev00MUVmrgzVxGaoyqLQWqKUGpQalQalBqVFalBuVEalZVqUGpQa0GpUiNSoGVFaSB0DoLQQIFpBaotBaBlA6BgECBiBBA0yiBAQQJRKqBAgQIEMpRABpKiAKiBAVEAoAFQZoM1oeXX5l1QIEBFIGAYg1EDEGoikGp+wIEEAyggACgFAogQJRAqABYosBAMVILAGAzY0DBBYDNjSs4IzYozYoLFGcAYolwVBlUQGAYBgNRFQNQCCBYBkQWAcBYosFPlA+Si8lDOSjXkoZylD5DFlFXkFgCxRmxUYsUc+msRz6XBz6axNc+m8Rz6qjFqjFqozaqs2qgtUGqDQGipQCLQSgBKEFECBgGKGINQDEDAagGAYCFMQagKA0BgNQGog1AbgNRFbiKYg1IyNSAQOCjAOCCxaBRmxQWKMWKyLFGVFVwCgBKKgoCBAQMBAgaBRNQ/wCoEFAIIEuAVSqIECBAgQIECUQIECMBVUAFQURiqrFqjNqjNqjFUZoBUSiAxVMNDERqA1EGpQbgrUrOjURGpQalRWpQMqRGpSDSQMqBFOgtBaCAqiBaimKhgIGkCBiIYCBqMqlxUoWUQJRKiFxCoEogQgoIEoqAVFoIwChAiAAKqDNAVcHi1+adSC0CC0DKKQalQaiBgNRFaiBkBpFiCEIlQWCiwBgCxQVQAhEogQIFi0OFFhQYUGUF5EjNi0HlaC8qRnCjNjSM2AzYozYozigxQKCgyqEEBgGBjURTAMgNSAcShxA4B8pReVofILBT5A+UD5A+TdD5SkPlaQ+UqryUXlaC8lBYtGLyox1GkcuouI59NYOXVaxHLqt4jl01g59VcGbWhm0Rm1Rm1VGqLQWiAECBaoVABBRAgQMBqAQMQagEDAMAimQDAMQIGA1AaiDUBuINQqtxlW5EGpEGpAMiKcKLCiwQWLQWAzeVGbGhmxakZsUFioy0CxRYAUVBAgQECCAgQUEKQKC1RaQIIwCqQQiUQIECBAgQKqDQRALmC1VFqIzasBasRm1VYqjFoM2rmDNaGbRAogRBKrWgZUiNygZQalBqVBqCtRBqVINSkGpWRqUDKDUqRDqB0DKB0FoICC0CCgGAQKB0CI1EEDUSLUpUFKRUQRESohUFQqUQiCi0KlhRoK0QKIECUQIFoi0VUGaoKuDwvzLqYBBQCBgEUxBqJo1AaiK1EGogRTgIDlBYAwBigsAWKDFFgLBFhRYUWAcBYBwB5BeQXkoLytBeVGbytGbyqM3lRm8qMXlRixRmxcRnFBVBgDK0iBAQMgY1EUyINSA1Ig1iVTIUa8pQ+QM5KGcFIfBSKcFIfCVYZyBnINeQM5BeCi8pReVBeQYvK4MdRrBz6jWGuPa4jl1+m8Rx6axly6rY5dVrBz6q4jFrQzaozqqzQWqLVRaQBBAtQSjQIFgHAMAyAQMBrAMQMBqAgIGAQMAwUoGA1AaQbgNcoOkQakRpuRkbkQakRWpAOFD5KLyA8gzeVBYqMWLgzY0M2NYmsWKgxRmxQKBRAgSqgMAohBQCCAgWUC4JVaREYBVQEEqIECBAgWkGdii2AtIBVSoNAWgza0M2gzaqM2kGbVisWrgzaqC1QaC0xUodAwGoBgNQGoiNSg1KgYRWpUGpQalZRqAZUVqUDoGVA6RDpFOkRILQINAgIGAYgYBEKBgGAQQEaQLQWjI0FoLVaQIRasQAtUAIECUQIECoIACBmqBcHifmnVAZ+kDAIGARTEGomjcQakRWpBWpEGpAOJociCwVYovJQXlaDyA8qC8iLyoPNBeaC8gZyB8oHyB8gvILx/wF4KDytBeVqM3laM3laMXlaM3laMXlpGLyoxeVGbFGbFRmxRYosAAZAOA1Ig1IDc5QanKVWpyg3OUManJVPlKQzgofJQ+UoZwUPgofJVM5KHyUPhA+YC8wBeVozeVzRmxUcu4uDl3G8Nce40jh23iOPbeMuPTWDj03g59VrEYqjFqqFFRACXBKJBIIDFCCgECCiBBqQCBgNSAQIGAQUAwCBgGCtRAwG4g1Ab5Z0dIit8xNVuRBuRkbkRWpEDIB8lF5KLFozeQZvLWaM3lRi8riMWNYM2KMWNAsXE1nFQYosUALAIJVMRCCgEFAIIEBgEEAAqiBAgFBKIEAAKo0FoLVQaYC1YM2rAWgxasRm1YC0gxaqi1UZqgAKqBQCBgNQDAagEGoiNSg1EGoBiDUojWoGUVqVINSop0DAOiGCEEClQMoNIqA6qGVAgZQMqaEDASBBaBBAlECFQUapVoBUQIEogQEQCoACBAmgWoMqKqjx4/MuyAoEEBFINSINSJo3IixqRFbkQakTRqRBrEDgqwF5UXkFgDCg8rReVqDyoPIqwD5KhnKUPkqmclD5SofJVXkqLyUF4WgvC0ZvK0YvK1GLyuaM3lRi8tVI53lrBi8qMWKMWKDFRnGhYCwDIBkTdGpEHSQGpyzo3OUqtzlBucpVxqclGpylUzkofKUPgofFKHxShnAHwUU5SqfBQ+Si8lBeVozeVqOfXKjl3GsRx7jeGuHcbRw7bxHn7bxHHtvEcemsHO1rEYt/KjCqqoBECBLRAogQKiwDgHAWIGQGpAIGA1J+AIGAQIICBwEBgGCtRBqA1EG4DfLOjcRXTmMq6SINyINyMq3IDUiBwD5AeVBeQZsUYvKjFjSMXlrNGLFoxeWhmxU1mxUFjQFECAAsBoFgEECgEECAggQICqIEA/IIAotAWgNIJpQItAaoNBm1Rm1QaDNqozaqs2gLVRm0BqqFECBKEDAagGA1AKDUqB0iNSg1KgYDUEh1FjUoNSpCmUhTLEGpUU6M6gOgYBAoGUirSB0QwCBA6gZQOkDqbgtQQFRaC0FoLQWrAAlEAoIDqiBARBoq0ACBAGgUAoLSI82PzDsgQIU4BkQakBqQGpE1cbkZVuRBrmJRuRBqcorc5QM5KHygvIDytF5KsF5WoPJQYtF5BeVF5BeUoZyUOFGvKUM5KHylF5WivJQeVoPJRm8tVGLyozeVoxeVqOd5azRjqNZprn1FqOd5aGLFBYozioMUWA1IgZAbnKVW5ylHTnlDG+eWVbnKUbnKDU5QbnJVM4Sh8gZyVT5KHylF4KHyUPgofMSi8woLytBeVoxYo52NYjl3GsRw7jphrz9t4jz9/63iPP3+q3ia49fpvEce/01g51rEYv7UYVVVQAgQHAQIDgKAcUKBkA4BwDIBkBrAIHAQGAQUAgQQNAoK1P0g1AaiDcBvlnR05TVdOWVdOYmjpGVbkQa5iDciDWAsBYCsUZvKjF5UY65aGLyqOd5UZsaGOo1iazYqM2NDNiiyglECwFAILAIIECwDAQIECAqiBAFBQGgNAUwWqo1UFqg0BqgtAWqjNqxWbQFqjNqjOiC1QAFVWgAUUIhgGA1AMBoCimAYDU/SajUAxBoCK0iGUQxAykGtRTBNaiCAgQIKUCBA6BBJAkCB0DECQOxBbAWglggSg0ECBKIECBQDoIBQQiAUFoCrihTRaqM2qOPl+WrufJRYUPkovJRqRBqQGpyVWpyzo3OUG5ylVqcs1XScpRqcoNTlFanIHyUXgovJQeCqPKovP8AwB5UHkpq8lReVofKVcM5A+Uo1OSh8lSHyUi8lIvJSDyoLyUZvKjF5aGLyqMdctYMdcqjn1y1g53loc7y0kYvKjFigxUF5BYqtSINSINzko3zyyrrzyzRucpRucpVbnKVWpylG5ylD5KHyUPkD5QXkD5A+QXkDn/AWf8AAFgCxRzsawc+o0OPcaxHD6N4jzfSOmI830dMRw7/AE3ia8/beI5dNYOdbxGOv2owqoRYCBAgIKQDgHAOCnChwocA4gcAyAcAyAcBNBQUEIGAgIEFBWoaNRBqA3EHTlnR0n+IrpyzqunKDpyzo3EVuINyIFBqT8IqwoMWoLFzRm8qOdjWDF5azRi8qMdRrEYsUYsaGbGmRYoMAYosA4CxaLEQgsA4CAKpBAgQJUQAAAtUGqo0BoDVRaA1QaoPQDVRm0gNWAtVWbQFqozaoAFIBVGglECAwRA1AMBqAYKYg1AINQ0MRGoBAxBqAUQwDoGIGUGpQMoFAoGAQQHQOgtAygZQOgpUDoHQOgtQOgtUG0FtBaogQHQQIRAgQLQQJQaKLQWqgUFBm1Rm1RY/Ju8WAfIHAWBDOUI1OSq3OSjU5Sjc5Sq3OWarc5QbnLNG5ylWNTlBqclU+Ci8lF5KDytB5KK8iDyoPJQeSkPlaReUo1OQM5QanIHyVT5BeSi8lRnwtILypGbFIxeVqMdcqMXlqox1y1Rz6jWDneVo53lpGLy0axeVSM4osBYDU5QanJRucs0jpzylV0nKbo6c8s1W5wlG5ylVqcoNTkDOUo15KHyUXkofJVhnJRYCwSHyVYryUjN5KRmxUYsawcuo0OPcbxHn+jeI830dMR5vo3iPP9HTE15+43iOXTWDnW8RjpRnFUCIECA4BkAyCmRAyKNYBkQOAZPyDWIHAOAsBYosA4tFhRYBwRAgIEFBWoDXKDUBuIOnLOq6RCOnLOq6coOnKaNxlXTlBuIGRBuRNXFiCxakFi5ozYuDHXKjF5aoxeWqOd5XEYvLQzY1RjFZFi4M4tBiqsEWAcEWAgOAsAYBxaLCiKJVFBAlRkFQZtWDNVRaC1UZtUGgNUFpgNVBqwFq5ii0BaozaILVAA1VFAVRAhECAxRA1AMQagGCmINQCDUAxEagGAYgYDSIQQNIEDKB0DKgZSB1BaodIFBAdBSgdA6BlA6B0FECC1QggW0BoLQWgQQL8CLaC0FoIEogCqARECjNqgtUZtB38PyNegeCh8lDOSh8gpyK1OQanLNGpyitzlKNzlBucpuq6TlmjU5Sq3ORD5RVgHyC8iC8qosUZwFigsBYIsAyCnAMiDWAcBYgcUWALAGKjF5aVmwZYsawYsaHPqNI59crg52NDF5aRi8rRi8qC8rUGFDOShnJVbnKDc5ZHTnlBucpVb55QdJEVqcoNzlKNTlA4BwFgHBcWCnBlYLiwVAgFBnpplz6awcuv00jh23g4fRvE15vo6Yjy/RvEeft0xNcO20cemsHOt4jHSjKqBECAz9gcAwCK1IgZAakBqcoNSAZAM5A4CwDgLAWKLAAIEqIEDQICKoqt8pqNRBuIOnKarpEV05Z0dOWR05TRufplXTlBuINRBqIuNAsQVgmsWNDNijPUaHOxRi8tjnYqM2KMXlplmxRYoz5WiwosBKiBAsBYCwFgLAWAGlQCgKqCgzaoyqi0BaqC1Rm9KM2rAaA1cBqi0Bqg0QaAUFAUwCqrQCiog0CCUMAgQMQagGCmINQCDQGfpEagGAQMAohA6BiB0CB1AwCC0DKC0DqQUpA6QWkDoGUDqBlAgdBaB0FoLQQIECAgtBaCVECBAQSjNBaA1QWqM2qC0GLVHu8Px1eleChnBReCjXhKKcFGpwVWpwlGpwlG5wm6rc4Zo3zwlVucg1OUDOUofJRYKsEVgCgMUGKCyAMUWAQQECg0CgN5EBVEAAWLgzYqMWNYM2Ka52NIx1Pw1g52KMWNI52NDNijFioPK0HkofJRqcoNTlFbnKDpOUG5EG5EVuRkakBqRBqRA4CwCKhUCEMFQJWULgorFaxlz6/S4OXX6bTXH6N4PP23iPN9HTEeX6OmI8/beI4dt4jj23g51rEY6UCqKIgQGQCBwVqRBqQGpEGpyaNzlKNTlKNTkofIHyC8gvIC8qLFBgDFFgBoWILBCCgEVRVb5TUaiDcQdOUV05QbjKunKDpyzo3KiunNZG4g3EGoDUAsqgFgM2NIzY1g52KMWNYMWNDFijNiozeWsTRioPKgwFgLAGLgMBYooBEGAsBAMUFMBVUVUZqjNXBnVBaDNqjNqjOqDQFqgtUGgNVFoDVFoC0UKKgKoAAiUQICCAwGgMQagNQUoGA1AINIhAgoDQIDqIYBAoEFoEDoLQOgtA6B0FqClAgZQMoHUDqBlA6B0ECBKLaotoLQWgYghDQQIFpBaA2qBQaAtUFqjNoC1Rm1R/W8PxVepeChnBReChnCUM4KrU4SkanCUanBVanCUanKUbnKVWpylGpEqHBVgRZP/BBYoLFqgAqCxQUAogQIDKBQaBQG9AUEABLgFGLFGbFTWLGsRz6jWDFjQ52CMWNjNijFiosAYBxQyIrc5QbkQbnKDciK1Ig6SINSIGQCgQQIWoKgqUpgLRQJEoLSDPSo59VrBy6v4aRw7reDz/RvEeb6X9umI830dMR5/o3iOHdbxHHtvBzrSMVQKqEQLAIpkBqRBqQG5EG5yg3OUqtTlKRucpQzkGpxSkPgpF4KDyVFi0Z8tUGALFGbFBi0QIRYCwCKYqtSJqNRBuA3EHTllW4yrpzUHTmoOkqDfNZ1W4g3Kg3Kg1ALK0hRasGVQWKMWKMWNYMXlrNGbytGbytRm8rUZxaReVqM2KLCg8qLAGAPJQYtFhQAVEIAZq4BVZqozaozauYM2qM2qMWqM2qC1cGdWAtWAtIi0Fqg0FpFCiAUFqgBaIFECBAoBAwCDUQagNQVqIGA0BwocRGgWAgaACEDAOoGUFoEDoHQWkFpA6QWkFpA6QMqB0FKBlA6gdAygdA6C2JA6C1RaC0FoEFAIICIAQLQCgtIDVBqjNoC1RnVgzao/v+H4WvWvBQ+Si8FDOCqfBQzhKNTgo1OEo1OCjU5Zo15FhnKEPkqnCiwozYqBUQMf6oqqM2qrKiAaC1RaB0DqBlAygdAoIECUAM1UZrRrFaRixoY6i4OdijFjSM2KM2KgUWAsBqRFbkQakQbkRW4g1IDcQMQMQIEECBKIFoLVBpFq0hVaozaIz1Vwc7WsHLqtYjh3f23iPP3XTDXm+lbxHn7rpiPP8ASt4jh23iOXX7awc+mkYv7VQqIFAIHBWpEGpAbkQb5iDpzyg3OUXG+eWVbnANTkGpygvILyC8KjN5UZsVGbyuDNjQzYoMAYosEQIEKYqtz9JqGINT9g6RBuIrpKyrcZHTkG5UG5WdV05rI3KDUqDUqDUqBUFBAKDONYMWKM2KM2KM2NIzeVB5KDFZFigwoMaBYDOAlAABlpSJooioM1cGaqs2tIxaozaozaoxaozaqs2tIzaYDVQaoNBaC0FpglVAAQBRCCglBoLQWgpQIGA0DUQagNwUxAwGgaiIQP8AgIEB0BqoQSB0FoHQWgZ0B9AtA6C9AdBaBnQHUDoLQa1A6BgEFqBAggOggQIGhEKtBaBlBCKgDBWqM6oKozoM2qM2qDVGbVH6jw/A17F5KHwUPgovBVPgofCUPgI1OSkM5SkanKVT5KHAWAsAWLgKqMVUZtUFUZtUZtXBWqjNqwGkQelF6BeiB9AfSQanRFanSRTKgdBaB0BQZrSMqazWsRiqMdNDnVGbGkYqgsAYqLAMgNYitSA1EG4yGCtQG4gYgQIIECBaC2KDVFoDQVqg0BaDHXTWYOdq4muXfTWYOHfTeI4fSumGvN3W8Zeb6V0wcO63jLj1WsHK1vBiqjCqsUWCIFBWpAbkQakBuRB05iaOnPLKunPLKunPKDc5Sjc5SjXkovMKLzCgvC0ZvK0ZvK0YvLVGLGsRixUFijFUQIRKICimA3AaiDcQdORW5WVblTR05rI3Kg3Kg3EGpUV0lQalQaiBBAlBQFBmqM4oLFGbGkZsigwBYIzYuaDFQKM2LgzRRWkACgy0qEWiM2rgzaqi1UZtUYtaVi1UYtUZtUZtXMGLVBaqDVBoLTBaqrQWggQJQAhEoAAIECBQCBgNQGog1AbgpiDUBqIhgNAgQiFVARUOgtBaC0DoLQOgtBaQOkDoLQOoKUGtBaBlBrUDKB0DqBA6B0DoERQCCBRA/wCggQIEogFpgNUFqjNoC1Rm1Rm1Rm1RnVH7Hw+evcvBUi8FUzgofBReSh8FD4Sh8lD5KLAMgHAGUBVGauDNVlmqMVQWtDFqxGbVgza0jOkB6UHpYL0QXogfRA+kgZ0QanSDU6TcVqUhT6SFOgpYAtVWVTWa1iMVRitDFUYrSM1QAMUWARDEVqA1EG0gQaiK1KkDpAykDsILSC0gNUVoDQGqK0B6IL0sGb0QF6WDHXTQxelzE1x76bxHDvprMHD6dN4mvP303iPP3XTEefut4jl1WsHOtYMVpGRUohEBgrUgNyIN8xB05iarpzGSOnMZV155QdOeUo6TlKrc4ZDOSh8FF4KC8qjN5UY65aHPqKMWNYmsWNVGLFGbFGcaEiJRAQMFbiDUQa5QdIDcrKtxFblTRuVBuVBqVBuVFblQbnSDUqQalgHQWgKAoCqM4oLFBYuIzigsUZsBnqCazVQNAq4MVQUBaoNhBmtAAWtIzekGbVVm1pGbVVi1UZtUYtaVm1UYtUFqozqgtAaqrQWgtBaodgIECESgAUEAqgA7AWgYg1AMoNwGog1BWog1AaiI1AIIEItBaoLQGglEQWkFqwWkFpA6QOwgtSB0gtIHQMoGUDKg1oJBqAZQa1A6BQMA6BlEIKAQUQIIECBKC0gKoNUZtAWqMWqC1Rm1Rm1RlR+48vnVe4+Si8lF5KLyUPkqnyUXkF5A4CwohEAUZqjNXBitMsWris2qjFrQzauJrNrSMWrBm1cwZtWC0gPSwXogvRA+iBnSQanSQanSQbnRAyoNSgdAaNCiaK1iMVRitYM1RzrSMmA/1RKIEIUVqA1AaiDUqBlIFFOgdBaC0DoDQGqLQGrAauYDVKPQgvQM3pYMXprMHPrpoceulzEce+m8xHDvpvMR5++m8wefut4jj1W8Ry6rWDFaGKqAVKIQwDDVbiDUgOnMQdOYyuOnMRXXmMjtzyzo6SMq6c8oNyINTkF5BeQF5UY65UY6jQ59RpHPqLiax1GkYrQxVGaosEWKICB/0XDEG4g1AbiDUqK6SorUqDfNQblQalQblQblQalSK1KDcqBAgLUFoC/pQKCmDNaxADNaBQYqprNVBaozWhi1Rm0GbVBqgtEZvTQLRWbVRnQZvTQzaozelwYvSqza0jFqjNqgtVBoABqqtBaC1RaIQQIECUWgAACqAUgoDSIYDUBqA1AbjKtQG4BgNIiBAtESgBAFFaoNILVFoLaA9AvQGUD6A6BlAyoHSBlAyoHQalQMoNaB1Ayg1qB0CgYBghBSgQP+AoCBaA0gKoAZtUZtUFqjOqM2qM2rgzaoLVH73Hzd71gGQFgLAWAcBAsUWAgFi4goBoZoMWtIx1VwYrWIxaozWhjqriaxbWkYtVGbWsGb0sBelgzegHsF6WFM6SDU6INTpIN89JuDU6QbnSRWpU3A7CB0gLSDNqwZtaGauDFrWIxVGVBVBtBbRFoHRWoDUqDUoHUDKB1IHSB0irSItILSKrVgNIDasQaoz6UF6AWgzemoM3pYMddKjn101By66azEcO+msHDvpvE1w76bxHDut4jl1WsHLqtDFrQyCUQiAg1EVuT8g3zEG+UHXmIuOvMZV04jI7cs6OnMRXXmMjciDUgLAWALFGOoox1FHPqN4jl1Fwc63iMWNIxVGaoFQggQEXDEVqCNRBuA1Kg3KityorUQalQblSDcqDUqDcqDUqDUtFMoNbUFoIBtUQM1UFUZqgUYtVGbVGbVRm9KMXpRm9LBi9LAXpYM3pRm9LAXoGbVQXpYM3pYM3pRm9KMWtKzaqM2qM2rBnVBogtAaqrQGqIFohlA6C1RaC0EAoLQCgogCnRVBWoDUEaiDUBqA3EVqINQGoIdEIIBQAJRaAtawGgNAaC0BtUWgdBbQMtA6B1AygZQalAyoGUg1Kg1KB0DECg1oGUDqBEalBbQMBpBAgSg0ACtBm1QVRm1Rm1Rm1Rm1Rm1QWqM6o+h4+avesBeQXkDgDAWKLASiAAKqM1QVRi1RiqjHTSM2rg51oZtVHPqtYjFrWDFqoza0MWqMWqD0uYg9LBeiC9EDOokG50kVudJBqdJB0nSRW5U3A6QWoLVFaDNrQxVRm1cGK0M1QWwGVRAdAyg1KKZUGtIHYkDKQOpA6C0gdBaC0BqqNVBpAWrBnVgL0sRm1YM3pRm9g59dNZhXPrpqJrl101Bx76azBw76bzE1w7rWMuPVbwcuq0MVRi1oCiEQKCkG5+kG+Qb5iDpzEV05ZHXlnVdeYg68s6OvMRXTmMjfMQbkA4CsBmwGOo1g52KOfTeI59Lg5dN4MVplzqjNiiVECBAhTAagrURGpUG4g1KityitSoNSoNSg3KzBuUGpUG5Ug1KyNQUyoh1VGgvyCEFqjFqjNqjN6VGbVRi2NDF6ijN6UYvS5gzemhi9KC9KMWqC9KgvRBm9LBn0sGb0oL0sGbQZtaGbVGbVBaozoLQZtUGgtBaodEWqIDoLQQEBoK1QANEWgAiFMFMBqURqA3EGoDcQaiK1AagiEh0FoAFqgt/Cg1QaoNAaA1YLSA2AthBbCB9AdBaDWoKUGpQMqDUoGUGpUg1KDUqBgNJoYgYBlAojQEDoFBSgdgBQArQZqgtWDNqjNqjNqjNqjNqgtUZ1QaQfRXzR71gHFFgLAFiiAUEogFAKjNUZqjHS4jNXEYv6aGK1gxWkc7VRjpRitjHS4jHVaHO1YM2qjNrWDOqL0QWkDKg1OiDc6Zg3Okg6TpFbnSRTOiDWoLQWgza0jNqjFqjNrQzaozRBoHQWqEDKgQMoNaC1BrRToLQOgtAaA9KLQGqjN6WDNqjN6IM3pqDN6WIxelgx10sHPrr8NRHLrprMHHvr9tDj3WsTXHut4jj1WsHPq/lrBiqjFVUohECgrUVWuWUb5BvlB15/SarpyyrrzGR15RXXlnR15Z0dIg3yg3EVqAKDNXEYqjnWsHOto5dLg59N4OXTTLFUZq4JUAKAQUVTAMRWoDURG5UDKi43KK1Kg1Kg3KDUqDXNQblQblQalQalIFmBBBVqwFqjNoM2qMdVU1m1UYtagx10uYMXpoYvSwZvS5gxemoM3pYjN6UZvSjNqwHowF6UZ9KM3oB6UFojN6ais2qC1QaA1QaA0AogWiLQKiBAQQIECUFFAyhcQqAwDAMBuA3ERqA3KDUQagGUU6gtVnVoDVBaAtUGgLVBaoNAaoNBaA0FoHQOgdAygZSDUqQalQMoGVBuUDoGUG5UDKmo1EDopiaNQQxAxQgogQQIFVGdAWqM2qM1Rm1Rm0Ga0C1RnQFUDQ+jvmT+gRECBKJQUGaCUQM1UCjNUFBiqmsVpGKozWsGK0jn0qMdNYOdawYtaxHOtYOdVGbWhiqC1QelReqQU6pBudJFa56ZG50kHSdJBudIrU6QanVIHQGgLVGLVBaoxaoyqCgNUWkFqwO0DKaGVBrQOoLQa0FoLQOkFpBasBoDVgL0QZtaGbVwYvVEFqjF6agx10sGOuqqOfVUcuq3g49dVrMRy6rWYOPVaxHLqtYMVRitIyKP9UIiBQVqKrUZR0gNxB05TVdeWR05Z1XXlFdeWdHXlB0n6QbjI1KB2grQZqjHVUY6awc+msRy6axHPpvBz6VHOrgzWhCC1QSg0gooRSgQalFalRGpU1WpQrUqQanQNSoNyorUqDcqQalQbiDUqBlIHSC0gtAWqM2qMXoGb00mud6WI53qtDHXS4MXqtQYvSwZvSwZvSjF6aiC9LBnVgz6UF6FHoGdWILVgNWDNtWAtAaoFFoAAoNACIEogILQILQMUQIBQQlAIXFgqAwCBgNwGpQbgjUQagNSoEVAdWMrSA1QWgzqitUGgzb+AGqDVBaCAaC0DpAgdAygZUGtBqUGpU0MqDUQalAwGoDUqaNSoGIjUAgUGgWgUEogVAALVgzasGbVBaDFqgtaGbVBVGbVAA1R9Jj5k95wACBKDVFaDNBKC1QVUFBmqM0Ga0msVUYrQzVwYrSMdLiOfTWDnWsGK0jn01g59KjnWsGbWsGLWgbBFoKUGp0m4Y1OkVudJB05qDc6TcVqdINTpA+gWgLVBaozaozaqCqDQZ1oWgNAhTKDWgdSC0gdQOgtBaB0FqwXogtIM2qC1Rm1YM2qaxasRm1rMGbVGL0I59dRrMGOq1g5dVcwceq1iOfVaxHLqtYOXTWDFUZqjID/VDoiBQVqA1EHSA3yg6cpo68ouOnDOq68sq68s6OnKDrKg1EGogdBaAqjn1VGLWsHPqtI5dVrEc+m8Rz6UYtawZqgVBVVAdiIQOgtFMqDUAyitSg1KzEalIGUG5UG5UVqVNVuVBqVBuWINSoNaB0FoDQFqjF6BztaGOumsRi9KjlemoMXpcwYvTUGL0ozemoMXqrEF6UZvSwHpVZtAWiD0oL0oNIDVBqgBWiDVUaABaoBBQSiA6CAqLQIINAiBAgSiFxIqUMAgYDQNRBuCNSg1qQalhAykDsBm1UWgtAaoNAWqC1cGdAANUGggSiBAdA6gZQalAyg1EGgalSDUQagGINQGpU0a0gdZiNQGoCiDUoEFoLQWggFq5gzasGdUFqjNoM1oZtUCjNsAWrgNUAPpT5k96UQIEDNUQBRAzVxE0M0GaAoM1pNY6VGa0jFVWelHPprE1z6axGK1g59N4jl0o59NIxWhjprE1iqM2qLQWgZQblQalQdJWVblBqVkalFOoEBqxBaoLVGdAKMrAKIECVCGNQVagQWgdBaC0DoLQGgrVBaDN6UZtaRm9LBi1Rm1Rm9LEc7Vgx1Whi1U1y6rWI5dVRz6rQ5Voc6uDPTQxQACNCRCCgEG5+xW4g3yg6RB15RcdeWdV05RXXljUdOaiuvKDcQIHQQM2qMWqMVrBy6aRz6awc+msZc7Whi/tcAoKqBVQIDP0moQIqgNaBlRTKDUoNSg1KzqNSg1EG+am4uNyorUoNyswalQa0DoLQFoM2rBi1RjrprGXK1Rz66azBztagx10uDnemhi9LEZvSgtUZvSjNqqNVBoC1QaA1VGqi0AIgGrFALQAJUAIEogQGAlEKZQQmoRAgQFQBiGiogIGA1EDEGpfwDcomnRCBgHQGgtUWgNAWrAaoLVBoDQADQWgtVcQERAQMQagGA3AMBpBqININRAwGoBBqIjUTRpAgYB0FqC0FaoNAWrgLVGbVGbQZtUZtUGqDVGWgUACoPpOvmb3rVFoLQALQSgAVQVUFBm1QUGaqM1RmtIzVGelGKo59NYjHTWDn03iOfSo5dNYOfTWI51rBjprE1itDKiAaDUoNSoNSoN81FblZGpQblSK1qItILVAoKDOtQFoMqIEGpRCGBhFWgQWgtBaC0DoC0B6EW1YDasKzasKzasGbVGbVGLVRi1cGLWhjqqjn10uDFrWI5dX9qOfVaHPqqMVrBjpRmgzqiBCGKICg1KK3z+wdOWRvlB15TVdOWVdeaiuvKbg6RkdOag3Kg1AIK0GbVGLVHO1rMHPqtYjn1WsRy6tXEYrQzWhkAqKqDRSClA6gdUOoHQKBgEGpRWpURqUGpUG5UVqWoNyorcoNSpBrWQ6C0GbVwZtVNY66WDn11WsRy66azBz66awcuuq0MddVcGL0sGLWkFqjNqwFqwFoDVBqwFoDRRtVFoDYC1YK0BoLVAC0AIlECBAgWqq0CCEpgiBCxKRBCpECFQICBgGINQGoBlEOoQ6IdUIIFoC1YDVBoKqAGdBAlUAhEKlEIoDSBgEDKg1KDXNBqA0g1GRqA1ERqAYDUQOmjUQKB0DoLQG1REBqgtAWgzaozaoLVGa0CgzaolAAtAA+k6+ZvelBoLQVoJRANAWqgUVBlQUGaqM1UZrSs1UZ6qjFq4OdaxGOmsHPpvEc+lRy6awc+m8Rzq4OfTWJrNaGKogQGA1EGoDUQxuJqtysjUoNaggWqAEoGhmgASiDVoLYIgw4KQIIECBbAGqC0xFqgAWqMWqC1Rm1Ri1cGLViMWtYM2qOfVVHPqtRGOqo59VRz6rWYOdqjNqoxaqs0GdUWqi0DoEDAMRW5QdIg6coOnNZ1XTlFduWR05TVdYyN8oNyg1KgvSi0GaDFrQx1WkcuquDHTWI5VpGa1gxqgUAgtUApgEEB0EgdAygZQagGVAyg1Kg3Kg3KDUqDcqK3KitSg1qC0FoM2gLVTXPqtI5dVRy6rQ59dNYOfXTQ59VcwYtaRm9KM3pVGqg9KDTAaoNBaoNBaAUQLQAIFqoASiBAgQIECVVAOiIEqIDoq0VaotBaC0FoIQgQMoNQUwRqUDKinVjJ2EFoLSC1YDQGqLQGgNAAgSrg0ECUQIDBCBiDQFBqA1AagGINSoNSg1KiNSoNQDAaQMAyshILVgtoJQbAGqC0BaDNq4BQaozaozaAaEA0BoIH0h80e9AlEC0BoLVBoiUSjNBmgKDNaQVUYqjNqozWlYqoxWsRz6awc+r+2sHLppHOrg59VvEY6awc61iazVGKogQGA0g1AagNxnVxqINRAg1v4AAgFUDQKGhUQqoAFIqNRFwggIIEAoIA0gBALVGbVGLVGbVGbVzEYvTQxaox10uJrFrQxaqMddKOdqqxaqOfVaGLVGLVGLQFqozqi0FoEDKBgNQGoiukQb5oOvNZ1XTllXXmsjrKDpKyrpKg1KDUQQLQZtUZtaxHPqqMWtYOfX7axHOtIx0oyozVBVBoLQKogWiqCtSoi0CB1Ayg1oGVBqUGpRWpU1G5UG5UG5TVxqVlWtBaC0BaDHVaxNc+qqOXVawc+q0OXVUcuq1gxa0jNqjFqqzaqDVBoLVwWqC0ECEGqq0FoDVRaA0ECUWgAUAggQIEqoTUIRUKlEqIECBAgQGAVEBBqVA6oZQKB1UWgdoLQWgNUWgNBaABKIBRcQIKFVAgImtQQxBqAYDQNQDEGoBiDUBqIjUTRqIGUGgILUDKB1RagNAaC1Rm1QaQZ1RWqM6oLQZaACoCggQPoz5q95ACIEogAJRUAoLQGrBm0GarLNqjNaGbVGLVwZtaRztXEY6rWYOfVbwc+qqOVawc+msRjprBzrSazaozVECwDIDUiDUgNRFjcTRqINRAwCCBAqoy0ANCohQBwEBgEFgEECBUAAaQAAZrWDKjPVVGLVGLVGOq1gxeliMXpcwYvTSOd6UYtWDFqwYvSjFrQxaoxaDNqxGVAC1QasGpUDKgZQalBqVFb5po6c1B05TVx15rKuvNZ0dOag6c1IrpKyNygdA6A0Baoxa0jFq5gxa0OfVaRzqoxaoyoFBb+FGVECBaB0EKZRCgQIGIGUDKDUoNSoNSpo3KDcqDUorcqFOoHQXoGbQZ6qo5dVqDn1Why7qjla0OdrQxa0jFqqzaIKoFBtWC0AotAKIF+FFoDRECBaAUQIECUW0VbQWgdBAlRBECBaKVECEQIECBAVCC0DoGUDKB2gdEWgtUWgtBaCUQL8ANBaCBAlAAtFWhSFMEOg1KBgNRAg1KDUoGVBpBqUGogZURqUgUGpQOgtBaC0FoK0BoC9LAWqDQGrBm9VcBqg0gNUWgKA0EC0H0Z81e9aqLQWqLSA0Fqi0ECtBmgKozVGbVZZtawZtUYtUZti4jFrQ59VcRi1vBz6rQ59VcRzrWDn01iMdVrBiqms1RmqLAIGQG4g1IDUiK1ImhxBqRBoECBGCqgaAGiiBVQIEBgGAQWAQQLAGAyqBQKMdVcGbVRjqqMWtQc7Vgxa0OdrSMXpcRjrpRi9LBi9KMddNYMWgx1WkYtFZtVGbVBoM2qLaqrQMqIZQMoNyg1Kit81NHTmoOnNTVdeazqunNQdOag681FblQblQOoHVFoM2qM2qjna1gx1VGOq0jFqoxVGVA0M0AogQIECgEDKKRDqC0DKDUoNSkDKg1Kg3KDUqQblQblAygdQGgLVGOquDnao59VocuquDn1WsHO1pHO1VYqgrSM0EAVUqARAKqrQSogQAEogGgtBaC1RaBACoEB1RQCogQIECEOgASiBAYC2AQWgoIYoZQOoLVDKC0DoLQGgVECAaotgLQFoIECBQCBgEDAagNQDAMBpBqAYmjUQMoNIGURrUgZQWoH1AWgtUGkFpBasBpAWqDVBoC1cAoNAaA0EogQJB9FfNnuWqDQWgtUQIFoIBaA1oZtE0WqjFrSs2qjFqjPVaRztU1m1cRi1oc+q1iOfVUYtaxHO1oc7WsGK0jNUFAKKRA4DUgNSIuNyA1IyNSAZEGpAOAcBYCwBigsUGKDACkX6BaCAwCBA4CxBYCxQAKDFaNZqozWhi1Uc+quDn1WsGOq0muXVaGOulRzvSjFrQ53pRi9KjN6UYvSjNorFqjNqoLVGdIDVVaC1UOop0GoDUqDcQagrpyzqOkB15rOq681NV05rI6c1BuUVqVINegXogvRBm1Rm1UYtXBnqtDnaqaxVRm1oFUZq4M1VQi0RAgQICKhTKiFRSikGpQMEajIYDcoNSoNyoNSkGtQWgtAWrBi0zBi1oc+6uDl01g5dVoYv6VHOrgw0BQVcBooVEuCAaCBANVECAaCXBAgQIAqoEC0Fqh0FoFRaBBAgQIRKIECBAjBKqBaJp0QgQWgdBaB0EogQEFoLQFUQIECAAQQKAYDQEDAINQCDUBqVA6DUqBlEalQOgtQOgdBaC0DoDYotAaA1RWgNBm1YLQGqDQGqLQWggQIH0XXzZ7htUWgtAaC0FoLQFqogFrRRasGLSIzaoza1mDHVWI52tFZtVGLWoMddNZgxaqOfVWDFrWIx1fy0MVRitIzVBYCxQyIHAakRY3Im6NSFGpyg1OUVqRA4qNeUVYC8qgwUYCxQYozYqDFFgLAWAYBAyAUU4gMVFgCqCgxWjWKqMWtYOfVVHPqtYOXXTSVz66awc+umkcuu1g59dNZgxelgxeliMXpYMXpVZvSjNogtUYvSwFqqNBaC0FqoUUyg1AalBuINyoN81B05qDpzUV15rKukqDfNQblQblA6B0BoC1Rm1Rm1Ri1Ri1pNYtWIzWgAKoyqoRYIvyCBAhUC0UgYBBSgYDUoHURqUGpUGpQblQalA6KZURaQFqwYtBmtDl0uDn1fy0OdUc+r+Gkc+lxWaqM2tQFoAVKg0wWqDVEABaCoAEqIFoLVVaA2hECBAtUMBKIDAIIRAtAgtAaotBaC0FqwWirQWghCEOhFoHREoYBBaLDoRaItAaotBaKtAAhEBAggShgGVAygYDUAwDAalAxBrQMoNaiHQOgtSB0DpBeiC9KLQGgtAaA1RaA1QaAtBaA1RaC0ABBaC0H0R83e5aA0BoLQWqi0gtIDVgtEFqjNrQzaozaoxauIx1Whi1UYtawYtXBi1oZtUYtaRiqjF/ajNUYrSBRAsAyINSFGpEVuRBqRBuQGpEUyFGsQWAc/4CygsUGAzYoMUZsVBigUQIDAQNYgUVAcVBQZqjNBjpo1i1Uc+q1g59VrEcuq1g5ddNMuXXTQ5ddNYOfXTQ59dLgxemkc70ozelVi0QWqM2gzelgNVRoLQWqiBSgQMqK1AagNwGoyOkFdOayjfNRXTmoOkqK3Kg3KkGp0QPpA+lgvRBm1QXpRm1YM2qM2qmsWtIKozaAqgVUIgKogQBFQqAggIGAQMoGA1KiNSg1Kg1KDUoGVILQWgrVGaDFrQ59VcHPpRzrSMdfpRzq4M1oZqqKqAAA1RaCUFBaoEEolFqIrVAA1WhoLQOiLQWgQSiAiIEBUIIECBAgQIAqoECBAdAqIQoiUaBAhVqi0Q6CAAgQLQQIEBBRQgYBiBgEDAIGAZQOg1KBlQOqh1AykDpA6QWkFpBeiC9EBpBaA1QaC0BoLVgNBaA1YLSC/KwWpBSgdQSwfRLXzZ7mdaKBEC0RaC1RaA0gLVii1QWqjNqjHVaRi1TWLVRi1oZtXBi1pGbVGKozVRmqM2KM2LRnFoMBeVIZAM5QakQanKDc5FbnKDU5QanKUanJQ+SqfJQ4gPKgsAYoLFRmxRmxQWLiMrgFFgGAYDSCRSA1UFoC1Ri1Ri1U1z6rWDl1Whz66axHHrpocuumsRy66axHLrprBz6rQ53ppHPrpRi9KrN6VGb0AtBm1cBqqNEWqDQQEEBAwVqCtz9IjUQagNyoOnNRW5UV05qDcqDcoNzpBqdAfSQXpRegHpQWkGbWhm0BauIzaqM2qBQAqqgEIdUUAiAVAgKKgIEF/oEGgMoGA1AalRGpQOgdQWkBqjNoM2qOfTQ59KMVpHOqrFVGKoKqsqgoC1RAgDShEQJoAJEQCri4NVUCAaBUQICIqBBKhgEAgQWqLQWgtBaCtMBqqgQIEqEFoEFoEEBA6A1VQEECE1CIECBKGAQQIFAIGAQagIDECBgFQ6gdBegOgZQOiHQWgvQLQWgNBaA0FqwGgtUGqLQGgtBaYLVFqClA6B0H0O182e4WqgEQLVBoLVgtAaoNIC1QWrBi1UYvTRWLViMWtDNqjNrWIzaDNUZUFUZxUZsUFgDzQXlReQPkDIitTko1OUo3IDUjNG5ylGpyg1gpwFgLAWFFYtGbFzRmxRmxUZsUZsUZsaQKIECBrUFqKtoLVRnQFqjnasGOumoa59dNYjj101g5ddNYjl100OPXTWMuXXTY59dKOXXTSOfXTQxaqsWiM2tYM2qo9UiDSC0UaqIECAgYB0UwGog1AblBqINRBvmitzpIVuVFblQblBqdINegPogvVIL1VgvRAWqgtCs2rCs6oLVQAlBoBVQIRKLQOggQHASCBoEKgIEQwDorWgZQalAyoh0FoC1Rm0GbVHO1oYqjHSo51RmqMWtDNUACgFEA1YBVRiDVECBaiM6qxWgNVUCBAtUMoIEIgOiFRAgMQQFRAgQBYIVAtBaA1UOggQGAgIHQWqHRUCBAtEq0CEQiBAlECAggMAgYBBQGpQWgZQOgdBaBgEEB0Doi0FoLQWgtAaQWrmA0gtID0otAaC0Fqg0FoHQWgtBrQUoPoj5q9wqotVADOqqVFoLRBaqs6AtUZvTSM2qjFqjFqgv6aGLVQKM0GWgKLAGAsAXlagwVeQXkDOQM5BqcoNzlKNTlN0bkQM5FbnIHyBxKHyUWJReYtBYDNijNijNjWaMWKjGNDNioK0AECA6gNVVoLRGbQYtUYvTQ59dKjj300OXXTWDl101iOXXbWYOPXTeMuXXTWDn100OfXTQ59dAxelRm1oZtVRoDVRaABaC0CCAgYKoDUFan6RGoDUBqINxBqUGpRW5U0blRWpQMoNSoHQWqLQWgLVxBogtUGqAFaoNBKAUghEogQEEBAggIJFUAiGKJAitAYB0DoEEAtVBaDNqjnVRmrg59VRitDFUZqqzVRmgFEAq4BVQCiJQaC0ACVQCBAgSiBAYCBCaVQggQGAQQAEBAKKgAQqUQiBAdBAQWggOqqA6C0CCEQigHQWggQJQgqCgECBgIDAKhBAdBagdUWgdAyggOkRaQWkBpBaQWkBaotAaQWqDQOgNBaC0FoLQWqHUFKB0DoPor5s92gxkKCqoAKg1QWgLVBaqM2qM2qazaqM2qM2tIzqjNUAKwGcaFgLAXkF5KLyUXiFVeCi8FDOShnCUanJRqcg1OUo1OWaNzkDORcOIp8lDgLAWLQWCazY0jFijHUXBmxoYrSMX9rgzVxAoAQLQWgtBm0GL00MXpRz67XMRy66aHLrprMHLrtrMRx66azE1y76bzEcuumsHLrprBjrpUcrVVm1pGLVGbVUaAAKiBAgMAggIpgpBqIjQGAQaiDUBqA3KDUrI1KQalIGUgZ0gdA6Li1QeiItWAtBaotUFoDVVaC0ABVCCEQqAggIEFAIIDAQGAQQECB0FoHQWgCAtUZtUZqox0o51VYqozVwYrQzQZMEoGlALQCogGgAVAaohUCBKIECBCGKICCEMBAgIEBQAi1RaC0ECBCoVAlRAgQEECn7VSBgIEJqEMoEECBKGAgQIEBgEDAQGAgKhUWgtA6kECUOgtA6C0FoL0QHogtUWgtEAIBqi0FoIECBApQOggMAgdB9GfNXu0DIq4MtAoUVQUAoLVRm1YVm1Ss2rEZtUZtUFUZrQKIAILFosKq8lD5Si8gvIHyC8gfAHwUM5Sh8lGpylGpBTIhGpEpGpAM5A4gsKqwoMWgsVBikc7GkYq4MVsc7FRitYM1cRnVBoLQGqC0gL0QZtUY66XMHPrpqJXPvpRx66azBy67aRx67azBy67axNcuum8RzvSwc7WhjqqOdqxGbVGaoFUUACVECwECAgRSBgrU/YNREMAwWNQIURqCxqBDBGog1KB0UygdBagfVWB9UgNEWqLQWqLQAJVQIQhUogQEEBBAQIHAQKAQQIDAILQILQOwFoLYotBm1cwFWDFqjPVUc6sRmqMWqrFqozQFUFWAVUIKC1QUEDOgtUQo0F+wWAVECBAgMVEBBCGAgQEFQGrCoiIECBAhYgQqBKiBAgWqHRUBgIDoiFQkQhgEVCJQggQIEBgEDAQLQMqhBaotA6A1YGUgtILSC0FoLaBlBaA0RAgWqC1BaKtqgtBaC0FoQasItIQzqkIdIQpEUINaQIP/Z"

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

	/*jslint browser: true, plusplus: true, indent: 2 */
	
	// This will be removed by uglify, along with the DEBUG code
	if (false) {
	  DEBUG = true;
	}
	
	// Logic and fallbacks based on the following SO answers:
	// - Getting caret position cross browser: http://stackoverflow.com/a/9370239/147507
	// - Selection API on non input-text fields: http://stackoverflow.com/a/24247942/147507
	// - Set cursor position on input text: http://stackoverflow.com/q/5755826/147507
	angular.module('ngPatternRestrict', [])
	  .directive('ngPatternRestrict', ['$log', function ($log) {
	    'use strict';
	
	    function showDebugInfo() {
	      $log.debug("[ngPatternRestrict] " + Array.prototype.join.call(arguments, ' '));
	    }
	
	    return {
	      restrict: 'A',
	      require: "?ngModel",
	      compile: function uiPatternRestrictCompile() {
	        (false) && showDebugInfo("Loaded");
	
	        return function ngPatternRestrictLinking(scope, iElement, iAttrs, ngModelController) {
	          var regex, // validation regex object
	            oldValue, // keeping track of the previous value of the element
	            caretPosition, // keeping track of where the caret is at to avoid jumpiness
	            // housekeeping
	            initialized = false, // have we initialized our directive yet?
	            eventsBound = false, // have we bound our events yet?
	            // functions
	            getCaretPosition, // function to get the caret position, set in detectGetCaretPositionMethods
	            setCaretPosition; // function to set the caret position, set in detectSetCaretPositionMethods
	
	          //-------------------------------------------------------------------
	          // caret position
	          function getCaretPositionWithInputSelectionStart() {
	            return iElement[0].selectionStart; // we need to go under jqlite
	          }
	
	          function getCaretPositionWithDocumentSelection() {
	            // create a selection range from where we are to the beggining
	            // and measure how much we moved
	            var range = document.selection.createRange();
	            range.moveStart('character', -iElement.val().length);
	            return range.text.length;
	          }
	
	          function getCaretPositionWithWindowSelection() {
	            var s = window.getSelection(),
	              originalSelectionLength = String(s).length,
	              selectionLength,
	              didReachZero = false,
	              detectedCaretPosition,
	              restorePositionCounter;
	
	            do {
	              selectionLength = String(s).length;
	              s.modify('extend', 'backward', 'character');
	              // we're undoing a selection, and starting a new one towards the beggining of the string
	              if (String(s).length === 0) {
	                didReachZero = true;
	              }
	            } while (selectionLength !== String(s).length);
	
	            detectedCaretPosition = didReachZero ? selectionLength : selectionLength - originalSelectionLength;
	            s.collapseToStart();
	
	            restorePositionCounter = detectedCaretPosition;
	            while (restorePositionCounter-- > 0) {
	              s.modify('move', 'forward', 'character');
	            }
	            while (originalSelectionLength-- > 0) {
	              s.modify('extend', 'forward', 'character');
	            }
	
	            return detectedCaretPosition;
	          }
	
	          function setCaretPositionWithSetSelectionRange(position) {
	            iElement[0].setSelectionRange(position, position);
	          }
	
	          function setCaretPositionWithCreateTextRange(position) {
	            var textRange = iElement[0].createTextRange();
	            textRange.collapse(true);
	            textRange.moveEnd('character', position);
	            textRange.moveStart('character', position);
	            textRange.select();
	          }
	
	          function setCaretPositionWithWindowSelection(position) {
	            var s = window.getSelection(),
	              selectionLength;
	
	            do {
	              selectionLength = String(s).length;
	              s.modify('extend', 'backward', 'line');
	            } while (selectionLength !== String(s).length);
	            s.collapseToStart();
	
	            while (position--) {
	              s.modify('move', 'forward', 'character');
	            }
	          }
	
	          // HACK: Opera 12 won't give us a wrong validity status although the input is invalid
	          // we can select the whole text and check the selection size
	          // Congratulations to IE 11 for doing the same but not returning the selection.
	          function getValueLengthThroughSelection(input) {
	            // only do this on opera, since it'll mess up the caret position
	            // and break Firefox functionality
	            if (!/Opera/i.test(navigator.userAgent)) {
	              return 0;
	            }
	
	            input.focus();
	            document.execCommand("selectAll");
	            var focusNode = window.getSelection().focusNode;
	            return (focusNode || {}).selectionStart || 0;
	          }
	
	          //-------------------------------------------------------------------
	          // event handlers
	          function revertToPreviousValue() {
	            if (ngModelController) {
	              scope.$apply(function () {
	                ngModelController.$setViewValue(oldValue);
	              });
	            }
	            iElement.val(oldValue);
	
	            if (!angular.isUndefined(caretPosition)) {
	              setCaretPosition(caretPosition);
	            }
	          }
	
	          function updateCurrentValue(newValue) {
	            oldValue = newValue;
	            caretPosition = getCaretPosition();
	          }
	
	          function genericEventHandler(evt) {
	            (false) && showDebugInfo("Reacting to event:", evt.type);
	
	            //HACK Chrome returns an empty string as value if user inputs a non-numeric string into a number type input
	            // and this may happen with other non-text inputs soon enough. As such, if getting the string only gives us an
	            // empty string, we don't have the chance of validating it against a regex. All we can do is assume it's wrong,
	            // since the browser is rejecting it either way.
	            var newValue = iElement.val(),
	              inputValidity = iElement.prop("validity");
	            if (newValue === "" && iElement.attr("type") !== "text" && inputValidity && inputValidity.badInput) {
	              (false) && showDebugInfo("Value cannot be verified. Should be invalid. Reverting back to:", oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            } else if (newValue === "" && getValueLengthThroughSelection(iElement[0]) !== 0) {
	              (false) && showDebugInfo("Invalid input. Reverting back to:", oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            } else if (regex.test(newValue)) {
	              (false) && showDebugInfo("New value passed validation against", regex, newValue);
	              updateCurrentValue(newValue);
	            } else {
	              (false) && showDebugInfo("New value did NOT pass validation against", regex, newValue, "Reverting back to:", oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            }
	          }
	
	          //-------------------------------------------------------------------
	          // setup based on attributes
	          function tryParseRegex(regexString) {
	            try {
	              regex = new RegExp(regexString);
	            } catch (e) {
	              throw "Invalid RegEx string parsed for ngPatternRestrict: " + regexString;
	            }
	          }
	
	          //-------------------------------------------------------------------
	          // setup events
	          function bindListeners() {
	            if (eventsBound) {
	              return;
	            }
	
	            iElement.bind('input keyup click', genericEventHandler);
	
	            (false) && showDebugInfo("Bound events: input, keyup, click");
	          }
	
	          function unbindListeners() {
	            if (!eventsBound) {
	              return;
	            }
	
	            iElement.unbind('input', genericEventHandler);
	            //input: HTML5 spec, changes in content
	
	            iElement.unbind('keyup', genericEventHandler);
	            //keyup: DOM L3 spec, key released (possibly changing content)
	
	            iElement.unbind('click', genericEventHandler);
	            //click: DOM L3 spec, mouse clicked and released (possibly changing content)
	
	            (false) && showDebugInfo("Unbound events: input, keyup, click");
	
	            eventsBound = false;
	          }
	
	          //-------------------------------------------------------------------
	          // initialization
	          function readPattern() {
	            var entryRegex = !!iAttrs.ngPatternRestrict ? iAttrs.ngPatternRestrict : iAttrs.pattern;
	            (false) && showDebugInfo("RegEx to use:", entryRegex);
	            tryParseRegex(entryRegex);
	          }
	
	          function notThrows(testFn, shouldReturnTruthy) {
	          	try {
	          		return testFn() || !shouldReturnTruthy;
	          	} catch (e) {
	          		return false;
	          	}
	          }
	
	          function detectGetCaretPositionMethods() {
	            var input = iElement[0];
	
	            // Chrome will throw on input.selectionStart of input type=number
	            // See http://stackoverflow.com/a/21959157/147507
	            if (notThrows(function () { return input.selectionStart; })) {
	              getCaretPosition = getCaretPositionWithInputSelectionStart;
	            } else {
	              // IE 9- will use document.selection
	              // TODO support IE 11+ with document.getSelection()
	              if (notThrows(function () { return document.selection; }, true)) {
	                getCaretPosition = getCaretPositionWithDocumentSelection;
	              } else {
	                getCaretPosition = getCaretPositionWithWindowSelection;
	              }
	            }
	          }
	
	          function detectSetCaretPositionMethods() {
	            var input = iElement[0];
	            if (typeof input.setSelectionRange === 'function') {
	              setCaretPosition = setCaretPositionWithSetSelectionRange;
	            } else if (typeof input.createTextRange === 'function') {
	              setCaretPosition = setCaretPositionWithCreateTextRange;
	            } else {
	              setCaretPosition = setCaretPositionWithWindowSelection;
	            }
	          }
	
	          function initialize() {
	            if (initialized) {
	              return;
	            }
	            (false) && showDebugInfo("Initializing");
	
	            readPattern();
	
	            oldValue = iElement.val();
	            if (!oldValue) {
	              oldValue = "";
	            }
	            (false) && showDebugInfo("Original value:", oldValue);
	
	            bindListeners();
	
	            detectGetCaretPositionMethods();
	            detectSetCaretPositionMethods();
	
	            initialized = true;
	          }
	
	          function uninitialize() {
	            (false) && showDebugInfo("Uninitializing");
	            unbindListeners();
	          }
	
	          iAttrs.$observe("ngPatternRestrict", readPattern);
	          iAttrs.$observe("pattern", readPattern);
	
	          scope.$on("$destroy", uninitialize);
	
	          initialize();
	        };
	      }
	    };
	  }]);


/***/ })

/******/ });


// WEBPACK FOOTER //
// app.js